// navigator.geolocation.getCurrentPosition(function (position) {
//   let apiKey = 'AIzaSyB1RJUfQM75X8TzhyMZDiC_--FuhcyGty4';
//   let url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=${apiKey}`;
//   fetch(url)
//     .then(response => response.json() )
//     .then(data => {
//       let codes = data.results[0].address_components
//       codes.forEach(el => {
//         if(el.types.includes("postal_code")) {
//           calculateZip("#zip-select", 
//           ".o-quantity-selector__select-field option:selected", 
//           el.long_name);
//           console.log('MY ZIPCODE START')
//           console.log(el.long_name)
//           console.log('MY ZIPCODE END')
//         }
//         if(el.types.includes("locality")) {
//           let placeName = el.short_name
//         }
//       });
//     })
//     .catch(err => console.warn(err.message))
//   }, function (err) {
//     alert('YOUR GEOLOCATION DISABLED');
//   });
let postcodes = [
  {
    "postcode":200,
    "place_name":"Australian National University",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":221,
    "place_name":"Barton",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2540,
    "place_name":"Wreck Bay",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2540,
    "place_name":"Hmas Creswell",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2540,
    "place_name":"Jervis Bay",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Deakin West",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Duntroon",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Parliament House",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Yarralumla",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Russell",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Barton",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Deakin",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Capital Hill",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Parkes",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Harman",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Hmas Harman",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2600,
    "place_name":"Canberra",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2601,
    "place_name":"City",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2601,
    "place_name":"Canberra",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2601,
    "place_name":"Acton",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2601,
    "place_name":"Black Mountain",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2602,
    "place_name":"Downer",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2602,
    "place_name":"Hackett",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2602,
    "place_name":"Watson",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2602,
    "place_name":"Lyneham",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2602,
    "place_name":"O'Connor",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2602,
    "place_name":"Ainslie",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2602,
    "place_name":"Dickson",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2603,
    "place_name":"Red Hill",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2603,
    "place_name":"Manuka",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2603,
    "place_name":"Griffith",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2603,
    "place_name":"Forrest",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2604,
    "place_name":"Narrabundah",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2604,
    "place_name":"Causeway",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2604,
    "place_name":"Kingston",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2605,
    "place_name":"Hughes",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2605,
    "place_name":"Garran",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2605,
    "place_name":"Curtin",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2606,
    "place_name":"O'Malley",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2606,
    "place_name":"Lyons",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2606,
    "place_name":"Chifley",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2606,
    "place_name":"Woden",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2606,
    "place_name":"Phillip",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2606,
    "place_name":"Swinger Hill",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2607,
    "place_name":"Isaacs",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2607,
    "place_name":"Torrens",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2607,
    "place_name":"Mawson",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2607,
    "place_name":"Farrer",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2607,
    "place_name":"Pearce",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2608,
    "place_name":"Civic Square",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2609,
    "place_name":"Pialligo",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2609,
    "place_name":"Canberra Airport",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2609,
    "place_name":"Fyshwick",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2609,
    "place_name":"Symonston",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2609,
    "place_name":"Majura",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2610,
    "place_name":"Canberra Bc",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2610,
    "place_name":"Canberra Mc",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Stirling",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Wright",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Coree",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Uriarra Village",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Holder",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Stromlo",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Waramanga",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Chapman",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Weston Creek",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Mount Stromlo",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Weston",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Coombs",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Uriarra",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Duffy",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Fisher",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2611,
    "place_name":"Rivett",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2612,
    "place_name":"Campbell",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2612,
    "place_name":"Turner",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2612,
    "place_name":"Reid",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2612,
    "place_name":"Braddon",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2614,
    "place_name":"Cook",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2614,
    "place_name":"Aranda",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2614,
    "place_name":"Page",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2614,
    "place_name":"Hawker",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2614,
    "place_name":"Scullin",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2614,
    "place_name":"Jamison Centre",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2614,
    "place_name":"Weetangera",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2614,
    "place_name":"Macquarie",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Fraser",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Spence",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Florey",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Holt",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Charnwood",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Higgins",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Dunlop",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Kippax",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Melba",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Flynn",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Latham",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Macgregor",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2615,
    "place_name":"Kippax Centre",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2616,
    "place_name":"Belconnen",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2617,
    "place_name":"Mckellar",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2617,
    "place_name":"Belconnen",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2617,
    "place_name":"Evatt",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2617,
    "place_name":"Lawson",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2617,
    "place_name":"Giralang",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2617,
    "place_name":"University Of Canberra",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2617,
    "place_name":"Belconnen DC",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2617,
    "place_name":"Kaleen",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2617,
    "place_name":"Bruce",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2618,
    "place_name":"Hall",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2620,
    "place_name":"Hume",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2620,
    "place_name":"Paddys River",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2620,
    "place_name":"Beard",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2620,
    "place_name":"Oaks Estate",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2620,
    "place_name":"Tharwa",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2620,
    "place_name":"Kowen",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2900,
    "place_name":"Greenway",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2900,
    "place_name":"Tuggeranong",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2901,
    "place_name":"Tuggeranong Dc",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2902,
    "place_name":"Kambah",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2902,
    "place_name":"Kambah Village",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2903,
    "place_name":"Erindale Centre",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2903,
    "place_name":"Oxley",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2903,
    "place_name":"Wanniassa",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2904,
    "place_name":"Fadden",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2904,
    "place_name":"Monash",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2904,
    "place_name":"Gowrie",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2904,
    "place_name":"Macarthur",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2905,
    "place_name":"Isabella Plains",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2905,
    "place_name":"Theodore",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2905,
    "place_name":"Gilmore",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2905,
    "place_name":"Richardson",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2905,
    "place_name":"Calwell",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2905,
    "place_name":"Chisholm",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2905,
    "place_name":"Bonython",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2906,
    "place_name":"Conder",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2906,
    "place_name":"Gordon",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2906,
    "place_name":"Banks",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2911,
    "place_name":"Mitchell",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2911,
    "place_name":"Crace",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2912,
    "place_name":"Gungahlin",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2913,
    "place_name":"Casey",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2913,
    "place_name":"Franklin",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2913,
    "place_name":"Taylor",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2913,
    "place_name":"Palmerston",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2913,
    "place_name":"Kinlyside",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2913,
    "place_name":"Nicholls",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2913,
    "place_name":"Ginninderra Village",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2913,
    "place_name":"Ngunnawal",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2914,
    "place_name":"Bonner",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2914,
    "place_name":"Forde",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2914,
    "place_name":"Harrison",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2914,
    "place_name":"Amaroo",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2914,
    "place_name":"Moncrieff",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":2914,
    "place_name":"Jacka",
    "state_name":"Australian Capital Territory"
  },
  {
    "postcode":1001,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1002,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1003,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1004,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1005,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1006,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1007,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1008,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1009,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1010,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1011,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1020,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1021,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1022,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1023,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1025,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1026,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1027,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1028,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1029,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1030,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1031,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1032,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1033,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1034,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1035,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1036,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1037,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1038,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1039,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1040,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1041,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1042,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1043,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1044,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1045,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1046,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1100,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1101,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1105,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1106,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1107,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1108,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1109,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1110,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1112,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1113,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1114,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1115,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1116,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1117,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1118,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1119,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1120,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1121,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1122,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1123,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1124,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1125,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1126,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1127,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1128,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1129,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1130,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1131,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1132,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1133,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1134,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1135,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1136,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1137,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1138,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1139,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1140,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1141,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1142,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1143,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1144,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1145,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1146,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1147,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1148,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1149,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1150,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1151,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1152,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1153,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1154,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1155,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1156,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1157,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1158,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1159,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1160,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1161,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1162,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1163,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1164,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1165,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1166,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1167,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1168,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1169,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1170,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1171,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1172,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1173,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1174,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1175,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1176,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1177,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1178,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1179,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1180,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1181,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1182,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1183,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1184,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1185,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1186,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1187,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1188,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1189,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1190,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1191,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1192,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1193,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1194,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1195,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1196,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1197,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1198,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1199,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1200,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1201,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1202,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1203,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1204,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1205,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1206,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1207,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1208,
    "place_name":"Haymarket",
    "state_name":"New South Wales"
  },
  {
    "postcode":1209,
    "place_name":"Australia Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":1210,
    "place_name":"Australia Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":1211,
    "place_name":"Australia Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":1212,
    "place_name":"Australia Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":1213,
    "place_name":"Australia Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":1214,
    "place_name":"Australia Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":1215,
    "place_name":"Australia Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":1216,
    "place_name":"Grosvenor Place",
    "state_name":"New South Wales"
  },
  {
    "postcode":1217,
    "place_name":"Grosvenor Place",
    "state_name":"New South Wales"
  },
  {
    "postcode":1218,
    "place_name":"Grosvenor Place",
    "state_name":"New South Wales"
  },
  {
    "postcode":1219,
    "place_name":"Grosvenor Place",
    "state_name":"New South Wales"
  },
  {
    "postcode":1220,
    "place_name":"Grosvenor Place",
    "state_name":"New South Wales"
  },
  {
    "postcode":1221,
    "place_name":"Royal Exchange",
    "state_name":"New South Wales"
  },
  {
    "postcode":1222,
    "place_name":"Royal Exchange",
    "state_name":"New South Wales"
  },
  {
    "postcode":1223,
    "place_name":"Royal Exchange",
    "state_name":"New South Wales"
  },
  {
    "postcode":1224,
    "place_name":"Royal Exchange",
    "state_name":"New South Wales"
  },
  {
    "postcode":1225,
    "place_name":"Royal Exchange",
    "state_name":"New South Wales"
  },
  {
    "postcode":1226,
    "place_name":"Queen Victoria Building",
    "state_name":"New South Wales"
  },
  {
    "postcode":1227,
    "place_name":"Queen Victoria Building",
    "state_name":"New South Wales"
  },
  {
    "postcode":1228,
    "place_name":"Queen Victoria Building",
    "state_name":"New South Wales"
  },
  {
    "postcode":1229,
    "place_name":"Queen Victoria Building",
    "state_name":"New South Wales"
  },
  {
    "postcode":1230,
    "place_name":"Queen Victoria Building",
    "state_name":"New South Wales"
  },
  {
    "postcode":1231,
    "place_name":"Sydney South",
    "state_name":"New South Wales"
  },
  {
    "postcode":1232,
    "place_name":"Sydney South",
    "state_name":"New South Wales"
  },
  {
    "postcode":1233,
    "place_name":"Sydney South",
    "state_name":"New South Wales"
  },
  {
    "postcode":1234,
    "place_name":"Sydney South",
    "state_name":"New South Wales"
  },
  {
    "postcode":1235,
    "place_name":"Sydney South",
    "state_name":"New South Wales"
  },
  {
    "postcode":1236,
    "place_name":"Haymarket",
    "state_name":"New South Wales"
  },
  {
    "postcode":1237,
    "place_name":"Haymarket",
    "state_name":"New South Wales"
  },
  {
    "postcode":1238,
    "place_name":"Haymarket",
    "state_name":"New South Wales"
  },
  {
    "postcode":1239,
    "place_name":"Haymarket",
    "state_name":"New South Wales"
  },
  {
    "postcode":1240,
    "place_name":"Haymarket",
    "state_name":"New South Wales"
  },
  {
    "postcode":1291,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1292,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1293,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1294,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1295,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1296,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1297,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1298,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1299,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1300,
    "place_name":"Darlinghurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":1311,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1312,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1313,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1314,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1315,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1316,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1317,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1318,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1319,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1320,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1321,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1322,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1323,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1324,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1325,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1326,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1327,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1328,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1329,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1330,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1331,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1332,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1333,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1334,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1335,
    "place_name":"Potts Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":1340,
    "place_name":"Kings Cross",
    "state_name":"New South Wales"
  },
  {
    "postcode":1350,
    "place_name":"Woollahra",
    "state_name":"New South Wales"
  },
  {
    "postcode":1355,
    "place_name":"Bondi Junction",
    "state_name":"New South Wales"
  },
  {
    "postcode":1360,
    "place_name":"Double Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":1363,
    "place_name":"Moore Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":1391,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1401,
    "place_name":"Broadway",
    "state_name":"New South Wales"
  },
  {
    "postcode":1416,
    "place_name":"Southern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1419,
    "place_name":"Southern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1420,
    "place_name":"Strawberry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1421,
    "place_name":"Strawberry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1422,
    "place_name":"Strawberry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1423,
    "place_name":"Strawberry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1424,
    "place_name":"Strawberry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1425,
    "place_name":"Strawberry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1426,
    "place_name":"Strawberry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1427,
    "place_name":"Strawberry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1428,
    "place_name":"Strawberry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1429,
    "place_name":"Strawberry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1430,
    "place_name":"Eveleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":1435,
    "place_name":"Alexandria",
    "state_name":"New South Wales"
  },
  {
    "postcode":1440,
    "place_name":"Waterloo",
    "state_name":"New South Wales"
  },
  {
    "postcode":1445,
    "place_name":"Rosebery",
    "state_name":"New South Wales"
  },
  {
    "postcode":1450,
    "place_name":"Camperdown",
    "state_name":"New South Wales"
  },
  {
    "postcode":1455,
    "place_name":"Botany",
    "state_name":"New South Wales"
  },
  {
    "postcode":1460,
    "place_name":"Mascot",
    "state_name":"New South Wales"
  },
  {
    "postcode":1465,
    "place_name":"Kensington",
    "state_name":"New South Wales"
  },
  {
    "postcode":1466,
    "place_name":"Unsw Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":1470,
    "place_name":"Drummoyne",
    "state_name":"New South Wales"
  },
  {
    "postcode":1475,
    "place_name":"Marrickville",
    "state_name":"New South Wales"
  },
  {
    "postcode":1480,
    "place_name":"Kingsgrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":1481,
    "place_name":"Hurstville Bc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1484,
    "place_name":"Kingsgrove DC",
    "state_name":"New South Wales"
  },
  {
    "postcode":1485,
    "place_name":"Kogarah",
    "state_name":"New South Wales"
  },
  {
    "postcode":1487,
    "place_name":"Kogarah",
    "state_name":"New South Wales"
  },
  {
    "postcode":1490,
    "place_name":"Miranda",
    "state_name":"New South Wales"
  },
  {
    "postcode":1493,
    "place_name":"Hurstville",
    "state_name":"New South Wales"
  },
  {
    "postcode":1495,
    "place_name":"Caringbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":1499,
    "place_name":"Sutherland",
    "state_name":"New South Wales"
  },
  {
    "postcode":1515,
    "place_name":"West Chatswood",
    "state_name":"New South Wales"
  },
  {
    "postcode":1560,
    "place_name":"Northbridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":1565,
    "place_name":"Milsons Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":1570,
    "place_name":"Artarmon",
    "state_name":"New South Wales"
  },
  {
    "postcode":1582,
    "place_name":"Crows Nest",
    "state_name":"New South Wales"
  },
  {
    "postcode":1585,
    "place_name":"Crows Nest",
    "state_name":"New South Wales"
  },
  {
    "postcode":1590,
    "place_name":"St Leonards",
    "state_name":"New South Wales"
  },
  {
    "postcode":1595,
    "place_name":"Lane Cove",
    "state_name":"New South Wales"
  },
  {
    "postcode":1597,
    "place_name":"Lane Cove",
    "state_name":"New South Wales"
  },
  {
    "postcode":1602,
    "place_name":"Lane Cove DC",
    "state_name":"New South Wales"
  },
  {
    "postcode":1630,
    "place_name":"Hornsby",
    "state_name":"New South Wales"
  },
  {
    "postcode":1635,
    "place_name":"Hornsby Westfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":1639,
    "place_name":"Frenchs Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":1640,
    "place_name":"Frenchs Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":1655,
    "place_name":"Manly",
    "state_name":"New South Wales"
  },
  {
    "postcode":1658,
    "place_name":"Mona Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":1660,
    "place_name":"Mona Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":1670,
    "place_name":"North Ryde Bc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1671,
    "place_name":"North Ryde",
    "state_name":"New South Wales"
  },
  {
    "postcode":1675,
    "place_name":"Gladesville",
    "state_name":"New South Wales"
  },
  {
    "postcode":1680,
    "place_name":"Ryde",
    "state_name":"New South Wales"
  },
  {
    "postcode":1685,
    "place_name":"West Ryde",
    "state_name":"New South Wales"
  },
  {
    "postcode":1690,
    "place_name":"Northern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1691,
    "place_name":"Northern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1692,
    "place_name":"Northern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1693,
    "place_name":"Northern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1694,
    "place_name":"Northern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1695,
    "place_name":"Northern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1696,
    "place_name":"Northern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1697,
    "place_name":"Northern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1698,
    "place_name":"Northern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1699,
    "place_name":"Northern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1700,
    "place_name":"Ermington",
    "state_name":"New South Wales"
  },
  {
    "postcode":1701,
    "place_name":"Rydalmere Bc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1710,
    "place_name":"Epping",
    "state_name":"New South Wales"
  },
  {
    "postcode":1712,
    "place_name":"Epping",
    "state_name":"New South Wales"
  },
  {
    "postcode":1715,
    "place_name":"Pennant Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1730,
    "place_name":"Seven Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1740,
    "place_name":"Parramatta",
    "state_name":"New South Wales"
  },
  {
    "postcode":1741,
    "place_name":"Parramatta",
    "state_name":"New South Wales"
  },
  {
    "postcode":1750,
    "place_name":"North Parramatta",
    "state_name":"New South Wales"
  },
  {
    "postcode":1755,
    "place_name":"Baulkham Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1765,
    "place_name":"Castle Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":1771,
    "place_name":"Pennant Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":1781,
    "place_name":"Seven Hills Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1790,
    "place_name":"St Marys",
    "state_name":"New South Wales"
  },
  {
    "postcode":1797,
    "place_name":"Penrith South DC",
    "state_name":"New South Wales"
  },
  {
    "postcode":1800,
    "place_name":"Ashfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":1805,
    "place_name":"Burwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":1811,
    "place_name":"Silverwater",
    "state_name":"New South Wales"
  },
  {
    "postcode":1825,
    "place_name":"Lidcombe",
    "state_name":"New South Wales"
  },
  {
    "postcode":1826,
    "place_name":"Lidcombe",
    "state_name":"New South Wales"
  },
  {
    "postcode":1830,
    "place_name":"Granville",
    "state_name":"New South Wales"
  },
  {
    "postcode":1831,
    "place_name":"Granville",
    "state_name":"New South Wales"
  },
  {
    "postcode":1835,
    "place_name":"Auburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":1848,
    "place_name":"Guildford",
    "state_name":"New South Wales"
  },
  {
    "postcode":1851,
    "place_name":"Wetherill Park Dc",
    "state_name":"New South Wales"
  },
  {
    "postcode":1860,
    "place_name":"Fairfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":1871,
    "place_name":"Liverpool",
    "state_name":"New South Wales"
  },
  {
    "postcode":1875,
    "place_name":"Moorebank",
    "state_name":"New South Wales"
  },
  {
    "postcode":1885,
    "place_name":"Bankstown",
    "state_name":"New South Wales"
  },
  {
    "postcode":1888,
    "place_name":"Bankstown",
    "state_name":"New South Wales"
  },
  {
    "postcode":1890,
    "place_name":"Ingleburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":1891,
    "place_name":"Milperra",
    "state_name":"New South Wales"
  },
  {
    "postcode":1900,
    "place_name":"Leightonfield Mc",
    "state_name":"New South Wales" 
  },
  {
    "postcode":1902,
    "place_name":"Leightonfield Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2000,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":2000,
    "place_name":"Dawes Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2000,
    "place_name":"The Rocks",
    "state_name":"New South Wales"
  },
  {
    "postcode":2000,
    "place_name":"Parliament House",
    "state_name":"New South Wales"
  },
  {
    "postcode":2000,
    "place_name":"Sydney South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2000,
    "place_name":"Barangaroo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2000,
    "place_name":"Millers Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2000,
    "place_name":"Haymarket",
    "state_name":"New South Wales"
  },
  {
    "postcode":2001,
    "place_name":"Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":2002,
    "place_name":"World Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":2004,
    "place_name":"Alexandria Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2004,
    "place_name":"Eastern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2006,
    "place_name":"The University Of Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":2007,
    "place_name":"Broadway",
    "state_name":"New South Wales"
  },
  {
    "postcode":2007,
    "place_name":"Ultimo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2008,
    "place_name":"Darlington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2008,
    "place_name":"Chippendale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2009,
    "place_name":"Pyrmont",
    "state_name":"New South Wales"
  },
  {
    "postcode":2010,
    "place_name":"Darlinghurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2010,
    "place_name":"Surry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2011,
    "place_name":"Kings Cross",
    "state_name":"New South Wales"
  },
  {
    "postcode":2011,
    "place_name":"Potts Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2011,
    "place_name":"Rushcutters Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2011,
    "place_name":"Elizabeth Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2011,
    "place_name":"Woolloomooloo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2012,
    "place_name":"Strawberry Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2015,
    "place_name":"Eveleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2015,
    "place_name":"Alexandria",
    "state_name":"New South Wales"
  },
  {
    "postcode":2015,
    "place_name":"Beaconsfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2016,
    "place_name":"Redfern",
    "state_name":"New South Wales"
  },
  {
    "postcode":2017,
    "place_name":"Waterloo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2017,
    "place_name":"Zetland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2018,
    "place_name":"Rosebery",
    "state_name":"New South Wales"
  },
  {
    "postcode":2018,
    "place_name":"Eastlakes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2019,
    "place_name":"Botany",
    "state_name":"New South Wales"
  },
  {
    "postcode":2019,
    "place_name":"Banksmeadow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2020,
    "place_name":"Sydney International Airport",
    "state_name":"New South Wales"
  },
  {
    "postcode":2020,
    "place_name":"Mascot",
    "state_name":"New South Wales"
  },
  {
    "postcode":2020,
    "place_name":"Sydney Domestic Airport",
    "state_name":"New South Wales"
  },
  {
    "postcode":2021,
    "place_name":"Paddington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2021,
    "place_name":"Moore Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2021,
    "place_name":"Centennial Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2022,
    "place_name":"Queens Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2022,
    "place_name":"Bondi Junction",
    "state_name":"New South Wales"
  },
  {
    "postcode":2023,
    "place_name":"Bellevue Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2024,
    "place_name":"Bronte",
    "state_name":"New South Wales"
  },
  {
    "postcode":2024,
    "place_name":"Waverley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2025,
    "place_name":"Woollahra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2026,
    "place_name":"Tamarama",
    "state_name":"New South Wales"
  },
  {
    "postcode":2026,
    "place_name":"Bondi Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2026,
    "place_name":"Bondi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2026,
    "place_name":"North Bondi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2026,
    "place_name":"Ben Buckler",
    "state_name":"New South Wales"
  },
  {
    "postcode":2027,
    "place_name":"Darling Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2027,
    "place_name":"Hmas Rushcutters",
    "state_name":"New South Wales"
  },
  {
    "postcode":2027,
    "place_name":"Point Piper",
    "state_name":"New South Wales"
  },
  {
    "postcode":2027,
    "place_name":"Edgecliff",
    "state_name":"New South Wales"
  },
  {
    "postcode":2028,
    "place_name":"Double Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2029,
    "place_name":"Rose Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2030,
    "place_name":"Vaucluse",
    "state_name":"New South Wales"
  },
  {
    "postcode":2030,
    "place_name":"Dover Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2030,
    "place_name":"Watsons Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2030,
    "place_name":"Hmas Watson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2030,
    "place_name":"Rose Bay North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2031,
    "place_name":"Clovelly",
    "state_name":"New South Wales"
  },
  {
    "postcode":2031,
    "place_name":"Randwick",
    "state_name":"New South Wales"
  },
  {
    "postcode":2031,
    "place_name":"St Pauls",
    "state_name":"New South Wales"
  },
  {
    "postcode":2031,
    "place_name":"Clovelly West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2032,
    "place_name":"Kingsford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2032,
    "place_name":"Daceyville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2033,
    "place_name":"Kensington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2034,
    "place_name":"South Coogee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2034,
    "place_name":"Coogee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2035,
    "place_name":"Maroubra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2035,
    "place_name":"Pagewood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2035,
    "place_name":"Maroubra South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2036,
    "place_name":"Phillip Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2036,
    "place_name":"Hillsdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2036,
    "place_name":"Port Botany",
    "state_name":"New South Wales"
  },
  {
    "postcode":2036,
    "place_name":"Eastgardens",
    "state_name":"New South Wales"
  },
  {
    "postcode":2036,
    "place_name":"Little Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2036,
    "place_name":"Malabar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2036,
    "place_name":"Chifley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2036,
    "place_name":"La Perouse",
    "state_name":"New South Wales"
  },
  {
    "postcode":2036,
    "place_name":"Matraville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2037,
    "place_name":"Glebe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2037,
    "place_name":"Forest Lodge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2038,
    "place_name":"Annandale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2039,
    "place_name":"Rozelle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2040,
    "place_name":"Lilyfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2040,
    "place_name":"Leichhardt",
    "state_name":"New South Wales"
  },
  {
    "postcode":2041,
    "place_name":"Balmain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2041,
    "place_name":"Balmain East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2041,
    "place_name":"Birchgrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2042,
    "place_name":"Newtown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2042,
    "place_name":"Enmore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2043,
    "place_name":"Erskineville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2044,
    "place_name":"St Peters",
    "state_name":"New South Wales"
  },
  {
    "postcode":2044,
    "place_name":"Sydenham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2044,
    "place_name":"Tempe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2045,
    "place_name":"Haberfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2046,
    "place_name":"Russell Lea",
    "state_name":"New South Wales"
  },
  {
    "postcode":2046,
    "place_name":"Wareemba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2046,
    "place_name":"Five Dock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2046,
    "place_name":"Chiswick",
    "state_name":"New South Wales"
  },
  {
    "postcode":2046,
    "place_name":"Abbotsford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2046,
    "place_name":"Canada Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2046,
    "place_name":"Rodd Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2047,
    "place_name":"Drummoyne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2048,
    "place_name":"Westgate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2048,
    "place_name":"Stanmore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2049,
    "place_name":"Petersham North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2049,
    "place_name":"Petersham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2049,
    "place_name":"Lewisham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2050,
    "place_name":"Missenden Road",
    "state_name":"New South Wales"
  },
  {
    "postcode":2050,
    "place_name":"Camperdown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2052,
    "place_name":"Unsw Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":2055,
    "place_name":"North Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":2057,
    "place_name":"Chatswood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2058,
    "place_name":"Northern Suburbs Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2059,
    "place_name":"North Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":2060,
    "place_name":"Hmas Waterhen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2060,
    "place_name":"Waverton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2060,
    "place_name":"Hmas Platypus",
    "state_name":"New South Wales"
  },
  {
    "postcode":2060,
    "place_name":"Mcmahons Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2060,
    "place_name":"North Sydney Shoppingworld",
    "state_name":"New South Wales"
  },
  {
    "postcode":2060,
    "place_name":"North Sydney",
    "state_name":"New South Wales"
  },
  {
    "postcode":2060,
    "place_name":"Lavender Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2061,
    "place_name":"Milsons Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2061,
    "place_name":"Kirribilli",
    "state_name":"New South Wales"
  },
  {
    "postcode":2062,
    "place_name":"Cammeray",
    "state_name":"New South Wales"
  },
  {
    "postcode":2063,
    "place_name":"Northbridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2064,
    "place_name":"Artarmon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2065,
    "place_name":"Greenwich",
    "state_name":"New South Wales"
  },
  {
    "postcode":2065,
    "place_name":"Crows Nest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2065,
    "place_name":"Gore Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2065,
    "place_name":"Wollstonecraft",
    "state_name":"New South Wales"
  },
  {
    "postcode":2065,
    "place_name":"St Leonards",
    "state_name":"New South Wales"
  },
  {
    "postcode":2065,
    "place_name":"Naremburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2065,
    "place_name":"Royal North Shore Hospital",
    "state_name":"New South Wales"
  },
  {
    "postcode":2066,
    "place_name":"Northwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2066,
    "place_name":"Riverview",
    "state_name":"New South Wales"
  },
  {
    "postcode":2066,
    "place_name":"Longueville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2066,
    "place_name":"Lane Cove North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2066,
    "place_name":"Linley Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2066,
    "place_name":"Lane Cove West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2066,
    "place_name":"Lane Cove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2067,
    "place_name":"Chatswood West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2067,
    "place_name":"Chatswood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2068,
    "place_name":"Willoughby East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2068,
    "place_name":"Middle Cove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2068,
    "place_name":"Willoughby North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2068,
    "place_name":"Castlecrag",
    "state_name":"New South Wales"
  },
  {
    "postcode":2068,
    "place_name":"Willoughby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2068,
    "place_name":"North Willoughby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2069,
    "place_name":"Castle Cove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2069,
    "place_name":"Roseville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2069,
    "place_name":"Roseville Chase",
    "state_name":"New South Wales"
  },
  {
    "postcode":2070,
    "place_name":"East Lindfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2070,
    "place_name":"Lindfield West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2070,
    "place_name":"Lindfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2071,
    "place_name":"Killara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2071,
    "place_name":"East Killara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2072,
    "place_name":"Gordon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2073,
    "place_name":"West Pymble",
    "state_name":"New South Wales"
  },
  {
    "postcode":2073,
    "place_name":"Pymble",
    "state_name":"New South Wales"
  },
  {
    "postcode":2074,
    "place_name":"South Turramurra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2074,
    "place_name":"Warrawee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2074,
    "place_name":"North Turramurra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2074,
    "place_name":"Turramurra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2075,
    "place_name":"St Ives Chase",
    "state_name":"New South Wales"
  },
  {
    "postcode":2075,
    "place_name":"St Ives",
    "state_name":"New South Wales"
  },
  {
    "postcode":2076,
    "place_name":"Wahroonga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2076,
    "place_name":"North Wahroonga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2076,
    "place_name":"Normanhurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2077,
    "place_name":"Waitara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2077,
    "place_name":"Hornsby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2077,
    "place_name":"Asquith",
    "state_name":"New South Wales"
  },
  {
    "postcode":2077,
    "place_name":"Hornsby Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2079,
    "place_name":"Mount Colah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2080,
    "place_name":"Mount Kuring-Gai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2081,
    "place_name":"Berowra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2081,
    "place_name":"Cowan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2082,
    "place_name":"Berowra Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2082,
    "place_name":"Berowra Waters",
    "state_name":"New South Wales"
  },
  {
    "postcode":2082,
    "place_name":"Berowra Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2083,
    "place_name":"Cogra Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2083,
    "place_name":"Dangar Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2083,
    "place_name":"Cheero Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2083,
    "place_name":"Bar Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2083,
    "place_name":"Brooklyn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2083,
    "place_name":"Milsons Passage",
    "state_name":"New South Wales"
  },
  {
    "postcode":2083,
    "place_name":"Mooney Mooney",
    "state_name":"New South Wales"
  },
  {
    "postcode":2084,
    "place_name":"Duffys Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2084,
    "place_name":"Terrey Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2084,
    "place_name":"Cottage Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2085,
    "place_name":"Belrose West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2085,
    "place_name":"Belrose",
    "state_name":"New South Wales"
  },
  {
    "postcode":2085,
    "place_name":"Davidson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2086,
    "place_name":"Frenchs Forest East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2086,
    "place_name":"Frenchs Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2087,
    "place_name":"Killarney Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2087,
    "place_name":"Forestville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2088,
    "place_name":"Mosman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2088,
    "place_name":"Spit Junction",
    "state_name":"New South Wales"
  },
  {
    "postcode":2089,
    "place_name":"Kurraba Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2089,
    "place_name":"Neutral Bay Junction",
    "state_name":"New South Wales"
  },
  {
    "postcode":2089,
    "place_name":"Neutral Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2090,
    "place_name":"Cremorne Junction",
    "state_name":"New South Wales"
  },
  {
    "postcode":2090,
    "place_name":"Cremorne Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2090,
    "place_name":"Cremorne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2091,
    "place_name":"Hmas Penguin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2092,
    "place_name":"Seaforth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2093,
    "place_name":"Balgowlah Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2093,
    "place_name":"North Balgowlah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2093,
    "place_name":"Balgowlah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2093,
    "place_name":"Manly Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2093,
    "place_name":"Clontarf",
    "state_name":"New South Wales"
  },
  {
    "postcode":2094,
    "place_name":"Fairlight",
    "state_name":"New South Wales"
  },
  {
    "postcode":2095,
    "place_name":"Manly",
    "state_name":"New South Wales"
  },
  {
    "postcode":2095,
    "place_name":"Manly East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2096,
    "place_name":"Curl Curl",
    "state_name":"New South Wales"
  },
  {
    "postcode":2096,
    "place_name":"Harbord",
    "state_name":"New South Wales"
  },
  {
    "postcode":2096,
    "place_name":"Queenscliff",
    "state_name":"New South Wales"
  },
  {
    "postcode":2096,
    "place_name":"Freshwater",
    "state_name":"New South Wales"
  },
  {
    "postcode":2097,
    "place_name":"Collaroy Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2097,
    "place_name":"Wheeler Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2097,
    "place_name":"Collaroy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2097,
    "place_name":"Collaroy Plateau",
    "state_name":"New South Wales"
  },
  {
    "postcode":2099,
    "place_name":"Wingala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2099,
    "place_name":"Narraweena",
    "state_name":"New South Wales"
  },
  {
    "postcode":2099,
    "place_name":"Cromer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2099,
    "place_name":"Dee Why",
    "state_name":"New South Wales"
  },
  {
    "postcode":2099,
    "place_name":"North Curl Curl",
    "state_name":"New South Wales"
  },
  {
    "postcode":2100,
    "place_name":"Brookvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2100,
    "place_name":"Warringah Mall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2100,
    "place_name":"Beacon Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2100,
    "place_name":"Oxford Falls",
    "state_name":"New South Wales"
  },
  {
    "postcode":2100,
    "place_name":"Allambie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2100,
    "place_name":"North Manly",
    "state_name":"New South Wales"
  },
  {
    "postcode":2100,
    "place_name":"Allambie Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2101,
    "place_name":"Elanora Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2101,
    "place_name":"Narrabeen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2101,
    "place_name":"North Narrabeen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2101,
    "place_name":"Ingleside",
    "state_name":"New South Wales"
  },
  {
    "postcode":2102,
    "place_name":"Warriewood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2102,
    "place_name":"Warriewood Shopping Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":2103,
    "place_name":"Mona Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2104,
    "place_name":"Bayview",
    "state_name":"New South Wales"
  },
  {
    "postcode":2105,
    "place_name":"Church Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2105,
    "place_name":"Morning Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2105,
    "place_name":"Elvina Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2105,
    "place_name":"Lovett Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2105,
    "place_name":"Scotland Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2105,
    "place_name":"Mccarrs Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2106,
    "place_name":"Newport",
    "state_name":"New South Wales"
  },
  {
    "postcode":2106,
    "place_name":"Newport Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2107,
    "place_name":"Clareville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2107,
    "place_name":"Bilgola Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2107,
    "place_name":"Whale Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2107,
    "place_name":"Bilgola Plateau",
    "state_name":"New South Wales"
  },
  {
    "postcode":2107,
    "place_name":"Careel Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2107,
    "place_name":"Avalon Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2107,
    "place_name":"Bilgola",
    "state_name":"New South Wales"
  },
  {
    "postcode":2108,
    "place_name":"Great Mackerel Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2108,
    "place_name":"Palm Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2108,
    "place_name":"Currawong Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2108,
    "place_name":"Coasters Retreat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2108,
    "place_name":"The Basin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2109,
    "place_name":"Macquarie University",
    "state_name":"New South Wales"
  },
  {
    "postcode":2110,
    "place_name":"Hunters Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2110,
    "place_name":"Woolwich",
    "state_name":"New South Wales"
  },
  {
    "postcode":2111,
    "place_name":"Henley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2111,
    "place_name":"Gladesville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2111,
    "place_name":"Huntleys Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2111,
    "place_name":"Huntleys Cove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2111,
    "place_name":"Tennyson Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2111,
    "place_name":"Monash Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2111,
    "place_name":"Boronia Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2112,
    "place_name":"Ryde",
    "state_name":"New South Wales"
  },
  {
    "postcode":2112,
    "place_name":"Putney",
    "state_name":"New South Wales"
  },
  {
    "postcode":2112,
    "place_name":"Denistone East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2113,
    "place_name":"Macquarie Centre",
    "state_name":"New South Wales"
  },
  {
    "postcode":2113,
    "place_name":"East Ryde",
    "state_name":"New South Wales"
  },
  {
    "postcode":2113,
    "place_name":"Macquarie Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2113,
    "place_name":"North Ryde",
    "state_name":"New South Wales"
  },
  {
    "postcode":2113,
    "place_name":"Blenheim Road",
    "state_name":"New South Wales"
  },
  {
    "postcode":2114,
    "place_name":"Meadowbank",
    "state_name":"New South Wales"
  },
  {
    "postcode":2114,
    "place_name":"West Ryde",
    "state_name":"New South Wales"
  },
  {
    "postcode":2114,
    "place_name":"Denistone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2114,
    "place_name":"Denistone West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2114,
    "place_name":"Melrose Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2115,
    "place_name":"Ermington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2116,
    "place_name":"Rydalmere",
    "state_name":"New South Wales"
  },
  {
    "postcode":2117,
    "place_name":"Dundas",
    "state_name":"New South Wales"
  },
  {
    "postcode":2117,
    "place_name":"Dundas Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2117,
    "place_name":"Telopea",
    "state_name":"New South Wales"
  },
  {
    "postcode":2117,
    "place_name":"Oatlands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2118,
    "place_name":"Carlingford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2118,
    "place_name":"Carlingford Court",
    "state_name":"New South Wales"
  },
  {
    "postcode":2118,
    "place_name":"Carlingford North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2118,
    "place_name":"Kingsdene",
    "state_name":"New South Wales"
  },
  {
    "postcode":2119,
    "place_name":"Beecroft",
    "state_name":"New South Wales"
  },
  {
    "postcode":2119,
    "place_name":"Cheltenham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2120,
    "place_name":"Pennant Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2120,
    "place_name":"Thornleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2120,
    "place_name":"Westleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2121,
    "place_name":"Epping",
    "state_name":"New South Wales"
  },
  {
    "postcode":2121,
    "place_name":"North Epping",
    "state_name":"New South Wales"
  },
  {
    "postcode":2122,
    "place_name":"Marsfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2122,
    "place_name":"Eastwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2123,
    "place_name":"Parramatta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2124,
    "place_name":"Parramatta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2125,
    "place_name":"West Pennant Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2126,
    "place_name":"Cherrybrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2127,
    "place_name":"Sydney Olympic Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2127,
    "place_name":"Wentworth Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2127,
    "place_name":"Homebush Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2127,
    "place_name":"Newington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2128,
    "place_name":"Silverwater",
    "state_name":"New South Wales"
  },
  {
    "postcode":2129,
    "place_name":"Sydney Markets",
    "state_name":"New South Wales"
  },
  {
    "postcode":2130,
    "place_name":"Summer Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2131,
    "place_name":"Ashfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2132,
    "place_name":"Croydon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2133,
    "place_name":"Enfield South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2133,
    "place_name":"Croydon Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2134,
    "place_name":"Burwood North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2134,
    "place_name":"Burwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2135,
    "place_name":"Strathfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2136,
    "place_name":"Strathfield South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2136,
    "place_name":"Burwood Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2136,
    "place_name":"Enfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2137,
    "place_name":"Mortlake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2137,
    "place_name":"Breakfast Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2137,
    "place_name":"Concord",
    "state_name":"New South Wales"
  },
  {
    "postcode":2137,
    "place_name":"Cabarita",
    "state_name":"New South Wales"
  },
  {
    "postcode":2137,
    "place_name":"North Strathfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2138,
    "place_name":"Concord West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2138,
    "place_name":"Rhodes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2138,
    "place_name":"Liberty Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2139,
    "place_name":"Concord Repatriation Hospital",
    "state_name":"New South Wales"
  },
  {
    "postcode":2140,
    "place_name":"Homebush",
    "state_name":"New South Wales"
  },
  {
    "postcode":2140,
    "place_name":"Homebush South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2140,
    "place_name":"Homebush West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2141,
    "place_name":"Rookwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2141,
    "place_name":"Lidcombe North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2141,
    "place_name":"Berala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2141,
    "place_name":"Lidcombe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2142,
    "place_name":"Camellia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2142,
    "place_name":"Blaxcell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2142,
    "place_name":"Granville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2142,
    "place_name":"South Granville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2142,
    "place_name":"Rosehill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2142,
    "place_name":"Clyde",
    "state_name":"New South Wales"
  },
  {
    "postcode":2142,
    "place_name":"Holroyd",
    "state_name":"New South Wales"
  },
  {
    "postcode":2143,
    "place_name":"Birrong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2143,
    "place_name":"Potts Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2143,
    "place_name":"Regents Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2144,
    "place_name":"Auburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2145,
    "place_name":"Wentworthville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2145,
    "place_name":"Girraween",
    "state_name":"New South Wales"
  },
  {
    "postcode":2145,
    "place_name":"Pemulwuy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2145,
    "place_name":"Westmead",
    "state_name":"New South Wales"
  },
  {
    "postcode":2145,
    "place_name":"Greystanes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2145,
    "place_name":"Mays Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2145,
    "place_name":"South Wentworthville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2145,
    "place_name":"Pendle Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2145,
    "place_name":"Constitution Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2146,
    "place_name":"Toongabbie East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2146,
    "place_name":"Toongabbie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2146,
    "place_name":"Old Toongabbie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2147,
    "place_name":"Lalor Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2147,
    "place_name":"Seven Hills West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2147,
    "place_name":"Seven Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2147,
    "place_name":"Kings Langley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2148,
    "place_name":"Prospect",
    "state_name":"New South Wales"
  },
  {
    "postcode":2148,
    "place_name":"Kings Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2148,
    "place_name":"Marayong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2148,
    "place_name":"Huntingwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2148,
    "place_name":"Blacktown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2148,
    "place_name":"Blacktown Westpoint",
    "state_name":"New South Wales"
  },
  {
    "postcode":2148,
    "place_name":"Arndell Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2150,
    "place_name":"Parramatta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2150,
    "place_name":"Harris Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2150,
    "place_name":"Parramatta Westfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2151,
    "place_name":"North Parramatta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2151,
    "place_name":"North Rocks",
    "state_name":"New South Wales"
  },
  {
    "postcode":2152,
    "place_name":"Northmead",
    "state_name":"New South Wales"
  },
  {
    "postcode":2153,
    "place_name":"Winston Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2153,
    "place_name":"Bella Vista",
    "state_name":"New South Wales"
  },
  {
    "postcode":2153,
    "place_name":"Baulkham Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2154,
    "place_name":"Castle Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2155,
    "place_name":"Rouse Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2155,
    "place_name":"Beaumont Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2155,
    "place_name":"Kellyville Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2155,
    "place_name":"Kellyville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2156,
    "place_name":"Annangrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2156,
    "place_name":"Glenhaven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2156,
    "place_name":"Kenthurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2157,
    "place_name":"Glenorie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2157,
    "place_name":"Forest Glen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2157,
    "place_name":"Canoelands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2158,
    "place_name":"Round Corner",
    "state_name":"New South Wales"
  },
  {
    "postcode":2158,
    "place_name":"Dural",
    "state_name":"New South Wales"
  },
  {
    "postcode":2158,
    "place_name":"Middle Dural",
    "state_name":"New South Wales"
  },
  {
    "postcode":2159,
    "place_name":"Galston",
    "state_name":"New South Wales"
  },
  {
    "postcode":2159,
    "place_name":"Arcadia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2159,
    "place_name":"Berrilee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2159,
    "place_name":"Fiddletown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2160,
    "place_name":"Merrylands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2160,
    "place_name":"Merrylands West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2161,
    "place_name":"Guildford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2161,
    "place_name":"Old Guildford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2161,
    "place_name":"Yennora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2161,
    "place_name":"Guildford West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2162,
    "place_name":"Chester Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2162,
    "place_name":"Sefton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2163,
    "place_name":"Lansdowne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2163,
    "place_name":"Carramar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2163,
    "place_name":"Villawood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2164,
    "place_name":"Smithfield West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2164,
    "place_name":"Smithfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2164,
    "place_name":"Woodpark",
    "state_name":"New South Wales"
  },
  {
    "postcode":2164,
    "place_name":"Wetherill Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2165,
    "place_name":"Fairfield West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2165,
    "place_name":"Fairfield East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2165,
    "place_name":"Fairfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2165,
    "place_name":"Fairfield Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2166,
    "place_name":"Canley Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2166,
    "place_name":"Cabramatta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2166,
    "place_name":"Cabramatta West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2166,
    "place_name":"Lansvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2166,
    "place_name":"Canley Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2167,
    "place_name":"Glenfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2168,
    "place_name":"Green Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2168,
    "place_name":"Ashcroft",
    "state_name":"New South Wales"
  },
  {
    "postcode":2168,
    "place_name":"Heckenberg",
    "state_name":"New South Wales"
  },
  {
    "postcode":2168,
    "place_name":"Busby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2168,
    "place_name":"Cartwright",
    "state_name":"New South Wales"
  },
  {
    "postcode":2168,
    "place_name":"Miller",
    "state_name":"New South Wales"
  },
  {
    "postcode":2168,
    "place_name":"Hinchinbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2168,
    "place_name":"Sadleir",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Casula",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Lurnea",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Hammondville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Liverpool South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Chipping Norton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Casula Mall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Mount Pritchard",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Liverpool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Moorebank",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Liverpool Westfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Prestons",
    "state_name":"New South Wales"
  },
  {
    "postcode":2170,
    "place_name":"Warwick Farm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2171,
    "place_name":"Hoxton Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2171,
    "place_name":"Carnes Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2171,
    "place_name":"Cecil Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2171,
    "place_name":"West Hoxton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2171,
    "place_name":"Len Waters Estate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2171,
    "place_name":"Horningsea Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2171,
    "place_name":"Elizabeth Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2171,
    "place_name":"Middleton Grange",
    "state_name":"New South Wales"
  },
  {
    "postcode":2172,
    "place_name":"Sandy Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2172,
    "place_name":"Voyager Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2172,
    "place_name":"Pleasure Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2173,
    "place_name":"Holsworthy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2173,
    "place_name":"Wattle Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2174,
    "place_name":"Edmondson Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2175,
    "place_name":"Horsley Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2176,
    "place_name":"Bossley Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2176,
    "place_name":"Abbotsbury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2176,
    "place_name":"St Johns Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2176,
    "place_name":"Greenfield Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2176,
    "place_name":"Prairiewood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2176,
    "place_name":"Wakeley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2176,
    "place_name":"Edensor Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2177,
    "place_name":"Bonnyrigg Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2177,
    "place_name":"Bonnyrigg",
    "state_name":"New South Wales"
  },
  {
    "postcode":2178,
    "place_name":"Kemps Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2178,
    "place_name":"Mount Vernon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2178,
    "place_name":"Cecil Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2179,
    "place_name":"Austral",
    "state_name":"New South Wales"
  },
  {
    "postcode":2179,
    "place_name":"Leppington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2190,
    "place_name":"Mount Lewis",
    "state_name":"New South Wales"
  },
  {
    "postcode":2190,
    "place_name":"Greenacre",
    "state_name":"New South Wales"
  },
  {
    "postcode":2190,
    "place_name":"Chullora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2191,
    "place_name":"Belfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2192,
    "place_name":"Belmore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2193,
    "place_name":"Hurlstone Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2193,
    "place_name":"Canterbury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2193,
    "place_name":"Ashbury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2194,
    "place_name":"Campsie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2195,
    "place_name":"Wiley Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2195,
    "place_name":"Lakemba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2196,
    "place_name":"Roselands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2196,
    "place_name":"Punchbowl",
    "state_name":"New South Wales"
  },
  {
    "postcode":2197,
    "place_name":"Bass Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2198,
    "place_name":"Georges Hall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2199,
    "place_name":"Yagoona",
    "state_name":"New South Wales"
  },
  {
    "postcode":2199,
    "place_name":"Yagoona West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2200,
    "place_name":"Condell Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2200,
    "place_name":"Mount Lewis",
    "state_name":"New South Wales"
  },
  {
    "postcode":2200,
    "place_name":"Bankstown Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":2200,
    "place_name":"Bankstown Aerodrome",
    "state_name":"New South Wales"
  },
  {
    "postcode":2200,
    "place_name":"Bankstown North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2200,
    "place_name":"Manahan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2200,
    "place_name":"Bankstown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2203,
    "place_name":"Dulwich Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2204,
    "place_name":"Marrickville Metro",
    "state_name":"New South Wales"
  },
  {
    "postcode":2204,
    "place_name":"Marrickville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2204,
    "place_name":"Marrickville South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2205,
    "place_name":"Turrella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2205,
    "place_name":"Wolli Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2205,
    "place_name":"Arncliffe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2206,
    "place_name":"Earlwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2206,
    "place_name":"Undercliffe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2206,
    "place_name":"Clemton Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2207,
    "place_name":"Bexley South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2207,
    "place_name":"Bexley North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2207,
    "place_name":"Bexley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2207,
    "place_name":"Bardwell Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2207,
    "place_name":"Bardwell Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2208,
    "place_name":"Kingsway West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2208,
    "place_name":"Kingsgrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2209,
    "place_name":"Beverly Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2209,
    "place_name":"Narwee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2210,
    "place_name":"Peakhurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2210,
    "place_name":"Peakhurst Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2210,
    "place_name":"Lugarno",
    "state_name":"New South Wales"
  },
  {
    "postcode":2210,
    "place_name":"Riverwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2211,
    "place_name":"Padstow Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2211,
    "place_name":"Padstow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2212,
    "place_name":"Revesby Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2212,
    "place_name":"Revesby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2212,
    "place_name":"Revesby North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2213,
    "place_name":"Panania",
    "state_name":"New South Wales"
  },
  {
    "postcode":2213,
    "place_name":"East Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2213,
    "place_name":"Picnic Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2214,
    "place_name":"Milperra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2216,
    "place_name":"Rockdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2216,
    "place_name":"Kyeemagh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2216,
    "place_name":"Brighton-Le-Sands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2216,
    "place_name":"Banksia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2217,
    "place_name":"Beverley Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2217,
    "place_name":"Ramsgate Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2217,
    "place_name":"Kogarah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2217,
    "place_name":"Kogarah Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2217,
    "place_name":"Monterey",
    "state_name":"New South Wales"
  },
  {
    "postcode":2217,
    "place_name":"Ramsgate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2218,
    "place_name":"Allawah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2218,
    "place_name":"Carlton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2219,
    "place_name":"Dolls Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2219,
    "place_name":"Sans Souci",
    "state_name":"New South Wales"
  },
  {
    "postcode":2219,
    "place_name":"Sandringham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2220,
    "place_name":"Hurstville Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2220,
    "place_name":"Hurstville Westfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2220,
    "place_name":"Hurstville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2221,
    "place_name":"Blakehurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2221,
    "place_name":"Kyle Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2221,
    "place_name":"Carss Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2221,
    "place_name":"South Hurstville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2221,
    "place_name":"Connells Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2222,
    "place_name":"Penshurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2223,
    "place_name":"Mortdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2223,
    "place_name":"Oatley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2224,
    "place_name":"Kangaroo Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2224,
    "place_name":"Sylvania",
    "state_name":"New South Wales"
  },
  {
    "postcode":2224,
    "place_name":"Sylvania Southgate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2224,
    "place_name":"Sylvania Waters",
    "state_name":"New South Wales"
  },
  {
    "postcode":2225,
    "place_name":"Oyster Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2226,
    "place_name":"Jannali",
    "state_name":"New South Wales"
  },
  {
    "postcode":2226,
    "place_name":"Como",
    "state_name":"New South Wales"
  },
  {
    "postcode":2226,
    "place_name":"Bonnet Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2227,
    "place_name":"Gymea Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2227,
    "place_name":"Gymea",
    "state_name":"New South Wales"
  },
  {
    "postcode":2228,
    "place_name":"Miranda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2228,
    "place_name":"Yowie Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2229,
    "place_name":"Taren Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2229,
    "place_name":"Caringbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2229,
    "place_name":"Caringbah South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2229,
    "place_name":"Port Hacking",
    "state_name":"New South Wales"
  },
  {
    "postcode":2229,
    "place_name":"Dolans Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2229,
    "place_name":"Lilli Pilli",
    "state_name":"New South Wales"
  },
  {
    "postcode":2230,
    "place_name":"Greenhills Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2230,
    "place_name":"Burraneer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2230,
    "place_name":"Maianbar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2230,
    "place_name":"Woolooware",
    "state_name":"New South Wales"
  },
  {
    "postcode":2230,
    "place_name":"Bundeena",
    "state_name":"New South Wales"
  },
  {
    "postcode":2230,
    "place_name":"Cronulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2231,
    "place_name":"Kurnell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2232,
    "place_name":"Audley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2232,
    "place_name":"Sutherland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2232,
    "place_name":"Loftus",
    "state_name":"New South Wales"
  },
  {
    "postcode":2232,
    "place_name":"Kirrawee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2232,
    "place_name":"Woronora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2232,
    "place_name":"Kareela",
    "state_name":"New South Wales"
  },
  {
    "postcode":2232,
    "place_name":"Grays Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2233,
    "place_name":"Waterfall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2233,
    "place_name":"Woronora Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2233,
    "place_name":"Heathcote",
    "state_name":"New South Wales"
  },
  {
    "postcode":2233,
    "place_name":"Yarrawarrah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2233,
    "place_name":"Engadine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2234,
    "place_name":"Lucas Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2234,
    "place_name":"Illawong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2234,
    "place_name":"Menai Central",
    "state_name":"New South Wales"
  },
  {
    "postcode":2234,
    "place_name":"Menai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2234,
    "place_name":"Bangor",
    "state_name":"New South Wales"
  },
  {
    "postcode":2234,
    "place_name":"Alfords Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2234,
    "place_name":"Barden Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Wyoming",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Somersby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"West Gosford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Mount Elliot",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Erina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Niagara Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Central Mangrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Mangrove Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Glenworth Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Kariong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Narara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Tascott",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Peats Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Mount White",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Kulnura",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Springfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Point Clare",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Mooney Mooney Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Lisarow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Gosford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"East Gosford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Mangrove Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Upper Mangrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"North Gosford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Matcham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Ten Mile Hollow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Erina Fair",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Point Frederick",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Holgate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Bucketty",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Lower Mangrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Wendoree Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Greengrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2250,
    "place_name":"Calga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Picketts Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Bouddi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Davistown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Copacabana",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Green Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Yattalunga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Kincumber",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Macmasters Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Avoca Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Saratoga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Bensville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2251,
    "place_name":"Kincumber South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2252,
    "place_name":"Central Coast Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2256,
    "place_name":"Horsfield Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2256,
    "place_name":"Phegans Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2256,
    "place_name":"Woy Woy Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2256,
    "place_name":"Little Wobby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2256,
    "place_name":"Patonga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2256,
    "place_name":"Koolewong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2256,
    "place_name":"Pearl Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2256,
    "place_name":"Blackwall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2256,
    "place_name":"Wondabyne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2256,
    "place_name":"Woy Woy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"Killcare Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"Booker Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"Daleys Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"Empire Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"Hardys Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"Pretty Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"Box Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"Killcare",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"St Huberts Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"Umina Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"Ettalong Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2257,
    "place_name":"Wagstaffe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2258,
    "place_name":"Palmdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2258,
    "place_name":"Palm Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2258,
    "place_name":"Fountaindale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2258,
    "place_name":"Kangy Angy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2258,
    "place_name":"Ourimbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Wybung",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Yarramalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Cedar Brush Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Kiar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Frazer Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Lake Munmorah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Dooralong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Wadalba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Bushells Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Mardi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Little Jilliby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Warnervale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Gwandalan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Alison",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Mannering Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Freemans",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Tacoma South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Halloran",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Watanobbi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Jilliby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Crangan Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Wyong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Durren Durren",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Point Wolstoncroft",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Moonee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Tacoma",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Kingfisher Shores",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Wyong Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Chain Valley Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Ravensdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Rocky Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Wyee Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Lemon Tree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Wyee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Kanwal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Wallarah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Tuggerah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Tuggerawong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Woongarrah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Summerland Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Wyongah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2259,
    "place_name":"Hamlyn Terrace",
    "state_name":"New South Wales"
  },
  {
    "postcode":2260,
    "place_name":"Terrigal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2260,
    "place_name":"Wamberal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2260,
    "place_name":"Erina Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2260,
    "place_name":"Forresters Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2260,
    "place_name":"North Avoca",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Blue Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Killarney Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Bateau Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Bay Village",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Tumbi Umbi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Chittaway Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Long Jetty",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"The Entrance North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Magenta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"The Entrance",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Toowoon Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Berkeley Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Glenning Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Shelly Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2261,
    "place_name":"Chittaway Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2262,
    "place_name":"Colongra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2262,
    "place_name":"Budgewoi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2262,
    "place_name":"Halekulani",
    "state_name":"New South Wales"
  },
  {
    "postcode":2262,
    "place_name":"Doyalson North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2262,
    "place_name":"San Remo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2262,
    "place_name":"Budgewoi Peninsula",
    "state_name":"New South Wales"
  },
  {
    "postcode":2262,
    "place_name":"Buff Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2262,
    "place_name":"Doyalson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2262,
    "place_name":"Blue Haven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2263,
    "place_name":"Charmhaven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2263,
    "place_name":"Gorokan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2263,
    "place_name":"Norah Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2263,
    "place_name":"Canton Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2263,
    "place_name":"Toukley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2263,
    "place_name":"Noraville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2263,
    "place_name":"Lake Haven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Yarrawonga Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Myuna Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Dora Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Silverwater",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Mirrabooka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Mandalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Balcolyn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Morisset",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Eraring",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Sunshine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Windermere Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Morisset Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Bonnells Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2264,
    "place_name":"Brightwaters",
    "state_name":"New South Wales"
  },
  {
    "postcode":2265,
    "place_name":"Cooranbong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2265,
    "place_name":"Martinsville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2267,
    "place_name":"Wangi Wangi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2278,
    "place_name":"Barnsley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2278,
    "place_name":"Killingworth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2278,
    "place_name":"Wakefield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2280,
    "place_name":"Croudace Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2280,
    "place_name":"Marks Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2280,
    "place_name":"Belmont South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2280,
    "place_name":"Jewells",
    "state_name":"New South Wales"
  },
  {
    "postcode":2280,
    "place_name":"Belmont",
    "state_name":"New South Wales"
  },
  {
    "postcode":2280,
    "place_name":"Valentine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2280,
    "place_name":"Floraville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2280,
    "place_name":"Belmont North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Blacksmiths",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Little Pelican",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Swansea",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Middle Camp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Murrays Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Pinny Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Pelican",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Swansea Heads",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Caves Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Cams Wharf",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Nords Wharf",
    "state_name":"New South Wales"
  },
  {
    "postcode":2281,
    "place_name":"Catherine Hill Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2282,
    "place_name":"Warners Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2282,
    "place_name":"Lakelands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2282,
    "place_name":"Eleebana",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Buttaba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Balmoral",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Carey Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Coal Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Fishing Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Rathmines",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Fassifern",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Arcadia Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Kilaben Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Ryhope",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Bolton Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Toronto",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Blackalls Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Fennell Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2283,
    "place_name":"Awaba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2284,
    "place_name":"Teralba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2284,
    "place_name":"Argenton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2284,
    "place_name":"Marmong Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2284,
    "place_name":"Boolaroo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2284,
    "place_name":"Woodrising",
    "state_name":"New South Wales"
  },
  {
    "postcode":2284,
    "place_name":"Speers Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2284,
    "place_name":"Booragul",
    "state_name":"New South Wales"
  },
  {
    "postcode":2285,
    "place_name":"Macquarie Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2285,
    "place_name":"Cardiff South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2285,
    "place_name":"Cameron Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2285,
    "place_name":"Edgeworth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2285,
    "place_name":"Cardiff",
    "state_name":"New South Wales"
  },
  {
    "postcode":2285,
    "place_name":"Cardiff Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2285,
    "place_name":"Glendale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2286,
    "place_name":"West Wallsend",
    "state_name":"New South Wales"
  },
  {
    "postcode":2286,
    "place_name":"Seahampton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2286,
    "place_name":"Holmesville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2287,
    "place_name":"Birmingham Gardens",
    "state_name":"New South Wales"
  },
  {
    "postcode":2287,
    "place_name":"Rankin Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2287,
    "place_name":"Elermore Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2287,
    "place_name":"Minmi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2287,
    "place_name":"Maryland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2287,
    "place_name":"Fletcher",
    "state_name":"New South Wales"
  },
  {
    "postcode":2287,
    "place_name":"Wallsend South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2287,
    "place_name":"Wallsend",
    "state_name":"New South Wales"
  },
  {
    "postcode":2287,
    "place_name":"Summer Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2289,
    "place_name":"Highfields",
    "state_name":"New South Wales"
  },
  {
    "postcode":2289,
    "place_name":"Kotara Fair",
    "state_name":"New South Wales"
  },
  {
    "postcode":2289,
    "place_name":"Kotara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2289,
    "place_name":"Kotara South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2289,
    "place_name":"Adamstown Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2289,
    "place_name":"Garden Suburb",
    "state_name":"New South Wales"
  },
  {
    "postcode":2289,
    "place_name":"Adamstown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2290,
    "place_name":"Charlestown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2290,
    "place_name":"Dudley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2290,
    "place_name":"Whitebridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2290,
    "place_name":"Bennetts Green",
    "state_name":"New South Wales"
  },
  {
    "postcode":2290,
    "place_name":"Redhead",
    "state_name":"New South Wales"
  },
  {
    "postcode":2290,
    "place_name":"Mount Hutton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2290,
    "place_name":"Gateshead",
    "state_name":"New South Wales"
  },
  {
    "postcode":2290,
    "place_name":"Kahibah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2290,
    "place_name":"Hillsborough",
    "state_name":"New South Wales"
  },
  {
    "postcode":2290,
    "place_name":"Tingira Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2291,
    "place_name":"The Junction",
    "state_name":"New South Wales"
  },
  {
    "postcode":2291,
    "place_name":"Merewether",
    "state_name":"New South Wales"
  },
  {
    "postcode":2291,
    "place_name":"Merewether Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2292,
    "place_name":"Hamilton North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2292,
    "place_name":"Broadmeadow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2293,
    "place_name":"Maryville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2293,
    "place_name":"Wickham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2294,
    "place_name":"Carrington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2295,
    "place_name":"Fern Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2295,
    "place_name":"Stockton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2296,
    "place_name":"Islington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2297,
    "place_name":"Tighes Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2298,
    "place_name":"Waratah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2298,
    "place_name":"Georgetown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2298,
    "place_name":"Waratah West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2299,
    "place_name":"Lambton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2299,
    "place_name":"Jesmond",
    "state_name":"New South Wales"
  },
  {
    "postcode":2299,
    "place_name":"North Lambton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2300,
    "place_name":"Newcastle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2300,
    "place_name":"The Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2300,
    "place_name":"Cooks Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2300,
    "place_name":"Newcastle East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2300,
    "place_name":"Bar Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2302,
    "place_name":"Newcastle West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2303,
    "place_name":"Hamilton South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2303,
    "place_name":"Hamilton East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2303,
    "place_name":"Hamilton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2304,
    "place_name":"Kooragang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2304,
    "place_name":"Warabrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2304,
    "place_name":"Mayfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2304,
    "place_name":"Mayfield West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2304,
    "place_name":"Sandgate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2304,
    "place_name":"Mayfield East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2304,
    "place_name":"Mayfield North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2305,
    "place_name":"New Lambton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2305,
    "place_name":"Kotara East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2305,
    "place_name":"New Lambton Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2306,
    "place_name":"Windale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2307,
    "place_name":"Shortland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2308,
    "place_name":"Newcastle University",
    "state_name":"New South Wales"
  },
  {
    "postcode":2308,
    "place_name":"Callaghan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2309,
    "place_name":"Dangar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2310,
    "place_name":"Hunter Region Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2311,
    "place_name":"East Gresford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2311,
    "place_name":"Halton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2311,
    "place_name":"Gresford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2311,
    "place_name":"Bingleburra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2311,
    "place_name":"Mount Rivers",
    "state_name":"New South Wales"
  },
  {
    "postcode":2311,
    "place_name":"Upper Allyn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2311,
    "place_name":"Lostock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2311,
    "place_name":"Allynbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2311,
    "place_name":"Eccleston",
    "state_name":"New South Wales"
  },
  {
    "postcode":2311,
    "place_name":"Carrabolla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2311,
    "place_name":"Lewinsbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2312,
    "place_name":"Minimbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2312,
    "place_name":"Nabiac",
    "state_name":"New South Wales"
  },
  {
    "postcode":2314,
    "place_name":"Williamtown Raaf",
    "state_name":"New South Wales"
  },
  {
    "postcode":2315,
    "place_name":"Fingal Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2315,
    "place_name":"Corlette",
    "state_name":"New South Wales"
  },
  {
    "postcode":2315,
    "place_name":"Shoal Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2315,
    "place_name":"Nelson Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2316,
    "place_name":"Taylors Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2316,
    "place_name":"Fishermans Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2316,
    "place_name":"Boat Harbour",
    "state_name":"New South Wales"
  },
  {
    "postcode":2316,
    "place_name":"Anna Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2316,
    "place_name":"Bobs Farm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2316,
    "place_name":"One Mile",
    "state_name":"New South Wales"
  },
  {
    "postcode":2317,
    "place_name":"Soldiers Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2317,
    "place_name":"Salamander Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2318,
    "place_name":"Medowie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2318,
    "place_name":"Salt Ash",
    "state_name":"New South Wales"
  },
  {
    "postcode":2318,
    "place_name":"Ferodale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2318,
    "place_name":"Campvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2318,
    "place_name":"Williamtown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2318,
    "place_name":"Oyster Cove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2318,
    "place_name":"Fullerton Cove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2319,
    "place_name":"Tilligerry Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2319,
    "place_name":"Tanilba Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2319,
    "place_name":"Mallabula",
    "state_name":"New South Wales"
  },
  {
    "postcode":2319,
    "place_name":"Lemon Tree Passage",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Mindaribba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Bolwarra Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Keinbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Allandale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Mount Dee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"South Maitland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Anambah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Louth Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Farley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Lorn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Rutherford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Largs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Wallalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Horseshoe Bend",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Maitland Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Windella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Maitland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Oakhampton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Gosforth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Telarah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Maitland North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Bolwarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Pokolbin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Rosebrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Rothbury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Aberglasslyn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Oakhampton Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Hillsborough",
    "state_name":"New South Wales"
  },
  {
    "postcode":2320,
    "place_name":"Glen Oak",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2320,
    "place_name":"Melville",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Butterwick",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Duns Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Morpeth",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Woodville",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Lochinvar",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Duckenfield",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Luskintyre",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Raworth",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Cliftleigh",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Berry Park",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Clarence Town",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Glen William",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Oswald",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Heddon Greta",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Glen Martin",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Gillieston Heights",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Harpers Hill",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Windermere",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Phoenix Park",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2321,
    "place_name":"Hinton",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2322,
    "place_name":"Hexham",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2322,
    "place_name":"Stockrington",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2322,
    "place_name":"Chisholm",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2322,
    "place_name":"Lenaghan",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2322,
    "place_name":"Black Hill",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2322,
    "place_name":"Woodberry",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2322,
    "place_name":"Tarro",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2322,
    "place_name":"Beresfield",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2322,
    "place_name":"Thornton",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2322,
    "place_name":"Tomago",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"East Maitland",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Mulbring",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Metford",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Ashtonfield",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Four Mile Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Buttai",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Brunkerville",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Green Hills",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Metford Dc",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Pitnacree",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Freemans Waterhole",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Buchanan",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Mount Vincent",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Tenambit",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2323,
    "place_name":"Richmond Vale",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Limeburners Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Twelve Mile Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"East Seaham",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Millers Forest",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Seaham",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Tea Gardens",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Eagleton",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Cells River",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Tahlee",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Osterley",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Brandy Hill",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Hawks Nest",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"North Arm Cove",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Raymond Terrace East",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Pindimar",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Carrington",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Heatherbrae",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Bundabah",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Nelsons Plains",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Swan Bay",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Balickera",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Raymond Terrace",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2324,
    "place_name":"Karuah",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Paxton",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Quorrobolong",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Wollombi",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Cessnock West",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Kearsley",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Cessnock",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Kitchener",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Ellalong",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Bellbird",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Mount View",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Elrington",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Pelton",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Nulkaba",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Lovedale",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Laguna",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Abernethy",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Millfield",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Greta Main",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Sweetmans Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Olney",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Paynes Crossing",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Cedar Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Congewai",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Moruben",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Corrabare",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Aberdare",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2325,
    "place_name":"Bellbird Heights",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2326,
    "place_name":"Neath",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2326,
    "place_name":"Abermain",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2326,
    "place_name":"Bishops Bridge",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2326,
    "place_name":"Weston",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2326,
    "place_name":"Loxford",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2326,
    "place_name":"Sawyers Gully",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2327,
    "place_name":"Stanford Merthyr",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2327,
    "place_name":"Pelaw Main",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2327,
    "place_name":"Kurri Kurri",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2328,
    "place_name":"Denman",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2328,
    "place_name":"Widden",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2328,
    "place_name":"Kerrabee",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2328,
    "place_name":"Martindale",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2328,
    "place_name":"Bureen",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2328,
    "place_name":"Hollydeen",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2328,
    "place_name":"Giants Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2328,
    "place_name":"Yarrawa",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2328,
    "place_name":"Dalswinton",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2328,
    "place_name":"Mangoola",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2329,
    "place_name":"Cassilis",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2329,
    "place_name":"Borambil",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2329,
    "place_name":"Uarbry",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2329,
    "place_name":"Merriwa",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Ravensworth",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Gowrie",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Glenridding",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Howick",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Warkworth",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Glendon Brook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Scotts Flat",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Hunterview",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Putty",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Dunolly",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Gouldsville",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Milbrodale",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Long Point",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Goorangoola",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Mitchells Flat",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Redbournberry",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Whittingham",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Big Ridge",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Doyles Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Mirannie",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Glendon",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Hebden",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Wollemi",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Darlington",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Sedgefield",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Mount Thorley",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Bowmans Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Mount Olive",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Maison Dieu",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Appletree Flat",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Camberwell",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Bridgman",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Singleton",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Combo",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Middle Falbrook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Westbrook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Mount Royal",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Obanvale",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Reedy Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Jerrys Plains",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Big Yengo",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Lemington",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Fern Gully",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Garland Valley",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Fordwich",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Rixs Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Hambledon Hill",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Howes Valley",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"St Clair",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Dyrring",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Clydesdale",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Wattle Ponds",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Dural",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Roughit",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Falbrook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Wylies Flat",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Bulga",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Mcdougalls Hill",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Broke",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Greenlands",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Glennies Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Singleton Heights",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2330,
    "place_name":"Carrowbrook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2331,
    "place_name":"Singleton Milpo",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2331,
    "place_name":"Singleton Military Area",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Baerami Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Mccullys Gap",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Liddell",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Edderton",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Sandy Hollow",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Castle Rock",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Muscle Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Gungal",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Kayuga",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Bengalla",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Baerami",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Manobalai",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Muswellbrook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2333,
    "place_name":"Wybong",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2334,
    "place_name":"Greta",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2335,
    "place_name":"Leconfield",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2335,
    "place_name":"Elderslie",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2335,
    "place_name":"Stanhope",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2335,
    "place_name":"North Rothbury",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2335,
    "place_name":"Lower Belford",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2335,
    "place_name":"East Branxton",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2335,
    "place_name":"Dalwood",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2335,
    "place_name":"Lambs Valley",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2335,
    "place_name":"Belford",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2335,
    "place_name":"Branxton",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2336,
    "place_name":"Upper Rouchel",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2336,
    "place_name":"Rouchel",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2336,
    "place_name":"Dartbrook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2336,
    "place_name":"Upper Dartbrook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2336,
    "place_name":"Aberdeen",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2336,
    "place_name":"Rouchel Brook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2336,
    "place_name":"Davis Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2336,
    "place_name":"Rossgole",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Stewarts Brook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Owens Gap",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Moonan Flat",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Ellerston",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Satur",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Wingen",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Moonan Brook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Moobi",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Glenrock",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Segenhoe",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Scone",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Glenbawn",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Tomalla",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Gundy",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Belltrees",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Murulla",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Bunnan",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Kars Springs",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Parkville",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Middle Brook",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Pages Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Woolooma",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Omadale",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Waverly",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Brawboy",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2337,
    "place_name":"Dry Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2338,
    "place_name":"Timor",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2338,
    "place_name":"Ardglen",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2338,
    "place_name":"Pages River",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2338,
    "place_name":"Murrurundi",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2338,
    "place_name":"Green Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2338,
    "place_name":"Blandford",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2338,
    "place_name":"Crawney",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2338,
    "place_name":"Sandy Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2338,
    "place_name":"Scotts Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2339,
    "place_name":"Warrah Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2339,
    "place_name":"Cattle Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2339,
    "place_name":"Braefield",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2339,
    "place_name":"Little Jacks Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2339,
    "place_name":"Willow Tree",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2339,
    "place_name":"Macdonalds Creek",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2339,
    "place_name":"Warrah",
    "state_name":"New South Wales",
  
  },
  {
    "postcode":2339,
    "place_name":"Parraweena",
    "state_name":"New South Wales"
  },
  {
    "postcode":2339,
    "place_name":"Big Jacks Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2339,
    "place_name":"Chilcotts Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Loomberah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Daruka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Somerton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Hillvue",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Moore Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Garoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Hanging Rock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Appleby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Westdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Gowrie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Goonoo Goonoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"South Tamworth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Nundle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Calala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Carroll",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Bithramere",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Woolomin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Tamworth South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Gidley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Keepit",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Barry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Oxley Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Duncans Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Weabonga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Warral",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Ogunbil",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"North Tamworth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Kingswood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Dungowan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Wallamore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Bective",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Hallsville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Piallamore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Taminda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"West Tamworth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Nemingha",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Timbumburi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Bowling Alley Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"East Tamworth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2340,
    "place_name":"Tamworth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2341,
    "place_name":"Werris Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2342,
    "place_name":"Piallaway",
    "state_name":"New South Wales"
  },
  {
    "postcode":2342,
    "place_name":"Currabubula",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Coomoo Coomoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Warrah Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Spring Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Quirindi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Pine Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Blackville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Colly Blue",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Yarraman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Wallabadah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Caroona",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Borambil",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Bundella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Windy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Yannergee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2343,
    "place_name":"Quipolly",
    "state_name":"New South Wales"
  },
  {
    "postcode":2344,
    "place_name":"Duri",
    "state_name":"New South Wales"
  },
  {
    "postcode":2344,
    "place_name":"Winton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2345,
    "place_name":"Garthowen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2345,
    "place_name":"Attunga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2346,
    "place_name":"Wongo Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2346,
    "place_name":"Borah Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2346,
    "place_name":"Manilla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2346,
    "place_name":"Halls Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2346,
    "place_name":"Klori",
    "state_name":"New South Wales"
  },
  {
    "postcode":2346,
    "place_name":"Namoi River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2346,
    "place_name":"Upper Manilla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2346,
    "place_name":"Wimborne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2346,
    "place_name":"New Mexico",
    "state_name":"New South Wales"
  },
  {
    "postcode":2346,
    "place_name":"Rushes Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2346,
    "place_name":"Warrabah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Thirldene",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Woodsreef",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Cobbadah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Banoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Red Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Barraba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Gundamulda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Gulf Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Mayvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Upper Horton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Ironbark",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Lindesay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2347,
    "place_name":"Longarm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2348,
    "place_name":"New England Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Hillgrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Tilbuster",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Dangarsleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Lyndhurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Castle Doyle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Duval",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Wongwibinda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Abington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Dumaresq",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Aberfoyle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Saumarez",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"East Armidale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Boorolong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Wollomombi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Kellys Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Jeogla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Enmore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Wards Mistake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Armidale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Saumarez Ponds",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Invergowrie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Thalgarrah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"West Armidale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Puddledock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Donald Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Argyle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2350,
    "place_name":"Metz",
    "state_name":"New South Wales"
  },
  {
    "postcode":2351,
    "place_name":"University Of New England",
    "state_name":"New South Wales"
  },
  {
    "postcode":2352,
    "place_name":"Limbri",
    "state_name":"New South Wales"
  },
  {
    "postcode":2352,
    "place_name":"Mulla Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2352,
    "place_name":"Kootingal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2352,
    "place_name":"Tintinhull",
    "state_name":"New South Wales"
  },
  {
    "postcode":2353,
    "place_name":"Moonbi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2354,
    "place_name":"Woolbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2354,
    "place_name":"Niangala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2354,
    "place_name":"Kentucky",
    "state_name":"New South Wales"
  },
  {
    "postcode":2354,
    "place_name":"Walcha",
    "state_name":"New South Wales"
  },
  {
    "postcode":2354,
    "place_name":"Nowendoc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2354,
    "place_name":"Wollun",
    "state_name":"New South Wales"
  },
  {
    "postcode":2354,
    "place_name":"Yarrowitch",
    "state_name":"New South Wales"
  },
  {
    "postcode":2354,
    "place_name":"Walcha Road",
    "state_name":"New South Wales"
  },
  {
    "postcode":2354,
    "place_name":"Kentucky South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2355,
    "place_name":"Watsons Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2355,
    "place_name":"Retreat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2355,
    "place_name":"Bendemeer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2356,
    "place_name":"Gwabegar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2357,
    "place_name":"Coonabarabran",
    "state_name":"New South Wales"
  },
  {
    "postcode":2357,
    "place_name":"Ulamambri",
    "state_name":"New South Wales"
  },
  {
    "postcode":2357,
    "place_name":"Gowang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2357,
    "place_name":"Wattle Springs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2357,
    "place_name":"Purlewaugh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2357,
    "place_name":"Box Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2357,
    "place_name":"Dandry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2357,
    "place_name":"Rocky Glen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2357,
    "place_name":"Tannabar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2357,
    "place_name":"Bugaldie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2357,
    "place_name":"Bomera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2358,
    "place_name":"Gostwyck",
    "state_name":"New South Wales"
  },
  {
    "postcode":2358,
    "place_name":"Arding",
    "state_name":"New South Wales"
  },
  {
    "postcode":2358,
    "place_name":"Yarrowyck",
    "state_name":"New South Wales"
  },
  {
    "postcode":2358,
    "place_name":"Enmore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2358,
    "place_name":"Rocky River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2358,
    "place_name":"Torryburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2358,
    "place_name":"Balala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2358,
    "place_name":"Salisbury Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2358,
    "place_name":"Mihi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2358,
    "place_name":"Kingstown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2358,
    "place_name":"Uralla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2359,
    "place_name":"Bakers Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2359,
    "place_name":"Bundarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2359,
    "place_name":"Aberdeen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2359,
    "place_name":"Camerons Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Wandera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Copeton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Mount Russell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Little Plain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Auburn Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Rob Roy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Cherry Tree Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Stanborough",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Sapphire",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Swanbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Inverell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Bukkulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Howell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Spring Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Gilgai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Nullamanna",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Brodies Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Long Plain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Woodstock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Wallangra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Oakwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Kings Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Newstead",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Paradise",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Elsmore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Gum Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2360,
    "place_name":"Graman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2361,
    "place_name":"Ashford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2361,
    "place_name":"Atholwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2361,
    "place_name":"Limestone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2361,
    "place_name":"Bonshaw",
    "state_name":"New South Wales"
  },
  {
    "postcode":2361,
    "place_name":"Pindaroi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Oban",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Brushy Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Tubbamurra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Glencoe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Brockley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Ben Lomond",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Georges Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Guyra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"The Gulf",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Falconer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Llangothlin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Black Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Baldersleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Bald Blair",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Mount Mitchell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Wandsworth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Maybole",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"South Guyra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Backwater",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Tenterden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Green Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Briarbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Bassendean",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"Glen Nevis",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"The Basin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2365,
    "place_name":"New Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2369,
    "place_name":"Tingha",
    "state_name":"New South Wales"
  },
  {
    "postcode":2369,
    "place_name":"Old Mill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2369,
    "place_name":"Stannifer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Dundee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Moggs Swamp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Shannon Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Glen Innes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Wellingrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Morven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Glen Elgin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Kingsland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Stonehenge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Diehard",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Reddestone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Pinkett",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Matheson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Bald Nob",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Swan Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Gibraltar Range",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Newton Boyd",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Lambs Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Kookabookra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Yarrowford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Moogem",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Furracabad",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Kingsgate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Red Range",
    "state_name":"New South Wales"
  },
  {
    "postcode":2370,
    "place_name":"Rangers Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2371,
    "place_name":"Rocky Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2371,
    "place_name":"Yellow Dam",
    "state_name":"New South Wales"
  },
  {
    "postcode":2371,
    "place_name":"Capoompeta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2371,
    "place_name":"Emmaville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2371,
    "place_name":"Stannum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2371,
    "place_name":"Deepwater",
    "state_name":"New South Wales"
  },
  {
    "postcode":2371,
    "place_name":"Wellington Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2371,
    "place_name":"Torrington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Silent Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Woodside",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Liston",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Bolivia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Sandy Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Back Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Rocky River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Tarban",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Black Swamp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Boorook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Sandy Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Rivertree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Boonoo Boonoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Dumaresq Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Mole River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Wylie Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Forest Land",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Timbarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Bookookoorara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Tenterfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Bungulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Carrolls Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Willsons Downfall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2372,
    "place_name":"Cullendore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2379,
    "place_name":"Goolhi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2379,
    "place_name":"Mullaley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2379,
    "place_name":"Napier Lane",
    "state_name":"New South Wales"
  },
  {
    "postcode":2379,
    "place_name":"Nombi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2380,
    "place_name":"Coocooboonah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2380,
    "place_name":"Ghoolendaadi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2380,
    "place_name":"Kelvin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2380,
    "place_name":"Rangari",
    "state_name":"New South Wales"
  },
  {
    "postcode":2380,
    "place_name":"Orange Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2380,
    "place_name":"Milroy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2380,
    "place_name":"Emerald Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2380,
    "place_name":"Marys Mount",
    "state_name":"New South Wales"
  },
  {
    "postcode":2380,
    "place_name":"Gunnedah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2380,
    "place_name":"Burburgate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2380,
    "place_name":"Blue Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2381,
    "place_name":"Curlewis",
    "state_name":"New South Wales"
  },
  {
    "postcode":2381,
    "place_name":"Pullaming",
    "state_name":"New South Wales"
  },
  {
    "postcode":2381,
    "place_name":"Breeza",
    "state_name":"New South Wales"
  },
  {
    "postcode":2381,
    "place_name":"Tambar Springs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2381,
    "place_name":"Premer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2382,
    "place_name":"Maules Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2382,
    "place_name":"Willala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2382,
    "place_name":"Wean",
    "state_name":"New South Wales"
  },
  {
    "postcode":2382,
    "place_name":"Boggabri",
    "state_name":"New South Wales"
  },
  {
    "postcode":2386,
    "place_name":"Drildool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2386,
    "place_name":"Burren Junction",
    "state_name":"New South Wales"
  },
  {
    "postcode":2386,
    "place_name":"Nowley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2387,
    "place_name":"Rowena",
    "state_name":"New South Wales"
  },
  {
    "postcode":2387,
    "place_name":"Bulyeroi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2388,
    "place_name":"Merah North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2388,
    "place_name":"Cuttabri",
    "state_name":"New South Wales"
  },
  {
    "postcode":2388,
    "place_name":"Yarrie Lake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2388,
    "place_name":"Spring Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2388,
    "place_name":"Boolcarroll",
    "state_name":"New South Wales"
  },
  {
    "postcode":2388,
    "place_name":"Pilliga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2388,
    "place_name":"The Pilliga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2388,
    "place_name":"Wee Waa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Jacks Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Kaputar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Turrawan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Eulah Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Edgeroi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Harparary",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Narrabri West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Berrigal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Rocky Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Baan Baa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Bullawa Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Couradda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Back Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Narrabri",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Tarriaro",
    "state_name":"New South Wales"
  },
  {
    "postcode":2390,
    "place_name":"Bohena Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2395,
    "place_name":"Ropers Road",
    "state_name":"New South Wales"
  },
  {
    "postcode":2395,
    "place_name":"Binnaway",
    "state_name":"New South Wales"
  },
  {
    "postcode":2395,
    "place_name":"Weetaliba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2396,
    "place_name":"Barwon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2396,
    "place_name":"Goorianawa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2396,
    "place_name":"Kenebri",
    "state_name":"New South Wales"
  },
  {
    "postcode":2396,
    "place_name":"Baradine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2397,
    "place_name":"Millie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2397,
    "place_name":"Bellata",
    "state_name":"New South Wales"
  },
  {
    "postcode":2397,
    "place_name":"Jews Lagoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2398,
    "place_name":"Gurley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2399,
    "place_name":"Biniguy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2399,
    "place_name":"Pallamallawa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2400,
    "place_name":"Bullarah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2400,
    "place_name":"Terry Hie Hie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2400,
    "place_name":"Moree East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2400,
    "place_name":"Moree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2400,
    "place_name":"Crooble",
    "state_name":"New South Wales"
  },
  {
    "postcode":2400,
    "place_name":"Tulloona",
    "state_name":"New South Wales"
  },
  {
    "postcode":2400,
    "place_name":"Mallowa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2400,
    "place_name":"Ashley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2401,
    "place_name":"Gravesend",
    "state_name":"New South Wales"
  },
  {
    "postcode":2402,
    "place_name":"Coolatai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2402,
    "place_name":"Warialda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2402,
    "place_name":"Warialda Rail",
    "state_name":"New South Wales"
  },
  {
    "postcode":2403,
    "place_name":"Delungra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2403,
    "place_name":"Myall Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2403,
    "place_name":"Koloona",
    "state_name":"New South Wales"
  },
  {
    "postcode":2403,
    "place_name":"Gragin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2403,
    "place_name":"Balfours Peak",
    "state_name":"New South Wales"
  },
  {
    "postcode":2404,
    "place_name":"Bingara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2404,
    "place_name":"Elcombe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2404,
    "place_name":"Keera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2404,
    "place_name":"Gineroi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2404,
    "place_name":"Bangheet",
    "state_name":"New South Wales"
  },
  {
    "postcode":2404,
    "place_name":"Pallal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2404,
    "place_name":"Riverview",
    "state_name":"New South Wales"
  },
  {
    "postcode":2404,
    "place_name":"Dinoga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2404,
    "place_name":"Upper Bingara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2405,
    "place_name":"Boomi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2405,
    "place_name":"Garah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2406,
    "place_name":"Weemelah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2406,
    "place_name":"Mungindi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2408,
    "place_name":"North Star",
    "state_name":"New South Wales"
  },
  {
    "postcode":2408,
    "place_name":"Blue Nobby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2408,
    "place_name":"Yallaroi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2409,
    "place_name":"Boggabilla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2409,
    "place_name":"Boonal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2410,
    "place_name":"Yetman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2410,
    "place_name":"Twin Rivers",
    "state_name":"New South Wales"
  },
  {
    "postcode":2411,
    "place_name":"Croppa Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2415,
    "place_name":"Monkerai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2415,
    "place_name":"Nooroo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2415,
    "place_name":"Stroud Road",
    "state_name":"New South Wales"
  },
  {
    "postcode":2415,
    "place_name":"Upper Karuah River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2415,
    "place_name":"Weismantels",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Fosterton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Wallarobba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Underbank",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Dungog",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Stroud Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Bendolba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Main Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Wirragulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Sugarloaf",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Brookfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Bandon Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Salisbury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Hanleys Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Marshdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Munni",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Flat Tops",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Wallaringa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Cambra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Tabbil Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Hilldale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Alison",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Chichester",
    "state_name":"New South Wales"
  },
  {
    "postcode":2420,
    "place_name":"Martins Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2421,
    "place_name":"Webbers Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2421,
    "place_name":"Tocal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2421,
    "place_name":"Fishers Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2421,
    "place_name":"Trevallyn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2421,
    "place_name":"Vacy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2421,
    "place_name":"Paterson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2421,
    "place_name":"Torryburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2421,
    "place_name":"Summer Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Gloucester Tops",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Belbora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Barrington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Bulliac",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Stratford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Cobark",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Rawdon Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Gangat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Gloucester",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Craven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Copeland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Giro",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Bundook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Wards River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Forbesdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Rookhurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Dewitt",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Curricabark",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Callaghans Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Bowman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Faulkland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Mograni",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Bindera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Upper Bowman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Titaatee Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Baxters Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Barrington Tops",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Coneac",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Terreel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Bretti",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Craven Plateau",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Tugrabakh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Invergordon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Glen Ward",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Bowman Farm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Kia Ora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Back Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Waukivory",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Tibbuc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Woko",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Berrico",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Mernot",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Wallanbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Moppy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Mares Run",
    "state_name":"New South Wales"
  },
  {
    "postcode":2422,
    "place_name":"Bakers Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Upper Myall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Bungwahl",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Crawford River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Violet Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Wang Wauk",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Mayers Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Wootton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Boolambayte",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Topi Topi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Bulahdelah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Markwell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Mungo Brush",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Warranulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Myall Lake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Nerong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Bombah Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Coolongolook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Yagon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Willina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2423,
    "place_name":"Seal Rocks",
    "state_name":"New South Wales"
  },
  {
    "postcode":2424,
    "place_name":"Knorrit Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2424,
    "place_name":"Mount George",
    "state_name":"New South Wales"
  },
  {
    "postcode":2424,
    "place_name":"Cells River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2424,
    "place_name":"Cundle Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2424,
    "place_name":"Caffreys Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2424,
    "place_name":"Number One",
    "state_name":"New South Wales"
  },
  {
    "postcode":2424,
    "place_name":"Tiri",
    "state_name":"New South Wales"
  },
  {
    "postcode":2424,
    "place_name":"Cooplacurripa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2424,
    "place_name":"Knorrit Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2425,
    "place_name":"Allworth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2425,
    "place_name":"Washpool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2425,
    "place_name":"Stroud",
    "state_name":"New South Wales"
  },
  {
    "postcode":2425,
    "place_name":"The Branch",
    "state_name":"New South Wales"
  },
  {
    "postcode":2425,
    "place_name":"Girvan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2425,
    "place_name":"Booral",
    "state_name":"New South Wales"
  },
  {
    "postcode":2426,
    "place_name":"Moto",
    "state_name":"New South Wales"
  },
  {
    "postcode":2426,
    "place_name":"Coopernook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2426,
    "place_name":"Langley Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2427,
    "place_name":"Harrington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2427,
    "place_name":"Crowdy Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Whoota",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Coomba Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Coomba Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Elizabeth Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Blueys Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Smiths Lake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Booti Booti",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Tiona",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Forster",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Shallow Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Green Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Forster Shopping Village",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Tuncurry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Wallingat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Charlotte Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Tarbuck Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Darawank",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Sandbar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Pacific Palms",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Wallis Lake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2428,
    "place_name":"Boomerang Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Bobin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Kimbriki",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Cedar Party",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Bucca Wauka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Burrell Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Krambach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Dyers Crossing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Yarratt Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Killawarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Killabakh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Wingham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Innes View",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Comboyne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Kundibakh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Elands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Bulga Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Wherrol Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Khatambuhl",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Marlee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Dollys Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Mooral Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Strathcedar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Bunyah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"The Bight",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Warriwillah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Tipperary",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Caparra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Boorganna",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Firefly",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Kippaxs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Dingo Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2429,
    "place_name":"Karaak Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Purfleet",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Cundletown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Bohnock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Rainbow Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Taree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Brimbin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Cabbage Tree Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Kundle Kundle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Glenthorne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Black Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Oxley Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Dumaresq Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Chatham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Ghinni Ghinni",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Old Bar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Lansdowne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Mitchells Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Hallidays Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Possum Brush",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Lansdowne Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Koorainghat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Diamond Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Kolodong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Tallwoods Village",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Failford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Bootawa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Upper Lansdowne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Hillville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Red Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Kiwarrak",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Croki",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Tinonee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Jones Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Wallabi Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Saltwater",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Manning Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Pampoolah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Mondrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Taree South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2430,
    "place_name":"Melinga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2431,
    "place_name":"South West Rocks",
    "state_name":"New South Wales"
  },
  {
    "postcode":2431,
    "place_name":"Arakoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2431,
    "place_name":"Jerseyville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2439,
    "place_name":"Kerewong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2439,
    "place_name":"Lorne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2439,
    "place_name":"Black Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2439,
    "place_name":"Rossglen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2439,
    "place_name":"Batar Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2439,
    "place_name":"Upsalls Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2439,
    "place_name":"Kew",
    "state_name":"New South Wales"
  },
  {
    "postcode":2439,
    "place_name":"Logans Crossing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2439,
    "place_name":"Kendall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2439,
    "place_name":"Swans Crossing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"West Kempsey",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Yarravel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Dondingalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"East Kempsey",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Lower Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Old Station",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Frederickton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Temagog",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Comara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Rainbow Reach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Kinchela",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Yessabah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"South Kempsey",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Wittitrin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Skillion Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Toorooka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Sherwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Hampden Hall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Willi Willi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Bellimbopinni",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Willawarrin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Belmore River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Kempsey",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Greenhill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Aldavilla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Carrai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Hickeys Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Gladstone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Millbank",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Pola Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Austral Eden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Hat Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Euroka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Deep Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Clybucca",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Seven Oaks",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Mooneba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Turners Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Crescent Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Moparrabah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Smithtown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Collombatti",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Burnt Bridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Summer Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Bellbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Mungay Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Corangula",
    "state_name":"New South Wales"
  },
  {
    "postcode":2440,
    "place_name":"Verges Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Eungai Rail",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Yarrahapinni",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Kundabung",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Bril Bril",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Upper Rollands Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Cooperabung",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Eungai Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Stuarts Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Tamban",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Crossmaglen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Telegraph Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Fishermans Reach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Allgomera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Grassy Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Ballengarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Gum Scrub",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Barraganyatti",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Marlo Merrican",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Kippara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Bonville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Rollands Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2441,
    "place_name":"Hacks Ferry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2442,
    "place_name":"Mid North Coast Msc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2442,
    "place_name":"Mid North Coast Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Diamond Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Laurieton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Coralville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Waitui",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Bobs Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"North Haven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Deauville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Middle Brother",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Stewarts River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Dunbogan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Lakewood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"North Brother",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Camden Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Moorland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Hannam Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Crowdy Bay National Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"West Haven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Herons Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2443,
    "place_name":"Johns River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"Riverside",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"Limeburners Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"Blackmans Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"Fernbank Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"Port Macquarie Bc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"North Shore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"The Hatch",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"Flynns Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"Port Macquarie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"Thrumster",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"Settlement City",
    "state_name":"New South Wales"
  },
  {
    "postcode":2444,
    "place_name":"Lighthouse Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2445,
    "place_name":"Bonny Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2445,
    "place_name":"Lake Cathie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2445,
    "place_name":"Grants Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2445,
    "place_name":"Jolly Nose",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Wauchope",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Hartys Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Banda Banda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Yippin Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Redbank",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Long Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Pembrooke",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Bago",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Ellenborough",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Birdwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Bellangry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Lower Pappinbarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Forbes River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Hollisdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Sancrox",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Toms Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Rawdon Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"King Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Brombin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Rosewood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Beechwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Pappinbarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Yarras",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Cairncross",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Byabarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Huntingdon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Mount Seaview",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Kindee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Mortons Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Doyles River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Gearys Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Upper Pappinbarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Werrikimbe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Frazers Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Bagnoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Debenham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Lake Innes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Kings Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Crosslands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Hyndmans Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2446,
    "place_name":"Pipeclay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Gumma",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Taylors Arm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Wirrimbi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Congarinni",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Scotts Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Newee Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Warrell Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Upper Taylors Arm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Thumb Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Talarm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Macksville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Congarinni North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Burrapine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Donnellyville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Yarranbella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Bakers Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Way Way",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"Utungun",
    "state_name":"New South Wales"
  },
  {
    "postcode":2447,
    "place_name":"North Macksville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2448,
    "place_name":"Hyland Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2448,
    "place_name":"Valla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2448,
    "place_name":"Valla Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2448,
    "place_name":"Nambucca Heads",
    "state_name":"New South Wales"
  },
  {
    "postcode":2449,
    "place_name":"South Arm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2449,
    "place_name":"Missabotti",
    "state_name":"New South Wales"
  },
  {
    "postcode":2449,
    "place_name":"Bowraville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2449,
    "place_name":"Buckra Bendinni",
    "state_name":"New South Wales"
  },
  {
    "postcode":2449,
    "place_name":"Killiekrankie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2449,
    "place_name":"Tewinga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2449,
    "place_name":"Girralong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2449,
    "place_name":"Argents Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2449,
    "place_name":"Kennaicle Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Upper Orara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Coffs Harbour",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Coffs Harbour Plaza",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Moonee Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Nana Glen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Bonville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Sapphire Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Brooklana",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Ulong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Korora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Lower Bucca",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Glenreagh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Coffs Harbour Jetty",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Sherwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Lowanna",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"North Boambee Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Bucca",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Coramba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Boambee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2450,
    "place_name":"Karangi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2452,
    "place_name":"Sawtell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2452,
    "place_name":"Boambee East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2452,
    "place_name":"Toormina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Never Never",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Deer Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Billys Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"North Dorrigo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Ebor",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Marengo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Dundurrabin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Clouds Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Tallowwood Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Cascade",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Bielsdown Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Tyringham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Bostobrick",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Megan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Hernani",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Dorrigo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Fernbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Briggsvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Dorrigo Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Wild Cattle Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2453,
    "place_name":"Moonpar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Mylestom",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Fernmount",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Valery",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Raleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Thora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Spicketts Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Brinerville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Kalang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Sunny Corner",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Repton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Brierfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Bundagen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Darkwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Gleniffer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2454,
    "place_name":"Bellingen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2455,
    "place_name":"Urunga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2456,
    "place_name":"Mullaway",
    "state_name":"New South Wales"
  },
  {
    "postcode":2456,
    "place_name":"Emerald Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2456,
    "place_name":"Upper Corindi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2456,
    "place_name":"Corindi Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2456,
    "place_name":"Red Rock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2456,
    "place_name":"Arrawarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2456,
    "place_name":"Arrawarra Headland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2456,
    "place_name":"Safety Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2456,
    "place_name":"Dirty Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2456,
    "place_name":"Woolgoolga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2456,
    "place_name":"Sandy Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Smiths Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Halfway Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Gurranang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Eatonsville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Braunstone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Buccarumbi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Kungala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Clifden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Lanitza",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Whiteman Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Banyabba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Fine Flower",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Carrs Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Coutts Crossing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Tyndale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Baryulgil",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Collum Collum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Bookram",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Waterview",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Eighteen Mile",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Brushgrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Jackadgery",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Mountain View",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Fortis Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Alumy Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Grafton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Lionsville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Lilydale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Dalmorton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Kangaroo Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Lower Southgate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Great Marlow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Seelands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Chambigne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"South Grafton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Grafton West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Junction Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Copmanhurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Dilkoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Levenstrath",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"South Arm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Bom Bom",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Ramornie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Upper Copmanhurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Stockyard Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Coaldale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Cowper",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Heifer Station",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"The Pinnacles",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Cangai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Southgate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Wells Crossing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Elland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Clarenza",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Waterview Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Newbold",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Deep Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Punchbowl",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Koolkhan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Washpool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Carnham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Trenayr",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"The Whiteman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Wombat Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Moleville Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Mylneford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Upper Fine Flower",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Glenugie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Dumbudgery",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Chaelundi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Kyarran",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Pulganbar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Winegrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Towallum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Crowther Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Nymboida",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Southampton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Sandy Crossing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Calamia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Blaxlands Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Barcoongere",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Warragai Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Coombadjha",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Rushforth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Malabugilmah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Barretts Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Lawrence",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Kremnos",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Shannondale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Carrs Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2460,
    "place_name":"Carrs Peninsular",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Wooli",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Lavadia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Ulmarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Swan Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Pillar Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Gilletts Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Minnie Water",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Lake Hiawatha",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Diggers Camp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Calliope",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Tucabia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2462,
    "place_name":"Coldstream",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Maclean",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Palmers Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Townsend",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"The Sandon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Shark Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Palmers Channel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Ashby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Ashby Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Gulmarrad",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Woodford Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Ilarwill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"James Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Tullymorgan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Jacky Bulbin Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Brooms Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Sandon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Taloumbi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Woodford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2463,
    "place_name":"Ashby Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2464,
    "place_name":"Freeburn Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2464,
    "place_name":"Angourie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2464,
    "place_name":"Micalo Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2464,
    "place_name":"Yuraygir",
    "state_name":"New South Wales"
  },
  {
    "postcode":2464,
    "place_name":"Yamba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2464,
    "place_name":"Wooloweyah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2465,
    "place_name":"Harwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2466,
    "place_name":"Woody Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2466,
    "place_name":"Iluka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2466,
    "place_name":"The Freshwater",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Haystack",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Lower Duck Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Paddys Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Bonalbo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Ewingar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Rappville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Theresa Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Gorge Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Goodwood Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Pikapene",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Camira",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Tabulam",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Mallanganee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Chatsworth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Drake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Kippenduff",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Old Bonalbo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Pagans Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Bottle Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Duck Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Mummulgum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Mount Marsh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Alice",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Capeen Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Myrtle Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Drake Village",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Mororo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Lower Bottle Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Whiporie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Deep Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Gibberagee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Jacksons Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Clearfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Joes Box",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Six Mile Swamp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Louisa Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Bean Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Keybarbin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Tunglebung",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Wyan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Peacock Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Woombah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Lower Peacock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Bungawalbin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Hogarth Range",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Busbys Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Warregah Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Mookima Wybra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Bingeebeebra Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Cambridge Plateau",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Coongbar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Yabbra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Culmaran Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Sandilands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Simpkins Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Upper Duck Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2469,
    "place_name":"Bulldog",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Ellangowan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Sextonville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Yorklea",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Irvington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Fairy Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Babyl Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Dobies Bight",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Dyraaba Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Shannon Brook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Stratheden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Dyraaba Central",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Baraimal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Spring Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Leeville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Dyraaba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Coombell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Doubtful Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Naughtons Gap",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Casino",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Backmede",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Tomki",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Woodview",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Upper Mongogarie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Lower Dyraaba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Woolners Arm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"North Casino",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Piora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2470,
    "place_name":"Mongogarie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2471,
    "place_name":"Codrington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2471,
    "place_name":"Bora Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2471,
    "place_name":"Tatham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2471,
    "place_name":"Coraki",
    "state_name":"New South Wales"
  },
  {
    "postcode":2471,
    "place_name":"North Woodburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2471,
    "place_name":"Swan Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2471,
    "place_name":"Greenridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2471,
    "place_name":"East Coraki",
    "state_name":"New South Wales"
  },
  {
    "postcode":2471,
    "place_name":"West Coraki",
    "state_name":"New South Wales"
  },
  {
    "postcode":2471,
    "place_name":"West Bungawalbin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2471,
    "place_name":"Green Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2472,
    "place_name":"Rileys Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2472,
    "place_name":"Broadwater",
    "state_name":"New South Wales"
  },
  {
    "postcode":2472,
    "place_name":"Buckendoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2472,
    "place_name":"Esk",
    "state_name":"New South Wales"
  },
  {
    "postcode":2472,
    "place_name":"Woodburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2472,
    "place_name":"Tabbimoble",
    "state_name":"New South Wales"
  },
  {
    "postcode":2472,
    "place_name":"New Italy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2472,
    "place_name":"Trustums Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2472,
    "place_name":"The Gap",
    "state_name":"New South Wales"
  },
  {
    "postcode":2472,
    "place_name":"Kilgin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2472,
    "place_name":"Moonem",
    "state_name":"New South Wales"
  },
  {
    "postcode":2473,
    "place_name":"Evans Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2473,
    "place_name":"South Evans Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2473,
    "place_name":"Bundjalung",
    "state_name":"New South Wales"
  },
  {
    "postcode":2473,
    "place_name":"Iron Gates",
    "state_name":"New South Wales"
  },
  {
    "postcode":2473,
    "place_name":"Doonbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Cawongla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Findon Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Loadstone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Rukenvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Green Pigeon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Roseberry Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Cedar Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Sawpit Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Horseshoe Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Border Ranges",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Barkers Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Eden Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Roseberry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Upper Eden Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Wadeville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Kilgra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Homeleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Kyogle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"The Risk",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Edenville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Upper Horseshoe Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Wiangaree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Afterlee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Toonumbar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Sherwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Gradys Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Cougal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Wyneden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Geneva",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Ettrick",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Dairy Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"New Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Smiths Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Little Back Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"West Wiangaree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Grevillia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Warrazambil Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Fawcetts Plain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Unumgar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Iron Pot Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Ghinni Ghi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Horse Station Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Terrace Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Lynchs Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Old Grevillia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2474,
    "place_name":"Collins Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2475,
    "place_name":"Upper Tooloom",
    "state_name":"New South Wales"
  },
  {
    "postcode":2475,
    "place_name":"Tooloom",
    "state_name":"New South Wales"
  },
  {
    "postcode":2475,
    "place_name":"Urbenville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"Koreelah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"Old Koreelah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"Legume",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"Muli Muli",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"The Glen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"Lindesay Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"Acacia Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"Acacia Plateau",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"Lower Acacia Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"Brumby Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"Woodenbong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2476,
    "place_name":"Boomi Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Lynwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Wardell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Rous",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Alstonvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Rous Mill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Tuckombil",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Bagotville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Pearces Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Meerschaum Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Cabbage Tree Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"East Wardell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Wollongbar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Goat Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Alstonville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Dalwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2477,
    "place_name":"Uralba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Empire Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"East Ballina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Ballina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"South Ballina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Cumbalum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Patchs Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Lennox Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Pimlico Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Pimlico",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Keith Hall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Skennars Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Tintenbar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Coolgardie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"West Ballina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2478,
    "place_name":"Teven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2479,
    "place_name":"Bangalow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2479,
    "place_name":"Brooklet",
    "state_name":"New South Wales"
  },
  {
    "postcode":2479,
    "place_name":"Binna Burra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2479,
    "place_name":"Knockrow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2479,
    "place_name":"Coopers Shoot",
    "state_name":"New South Wales"
  },
  {
    "postcode":2479,
    "place_name":"Coorabell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2479,
    "place_name":"Newrybar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2479,
    "place_name":"Mcleods Shoot",
    "state_name":"New South Wales"
  },
  {
    "postcode":2479,
    "place_name":"Nashua",
    "state_name":"New South Wales"
  },
  {
    "postcode":2479,
    "place_name":"Possum Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2479,
    "place_name":"Fernleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Tucki Tucki",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Marom Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"East Lismore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Mcleans Ridges",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Lismore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Bentley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"South Gundurimba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Blue Knob",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Blakebrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Eltham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Rosebank",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Goonellabah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Bexhill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Clovass",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"South Lismore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"The Channon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Tregeagle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Jiggi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Chilcotts Grass",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Nimbin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Modanville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Fernside",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Keerrong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Bungabbee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Wyrallah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Koonorigan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Lismore Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Booyong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Eureka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Lillian Rock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Repentance Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Goolmangar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Tuncester",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Whian Whian",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Dorroughby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Rock Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Corndale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Tullera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Clunes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"North Lismore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Caniaba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Numulgi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Richmond Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Larnook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Coffee Camp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Leycester",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Stony Chute",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Monaltrie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Nightcap",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Girards Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Mountain Top",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Federal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Tuntable Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Georgica",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Booerie Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Dungarubba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Boorabee Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Mckees Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Terania Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Ruthven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Lindendale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Dunoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Loftville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Tuckurimba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Howards Grass",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Boat Harbour",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Lagoon Grass",
    "state_name":"New South Wales"
  },
  {
    "postcode":2480,
    "place_name":"Woodlawn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2481,
    "place_name":"Hayters Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2481,
    "place_name":"Broken Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2481,
    "place_name":"Suffolk Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2481,
    "place_name":"Talofa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2481,
    "place_name":"Ewingsdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2481,
    "place_name":"Tyagarah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2481,
    "place_name":"Byron Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2481,
    "place_name":"Skinners Shoot",
    "state_name":"New South Wales"
  },
  {
    "postcode":2481,
    "place_name":"Myocum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Upper Wilsons Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Main Arm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Upper Coopers Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Goonengerry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Montecollum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Huonbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Mullumbimby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Mullumbimby Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Upper Main Arm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Koonyum Range",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Wanganui",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Palmwoods",
    "state_name":"New South Wales"
  },
  {
    "postcode":2482,
    "place_name":"Wilsons Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"Sleepy Hollow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"Middle Pocket",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"Crabbes Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"Burringbar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"Upper Burringbar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"Wooyung",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"Ocean Shores",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"Mooball",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"Yelgun",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"The Pocket",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"Brunswick Heads",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"New Brighton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"Billinudgel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2483,
    "place_name":"South Golden Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Dum Dum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Condong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Pumpenbil",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Kielvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Chillingham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Crystal Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Reserve Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Murwillumbah South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Murwillumbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Kunghur",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Terragon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Mebbin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Round Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Fernvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Dunbible",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Uki",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Dungay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Mount Burrell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Clothiers Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Rowlands Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Zara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Dulguigan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Cudgera Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Tyalgum Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Limpinwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Doon Doon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Stokers Siding",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Farrants Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Eungella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Urliup",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Tomewin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Chowan Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Nobbys Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Smiths Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Commissioners Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Hopkins Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Byangum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"North Arm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"South Murwillumbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Back Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Palmvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Kunghur Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Numinbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Cedar Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Eviron",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Byrrill Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Upper Crystal Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Mount Warning",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Bray Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Kynnumboon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Nunderi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Tygalgah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Brays Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Wardrop Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Midginbil",
    "state_name":"New South Wales"
  },
  {
    "postcode":2484,
    "place_name":"Tyalgum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2485,
    "place_name":"Tweed Heads West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2485,
    "place_name":"Tweed Heads",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Piggabeen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Carool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Bilambil Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Tweed Heads South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Cobaki",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Banora Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Upper Duroby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Glengarrie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Duroby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Terranora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Bilambil",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Cobaki Lakes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2486,
    "place_name":"Bungalora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2487,
    "place_name":"Duranbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2487,
    "place_name":"Cudgen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2487,
    "place_name":"Kingscliff",
    "state_name":"New South Wales"
  },
  {
    "postcode":2487,
    "place_name":"Kings Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2487,
    "place_name":"Fingal Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2487,
    "place_name":"Casuarina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2487,
    "place_name":"Stotts Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2487,
    "place_name":"Chinderah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2488,
    "place_name":"Bogangar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2488,
    "place_name":"Tanglewood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2488,
    "place_name":"Cabarita Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2489,
    "place_name":"Pottsville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2489,
    "place_name":"Pottsville Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2489,
    "place_name":"Hastings Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2490,
    "place_name":"North Tumbulgum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2490,
    "place_name":"Tumbulgum",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"Wollongong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"Wollongong DC",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"Keiraville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"Mount Keira",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"Gwynneville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"Wollongong West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"Mangerton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"Spring Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"North Wollongong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"Coniston",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"Mount Saint Thomas",
    "state_name":"New South Wales"
  },
  {
    "postcode":2500,
    "place_name":"West Wollongong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2502,
    "place_name":"Primbee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2502,
    "place_name":"Cringila",
    "state_name":"New South Wales"
  },
  {
    "postcode":2502,
    "place_name":"Warrawong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2502,
    "place_name":"Lake Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2505,
    "place_name":"Kemblawarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2505,
    "place_name":"Port Kembla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2506,
    "place_name":"Berkeley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2508,
    "place_name":"Maddens Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2508,
    "place_name":"Coalcliff",
    "state_name":"New South Wales"
  },
  {
    "postcode":2508,
    "place_name":"Helensburgh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2508,
    "place_name":"Otford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2508,
    "place_name":"Woronora Dam",
    "state_name":"New South Wales"
  },
  {
    "postcode":2508,
    "place_name":"Darkes Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2508,
    "place_name":"Stanwell Tops",
    "state_name":"New South Wales"
  },
  {
    "postcode":2508,
    "place_name":"Stanwell Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2508,
    "place_name":"Lilyvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2515,
    "place_name":"Coledale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2515,
    "place_name":"Thirroul",
    "state_name":"New South Wales"
  },
  {
    "postcode":2515,
    "place_name":"Clifton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2515,
    "place_name":"Wombarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2515,
    "place_name":"Scarborough",
    "state_name":"New South Wales"
  },
  {
    "postcode":2515,
    "place_name":"Austinmer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2516,
    "place_name":"Bulli",
    "state_name":"New South Wales"
  },
  {
    "postcode":2517,
    "place_name":"Woonona",
    "state_name":"New South Wales"
  },
  {
    "postcode":2517,
    "place_name":"Woonona East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2517,
    "place_name":"Russell Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2518,
    "place_name":"Bellambi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2518,
    "place_name":"Corrimal East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2518,
    "place_name":"East Corrimal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2518,
    "place_name":"Tarrawanna",
    "state_name":"New South Wales"
  },
  {
    "postcode":2518,
    "place_name":"Corrimal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2518,
    "place_name":"Towradgi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2519,
    "place_name":"Balgownie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2519,
    "place_name":"Fernhill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2519,
    "place_name":"Mount Ousley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2519,
    "place_name":"Fairy Meadow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2519,
    "place_name":"Mount Pleasant",
    "state_name":"New South Wales"
  },
  {
    "postcode":2520,
    "place_name":"Wollongong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2521,
    "place_name":"South Coast Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2522,
    "place_name":"University Of Wollongong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2525,
    "place_name":"Figtree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2526,
    "place_name":"Cordeaux",
    "state_name":"New South Wales"
  },
  {
    "postcode":2526,
    "place_name":"Cordeaux Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2526,
    "place_name":"Kembla Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2526,
    "place_name":"Kembla Grange",
    "state_name":"New South Wales"
  },
  {
    "postcode":2526,
    "place_name":"Mount Kembla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2526,
    "place_name":"Farmborough Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2526,
    "place_name":"Unanderra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2527,
    "place_name":"Tullimbar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2527,
    "place_name":"Tongarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2527,
    "place_name":"Calderwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2527,
    "place_name":"Yellow Rock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2527,
    "place_name":"Albion Park Rail",
    "state_name":"New South Wales"
  },
  {
    "postcode":2527,
    "place_name":"North Macquarie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2527,
    "place_name":"Albion Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2527,
    "place_name":"Croom",
    "state_name":"New South Wales"
  },
  {
    "postcode":2528,
    "place_name":"Warilla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2528,
    "place_name":"Lake Illawarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2528,
    "place_name":"Windang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2528,
    "place_name":"Barrack Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2528,
    "place_name":"Mount Warrigal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2528,
    "place_name":"Barrack Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2529,
    "place_name":"Shell Cove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2529,
    "place_name":"Shellharbour City Centre",
    "state_name":"New South Wales"
  },
  {
    "postcode":2529,
    "place_name":"Blackbutt",
    "state_name":"New South Wales"
  },
  {
    "postcode":2529,
    "place_name":"Oak Flats",
    "state_name":"New South Wales"
  },
  {
    "postcode":2529,
    "place_name":"Flinders",
    "state_name":"New South Wales"
  },
  {
    "postcode":2529,
    "place_name":"Shellharbour Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":2529,
    "place_name":"Dunmore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2529,
    "place_name":"Shellharbour",
    "state_name":"New South Wales"
  },
  {
    "postcode":2529,
    "place_name":"Oak Flats Dc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Penrose",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Yallah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Koonawarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Dombarton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Huntley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Brownsville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Haywards Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Cleveland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Kanahooka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Dapto",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Marshall Mount",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Wongawilli",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Avondale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2530,
    "place_name":"Horsley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2533,
    "place_name":"Jerrara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2533,
    "place_name":"Kiama",
    "state_name":"New South Wales"
  },
  {
    "postcode":2533,
    "place_name":"Jamberoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2533,
    "place_name":"Curramore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2533,
    "place_name":"Bombo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2533,
    "place_name":"Kiama Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2533,
    "place_name":"Minnamurra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2533,
    "place_name":"Kiama Downs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2533,
    "place_name":"Saddleback Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2534,
    "place_name":"Broughton Village",
    "state_name":"New South Wales"
  },
  {
    "postcode":2534,
    "place_name":"Willow Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2534,
    "place_name":"Werri Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2534,
    "place_name":"Toolijooa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2534,
    "place_name":"Gerringong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2534,
    "place_name":"Rose Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2534,
    "place_name":"Gerroa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2534,
    "place_name":"Foxground",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Coolangatta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Broughton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Jaspers Brush",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Far Meadow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Wattamolla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Bellawongarah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Woodhill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Budderoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Shoalhaven Heads",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Berry Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Broughton Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Brogers Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Berry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Bundewallah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2535,
    "place_name":"Back Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"South Durras",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Guerilla Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Catalina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Denhams Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Maloneys Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"North Batemans Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Jeremadra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Pebbly Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Surfside",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Bimbimbie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Benandarah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Buckenbowra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Long Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Surf Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Mogo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Depot Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Lilli Pilli",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Runnyford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Batemans Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Sunshine Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Malua Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Batehaven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Nelligen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Woodlands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Rosedale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"East Lynne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Currowan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2536,
    "place_name":"Durras North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Congo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Meringo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Mossy Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Moruya Heads",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Bergalia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Deua",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Bingie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Moruya",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Mogendoura",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Wamban",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Broulee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Coila",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Tuross Head",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Deua River Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Tomakin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Kiora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2537,
    "place_name":"Turlinjah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2538,
    "place_name":"Mogood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2538,
    "place_name":"Little Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2538,
    "place_name":"Brooman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2538,
    "place_name":"Woodstock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2538,
    "place_name":"Milton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2538,
    "place_name":"Porters Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2538,
    "place_name":"Morton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2538,
    "place_name":"Woodburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Conjola",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Croobyar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Bawley Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Yatte Yattah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Burrill Lake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Kioloa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Fishermans Paradise",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Berringer Lake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Cunjurong Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Pretty Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Mollymook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Lake Tabourie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Bendalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Cockwhy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Conjola Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Yadboro",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Ulladulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Mollymook Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Termeil",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Pointer Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Manyana",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Narrawallee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Lake Conjola",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Kings Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Dolphin Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2539,
    "place_name":"Mount Kingiman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Culburra Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Tomerong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Sussex Inlet",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Currarong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Worrigee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Cambewarra Village",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Cudmirrah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Terara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Meroo Meadow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Browns Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Illaroo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Old Erowal Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Worrowing Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Twelve Mile Peg",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Hyams Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Brundee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Nowra Naval Po",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Nowra Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Sanctuary Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"St Georges Basin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Pyree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Moollattoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Callala Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Myola",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Orient Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Wrights Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Mundamia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Tullarwalla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Tallowal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Bream Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Callala Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Yalwal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Boolijah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Yerriyong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Berrara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Vincentia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Greenwell Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Mondayong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Kinghorne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Wandandian",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Falls Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Ettrema",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Woollamia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Beecroft Peninsula",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Wollumboola",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Bewong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Erowal Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Burrier",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Comerong Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Swanhaven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Basin View",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Bamarang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Bolong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Numbaa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Hmas Albatross",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Buangla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Barringella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Comberton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Longreach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Cambewarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Jerrawangala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Watersleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Huskisson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Parma",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Tapitallee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2540,
    "place_name":"Mayfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2541,
    "place_name":"Nowra Dc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2541,
    "place_name":"Bomaderry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2541,
    "place_name":"Nowra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2541,
    "place_name":"West Nowra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2541,
    "place_name":"South Nowra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2541,
    "place_name":"Nowra East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2541,
    "place_name":"North Nowra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2541,
    "place_name":"Nowra North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2541,
    "place_name":"Bangalee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2545,
    "place_name":"Belowra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2545,
    "place_name":"Bodalla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2545,
    "place_name":"Eurobodalla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2545,
    "place_name":"Potato Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2545,
    "place_name":"Cadgee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2545,
    "place_name":"Nerrigundah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Wallaga Lake Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Murrah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Narooma",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Tinpot",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Akolele",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Bermagui",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Corunna",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Kianga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Central Tilba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Tilba Tilba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Dalmeny",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Beauty Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Wallaga Lake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Cuttagee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Dignams Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Barragga Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Wadbilliga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"Mystery Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2546,
    "place_name":"North Narooma",
    "state_name":"New South Wales"
  },
  {
    "postcode":2548,
    "place_name":"Bournda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2548,
    "place_name":"Tura Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2548,
    "place_name":"Merimbula",
    "state_name":"New South Wales"
  },
  {
    "postcode":2548,
    "place_name":"Berrambool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2548,
    "place_name":"Mirador",
    "state_name":"New South Wales"
  },
  {
    "postcode":2548,
    "place_name":"Yellow Pinch",
    "state_name":"New South Wales"
  },
  {
    "postcode":2549,
    "place_name":"Nethercote",
    "state_name":"New South Wales"
  },
  {
    "postcode":2549,
    "place_name":"Broadwater",
    "state_name":"New South Wales"
  },
  {
    "postcode":2549,
    "place_name":"Pambula Beach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2549,
    "place_name":"Pambula",
    "state_name":"New South Wales"
  },
  {
    "postcode":2549,
    "place_name":"Greigs Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2549,
    "place_name":"Millingandi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2549,
    "place_name":"Lochiel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2549,
    "place_name":"Bald Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2549,
    "place_name":"South Pambula",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Wog Wog",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Jellat Jellat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Nelson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Bournda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Mumbulla Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Burragate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Coolangubra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Wandella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Doctor George Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Quaama",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Greendale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Mogilla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Devils Hole",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Mogareeka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Verona",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Towamba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Reedy Swamp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Cobargo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Stony Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Kalaru",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Myrtle Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Numbugga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Yambulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Kameruka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Candelo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Bemboka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Tarraganda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Angledale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Rocky Hall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"South Wolumla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Wapengo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Bega",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Black Range",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Tanja",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Pericoe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Morans Crossing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Tathra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Wolumla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Wallagoot",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Brogo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Tantawangalo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Chinnock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Kanoona",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"New Buildings",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Frogs Hollow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Buckajo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Wyndham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Yowrie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Coolagolite",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Toothdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Yankees Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Kingswood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2550,
    "place_name":"Coopers Gully",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Boydtown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Green Cape",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Wonboyn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Kiah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Eden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Wonboyn North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Timbillica",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Wonboyn Lake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Nungatta South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Edrom",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Nungatta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Nadgee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Narrabarba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2551,
    "place_name":"Nullica",
    "state_name":"New South Wales"
  },
  {
    "postcode":2555,
    "place_name":"Badgerys Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2556,
    "place_name":"Bringelly",
    "state_name":"New South Wales"
  },
  {
    "postcode":2557,
    "place_name":"Rossmore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2557,
    "place_name":"Catherine Field",
    "state_name":"New South Wales"
  },
  {
    "postcode":2557,
    "place_name":"Gregory Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2557,
    "place_name":"Gledswood Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2558,
    "place_name":"Eschol Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2558,
    "place_name":"Kearns",
    "state_name":"New South Wales"
  },
  {
    "postcode":2558,
    "place_name":"Eagle Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2559,
    "place_name":"Claymore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2559,
    "place_name":"Blairmount",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Leumeah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Englorie Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Woodbine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Glen Alpine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Kentlyn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Wedderburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Macarthur Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Blair Athol",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Appin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Gilead",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Rosemeadow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Airds",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Campbelltown North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Ruse",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Cataract",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Bradbury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"St Helens Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Campbelltown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2560,
    "place_name":"Ambarvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2563,
    "place_name":"Menangle Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2564,
    "place_name":"Long Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2564,
    "place_name":"Macquarie Fields",
    "state_name":"New South Wales"
  },
  {
    "postcode":2564,
    "place_name":"Glenquarie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2565,
    "place_name":"Ingleburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2565,
    "place_name":"Macquarie Links",
    "state_name":"New South Wales"
  },
  {
    "postcode":2565,
    "place_name":"Denham Court",
    "state_name":"New South Wales"
  },
  {
    "postcode":2565,
    "place_name":"Bardia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2566,
    "place_name":"Minto Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2566,
    "place_name":"Minto DC",
    "state_name":"New South Wales"
  },
  {
    "postcode":2566,
    "place_name":"St Andrews",
    "state_name":"New South Wales"
  },
  {
    "postcode":2566,
    "place_name":"Bow Bowing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2566,
    "place_name":"Raby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2566,
    "place_name":"Varroville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2566,
    "place_name":"Minto",
    "state_name":"New South Wales"
  },
  {
    "postcode":2567,
    "place_name":"Narellan Dc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2567,
    "place_name":"Smeaton Grange",
    "state_name":"New South Wales"
  },
  {
    "postcode":2567,
    "place_name":"Harrington Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2567,
    "place_name":"Narellan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2567,
    "place_name":"Currans Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2567,
    "place_name":"Mount Annan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2567,
    "place_name":"Narellan Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2568,
    "place_name":"Menangle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2569,
    "place_name":"Douglas Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Glenmore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Werombi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Orangeville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Grasmere",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Camden Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Brownlow Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Mount Hunter",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Oakdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Camden South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Spring Farm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Theresa Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Bickley Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Nattai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Oran Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Cawdor",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Cobbitty",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Belimbla Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Ellis Lane",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Elderslie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Camden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"The Oaks",
    "state_name":"New South Wales"
  },
  {
    "postcode":2570,
    "place_name":"Kirkham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2571,
    "place_name":"Balmoral Village",
    "state_name":"New South Wales"
  },
  {
    "postcode":2571,
    "place_name":"Balmoral",
    "state_name":"New South Wales"
  },
  {
    "postcode":2571,
    "place_name":"Maldon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2571,
    "place_name":"Wilton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2571,
    "place_name":"Couridjah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2571,
    "place_name":"Razorback",
    "state_name":"New South Wales"
  },
  {
    "postcode":2571,
    "place_name":"Picton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2571,
    "place_name":"Buxton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2571,
    "place_name":"Mowbray Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2572,
    "place_name":"Thirlmere",
    "state_name":"New South Wales"
  },
  {
    "postcode":2572,
    "place_name":"Lakesland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2573,
    "place_name":"Tahmoor",
    "state_name":"New South Wales"
  },
  {
    "postcode":2574,
    "place_name":"Pheasants Nest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2574,
    "place_name":"Avon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2574,
    "place_name":"Bargo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2574,
    "place_name":"Yanderra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Yerrinbool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Mount Lindsey",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"High Range",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Mittagong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Alpine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Willow Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Colo Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Mandemar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Aylmerton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Wattle Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Woodlands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Goodmans Ford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Renwick",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Bullio",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Braemar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Welby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Balaclava",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Joadja",
    "state_name":"New South Wales"
  },
  {
    "postcode":2575,
    "place_name":"Hill Top",
    "state_name":"New South Wales"
  },
  {
    "postcode":2576,
    "place_name":"East Bowral",
    "state_name":"New South Wales"
  },
  {
    "postcode":2576,
    "place_name":"Burradoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2576,
    "place_name":"Bowral",
    "state_name":"New South Wales"
  },
  {
    "postcode":2576,
    "place_name":"East Kangaloon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2576,
    "place_name":"Glenquarry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2576,
    "place_name":"Kangaloon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Paddys River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Kangaroo Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Burrawang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Medway",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Budgong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Berrima",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"New Berrima",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Upper Kangaroo River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Yarrunga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Sutton Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Carrington Falls",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Barrengarry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Macquarie Pass",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Belanglo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Meryla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Beaumont",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Werai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Canyonleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Knights Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Robertson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Wildes Meadow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Avoca",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Moss Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Barren Grounds",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Mount Murray",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Red Rocks",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Fitzroy Falls",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Manchester Square",
    "state_name":"New South Wales"
  },
  {
    "postcode":2577,
    "place_name":"Upper Kangaroo Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2578,
    "place_name":"Bundanoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2579,
    "place_name":"Brayton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2579,
    "place_name":"Exeter",
    "state_name":"New South Wales"
  },
  {
    "postcode":2579,
    "place_name":"Marulan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2579,
    "place_name":"Tallong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2579,
    "place_name":"Wingello",
    "state_name":"New South Wales"
  },
  {
    "postcode":2579,
    "place_name":"Penrose",
    "state_name":"New South Wales"
  },
  {
    "postcode":2579,
    "place_name":"Big Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Carrick",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Bannaby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Richlands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Mayfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Chatsbury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Middle Arm",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Wayo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Towrang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Gundary",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Curraweela",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Myrtleville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Taralga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Currawang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Goulburn North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Yarra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Quialigo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Windellama",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Kingsdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Yalbraith",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Baw Baw",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Tarlo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Stonequarry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Bungonia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Mount Fairy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Goulburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Wombeyan Caves",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Pomeroy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Run-O-Waters",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Goulburn DC",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Tarago",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Golspie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Lower Boro",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Woodhouselee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Tirrannaville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Bannister",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Roslyn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Paling Yards",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Greenwich Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Jerrong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Mummel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Lake Bathurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Parkesbourne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Brisbane Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Boxers Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2580,
    "place_name":"Wiarborough",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Dalton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Broadway",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Gurrundah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Lake George",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Blakney Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Merrill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Biala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Bellmount Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Oolong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Wollogorang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Breadalbane",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Bevendale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Collector",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Lade Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Gunning",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Lerida",
    "state_name":"New South Wales"
  },
  {
    "postcode":2581,
    "place_name":"Cullerin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Mullion",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Jeir",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Yass",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Jerrawa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Cavan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Good Hope",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Wee Jasper",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Bango",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Bowning",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Manton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Bookham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Boambolo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Kangiara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Yass River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Laverstock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Marchmont",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Murrumbateman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Burrinjuck",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Berremangra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Woolgarlo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2582,
    "place_name":"Narrangullen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Binda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Laggan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Narrawa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Limerick",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Grabben Gullen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Crookwell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Pejar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Rugby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Tuena",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Lost River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Bigga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Crooked Corner",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Wheeo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Blanket Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Kialla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Peelwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2583,
    "place_name":"Fullerton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2584,
    "place_name":"Binalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2585,
    "place_name":"Galong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2586,
    "place_name":"Boorowa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2586,
    "place_name":"Frogmore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2586,
    "place_name":"Murringo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2586,
    "place_name":"Godfreys Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2586,
    "place_name":"Taylors Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2586,
    "place_name":"Rye Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2586,
    "place_name":"Reids Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2587,
    "place_name":"Wombat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2587,
    "place_name":"Cunningar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2587,
    "place_name":"Murrumburrah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2587,
    "place_name":"Nubba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2587,
    "place_name":"Beggan Beggan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2587,
    "place_name":"Kingsvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2587,
    "place_name":"Harden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2587,
    "place_name":"Mcmahons Reef",
    "state_name":"New South Wales"
  },
  {
    "postcode":2588,
    "place_name":"Wallendbeen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2590,
    "place_name":"Bethungra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2590,
    "place_name":"Cootamundra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2590,
    "place_name":"Illabo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Burrangong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Young",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Bulla Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Milvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Monteagle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Maimuru",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Barwang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Tubbul",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Kikiamah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Weedallion",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Memagong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Bribbaree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Berthong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2594,
    "place_name":"Thuddungra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2611,
    "place_name":"Bimberi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2611,
    "place_name":"Brindabella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2611,
    "place_name":"Cooleman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2618,
    "place_name":"Springrange",
    "state_name":"New South Wales"
  },
  {
    "postcode":2618,
    "place_name":"Nanima",
    "state_name":"New South Wales"
  },
  {
    "postcode":2618,
    "place_name":"Wallaroo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2619,
    "place_name":"Jerrabomberra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Queanbeyan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Yarrow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Tinderry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Queanbeyan East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"The Ridgeway",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Sutton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Williamsdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Queanbeyan West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Karabar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Burra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Michelago",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Tralee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Royalla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Crestwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Urila",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Gundaroo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Clear Range",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Carwoola",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"The Angle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Wamboin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Environa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Greenleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Queanbeyan DC",
    "state_name":"New South Wales"
  },
  {
    "postcode":2620,
    "place_name":"Googong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2621,
    "place_name":"Bungendore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2621,
    "place_name":"Anembo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2621,
    "place_name":"Bywong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2621,
    "place_name":"Forbes Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2621,
    "place_name":"Hoskinstown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2621,
    "place_name":"Primrose Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2621,
    "place_name":"Rossi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Bendoura",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Corang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Braidwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Ballalaba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Nerriga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Warri",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Araluen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Jinden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Reidsdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Mulloon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Boro",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Charleys Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Endrick",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Back Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Oallen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Oranmeir",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Krawarree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Snowball",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Larbert",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Palerang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Merricumbene",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Wog Wog",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Touga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"St George",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Coolumburra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Gundillion",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Manar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Mayfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Northangera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Jembaicumbene",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Jerrabattgulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Farringdon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Tomboye",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Wyanbene",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Durran Durra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Quiera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Monga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Tolwong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Hereford Hall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Budawang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Jingera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Kindervale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Murrengenburg",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Majors Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Sassafras",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Marlowe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Harolds Cross",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Neringla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Bulee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Mongarlowe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Berlang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Tianjara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2622,
    "place_name":"Bombay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2623,
    "place_name":"Captains Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2624,
    "place_name":"Charlottes Pass",
    "state_name":"New South Wales"
  },
  {
    "postcode":2624,
    "place_name":"Smiggin Holes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2624,
    "place_name":"Perisher Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2625,
    "place_name":"Thredbo Village",
    "state_name":"New South Wales"
  },
  {
    "postcode":2625,
    "place_name":"Thredbo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2626,
    "place_name":"Bredbo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2626,
    "place_name":"Bumbalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2626,
    "place_name":"Colinton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2627,
    "place_name":"Kosciuszko National Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2627,
    "place_name":"Ingebirah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2627,
    "place_name":"Jindabyne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2627,
    "place_name":"Pilot Wilderness",
    "state_name":"New South Wales"
  },
  {
    "postcode":2627,
    "place_name":"Grosses Plain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2627,
    "place_name":"Crackenback",
    "state_name":"New South Wales"
  },
  {
    "postcode":2627,
    "place_name":"East Jindabyne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2627,
    "place_name":"Kalkite",
    "state_name":"New South Wales"
  },
  {
    "postcode":2627,
    "place_name":"Kosciuszko",
    "state_name":"New South Wales"
  },
  {
    "postcode":2627,
    "place_name":"Moonbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Beloka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Eucumbene",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Hill Top",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Snowy Plain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Nimmo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Dalgety",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Berridale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Paupong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Byadbo Wilderness",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Braemar Bay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Avonside",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Rocky Plain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Cootralantra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2628,
    "place_name":"Numbla Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2629,
    "place_name":"Tantangara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2629,
    "place_name":"Cabramurra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2629,
    "place_name":"Anglers Reach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2629,
    "place_name":"Adaminaby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2629,
    "place_name":"Old Adaminaby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2629,
    "place_name":"Long Plain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2629,
    "place_name":"Kiandra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2629,
    "place_name":"Bolaro",
    "state_name":"New South Wales"
  },
  {
    "postcode":2629,
    "place_name":"Yaouk",
    "state_name":"New South Wales"
  },
  {
    "postcode":2629,
    "place_name":"Providence Portal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Rhine Falls",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Bungarby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Bunyan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Cooma",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Jerangle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Billilingra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Maffra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Bobundara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Coolringdon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Frying Pan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Badja",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Middle Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Numeralla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Peak View",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Rock Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Binjura",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Dairymans Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"The Brothers",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Glen Fergus",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Dry Plain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Dangelong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Springfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Cooma North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Countegany",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Middlingbank",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Wambrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Buckenderra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Murrumbucca",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Polo Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Pine Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Rose Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Myalla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Tuross",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Shannons Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Carlaminda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Chakola",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Ironmungy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Jimenbuen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2630,
    "place_name":"Arable",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Holts Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Winifred",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Jincumbilly",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Glen Allen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Mount Cooper",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Greenlands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Steeple Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Nimmitabel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Boco",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Ando",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Creewah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2631,
    "place_name":"Kybeyan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Cathcart",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Paddys Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Rockton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Palarang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Bukalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Lords Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Mount Darragh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Gunningrah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Mila",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Merriangaah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Cambalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Rosemeath",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Bombala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Coolumbooka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Bondi Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Bibbenluke",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Craigie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2632,
    "place_name":"Quidong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2633,
    "place_name":"Corrowong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2633,
    "place_name":"Tombong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2633,
    "place_name":"Delegate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Talmalmo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Table Top",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"North Albury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Ournie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Moorwatha",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Thurgoona",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Lavington Dc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Bungowannah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"East Albury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Wymah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"South Albury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"West Albury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Wirlinga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Glenroy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Ettamogah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Splitters Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2640,
    "place_name":"Albury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2641,
    "place_name":"Lavington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2641,
    "place_name":"Hamilton Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2641,
    "place_name":"Springdale Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Jagumba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Tooma",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Burrumbuttock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Welaregang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Bidgeemia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Rand",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Brocklesby",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Walbundrie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Jagungal Wilderness",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Greg Greg",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Glenellen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Jingellic",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Wrathall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Yerong Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Murray Gorge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Gerogery",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Geehi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Khancoban",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Indi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2642,
    "place_name":"Jindera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2643,
    "place_name":"Howlong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2644,
    "place_name":"Little Billabong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2644,
    "place_name":"Bowna",
    "state_name":"New South Wales"
  },
  {
    "postcode":2644,
    "place_name":"Mountain Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2644,
    "place_name":"Woomargama",
    "state_name":"New South Wales"
  },
  {
    "postcode":2644,
    "place_name":"Lankeys Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2644,
    "place_name":"Holbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2644,
    "place_name":"Yarara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2644,
    "place_name":"Mullengandra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2644,
    "place_name":"Wantagong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2644,
    "place_name":"Coppabella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2645,
    "place_name":"Urana",
    "state_name":"New South Wales"
  },
  {
    "postcode":2645,
    "place_name":"Cullivel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Daysdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Rennie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Oaklands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Balldale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Coreen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Savernake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Corowa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Goombargana",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Lowesdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Sanger",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Ringwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Hopefield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Redlands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Nyora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2646,
    "place_name":"Collendina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2647,
    "place_name":"Mulwala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Mourquong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Ellerslie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Anabranch North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Palinyewah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Rufus",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Pomona",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Wentworth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Rufus River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Pooncarie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Moorara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Cal Lal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Para",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Scotia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Pan Ban",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Anabranch South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Pine Camp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2648,
    "place_name":"Curlwaa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2649,
    "place_name":"Laurel Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2649,
    "place_name":"Nurenmerenmong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Tolland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Burrandana",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Bomen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Pulletop",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"East Wagga Wagga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Estella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Glenfield Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Yathella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Wagga Wagga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Wantabadgery",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Mount Austin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Eunanoreenya",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Oura",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Oberne Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Galore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Maxwell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Lake Albert",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Ashmont",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Gregadoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Wallacetown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Boorooma",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Kyeamba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Currawarna",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Belfrayden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Cookardinia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Tatton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Cartwrights Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Big Springs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Brucedale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Moorong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"San Isidore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Wagga Wagga South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Bourkelands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Gobbagombalin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Carabost",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Downside",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Turvey Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Springvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Yarragundry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Book Book",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Harefield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Borambola",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Alfredtown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Hillgrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Bulgary",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Wagga Wagga BC",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Rowan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Lloyd",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Kooringal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"The Gap",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"North Wagga Wagga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Collingullie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Euberta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2650,
    "place_name":"Gelston Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2651,
    "place_name":"Forest Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2651,
    "place_name":"Wagga Wagga Raaf",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Boree Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Boorga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Humula",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Galore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Marrar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Gumly Gumly",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Tarcutta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Tabbita",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Uranquinty",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Landervale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Ladysmith",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Grong Grong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Rosewood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Matong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Cowabbie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Old Junee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Merriwagga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Mangoplah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Murrulebale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2652,
    "place_name":"Goolgowi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2653,
    "place_name":"Burra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2653,
    "place_name":"Courabyra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2653,
    "place_name":"Glenroy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2653,
    "place_name":"Paddys River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2653,
    "place_name":"Mannus",
    "state_name":"New South Wales"
  },
  {
    "postcode":2653,
    "place_name":"Taradale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2653,
    "place_name":"Willigobung",
    "state_name":"New South Wales"
  },
  {
    "postcode":2653,
    "place_name":"Munderoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2653,
    "place_name":"Westdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2653,
    "place_name":"Tumbarumba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2653,
    "place_name":"Maragle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2655,
    "place_name":"The Rock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2655,
    "place_name":"Tootool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2655,
    "place_name":"French Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2656,
    "place_name":"Osborne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2656,
    "place_name":"Urangeline East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2656,
    "place_name":"Brookong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2656,
    "place_name":"Fargunyah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2656,
    "place_name":"Urangeline",
    "state_name":"New South Wales"
  },
  {
    "postcode":2656,
    "place_name":"Lockhart",
    "state_name":"New South Wales"
  },
  {
    "postcode":2656,
    "place_name":"Brookdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2656,
    "place_name":"Milbrulong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2658,
    "place_name":"Pleasant Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2658,
    "place_name":"Henty",
    "state_name":"New South Wales"
  },
  {
    "postcode":2658,
    "place_name":"Ryan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2658,
    "place_name":"Munyabla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2659,
    "place_name":"Alma Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2659,
    "place_name":"Walla Walla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2660,
    "place_name":"Morven",
    "state_name":"New South Wales"
  },
  {
    "postcode":2660,
    "place_name":"Culcairn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2661,
    "place_name":"Kapooka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2663,
    "place_name":"Erin Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2663,
    "place_name":"Eurongilly",
    "state_name":"New South Wales"
  },
  {
    "postcode":2663,
    "place_name":"Wantiool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2663,
    "place_name":"Marinna",
    "state_name":"New South Wales"
  },
  {
    "postcode":2663,
    "place_name":"Junee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Mirrool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Barellan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Tara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Bectric",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Kamarah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Moombooldool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Beckom",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Binya",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Walleroobie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Ariah Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Quandary",
    "state_name":"New South Wales"
  },
  {
    "postcode":2665,
    "place_name":"Ardlethan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Grogan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Reefton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Dirnaseer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Junee Reefs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Morangarell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Mimosa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Combaning",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Pucawan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Sebastopol",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Temora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Gidginbung",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Trungley Hall",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Narraburra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2666,
    "place_name":"Springdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2668,
    "place_name":"Barmedman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Rankins Springs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Melbergen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Tallimba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Erigolia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Gubbata",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Tullibigeal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Naradhan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Girral",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Weethalle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Bygalorie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Ungarie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2669,
    "place_name":"Kikoira",
    "state_name":"New South Wales"
  },
  {
    "postcode":2671,
    "place_name":"West Wyalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2671,
    "place_name":"North Yalgogrin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2671,
    "place_name":"Wyalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2671,
    "place_name":"Alleena",
    "state_name":"New South Wales"
  },
  {
    "postcode":2671,
    "place_name":"Lake Cowal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2671,
    "place_name":"Back Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2671,
    "place_name":"Burcher",
    "state_name":"New South Wales"
  },
  {
    "postcode":2672,
    "place_name":"Lake Cargelligo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2672,
    "place_name":"Curlew Waters",
    "state_name":"New South Wales"
  },
  {
    "postcode":2672,
    "place_name":"Murrin Bridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2672,
    "place_name":"Burgooney",
    "state_name":"New South Wales"
  },
  {
    "postcode":2675,
    "place_name":"Hillston",
    "state_name":"New South Wales"
  },
  {
    "postcode":2675,
    "place_name":"Wallanthery",
    "state_name":"New South Wales"
  },
  {
    "postcode":2675,
    "place_name":"Lake Brewster",
    "state_name":"New South Wales"
  },
  {
    "postcode":2675,
    "place_name":"Monia Gap",
    "state_name":"New South Wales"
  },
  {
    "postcode":2675,
    "place_name":"Roto",
    "state_name":"New South Wales"
  },
  {
    "postcode":2678,
    "place_name":"Riverina Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2678,
    "place_name":"Charles Sturt University",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Beelbangera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Nericon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Bilbul",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Griffith East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Yoogali",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Willbriggie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Warburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Warrawidgee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Hanwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Kooba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Griffith",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Griffith DC",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Lake Wyangan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Tharbogang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Widgelli",
    "state_name":"New South Wales"
  },
  {
    "postcode":2680,
    "place_name":"Benerembah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2681,
    "place_name":"Yenda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2681,
    "place_name":"Myall Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2700,
    "place_name":"Sandigo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2700,
    "place_name":"Morundah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2700,
    "place_name":"Narrandera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2700,
    "place_name":"Gillenbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2700,
    "place_name":"Colinroobie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2700,
    "place_name":"Bundure",
    "state_name":"New South Wales"
  },
  {
    "postcode":2700,
    "place_name":"Cudgel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2700,
    "place_name":"Euroley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2700,
    "place_name":"Corobimilla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2701,
    "place_name":"Methul",
    "state_name":"New South Wales"
  },
  {
    "postcode":2701,
    "place_name":"Berry Jerry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2701,
    "place_name":"Coolamon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2701,
    "place_name":"Rannock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2702,
    "place_name":"Ganmain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2703,
    "place_name":"Yanco",
    "state_name":"New South Wales"
  },
  {
    "postcode":2705,
    "place_name":"Corbie Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2705,
    "place_name":"Whitton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2705,
    "place_name":"Wamoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2705,
    "place_name":"Merungle Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2705,
    "place_name":"Murrami",
    "state_name":"New South Wales"
  },
  {
    "postcode":2705,
    "place_name":"Leeton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2705,
    "place_name":"Stanbridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2705,
    "place_name":"Brobenah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2705,
    "place_name":"Gogeldrie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2706,
    "place_name":"Darlington Point",
    "state_name":"New South Wales"
  },
  {
    "postcode":2707,
    "place_name":"Coleambally",
    "state_name":"New South Wales"
  },
  {
    "postcode":2707,
    "place_name":"Argoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2708,
    "place_name":"Murray Region Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Pretty Pine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Mathoura",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Wakool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Wandook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Birganbigil",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Caldwell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Moonbria",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Deniliquin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Stud Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Conargo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Steam Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Calimo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Gulpa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Wanganella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Booroorban",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Lindifferon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Barratta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Coree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Moira",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Hartwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Morago",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Bullatale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Mayrung",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Willurah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2710,
    "place_name":"Warragoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Oxley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Carrathool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Maude",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Yanga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Gunbar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Keri Keri",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Corrong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Waugorah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Booligal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Hay South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"One Tree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Clare",
    "state_name":"New South Wales"
  },
  {
    "postcode":2711,
    "place_name":"Hay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2712,
    "place_name":"Berrigan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2712,
    "place_name":"Boomanoomana",
    "state_name":"New South Wales"
  },
  {
    "postcode":2713,
    "place_name":"Myrtle Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2713,
    "place_name":"Blighty",
    "state_name":"New South Wales"
  },
  {
    "postcode":2713,
    "place_name":"Logie Brae",
    "state_name":"New South Wales"
  },
  {
    "postcode":2713,
    "place_name":"Finley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2714,
    "place_name":"Tuppal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2714,
    "place_name":"Tocumwal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2714,
    "place_name":"Aratula",
    "state_name":"New South Wales"
  },
  {
    "postcode":2714,
    "place_name":"Pine Lodge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2715,
    "place_name":"Hatfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2715,
    "place_name":"Mungo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2715,
    "place_name":"Balranald",
    "state_name":"New South Wales"
  },
  {
    "postcode":2715,
    "place_name":"Kyalite",
    "state_name":"New South Wales"
  },
  {
    "postcode":2715,
    "place_name":"Arumpo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2716,
    "place_name":"Four Corners",
    "state_name":"New South Wales"
  },
  {
    "postcode":2716,
    "place_name":"Mairjimmy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2716,
    "place_name":"Gala Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2716,
    "place_name":"Mabins Well",
    "state_name":"New South Wales"
  },
  {
    "postcode":2716,
    "place_name":"Jerilderie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2717,
    "place_name":"Dareton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2717,
    "place_name":"Coomealla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Bombowlee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Pinbeyan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Lacmalac",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Blowering",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Talbingo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Gadara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Red Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Tumut",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Minjary",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Mundongo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Tumorrama",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Argalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Yarrangobilly",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Couragago",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Gocup",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Gilmore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Killimicat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Little River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Goobarragandra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Jones Bridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Bombowlee Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Wyangle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Buddong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Windowie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Tumut Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Bogong Peaks Wilderness",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Wereboldera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2720,
    "place_name":"Wermatong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2721,
    "place_name":"Quandialla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2721,
    "place_name":"Bland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2722,
    "place_name":"Gundagai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2722,
    "place_name":"Darbalara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2722,
    "place_name":"South Gundagai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2722,
    "place_name":"Brungle Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2722,
    "place_name":"Brungle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2722,
    "place_name":"Jones Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2722,
    "place_name":"Muttama",
    "state_name":"New South Wales"
  },
  {
    "postcode":2722,
    "place_name":"Burra Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2722,
    "place_name":"Nangus",
    "state_name":"New South Wales"
  },
  {
    "postcode":2725,
    "place_name":"Stockinbingal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2726,
    "place_name":"Cooneys Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2726,
    "place_name":"Jugiong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2727,
    "place_name":"Coolac",
    "state_name":"New South Wales"
  },
  {
    "postcode":2727,
    "place_name":"Gobarralong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2727,
    "place_name":"Adjungbilly",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Westwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Mount Horeb",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Sandy Gully",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Cooleys Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Califat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Black Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Adelong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Tumblong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Grahamstown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Darlow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Sharps Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Mundarlo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Yaven Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Bangadang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Ellerslie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Mount Adrah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2729,
    "place_name":"Wondalga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2730,
    "place_name":"Green Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2730,
    "place_name":"Kunama",
    "state_name":"New South Wales"
  },
  {
    "postcode":2730,
    "place_name":"Lower Bago",
    "state_name":"New South Wales"
  },
  {
    "postcode":2730,
    "place_name":"Batlow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2731,
    "place_name":"Bunnaloo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2731,
    "place_name":"Tantonan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2731,
    "place_name":"Womboota",
    "state_name":"New South Wales"
  },
  {
    "postcode":2731,
    "place_name":"Thyra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2731,
    "place_name":"Moama",
    "state_name":"New South Wales"
  },
  {
    "postcode":2732,
    "place_name":"Burraboi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2732,
    "place_name":"Gonn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2732,
    "place_name":"Cobramunga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2732,
    "place_name":"Tullakool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2732,
    "place_name":"Thule",
    "state_name":"New South Wales"
  },
  {
    "postcode":2732,
    "place_name":"Barham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2732,
    "place_name":"Noorong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2733,
    "place_name":"Dhuragoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2733,
    "place_name":"Niemur",
    "state_name":"New South Wales"
  },
  {
    "postcode":2733,
    "place_name":"Moulamein",
    "state_name":"New South Wales"
  },
  {
    "postcode":2734,
    "place_name":"Dilpurra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2734,
    "place_name":"Stony Crossing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2734,
    "place_name":"Cunninyeuk",
    "state_name":"New South Wales"
  },
  {
    "postcode":2734,
    "place_name":"Kyalite",
    "state_name":"New South Wales"
  },
  {
    "postcode":2734,
    "place_name":"Mallan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2734,
    "place_name":"Wetuppa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2734,
    "place_name":"Tooranie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2734,
    "place_name":"Murray Downs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2734,
    "place_name":"Mellool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2734,
    "place_name":"Moolpa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2735,
    "place_name":"Koraleigh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2735,
    "place_name":"Speewa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2736,
    "place_name":"Goodnight",
    "state_name":"New South Wales"
  },
  {
    "postcode":2736,
    "place_name":"Tooleybuc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2737,
    "place_name":"Euston",
    "state_name":"New South Wales"
  },
  {
    "postcode":2738,
    "place_name":"Paringi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2738,
    "place_name":"Gol Gol",
    "state_name":"New South Wales"
  },
  {
    "postcode":2738,
    "place_name":"Trentham Cliffs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2738,
    "place_name":"Mallee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2738,
    "place_name":"Monak",
    "state_name":"New South Wales"
  },
  {
    "postcode":2739,
    "place_name":"Mourquong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2739,
    "place_name":"Boeill Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2739,
    "place_name":"Buronga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2745,
    "place_name":"Mulgoa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2745,
    "place_name":"Glenmore Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2745,
    "place_name":"Greendale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2745,
    "place_name":"Luddenham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2745,
    "place_name":"Regentville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2745,
    "place_name":"Wallacia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2747,
    "place_name":"Claremont Meadows",
    "state_name":"New South Wales"
  },
  {
    "postcode":2747,
    "place_name":"Kingswood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2747,
    "place_name":"Shanes Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2747,
    "place_name":"Cambridge Gardens",
    "state_name":"New South Wales"
  },
  {
    "postcode":2747,
    "place_name":"Caddens",
    "state_name":"New South Wales"
  },
  {
    "postcode":2747,
    "place_name":"Werrington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2747,
    "place_name":"Cambridge Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2747,
    "place_name":"Werrington County",
    "state_name":"New South Wales"
  },
  {
    "postcode":2747,
    "place_name":"Llandilo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2747,
    "place_name":"Werrington Downs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2747,
    "place_name":"Jordan Springs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2748,
    "place_name":"Orchard Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2749,
    "place_name":"Castlereagh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2749,
    "place_name":"Cranebrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2750,
    "place_name":"Penrith",
    "state_name":"New South Wales"
  },
  {
    "postcode":2750,
    "place_name":"Leonay",
    "state_name":"New South Wales"
  },
  {
    "postcode":2750,
    "place_name":"Jamisontown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2750,
    "place_name":"Emu Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2750,
    "place_name":"South Penrith",
    "state_name":"New South Wales"
  },
  {
    "postcode":2750,
    "place_name":"Emu Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2750,
    "place_name":"Penrith Plaza",
    "state_name":"New South Wales"
  },
  {
    "postcode":2750,
    "place_name":"Penrith South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2751,
    "place_name":"Penrith",
    "state_name":"New South Wales"
  },
  {
    "postcode":2752,
    "place_name":"Warragamba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2752,
    "place_name":"Silverdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2753,
    "place_name":"Londonderry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2753,
    "place_name":"Agnes Banks",
    "state_name":"New South Wales"
  },
  {
    "postcode":2753,
    "place_name":"Grose Wold",
    "state_name":"New South Wales"
  },
  {
    "postcode":2753,
    "place_name":"Hobartville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2753,
    "place_name":"Bowen Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2753,
    "place_name":"Yarramundi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2753,
    "place_name":"Grose Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2753,
    "place_name":"Richmond",
    "state_name":"New South Wales"
  },
  {
    "postcode":2753,
    "place_name":"Richmond Lowlands",
    "state_name":"New South Wales"
  },
  {
    "postcode":2754,
    "place_name":"The Slopes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2754,
    "place_name":"North Richmond",
    "state_name":"New South Wales"
  },
  {
    "postcode":2754,
    "place_name":"Tennyson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2755,
    "place_name":"Richmond Raaf",
    "state_name":"New South Wales"
  },
  {
    "postcode":2755,
    "place_name":"Richmond",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Bligh Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Cornwallis",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Colo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Mellong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Ebenezer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Freemans Reach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Cumberland Reach",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Colo Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Glossodia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Sackville North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Cattai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Upper Colo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Pitt Town",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Mulgrave",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Mcgraths Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Pitt Town Bottoms",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"South Maroota",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Sackville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Maroota",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Windsor Downs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Central Colo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Windsor",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Womerah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Scheyville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"South Windsor",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Wilberforce",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Lower Portland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2756,
    "place_name":"Clarendon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2757,
    "place_name":"Kurmond",
    "state_name":"New South Wales"
  },
  {
    "postcode":2758,
    "place_name":"Blaxlands Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2758,
    "place_name":"Wheeny Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2758,
    "place_name":"Mountain Lagoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2758,
    "place_name":"Bilpin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2758,
    "place_name":"Mount Tomah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2758,
    "place_name":"Kurrajong Hills",
    "state_name":"New South Wales"
  },
  {
    "postcode":2758,
    "place_name":"East Kurrajong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2758,
    "place_name":"Berambing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2758,
    "place_name":"Kurrajong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2758,
    "place_name":"The Devils Wilderness",
    "state_name":"New South Wales"
  },
  {
    "postcode":2758,
    "place_name":"Kurrajong Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2759,
    "place_name":"St Clair",
    "state_name":"New South Wales"
  },
  {
    "postcode":2759,
    "place_name":"Erskine Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2760,
    "place_name":"Colyton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2760,
    "place_name":"St Marys East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2760,
    "place_name":"North St Marys",
    "state_name":"New South Wales"
  },
  {
    "postcode":2760,
    "place_name":"Ropes Crossing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2760,
    "place_name":"Oxley Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2760,
    "place_name":"St Marys",
    "state_name":"New South Wales"
  },
  {
    "postcode":2760,
    "place_name":"St Marys South",
    "state_name":"New South Wales"
  },
  {
    "postcode":2761,
    "place_name":"Plumpton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2761,
    "place_name":"Hassall Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2761,
    "place_name":"Dean Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2761,
    "place_name":"Oakhurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2761,
    "place_name":"Colebee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2761,
    "place_name":"Glendenning",
    "state_name":"New South Wales"
  },
  {
    "postcode":2762,
    "place_name":"Schofields",
    "state_name":"New South Wales"
  },
  {
    "postcode":2763,
    "place_name":"Quakers Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2763,
    "place_name":"Acacia Gardens",
    "state_name":"New South Wales"
  },
  {
    "postcode":2765,
    "place_name":"Box Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2765,
    "place_name":"Vineyard",
    "state_name":"New South Wales"
  },
  {
    "postcode":2765,
    "place_name":"Nelson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2765,
    "place_name":"Oakville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2765,
    "place_name":"Riverstone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2765,
    "place_name":"Marsden Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2765,
    "place_name":"Maraylya",
    "state_name":"New South Wales"
  },
  {
    "postcode":2765,
    "place_name":"Berkshire Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2766,
    "place_name":"Eastern Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2766,
    "place_name":"Rooty Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2767,
    "place_name":"Bungarribee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2767,
    "place_name":"Woodcroft",
    "state_name":"New South Wales"
  },
  {
    "postcode":2767,
    "place_name":"Doonside",
    "state_name":"New South Wales"
  },
  {
    "postcode":2768,
    "place_name":"Parklea",
    "state_name":"New South Wales"
  },
  {
    "postcode":2768,
    "place_name":"Stanhope Gardens",
    "state_name":"New South Wales"
  },
  {
    "postcode":2768,
    "place_name":"Glenwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2769,
    "place_name":"The Ponds",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Lethbridge Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Tregear",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Bidwill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Dharruk",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Hebersham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Whalan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Willmot",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Minchinbury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Emerton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Mount Druitt Village",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Mount Druitt",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Shalvey",
    "state_name":"New South Wales"
  },
  {
    "postcode":2770,
    "place_name":"Blackett",
    "state_name":"New South Wales"
  },
  {
    "postcode":2773,
    "place_name":"Lapstone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2773,
    "place_name":"Glenbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2774,
    "place_name":"Mount Riverview",
    "state_name":"New South Wales"
  },
  {
    "postcode":2774,
    "place_name":"Blaxland East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2774,
    "place_name":"Blaxland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2774,
    "place_name":"Warrimoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Wisemans Ferry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Spencer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Marlow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"St Albans",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Higher Macdonald",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Singletons Mill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Perrys Crossing",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Lower Macdonald",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Central Macdonald",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Webbs Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Leets Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Fernances",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Wrights Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Upper Macdonald",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Laughtondale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Gunderman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Mogo Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2775,
    "place_name":"Lower Hawkesbury",
    "state_name":"New South Wales"
  },
  {
    "postcode":2776,
    "place_name":"Faulconbridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2777,
    "place_name":"Hawkesbury Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2777,
    "place_name":"Sun Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2777,
    "place_name":"Winmalee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2777,
    "place_name":"Yellow Rock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2777,
    "place_name":"Springwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2777,
    "place_name":"Valley Heights",
    "state_name":"New South Wales"
  },
  {
    "postcode":2778,
    "place_name":"Linden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2778,
    "place_name":"Woodford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2779,
    "place_name":"Hazelbrook",
    "state_name":"New South Wales"
  },
  {
    "postcode":2780,
    "place_name":"Katoomba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2780,
    "place_name":"Katoomba DC",
    "state_name":"New South Wales"
  },
  {
    "postcode":2780,
    "place_name":"Medlow Bath",
    "state_name":"New South Wales"
  },
  {
    "postcode":2780,
    "place_name":"Leura",
    "state_name":"New South Wales"
  },
  {
    "postcode":2782,
    "place_name":"Wentworth Falls",
    "state_name":"New South Wales"
  },
  {
    "postcode":2783,
    "place_name":"Lawson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2784,
    "place_name":"Bullaburra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2785,
    "place_name":"Megalong Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2785,
    "place_name":"Blackheath",
    "state_name":"New South Wales"
  },
  {
    "postcode":2785,
    "place_name":"Megalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2786,
    "place_name":"Mount Irvine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2786,
    "place_name":"Mount Victoria",
    "state_name":"New South Wales"
  },
  {
    "postcode":2786,
    "place_name":"Bell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2786,
    "place_name":"Mount Wilson",
    "state_name":"New South Wales"
  },
  {
    "postcode":2786,
    "place_name":"Dargan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Duckmaloi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Essington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Oberon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Edith",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Shooters Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Black Springs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Mount Werong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Mayfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Gurnang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Tarana",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Hazelgrove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Porters Retreat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Gingkin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Chatham Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Mozart",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Norway",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"The Meadows",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Jaunter",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Kanangra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2787,
    "place_name":"Mount Olive",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Springvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Littleton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Little Hartley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Oaky Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Hartley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Hermitage Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Hartley Vale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Good Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Bowenfels",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Clarence",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Lidsdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Kanimbla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Jenolan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"South Littleton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Blackmans Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Hassans Walls",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Rydal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Hampton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Pottery Estate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Wollangambe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Cullen Bullen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"South Bowenfels",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Morts Estate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Newnes Plateau",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Lowther",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Lithgow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Sodwalls",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"State Mine Gully",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Newnes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Mount Lambie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Ben Bullen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Doctors Gap",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Ganbenang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Wolgan Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Vale Of Clwydd",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Corney Town",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Mckellars Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Sheedys Gully",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Jenolan Caves",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Marrangaroo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2790,
    "place_name":"Cobar Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2791,
    "place_name":"Carcoar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2791,
    "place_name":"Errowanbang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2792,
    "place_name":"Mandurama",
    "state_name":"New South Wales"
  },
  {
    "postcode":2792,
    "place_name":"Burnt Yards",
    "state_name":"New South Wales"
  },
  {
    "postcode":2793,
    "place_name":"Darbys Falls",
    "state_name":"New South Wales"
  },
  {
    "postcode":2793,
    "place_name":"Roseberg",
    "state_name":"New South Wales"
  },
  {
    "postcode":2793,
    "place_name":"Woodstock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2794,
    "place_name":"Noonbinna",
    "state_name":"New South Wales"
  },
  {
    "postcode":2794,
    "place_name":"Westville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2794,
    "place_name":"Wattamondara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2794,
    "place_name":"Cowra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2794,
    "place_name":"Hovells Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2794,
    "place_name":"Mount Collins",
    "state_name":"New South Wales"
  },
  {
    "postcode":2794,
    "place_name":"Bumbaldry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Locksley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Fosters Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Georges Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Triangle Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Wimbledon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Laffing Waters",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Windradyne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Mitchell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Sunny Corner",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Billywillinga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Meadow Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Copperhannia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Robin Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Kirkconnell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Peel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Dunkeld",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"West Bathurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Jeremy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Glanmire",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Mount David",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Crudine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Fitzgeralds Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Yetholme",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Raglan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Gowan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Cow Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Burraga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Wisemans Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Arkell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Clear Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"O'Connell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Colo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Hobbys Yards",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Forest Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Trunkey Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Wiagdon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Llanarth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Gemalla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Caloola",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Abercrombie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Palmers Oaky",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Yarras",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Dog Rocks",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Wattle Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Stewarts Mount",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Perthville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Walang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"The Lagoon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Arkstone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Isabella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Bathurst West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Kelso",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Twenty Forests",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Paling Yards",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Ballyroe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Mount Rankin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Moorilda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Gilmandyke",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Milkers Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Eglinton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Millah Murrah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Mount Panorama",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Killongbutta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Bathurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Watton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Charles Sturt University",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Abercrombie River",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Dark Corner",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Evans Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Charlton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Limekilns",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Turondale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"South Bathurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Rockley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Gormans Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Brewongle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"White Rock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Winburndale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Tannas Mount",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Sofala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Freemantle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Orton Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"The Rocks",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Upper Turon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Judds Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Bruinbun",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Bald Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Napoleon Reef",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Bathampton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Newbridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Rock Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Wambool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Duramana",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Curragh",
    "state_name":"New South Wales"
  },
  {
    "postcode":2795,
    "place_name":"Rockley Mount",
    "state_name":"New South Wales"
  },
  {
    "postcode":2797,
    "place_name":"Garland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2797,
    "place_name":"Lyndhurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2798,
    "place_name":"Forest Reefs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2798,
    "place_name":"Tallwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2798,
    "place_name":"Spring Terrace",
    "state_name":"New South Wales"
  },
  {
    "postcode":2798,
    "place_name":"Guyong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2798,
    "place_name":"Millthorpe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2799,
    "place_name":"Neville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2799,
    "place_name":"Kings Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2799,
    "place_name":"Barry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2799,
    "place_name":"Blayney",
    "state_name":"New South Wales"
  },
  {
    "postcode":2799,
    "place_name":"Vittoria",
    "state_name":"New South Wales"
  },
  {
    "postcode":2799,
    "place_name":"Fitzgeralds Mount",
    "state_name":"New South Wales"
  },
  {
    "postcode":2799,
    "place_name":"Browns Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Lucknow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Nashdale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Summer Hill Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Huntley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Canobolas",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Borenore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Ophir",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"March",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Spring Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Clergate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Clifton Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Spring Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Lidster",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Bowen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Lewis Ponds",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Windera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Byng",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Lower Lewis Ponds",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Cadia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Waldegrave",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Mullion Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Orange",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Shadforth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Orange East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Four Mile Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Kerrs Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Belgravia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Narrambla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Emu Swamp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Kangaroobie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Springside",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Panuara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Cargo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Orange DC",
    "state_name":"New South Wales"
  },
  {
    "postcode":2800,
    "place_name":"Boree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2803,
    "place_name":"Crowther",
    "state_name":"New South Wales"
  },
  {
    "postcode":2803,
    "place_name":"Wirrimah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2803,
    "place_name":"Bendick Murrell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2804,
    "place_name":"Nyrang Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2804,
    "place_name":"Moorbel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2804,
    "place_name":"Canowindra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2804,
    "place_name":"Billimari",
    "state_name":"New South Wales"
  },
  {
    "postcode":2805,
    "place_name":"Gooloogong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2806,
    "place_name":"Eugowra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2807,
    "place_name":"Koorawatha",
    "state_name":"New South Wales"
  },
  {
    "postcode":2808,
    "place_name":"Wyangala",
    "state_name":"New South Wales"
  },
  {
    "postcode":2809,
    "place_name":"Greenethorpe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2810,
    "place_name":"Pinnacle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2810,
    "place_name":"Piney Range",
    "state_name":"New South Wales"
  },
  {
    "postcode":2810,
    "place_name":"Warraderry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2810,
    "place_name":"Pullabooka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2810,
    "place_name":"Glenelg",
    "state_name":"New South Wales"
  },
  {
    "postcode":2810,
    "place_name":"Caragabal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2810,
    "place_name":"Bimbi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2810,
    "place_name":"Grenfell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2818,
    "place_name":"Terrabella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2818,
    "place_name":"Benolong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2818,
    "place_name":"Ponto",
    "state_name":"New South Wales"
  },
  {
    "postcode":2818,
    "place_name":"Geurie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Medway",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Apsley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Walmer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Gollan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Bakers Swamp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Stuart Town",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Maryvale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Curra Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Arthurville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Montefiores",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Bodangora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Neurea",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Dripstone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Mount Arthur",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Mumbil",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Wuuluman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Wellington",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Spicers Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Farnham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Suntop",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Comobella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Lake Burrendong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Mount Aquila",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Mookerawa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2820,
    "place_name":"Yarragal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2821,
    "place_name":"Narromine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2821,
    "place_name":"Burroway",
    "state_name":"New South Wales"
  },
  {
    "postcode":2823,
    "place_name":"Trangie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2823,
    "place_name":"Cathundral",
    "state_name":"New South Wales"
  },
  {
    "postcode":2823,
    "place_name":"Dandaloo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2823,
    "place_name":"Gin Gin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2823,
    "place_name":"Bundemar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Mount Foster",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Warren",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Mount Harris",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Snakes Plain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Eenaweena",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Tenandra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Marthaguy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Ravenswood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Red Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Beemunnel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Bullagreen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Pine Clump",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Pigeonbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Mumblebone Plain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2824,
    "place_name":"Oxley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2825,
    "place_name":"Nyngan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2825,
    "place_name":"Mulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2825,
    "place_name":"Miandetta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2825,
    "place_name":"Bogan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2825,
    "place_name":"Mullengudgery",
    "state_name":"New South Wales"
  },
  {
    "postcode":2825,
    "place_name":"Honeybugle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2825,
    "place_name":"Canonba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2825,
    "place_name":"Pangee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2825,
    "place_name":"Murrawombie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2825,
    "place_name":"Babinda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2825,
    "place_name":"Buddabadah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2826,
    "place_name":"Nevertire",
    "state_name":"New South Wales"
  },
  {
    "postcode":2826,
    "place_name":"Bogan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2827,
    "place_name":"Biddon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2827,
    "place_name":"Collie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2827,
    "place_name":"Gilgandra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2827,
    "place_name":"Curban",
    "state_name":"New South Wales"
  },
  {
    "postcode":2827,
    "place_name":"Bearbong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2827,
    "place_name":"Breelong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2827,
    "place_name":"Merrigal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2828,
    "place_name":"Armatree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2828,
    "place_name":"Tonderburine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2828,
    "place_name":"Black Hollow",
    "state_name":"New South Wales"
  },
  {
    "postcode":2828,
    "place_name":"Bourbah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2828,
    "place_name":"Warrumbungle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2828,
    "place_name":"Gulargambone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2828,
    "place_name":"Quanda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2828,
    "place_name":"Mount Tenandra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Gilgooma",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Gungalman",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Pine Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Combara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Nebea",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Teridgerie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Billeroy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Tooloon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Magometon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Conimbia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Coonamble",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Urawilkie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2829,
    "place_name":"Wingadee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Dubbo West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Minore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Mogriguy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Brocklehurst",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Ballimore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Muronbung",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Terramungamine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Goonoo Forest",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Rawsonville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Dubbo Grove",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Dubbo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Dubbo East",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Kickabil",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Dubbo DC",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Toongi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2830,
    "place_name":"Wambangalang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Wongarbon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Goodooga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Neilrex",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Girilambone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Quambone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"The Marra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Merrygoen",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Hermidale",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Armatree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Nevertire",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Elong Elong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Macquarie Marshes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Balladoran",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Tooraweenah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Nymagee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Carinda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Eumungerie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Byrock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2831,
    "place_name":"Coolabah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2832,
    "place_name":"Come By Chance",
    "state_name":"New South Wales"
  },
  {
    "postcode":2832,
    "place_name":"Cryon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2832,
    "place_name":"Cumborah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2832,
    "place_name":"Walgett",
    "state_name":"New South Wales"
  },
  {
    "postcode":2833,
    "place_name":"Collarenebri",
    "state_name":"New South Wales"
  },
  {
    "postcode":2834,
    "place_name":"Angledool",
    "state_name":"New South Wales"
  },
  {
    "postcode":2834,
    "place_name":"Lightning Ridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2835,
    "place_name":"Cobar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2835,
    "place_name":"Bulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2835,
    "place_name":"Irymple",
    "state_name":"New South Wales"
  },
  {
    "postcode":2835,
    "place_name":"Gilgunnia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2835,
    "place_name":"Canbelego",
    "state_name":"New South Wales"
  },
  {
    "postcode":2835,
    "place_name":"Kerrigundi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2835,
    "place_name":"Tindarey",
    "state_name":"New South Wales"
  },
  {
    "postcode":2835,
    "place_name":"Noona",
    "state_name":"New South Wales"
  },
  {
    "postcode":2835,
    "place_name":"Cubba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2835,
    "place_name":"Kulwin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2835,
    "place_name":"Sandy Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2836,
    "place_name":"White Cliffs",
    "state_name":"New South Wales"
  },
  {
    "postcode":2836,
    "place_name":"Wilcannia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2838,
    "place_name":"Goodooga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2839,
    "place_name":"Narran Lake",
    "state_name":"New South Wales"
  },
  {
    "postcode":2839,
    "place_name":"Collerina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2839,
    "place_name":"Talawanta",
    "state_name":"New South Wales"
  },
  {
    "postcode":2839,
    "place_name":"Gongolgon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2839,
    "place_name":"Weilmoringle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2839,
    "place_name":"Brewarrina",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Enngonia",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Hungerford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Louth",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Bourke",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Yantabulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Barringun",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Fords Bridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"North Bourke",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Wanaaring",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Urisino",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Gunderbooka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Tilpa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2840,
    "place_name":"Gumbalie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2842,
    "place_name":"Mendooran",
    "state_name":"New South Wales"
  },
  {
    "postcode":2842,
    "place_name":"Yarragrin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2842,
    "place_name":"New Mollyan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2842,
    "place_name":"Mollyan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2843,
    "place_name":"Coolah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2844,
    "place_name":"Leadville",
    "state_name":"New South Wales"
  },
  {
    "postcode":2844,
    "place_name":"Birriwa",
    "state_name":"New South Wales"
  },
  {
    "postcode":2844,
    "place_name":"Cobbora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2844,
    "place_name":"Dunedoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2845,
    "place_name":"Wallerawang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2846,
    "place_name":"Glen Davis",
    "state_name":"New South Wales"
  },
  {
    "postcode":2846,
    "place_name":"Round Swamp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2846,
    "place_name":"Capertee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2847,
    "place_name":"Pipers Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2847,
    "place_name":"Portland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2848,
    "place_name":"Clandulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2848,
    "place_name":"Brogans Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2848,
    "place_name":"Kandos",
    "state_name":"New South Wales"
  },
  {
    "postcode":2848,
    "place_name":"Charbon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Upper Bylong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Bylong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Budden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Lee Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Ginghi",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Coggan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Bogee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Dungeree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Camboon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Wirraba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Breakfast Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Mount Marsden",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Rylstone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Upper Nile",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Olinda",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Kelgoola",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Pinnacle Swamp",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Coxs Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Dunville Loop",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Coxs Crown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Murrumbo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Dabee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Growee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Pyangle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Glen Alice",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Reedy Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Nullo Mountain",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Upper Growee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2849,
    "place_name":"Carwell",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Mogo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Turill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Lue",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Wilbetree",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Bombira",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Stony Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Apple Tree Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Ulan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Wollar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Twelve Mile",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Bara",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Hayes Gap",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Mudgee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Windeyer",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Pyramul",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Cross Roads",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Cooyal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Running Stream",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Caerleon",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Home Rule",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Collingwood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Sallys Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Aarons Pass",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Ullamalla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Avisford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Ilford",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Putta Bucca",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Mullamuddy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Budgee Budgee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Erudgere",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Hargraves",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Maitland Bar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Barigan",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Piambong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Menah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Milroy",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Mount Frome",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Munghorn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Yarrawonga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Canadian Lead",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Tambaroora",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Meroo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Cullenbone",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Eurunderee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Buckaroo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Triamble",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Grattai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Monivae",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Bocoble",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Spring Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Linburn",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Worlds End",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Kains Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Tichular",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Yarrabin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Galambine",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Cudgegong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"St Fillans",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Mount Knowles",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Carcalgong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Hill End",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Cumbo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Moolarben",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Green Gully",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Havilah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Queens Pinch",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Riverlea",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Frog Rock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Wilpinjong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Botobolar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Burrundulla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Totnes Valley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2850,
    "place_name":"Cooks Gap",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Stubbo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Bungaba",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Guntawang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Two Mile Flat",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Beryl",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Barneys Reef",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Mebul",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Gulgong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Tallawang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Cope",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Goolma",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Cumbandry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2852,
    "place_name":"Merotherie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2864,
    "place_name":"Murga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2864,
    "place_name":"Cudal",
    "state_name":"New South Wales"
  },
  {
    "postcode":2864,
    "place_name":"Bowan Park",
    "state_name":"New South Wales"
  },
  {
    "postcode":2864,
    "place_name":"Toogong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2865,
    "place_name":"Gumble",
    "state_name":"New South Wales"
  },
  {
    "postcode":2865,
    "place_name":"Bocobra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2865,
    "place_name":"Manildra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2866,
    "place_name":"Amaroo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2866,
    "place_name":"Boomey",
    "state_name":"New South Wales"
  },
  {
    "postcode":2866,
    "place_name":"Molong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2866,
    "place_name":"Euchareena",
    "state_name":"New South Wales"
  },
  {
    "postcode":2866,
    "place_name":"Garra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2866,
    "place_name":"Larras Lee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2866,
    "place_name":"Cundumbul",
    "state_name":"New South Wales"
  },
  {
    "postcode":2867,
    "place_name":"Baldry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2867,
    "place_name":"Loombah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2867,
    "place_name":"Cumnock",
    "state_name":"New South Wales"
  },
  {
    "postcode":2867,
    "place_name":"Yullundry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2867,
    "place_name":"Eurimbla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2868,
    "place_name":"Obley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2868,
    "place_name":"North Yeoval",
    "state_name":"New South Wales"
  },
  {
    "postcode":2868,
    "place_name":"Yeoval",
    "state_name":"New South Wales"
  },
  {
    "postcode":2868,
    "place_name":"Bournewood",
    "state_name":"New South Wales"
  },
  {
    "postcode":2869,
    "place_name":"Trewilga",
    "state_name":"New South Wales"
  },
  {
    "postcode":2869,
    "place_name":"Tomingley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2869,
    "place_name":"Peak Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2870,
    "place_name":"Goonumbla",
    "state_name":"New South Wales"
  },
  {
    "postcode":2870,
    "place_name":"Cooks Myalls",
    "state_name":"New South Wales"
  },
  {
    "postcode":2870,
    "place_name":"Cookamidgera",
    "state_name":"New South Wales"
  },
  {
    "postcode":2870,
    "place_name":"Alectown",
    "state_name":"New South Wales"
  },
  {
    "postcode":2870,
    "place_name":"Mandagery",
    "state_name":"New South Wales"
  },
  {
    "postcode":2870,
    "place_name":"Daroobalgie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2870,
    "place_name":"Parkes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2870,
    "place_name":"Bumberry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2870,
    "place_name":"Tichborne",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Bedgerebong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Forbes",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Ooma",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Bedgerabong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Fairholme",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Warroo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Paytens Bridge",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Gunning Gap",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Wirrinya",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Corinella",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Jemalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Mulyandry",
    "state_name":"New South Wales"
  },
  {
    "postcode":2871,
    "place_name":"Garema",
    "state_name":"New South Wales"
  },
  {
    "postcode":2873,
    "place_name":"Albert",
    "state_name":"New South Wales"
  },
  {
    "postcode":2873,
    "place_name":"Tottenham",
    "state_name":"New South Wales"
  },
  {
    "postcode":2873,
    "place_name":"Miamley",
    "state_name":"New South Wales"
  },
  {
    "postcode":2873,
    "place_name":"Five Ways",
    "state_name":"New South Wales"
  },
  {
    "postcode":2874,
    "place_name":"Tullamore",
    "state_name":"New South Wales"
  },
  {
    "postcode":2875,
    "place_name":"Bruie Plains",
    "state_name":"New South Wales"
  },
  {
    "postcode":2875,
    "place_name":"Trundle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2875,
    "place_name":"Yarrabandai",
    "state_name":"New South Wales"
  },
  {
    "postcode":2875,
    "place_name":"Ootha",
    "state_name":"New South Wales"
  },
  {
    "postcode":2875,
    "place_name":"Fifield",
    "state_name":"New South Wales"
  },
  {
    "postcode":2876,
    "place_name":"Bogan Gate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2876,
    "place_name":"Nelungaloo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2876,
    "place_name":"Gunningbland",
    "state_name":"New South Wales"
  },
  {
    "postcode":2877,
    "place_name":"Bobadah",
    "state_name":"New South Wales"
  },
  {
    "postcode":2877,
    "place_name":"Euabalong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2877,
    "place_name":"Eremerang",
    "state_name":"New South Wales"
  },
  {
    "postcode":2877,
    "place_name":"Condobolin",
    "state_name":"New South Wales"
  },
  {
    "postcode":2877,
    "place_name":"Mulguthrie",
    "state_name":"New South Wales"
  },
  {
    "postcode":2877,
    "place_name":"Boona Mount",
    "state_name":"New South Wales"
  },
  {
    "postcode":2877,
    "place_name":"Mount Hope",
    "state_name":"New South Wales"
  },
  {
    "postcode":2877,
    "place_name":"Euabalong West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2877,
    "place_name":"Derriwong",
    "state_name":"New South Wales"
  },
  {
    "postcode":2877,
    "place_name":"Kiacatoo",
    "state_name":"New South Wales"
  },
  {
    "postcode":2878,
    "place_name":"Ivanhoe",
    "state_name":"New South Wales"
  },
  {
    "postcode":2878,
    "place_name":"Trida",
    "state_name":"New South Wales"
  },
  {
    "postcode":2878,
    "place_name":"Mossgiel",
    "state_name":"New South Wales"
  },
  {
    "postcode":2878,
    "place_name":"Conoble",
    "state_name":"New South Wales"
  },
  {
    "postcode":2879,
    "place_name":"Menindee",
    "state_name":"New South Wales"
  },
  {
    "postcode":2879,
    "place_name":"Sunset Strip",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"Broken Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"Broken Hill West",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"Milparinka",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"Broken Hill North",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"South Broken Hill",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"Silverton",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"Packsaddle",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"Broughams Gate",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"Mutawintji",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"Tibooburra",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"Little Topar",
    "state_name":"New South Wales"
  },
  {
    "postcode":2880,
    "place_name":"Fowlers Gap",
    "state_name":"New South Wales"
  },
  {
    "postcode":2890,
    "place_name":"Australian Defence Forces",
    "state_name":"New South Wales"
  },
  {
    "postcode":2891,
    "place_name":"International Mc",
    "state_name":"New South Wales"
  },
  {
    "postcode":2898,
    "place_name":"Lord Howe Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":2899,
    "place_name":"Norfolk Island",
    "state_name":"New South Wales"
  },
  {
    "postcode":3500,
    "place_name":"Paringi",
    "state_name":"New South Wales"
  },
  {
    "postcode":3644,
    "place_name":"Barooga",
    "state_name":"New South Wales"
  },
  {
    "postcode":3644,
    "place_name":"Lalalty",
    "state_name":"New South Wales"
  },
  {
    "postcode":3691,
    "place_name":"Lake Hume Village",
    "state_name":"New South Wales"
  },
  {
    "postcode":3707,
    "place_name":"Bringenbrong",
    "state_name":"New South Wales"
  },
  {
    "postcode":4377,
    "place_name":"Maryland",
    "state_name":"New South Wales"
  },
  {
    "postcode":4380,
    "place_name":"Mingoola",
    "state_name":"New South Wales"
  },
  {
    "postcode":4380,
    "place_name":"Amosfield",
    "state_name":"New South Wales"
  },
  {
    "postcode":4380,
    "place_name":"Ruby Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":4380,
    "place_name":"Undercliffe",
    "state_name":"New South Wales"
  },
  {
    "postcode":4383,
    "place_name":"Jennings",
    "state_name":"New South Wales"
  },
  {
    "postcode":4385,
    "place_name":"Camp Creek",
    "state_name":"New South Wales"
  },
  {
    "postcode":800,
    "place_name":"Darwin",
    "state_name":"Northern Territory"
  },
  {
    "postcode":801,
    "place_name":"Darwin",
    "state_name":"Northern Territory"
  },
  {
    "postcode":803,
    "place_name":"Wagait Beach",
    "state_name":"Northern Territory"
  },
  {
    "postcode":804,
    "place_name":"Parap",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Casuarina",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Tiwi",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Lyons",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Nightcliff",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Brinkin",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Moil",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Millner",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Jingili",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Rapid Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Alawa",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Muirhead",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Nakara",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Wagaman",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Coconut Grove",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Wanguri",
    "state_name":"Northern Territory"
  },
  {
    "postcode":810,
    "place_name":"Lee Point",
    "state_name":"Northern Territory"
  },
  {
    "postcode":811,
    "place_name":"Casuarina",
    "state_name":"Northern Territory"
  },
  {
    "postcode":812,
    "place_name":"Sanderson",
    "state_name":"Northern Territory"
  },
  {
    "postcode":812,
    "place_name":"Marrara",
    "state_name":"Northern Territory"
  },
  {
    "postcode":812,
    "place_name":"Leanyer",
    "state_name":"Northern Territory"
  },
  {
    "postcode":812,
    "place_name":"Anula",
    "state_name":"Northern Territory"
  },
  {
    "postcode":812,
    "place_name":"Woodleigh Gardens",
    "state_name":"Northern Territory"
  },
  {
    "postcode":812,
    "place_name":"Malak",
    "state_name":"Northern Territory"
  },
  {
    "postcode":812,
    "place_name":"Buffalo Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":812,
    "place_name":"Holmes",
    "state_name":"Northern Territory"
  },
  {
    "postcode":812,
    "place_name":"Karama",
    "state_name":"Northern Territory"
  },
  {
    "postcode":812,
    "place_name":"Wulagi",
    "state_name":"Northern Territory"
  },
  {
    "postcode":813,
    "place_name":"Sanderson",
    "state_name":"Northern Territory"
  },
  {
    "postcode":813,
    "place_name":"Karama",
    "state_name":"Northern Territory"
  },
  {
    "postcode":814,
    "place_name":"Nightcliff",
    "state_name":"Northern Territory"
  },
  {
    "postcode":815,
    "place_name":"Charles Darwin University",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Winnellie",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"East Point",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Bagot",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Charles Darwin",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Darwin DC",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Coonawarra",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Stuart Park",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Ludmilla",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Darwin International Airport",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Fannie Bay",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"The Gardens",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Larrakeyah",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Eaton",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Bayview",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Woolner",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"Parap",
    "state_name":"Northern Territory"
  },
  {
    "postcode":820,
    "place_name":"The Narrows",
    "state_name":"Northern Territory"
  },
  {
    "postcode":821,
    "place_name":"Winnellie",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Milyakburra",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Blackmore",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Murrumujuk",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Maningrida",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Nganmarriyanga",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Gunbalanya",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Tiwi Islands",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Coomalie Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Darwin River Dam",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Acacia Hills",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Charles Darwin",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Anindilyakwa",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Daly River",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Lloyd Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Mandorah",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Thamarrurr",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"East Arnhem",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Wickham",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Numbulwar",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Darwin Mc",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Nauiyu",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Tumbling Waters",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Kakadu",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Bathurst Island",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Wadeye",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Hughes",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Marrakai",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Delissaville",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Pularumpi",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Pirlangimpi",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Croker Island",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Peppimenarti",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Douglas-Daly",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Numburindi",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Litchfield Park",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Wurrumiyanga",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Nemarluk",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"West Arnhem",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Umbakumba",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Charlotte",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Hidden Valley",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Southport",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Bynoe Harbour",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Warruwi",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Angurugu",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Cox Peninsula",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Bynoe",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Black Jungle",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Weddell",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Fly Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Claravale",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Goulburn Island",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Mcminns Lagoon",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Lambells Lagoon",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"East Arm",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Bees Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Finniss Valley",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Livingstone",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Tipperary",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Annie River",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Tortilla Flats",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Burrundie",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Tivendale",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Nguiu",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Vernon Islands",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Minjilang",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Stapleton",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Oenpelli",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Rakula",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Galiwinku",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Robin Falls",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Channel Island",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Wak Wak",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Milingimbi",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Glyde Point",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Camp Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Eva Valley",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Winnellie",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Daly",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Hotham",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Hayes Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Ramingining",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Mapuru",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Freds Pass",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Middle Point",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Koolpinyah",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Wagait Beach",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Mickett Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Point Stephens",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Belyuen",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Margaret River",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Woolaning",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Wishart",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Collett Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Maranunga",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Milikapiti",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Lake Bennett",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Cobourg",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Fleming",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Sandpalms Roadhouse",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Gunn Point",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Point Stuart",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Mount Bundey",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Rum Jungle",
    "state_name":"Northern Territory"
  },
  {
    "postcode":822,
    "place_name":"Elrundie",
    "state_name":"Northern Territory"
  },
  {
    "postcode":828,
    "place_name":"Berrimah",
    "state_name":"Northern Territory"
  },
  {
    "postcode":828,
    "place_name":"Knuckey Lagoon",
    "state_name":"Northern Territory"
  },
  {
    "postcode":829,
    "place_name":"Pinelands",
    "state_name":"Northern Territory"
  },
  {
    "postcode":829,
    "place_name":"Holtze",
    "state_name":"Northern Territory"
  },
  {
    "postcode":830,
    "place_name":"Driver",
    "state_name":"Northern Territory"
  },
  {
    "postcode":830,
    "place_name":"Archer",
    "state_name":"Northern Territory"
  },
  {
    "postcode":830,
    "place_name":"Shoal Bay",
    "state_name":"Northern Territory"
  },
  {
    "postcode":830,
    "place_name":"Marlow Lagoon",
    "state_name":"Northern Territory"
  },
  {
    "postcode":830,
    "place_name":"Farrar",
    "state_name":"Northern Territory"
  },
  {
    "postcode":830,
    "place_name":"Durack",
    "state_name":"Northern Territory"
  },
  {
    "postcode":830,
    "place_name":"Palmerston",
    "state_name":"Northern Territory"
  },
  {
    "postcode":830,
    "place_name":"Gray",
    "state_name":"Northern Territory"
  },
  {
    "postcode":830,
    "place_name":"Woodroffe",
    "state_name":"Northern Territory"
  },
  {
    "postcode":830,
    "place_name":"Moulden",
    "state_name":"Northern Territory"
  },
  {
    "postcode":830,
    "place_name":"Yarrawonga",
    "state_name":"Northern Territory"
  },
  {
    "postcode":831,
    "place_name":"Palmerston",
    "state_name":"Northern Territory"
  },
  {
    "postcode":832,
    "place_name":"Zuccoli",
    "state_name":"Northern Territory"
  },
  {
    "postcode":832,
    "place_name":"Bakewell",
    "state_name":"Northern Territory"
  },
  {
    "postcode":832,
    "place_name":"Johnston",
    "state_name":"Northern Territory"
  },
  {
    "postcode":832,
    "place_name":"Gunn",
    "state_name":"Northern Territory"
  },
  {
    "postcode":832,
    "place_name":"Rosebery",
    "state_name":"Northern Territory"
  },
  {
    "postcode":832,
    "place_name":"Mitchell",
    "state_name":"Northern Territory"
  },
  {
    "postcode":832,
    "place_name":"Rosebery Heights",
    "state_name":"Northern Territory"
  },
  {
    "postcode":832,
    "place_name":"Bellamack",
    "state_name":"Northern Territory"
  },
  {
    "postcode":834,
    "place_name":"Virginia",
    "state_name":"Northern Territory"
  },
  {
    "postcode":835,
    "place_name":"Coolalinga",
    "state_name":"Northern Territory"
  },
  {
    "postcode":835,
    "place_name":"Howard Springs",
    "state_name":"Northern Territory"
  },
  {
    "postcode":835,
    "place_name":"Virginia",
    "state_name":"Northern Territory"
  },
  {
    "postcode":836,
    "place_name":"Girraween",
    "state_name":"Northern Territory"
  },
  {
    "postcode":836,
    "place_name":"Humpty Doo",
    "state_name":"Northern Territory"
  },
  {
    "postcode":836,
    "place_name":"Herbert",
    "state_name":"Northern Territory"
  },
  {
    "postcode":837,
    "place_name":"Manton",
    "state_name":"Northern Territory"
  },
  {
    "postcode":837,
    "place_name":"Noonamah",
    "state_name":"Northern Territory"
  },
  {
    "postcode":838,
    "place_name":"Berry Springs",
    "state_name":"Northern Territory"
  },
  {
    "postcode":839,
    "place_name":"Coolalinga",
    "state_name":"Northern Territory"
  },
  {
    "postcode":840,
    "place_name":"Dundee Beach",
    "state_name":"Northern Territory"
  },
  {
    "postcode":840,
    "place_name":"Dundee Downs",
    "state_name":"Northern Territory"
  },
  {
    "postcode":840,
    "place_name":"Dundee Forest",
    "state_name":"Northern Territory"
  },
  {
    "postcode":841,
    "place_name":"Darwin River",
    "state_name":"Northern Territory"
  },
  {
    "postcode":845,
    "place_name":"Batchelor",
    "state_name":"Northern Territory"
  },
  {
    "postcode":846,
    "place_name":"Adelaide River",
    "state_name":"Northern Territory"
  },
  {
    "postcode":847,
    "place_name":"Pine Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":850,
    "place_name":"Cossack",
    "state_name":"Northern Territory"
  },
  {
    "postcode":850,
    "place_name":"Katherine",
    "state_name":"Northern Territory"
  },
  {
    "postcode":850,
    "place_name":"Katherine South",
    "state_name":"Northern Territory"
  },
  {
    "postcode":850,
    "place_name":"Lansdowne",
    "state_name":"Northern Territory"
  },
  {
    "postcode":850,
    "place_name":"Emungalan",
    "state_name":"Northern Territory"
  },
  {
    "postcode":850,
    "place_name":"Katherine East",
    "state_name":"Northern Territory"
  },
  {
    "postcode":851,
    "place_name":"Katherine",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Yarralin",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Beswick",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Barunga",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Wave Hill",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Jilkminggan",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Maranboy",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Daguragu",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Wilton",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Numbulwar",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Ngukurr",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Baines",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Uralla",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Gregory",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Victoria River Downs",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Venn",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Timber Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Edith",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Binjari",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Manbulloo",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Top Springs",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Gurindji",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Bulman Weemol",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Kalkarindji",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Limmen",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Birdum",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Arnold",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Elsey",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Bradshaw",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Creswell",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Tanami East",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Delamere",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Lajamanu",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Flying Fox",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Beswick Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Victoria River",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Pellew Islands",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Florina",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Robinson River",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Daly Waters",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Larrimah",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Gulung Mardrulk",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Pigeon Hole",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Miniyeri",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Katherine",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Mataranka",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Helen Springs Station",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Mcarthur",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Buchanan",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Sturt Plateau",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Warumungu",
    "state_name":"Northern Territory"
  },
  {
    "postcode":852,
    "place_name":"Nitmiluk",
    "state_name":"Northern Territory"
  },
  {
    "postcode":853,
    "place_name":"Tindal",
    "state_name":"Northern Territory"
  },
  {
    "postcode":853,
    "place_name":"Tindal Raaf",
    "state_name":"Northern Territory"
  },
  {
    "postcode":854,
    "place_name":"King Ash Bay",
    "state_name":"Northern Territory"
  },
  {
    "postcode":854,
    "place_name":"Borroloola",
    "state_name":"Northern Territory"
  },
  {
    "postcode":860,
    "place_name":"Tennant Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":861,
    "place_name":"Tennant Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":862,
    "place_name":"Warrego",
    "state_name":"Northern Territory"
  },
  {
    "postcode":862,
    "place_name":"Tennant Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":862,
    "place_name":"Newcastle Waters",
    "state_name":"Northern Territory"
  },
  {
    "postcode":862,
    "place_name":"Renner Springs",
    "state_name":"Northern Territory"
  },
  {
    "postcode":862,
    "place_name":"Calvert",
    "state_name":"Northern Territory"
  },
  {
    "postcode":862,
    "place_name":"Tablelands",
    "state_name":"Northern Territory"
  },
  {
    "postcode":862,
    "place_name":"Nicholson",
    "state_name":"Northern Territory"
  },
  {
    "postcode":862,
    "place_name":"Pamayu",
    "state_name":"Northern Territory"
  },
  {
    "postcode":862,
    "place_name":"Elliott",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Stuart",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Ross",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Larapinta",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Araluen",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Mount Johns",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Flynn",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"The Gap",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Sadadeen",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"East Side",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Arumbera",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Connellan",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Alice Springs",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Irlpme",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Ilparpa",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Undoolya",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Gillen",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Ciccone",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"White Gums",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Braitling",
    "state_name":"Northern Territory"
  },
  {
    "postcode":870,
    "place_name":"Desert Springs",
    "state_name":"Northern Territory"
  },
  {
    "postcode":871,
    "place_name":"Alice Springs",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Ampilatwatja",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Wilora",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Barrow Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Hale",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Laramba",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Ali Curung",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Wallace Rockhole",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Yuendumu",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Papunya",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Tara",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Davenport",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Kulgera",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Anmatjere",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Wutunugurra",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Namatjira",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Canteen Creek",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Hart",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Burt Plain",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Napperby Station",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Engawala",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Atitjere",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Nyirripi",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Imanpa",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Sandover",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Finke",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Tanami",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Santa Teresa",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Mutitjulu",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Anatye",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Costello",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Erldunda",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Chilla Well",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Alice Springs",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Titjikala",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Areyonga",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Willowra",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Hart Range",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Yuelamu",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Ti Tree",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Yulara",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Haasts Bluff",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Mereenie",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Mount Zeil",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Kaltukatjara",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Hermannsburg",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Kings Creek Station",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Kintore",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Hugh",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Telegraph Station",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Lake Mackay",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Ininti Store",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Macdonnell Range",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Simpson",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Mount Liebig",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Ghan",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Kunparrka",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Amoonguna",
    "state_name":"Northern Territory"
  },
  {
    "postcode":872,
    "place_name":"Petermann",
    "state_name":"Northern Territory"
  },
  {
    "postcode":873,
    "place_name":"Heavitree Gap Cpa",
    "state_name":"Northern Territory"
  },
  {
    "postcode":880,
    "place_name":"Nhulunbuy",
    "state_name":"Northern Territory"
  },
  {
    "postcode":880,
    "place_name":"Yirrkala",
    "state_name":"Northern Territory"
  },
  {
    "postcode":880,
    "place_name":"Gapuwiyak",
    "state_name":"Northern Territory"
  },
  {
    "postcode":880,
    "place_name":"Gunyangara",
    "state_name":"Northern Territory"
  },
  {
    "postcode":881,
    "place_name":"Nhulunbuy",
    "state_name":"Northern Territory"
  },
  {
    "postcode":885,
    "place_name":"Alyangula",
    "state_name":"Northern Territory"
  },
  {
    "postcode":886,
    "place_name":"Jabiru",
    "state_name":"Northern Territory"
  },
  {
    "postcode":906,
    "place_name":"Winnellie",
    "state_name":"Northern Territory"
  },
  {
    "postcode":907,
    "place_name":"Winnellie",
    "state_name":"Northern Territory"
  },
  {
    "postcode":909,
    "place_name":"Charles Darwin University",
    "state_name":"Northern Territory"
  },
  {
    "postcode":4825,
    "place_name":"Alpurrurulam",
    "state_name":"Northern Territory"
  },
  {
    "postcode":4000,
    "place_name":"Brisbane City",
    "state_name":"Queensland"
  },
  {
    "postcode":4000,
    "place_name":"Brisbane Adelaide Street",
    "state_name":"Queensland"
  },
  {
    "postcode":4000,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":4000,
    "place_name":"Petrie Terrace",
    "state_name":"Queensland"
  },
  {
    "postcode":4000,
    "place_name":"Spring Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4000,
    "place_name":"Brisbane GPO",
    "state_name":"Queensland"
  },
  {
    "postcode":4001,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":4001,
    "place_name":"Central Plaza",
    "state_name":"Queensland"
  },
  {
    "postcode":4001,
    "place_name":"Riverside Centre",
    "state_name":"Queensland"
  },
  {
    "postcode":4001,
    "place_name":"Waterfront Place",
    "state_name":"Queensland"
  },
  {
    "postcode":4002,
    "place_name":"City East",
    "state_name":"Queensland"
  },
  {
    "postcode":4002,
    "place_name":"Wintergarden",
    "state_name":"Queensland"
  },
  {
    "postcode":4003,
    "place_name":"George Street",
    "state_name":"Queensland"
  },
  {
    "postcode":4004,
    "place_name":"Spring Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4005,
    "place_name":"New Farm",
    "state_name":"Queensland"
  },
  {
    "postcode":4005,
    "place_name":"Teneriffe",
    "state_name":"Queensland"
  },
  {
    "postcode":4006,
    "place_name":"Newstead",
    "state_name":"Queensland"
  },
  {
    "postcode":4006,
    "place_name":"Fortitude Valley BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4006,
    "place_name":"Bowen Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4006,
    "place_name":"Herston",
    "state_name":"Queensland"
  },
  {
    "postcode":4006,
    "place_name":"Fortitude Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4007,
    "place_name":"Hamilton",
    "state_name":"Queensland"
  },
  {
    "postcode":4007,
    "place_name":"Ascot",
    "state_name":"Queensland"
  },
  {
    "postcode":4007,
    "place_name":"Hamilton Central",
    "state_name":"Queensland"
  },
  {
    "postcode":4008,
    "place_name":"Pinkenba",
    "state_name":"Queensland"
  },
  {
    "postcode":4008,
    "place_name":"Brisbane Airport",
    "state_name":"Queensland"
  },
  {
    "postcode":4009,
    "place_name":"Eagle Farm BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4009,
    "place_name":"Eagle Farm",
    "state_name":"Queensland"
  },
  {
    "postcode":4010,
    "place_name":"Albion DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4010,
    "place_name":"Albion",
    "state_name":"Queensland"
  },
  {
    "postcode":4010,
    "place_name":"Albion BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4011,
    "place_name":"Clayfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4011,
    "place_name":"Hendra",
    "state_name":"Queensland"
  },
  {
    "postcode":4012,
    "place_name":"Nundah",
    "state_name":"Queensland"
  },
  {
    "postcode":4012,
    "place_name":"Wavell Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4012,
    "place_name":"Toombul",
    "state_name":"Queensland"
  },
  {
    "postcode":4012,
    "place_name":"Wavell Heights North",
    "state_name":"Queensland"
  },
  {
    "postcode":4013,
    "place_name":"Northgate",
    "state_name":"Queensland"
  },
  {
    "postcode":4014,
    "place_name":"Nudgee Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4014,
    "place_name":"Banyo",
    "state_name":"Queensland"
  },
  {
    "postcode":4014,
    "place_name":"Virginia",
    "state_name":"Queensland"
  },
  {
    "postcode":4014,
    "place_name":"Virginia BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4014,
    "place_name":"Nudgee",
    "state_name":"Queensland"
  },
  {
    "postcode":4014,
    "place_name":"Virginia DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4017,
    "place_name":"Brighton",
    "state_name":"Queensland"
  },
  {
    "postcode":4017,
    "place_name":"Brighton Nathan Street",
    "state_name":"Queensland"
  },
  {
    "postcode":4017,
    "place_name":"Deagon",
    "state_name":"Queensland"
  },
  {
    "postcode":4017,
    "place_name":"Sandgate",
    "state_name":"Queensland"
  },
  {
    "postcode":4017,
    "place_name":"Shorncliffe",
    "state_name":"Queensland"
  },
  {
    "postcode":4017,
    "place_name":"Brighton Eventide",
    "state_name":"Queensland"
  },
  {
    "postcode":4017,
    "place_name":"Bracken Ridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4017,
    "place_name":"Sandgate DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4018,
    "place_name":"Taigum",
    "state_name":"Queensland"
  },
  {
    "postcode":4018,
    "place_name":"Fitzgibbon",
    "state_name":"Queensland"
  },
  {
    "postcode":4019,
    "place_name":"Woody Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4019,
    "place_name":"Margate",
    "state_name":"Queensland"
  },
  {
    "postcode":4019,
    "place_name":"Margate Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4019,
    "place_name":"Clontarf",
    "state_name":"Queensland"
  },
  {
    "postcode":4019,
    "place_name":"Clontarf DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4019,
    "place_name":"Clontarf Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4020,
    "place_name":"Newport",
    "state_name":"Queensland"
  },
  {
    "postcode":4020,
    "place_name":"Redcliffe North",
    "state_name":"Queensland"
  },
  {
    "postcode":4020,
    "place_name":"Scarborough",
    "state_name":"Queensland"
  },
  {
    "postcode":4020,
    "place_name":"Redcliffe",
    "state_name":"Queensland"
  },
  {
    "postcode":4021,
    "place_name":"Kippa-Ring",
    "state_name":"Queensland"
  },
  {
    "postcode":4022,
    "place_name":"Rothwell",
    "state_name":"Queensland"
  },
  {
    "postcode":4025,
    "place_name":"Tangalooma",
    "state_name":"Queensland"
  },
  {
    "postcode":4025,
    "place_name":"Cape Moreton",
    "state_name":"Queensland"
  },
  {
    "postcode":4025,
    "place_name":"Cowan Cowan",
    "state_name":"Queensland"
  },
  {
    "postcode":4025,
    "place_name":"Bulwer",
    "state_name":"Queensland"
  },
  {
    "postcode":4025,
    "place_name":"Kooringal",
    "state_name":"Queensland"
  },
  {
    "postcode":4029,
    "place_name":"Royal Brisbane Hospital",
    "state_name":"Queensland"
  },
  {
    "postcode":4030,
    "place_name":"Wooloowin",
    "state_name":"Queensland"
  },
  {
    "postcode":4030,
    "place_name":"Lutwyche",
    "state_name":"Queensland"
  },
  {
    "postcode":4030,
    "place_name":"Windsor",
    "state_name":"Queensland"
  },
  {
    "postcode":4031,
    "place_name":"Kedron",
    "state_name":"Queensland"
  },
  {
    "postcode":4031,
    "place_name":"Gordon Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4032,
    "place_name":"Chermside West",
    "state_name":"Queensland"
  },
  {
    "postcode":4032,
    "place_name":"Chermside",
    "state_name":"Queensland"
  },
  {
    "postcode":4032,
    "place_name":"Chermside Centre",
    "state_name":"Queensland"
  },
  {
    "postcode":4032,
    "place_name":"Chermside South",
    "state_name":"Queensland"
  },
  {
    "postcode":4034,
    "place_name":"Carseldine",
    "state_name":"Queensland"
  },
  {
    "postcode":4034,
    "place_name":"Boondall",
    "state_name":"Queensland"
  },
  {
    "postcode":4034,
    "place_name":"Aspley",
    "state_name":"Queensland"
  },
  {
    "postcode":4034,
    "place_name":"Zillmere",
    "state_name":"Queensland"
  },
  {
    "postcode":4034,
    "place_name":"Geebung",
    "state_name":"Queensland"
  },
  {
    "postcode":4035,
    "place_name":"Albany Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4035,
    "place_name":"Bridgeman Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4036,
    "place_name":"Bald Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4037,
    "place_name":"Eatons Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4051,
    "place_name":"Enoggera",
    "state_name":"Queensland"
  },
  {
    "postcode":4051,
    "place_name":"Grange",
    "state_name":"Queensland"
  },
  {
    "postcode":4051,
    "place_name":"Newmarket",
    "state_name":"Queensland"
  },
  {
    "postcode":4051,
    "place_name":"Gaythorne",
    "state_name":"Queensland"
  },
  {
    "postcode":4051,
    "place_name":"Alderley",
    "state_name":"Queensland"
  },
  {
    "postcode":4051,
    "place_name":"Wilston",
    "state_name":"Queensland"
  },
  {
    "postcode":4053,
    "place_name":"Everton Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4053,
    "place_name":"Brookside Centre",
    "state_name":"Queensland"
  },
  {
    "postcode":4053,
    "place_name":"Mitchelton",
    "state_name":"Queensland"
  },
  {
    "postcode":4053,
    "place_name":"Stafford DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4053,
    "place_name":"Mcdowall",
    "state_name":"Queensland"
  },
  {
    "postcode":4053,
    "place_name":"Stafford Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4053,
    "place_name":"Stafford",
    "state_name":"Queensland"
  },
  {
    "postcode":4053,
    "place_name":"Everton Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4054,
    "place_name":"Arana Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4054,
    "place_name":"Keperra",
    "state_name":"Queensland"
  },
  {
    "postcode":4055,
    "place_name":"Ferny Grove",
    "state_name":"Queensland"
  },
  {
    "postcode":4055,
    "place_name":"Bunya",
    "state_name":"Queensland"
  },
  {
    "postcode":4055,
    "place_name":"Ferny Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4055,
    "place_name":"Ferny Hills DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4055,
    "place_name":"Upper Kedron",
    "state_name":"Queensland"
  },
  {
    "postcode":4059,
    "place_name":"Red Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4059,
    "place_name":"Kelvin Grove Bc",
    "state_name":"Queensland"
  },
  {
    "postcode":4059,
    "place_name":"Kelvin Grove",
    "state_name":"Queensland"
  },
  {
    "postcode":4059,
    "place_name":"Kelvin Grove Dc",
    "state_name":"Queensland"
  },
  {
    "postcode":4060,
    "place_name":"Ashgrove",
    "state_name":"Queensland"
  },
  {
    "postcode":4060,
    "place_name":"Ashgrove East",
    "state_name":"Queensland"
  },
  {
    "postcode":4060,
    "place_name":"Dorrington",
    "state_name":"Queensland"
  },
  {
    "postcode":4061,
    "place_name":"The Gap",
    "state_name":"Queensland"
  },
  {
    "postcode":4064,
    "place_name":"Milton",
    "state_name":"Queensland"
  },
  {
    "postcode":4064,
    "place_name":"Milton BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4064,
    "place_name":"Paddington",
    "state_name":"Queensland"
  },
  {
    "postcode":4065,
    "place_name":"Bardon",
    "state_name":"Queensland"
  },
  {
    "postcode":4066,
    "place_name":"Toowong",
    "state_name":"Queensland"
  },
  {
    "postcode":4066,
    "place_name":"Toowong DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4066,
    "place_name":"Toowong BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4066,
    "place_name":"Mount Coot-Tha",
    "state_name":"Queensland"
  },
  {
    "postcode":4066,
    "place_name":"Auchenflower",
    "state_name":"Queensland"
  },
  {
    "postcode":4067,
    "place_name":"St Lucia",
    "state_name":"Queensland"
  },
  {
    "postcode":4067,
    "place_name":"St Lucia South",
    "state_name":"Queensland"
  },
  {
    "postcode":4068,
    "place_name":"Chelmer",
    "state_name":"Queensland"
  },
  {
    "postcode":4068,
    "place_name":"Indooroopilly",
    "state_name":"Queensland"
  },
  {
    "postcode":4068,
    "place_name":"Indooroopilly Centre",
    "state_name":"Queensland"
  },
  {
    "postcode":4068,
    "place_name":"Taringa",
    "state_name":"Queensland"
  },
  {
    "postcode":4069,
    "place_name":"Upper Brookfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4069,
    "place_name":"Pullenvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4069,
    "place_name":"Brookfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4069,
    "place_name":"Kenmore DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4069,
    "place_name":"Chapel Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4069,
    "place_name":"Fig Tree Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4069,
    "place_name":"Kenmore",
    "state_name":"Queensland"
  },
  {
    "postcode":4069,
    "place_name":"Pinjarra Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4069,
    "place_name":"Kenmore East",
    "state_name":"Queensland"
  },
  {
    "postcode":4069,
    "place_name":"Kenmore Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4070,
    "place_name":"Anstead",
    "state_name":"Queensland"
  },
  {
    "postcode":4070,
    "place_name":"Moggill",
    "state_name":"Queensland"
  },
  {
    "postcode":4070,
    "place_name":"Bellbowrie",
    "state_name":"Queensland"
  },
  {
    "postcode":4072,
    "place_name":"University Of Queensland",
    "state_name":"Queensland"
  },
  {
    "postcode":4073,
    "place_name":"Seventeen Mile Rocks",
    "state_name":"Queensland"
  },
  {
    "postcode":4073,
    "place_name":"Sinnamon Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4074,
    "place_name":"Sumner",
    "state_name":"Queensland"
  },
  {
    "postcode":4074,
    "place_name":"Riverhills",
    "state_name":"Queensland"
  },
  {
    "postcode":4074,
    "place_name":"Mount Ommaney",
    "state_name":"Queensland"
  },
  {
    "postcode":4074,
    "place_name":"Jindalee",
    "state_name":"Queensland"
  },
  {
    "postcode":4074,
    "place_name":"Westlake",
    "state_name":"Queensland"
  },
  {
    "postcode":4074,
    "place_name":"Jamboree Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4074,
    "place_name":"Sumner Park Bc",
    "state_name":"Queensland"
  },
  {
    "postcode":4074,
    "place_name":"Middle Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4075,
    "place_name":"Sherwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4075,
    "place_name":"Graceville East",
    "state_name":"Queensland"
  },
  {
    "postcode":4075,
    "place_name":"Corinda",
    "state_name":"Queensland"
  },
  {
    "postcode":4075,
    "place_name":"Graceville",
    "state_name":"Queensland"
  },
  {
    "postcode":4075,
    "place_name":"Oxley",
    "state_name":"Queensland"
  },
  {
    "postcode":4076,
    "place_name":"Darra",
    "state_name":"Queensland"
  },
  {
    "postcode":4076,
    "place_name":"Wacol",
    "state_name":"Queensland"
  },
  {
    "postcode":4077,
    "place_name":"Inala Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4077,
    "place_name":"Richlands",
    "state_name":"Queensland"
  },
  {
    "postcode":4077,
    "place_name":"Durack",
    "state_name":"Queensland"
  },
  {
    "postcode":4077,
    "place_name":"Inala East",
    "state_name":"Queensland"
  },
  {
    "postcode":4077,
    "place_name":"Doolandella",
    "state_name":"Queensland"
  },
  {
    "postcode":4077,
    "place_name":"Inala",
    "state_name":"Queensland"
  },
  {
    "postcode":4078,
    "place_name":"Ellen Grove",
    "state_name":"Queensland"
  },
  {
    "postcode":4078,
    "place_name":"Forest Lake",
    "state_name":"Queensland"
  },
  {
    "postcode":4101,
    "place_name":"South Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":4101,
    "place_name":"West End",
    "state_name":"Queensland"
  },
  {
    "postcode":4101,
    "place_name":"Highgate Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4101,
    "place_name":"South Brisbane BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4102,
    "place_name":"Woolloongabba",
    "state_name":"Queensland"
  },
  {
    "postcode":4102,
    "place_name":"Dutton Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4102,
    "place_name":"Buranda",
    "state_name":"Queensland"
  },
  {
    "postcode":4103,
    "place_name":"Fairfield Gardens",
    "state_name":"Queensland"
  },
  {
    "postcode":4103,
    "place_name":"Fairfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4103,
    "place_name":"Annerley",
    "state_name":"Queensland"
  },
  {
    "postcode":4104,
    "place_name":"Yeronga",
    "state_name":"Queensland"
  },
  {
    "postcode":4105,
    "place_name":"Tennyson",
    "state_name":"Queensland"
  },
  {
    "postcode":4105,
    "place_name":"Moorooka",
    "state_name":"Queensland"
  },
  {
    "postcode":4105,
    "place_name":"Yeerongpilly",
    "state_name":"Queensland"
  },
  {
    "postcode":4106,
    "place_name":"Brisbane Market",
    "state_name":"Queensland"
  },
  {
    "postcode":4106,
    "place_name":"Rocklea",
    "state_name":"Queensland"
  },
  {
    "postcode":4106,
    "place_name":"Rocklea Dc",
    "state_name":"Queensland"
  },
  {
    "postcode":4107,
    "place_name":"Salisbury",
    "state_name":"Queensland"
  },
  {
    "postcode":4107,
    "place_name":"Salisbury East",
    "state_name":"Queensland"
  },
  {
    "postcode":4108,
    "place_name":"Archerfield BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4108,
    "place_name":"Archerfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4108,
    "place_name":"Coopers Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4109,
    "place_name":"Macgregor",
    "state_name":"Queensland"
  },
  {
    "postcode":4109,
    "place_name":"Robertson",
    "state_name":"Queensland"
  },
  {
    "postcode":4109,
    "place_name":"Sunnybank",
    "state_name":"Queensland"
  },
  {
    "postcode":4109,
    "place_name":"Sunnybank Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4109,
    "place_name":"Sunnybank South",
    "state_name":"Queensland"
  },
  {
    "postcode":4110,
    "place_name":"Willawong",
    "state_name":"Queensland"
  },
  {
    "postcode":4110,
    "place_name":"Larapinta",
    "state_name":"Queensland"
  },
  {
    "postcode":4110,
    "place_name":"Heathwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4110,
    "place_name":"Acacia Ridge Dc",
    "state_name":"Queensland"
  },
  {
    "postcode":4110,
    "place_name":"Acacia Ridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4110,
    "place_name":"Heathwood Df",
    "state_name":"Queensland"
  },
  {
    "postcode":4110,
    "place_name":"Pallara",
    "state_name":"Queensland"
  },
  {
    "postcode":4111,
    "place_name":"Nathan",
    "state_name":"Queensland"
  },
  {
    "postcode":4112,
    "place_name":"Kuraby",
    "state_name":"Queensland"
  },
  {
    "postcode":4113,
    "place_name":"Eight Mile Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4113,
    "place_name":"Runcorn",
    "state_name":"Queensland"
  },
  {
    "postcode":4114,
    "place_name":"Logan City Dc",
    "state_name":"Queensland"
  },
  {
    "postcode":4114,
    "place_name":"Kingston",
    "state_name":"Queensland"
  },
  {
    "postcode":4114,
    "place_name":"Woodridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4114,
    "place_name":"Logan Central",
    "state_name":"Queensland"
  },
  {
    "postcode":4115,
    "place_name":"Algester",
    "state_name":"Queensland"
  },
  {
    "postcode":4115,
    "place_name":"Parkinson",
    "state_name":"Queensland"
  },
  {
    "postcode":4116,
    "place_name":"Stretton",
    "state_name":"Queensland"
  },
  {
    "postcode":4116,
    "place_name":"Calamvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4116,
    "place_name":"Drewvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4117,
    "place_name":"Berrinba",
    "state_name":"Queensland"
  },
  {
    "postcode":4117,
    "place_name":"Karawatha",
    "state_name":"Queensland"
  },
  {
    "postcode":4118,
    "place_name":"Forestdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4118,
    "place_name":"Browns Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4118,
    "place_name":"Regents Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4118,
    "place_name":"Heritage Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4118,
    "place_name":"Hillcrest",
    "state_name":"Queensland"
  },
  {
    "postcode":4119,
    "place_name":"Underwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4120,
    "place_name":"Greenslopes",
    "state_name":"Queensland"
  },
  {
    "postcode":4120,
    "place_name":"Stones Corner",
    "state_name":"Queensland"
  },
  {
    "postcode":4121,
    "place_name":"Holland Park West",
    "state_name":"Queensland"
  },
  {
    "postcode":4121,
    "place_name":"Holland Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4121,
    "place_name":"Tarragindi",
    "state_name":"Queensland"
  },
  {
    "postcode":4121,
    "place_name":"Holland Park East",
    "state_name":"Queensland"
  },
  {
    "postcode":4121,
    "place_name":"Wellers Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4122,
    "place_name":"Upper Mount Gravatt",
    "state_name":"Queensland"
  },
  {
    "postcode":4122,
    "place_name":"Mansfield DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4122,
    "place_name":"Mansfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4122,
    "place_name":"Mount Gravatt",
    "state_name":"Queensland"
  },
  {
    "postcode":4122,
    "place_name":"Wishart",
    "state_name":"Queensland"
  },
  {
    "postcode":4122,
    "place_name":"Upper Mount Gravatt BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4122,
    "place_name":"Mount Gravatt East",
    "state_name":"Queensland"
  },
  {
    "postcode":4122,
    "place_name":"Mansfield BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4123,
    "place_name":"Rochedale",
    "state_name":"Queensland"
  },
  {
    "postcode":4123,
    "place_name":"Rochedale South",
    "state_name":"Queensland"
  },
  {
    "postcode":4124,
    "place_name":"New Beith",
    "state_name":"Queensland"
  },
  {
    "postcode":4124,
    "place_name":"Lyons",
    "state_name":"Queensland"
  },
  {
    "postcode":4124,
    "place_name":"Greenbank",
    "state_name":"Queensland"
  },
  {
    "postcode":4124,
    "place_name":"Boronia Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4124,
    "place_name":"Spring Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4125,
    "place_name":"Park Ridge South",
    "state_name":"Queensland"
  },
  {
    "postcode":4125,
    "place_name":"Munruben",
    "state_name":"Queensland"
  },
  {
    "postcode":4125,
    "place_name":"Park Ridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4127,
    "place_name":"Springwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4127,
    "place_name":"Daisy Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4127,
    "place_name":"Slacks Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4127,
    "place_name":"Priestdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4128,
    "place_name":"Shailer Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4128,
    "place_name":"Tanah Merah",
    "state_name":"Queensland"
  },
  {
    "postcode":4129,
    "place_name":"Loganholme",
    "state_name":"Queensland"
  },
  {
    "postcode":4129,
    "place_name":"Loganholme DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4129,
    "place_name":"Loganholme BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4130,
    "place_name":"Cornubia",
    "state_name":"Queensland"
  },
  {
    "postcode":4130,
    "place_name":"Carbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4131,
    "place_name":"Loganlea",
    "state_name":"Queensland"
  },
  {
    "postcode":4131,
    "place_name":"Meadowbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4132,
    "place_name":"Marsden",
    "state_name":"Queensland"
  },
  {
    "postcode":4132,
    "place_name":"Crestmead",
    "state_name":"Queensland"
  },
  {
    "postcode":4133,
    "place_name":"Waterford West",
    "state_name":"Queensland"
  },
  {
    "postcode":4133,
    "place_name":"Waterford",
    "state_name":"Queensland"
  },
  {
    "postcode":4133,
    "place_name":"Chambers Flat",
    "state_name":"Queensland"
  },
  {
    "postcode":4133,
    "place_name":"Logan Reserve",
    "state_name":"Queensland"
  },
  {
    "postcode":4151,
    "place_name":"Coorparoo DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4151,
    "place_name":"Coorparoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4152,
    "place_name":"Carindale",
    "state_name":"Queensland"
  },
  {
    "postcode":4152,
    "place_name":"Carina",
    "state_name":"Queensland"
  },
  {
    "postcode":4152,
    "place_name":"Carina Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4152,
    "place_name":"Camp Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4153,
    "place_name":"Belmont",
    "state_name":"Queensland"
  },
  {
    "postcode":4154,
    "place_name":"Ransome",
    "state_name":"Queensland"
  },
  {
    "postcode":4154,
    "place_name":"Wakerley",
    "state_name":"Queensland"
  },
  {
    "postcode":4154,
    "place_name":"Gumdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4155,
    "place_name":"Chandler",
    "state_name":"Queensland"
  },
  {
    "postcode":4156,
    "place_name":"Mackenzie",
    "state_name":"Queensland"
  },
  {
    "postcode":4156,
    "place_name":"Burbank",
    "state_name":"Queensland"
  },
  {
    "postcode":4157,
    "place_name":"Sheldon",
    "state_name":"Queensland"
  },
  {
    "postcode":4157,
    "place_name":"Capalaba West",
    "state_name":"Queensland"
  },
  {
    "postcode":4157,
    "place_name":"Capalaba",
    "state_name":"Queensland"
  },
  {
    "postcode":4157,
    "place_name":"Capalaba DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4157,
    "place_name":"Capalaba BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4158,
    "place_name":"Thorneside",
    "state_name":"Queensland"
  },
  {
    "postcode":4159,
    "place_name":"Birkdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4160,
    "place_name":"Wellington Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4160,
    "place_name":"Ormiston",
    "state_name":"Queensland"
  },
  {
    "postcode":4161,
    "place_name":"Alexandra Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4163,
    "place_name":"Cleveland",
    "state_name":"Queensland"
  },
  {
    "postcode":4163,
    "place_name":"Cleveland DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4164,
    "place_name":"Thornlands",
    "state_name":"Queensland"
  },
  {
    "postcode":4165,
    "place_name":"Mount Cotton",
    "state_name":"Queensland"
  },
  {
    "postcode":4165,
    "place_name":"Redland Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4165,
    "place_name":"Victoria Point West",
    "state_name":"Queensland"
  },
  {
    "postcode":4165,
    "place_name":"Victoria Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4169,
    "place_name":"East Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":4169,
    "place_name":"Kangaroo Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4170,
    "place_name":"Norman Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4170,
    "place_name":"Seven Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4170,
    "place_name":"Cannon Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4170,
    "place_name":"Morningside",
    "state_name":"Queensland"
  },
  {
    "postcode":4171,
    "place_name":"Balmoral",
    "state_name":"Queensland"
  },
  {
    "postcode":4171,
    "place_name":"Bulimba",
    "state_name":"Queensland"
  },
  {
    "postcode":4171,
    "place_name":"Hawthorne",
    "state_name":"Queensland"
  },
  {
    "postcode":4172,
    "place_name":"Murarrie",
    "state_name":"Queensland"
  },
  {
    "postcode":4173,
    "place_name":"Tingalpa",
    "state_name":"Queensland"
  },
  {
    "postcode":4173,
    "place_name":"Tingalpa Bc",
    "state_name":"Queensland"
  },
  {
    "postcode":4173,
    "place_name":"Tingalpa Dc",
    "state_name":"Queensland"
  },
  {
    "postcode":4174,
    "place_name":"Hemmant",
    "state_name":"Queensland"
  },
  {
    "postcode":4178,
    "place_name":"Wynnum North",
    "state_name":"Queensland"
  },
  {
    "postcode":4178,
    "place_name":"Wynnum Plaza",
    "state_name":"Queensland"
  },
  {
    "postcode":4178,
    "place_name":"Wynnum",
    "state_name":"Queensland"
  },
  {
    "postcode":4178,
    "place_name":"Port Of Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":4178,
    "place_name":"Lytton",
    "state_name":"Queensland"
  },
  {
    "postcode":4178,
    "place_name":"Wynnum West",
    "state_name":"Queensland"
  },
  {
    "postcode":4179,
    "place_name":"Lota",
    "state_name":"Queensland"
  },
  {
    "postcode":4179,
    "place_name":"Manly",
    "state_name":"Queensland"
  },
  {
    "postcode":4179,
    "place_name":"Manly West",
    "state_name":"Queensland"
  },
  {
    "postcode":4183,
    "place_name":"North Stradbroke Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4183,
    "place_name":"Point Lookout",
    "state_name":"Queensland"
  },
  {
    "postcode":4183,
    "place_name":"Amity Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4183,
    "place_name":"Amity",
    "state_name":"Queensland"
  },
  {
    "postcode":4183,
    "place_name":"Dunwich",
    "state_name":"Queensland"
  },
  {
    "postcode":4184,
    "place_name":"Peel Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4184,
    "place_name":"Lamb Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4184,
    "place_name":"Perulpa Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4184,
    "place_name":"Macleay Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4184,
    "place_name":"Karragarra Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4184,
    "place_name":"Coochiemudlo Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4184,
    "place_name":"Russell Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4205,
    "place_name":"Bethania",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Cedar Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Yarrabilba",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Eagleby",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Alberton",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Bahrs Scrub",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Buccan",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Mount Warren Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Bannockburn",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Wolffdene",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Belivah",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Holmview",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Steiglitz",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Logan Village",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Windaroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Yatala",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Woongoolba",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Edens Landing",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Stapylton",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Luscombe",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Yatala DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4207,
    "place_name":"Beenleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4208,
    "place_name":"Ormeau Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4208,
    "place_name":"Norwell",
    "state_name":"Queensland"
  },
  {
    "postcode":4208,
    "place_name":"Gilberton",
    "state_name":"Queensland"
  },
  {
    "postcode":4208,
    "place_name":"Ormeau",
    "state_name":"Queensland"
  },
  {
    "postcode":4208,
    "place_name":"Jacobs Well",
    "state_name":"Queensland"
  },
  {
    "postcode":4208,
    "place_name":"Kingsholme",
    "state_name":"Queensland"
  },
  {
    "postcode":4209,
    "place_name":"Willow Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4209,
    "place_name":"Pimpama",
    "state_name":"Queensland"
  },
  {
    "postcode":4209,
    "place_name":"Coomera",
    "state_name":"Queensland"
  },
  {
    "postcode":4209,
    "place_name":"Upper Coomera",
    "state_name":"Queensland"
  },
  {
    "postcode":4210,
    "place_name":"Wongawallan",
    "state_name":"Queensland"
  },
  {
    "postcode":4210,
    "place_name":"Studio Village",
    "state_name":"Queensland"
  },
  {
    "postcode":4210,
    "place_name":"Guanaba",
    "state_name":"Queensland"
  },
  {
    "postcode":4210,
    "place_name":"Oxenford",
    "state_name":"Queensland"
  },
  {
    "postcode":4210,
    "place_name":"Maudsland",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Beechmont",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Gaven",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Southern Lamington",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Highland Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Nerang",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Gilston",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Clagiraba",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Numinbah Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Nerang BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Mount Nathan",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Binna Burra",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Advancetown",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Natural Bridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Pacific Pines",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Lower Beechmont",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Nerang DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4211,
    "place_name":"Carrara",
    "state_name":"Queensland"
  },
  {
    "postcode":4212,
    "place_name":"Helensvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4212,
    "place_name":"Sanctuary Cove",
    "state_name":"Queensland"
  },
  {
    "postcode":4212,
    "place_name":"Helensvale Town Centre",
    "state_name":"Queensland"
  },
  {
    "postcode":4212,
    "place_name":"Hope Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4213,
    "place_name":"Worongary",
    "state_name":"Queensland"
  },
  {
    "postcode":4213,
    "place_name":"Austinville",
    "state_name":"Queensland"
  },
  {
    "postcode":4213,
    "place_name":"Neranwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4213,
    "place_name":"Tallai",
    "state_name":"Queensland"
  },
  {
    "postcode":4213,
    "place_name":"Springbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4213,
    "place_name":"Mudgeeraba",
    "state_name":"Queensland"
  },
  {
    "postcode":4213,
    "place_name":"Bonogin",
    "state_name":"Queensland"
  },
  {
    "postcode":4214,
    "place_name":"Molendinar",
    "state_name":"Queensland"
  },
  {
    "postcode":4214,
    "place_name":"Ashmore City",
    "state_name":"Queensland"
  },
  {
    "postcode":4214,
    "place_name":"Parkwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4214,
    "place_name":"Ashmore",
    "state_name":"Queensland"
  },
  {
    "postcode":4214,
    "place_name":"Arundel",
    "state_name":"Queensland"
  },
  {
    "postcode":4214,
    "place_name":"Arundel Bc",
    "state_name":"Queensland"
  },
  {
    "postcode":4214,
    "place_name":"Arundel Dc",
    "state_name":"Queensland"
  },
  {
    "postcode":4215,
    "place_name":"Southport",
    "state_name":"Queensland"
  },
  {
    "postcode":4215,
    "place_name":"Labrador",
    "state_name":"Queensland"
  },
  {
    "postcode":4215,
    "place_name":"Australia Fair",
    "state_name":"Queensland"
  },
  {
    "postcode":4215,
    "place_name":"Southport BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4215,
    "place_name":"Southport Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4215,
    "place_name":"Chirn Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4216,
    "place_name":"South Stradbroke",
    "state_name":"Queensland"
  },
  {
    "postcode":4216,
    "place_name":"Runaway Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4216,
    "place_name":"Paradise Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4216,
    "place_name":"Biggera Waters",
    "state_name":"Queensland"
  },
  {
    "postcode":4216,
    "place_name":"Coombabah",
    "state_name":"Queensland"
  },
  {
    "postcode":4216,
    "place_name":"Hollywell",
    "state_name":"Queensland"
  },
  {
    "postcode":4217,
    "place_name":"Main Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4217,
    "place_name":"Surfers Paradise",
    "state_name":"Queensland"
  },
  {
    "postcode":4217,
    "place_name":"Bundall",
    "state_name":"Queensland"
  },
  {
    "postcode":4217,
    "place_name":"Benowa",
    "state_name":"Queensland"
  },
  {
    "postcode":4217,
    "place_name":"Isle Of Capri",
    "state_name":"Queensland"
  },
  {
    "postcode":4217,
    "place_name":"Bundall BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4217,
    "place_name":"Bundall DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4217,
    "place_name":"Gold Coast Mc",
    "state_name":"Queensland"
  },
  {
    "postcode":4217,
    "place_name":"Chevron Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4218,
    "place_name":"Broadbeach",
    "state_name":"Queensland"
  },
  {
    "postcode":4218,
    "place_name":"Mermaid Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4218,
    "place_name":"Mermaid Waters",
    "state_name":"Queensland"
  },
  {
    "postcode":4218,
    "place_name":"Broadbeach Waters",
    "state_name":"Queensland"
  },
  {
    "postcode":4218,
    "place_name":"Nobby Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4218,
    "place_name":"Q Supercentre",
    "state_name":"Queensland"
  },
  {
    "postcode":4218,
    "place_name":"Pacific Fair",
    "state_name":"Queensland"
  },
  {
    "postcode":4219,
    "place_name":"West Burleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4220,
    "place_name":"Miami",
    "state_name":"Queensland"
  },
  {
    "postcode":4220,
    "place_name":"Burleigh Town",
    "state_name":"Queensland"
  },
  {
    "postcode":4220,
    "place_name":"Burleigh Heads",
    "state_name":"Queensland"
  },
  {
    "postcode":4220,
    "place_name":"Burleigh Waters",
    "state_name":"Queensland"
  },
  {
    "postcode":4220,
    "place_name":"Burleigh DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4221,
    "place_name":"Elanora",
    "state_name":"Queensland"
  },
  {
    "postcode":4221,
    "place_name":"Palm Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4222,
    "place_name":"Griffith University",
    "state_name":"Queensland"
  },
  {
    "postcode":4223,
    "place_name":"Currumbin",
    "state_name":"Queensland"
  },
  {
    "postcode":4223,
    "place_name":"Currumbin Waters",
    "state_name":"Queensland"
  },
  {
    "postcode":4223,
    "place_name":"Currumbin Dc",
    "state_name":"Queensland"
  },
  {
    "postcode":4223,
    "place_name":"Currumbin Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4224,
    "place_name":"Tugun",
    "state_name":"Queensland"
  },
  {
    "postcode":4225,
    "place_name":"Coolangatta",
    "state_name":"Queensland"
  },
  {
    "postcode":4225,
    "place_name":"Bilinga",
    "state_name":"Queensland"
  },
  {
    "postcode":4226,
    "place_name":"Robina",
    "state_name":"Queensland"
  },
  {
    "postcode":4226,
    "place_name":"Clear Island Waters",
    "state_name":"Queensland"
  },
  {
    "postcode":4226,
    "place_name":"Robina DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4226,
    "place_name":"Merrimac",
    "state_name":"Queensland"
  },
  {
    "postcode":4227,
    "place_name":"Reedy Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4227,
    "place_name":"Varsity Lakes",
    "state_name":"Queensland"
  },
  {
    "postcode":4228,
    "place_name":"Tallebudgera",
    "state_name":"Queensland"
  },
  {
    "postcode":4228,
    "place_name":"Tallebudgera Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4229,
    "place_name":"Bond University",
    "state_name":"Queensland"
  },
  {
    "postcode":4230,
    "place_name":"Robina Town Centre",
    "state_name":"Queensland"
  },
  {
    "postcode":4270,
    "place_name":"Tamborine",
    "state_name":"Queensland"
  },
  {
    "postcode":4271,
    "place_name":"Eagle Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4272,
    "place_name":"Mount Tamborine",
    "state_name":"Queensland"
  },
  {
    "postcode":4272,
    "place_name":"Tamborine Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4272,
    "place_name":"North Tamborine",
    "state_name":"Queensland"
  },
  {
    "postcode":4275,
    "place_name":"Sarabah",
    "state_name":"Queensland"
  },
  {
    "postcode":4275,
    "place_name":"Witheren",
    "state_name":"Queensland"
  },
  {
    "postcode":4275,
    "place_name":"Boyland",
    "state_name":"Queensland"
  },
  {
    "postcode":4275,
    "place_name":"Benobble",
    "state_name":"Queensland"
  },
  {
    "postcode":4275,
    "place_name":"Wonglepong",
    "state_name":"Queensland"
  },
  {
    "postcode":4275,
    "place_name":"Canungra",
    "state_name":"Queensland"
  },
  {
    "postcode":4275,
    "place_name":"Lamington National Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4275,
    "place_name":"Ferny Glen",
    "state_name":"Queensland"
  },
  {
    "postcode":4275,
    "place_name":"Flying Fox",
    "state_name":"Queensland"
  },
  {
    "postcode":4275,
    "place_name":"Illinbah",
    "state_name":"Queensland"
  },
  {
    "postcode":4275,
    "place_name":"Biddaddaba",
    "state_name":"Queensland"
  },
  {
    "postcode":4280,
    "place_name":"Jimboomba",
    "state_name":"Queensland"
  },
  {
    "postcode":4280,
    "place_name":"South Maclean",
    "state_name":"Queensland"
  },
  {
    "postcode":4280,
    "place_name":"North Maclean",
    "state_name":"Queensland"
  },
  {
    "postcode":4280,
    "place_name":"Stockleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Veresdale Scrub",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Darlington",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Beaudesert",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Veresdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Birnam",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Kerry",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Lamington",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Laravale",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Cedar Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Oaky Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Tabooba",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Mount Gipps",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Kagaru",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Bromelton",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Josephville",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Kooralbyn",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Tamrookum",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Cryna",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Hillview",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Chinghee Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Cedar Grove",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Allenview",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Mundoolun",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Christmas Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Cainbable",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Nindooinbah",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Woodhill",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Knapp Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Tamrookum Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Tabragalba",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Innisplain",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Gleneagle",
    "state_name":"Queensland"
  },
  {
    "postcode":4285,
    "place_name":"Undullah",
    "state_name":"Queensland"
  },
  {
    "postcode":4287,
    "place_name":"Rathdowney",
    "state_name":"Queensland"
  },
  {
    "postcode":4287,
    "place_name":"Barney View",
    "state_name":"Queensland"
  },
  {
    "postcode":4287,
    "place_name":"Running Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4287,
    "place_name":"Mount Barney",
    "state_name":"Queensland"
  },
  {
    "postcode":4287,
    "place_name":"Palen Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4287,
    "place_name":"Mount Lindesay",
    "state_name":"Queensland"
  },
  {
    "postcode":4300,
    "place_name":"Gailes",
    "state_name":"Queensland"
  },
  {
    "postcode":4300,
    "place_name":"Springfield Lakes",
    "state_name":"Queensland"
  },
  {
    "postcode":4300,
    "place_name":"Goodna",
    "state_name":"Queensland"
  },
  {
    "postcode":4300,
    "place_name":"Springfield Central",
    "state_name":"Queensland"
  },
  {
    "postcode":4300,
    "place_name":"Camira",
    "state_name":"Queensland"
  },
  {
    "postcode":4300,
    "place_name":"Bellbird Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4300,
    "place_name":"Springfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4300,
    "place_name":"Augustine Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4300,
    "place_name":"Carole Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4300,
    "place_name":"Brookwater",
    "state_name":"Queensland"
  },
  {
    "postcode":4301,
    "place_name":"Redbank Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4301,
    "place_name":"Collingwood Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4301,
    "place_name":"Redbank",
    "state_name":"Queensland"
  },
  {
    "postcode":4303,
    "place_name":"Dinmore",
    "state_name":"Queensland"
  },
  {
    "postcode":4303,
    "place_name":"Riverview",
    "state_name":"Queensland"
  },
  {
    "postcode":4303,
    "place_name":"New Chum",
    "state_name":"Queensland"
  },
  {
    "postcode":4304,
    "place_name":"North Booval",
    "state_name":"Queensland"
  },
  {
    "postcode":4304,
    "place_name":"Booval Fair",
    "state_name":"Queensland"
  },
  {
    "postcode":4304,
    "place_name":"Silkstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4304,
    "place_name":"Blackstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4304,
    "place_name":"Booval",
    "state_name":"Queensland"
  },
  {
    "postcode":4304,
    "place_name":"Bundamba",
    "state_name":"Queensland"
  },
  {
    "postcode":4304,
    "place_name":"Ebbw Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Limestone Ridges",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"North Ipswich",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Brassall",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Coalfalls",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Basin Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Yamanto",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Bremer",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"East Ipswich",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"West Ipswich",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Wulkuraka",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Moores Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Leichhardt",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Raceview",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Newtown",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Woodend",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Ipswich",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"North Tivoli",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"One Mile",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Sadliers Crossing",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Eastern Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Flinders View",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Churchill",
    "state_name":"Queensland"
  },
  {
    "postcode":4305,
    "place_name":"Tivoli",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"England Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Fernvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"South Ripley",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Blacksoil",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Karrabin",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Goolman",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Wanora",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Muirlea",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Harlin",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Blackbutt",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Moore",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Nukku",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Purga",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Pine Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Peak Crossing",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Ironbark",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Dundas",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Thagoona",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Mount Binga",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Fairney View",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Mount Crosby",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Swanbank",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Split Yard Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Borallon",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Deebing Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Linville",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Benarkin North",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Banks Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Colinton",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Teelah",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Ripley",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Blackbutt North",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Blackbutt South",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Avoca Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Walloon",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Lake Manchester",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Karana Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Washpool",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Willowbank",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Cherry Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Chuwar",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Glamorgan Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Vernor",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Googa Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Amberley",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Mount Stanley",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Lark Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"White Rock",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Barellan Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Wivenhoe Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Haigslea",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Taromeo",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Benarkin",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Mount Marrow",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Kholo",
    "state_name":"Queensland"
  },
  {
    "postcode":4306,
    "place_name":"Karalee",
    "state_name":"Queensland"
  },
  {
    "postcode":4307,
    "place_name":"Mutdapilly",
    "state_name":"Queensland"
  },
  {
    "postcode":4307,
    "place_name":"Warrill View",
    "state_name":"Queensland"
  },
  {
    "postcode":4307,
    "place_name":"Silverdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4307,
    "place_name":"Coleyville",
    "state_name":"Queensland"
  },
  {
    "postcode":4307,
    "place_name":"Radford",
    "state_name":"Queensland"
  },
  {
    "postcode":4307,
    "place_name":"Wilsons Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4307,
    "place_name":"Harrisville",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Charlwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Mount Edwards",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Frazerview",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Teviotville",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Fassifern",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Kulgun",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Aratula",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Obum Obum",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Kalbar",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Kents Lagoon",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Washpool",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Morwincha",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Fassifern Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Milora",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Clumber",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Munbilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Moogerah",
    "state_name":"Queensland"
  },
  {
    "postcode":4309,
    "place_name":"Tarome",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Mount Alford",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Boonah",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Maroon",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Burnett Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Bunburra",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Anthony",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Hoya",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Milford",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Frenches Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Coulson",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Cannon Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Wallaces Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Blantyre",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Dugandan",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Allandale",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Templin",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Roadvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Mount French",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Kents Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Croftby",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Wyaralong",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Coochin",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Milbong",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Carneys Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Woolooman",
    "state_name":"Queensland"
  },
  {
    "postcode":4310,
    "place_name":"Bunjurgen",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Lowood",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Coolana",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Atkinsons Dam",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Mount Tarampa",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Tarampa",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Minden",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Buaraba",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Buaraba South",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Rifle Range",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Coominya",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Churchable",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Wivenhoe Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Patrick Estate",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Lockyer Waters",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Brightview",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Prenzlau",
    "state_name":"Queensland"
  },
  {
    "postcode":4311,
    "place_name":"Clarendon",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Somerset Dam",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Esk",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Redbank Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Bryden",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Mount Hallen",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Caboonbah",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Murrumba",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Moombra",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Mount Byron",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Glen Esk",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Crossdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Coal Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4312,
    "place_name":"Eskdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Cressbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Yimbun",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Fulham",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Cooeeimbardi",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Toogoolawah",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Braemore",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Lower Cressbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Scrub Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Mount Beppo",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Ottaba",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Biarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Gregors Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4313,
    "place_name":"Ivory Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Rosewood",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Jeebropilly",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Tallegalla",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Lanefield",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"The Bluff",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Mount Walker",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Grandchester",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Woolshed",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Calvert",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Lower Mount Walker",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Rosevale",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Ebenezer",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Mount Mort",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Mount Walker West",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Ashwell",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Merryvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Mount Forbes",
    "state_name":"Queensland"
  },
  {
    "postcode":4340,
    "place_name":"Moorang",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Kentville",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Kensington Grove",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Mulgowie",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Thornton",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Regency Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Blenheim",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Plainland",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Mount Berryman",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Laidley South",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Hatton Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Laidley Creek West",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Laidley",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Laidley North",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Townson",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Laidley Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4341,
    "place_name":"Summerholm",
    "state_name":"Queensland"
  },
  {
    "postcode":4342,
    "place_name":"Glenore Grove",
    "state_name":"Queensland"
  },
  {
    "postcode":4342,
    "place_name":"Lynford",
    "state_name":"Queensland"
  },
  {
    "postcode":4342,
    "place_name":"Forest Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4342,
    "place_name":"Glen Cairn",
    "state_name":"Queensland"
  },
  {
    "postcode":4342,
    "place_name":"Crowley Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4342,
    "place_name":"Lockrose",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Morton Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Spring Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Placid Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"College View",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Caffey",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Fordsdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Lower Tenthill",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"East Haldon",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Black Duck Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Woodlands",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Adare",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Ingoldsby",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Woodbine",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Ropeley",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Junction View",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Gatton",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Vinegar Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Mount Sylvia",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Upper Tenthill",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Lawes",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Rockside",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Ringwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Lefthand Branch",
    "state_name":"Queensland"
  },
  {
    "postcode":4343,
    "place_name":"Lake Clarendon",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Seventeen Mile",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Egypt",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Helidon",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Lockyer",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Carpendale",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Helidon Spa",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Rockmount",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Lilydale",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Iredale",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Stockyard",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Upper Flagstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Flagstone Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4344,
    "place_name":"Silver Ridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4345,
    "place_name":"Gatton College",
    "state_name":"Queensland"
  },
  {
    "postcode":4346,
    "place_name":"Marburg",
    "state_name":"Queensland"
  },
  {
    "postcode":4347,
    "place_name":"Veradilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4347,
    "place_name":"Winwill",
    "state_name":"Queensland"
  },
  {
    "postcode":4347,
    "place_name":"Ma Ma Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4347,
    "place_name":"Mount Whitestone",
    "state_name":"Queensland"
  },
  {
    "postcode":4347,
    "place_name":"Grantham",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Athol",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Southtown",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Westbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Toowoomba Village Fair",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Harristown",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Toowoomba City",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Mount Rascal",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Toowoomba West",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Prince Henry Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Rangeville",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Rockville",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Clifford Gardens",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Cranley",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"East Toowoomba",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Harlaxton",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Wellcamp",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Drayton",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Drayton North",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"North Toowoomba",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Toowoomba DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Cotswold Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Northlands",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Blue Mountain Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Centenary Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Glenvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Toowoomba South",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Wilsonton Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Toowoomba BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Toowoomba East",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Finnie",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Gowrie Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Top Camp",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Darling Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Mount Lofty",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Newtown",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Charlton",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Wilsonton",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Middle Ridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Torrington",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Mount Kynoch",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Wyalla Plaza",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Kearneys Spring",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"South Toowoomba",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Toowoomba",
    "state_name":"Queensland"
  },
  {
    "postcode":4350,
    "place_name":"Redwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Umbiram",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Cement Mills",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Meringandan West",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Spring Bluff",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Kulpi",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Ballard",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Cabarlah",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Highgrove",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Wyreema",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Fifteen Mile",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Groomsville",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Highfields",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Yalangur",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Hodgson Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Karara",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Hampton",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Pampas",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Coalbank",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Maclagan",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Perseverance",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Kleinton",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Ravensbourne",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Meringandan",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Glencoe",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Peranga",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Djuan",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Muniganeen",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Pechey",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Tummaville",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Branchview",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Geham",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Evergreen",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Upper Lockyer",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Blanchview",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Cutella",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Nutgrove",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Gore",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Merritts Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Severnlea",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Narko",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Oman Ama",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Derrymore",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Birnam",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Mount Luke",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Silver Ridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Condamine Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Wutul",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Malling",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Woolmer",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Doctor Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Murphys Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Lyra",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Vale View",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Thornville",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Ramsay",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Yandilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Preston",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Toowoomba Mc",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Amiens",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"St Aubyn",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Bapaume",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Palmtree",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Gowrie Junction",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Lilyvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Woodleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Gowrie Little Plain",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Grapetree",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Withcott",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"White Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Kurrowah",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Whichello",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Iredale",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Rangemore",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Postmans Ridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"North Maclagan",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Pozieres",
    "state_name":"Queensland"
  },
  {
    "postcode":4352,
    "place_name":"Cawdor",
    "state_name":"Queensland"
  },
  {
    "postcode":4353,
    "place_name":"Bergen",
    "state_name":"Queensland"
  },
  {
    "postcode":4353,
    "place_name":"East Cooyar",
    "state_name":"Queensland"
  },
  {
    "postcode":4353,
    "place_name":"Haden",
    "state_name":"Queensland"
  },
  {
    "postcode":4354,
    "place_name":"Kilbirnie",
    "state_name":"Queensland"
  },
  {
    "postcode":4354,
    "place_name":"Goombungee",
    "state_name":"Queensland"
  },
  {
    "postcode":4354,
    "place_name":"Douglas",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"The Bluff",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"Mountain Camp",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"Pinelands",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"Crows Nest",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"Anduramba",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"Pierces Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"Cressbrook Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"Jones Gully",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"Glenaven",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"Upper Pinelands",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"Plainby",
    "state_name":"Queensland"
  },
  {
    "postcode":4355,
    "place_name":"Emu Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Mount Tyson",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Linthorpe",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Yarranlea",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Purrawunda",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Bongeen",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"North Branch",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Motley",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Irongate",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Stoneleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Broxburn",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Norwin",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Pittsworth",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Springside",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Evanslea",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Kincora",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Scrubby Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"Rossvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4356,
    "place_name":"St Helens",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Captains Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Kooroongarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Cypress Gardens",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Turallin",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Bringalily",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Millmerran Woods",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Bulli Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Clontarf",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Condamine Farms",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Lavelle",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Western Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Rocky Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"The Pines",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Mount Emlyn",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Forest Ridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Millmerran",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Domville",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Stonehenge",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Canning Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Millmerran Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Millwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Wattle Ridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Lemontree",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Grays Gate",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Woondul",
    "state_name":"Queensland"
  },
  {
    "postcode":4357,
    "place_name":"Punchs Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4358,
    "place_name":"Cambooya",
    "state_name":"Queensland"
  },
  {
    "postcode":4358,
    "place_name":"Vale View",
    "state_name":"Queensland"
  },
  {
    "postcode":4358,
    "place_name":"Ramsay",
    "state_name":"Queensland"
  },
  {
    "postcode":4358,
    "place_name":"Felton South",
    "state_name":"Queensland"
  },
  {
    "postcode":4358,
    "place_name":"Felton",
    "state_name":"Queensland"
  },
  {
    "postcode":4359,
    "place_name":"Hirstglen",
    "state_name":"Queensland"
  },
  {
    "postcode":4359,
    "place_name":"Greenmount East",
    "state_name":"Queensland"
  },
  {
    "postcode":4359,
    "place_name":"Ascot",
    "state_name":"Queensland"
  },
  {
    "postcode":4359,
    "place_name":"East Greenmount",
    "state_name":"Queensland"
  },
  {
    "postcode":4359,
    "place_name":"West Haldon",
    "state_name":"Queensland"
  },
  {
    "postcode":4359,
    "place_name":"Greenmount",
    "state_name":"Queensland"
  },
  {
    "postcode":4359,
    "place_name":"Budgee",
    "state_name":"Queensland"
  },
  {
    "postcode":4360,
    "place_name":"Nobby",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Pilton",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Manapouri",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Upper Pilton",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Ryeford",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Elphinstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Missen Flat",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Back Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Mount Molar",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Kings Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Victoria Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Spring Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Nevilton",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Ellangowan",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Sandy Camp",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Clifton",
    "state_name":"Queensland"
  },
  {
    "postcode":4361,
    "place_name":"Headington Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4362,
    "place_name":"Berat",
    "state_name":"Queensland"
  },
  {
    "postcode":4362,
    "place_name":"Mount Marshall",
    "state_name":"Queensland"
  },
  {
    "postcode":4362,
    "place_name":"Allora",
    "state_name":"Queensland"
  },
  {
    "postcode":4362,
    "place_name":"Ellinthorp",
    "state_name":"Queensland"
  },
  {
    "postcode":4362,
    "place_name":"Deuchar",
    "state_name":"Queensland"
  },
  {
    "postcode":4362,
    "place_name":"Talgai",
    "state_name":"Queensland"
  },
  {
    "postcode":4362,
    "place_name":"Goomburra",
    "state_name":"Queensland"
  },
  {
    "postcode":4362,
    "place_name":"Hendon",
    "state_name":"Queensland"
  },
  {
    "postcode":4363,
    "place_name":"Southbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4364,
    "place_name":"Brookstead",
    "state_name":"Queensland"
  },
  {
    "postcode":4365,
    "place_name":"Leyburn",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Morgan Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Wildash",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Thanes Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Mount Tabor",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Massie",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Clintonvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Cunningham",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Danderoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Pratten",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Elbow Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Allan",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Leslie Dam",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Leslie",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Swan Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Thane",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Wiyarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"North Branch",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Sladevale",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Montrose",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Murrays Bridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Cherry Gully",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Canningvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Loch Lomond",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Wheatvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Bony Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Rodgers Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Warwick",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Rosenthal Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Mount Sturt",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Rosehill",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Womina",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"The Hermitage",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Junabee",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Glengallan",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Greymare",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Warwick DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Upper Freestone",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Tregony",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Mount Colliery",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Willowvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Freestone",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Silverwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Upper Wheatvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"The Glen",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Toolburra",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Maryvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4370,
    "place_name":"Gladfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4371,
    "place_name":"Emu Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4371,
    "place_name":"Swanfels",
    "state_name":"Queensland"
  },
  {
    "postcode":4371,
    "place_name":"Yangan",
    "state_name":"Queensland"
  },
  {
    "postcode":4372,
    "place_name":"Tannymorel",
    "state_name":"Queensland"
  },
  {
    "postcode":4373,
    "place_name":"The Head",
    "state_name":"Queensland"
  },
  {
    "postcode":4373,
    "place_name":"Killarney",
    "state_name":"Queensland"
  },
  {
    "postcode":4373,
    "place_name":"The Falls",
    "state_name":"Queensland"
  },
  {
    "postcode":4374,
    "place_name":"Dalveen",
    "state_name":"Queensland"
  },
  {
    "postcode":4375,
    "place_name":"Fleurbaix",
    "state_name":"Queensland"
  },
  {
    "postcode":4375,
    "place_name":"Cottonvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4376,
    "place_name":"Thulimbah",
    "state_name":"Queensland"
  },
  {
    "postcode":4377,
    "place_name":"Glen Niven",
    "state_name":"Queensland"
  },
  {
    "postcode":4377,
    "place_name":"The Summit",
    "state_name":"Queensland"
  },
  {
    "postcode":4378,
    "place_name":"Applethorpe",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Severnlea",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Springdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Stanthorpe",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Glenlyon",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Thorndale",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Pikedale",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Amiens",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Sugarloaf",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Pikes Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Broadwater",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Eukey",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Nundubbermere",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Greenlands",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Mingoola",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Kyoomba",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Dalcouth",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Storm King",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Mount Tully",
    "state_name":"Queensland"
  },
  {
    "postcode":4380,
    "place_name":"Cannon Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4381,
    "place_name":"Fletcher",
    "state_name":"Queensland"
  },
  {
    "postcode":4381,
    "place_name":"Glen Aplin",
    "state_name":"Queensland"
  },
  {
    "postcode":4382,
    "place_name":"Lyra",
    "state_name":"Queensland"
  },
  {
    "postcode":4382,
    "place_name":"Girraween",
    "state_name":"Queensland"
  },
  {
    "postcode":4382,
    "place_name":"Wyberba",
    "state_name":"Queensland"
  },
  {
    "postcode":4382,
    "place_name":"Ballandean",
    "state_name":"Queensland"
  },
  {
    "postcode":4382,
    "place_name":"Somme",
    "state_name":"Queensland"
  },
  {
    "postcode":4383,
    "place_name":"Wallangarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4384,
    "place_name":"Limevale",
    "state_name":"Queensland"
  },
  {
    "postcode":4385,
    "place_name":"Texas",
    "state_name":"Queensland"
  },
  {
    "postcode":4385,
    "place_name":"Smithlea",
    "state_name":"Queensland"
  },
  {
    "postcode":4385,
    "place_name":"Glenarbon",
    "state_name":"Queensland"
  },
  {
    "postcode":4385,
    "place_name":"Riverton",
    "state_name":"Queensland"
  },
  {
    "postcode":4385,
    "place_name":"Beebo",
    "state_name":"Queensland"
  },
  {
    "postcode":4385,
    "place_name":"Watsons Crossing",
    "state_name":"Queensland"
  },
  {
    "postcode":4385,
    "place_name":"Bonshaw",
    "state_name":"Queensland"
  },
  {
    "postcode":4385,
    "place_name":"Maidenhead",
    "state_name":"Queensland"
  },
  {
    "postcode":4385,
    "place_name":"Silver Spur",
    "state_name":"Queensland"
  },
  {
    "postcode":4387,
    "place_name":"Whetstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4387,
    "place_name":"Inglewood",
    "state_name":"Queensland"
  },
  {
    "postcode":4387,
    "place_name":"Coolmunda",
    "state_name":"Queensland"
  },
  {
    "postcode":4387,
    "place_name":"Warroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4387,
    "place_name":"Terrica",
    "state_name":"Queensland"
  },
  {
    "postcode":4387,
    "place_name":"Bybera",
    "state_name":"Queensland"
  },
  {
    "postcode":4387,
    "place_name":"Greenup",
    "state_name":"Queensland"
  },
  {
    "postcode":4387,
    "place_name":"Brush Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4387,
    "place_name":"Mosquito Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4388,
    "place_name":"Yelarbon",
    "state_name":"Queensland"
  },
  {
    "postcode":4388,
    "place_name":"Kurumbul",
    "state_name":"Queensland"
  },
  {
    "postcode":4390,
    "place_name":"Callandoon",
    "state_name":"Queensland"
  },
  {
    "postcode":4390,
    "place_name":"Calingunee",
    "state_name":"Queensland"
  },
  {
    "postcode":4390,
    "place_name":"Goondiwindi",
    "state_name":"Queensland"
  },
  {
    "postcode":4390,
    "place_name":"Kindon",
    "state_name":"Queensland"
  },
  {
    "postcode":4390,
    "place_name":"Wondalli",
    "state_name":"Queensland"
  },
  {
    "postcode":4390,
    "place_name":"Lundavra",
    "state_name":"Queensland"
  },
  {
    "postcode":4390,
    "place_name":"Yagaburne",
    "state_name":"Queensland"
  },
  {
    "postcode":4390,
    "place_name":"Wyaga",
    "state_name":"Queensland"
  },
  {
    "postcode":4390,
    "place_name":"Goodar",
    "state_name":"Queensland"
  },
  {
    "postcode":4390,
    "place_name":"Billa Billa",
    "state_name":"Queensland"
  },
  {
    "postcode":4400,
    "place_name":"Kingsthorpe",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Sabine",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Highland Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Muldu",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Aubigny",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Boodua",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Devon Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Rosalie Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Acland",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Biddeston",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Greenwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Oakey",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Silverleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Balgowan",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Kelvinhaugh",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Mount Irving",
    "state_name":"Queensland"
  },
  {
    "postcode":4401,
    "place_name":"Yargullen",
    "state_name":"Queensland"
  },
  {
    "postcode":4402,
    "place_name":"Kooralgin",
    "state_name":"Queensland"
  },
  {
    "postcode":4402,
    "place_name":"Upper Cooyar Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4402,
    "place_name":"Cooyar",
    "state_name":"Queensland"
  },
  {
    "postcode":4403,
    "place_name":"Brymaroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4403,
    "place_name":"Quinalow",
    "state_name":"Queensland"
  },
  {
    "postcode":4403,
    "place_name":"West Prairie",
    "state_name":"Queensland"
  },
  {
    "postcode":4403,
    "place_name":"Malu",
    "state_name":"Queensland"
  },
  {
    "postcode":4403,
    "place_name":"Jondaryan",
    "state_name":"Queensland"
  },
  {
    "postcode":4403,
    "place_name":"Mount Moriah",
    "state_name":"Queensland"
  },
  {
    "postcode":4404,
    "place_name":"Formartin",
    "state_name":"Queensland"
  },
  {
    "postcode":4404,
    "place_name":"Irvingdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4404,
    "place_name":"Bowenville",
    "state_name":"Queensland"
  },
  {
    "postcode":4404,
    "place_name":"Wainui",
    "state_name":"Queensland"
  },
  {
    "postcode":4405,
    "place_name":"Ducklo",
    "state_name":"Queensland"
  },
  {
    "postcode":4405,
    "place_name":"Dalby",
    "state_name":"Queensland"
  },
  {
    "postcode":4405,
    "place_name":"Blaxland",
    "state_name":"Queensland"
  },
  {
    "postcode":4405,
    "place_name":"Bunya Mountains",
    "state_name":"Queensland"
  },
  {
    "postcode":4405,
    "place_name":"Weranga",
    "state_name":"Queensland"
  },
  {
    "postcode":4405,
    "place_name":"Grassdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4405,
    "place_name":"Tipton",
    "state_name":"Queensland"
  },
  {
    "postcode":4405,
    "place_name":"St Ruth",
    "state_name":"Queensland"
  },
  {
    "postcode":4405,
    "place_name":"Ranges Bridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4405,
    "place_name":"Marmadua",
    "state_name":"Queensland"
  },
  {
    "postcode":4405,
    "place_name":"Pirrinuan",
    "state_name":"Queensland"
  },
  {
    "postcode":4406,
    "place_name":"Kaimkillenbun",
    "state_name":"Queensland"
  },
  {
    "postcode":4406,
    "place_name":"Weir River",
    "state_name":"Queensland"
  },
  {
    "postcode":4406,
    "place_name":"The Gums",
    "state_name":"Queensland"
  },
  {
    "postcode":4406,
    "place_name":"Boondandilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4406,
    "place_name":"Moonie",
    "state_name":"Queensland"
  },
  {
    "postcode":4406,
    "place_name":"Macalister",
    "state_name":"Queensland"
  },
  {
    "postcode":4406,
    "place_name":"Hannaford",
    "state_name":"Queensland"
  },
  {
    "postcode":4406,
    "place_name":"Jimbour",
    "state_name":"Queensland"
  },
  {
    "postcode":4406,
    "place_name":"Southwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4406,
    "place_name":"Kogan",
    "state_name":"Queensland"
  },
  {
    "postcode":4407,
    "place_name":"Cattle Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4407,
    "place_name":"Cecil Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4407,
    "place_name":"Dunmore",
    "state_name":"Queensland"
  },
  {
    "postcode":4407,
    "place_name":"Nangwee",
    "state_name":"Queensland"
  },
  {
    "postcode":4408,
    "place_name":"Bell",
    "state_name":"Queensland"
  },
  {
    "postcode":4410,
    "place_name":"Jandowae",
    "state_name":"Queensland"
  },
  {
    "postcode":4411,
    "place_name":"Warra",
    "state_name":"Queensland"
  },
  {
    "postcode":4412,
    "place_name":"Brigalow",
    "state_name":"Queensland"
  },
  {
    "postcode":4413,
    "place_name":"Durah",
    "state_name":"Queensland"
  },
  {
    "postcode":4413,
    "place_name":"Boonarga",
    "state_name":"Queensland"
  },
  {
    "postcode":4413,
    "place_name":"Hopeland",
    "state_name":"Queensland"
  },
  {
    "postcode":4413,
    "place_name":"Montrose",
    "state_name":"Queensland"
  },
  {
    "postcode":4413,
    "place_name":"Canaga",
    "state_name":"Queensland"
  },
  {
    "postcode":4413,
    "place_name":"Baking Board",
    "state_name":"Queensland"
  },
  {
    "postcode":4413,
    "place_name":"Burncluith",
    "state_name":"Queensland"
  },
  {
    "postcode":4413,
    "place_name":"Wieambilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4413,
    "place_name":"Chances Plain",
    "state_name":"Queensland"
  },
  {
    "postcode":4413,
    "place_name":"Chinchilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4415,
    "place_name":"Dalwogon",
    "state_name":"Queensland"
  },
  {
    "postcode":4415,
    "place_name":"Hookswood",
    "state_name":"Queensland"
  },
  {
    "postcode":4415,
    "place_name":"Columboola",
    "state_name":"Queensland"
  },
  {
    "postcode":4415,
    "place_name":"Myall Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4415,
    "place_name":"Miles",
    "state_name":"Queensland"
  },
  {
    "postcode":4415,
    "place_name":"Pelham",
    "state_name":"Queensland"
  },
  {
    "postcode":4415,
    "place_name":"Gurulmundi",
    "state_name":"Queensland"
  },
  {
    "postcode":4415,
    "place_name":"Kowguran",
    "state_name":"Queensland"
  },
  {
    "postcode":4416,
    "place_name":"Yulabilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4416,
    "place_name":"Condamine",
    "state_name":"Queensland"
  },
  {
    "postcode":4416,
    "place_name":"Pine Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4416,
    "place_name":"Moraby",
    "state_name":"Queensland"
  },
  {
    "postcode":4416,
    "place_name":"Nangram",
    "state_name":"Queensland"
  },
  {
    "postcode":4416,
    "place_name":"Barramornie",
    "state_name":"Queensland"
  },
  {
    "postcode":4416,
    "place_name":"Sunnyside",
    "state_name":"Queensland"
  },
  {
    "postcode":4417,
    "place_name":"Wellesley",
    "state_name":"Queensland"
  },
  {
    "postcode":4417,
    "place_name":"Parknook",
    "state_name":"Queensland"
  },
  {
    "postcode":4417,
    "place_name":"Surat",
    "state_name":"Queensland"
  },
  {
    "postcode":4417,
    "place_name":"Warkon",
    "state_name":"Queensland"
  },
  {
    "postcode":4417,
    "place_name":"Oberina",
    "state_name":"Queensland"
  },
  {
    "postcode":4417,
    "place_name":"Noorindoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4417,
    "place_name":"Weribone",
    "state_name":"Queensland"
  },
  {
    "postcode":4418,
    "place_name":"Guluguba",
    "state_name":"Queensland"
  },
  {
    "postcode":4419,
    "place_name":"Cockatoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4419,
    "place_name":"Wandoan",
    "state_name":"Queensland"
  },
  {
    "postcode":4419,
    "place_name":"Grosmont",
    "state_name":"Queensland"
  },
  {
    "postcode":4420,
    "place_name":"Spring Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4420,
    "place_name":"Coorada",
    "state_name":"Queensland"
  },
  {
    "postcode":4420,
    "place_name":"Ghinghinda",
    "state_name":"Queensland"
  },
  {
    "postcode":4420,
    "place_name":"Peek-A-Doo",
    "state_name":"Queensland"
  },
  {
    "postcode":4420,
    "place_name":"Taroom",
    "state_name":"Queensland"
  },
  {
    "postcode":4420,
    "place_name":"Gwambegwine",
    "state_name":"Queensland"
  },
  {
    "postcode":4420,
    "place_name":"Hornet Bank",
    "state_name":"Queensland"
  },
  {
    "postcode":4420,
    "place_name":"Glenhaughton",
    "state_name":"Queensland"
  },
  {
    "postcode":4420,
    "place_name":"Broadmere",
    "state_name":"Queensland"
  },
  {
    "postcode":4421,
    "place_name":"Tara",
    "state_name":"Queensland"
  },
  {
    "postcode":4421,
    "place_name":"Goranba",
    "state_name":"Queensland"
  },
  {
    "postcode":4422,
    "place_name":"Flinton",
    "state_name":"Queensland"
  },
  {
    "postcode":4422,
    "place_name":"Inglestone",
    "state_name":"Queensland"
  },
  {
    "postcode":4422,
    "place_name":"Meandarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4422,
    "place_name":"Coomrith",
    "state_name":"Queensland"
  },
  {
    "postcode":4422,
    "place_name":"Westmar",
    "state_name":"Queensland"
  },
  {
    "postcode":4423,
    "place_name":"Glenmorgan",
    "state_name":"Queensland"
  },
  {
    "postcode":4423,
    "place_name":"Teelba",
    "state_name":"Queensland"
  },
  {
    "postcode":4424,
    "place_name":"Drillham",
    "state_name":"Queensland"
  },
  {
    "postcode":4424,
    "place_name":"Drillham South",
    "state_name":"Queensland"
  },
  {
    "postcode":4424,
    "place_name":"Glenaubyn",
    "state_name":"Queensland"
  },
  {
    "postcode":4425,
    "place_name":"Dulacca",
    "state_name":"Queensland"
  },
  {
    "postcode":4425,
    "place_name":"Bogandilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4426,
    "place_name":"Jackson",
    "state_name":"Queensland"
  },
  {
    "postcode":4426,
    "place_name":"Jackson North",
    "state_name":"Queensland"
  },
  {
    "postcode":4426,
    "place_name":"Jackson South",
    "state_name":"Queensland"
  },
  {
    "postcode":4427,
    "place_name":"Yuleba",
    "state_name":"Queensland"
  },
  {
    "postcode":4427,
    "place_name":"Clifford",
    "state_name":"Queensland"
  },
  {
    "postcode":4427,
    "place_name":"Yuleba South",
    "state_name":"Queensland"
  },
  {
    "postcode":4427,
    "place_name":"Yuleba North",
    "state_name":"Queensland"
  },
  {
    "postcode":4428,
    "place_name":"Wallumbilla South",
    "state_name":"Queensland"
  },
  {
    "postcode":4428,
    "place_name":"Wallumbilla North",
    "state_name":"Queensland"
  },
  {
    "postcode":4428,
    "place_name":"Wallumbilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4428,
    "place_name":"Pickanjinnie",
    "state_name":"Queensland"
  },
  {
    "postcode":4454,
    "place_name":"Durham Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4454,
    "place_name":"Injune",
    "state_name":"Queensland"
  },
  {
    "postcode":4454,
    "place_name":"Baffle West",
    "state_name":"Queensland"
  },
  {
    "postcode":4454,
    "place_name":"Highland Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4454,
    "place_name":"Hutton Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4454,
    "place_name":"Beilba",
    "state_name":"Queensland"
  },
  {
    "postcode":4454,
    "place_name":"Simmie",
    "state_name":"Queensland"
  },
  {
    "postcode":4454,
    "place_name":"Westgrove",
    "state_name":"Queensland"
  },
  {
    "postcode":4454,
    "place_name":"Upper Dawson",
    "state_name":"Queensland"
  },
  {
    "postcode":4454,
    "place_name":"Mount Hutton",
    "state_name":"Queensland"
  },
  {
    "postcode":4454,
    "place_name":"Pony Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Orallo",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Roma",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Dargal Road",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Wycombe",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Euthulla",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Mooga",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Tingun",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Cornwall",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Ballaroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Mount Abundance",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Bymount",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Eumamurrin",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Blythdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Orange Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Hodgson",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Mount Bindango",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Gunnewin",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Bungil",
    "state_name":"Queensland"
  },
  {
    "postcode":4455,
    "place_name":"Bungeworgorai",
    "state_name":"Queensland"
  },
  {
    "postcode":4461,
    "place_name":"Muckadilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4462,
    "place_name":"Amby",
    "state_name":"Queensland"
  },
  {
    "postcode":4465,
    "place_name":"Forestvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4465,
    "place_name":"Womalilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4465,
    "place_name":"Dunkeld",
    "state_name":"Queensland"
  },
  {
    "postcode":4465,
    "place_name":"V Gate",
    "state_name":"Queensland"
  },
  {
    "postcode":4465,
    "place_name":"Mitchell",
    "state_name":"Queensland"
  },
  {
    "postcode":4467,
    "place_name":"Mungallala",
    "state_name":"Queensland"
  },
  {
    "postcode":4467,
    "place_name":"Tyrconnel",
    "state_name":"Queensland"
  },
  {
    "postcode":4467,
    "place_name":"Redford",
    "state_name":"Queensland"
  },
  {
    "postcode":4468,
    "place_name":"Clara Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4468,
    "place_name":"Morven",
    "state_name":"Queensland"
  },
  {
    "postcode":4470,
    "place_name":"Riversleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4470,
    "place_name":"Charleville",
    "state_name":"Queensland"
  },
  {
    "postcode":4470,
    "place_name":"Bakers Bend",
    "state_name":"Queensland"
  },
  {
    "postcode":4470,
    "place_name":"Langlo",
    "state_name":"Queensland"
  },
  {
    "postcode":4470,
    "place_name":"Murweh",
    "state_name":"Queensland"
  },
  {
    "postcode":4470,
    "place_name":"Gowrie Station",
    "state_name":"Queensland"
  },
  {
    "postcode":4471,
    "place_name":"Claverton",
    "state_name":"Queensland"
  },
  {
    "postcode":4472,
    "place_name":"Blackall",
    "state_name":"Queensland"
  },
  {
    "postcode":4472,
    "place_name":"Mount Enniskillen",
    "state_name":"Queensland"
  },
  {
    "postcode":4474,
    "place_name":"Adavale",
    "state_name":"Queensland"
  },
  {
    "postcode":4475,
    "place_name":"Cheepie",
    "state_name":"Queensland"
  },
  {
    "postcode":4477,
    "place_name":"Augathella",
    "state_name":"Queensland"
  },
  {
    "postcode":4477,
    "place_name":"Upper Warrego",
    "state_name":"Queensland"
  },
  {
    "postcode":4478,
    "place_name":"Tambo",
    "state_name":"Queensland"
  },
  {
    "postcode":4478,
    "place_name":"Lumeah",
    "state_name":"Queensland"
  },
  {
    "postcode":4478,
    "place_name":"Caldervale",
    "state_name":"Queensland"
  },
  {
    "postcode":4478,
    "place_name":"Macfarlane",
    "state_name":"Queensland"
  },
  {
    "postcode":4478,
    "place_name":"Minnie Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4478,
    "place_name":"Bayrick",
    "state_name":"Queensland"
  },
  {
    "postcode":4478,
    "place_name":"Windeyer",
    "state_name":"Queensland"
  },
  {
    "postcode":4478,
    "place_name":"Yandarlo",
    "state_name":"Queensland"
  },
  {
    "postcode":4478,
    "place_name":"Lansdowne",
    "state_name":"Queensland"
  },
  {
    "postcode":4478,
    "place_name":"Scrubby Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4479,
    "place_name":"Cooladdi",
    "state_name":"Queensland"
  },
  {
    "postcode":4480,
    "place_name":"Quilpie",
    "state_name":"Queensland"
  },
  {
    "postcode":4480,
    "place_name":"Eromanga",
    "state_name":"Queensland"
  },
  {
    "postcode":4481,
    "place_name":"Tanbar",
    "state_name":"Queensland"
  },
  {
    "postcode":4481,
    "place_name":"Windorah",
    "state_name":"Queensland"
  },
  {
    "postcode":4481,
    "place_name":"Farrars Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4482,
    "place_name":"Birdsville",
    "state_name":"Queensland"
  },
  {
    "postcode":4486,
    "place_name":"Hebel",
    "state_name":"Queensland"
  },
  {
    "postcode":4486,
    "place_name":"Dirranbandi",
    "state_name":"Queensland"
  },
  {
    "postcode":4487,
    "place_name":"St George",
    "state_name":"Queensland"
  },
  {
    "postcode":4487,
    "place_name":"Begonia",
    "state_name":"Queensland"
  },
  {
    "postcode":4488,
    "place_name":"Nebine",
    "state_name":"Queensland"
  },
  {
    "postcode":4488,
    "place_name":"Bollon",
    "state_name":"Queensland"
  },
  {
    "postcode":4489,
    "place_name":"Wyandra",
    "state_name":"Queensland"
  },
  {
    "postcode":4490,
    "place_name":"Cunnamulla",
    "state_name":"Queensland"
  },
  {
    "postcode":4490,
    "place_name":"Tuen",
    "state_name":"Queensland"
  },
  {
    "postcode":4490,
    "place_name":"Widgeegoara",
    "state_name":"Queensland"
  },
  {
    "postcode":4490,
    "place_name":"Barringun",
    "state_name":"Queensland"
  },
  {
    "postcode":4490,
    "place_name":"Coongoola",
    "state_name":"Queensland"
  },
  {
    "postcode":4490,
    "place_name":"Yowah",
    "state_name":"Queensland"
  },
  {
    "postcode":4490,
    "place_name":"Noorama",
    "state_name":"Queensland"
  },
  {
    "postcode":4490,
    "place_name":"Cuttaburra",
    "state_name":"Queensland"
  },
  {
    "postcode":4490,
    "place_name":"Humeburn",
    "state_name":"Queensland"
  },
  {
    "postcode":4490,
    "place_name":"Linden",
    "state_name":"Queensland"
  },
  {
    "postcode":4490,
    "place_name":"Jobs Gate",
    "state_name":"Queensland"
  },
  {
    "postcode":4491,
    "place_name":"Eulo",
    "state_name":"Queensland"
  },
  {
    "postcode":4492,
    "place_name":"Dynevor",
    "state_name":"Queensland"
  },
  {
    "postcode":4492,
    "place_name":"Nockatunga",
    "state_name":"Queensland"
  },
  {
    "postcode":4492,
    "place_name":"Bullawarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4492,
    "place_name":"Norley",
    "state_name":"Queensland"
  },
  {
    "postcode":4492,
    "place_name":"Bulloo Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4492,
    "place_name":"Thargomindah",
    "state_name":"Queensland"
  },
  {
    "postcode":4493,
    "place_name":"Hungerford",
    "state_name":"Queensland"
  },
  {
    "postcode":4494,
    "place_name":"Bungunya",
    "state_name":"Queensland"
  },
  {
    "postcode":4494,
    "place_name":"North Bungunya",
    "state_name":"Queensland"
  },
  {
    "postcode":4494,
    "place_name":"Tarawera",
    "state_name":"Queensland"
  },
  {
    "postcode":4496,
    "place_name":"Talwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4496,
    "place_name":"South Talwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4496,
    "place_name":"North Talwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4497,
    "place_name":"Thallon",
    "state_name":"Queensland"
  },
  {
    "postcode":4497,
    "place_name":"Weengallon",
    "state_name":"Queensland"
  },
  {
    "postcode":4497,
    "place_name":"Daymar",
    "state_name":"Queensland"
  },
  {
    "postcode":4498,
    "place_name":"Kioma",
    "state_name":"Queensland"
  },
  {
    "postcode":4498,
    "place_name":"Toobeah",
    "state_name":"Queensland"
  },
  {
    "postcode":4500,
    "place_name":"Brendale",
    "state_name":"Queensland"
  },
  {
    "postcode":4500,
    "place_name":"Warner",
    "state_name":"Queensland"
  },
  {
    "postcode":4500,
    "place_name":"Brendale BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4500,
    "place_name":"Clear Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4500,
    "place_name":"Strathpine Centre",
    "state_name":"Queensland"
  },
  {
    "postcode":4500,
    "place_name":"Joyner",
    "state_name":"Queensland"
  },
  {
    "postcode":4500,
    "place_name":"Brendale DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4500,
    "place_name":"Strathpine",
    "state_name":"Queensland"
  },
  {
    "postcode":4500,
    "place_name":"Cashmere",
    "state_name":"Queensland"
  },
  {
    "postcode":4500,
    "place_name":"Bray Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4501,
    "place_name":"Lawnton",
    "state_name":"Queensland"
  },
  {
    "postcode":4502,
    "place_name":"Petrie",
    "state_name":"Queensland"
  },
  {
    "postcode":4503,
    "place_name":"Murrumba Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4503,
    "place_name":"Kallangur",
    "state_name":"Queensland"
  },
  {
    "postcode":4503,
    "place_name":"Griffin",
    "state_name":"Queensland"
  },
  {
    "postcode":4503,
    "place_name":"Kurwongbah",
    "state_name":"Queensland"
  },
  {
    "postcode":4503,
    "place_name":"Dakabin",
    "state_name":"Queensland"
  },
  {
    "postcode":4503,
    "place_name":"Whiteside",
    "state_name":"Queensland"
  },
  {
    "postcode":4504,
    "place_name":"Narangba",
    "state_name":"Queensland"
  },
  {
    "postcode":4505,
    "place_name":"Burpengary",
    "state_name":"Queensland"
  },
  {
    "postcode":4505,
    "place_name":"Burpengary DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4505,
    "place_name":"Burpengary East",
    "state_name":"Queensland"
  },
  {
    "postcode":4506,
    "place_name":"Moorina",
    "state_name":"Queensland"
  },
  {
    "postcode":4506,
    "place_name":"Morayfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4507,
    "place_name":"Bongaree",
    "state_name":"Queensland"
  },
  {
    "postcode":4507,
    "place_name":"Bellara",
    "state_name":"Queensland"
  },
  {
    "postcode":4507,
    "place_name":"Banksia Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4507,
    "place_name":"Woorim",
    "state_name":"Queensland"
  },
  {
    "postcode":4507,
    "place_name":"Bribie Island North",
    "state_name":"Queensland"
  },
  {
    "postcode":4507,
    "place_name":"White Patch",
    "state_name":"Queensland"
  },
  {
    "postcode":4507,
    "place_name":"Bribie Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4507,
    "place_name":"Welsby",
    "state_name":"Queensland"
  },
  {
    "postcode":4508,
    "place_name":"Deception Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4509,
    "place_name":"North Lakes",
    "state_name":"Queensland"
  },
  {
    "postcode":4509,
    "place_name":"Mango Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4510,
    "place_name":"Caboolture",
    "state_name":"Queensland"
  },
  {
    "postcode":4510,
    "place_name":"Rocksberg",
    "state_name":"Queensland"
  },
  {
    "postcode":4510,
    "place_name":"Upper Caboolture",
    "state_name":"Queensland"
  },
  {
    "postcode":4510,
    "place_name":"Caboolture BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4510,
    "place_name":"Caboolture South",
    "state_name":"Queensland"
  },
  {
    "postcode":4510,
    "place_name":"Donnybrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4510,
    "place_name":"Moodlu",
    "state_name":"Queensland"
  },
  {
    "postcode":4510,
    "place_name":"Toorbul",
    "state_name":"Queensland"
  },
  {
    "postcode":4510,
    "place_name":"Bellmere",
    "state_name":"Queensland"
  },
  {
    "postcode":4510,
    "place_name":"Meldale",
    "state_name":"Queensland"
  },
  {
    "postcode":4510,
    "place_name":"Beachmere",
    "state_name":"Queensland"
  },
  {
    "postcode":4511,
    "place_name":"Godwin Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4511,
    "place_name":"Sandstone Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4511,
    "place_name":"Ningi",
    "state_name":"Queensland"
  },
  {
    "postcode":4512,
    "place_name":"Wamuran",
    "state_name":"Queensland"
  },
  {
    "postcode":4512,
    "place_name":"Wamuran Basin",
    "state_name":"Queensland"
  },
  {
    "postcode":4512,
    "place_name":"Bracalba",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"D'Aguilar",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"Woodford",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"Mount Delaney",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"Villeneuve",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"Neurum",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"Bellthorpe",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"Stony Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"Stanmore",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"Cedarton",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"Delaneys Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"Mount Archer",
    "state_name":"Queensland"
  },
  {
    "postcode":4514,
    "place_name":"Commissioners Flat",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Hazeldean",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Jimna",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Royston",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Kilcoy",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Sandy Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Woolmar",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Winya",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Sheep Station Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Mount Kilcoy",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Hazledean",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Glenfern",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Monsildale",
    "state_name":"Queensland"
  },
  {
    "postcode":4515,
    "place_name":"Kingaham",
    "state_name":"Queensland"
  },
  {
    "postcode":4516,
    "place_name":"Elimbah",
    "state_name":"Queensland"
  },
  {
    "postcode":4517,
    "place_name":"Beerburrum",
    "state_name":"Queensland"
  },
  {
    "postcode":4518,
    "place_name":"Glass House Mountains",
    "state_name":"Queensland"
  },
  {
    "postcode":4519,
    "place_name":"Beerwah",
    "state_name":"Queensland"
  },
  {
    "postcode":4519,
    "place_name":"Crohamhurst",
    "state_name":"Queensland"
  },
  {
    "postcode":4519,
    "place_name":"Peachester",
    "state_name":"Queensland"
  },
  {
    "postcode":4519,
    "place_name":"Coochin Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Mount Samson",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Samford Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Mount Nebo",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Kobble Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Cedar Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Yugar",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Highvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Mount Glorious",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Samford Village",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Wights Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Closeburn",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Samford",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Draper",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Jollys Lookout",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Armstrong Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Enoggera Reservoir",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Samsonvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4520,
    "place_name":"Camp Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4521,
    "place_name":"Campbells Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4521,
    "place_name":"Dayboro",
    "state_name":"Queensland"
  },
  {
    "postcode":4521,
    "place_name":"Ocean View",
    "state_name":"Queensland"
  },
  {
    "postcode":4521,
    "place_name":"Mount Pleasant",
    "state_name":"Queensland"
  },
  {
    "postcode":4521,
    "place_name":"Mount Mee",
    "state_name":"Queensland"
  },
  {
    "postcode":4521,
    "place_name":"Rush Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4521,
    "place_name":"Laceys Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4521,
    "place_name":"King Scrub",
    "state_name":"Queensland"
  },
  {
    "postcode":4550,
    "place_name":"Landsborough",
    "state_name":"Queensland"
  },
  {
    "postcode":4550,
    "place_name":"Mount Mellum",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Kings Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Shelly Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Aroona",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Little Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Caloundra BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Bells Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Golden Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Currimundi",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Battery Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Pelican Waters",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Caloundra",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Moffat Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Caloundra DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Caloundra West",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Meridan Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4551,
    "place_name":"Dicky Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Booroobin",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Maleny",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"North Maleny",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Curramore",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Cambroon",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Reesville",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Bald Knob",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Elaman Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Conondale",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Balmoral Ridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Crystal Waters",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Wootha",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Witta",
    "state_name":"Queensland"
  },
  {
    "postcode":4552,
    "place_name":"Harper Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4553,
    "place_name":"Glenview",
    "state_name":"Queensland"
  },
  {
    "postcode":4553,
    "place_name":"Mooloolah Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4553,
    "place_name":"Mooloolah",
    "state_name":"Queensland"
  },
  {
    "postcode":4553,
    "place_name":"Diamond Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4553,
    "place_name":"Palmview",
    "state_name":"Queensland"
  },
  {
    "postcode":4554,
    "place_name":"Ilkley",
    "state_name":"Queensland"
  },
  {
    "postcode":4554,
    "place_name":"Eudlo",
    "state_name":"Queensland"
  },
  {
    "postcode":4555,
    "place_name":"Chevallum",
    "state_name":"Queensland"
  },
  {
    "postcode":4555,
    "place_name":"Palmwoods",
    "state_name":"Queensland"
  },
  {
    "postcode":4555,
    "place_name":"Hunchy",
    "state_name":"Queensland"
  },
  {
    "postcode":4555,
    "place_name":"Landers Shoot",
    "state_name":"Queensland"
  },
  {
    "postcode":4556,
    "place_name":"Mons",
    "state_name":"Queensland"
  },
  {
    "postcode":4556,
    "place_name":"Forest Glen",
    "state_name":"Queensland"
  },
  {
    "postcode":4556,
    "place_name":"Sippy Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4556,
    "place_name":"Buderim",
    "state_name":"Queensland"
  },
  {
    "postcode":4556,
    "place_name":"Kunda Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4556,
    "place_name":"Tanawha",
    "state_name":"Queensland"
  },
  {
    "postcode":4557,
    "place_name":"Mountain Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4557,
    "place_name":"Mooloolaba",
    "state_name":"Queensland"
  },
  {
    "postcode":4558,
    "place_name":"Maroochydore DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4558,
    "place_name":"Sunshine Plaza",
    "state_name":"Queensland"
  },
  {
    "postcode":4558,
    "place_name":"Maroochydore Bc",
    "state_name":"Queensland"
  },
  {
    "postcode":4558,
    "place_name":"Maroochydore",
    "state_name":"Queensland"
  },
  {
    "postcode":4558,
    "place_name":"Kuluin",
    "state_name":"Queensland"
  },
  {
    "postcode":4558,
    "place_name":"Cotton Tree",
    "state_name":"Queensland"
  },
  {
    "postcode":4559,
    "place_name":"Woombye",
    "state_name":"Queensland"
  },
  {
    "postcode":4559,
    "place_name":"Diddillibah",
    "state_name":"Queensland"
  },
  {
    "postcode":4559,
    "place_name":"Kiels Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4559,
    "place_name":"West Woombye",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Parklands",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Nambour BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Burnside",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Towen Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Rosemount",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Kiamba",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Kulangoor",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Nambour",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Dulong",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Image Flat",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Mapleton",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Highworth",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Perwillowen",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Coes Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Montville",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Nambour DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Cooloolabin",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Sunshine Coast Mc",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Nambour West",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Kureelpa",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Flaxton",
    "state_name":"Queensland"
  },
  {
    "postcode":4560,
    "place_name":"Bli Bli",
    "state_name":"Queensland"
  },
  {
    "postcode":4561,
    "place_name":"Yandina",
    "state_name":"Queensland"
  },
  {
    "postcode":4561,
    "place_name":"Valdora",
    "state_name":"Queensland"
  },
  {
    "postcode":4561,
    "place_name":"Yandina Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4561,
    "place_name":"Maroochy River",
    "state_name":"Queensland"
  },
  {
    "postcode":4561,
    "place_name":"Ninderry",
    "state_name":"Queensland"
  },
  {
    "postcode":4561,
    "place_name":"Bridges",
    "state_name":"Queensland"
  },
  {
    "postcode":4561,
    "place_name":"North Arm",
    "state_name":"Queensland"
  },
  {
    "postcode":4562,
    "place_name":"Belli Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4562,
    "place_name":"Doonan",
    "state_name":"Queensland"
  },
  {
    "postcode":4562,
    "place_name":"Verrierdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4562,
    "place_name":"Weyba Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4562,
    "place_name":"Eumundi",
    "state_name":"Queensland"
  },
  {
    "postcode":4562,
    "place_name":"Eerwah Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4563,
    "place_name":"Carters Ridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4563,
    "place_name":"Black Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4563,
    "place_name":"Cooroy Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4563,
    "place_name":"Tinbeerwah",
    "state_name":"Queensland"
  },
  {
    "postcode":4563,
    "place_name":"Cooroy",
    "state_name":"Queensland"
  },
  {
    "postcode":4563,
    "place_name":"Ridgewood",
    "state_name":"Queensland"
  },
  {
    "postcode":4563,
    "place_name":"Lake Macdonald",
    "state_name":"Queensland"
  },
  {
    "postcode":4564,
    "place_name":"Pacific Paradise",
    "state_name":"Queensland"
  },
  {
    "postcode":4564,
    "place_name":"Marcoola",
    "state_name":"Queensland"
  },
  {
    "postcode":4564,
    "place_name":"Mudjimba",
    "state_name":"Queensland"
  },
  {
    "postcode":4564,
    "place_name":"Twin Waters",
    "state_name":"Queensland"
  },
  {
    "postcode":4565,
    "place_name":"Ringtail Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4565,
    "place_name":"Cootharaba",
    "state_name":"Queensland"
  },
  {
    "postcode":4565,
    "place_name":"Boreen Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4565,
    "place_name":"Noosa North Shore",
    "state_name":"Queensland"
  },
  {
    "postcode":4565,
    "place_name":"Cooroibah",
    "state_name":"Queensland"
  },
  {
    "postcode":4565,
    "place_name":"Tewantin",
    "state_name":"Queensland"
  },
  {
    "postcode":4565,
    "place_name":"North Shore",
    "state_name":"Queensland"
  },
  {
    "postcode":4566,
    "place_name":"Noosaville DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4566,
    "place_name":"Noosaville",
    "state_name":"Queensland"
  },
  {
    "postcode":4567,
    "place_name":"Castaways Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4567,
    "place_name":"Sunshine Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4567,
    "place_name":"Sunrise Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4567,
    "place_name":"Noosa Heads",
    "state_name":"Queensland"
  },
  {
    "postcode":4568,
    "place_name":"Pinbarren",
    "state_name":"Queensland"
  },
  {
    "postcode":4568,
    "place_name":"Federal",
    "state_name":"Queensland"
  },
  {
    "postcode":4568,
    "place_name":"Pomona",
    "state_name":"Queensland"
  },
  {
    "postcode":4569,
    "place_name":"Cooran",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Bollier",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Chatsworth",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Widgee",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Gympie",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Theebine",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Calgoa",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Nahrunda",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Traveston",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Lagoon Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Veteran",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Gunalda",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Southside",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Tamaree",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Kia Ora",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Langshaw",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Imbil",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Dagun",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Banks Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Kandanga",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"East Deep Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Amamoor",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Mooloo",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Wallu",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Victory Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Bells Bridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Canina",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Pie Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Upper Kandanga",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Woondum",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Kanigan",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Gympie DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Gilldora",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Glanmire",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Glenwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Cedar Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Curra",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Kybong",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Coles Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Toolara Forest",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Paterson",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Monkland",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Fishermans Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Mothar Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Widgee Crossing South",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Tandur",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Glen Echo",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Goomboorian",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Greens Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Wilsons Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Lake Borumba",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Araluen",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Corella",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Jones Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Neusa Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Lower Wonga",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Calico Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Two Mile",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Neerdie",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Miva",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Beenaam Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Downsfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Bella Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Woolooga",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Long Flat",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"The Palms",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Scrubby Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Wolvi",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Marodian",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Melawondi",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Munna Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Brooloo",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Tuchekoi",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Sexton",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Kandanga Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Glastonbury",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Anderleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Upper Glastonbury",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Marys Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"The Dawn",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Mcintosh Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Coondoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"North Deep Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Ross Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Scotchy Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Widgee Crossing North",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"Amamoor Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4570,
    "place_name":"St Mary",
    "state_name":"Queensland"
  },
  {
    "postcode":4571,
    "place_name":"Kin Kin",
    "state_name":"Queensland"
  },
  {
    "postcode":4571,
    "place_name":"Como",
    "state_name":"Queensland"
  },
  {
    "postcode":4572,
    "place_name":"Alexandra Headland",
    "state_name":"Queensland"
  },
  {
    "postcode":4573,
    "place_name":"Mount Coolum",
    "state_name":"Queensland"
  },
  {
    "postcode":4573,
    "place_name":"Peregian Springs",
    "state_name":"Queensland"
  },
  {
    "postcode":4573,
    "place_name":"Yaroomba",
    "state_name":"Queensland"
  },
  {
    "postcode":4573,
    "place_name":"Coolum Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4573,
    "place_name":"Point Arkwright",
    "state_name":"Queensland"
  },
  {
    "postcode":4573,
    "place_name":"Marcus Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4573,
    "place_name":"Peregian Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4574,
    "place_name":"Kenilworth",
    "state_name":"Queensland"
  },
  {
    "postcode":4574,
    "place_name":"Moy Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4574,
    "place_name":"Kidaman Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4574,
    "place_name":"Obi Obi",
    "state_name":"Queensland"
  },
  {
    "postcode":4574,
    "place_name":"Coolabine",
    "state_name":"Queensland"
  },
  {
    "postcode":4574,
    "place_name":"Gheerulla",
    "state_name":"Queensland"
  },
  {
    "postcode":4575,
    "place_name":"Bokarina",
    "state_name":"Queensland"
  },
  {
    "postcode":4575,
    "place_name":"Minyama",
    "state_name":"Queensland"
  },
  {
    "postcode":4575,
    "place_name":"Birtinya",
    "state_name":"Queensland"
  },
  {
    "postcode":4575,
    "place_name":"Parrearra",
    "state_name":"Queensland"
  },
  {
    "postcode":4575,
    "place_name":"Wurtulla",
    "state_name":"Queensland"
  },
  {
    "postcode":4575,
    "place_name":"Warana",
    "state_name":"Queensland"
  },
  {
    "postcode":4575,
    "place_name":"Buddina",
    "state_name":"Queensland"
  },
  {
    "postcode":4580,
    "place_name":"Tin Can Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4580,
    "place_name":"Cooloola Cove",
    "state_name":"Queensland"
  },
  {
    "postcode":4580,
    "place_name":"Cooloola",
    "state_name":"Queensland"
  },
  {
    "postcode":4581,
    "place_name":"Fraser Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4581,
    "place_name":"Inskip",
    "state_name":"Queensland"
  },
  {
    "postcode":4581,
    "place_name":"Eurong",
    "state_name":"Queensland"
  },
  {
    "postcode":4581,
    "place_name":"Orchid Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4581,
    "place_name":"Rainbow Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4600,
    "place_name":"Oakview",
    "state_name":"Queensland"
  },
  {
    "postcode":4600,
    "place_name":"Kilkivan",
    "state_name":"Queensland"
  },
  {
    "postcode":4600,
    "place_name":"Mudlo",
    "state_name":"Queensland"
  },
  {
    "postcode":4600,
    "place_name":"Cinnabar",
    "state_name":"Queensland"
  },
  {
    "postcode":4600,
    "place_name":"Black Snake",
    "state_name":"Queensland"
  },
  {
    "postcode":4601,
    "place_name":"Boonara",
    "state_name":"Queensland"
  },
  {
    "postcode":4601,
    "place_name":"Goomeribong",
    "state_name":"Queensland"
  },
  {
    "postcode":4601,
    "place_name":"Tansey",
    "state_name":"Queensland"
  },
  {
    "postcode":4601,
    "place_name":"Wrattens Forest",
    "state_name":"Queensland"
  },
  {
    "postcode":4601,
    "place_name":"Manyung",
    "state_name":"Queensland"
  },
  {
    "postcode":4601,
    "place_name":"Barambah",
    "state_name":"Queensland"
  },
  {
    "postcode":4601,
    "place_name":"Goomeri",
    "state_name":"Queensland"
  },
  {
    "postcode":4601,
    "place_name":"Kinbombi",
    "state_name":"Queensland"
  },
  {
    "postcode":4601,
    "place_name":"Manumbar",
    "state_name":"Queensland"
  },
  {
    "postcode":4601,
    "place_name":"Booubyjan",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Manyung",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Kitoba",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Windera",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Warnung",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Byee",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Redgate",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Moffatdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Oakdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Barlil",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Cherbourg",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Moondooner",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Crownthorpe",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Cloyna",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Wooroonden",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Silverleaf",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Murgon",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Cobbs Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Glenrock",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Merlwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Sunny Nook",
    "state_name":"Queensland"
  },
  {
    "postcode":4605,
    "place_name":"Tablelands",
    "state_name":"Queensland"
  },
  {
    "postcode":4606,
    "place_name":"Wondai",
    "state_name":"Queensland"
  },
  {
    "postcode":4606,
    "place_name":"Fairdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4606,
    "place_name":"Wheatlands",
    "state_name":"Queensland"
  },
  {
    "postcode":4606,
    "place_name":"Leafdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4606,
    "place_name":"Mp Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4606,
    "place_name":"Mount Mceuen",
    "state_name":"Queensland"
  },
  {
    "postcode":4606,
    "place_name":"Chelmsford",
    "state_name":"Queensland"
  },
  {
    "postcode":4606,
    "place_name":"Greenview",
    "state_name":"Queensland"
  },
  {
    "postcode":4606,
    "place_name":"Ficks Crossing",
    "state_name":"Queensland"
  },
  {
    "postcode":4608,
    "place_name":"Tingoora",
    "state_name":"Queensland"
  },
  {
    "postcode":4608,
    "place_name":"Cushnie",
    "state_name":"Queensland"
  },
  {
    "postcode":4608,
    "place_name":"Wooroolin",
    "state_name":"Queensland"
  },
  {
    "postcode":4608,
    "place_name":"Charlestown",
    "state_name":"Queensland"
  },
  {
    "postcode":4608,
    "place_name":"Wilkesdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Haly Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Ballogie",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Mannuem",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Boyneside",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Dangore",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Booie",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Wattle Grove",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Kumbia",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Coolabunia",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Memerambi",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Inverlaw",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Durong",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Hodgleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Ellesmere",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Durong South",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Ironpot",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Goodger",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Benair",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Taabinga",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Corndale",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Crawford",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Kingaroy",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Chahpingah",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Gordonbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Alice Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4610,
    "place_name":"Kingaroy DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4611,
    "place_name":"Marshlands",
    "state_name":"Queensland"
  },
  {
    "postcode":4611,
    "place_name":"Mondure",
    "state_name":"Queensland"
  },
  {
    "postcode":4612,
    "place_name":"Kawl Kawl",
    "state_name":"Queensland"
  },
  {
    "postcode":4612,
    "place_name":"Hivesville",
    "state_name":"Queensland"
  },
  {
    "postcode":4612,
    "place_name":"Wigton",
    "state_name":"Queensland"
  },
  {
    "postcode":4612,
    "place_name":"Stonelands",
    "state_name":"Queensland"
  },
  {
    "postcode":4612,
    "place_name":"Keysland",
    "state_name":"Queensland"
  },
  {
    "postcode":4613,
    "place_name":"Abbeywood",
    "state_name":"Queensland"
  },
  {
    "postcode":4613,
    "place_name":"Stalworth",
    "state_name":"Queensland"
  },
  {
    "postcode":4613,
    "place_name":"Brigooda",
    "state_name":"Queensland"
  },
  {
    "postcode":4613,
    "place_name":"Okeden",
    "state_name":"Queensland"
  },
  {
    "postcode":4613,
    "place_name":"Boondooma",
    "state_name":"Queensland"
  },
  {
    "postcode":4613,
    "place_name":"Melrose",
    "state_name":"Queensland"
  },
  {
    "postcode":4613,
    "place_name":"Kinleymore",
    "state_name":"Queensland"
  },
  {
    "postcode":4613,
    "place_name":"Coverty",
    "state_name":"Queensland"
  },
  {
    "postcode":4613,
    "place_name":"Proston",
    "state_name":"Queensland"
  },
  {
    "postcode":4613,
    "place_name":"Speedwell",
    "state_name":"Queensland"
  },
  {
    "postcode":4614,
    "place_name":"Yarraman",
    "state_name":"Queensland"
  },
  {
    "postcode":4614,
    "place_name":"Upper Yarraman",
    "state_name":"Queensland"
  },
  {
    "postcode":4614,
    "place_name":"Neumgna",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Wengenville",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Glan Devon",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"South Nanango",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Nanango",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Wyalla",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Tarong",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Maidenwell",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Brooklands",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Elgin Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Wattle Camp",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Johnstown",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Bullcamp",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Barker Creek Flat",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"East Nanango",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Kunioon",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Pimpimbudgee",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Runnymede",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"Sandy Ridges",
    "state_name":"Queensland"
  },
  {
    "postcode":4615,
    "place_name":"South East Nanango",
    "state_name":"Queensland"
  },
  {
    "postcode":4620,
    "place_name":"Aramara",
    "state_name":"Queensland"
  },
  {
    "postcode":4620,
    "place_name":"Brooweena",
    "state_name":"Queensland"
  },
  {
    "postcode":4620,
    "place_name":"Gungaloon",
    "state_name":"Queensland"
  },
  {
    "postcode":4620,
    "place_name":"Teebar",
    "state_name":"Queensland"
  },
  {
    "postcode":4620,
    "place_name":"Glenbar",
    "state_name":"Queensland"
  },
  {
    "postcode":4620,
    "place_name":"Gigoomgan",
    "state_name":"Queensland"
  },
  {
    "postcode":4620,
    "place_name":"Woocoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4620,
    "place_name":"Malarga",
    "state_name":"Queensland"
  },
  {
    "postcode":4620,
    "place_name":"North Aramara",
    "state_name":"Queensland"
  },
  {
    "postcode":4620,
    "place_name":"Doongul",
    "state_name":"Queensland"
  },
  {
    "postcode":4621,
    "place_name":"Lakeside",
    "state_name":"Queensland"
  },
  {
    "postcode":4621,
    "place_name":"Degilbo",
    "state_name":"Queensland"
  },
  {
    "postcode":4621,
    "place_name":"Coalstoun Lakes",
    "state_name":"Queensland"
  },
  {
    "postcode":4621,
    "place_name":"Woowoonga",
    "state_name":"Queensland"
  },
  {
    "postcode":4621,
    "place_name":"Biggenden",
    "state_name":"Queensland"
  },
  {
    "postcode":4621,
    "place_name":"Dallarnil",
    "state_name":"Queensland"
  },
  {
    "postcode":4621,
    "place_name":"Coringa",
    "state_name":"Queensland"
  },
  {
    "postcode":4621,
    "place_name":"Boompa",
    "state_name":"Queensland"
  },
  {
    "postcode":4621,
    "place_name":"Wateranga",
    "state_name":"Queensland"
  },
  {
    "postcode":4621,
    "place_name":"Didcot",
    "state_name":"Queensland"
  },
  {
    "postcode":4621,
    "place_name":"Golden Fleece",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Wetheron",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Toondahra",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Dirnbir",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Bon Accord",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Ideraway",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Mount Steadman",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Yenda",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Dundarrah",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Byrnestown",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Mount Lawless",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Gooroolba",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Stockhaven",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Aranbanga",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Gayndah",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Deep Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Reids Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Wahoon",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Humphery",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Binjour",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Wilson Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Mount Debateable",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Penwhaupell",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Ban Ban",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Blairmore",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Mingo",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Barlyne",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Ginoondan",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Campbell Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Pile Gully",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"The Limits",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Woodmillar",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Branch Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Harriet",
    "state_name":"Queensland"
  },
  {
    "postcode":4625,
    "place_name":"Ban Ban Springs",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Riverleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Obil Bil",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Mundubbera",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Brovinia",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Mundowran",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Hawkwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Monogorilby",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Glenrae",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"O'Bil Bil",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Old Cooranga",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Derri Derra",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Philpott",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Coonambula",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Dykehead",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Cattle Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Gurgeena",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Beeron",
    "state_name":"Queensland"
  },
  {
    "postcode":4626,
    "place_name":"Boynewood",
    "state_name":"Queensland"
  },
  {
    "postcode":4627,
    "place_name":"Eidsvold",
    "state_name":"Queensland"
  },
  {
    "postcode":4627,
    "place_name":"Ceratodus",
    "state_name":"Queensland"
  },
  {
    "postcode":4627,
    "place_name":"Malmoe",
    "state_name":"Queensland"
  },
  {
    "postcode":4627,
    "place_name":"Wuruma Dam",
    "state_name":"Queensland"
  },
  {
    "postcode":4627,
    "place_name":"Grosvenor",
    "state_name":"Queensland"
  },
  {
    "postcode":4627,
    "place_name":"Abercorn",
    "state_name":"Queensland"
  },
  {
    "postcode":4627,
    "place_name":"Cynthia",
    "state_name":"Queensland"
  },
  {
    "postcode":4627,
    "place_name":"Eidsvold West",
    "state_name":"Queensland"
  },
  {
    "postcode":4627,
    "place_name":"Cheltenham",
    "state_name":"Queensland"
  },
  {
    "postcode":4627,
    "place_name":"Eidsvold East",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Tellebang",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Kalpowar",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Bancroft",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Harrami",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Monto",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Selene",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Yarrol",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Cannindah",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Kapaldo",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Cania",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Three Moon",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Ventnor",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Mungungo",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Mulgildie",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Rawbelle",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Bukali",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Coominglah",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Splinter Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Moonford",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Glenleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Langley",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Monal",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Dalga",
    "state_name":"Queensland"
  },
  {
    "postcode":4630,
    "place_name":"Coominglah Forest",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Maryborough",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Thinoomba",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Dundathu",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"The Dimonds",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Maryborough DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Gootchie",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Boonooroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Tinana South",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Antigua",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Grahams Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Yengarie",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Mount Urah",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Owanyilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Maaroom",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Yerra",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Tandora",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Bauple",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Pilerwa",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Mungar",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Tinnanbar",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Tuan",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Oakhurst",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Granville",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Mount Steadman",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Tiaro",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Pallas Street Maryborough",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Poona",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Tuan Forest",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Aldershot",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Bidwill",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Netherby",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Talegalla Weir",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Tinana",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Prawle",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Maryborough West",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Boonooroo Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Bauple Forest",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Pioneers Rest",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"St Helens",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Magnolia",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Dunmora",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Ferney",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Gundiah",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"St Mary",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Duckinwilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Walkers Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Glenorchy",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Teddington",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Beaver Rock",
    "state_name":"Queensland"
  },
  {
    "postcode":4650,
    "place_name":"Island Plantation",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"River Heads",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Hervey Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Kingfisher Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Walliebum",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Wondunna",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Sunshine Acres",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Scarness",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Susan River",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Booral",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Toogoom",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Nikenbah",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Hervey Bay Dc",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Kawungan",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Kingfisher Bay Resort",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Pialba",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Great Sandy Strait",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Craignish",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Happy Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Urangan",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Bunya Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Torquay",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Walligan",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Eli Waters",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Point Vernon",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Dundowran",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Takura",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Urraween",
    "state_name":"Queensland"
  },
  {
    "postcode":4655,
    "place_name":"Dundowran Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4659,
    "place_name":"Beelbi Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4659,
    "place_name":"Pacific Haven",
    "state_name":"Queensland"
  },
  {
    "postcode":4659,
    "place_name":"Burrum Heads",
    "state_name":"Queensland"
  },
  {
    "postcode":4659,
    "place_name":"Burgowan",
    "state_name":"Queensland"
  },
  {
    "postcode":4659,
    "place_name":"Howard",
    "state_name":"Queensland"
  },
  {
    "postcode":4659,
    "place_name":"Burrum Town",
    "state_name":"Queensland"
  },
  {
    "postcode":4659,
    "place_name":"Burrum River",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Woodgate",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Apple Tree Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Cordalba",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Abington",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"North Isis",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Doolbi",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Redridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Goodwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Buxton",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Horton",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Childers",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Cherwell",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"South Isis",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Gregory River",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Eureka",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Isis Central",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Kullogum",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Farnsfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Promisedland",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"Isis River",
    "state_name":"Queensland"
  },
  {
    "postcode":4660,
    "place_name":"North Gregory",
    "state_name":"Queensland"
  },
  {
    "postcode":4662,
    "place_name":"Torbanlea",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Bundaberg North",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Kepnock",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Moore Park Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Bundaberg",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Gooburrum",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Bucca",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Bundaberg Dc",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Moorland",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Elliott",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Rubyanna",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Svensson Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Kalkie",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Bargara",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Watalgan",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Mullett Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Fairymead",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Avenell Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Walkervale",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Bundaberg South",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Avoca",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Calavos",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Oakwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Burnett Heads",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Millbank",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Meadowvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Elliott Heads",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Welcome Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Sharon",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Avondale",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Thabeban",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Winfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"South Kolan",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Norville",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Kensington",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Abbotsford",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Kinkuna",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Alloway",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Qunaba",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Branyan",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Woongarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Innes Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Bundaberg West",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Coonarr",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Bundaberg Central",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"South Bingera",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Bundaberg East",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Ashfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Electra",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Mon Repos",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Givelda",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Windermere",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Pine Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4670,
    "place_name":"Coral Cove",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Mount Perry",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Redhill Farms",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Bungadoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Monduran",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Wallaville",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Skyring Reserve",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Booyal",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Molangul",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Boolboonda",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Doughboy",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Gin Gin",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Drinan",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Tirroan",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Duingal",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Dalysford",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Maroondan",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Delan",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Good Night",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Wonbah",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Lake Monduran",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Kolonga",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Mungy",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"St Agnes",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Gaeta",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Moolboolaman",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Bullyard",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Damascus",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Mcilwraith",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Morganville",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Horse Camp",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Wonbah Forest",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"New Moonta",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Nearum",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"Takilberan",
    "state_name":"Queensland"
  },
  {
    "postcode":4671,
    "place_name":"St Kilda",
    "state_name":"Queensland"
  },
  {
    "postcode":4673,
    "place_name":"Yandaran",
    "state_name":"Queensland"
  },
  {
    "postcode":4673,
    "place_name":"Waterloo",
    "state_name":"Queensland"
  },
  {
    "postcode":4673,
    "place_name":"Littabella",
    "state_name":"Queensland"
  },
  {
    "postcode":4673,
    "place_name":"Miara",
    "state_name":"Queensland"
  },
  {
    "postcode":4674,
    "place_name":"Berajondo",
    "state_name":"Queensland"
  },
  {
    "postcode":4674,
    "place_name":"Euleilah",
    "state_name":"Queensland"
  },
  {
    "postcode":4674,
    "place_name":"Oyster Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4674,
    "place_name":"Baffle Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4674,
    "place_name":"Deepwater",
    "state_name":"Queensland"
  },
  {
    "postcode":4674,
    "place_name":"Taunton",
    "state_name":"Queensland"
  },
  {
    "postcode":4674,
    "place_name":"Rules Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4674,
    "place_name":"Mount Maria",
    "state_name":"Queensland"
  },
  {
    "postcode":4674,
    "place_name":"Rosedale",
    "state_name":"Queensland"
  },
  {
    "postcode":4676,
    "place_name":"Gindoran",
    "state_name":"Queensland"
  },
  {
    "postcode":4676,
    "place_name":"Lowmead",
    "state_name":"Queensland"
  },
  {
    "postcode":4677,
    "place_name":"Miriam Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4677,
    "place_name":"Eurimbula",
    "state_name":"Queensland"
  },
  {
    "postcode":4677,
    "place_name":"Colosseum",
    "state_name":"Queensland"
  },
  {
    "postcode":4677,
    "place_name":"Agnes Water",
    "state_name":"Queensland"
  },
  {
    "postcode":4677,
    "place_name":"Seventeen Seventy",
    "state_name":"Queensland"
  },
  {
    "postcode":4677,
    "place_name":"Mount Tom",
    "state_name":"Queensland"
  },
  {
    "postcode":4677,
    "place_name":"Round Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4677,
    "place_name":"Captain Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4678,
    "place_name":"Rodds Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4678,
    "place_name":"Foreshores",
    "state_name":"Queensland"
  },
  {
    "postcode":4678,
    "place_name":"Turkey Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4678,
    "place_name":"Bororen",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Glen Eden",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Gladstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Beecher",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Callemondah",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Byellee",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Tannum Sands",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Heron Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Burua",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Benaraby",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Boyne Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Kirkwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"South End",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Kin Kora",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Gladstone BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"West Stowe",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Telina",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Wooderson",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Builyan",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Gladstone Central",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Boynedale",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Barney Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Iveragh",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"River Ranch",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"South Gladstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Boyne Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Wurdong Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Tablelands",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Clinton",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"O'Connell",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"West Gladstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Taragoola",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Gladstone DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"South Trees",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"New Auckland",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Toolooa",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Diglum",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Calliope",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Sun Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Curtis Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Gladstone Harbour",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Ubobo",
    "state_name":"Queensland"
  },
  {
    "postcode":4680,
    "place_name":"Mount Alma",
    "state_name":"Queensland"
  },
  {
    "postcode":4694,
    "place_name":"Targinnie",
    "state_name":"Queensland"
  },
  {
    "postcode":4694,
    "place_name":"Aldoga",
    "state_name":"Queensland"
  },
  {
    "postcode":4694,
    "place_name":"Targinie",
    "state_name":"Queensland"
  },
  {
    "postcode":4694,
    "place_name":"Yarwun",
    "state_name":"Queensland"
  },
  {
    "postcode":4695,
    "place_name":"Bracewell",
    "state_name":"Queensland"
  },
  {
    "postcode":4695,
    "place_name":"The Narrows",
    "state_name":"Queensland"
  },
  {
    "postcode":4695,
    "place_name":"Ambrose",
    "state_name":"Queensland"
  },
  {
    "postcode":4695,
    "place_name":"Darts Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4695,
    "place_name":"Mount Larcom",
    "state_name":"Queensland"
  },
  {
    "postcode":4695,
    "place_name":"Machine Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4695,
    "place_name":"East End",
    "state_name":"Queensland"
  },
  {
    "postcode":4697,
    "place_name":"Raglan",
    "state_name":"Queensland"
  },
  {
    "postcode":4699,
    "place_name":"Port Alma",
    "state_name":"Queensland"
  },
  {
    "postcode":4699,
    "place_name":"Bajool",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"Fairy Bower",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"Rockhampton City",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"Wandal",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"West Rockhampton",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"Great Keppel Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"The Range",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"Rockhampton Hospital",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"Rockhampton",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"The Keppels",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"Allenstown",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"Depot Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4700,
    "place_name":"Port Curtis",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Nerimbera",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Central Queensland University",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Koongal",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Nankin",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Red Hill Rockhampton",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"The Common",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Rockyview",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Kawana",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"North Rockhampton",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Berserker",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Sandringham",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Lakes Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Ironpot",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Frenchville",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Mount Archer",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Park Avenue",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Greenlake",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Norman Gardens",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Limestone Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4701,
    "place_name":"Rockhampton DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Rolleston",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Westwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Smoky Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Yaraka",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Cawarral",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"South Yaamba",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Milman",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Garnant",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Stanwell",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Anakie",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Morinish",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Goomally",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Alton Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Plum Tree",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Banana",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Mimosa",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Willows",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Willows Gemfields",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Kunwarara",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Joskeleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Bluff",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Rossmoya",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Gracemere",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Canal Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Jambin",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Canoona",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Goovigen",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Dumpy Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Coowonga",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Comet",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Mount Chalmers",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Gainsford",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Gindie",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Dalma",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Pink Lily",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Stanage",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"The Caves",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Dululu",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Bushley",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Jardine",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Keppel Sands",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Kalapa",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Argoon",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Kokotungo",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Wowan",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Shoalwater",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Tungamull",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Woolein",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Dingo",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Rubyvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Etna Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Bingegang",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Baralaba",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Alsace",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Ulogie",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Alberta",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Coorumbene",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Marmor",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Blackdown",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Coorooman",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Wooroona",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Wycarbah",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Mackenzie",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Wallaroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Kabra",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Boolburra",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Yalleroi",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Bouldercombe",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Thompson Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Dixalea",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Jellinbah",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Goowarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Stewarton",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Midgee",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Lowesby",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Sapphire",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Central Queensland Mc",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Gogango",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Balcomba",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Parkhurst",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Barnard",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Nine Mile",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Ridgelands",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Consuelo",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Glenroy",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Coomoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Morinish South",
    "state_name":"Queensland"
  },
  {
    "postcode":4702,
    "place_name":"Pheasant Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Byfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Bungundarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Adelaide Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Hidden Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Yeppoon",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Maryvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Bangalee",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Lake Mary",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Mulambin",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Causeway Lake",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Inverness",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Mulara",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Cooee Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Stockyard",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Tanby",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Cobraball",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Barmoya",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Farnborough",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Taranganba",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Taroomball",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Bondoola",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Kinka Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Weerriba",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Rosslyn",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Meikleville Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Pacific Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Barlows Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Lammermoor",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Barmaryee",
    "state_name":"Queensland"
  },
  {
    "postcode":4703,
    "place_name":"Woodbury",
    "state_name":"Queensland"
  },
  {
    "postcode":4704,
    "place_name":"Wattlebank",
    "state_name":"Queensland"
  },
  {
    "postcode":4704,
    "place_name":"Yaamba",
    "state_name":"Queensland"
  },
  {
    "postcode":4705,
    "place_name":"Mackenzie River",
    "state_name":"Queensland"
  },
  {
    "postcode":4705,
    "place_name":"Lotus Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4705,
    "place_name":"Marlborough",
    "state_name":"Queensland"
  },
  {
    "postcode":4705,
    "place_name":"Mount Gardiner",
    "state_name":"Queensland"
  },
  {
    "postcode":4705,
    "place_name":"Clarke Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4706,
    "place_name":"Ogmore",
    "state_name":"Queensland"
  },
  {
    "postcode":4707,
    "place_name":"St Lawrence",
    "state_name":"Queensland"
  },
  {
    "postcode":4707,
    "place_name":"The Percy Group",
    "state_name":"Queensland"
  },
  {
    "postcode":4707,
    "place_name":"Collaroy",
    "state_name":"Queensland"
  },
  {
    "postcode":4709,
    "place_name":"Tieri",
    "state_name":"Queensland"
  },
  {
    "postcode":4710,
    "place_name":"Emu Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4710,
    "place_name":"Zilzie",
    "state_name":"Queensland"
  },
  {
    "postcode":4711,
    "place_name":"Glendale",
    "state_name":"Queensland"
  },
  {
    "postcode":4711,
    "place_name":"Glenlee",
    "state_name":"Queensland"
  },
  {
    "postcode":4712,
    "place_name":"Duaringa",
    "state_name":"Queensland"
  },
  {
    "postcode":4713,
    "place_name":"Woorabinda",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Hamilton Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Baree",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Wura",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Walterhall",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Struck Oil",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Mount Morgan",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Trotter Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Moongan",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Nine Mile Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Horse Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Leydens Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Fletcher Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Walmul",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Boulder Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"The Mine",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Limestone",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Oakey Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4714,
    "place_name":"Johnsons Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4715,
    "place_name":"Biloela",
    "state_name":"Queensland"
  },
  {
    "postcode":4715,
    "place_name":"Tarramba",
    "state_name":"Queensland"
  },
  {
    "postcode":4715,
    "place_name":"Prospect",
    "state_name":"Queensland"
  },
  {
    "postcode":4715,
    "place_name":"Greycliffe",
    "state_name":"Queensland"
  },
  {
    "postcode":4715,
    "place_name":"Valentine Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4715,
    "place_name":"Mount Murchison",
    "state_name":"Queensland"
  },
  {
    "postcode":4715,
    "place_name":"Callide",
    "state_name":"Queensland"
  },
  {
    "postcode":4715,
    "place_name":"Dumgree",
    "state_name":"Queensland"
  },
  {
    "postcode":4715,
    "place_name":"Dakenba",
    "state_name":"Queensland"
  },
  {
    "postcode":4715,
    "place_name":"Castle Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4715,
    "place_name":"Orange Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4716,
    "place_name":"Thangool",
    "state_name":"Queensland"
  },
  {
    "postcode":4716,
    "place_name":"Lawgi Dawes",
    "state_name":"Queensland"
  },
  {
    "postcode":4717,
    "place_name":"Blackwater",
    "state_name":"Queensland"
  },
  {
    "postcode":4718,
    "place_name":"Roundstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4718,
    "place_name":"Kianga",
    "state_name":"Queensland"
  },
  {
    "postcode":4718,
    "place_name":"Bauhinia",
    "state_name":"Queensland"
  },
  {
    "postcode":4718,
    "place_name":"Moura",
    "state_name":"Queensland"
  },
  {
    "postcode":4718,
    "place_name":"Mungabunda",
    "state_name":"Queensland"
  },
  {
    "postcode":4718,
    "place_name":"Oombabeer",
    "state_name":"Queensland"
  },
  {
    "postcode":4718,
    "place_name":"Dromedary",
    "state_name":"Queensland"
  },
  {
    "postcode":4718,
    "place_name":"Rhydding",
    "state_name":"Queensland"
  },
  {
    "postcode":4718,
    "place_name":"Warnoah",
    "state_name":"Queensland"
  },
  {
    "postcode":4719,
    "place_name":"Theodore",
    "state_name":"Queensland"
  },
  {
    "postcode":4719,
    "place_name":"Glenmoral",
    "state_name":"Queensland"
  },
  {
    "postcode":4719,
    "place_name":"Camboon",
    "state_name":"Queensland"
  },
  {
    "postcode":4719,
    "place_name":"Lonesome Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4719,
    "place_name":"Isla",
    "state_name":"Queensland"
  },
  {
    "postcode":4719,
    "place_name":"Cracow",
    "state_name":"Queensland"
  },
  {
    "postcode":4720,
    "place_name":"Emerald",
    "state_name":"Queensland"
  },
  {
    "postcode":4720,
    "place_name":"Yamala",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Winchester",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Theresa Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Clermont",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Elgin",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Laglan",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Gemini Mountains",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Pasha",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Kilcummin",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Wolfang",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Frankfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Argyll",
    "state_name":"Queensland"
  },
  {
    "postcode":4721,
    "place_name":"Mistake Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4722,
    "place_name":"Springsure",
    "state_name":"Queensland"
  },
  {
    "postcode":4722,
    "place_name":"Orion",
    "state_name":"Queensland"
  },
  {
    "postcode":4722,
    "place_name":"Cona Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4722,
    "place_name":"Buckland",
    "state_name":"Queensland"
  },
  {
    "postcode":4722,
    "place_name":"Cairdbeign",
    "state_name":"Queensland"
  },
  {
    "postcode":4722,
    "place_name":"Nandowrie",
    "state_name":"Queensland"
  },
  {
    "postcode":4722,
    "place_name":"Wealwandangie",
    "state_name":"Queensland"
  },
  {
    "postcode":4723,
    "place_name":"Capella",
    "state_name":"Queensland"
  },
  {
    "postcode":4723,
    "place_name":"Retro",
    "state_name":"Queensland"
  },
  {
    "postcode":4723,
    "place_name":"Belcong",
    "state_name":"Queensland"
  },
  {
    "postcode":4723,
    "place_name":"Lowestoff",
    "state_name":"Queensland"
  },
  {
    "postcode":4723,
    "place_name":"Crinum",
    "state_name":"Queensland"
  },
  {
    "postcode":4723,
    "place_name":"Chirnside",
    "state_name":"Queensland"
  },
  {
    "postcode":4723,
    "place_name":"Khosh Bulduk",
    "state_name":"Queensland"
  },
  {
    "postcode":4723,
    "place_name":"Carbine Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4723,
    "place_name":"Hibernia",
    "state_name":"Queensland"
  },
  {
    "postcode":4723,
    "place_name":"Lilyvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4723,
    "place_name":"Mount Macarthur",
    "state_name":"Queensland"
  },
  {
    "postcode":4724,
    "place_name":"Alpha",
    "state_name":"Queensland"
  },
  {
    "postcode":4724,
    "place_name":"Pine Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4724,
    "place_name":"Sedgeford",
    "state_name":"Queensland"
  },
  {
    "postcode":4724,
    "place_name":"Hobartville",
    "state_name":"Queensland"
  },
  {
    "postcode":4724,
    "place_name":"Port Wine",
    "state_name":"Queensland"
  },
  {
    "postcode":4724,
    "place_name":"Beaufort",
    "state_name":"Queensland"
  },
  {
    "postcode":4724,
    "place_name":"Surbiton",
    "state_name":"Queensland"
  },
  {
    "postcode":4724,
    "place_name":"Drummondslope",
    "state_name":"Queensland"
  },
  {
    "postcode":4725,
    "place_name":"Barcaldine Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4725,
    "place_name":"Barcaldine",
    "state_name":"Queensland"
  },
  {
    "postcode":4725,
    "place_name":"Tara Station",
    "state_name":"Queensland"
  },
  {
    "postcode":4725,
    "place_name":"Patrick",
    "state_name":"Queensland"
  },
  {
    "postcode":4726,
    "place_name":"Galilee",
    "state_name":"Queensland"
  },
  {
    "postcode":4726,
    "place_name":"Pelican Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4726,
    "place_name":"Aramac",
    "state_name":"Queensland"
  },
  {
    "postcode":4727,
    "place_name":"Ilfracombe",
    "state_name":"Queensland"
  },
  {
    "postcode":4728,
    "place_name":"Jericho",
    "state_name":"Queensland"
  },
  {
    "postcode":4728,
    "place_name":"Mexico",
    "state_name":"Queensland"
  },
  {
    "postcode":4728,
    "place_name":"Dunrobin",
    "state_name":"Queensland"
  },
  {
    "postcode":4728,
    "place_name":"Garfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4730,
    "place_name":"Chorregon",
    "state_name":"Queensland"
  },
  {
    "postcode":4730,
    "place_name":"Morella",
    "state_name":"Queensland"
  },
  {
    "postcode":4730,
    "place_name":"Stonehenge",
    "state_name":"Queensland"
  },
  {
    "postcode":4730,
    "place_name":"Ernestina",
    "state_name":"Queensland"
  },
  {
    "postcode":4730,
    "place_name":"Longreach",
    "state_name":"Queensland"
  },
  {
    "postcode":4730,
    "place_name":"Maneroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4730,
    "place_name":"Camoola",
    "state_name":"Queensland"
  },
  {
    "postcode":4730,
    "place_name":"Tocal",
    "state_name":"Queensland"
  },
  {
    "postcode":4730,
    "place_name":"Vergemont",
    "state_name":"Queensland"
  },
  {
    "postcode":4731,
    "place_name":"Isisford",
    "state_name":"Queensland"
  },
  {
    "postcode":4732,
    "place_name":"Muttaburra",
    "state_name":"Queensland"
  },
  {
    "postcode":4732,
    "place_name":"Tablederry",
    "state_name":"Queensland"
  },
  {
    "postcode":4733,
    "place_name":"Corfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4735,
    "place_name":"Middleton",
    "state_name":"Queensland"
  },
  {
    "postcode":4735,
    "place_name":"Diamantina Lakes",
    "state_name":"Queensland"
  },
  {
    "postcode":4735,
    "place_name":"Winton",
    "state_name":"Queensland"
  },
  {
    "postcode":4735,
    "place_name":"Opalton",
    "state_name":"Queensland"
  },
  {
    "postcode":4736,
    "place_name":"Jundah",
    "state_name":"Queensland"
  },
  {
    "postcode":4737,
    "place_name":"Blue Mountain",
    "state_name":"Queensland"
  },
  {
    "postcode":4737,
    "place_name":"Campwin Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4737,
    "place_name":"Sarina",
    "state_name":"Queensland"
  },
  {
    "postcode":4737,
    "place_name":"Sunnyside",
    "state_name":"Queensland"
  },
  {
    "postcode":4737,
    "place_name":"Freshwater Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4737,
    "place_name":"Sarina Range",
    "state_name":"Queensland"
  },
  {
    "postcode":4737,
    "place_name":"Armstrong Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4737,
    "place_name":"Sarina Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4738,
    "place_name":"Ilbilbie",
    "state_name":"Queensland"
  },
  {
    "postcode":4738,
    "place_name":"Koumala",
    "state_name":"Queensland"
  },
  {
    "postcode":4739,
    "place_name":"Carmila",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"The Leap",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Mackay DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Mount Pleasant",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Bakers Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Rural View",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Blacks Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Alligator Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"West Mackay",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Cremorne",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Beaconsfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Dumbleton",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Munbura",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Mackay West",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Erakala",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Mackay Caneland",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Dolphin Heads",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Belmunda",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Eimeo",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Balnagowan",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Glenella",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"East Mackay",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Homebush",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Racecourse",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"North Mackay",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Paget",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Grasstree Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Slade Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Mackay South",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Planland",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Andergrove",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Dunnrock",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Habana",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Mackay North",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Balberra",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Alexandra",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Mcewens Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Coningsby",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Cape Hillsborough",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Rosella",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Ooralea",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Nindaroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Dundula",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Mount Jukes",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Haliday Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Te Kowai",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Richmond",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"South Mackay",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Foulden",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Sandiford",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Hay Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Mackay Harbour",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Mackay",
    "state_name":"Queensland"
  },
  {
    "postcode":4740,
    "place_name":"Chelona",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Kuttabul",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Ball Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Oakenden",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Pinnacle",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Eton North",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"South Molle",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Coppabella",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Eungella Hinterland",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Yalboroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Epsom",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Farleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Pleystowe",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Mackay Mc",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Daydream Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Lindeman Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Owens Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Gargett",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Brightly",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Clairview",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Brampton Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Long Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Mount Pelion",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Kinchant Dam",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Seaforth",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"North Eton",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Hazledean",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Eton",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Orkabie",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Mount Ossa",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Hampden",
    "state_name":"Queensland"
  },
  {
    "postcode":4741,
    "place_name":"Mount Charlton",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Strathfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Oxford",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Elphinstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Eaglefield",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Turrawulla",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Mount Britton",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Mt Britton",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Valkyrie",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Kemmis",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Burton",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Hail Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4742,
    "place_name":"Nebo",
    "state_name":"Queensland"
  },
  {
    "postcode":4743,
    "place_name":"Glenden",
    "state_name":"Queensland"
  },
  {
    "postcode":4743,
    "place_name":"Suttor",
    "state_name":"Queensland"
  },
  {
    "postcode":4744,
    "place_name":"Moranbah",
    "state_name":"Queensland"
  },
  {
    "postcode":4745,
    "place_name":"Dysart",
    "state_name":"Queensland"
  },
  {
    "postcode":4746,
    "place_name":"Middlemount",
    "state_name":"Queensland"
  },
  {
    "postcode":4746,
    "place_name":"May Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4750,
    "place_name":"Bucasia",
    "state_name":"Queensland"
  },
  {
    "postcode":4750,
    "place_name":"Shoal Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4751,
    "place_name":"Victoria Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4751,
    "place_name":"Walkerston",
    "state_name":"Queensland"
  },
  {
    "postcode":4751,
    "place_name":"Palmyra",
    "state_name":"Queensland"
  },
  {
    "postcode":4751,
    "place_name":"Greenmount",
    "state_name":"Queensland"
  },
  {
    "postcode":4753,
    "place_name":"Devereux Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4753,
    "place_name":"Marian",
    "state_name":"Queensland"
  },
  {
    "postcode":4754,
    "place_name":"Mount Martin",
    "state_name":"Queensland"
  },
  {
    "postcode":4754,
    "place_name":"Mia Mia",
    "state_name":"Queensland"
  },
  {
    "postcode":4754,
    "place_name":"Benholme",
    "state_name":"Queensland"
  },
  {
    "postcode":4754,
    "place_name":"Pinevale",
    "state_name":"Queensland"
  },
  {
    "postcode":4754,
    "place_name":"Mirani",
    "state_name":"Queensland"
  },
  {
    "postcode":4754,
    "place_name":"Dows Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4754,
    "place_name":"Septimus",
    "state_name":"Queensland"
  },
  {
    "postcode":4756,
    "place_name":"Netherdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4756,
    "place_name":"Finch Hatton",
    "state_name":"Queensland"
  },
  {
    "postcode":4757,
    "place_name":"Crediton",
    "state_name":"Queensland"
  },
  {
    "postcode":4757,
    "place_name":"Broken River",
    "state_name":"Queensland"
  },
  {
    "postcode":4757,
    "place_name":"Dalrymple Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4757,
    "place_name":"Eungella Dam",
    "state_name":"Queensland"
  },
  {
    "postcode":4757,
    "place_name":"Eungella",
    "state_name":"Queensland"
  },
  {
    "postcode":4798,
    "place_name":"Pindi Pindi",
    "state_name":"Queensland"
  },
  {
    "postcode":4798,
    "place_name":"Mentmore",
    "state_name":"Queensland"
  },
  {
    "postcode":4798,
    "place_name":"Calen",
    "state_name":"Queensland"
  },
  {
    "postcode":4798,
    "place_name":"St Helens Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4799,
    "place_name":"Bloomsbury",
    "state_name":"Queensland"
  },
  {
    "postcode":4799,
    "place_name":"Midge Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Palm Grove",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Dittmer",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Mount Julian",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Breadalbane",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Cannon Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Lethebrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Strathdickie",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Hamilton Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Mount Marlow",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Gunyarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Thoopara",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Preston",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Riordanvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Foxdale",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Crystal Brook",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Laguna Quays",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Kelsey Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Dingo Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Cape Gloucester",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Glen Isla",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Proserpine",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Conway",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Sugarloaf",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Gregory River",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Wilson Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Andromache",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Silver Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Goorganga Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Lake Proserpine",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Conway Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Mount Pluto",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Goorganga Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Brandy Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Cape Conway",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Myrtlevale",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Hideaway Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4800,
    "place_name":"Pauls Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4801,
    "place_name":"Hayman Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4802,
    "place_name":"Cannonvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4802,
    "place_name":"Flametree",
    "state_name":"Queensland"
  },
  {
    "postcode":4802,
    "place_name":"Airlie Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4802,
    "place_name":"Mount Rooper",
    "state_name":"Queensland"
  },
  {
    "postcode":4802,
    "place_name":"Woodwark",
    "state_name":"Queensland"
  },
  {
    "postcode":4802,
    "place_name":"Whitsundays",
    "state_name":"Queensland"
  },
  {
    "postcode":4802,
    "place_name":"Jubilee Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4802,
    "place_name":"Shute Harbour",
    "state_name":"Queensland"
  },
  {
    "postcode":4802,
    "place_name":"Mandalay",
    "state_name":"Queensland"
  },
  {
    "postcode":4803,
    "place_name":"Hamilton Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4804,
    "place_name":"Mount Coolon",
    "state_name":"Queensland"
  },
  {
    "postcode":4804,
    "place_name":"Collinsville",
    "state_name":"Queensland"
  },
  {
    "postcode":4804,
    "place_name":"Springlands",
    "state_name":"Queensland"
  },
  {
    "postcode":4804,
    "place_name":"Scottville",
    "state_name":"Queensland"
  },
  {
    "postcode":4804,
    "place_name":"Newlands",
    "state_name":"Queensland"
  },
  {
    "postcode":4804,
    "place_name":"Mount Wyatt",
    "state_name":"Queensland"
  },
  {
    "postcode":4805,
    "place_name":"Gumlu",
    "state_name":"Queensland"
  },
  {
    "postcode":4805,
    "place_name":"Bogie",
    "state_name":"Queensland"
  },
  {
    "postcode":4805,
    "place_name":"Bowen",
    "state_name":"Queensland"
  },
  {
    "postcode":4805,
    "place_name":"Merinda",
    "state_name":"Queensland"
  },
  {
    "postcode":4805,
    "place_name":"Guthalungra",
    "state_name":"Queensland"
  },
  {
    "postcode":4805,
    "place_name":"Queens Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4806,
    "place_name":"Carstairs",
    "state_name":"Queensland"
  },
  {
    "postcode":4806,
    "place_name":"Home Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4806,
    "place_name":"Wangaratta",
    "state_name":"Queensland"
  },
  {
    "postcode":4806,
    "place_name":"Inkerman",
    "state_name":"Queensland"
  },
  {
    "postcode":4806,
    "place_name":"Rangemore",
    "state_name":"Queensland"
  },
  {
    "postcode":4806,
    "place_name":"Wunjunga",
    "state_name":"Queensland"
  },
  {
    "postcode":4806,
    "place_name":"Kirknie",
    "state_name":"Queensland"
  },
  {
    "postcode":4806,
    "place_name":"Osborne",
    "state_name":"Queensland"
  },
  {
    "postcode":4806,
    "place_name":"Fredericksfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Jarvisfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Mcdesme",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Mount Kelly",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Ayr",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Dalbeg",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Swans Lagoon",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Alva",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Airville",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Clare",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Mona Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Rita Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Mulgrave",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Millaroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Airdmillan",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Eight Mile Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Rite Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Claredale",
    "state_name":"Queensland"
  },
  {
    "postcode":4807,
    "place_name":"Parkside",
    "state_name":"Queensland"
  },
  {
    "postcode":4808,
    "place_name":"Brandon",
    "state_name":"Queensland"
  },
  {
    "postcode":4808,
    "place_name":"Colevale",
    "state_name":"Queensland"
  },
  {
    "postcode":4809,
    "place_name":"Cromarty",
    "state_name":"Queensland"
  },
  {
    "postcode":4809,
    "place_name":"Horseshoe Lagoon",
    "state_name":"Queensland"
  },
  {
    "postcode":4809,
    "place_name":"Upper Haughton",
    "state_name":"Queensland"
  },
  {
    "postcode":4809,
    "place_name":"Giru",
    "state_name":"Queensland"
  },
  {
    "postcode":4809,
    "place_name":"Mount Surround",
    "state_name":"Queensland"
  },
  {
    "postcode":4809,
    "place_name":"Jerona",
    "state_name":"Queensland"
  },
  {
    "postcode":4809,
    "place_name":"Shirbourne",
    "state_name":"Queensland"
  },
  {
    "postcode":4809,
    "place_name":"Barratta",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Pallarenda",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Townsville Mc",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"North Ward",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Town Common",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Rowes Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"South Townsville",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Townsville DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Railway Estate",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Castle Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Shelly Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Townsville City",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Townsville",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Belgian Gardens",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"West End",
    "state_name":"Queensland"
  },
  {
    "postcode":4810,
    "place_name":"Cape Cleveland",
    "state_name":"Queensland"
  },
  {
    "postcode":4811,
    "place_name":"Cluden",
    "state_name":"Queensland"
  },
  {
    "postcode":4811,
    "place_name":"James Cook University",
    "state_name":"Queensland"
  },
  {
    "postcode":4811,
    "place_name":"Idalia",
    "state_name":"Queensland"
  },
  {
    "postcode":4811,
    "place_name":"Stuart",
    "state_name":"Queensland"
  },
  {
    "postcode":4811,
    "place_name":"Oonoonba",
    "state_name":"Queensland"
  },
  {
    "postcode":4811,
    "place_name":"Oak Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4811,
    "place_name":"Roseneath",
    "state_name":"Queensland"
  },
  {
    "postcode":4811,
    "place_name":"Mount Stuart",
    "state_name":"Queensland"
  },
  {
    "postcode":4811,
    "place_name":"Wulguru",
    "state_name":"Queensland"
  },
  {
    "postcode":4812,
    "place_name":"Pimlico",
    "state_name":"Queensland"
  },
  {
    "postcode":4812,
    "place_name":"Hyde Park Castletown",
    "state_name":"Queensland"
  },
  {
    "postcode":4812,
    "place_name":"Mundingburra",
    "state_name":"Queensland"
  },
  {
    "postcode":4812,
    "place_name":"Currajong",
    "state_name":"Queensland"
  },
  {
    "postcode":4812,
    "place_name":"Hermit Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4812,
    "place_name":"Mysterton",
    "state_name":"Queensland"
  },
  {
    "postcode":4812,
    "place_name":"Hyde Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4812,
    "place_name":"Gulliver",
    "state_name":"Queensland"
  },
  {
    "postcode":4812,
    "place_name":"Rosslea",
    "state_name":"Queensland"
  },
  {
    "postcode":4813,
    "place_name":"Townsville Milpo",
    "state_name":"Queensland"
  },
  {
    "postcode":4814,
    "place_name":"Garbutt",
    "state_name":"Queensland"
  },
  {
    "postcode":4814,
    "place_name":"Garbutt East",
    "state_name":"Queensland"
  },
  {
    "postcode":4814,
    "place_name":"Murray",
    "state_name":"Queensland"
  },
  {
    "postcode":4814,
    "place_name":"Mount Louisa",
    "state_name":"Queensland"
  },
  {
    "postcode":4814,
    "place_name":"Douglas",
    "state_name":"Queensland"
  },
  {
    "postcode":4814,
    "place_name":"Heatley",
    "state_name":"Queensland"
  },
  {
    "postcode":4814,
    "place_name":"Aitkenvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4814,
    "place_name":"Vincent",
    "state_name":"Queensland"
  },
  {
    "postcode":4814,
    "place_name":"Annandale",
    "state_name":"Queensland"
  },
  {
    "postcode":4814,
    "place_name":"Cranbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4814,
    "place_name":"Thuringowa DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4815,
    "place_name":"Condon",
    "state_name":"Queensland"
  },
  {
    "postcode":4815,
    "place_name":"Gumlow",
    "state_name":"Queensland"
  },
  {
    "postcode":4815,
    "place_name":"Rasmussen",
    "state_name":"Queensland"
  },
  {
    "postcode":4815,
    "place_name":"Pinnacles",
    "state_name":"Queensland"
  },
  {
    "postcode":4815,
    "place_name":"Kelso",
    "state_name":"Queensland"
  },
  {
    "postcode":4815,
    "place_name":"Granite Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Nome",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Hidden Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Alligator Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Mutarnee",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Julago",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Mount Elliot",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Torrens Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"The Cape",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Homestead",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Greenvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Crystal Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Rollingstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Crimea",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Buchanan",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Ross River",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Savannah",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Barringha",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Malpas-Trenton",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Balgal Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Carruchan",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Toonpan",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Kennedy",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Brookhill",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Majors Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Paluma",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Ellerbeck",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Woodstock",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Prairie",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Reid River",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Clemant",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Macrossan",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Nelia",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Sellheim",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Calcium",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Cungulla",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Toomulla",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Mingela",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Palm Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Pentland",
    "state_name":"Queensland"
  },
  {
    "postcode":4816,
    "place_name":"Ravenswood",
    "state_name":"Queensland"
  },
  {
    "postcode":4817,
    "place_name":"Kirwan",
    "state_name":"Queensland"
  },
  {
    "postcode":4817,
    "place_name":"Thuringowa Central",
    "state_name":"Queensland"
  },
  {
    "postcode":4817,
    "place_name":"Bohle Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4817,
    "place_name":"Alice River",
    "state_name":"Queensland"
  },
  {
    "postcode":4817,
    "place_name":"Rangewood",
    "state_name":"Queensland"
  },
  {
    "postcode":4817,
    "place_name":"Hervey Range",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Lynam",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Beach Holm",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Yabulu",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Mount St John",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Burdell",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Blue Hills",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Bushland Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Mount Low",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Jensen",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Bohle",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Saunders Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Bluewater Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Bluewater",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Deeragun",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Toolakea",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Shaw",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Cosgrove",
    "state_name":"Queensland"
  },
  {
    "postcode":4818,
    "place_name":"Black River",
    "state_name":"Queensland"
  },
  {
    "postcode":4819,
    "place_name":"West Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4819,
    "place_name":"Florence Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4819,
    "place_name":"Horseshoe Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4819,
    "place_name":"Picnic Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4819,
    "place_name":"Nelly Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4819,
    "place_name":"Magnetic Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4819,
    "place_name":"Arcadia",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Broughton",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Columbia",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Breddan",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Black Jack",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Lissner",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Richmond Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Towers Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Balfes Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Alabama Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Millchester",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Charters Towers",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Mosman Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Grand Secret",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Campaspe",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Llanarth",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Southern Cross",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Toll",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Seventy Mile",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Queenton",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Dotswood",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Basalt",
    "state_name":"Queensland"
  },
  {
    "postcode":4820,
    "place_name":"Charters Towers City",
    "state_name":"Queensland"
  },
  {
    "postcode":4821,
    "place_name":"Tangorin",
    "state_name":"Queensland"
  },
  {
    "postcode":4821,
    "place_name":"Stamford",
    "state_name":"Queensland"
  },
  {
    "postcode":4821,
    "place_name":"Porcupine",
    "state_name":"Queensland"
  },
  {
    "postcode":4821,
    "place_name":"Dutton River",
    "state_name":"Queensland"
  },
  {
    "postcode":4821,
    "place_name":"Hughenden",
    "state_name":"Queensland"
  },
  {
    "postcode":4822,
    "place_name":"Albion",
    "state_name":"Queensland"
  },
  {
    "postcode":4822,
    "place_name":"Cambridge",
    "state_name":"Queensland"
  },
  {
    "postcode":4822,
    "place_name":"Bellfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4822,
    "place_name":"Richmond",
    "state_name":"Queensland"
  },
  {
    "postcode":4822,
    "place_name":"Maxwelton",
    "state_name":"Queensland"
  },
  {
    "postcode":4822,
    "place_name":"Victoria Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4822,
    "place_name":"Saxby",
    "state_name":"Queensland"
  },
  {
    "postcode":4822,
    "place_name":"Burleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4822,
    "place_name":"Woolgar",
    "state_name":"Queensland"
  },
  {
    "postcode":4823,
    "place_name":"Julia Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4823,
    "place_name":"Mckinlay",
    "state_name":"Queensland"
  },
  {
    "postcode":4823,
    "place_name":"Carpentaria",
    "state_name":"Queensland"
  },
  {
    "postcode":4823,
    "place_name":"Kynuna",
    "state_name":"Queensland"
  },
  {
    "postcode":4823,
    "place_name":"Taldora",
    "state_name":"Queensland"
  },
  {
    "postcode":4823,
    "place_name":"Warburton",
    "state_name":"Queensland"
  },
  {
    "postcode":4823,
    "place_name":"Stokes",
    "state_name":"Queensland"
  },
  {
    "postcode":4824,
    "place_name":"Kuridala",
    "state_name":"Queensland"
  },
  {
    "postcode":4824,
    "place_name":"Four Ways",
    "state_name":"Queensland"
  },
  {
    "postcode":4824,
    "place_name":"Oorindi",
    "state_name":"Queensland"
  },
  {
    "postcode":4824,
    "place_name":"Gidya",
    "state_name":"Queensland"
  },
  {
    "postcode":4824,
    "place_name":"Cloncurry",
    "state_name":"Queensland"
  },
  {
    "postcode":4824,
    "place_name":"Three Rivers",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Mount Isa DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Mount Isa",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Winston",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Menzies",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Sunset",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Happy Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Soldiers Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Waverley",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Townview",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Spreadborough",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Duchess",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Parkside",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Miles End",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Mount Isa East",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Healy",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"The Monument",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Gunpowder",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"The Gap",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Pioneer",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Ryan",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Dajarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Breakaway",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Buckingham",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Georgina",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Mount Isa City",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Piturie",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Mica Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Carrandotta",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Fisher",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Kalkadoon",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Lanskey",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Lawn Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Mornington",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Fielding",
    "state_name":"Queensland"
  },
  {
    "postcode":4825,
    "place_name":"Barkly",
    "state_name":"Queensland"
  },
  {
    "postcode":4828,
    "place_name":"Camooweal",
    "state_name":"Queensland"
  },
  {
    "postcode":4829,
    "place_name":"Boulia",
    "state_name":"Queensland"
  },
  {
    "postcode":4829,
    "place_name":"Toko",
    "state_name":"Queensland"
  },
  {
    "postcode":4829,
    "place_name":"Bedourie",
    "state_name":"Queensland"
  },
  {
    "postcode":4829,
    "place_name":"Wills",
    "state_name":"Queensland"
  },
  {
    "postcode":4829,
    "place_name":"Amaroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4829,
    "place_name":"Warenda",
    "state_name":"Queensland"
  },
  {
    "postcode":4829,
    "place_name":"Sturt",
    "state_name":"Queensland"
  },
  {
    "postcode":4829,
    "place_name":"Min Min",
    "state_name":"Queensland"
  },
  {
    "postcode":4830,
    "place_name":"Nicholson",
    "state_name":"Queensland"
  },
  {
    "postcode":4830,
    "place_name":"Burketown",
    "state_name":"Queensland"
  },
  {
    "postcode":4830,
    "place_name":"Gregory",
    "state_name":"Queensland"
  },
  {
    "postcode":4830,
    "place_name":"Doomadgee",
    "state_name":"Queensland"
  },
  {
    "postcode":4849,
    "place_name":"Cardwell",
    "state_name":"Queensland"
  },
  {
    "postcode":4849,
    "place_name":"Rungoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4849,
    "place_name":"Lumholtz",
    "state_name":"Queensland"
  },
  {
    "postcode":4849,
    "place_name":"Hinchinbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4849,
    "place_name":"Damper Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Ingham",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Yuruga",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Toobanna",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Peacock Siding",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Bemerside",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Macknade",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Lucinda",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Abergowrie",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Halifax",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Valley Of Lagoons",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Blackrock",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Trebonne",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Victoria Estate",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Victoria Plantation",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Hawkins Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Coolbie",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Long Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Allingham",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Braemeadows",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Dalrymple Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Bambaroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Orient",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Lannercost",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Wharps",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Helens Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Garrawalt",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Cordelia",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Wallaman",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Taylors Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Foresthome",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Mount Fox",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Forrest Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Upper Stone",
    "state_name":"Queensland"
  },
  {
    "postcode":4850,
    "place_name":"Gairloch",
    "state_name":"Queensland"
  },
  {
    "postcode":4852,
    "place_name":"Tam O'Shanter",
    "state_name":"Queensland"
  },
  {
    "postcode":4852,
    "place_name":"Djiru",
    "state_name":"Queensland"
  },
  {
    "postcode":4852,
    "place_name":"Dunk",
    "state_name":"Queensland"
  },
  {
    "postcode":4852,
    "place_name":"Garners Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4852,
    "place_name":"Bingil Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4852,
    "place_name":"Carmoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4852,
    "place_name":"Wongaling Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4852,
    "place_name":"Midgeree Bar",
    "state_name":"Queensland"
  },
  {
    "postcode":4852,
    "place_name":"South Mission Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4852,
    "place_name":"Mission Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Birkalla",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Midgenoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Murray Upper",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"East Feluga",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Tully Heads",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Bilyana",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Silky Oak",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Lower Tully",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Bulgun",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Hull Heads",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Cardstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Rockingham",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Djarawong",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Dingo Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Murrigal",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Tully",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Feluga",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Kooroomool",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Warrami",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Mount Mackay",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Euramo",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Munro Plains",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Jarra Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Merryburn",
    "state_name":"Queensland"
  },
  {
    "postcode":4854,
    "place_name":"Walter Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4855,
    "place_name":"El Arish",
    "state_name":"Queensland"
  },
  {
    "postcode":4855,
    "place_name":"Jaffa",
    "state_name":"Queensland"
  },
  {
    "postcode":4855,
    "place_name":"Maadi",
    "state_name":"Queensland"
  },
  {
    "postcode":4855,
    "place_name":"Granadilla",
    "state_name":"Queensland"
  },
  {
    "postcode":4855,
    "place_name":"Shell Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4855,
    "place_name":"Maria Creeks",
    "state_name":"Queensland"
  },
  {
    "postcode":4855,
    "place_name":"Daveson",
    "state_name":"Queensland"
  },
  {
    "postcode":4855,
    "place_name":"Friday Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4856,
    "place_name":"Silkwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4856,
    "place_name":"Goolboo",
    "state_name":"Queensland"
  },
  {
    "postcode":4856,
    "place_name":"Japoonvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4856,
    "place_name":"Walter Lever Estate",
    "state_name":"Queensland"
  },
  {
    "postcode":4856,
    "place_name":"No. 4 Branch",
    "state_name":"Queensland"
  },
  {
    "postcode":4856,
    "place_name":"No. 5 Branch",
    "state_name":"Queensland"
  },
  {
    "postcode":4856,
    "place_name":"Mccutcheon",
    "state_name":"Queensland"
  },
  {
    "postcode":4857,
    "place_name":"Silkwood East",
    "state_name":"Queensland"
  },
  {
    "postcode":4858,
    "place_name":"Comoon Loop",
    "state_name":"Queensland"
  },
  {
    "postcode":4858,
    "place_name":"Etty Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4858,
    "place_name":"Mourilyan Harbour",
    "state_name":"Queensland"
  },
  {
    "postcode":4858,
    "place_name":"Mourilyan",
    "state_name":"Queensland"
  },
  {
    "postcode":4858,
    "place_name":"New Harbourline",
    "state_name":"Queensland"
  },
  {
    "postcode":4858,
    "place_name":"Martyville",
    "state_name":"Queensland"
  },
  {
    "postcode":4859,
    "place_name":"No. 6 Branch",
    "state_name":"Queensland"
  },
  {
    "postcode":4859,
    "place_name":"South Johnstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Coorumba",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Innisfail Estate",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Hudson",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"East Palmerston",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Eubenangee",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Cooroo Lands",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Cullinane",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Garradunga",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Belvedere",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Nerada",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"South Innisfail",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Sundown",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Goondi",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Palmerston",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Daradgee",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Innisfail",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"East Innisfail",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Stoters Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Mighell",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Goondi Bend",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Wooroonooran",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Coquette Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Flying Fish Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Fitzgerald Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Eaton",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Coconuts",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Njatjan",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Ngatjan",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Bamboo Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"O'Briens Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Pin Gin Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Vasa Views",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Jubilee Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Webb",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Upper Daradgee",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Wanjuru",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Goondi Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4860,
    "place_name":"Mundoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4861,
    "place_name":"Bartle Frere",
    "state_name":"Queensland"
  },
  {
    "postcode":4861,
    "place_name":"East Russell",
    "state_name":"Queensland"
  },
  {
    "postcode":4861,
    "place_name":"Babinda",
    "state_name":"Queensland"
  },
  {
    "postcode":4865,
    "place_name":"Gordonvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4865,
    "place_name":"Packers Camp",
    "state_name":"Queensland"
  },
  {
    "postcode":4865,
    "place_name":"Green Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4865,
    "place_name":"Kamma",
    "state_name":"Queensland"
  },
  {
    "postcode":4865,
    "place_name":"Little Mulgrave",
    "state_name":"Queensland"
  },
  {
    "postcode":4865,
    "place_name":"Goldsborough",
    "state_name":"Queensland"
  },
  {
    "postcode":4868,
    "place_name":"Bayview Heights",
    "state_name":"Queensland"
  },
  {
    "postcode":4868,
    "place_name":"White Rock",
    "state_name":"Queensland"
  },
  {
    "postcode":4868,
    "place_name":"Woree",
    "state_name":"Queensland"
  },
  {
    "postcode":4868,
    "place_name":"Mount Sheridan",
    "state_name":"Queensland"
  },
  {
    "postcode":4869,
    "place_name":"Bentley Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4869,
    "place_name":"Mount Peter",
    "state_name":"Queensland"
  },
  {
    "postcode":4869,
    "place_name":"Edmonton",
    "state_name":"Queensland"
  },
  {
    "postcode":4869,
    "place_name":"Wrights Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Cairns",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Westcourt",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Edge Hill",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Cairns North",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Bungalow",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Cairns Central",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Manunda",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Cairns City",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Parramatta Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Mooroobool",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Whitfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Cairns Orchid Plaza",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Kanimbla",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Cairns DC",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Aeroglen",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Martynvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Redlynch",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Portsmith",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Brinsmead",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"North Cairns",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Manoora",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Barron Gorge",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Earlville",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Lamb Range",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Kamerunga",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Stratford",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Freshwater",
    "state_name":"Queensland"
  },
  {
    "postcode":4870,
    "place_name":"Earlville BC",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Coen",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Stockton",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Cowley Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Einasleigh",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Gilbert River",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Cowley",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Bellenden Ker",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Georgetown",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Basilisk",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Moresby",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"East Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Mena Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Mount Surprise",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"East Trinity",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Karron",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Strathmore",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Mount Molloy",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Lower Cowley",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Lyndhurst",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Desailly",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Mount Mulligan",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Julatten",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Springfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Yarrabah",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Lakeland Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Lockhart",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Aloomba",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Chillagoe",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Boogan",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Utchee Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Miriwinni",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Talaroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Laura",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Currajah",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Kurrimine Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Forsayth",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Aurukun",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Camp Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Kowanyama",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Petford",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Hurricane",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Green Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Gununa",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Croydon",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Crystalbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Portland Roads",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Claraville",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Esmeralda",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Coralie",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Bombeeta",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Woopen Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Deeral",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Glen Boughton",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Mount Carbine",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Amber",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Macalister Range",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Bolwarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Mirriwinni",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Blackbull",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Fishery Falls",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Sandy Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Fitzroy Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Cowley Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Wangan",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Fossilbrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Northhead",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Germantown",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Lakeland",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Edward River",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Thornborough",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Conjuboy",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Southedge",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Bulleringa",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Waugh Pocket",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Pormpuraaw",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Bramston Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Almaden",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Rookwood",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Warrubullen",
    "state_name":"Queensland"
  },
  {
    "postcode":4871,
    "place_name":"Nychum",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Kairi",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Silver Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Mutchilba",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Barrine",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Innot Hot Springs",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Wairuna",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Mount Garnet",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Kowrowa",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Danbulla",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Munderra",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Dimbulah",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Barwidgi",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Tinaroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Cairns Mc",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Walkamin",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Koombooloomba",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Forty Mile",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Lake Tinaroo",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Minnamoolka",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Glen Ruth",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Gunnawarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4872,
    "place_name":"Kirrama",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Cow Bay",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Forest Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Syndicate",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Dagmar",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Bamboo",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Kimberley",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Daintree",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Dedin",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Whyanbeel",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Shannonvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Diwan",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Low Isles",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Cassowary",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Rocky Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Miallo",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Noah",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Finlayvale",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Bonnie Doon",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Mossman",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Upper Daintree",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Newell",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Spurgeon",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Stewart Creek Valley",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Cape Tribulation",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Mossman Gorge",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Cooya Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Wonga",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Thornton Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4873,
    "place_name":"Lower Daintree",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Nanum",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Weipa",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Mapoon",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Napranum",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Evans Landing",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Rocky Point",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Wenlock",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Trunding",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Weipa Airport",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Jardine River",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Mission River",
    "state_name":"Queensland"
  },
  {
    "postcode":4874,
    "place_name":"Shelburne",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Prince Of Wales",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Murray Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Boigu Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Badu Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Dauan Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Thursday Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Erub",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Coconut Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Yorke Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Stephens Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Kubin Village",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Warraber Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Horn Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Saibai Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Mabuiag Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Moa Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4875,
    "place_name":"Yam Island",
    "state_name":"Queensland"
  },
  {
    "postcode":4876,
    "place_name":"Umagico",
    "state_name":"Queensland"
  },
  {
    "postcode":4876,
    "place_name":"New Mapoon",
    "state_name":"Queensland"
  },
  {
    "postcode":4876,
    "place_name":"Seisia",
    "state_name":"Queensland"
  },
  {
    "postcode":4876,
    "place_name":"Injinoo",
    "state_name":"Queensland"
  },
  {
    "postcode":4876,
    "place_name":"Bamaga",
    "state_name":"Queensland"
  },
  {
    "postcode":4877,
    "place_name":"Oak Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4877,
    "place_name":"Mowbray",
    "state_name":"Queensland"
  },
  {
    "postcode":4877,
    "place_name":"Craiglie",
    "state_name":"Queensland"
  },
  {
    "postcode":4877,
    "place_name":"Killaloe",
    "state_name":"Queensland"
  },
  {
    "postcode":4877,
    "place_name":"Wangetti",
    "state_name":"Queensland"
  },
  {
    "postcode":4877,
    "place_name":"Port Douglas",
    "state_name":"Queensland"
  },
  {
    "postcode":4878,
    "place_name":"Machans Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4878,
    "place_name":"Caravonica",
    "state_name":"Queensland"
  },
  {
    "postcode":4878,
    "place_name":"Yorkeys Knob",
    "state_name":"Queensland"
  },
  {
    "postcode":4878,
    "place_name":"Holloways Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4878,
    "place_name":"Smithfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4878,
    "place_name":"Barron",
    "state_name":"Queensland"
  },
  {
    "postcode":4879,
    "place_name":"Kewarra Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4879,
    "place_name":"Clifton Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4879,
    "place_name":"Ellis Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4879,
    "place_name":"Trinity Beach",
    "state_name":"Queensland"
  },
  {
    "postcode":4879,
    "place_name":"Palm Cove",
    "state_name":"Queensland"
  },
  {
    "postcode":4879,
    "place_name":"Trinity Park",
    "state_name":"Queensland"
  },
  {
    "postcode":4880,
    "place_name":"Chewko",
    "state_name":"Queensland"
  },
  {
    "postcode":4880,
    "place_name":"Mareeba",
    "state_name":"Queensland"
  },
  {
    "postcode":4880,
    "place_name":"Biboohra",
    "state_name":"Queensland"
  },
  {
    "postcode":4880,
    "place_name":"Glen Russell",
    "state_name":"Queensland"
  },
  {
    "postcode":4880,
    "place_name":"Paddys Green",
    "state_name":"Queensland"
  },
  {
    "postcode":4880,
    "place_name":"Arriga",
    "state_name":"Queensland"
  },
  {
    "postcode":4881,
    "place_name":"Speewah",
    "state_name":"Queensland"
  },
  {
    "postcode":4881,
    "place_name":"Koah",
    "state_name":"Queensland"
  },
  {
    "postcode":4881,
    "place_name":"Kuranda",
    "state_name":"Queensland"
  },
  {
    "postcode":4881,
    "place_name":"Mona Mona",
    "state_name":"Queensland"
  },
  {
    "postcode":4882,
    "place_name":"Tolga",
    "state_name":"Queensland"
  },
  {
    "postcode":4883,
    "place_name":"Carrington",
    "state_name":"Queensland"
  },
  {
    "postcode":4883,
    "place_name":"Atherton",
    "state_name":"Queensland"
  },
  {
    "postcode":4883,
    "place_name":"Upper Barron",
    "state_name":"Queensland"
  },
  {
    "postcode":4883,
    "place_name":"East Barron",
    "state_name":"Queensland"
  },
  {
    "postcode":4883,
    "place_name":"Wongabel",
    "state_name":"Queensland"
  },
  {
    "postcode":4884,
    "place_name":"Lake Eacham",
    "state_name":"Queensland"
  },
  {
    "postcode":4884,
    "place_name":"Yungaburra",
    "state_name":"Queensland"
  },
  {
    "postcode":4884,
    "place_name":"Lake Barrine",
    "state_name":"Queensland"
  },
  {
    "postcode":4884,
    "place_name":"Gadgarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4885,
    "place_name":"Peeramon",
    "state_name":"Queensland"
  },
  {
    "postcode":4885,
    "place_name":"Topaz",
    "state_name":"Queensland"
  },
  {
    "postcode":4885,
    "place_name":"North Johnstone",
    "state_name":"Queensland"
  },
  {
    "postcode":4885,
    "place_name":"Malanda",
    "state_name":"Queensland"
  },
  {
    "postcode":4885,
    "place_name":"Kureen",
    "state_name":"Queensland"
  },
  {
    "postcode":4885,
    "place_name":"Glen Allyn",
    "state_name":"Queensland"
  },
  {
    "postcode":4885,
    "place_name":"Butchers Creek",
    "state_name":"Queensland"
  },
  {
    "postcode":4885,
    "place_name":"Tarzali",
    "state_name":"Queensland"
  },
  {
    "postcode":4885,
    "place_name":"Jaggan",
    "state_name":"Queensland"
  },
  {
    "postcode":4886,
    "place_name":"Beatrice",
    "state_name":"Queensland"
  },
  {
    "postcode":4886,
    "place_name":"Mungalli",
    "state_name":"Queensland"
  },
  {
    "postcode":4886,
    "place_name":"Millaa Millaa",
    "state_name":"Queensland"
  },
  {
    "postcode":4886,
    "place_name":"Minbun",
    "state_name":"Queensland"
  },
  {
    "postcode":4886,
    "place_name":"Moregatta",
    "state_name":"Queensland"
  },
  {
    "postcode":4886,
    "place_name":"Maalan",
    "state_name":"Queensland"
  },
  {
    "postcode":4886,
    "place_name":"Ellinjaa",
    "state_name":"Queensland"
  },
  {
    "postcode":4886,
    "place_name":"Middlebrook",
    "state_name":"Queensland"
  },
  {
    "postcode":4887,
    "place_name":"Wondecla",
    "state_name":"Queensland"
  },
  {
    "postcode":4887,
    "place_name":"Irvinebank",
    "state_name":"Queensland"
  },
  {
    "postcode":4887,
    "place_name":"Herberton",
    "state_name":"Queensland"
  },
  {
    "postcode":4887,
    "place_name":"Watsonville",
    "state_name":"Queensland"
  },
  {
    "postcode":4887,
    "place_name":"Kalunga",
    "state_name":"Queensland"
  },
  {
    "postcode":4887,
    "place_name":"Moomin",
    "state_name":"Queensland"
  },
  {
    "postcode":4888,
    "place_name":"Tumoulin",
    "state_name":"Queensland"
  },
  {
    "postcode":4888,
    "place_name":"Millstream",
    "state_name":"Queensland"
  },
  {
    "postcode":4888,
    "place_name":"Ravenshoe",
    "state_name":"Queensland"
  },
  {
    "postcode":4888,
    "place_name":"Kaban",
    "state_name":"Queensland"
  },
  {
    "postcode":4888,
    "place_name":"Evelyn",
    "state_name":"Queensland"
  },
  {
    "postcode":4890,
    "place_name":"Normanton",
    "state_name":"Queensland"
  },
  {
    "postcode":4890,
    "place_name":"Howitt",
    "state_name":"Queensland"
  },
  {
    "postcode":4891,
    "place_name":"Karumba",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Archer River",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Lyndside",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Aurukun",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Coen",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Wrotham",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Lakefield",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"West Wellesley Islands",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Bellevue",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Staaten",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Highbury",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Yagoonya",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Lizard",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Ravensworth",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Yarraden",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Lockhart River",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"South Wellesley Islands",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Groganville",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Mount Mulgrave",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Laura",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Dixie",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Kowanyama",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Palmer",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Wellesley Islands",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Gununa",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Pormpuraaw",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Lockhart",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Holroyd River",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Arbouin",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Red River",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Maramie",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Edward River",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Gamboola",
    "state_name":"Queensland"
  },
  {
    "postcode":4892,
    "place_name":"Abingdon Downs",
    "state_name":"Queensland"
  },
  {
    "postcode":4895,
    "place_name":"Degarra",
    "state_name":"Queensland"
  },
  {
    "postcode":4895,
    "place_name":"Hope Vale",
    "state_name":"Queensland"
  },
  {
    "postcode":4895,
    "place_name":"Wujal Wujal",
    "state_name":"Queensland"
  },
  {
    "postcode":4895,
    "place_name":"Cooktown",
    "state_name":"Queensland"
  },
  {
    "postcode":4895,
    "place_name":"Ayton",
    "state_name":"Queensland"
  },
  {
    "postcode":4895,
    "place_name":"Starcke",
    "state_name":"Queensland"
  },
  {
    "postcode":4895,
    "place_name":"Rossville",
    "state_name":"Queensland"
  },
  {
    "postcode":4895,
    "place_name":"Bloomfield",
    "state_name":"Queensland"
  },
  {
    "postcode":4895,
    "place_name":"Helenvale",
    "state_name":"Queensland"
  },
  {
    "postcode":9000,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":9001,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":9002,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":9005,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":9007,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":9008,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":9009,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":9010,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":9013,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":9015,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":9016,
    "place_name":"Brisbane GPO Boxes",
    "state_name":"Queensland"
  },
  {
    "postcode":9017,
    "place_name":"Brisbane GPO Boxes",
    "state_name":"Queensland"
  },
  {
    "postcode":9018,
    "place_name":"Brisbane GPO Boxes",
    "state_name":"Queensland"
  },
  {
    "postcode":9019,
    "place_name":"Brisbane GPO Boxes",
    "state_name":"Queensland"
  },
  {
    "postcode":9020,
    "place_name":"Brisbane",
    "state_name":"Queensland"
  },
  {
    "postcode":9021,
    "place_name":"Brisbane GPO Boxes",
    "state_name":"Queensland"
  },
  {
    "postcode":9022,
    "place_name":"Brisbane GPO Boxes",
    "state_name":"Queensland"
  },
  {
    "postcode":9023,
    "place_name":"Brisbane GPO Boxes",
    "state_name":"Queensland"
  },
  {
    "postcode":9464,
    "place_name":"Northgate Mc",
    "state_name":"Queensland"
  },
  {
    "postcode":9726,
    "place_name":"Gold Coast Mc",
    "state_name":"Queensland"
  },
  {
    "postcode":9943,
    "place_name":"Mackay",
    "state_name":"Queensland"
  },
  {
    "postcode":9944,
    "place_name":"Cannonvale",
    "state_name":"Queensland"
  },
  {
    "postcode":872,
    "place_name":"Nyapari",
    "state_name":"South Australia"
  },
  {
    "postcode":872,
    "place_name":"Fregon",
    "state_name":"South Australia"
  },
  {
    "postcode":872,
    "place_name":"Mimili",
    "state_name":"South Australia"
  },
  {
    "postcode":872,
    "place_name":"Indulkana",
    "state_name":"South Australia"
  },
  {
    "postcode":872,
    "place_name":"Ernabella",
    "state_name":"South Australia"
  },
  {
    "postcode":5000,
    "place_name":"Adelaide",
    "state_name":"South Australia"
  },
  {
    "postcode":5000,
    "place_name":"Rundle Mall",
    "state_name":"South Australia"
  },
  {
    "postcode":5000,
    "place_name":"Hutt Street",
    "state_name":"South Australia"
  },
  {
    "postcode":5000,
    "place_name":"Halifax Street",
    "state_name":"South Australia"
  },
  {
    "postcode":5000,
    "place_name":"Station Arcade",
    "state_name":"South Australia"
  },
  {
    "postcode":5000,
    "place_name":"Adelaide Bc",
    "state_name":"South Australia"
  },
  {
    "postcode":5000,
    "place_name":"City West Campus",
    "state_name":"South Australia"
  },
  {
    "postcode":5000,
    "place_name":"Sturt Street",
    "state_name":"South Australia"
  },
  {
    "postcode":5001,
    "place_name":"Adelaide",
    "state_name":"South Australia"
  },
  {
    "postcode":5005,
    "place_name":"University Of Adelaide",
    "state_name":"South Australia"
  },
  {
    "postcode":5005,
    "place_name":"The University Of Adelaide",
    "state_name":"South Australia"
  },
  {
    "postcode":5005,
    "place_name":"Adelaide University",
    "state_name":"South Australia"
  },
  {
    "postcode":5006,
    "place_name":"North Adelaide",
    "state_name":"South Australia"
  },
  {
    "postcode":5006,
    "place_name":"North Adelaide Melbourne St",
    "state_name":"South Australia"
  },
  {
    "postcode":5007,
    "place_name":"Welland",
    "state_name":"South Australia"
  },
  {
    "postcode":5007,
    "place_name":"West Hindmarsh",
    "state_name":"South Australia"
  },
  {
    "postcode":5007,
    "place_name":"Hindmarsh",
    "state_name":"South Australia"
  },
  {
    "postcode":5007,
    "place_name":"Brompton",
    "state_name":"South Australia"
  },
  {
    "postcode":5007,
    "place_name":"Bowden",
    "state_name":"South Australia"
  },
  {
    "postcode":5008,
    "place_name":"Dudley Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5008,
    "place_name":"West Croydon",
    "state_name":"South Australia"
  },
  {
    "postcode":5008,
    "place_name":"Croydon",
    "state_name":"South Australia"
  },
  {
    "postcode":5008,
    "place_name":"Devon Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5008,
    "place_name":"Renown Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5008,
    "place_name":"Ridleyton",
    "state_name":"South Australia"
  },
  {
    "postcode":5008,
    "place_name":"Croydon Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5009,
    "place_name":"Kilkenny",
    "state_name":"South Australia"
  },
  {
    "postcode":5009,
    "place_name":"Beverley",
    "state_name":"South Australia"
  },
  {
    "postcode":5009,
    "place_name":"Allenby Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5010,
    "place_name":"Regency Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5010,
    "place_name":"Regency Park Bc",
    "state_name":"South Australia"
  },
  {
    "postcode":5010,
    "place_name":"Ferryden Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5010,
    "place_name":"Angle Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5011,
    "place_name":"Woodville Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5011,
    "place_name":"St Clair",
    "state_name":"South Australia"
  },
  {
    "postcode":5011,
    "place_name":"Woodville South",
    "state_name":"South Australia"
  },
  {
    "postcode":5011,
    "place_name":"Woodville West",
    "state_name":"South Australia"
  },
  {
    "postcode":5011,
    "place_name":"Woodville",
    "state_name":"South Australia"
  },
  {
    "postcode":5012,
    "place_name":"Woodville Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5012,
    "place_name":"Mansfield Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5012,
    "place_name":"Woodville North",
    "state_name":"South Australia"
  },
  {
    "postcode":5012,
    "place_name":"Athol Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5013,
    "place_name":"Rosewater East",
    "state_name":"South Australia"
  },
  {
    "postcode":5013,
    "place_name":"Gillman",
    "state_name":"South Australia"
  },
  {
    "postcode":5013,
    "place_name":"Ottoway",
    "state_name":"South Australia"
  },
  {
    "postcode":5013,
    "place_name":"Pennington",
    "state_name":"South Australia"
  },
  {
    "postcode":5013,
    "place_name":"Rosewater",
    "state_name":"South Australia"
  },
  {
    "postcode":5013,
    "place_name":"Wingfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5014,
    "place_name":"Cheltenham",
    "state_name":"South Australia"
  },
  {
    "postcode":5014,
    "place_name":"Queenstown",
    "state_name":"South Australia"
  },
  {
    "postcode":5014,
    "place_name":"Hendon",
    "state_name":"South Australia"
  },
  {
    "postcode":5014,
    "place_name":"Royal Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5014,
    "place_name":"Albert Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5014,
    "place_name":"Alberton",
    "state_name":"South Australia"
  },
  {
    "postcode":5015,
    "place_name":"Port Adelaide",
    "state_name":"South Australia"
  },
  {
    "postcode":5015,
    "place_name":"Ethelton",
    "state_name":"South Australia"
  },
  {
    "postcode":5015,
    "place_name":"Glanville",
    "state_name":"South Australia"
  },
  {
    "postcode":5015,
    "place_name":"New Port",
    "state_name":"South Australia"
  },
  {
    "postcode":5015,
    "place_name":"Birkenhead",
    "state_name":"South Australia"
  },
  {
    "postcode":5015,
    "place_name":"Port Adelaide DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5016,
    "place_name":"Peterhead",
    "state_name":"South Australia"
  },
  {
    "postcode":5016,
    "place_name":"Largs North",
    "state_name":"South Australia"
  },
  {
    "postcode":5016,
    "place_name":"Largs Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5017,
    "place_name":"Osborne",
    "state_name":"South Australia"
  },
  {
    "postcode":5017,
    "place_name":"Taperoo",
    "state_name":"South Australia"
  },
  {
    "postcode":5018,
    "place_name":"Outer Harbor",
    "state_name":"South Australia"
  },
  {
    "postcode":5018,
    "place_name":"North Haven",
    "state_name":"South Australia"
  },
  {
    "postcode":5019,
    "place_name":"Semaphore",
    "state_name":"South Australia"
  },
  {
    "postcode":5019,
    "place_name":"Semaphore Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5019,
    "place_name":"Semaphore South",
    "state_name":"South Australia"
  },
  {
    "postcode":5019,
    "place_name":"Exeter",
    "state_name":"South Australia"
  },
  {
    "postcode":5020,
    "place_name":"West Lakes Shore",
    "state_name":"South Australia"
  },
  {
    "postcode":5021,
    "place_name":"West Lakes",
    "state_name":"South Australia"
  },
  {
    "postcode":5022,
    "place_name":"Henley Beach South",
    "state_name":"South Australia"
  },
  {
    "postcode":5022,
    "place_name":"Henley Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5022,
    "place_name":"Tennyson",
    "state_name":"South Australia"
  },
  {
    "postcode":5022,
    "place_name":"Grange",
    "state_name":"South Australia"
  },
  {
    "postcode":5023,
    "place_name":"Seaton",
    "state_name":"South Australia"
  },
  {
    "postcode":5023,
    "place_name":"Findon",
    "state_name":"South Australia"
  },
  {
    "postcode":5024,
    "place_name":"West Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5024,
    "place_name":"Fulham",
    "state_name":"South Australia"
  },
  {
    "postcode":5024,
    "place_name":"Fulham Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5025,
    "place_name":"Flinders Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5025,
    "place_name":"Kidman Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5031,
    "place_name":"Torrensville Plaza",
    "state_name":"South Australia"
  },
  {
    "postcode":5031,
    "place_name":"Mile End",
    "state_name":"South Australia"
  },
  {
    "postcode":5031,
    "place_name":"Torrensville",
    "state_name":"South Australia"
  },
  {
    "postcode":5031,
    "place_name":"Mile End South",
    "state_name":"South Australia"
  },
  {
    "postcode":5031,
    "place_name":"Thebarton",
    "state_name":"South Australia"
  },
  {
    "postcode":5032,
    "place_name":"Lockleys",
    "state_name":"South Australia"
  },
  {
    "postcode":5032,
    "place_name":"Brooklyn Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5032,
    "place_name":"Underdale",
    "state_name":"South Australia"
  },
  {
    "postcode":5033,
    "place_name":"Marleston",
    "state_name":"South Australia"
  },
  {
    "postcode":5033,
    "place_name":"Hilton",
    "state_name":"South Australia"
  },
  {
    "postcode":5033,
    "place_name":"Marleston DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5033,
    "place_name":"Cowandilla",
    "state_name":"South Australia"
  },
  {
    "postcode":5033,
    "place_name":"West Richmond",
    "state_name":"South Australia"
  },
  {
    "postcode":5033,
    "place_name":"Hilton Plaza",
    "state_name":"South Australia"
  },
  {
    "postcode":5033,
    "place_name":"Richmond",
    "state_name":"South Australia"
  },
  {
    "postcode":5034,
    "place_name":"Wayville",
    "state_name":"South Australia"
  },
  {
    "postcode":5034,
    "place_name":"Millswood",
    "state_name":"South Australia"
  },
  {
    "postcode":5034,
    "place_name":"Goodwood",
    "state_name":"South Australia"
  },
  {
    "postcode":5034,
    "place_name":"Kings Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5034,
    "place_name":"Clarence Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5035,
    "place_name":"Black Forest",
    "state_name":"South Australia"
  },
  {
    "postcode":5035,
    "place_name":"Keswick",
    "state_name":"South Australia"
  },
  {
    "postcode":5035,
    "place_name":"Forestville",
    "state_name":"South Australia"
  },
  {
    "postcode":5035,
    "place_name":"Ashford",
    "state_name":"South Australia"
  },
  {
    "postcode":5035,
    "place_name":"Everard Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5035,
    "place_name":"Keswick Terminal",
    "state_name":"South Australia"
  },
  {
    "postcode":5037,
    "place_name":"Kurralta Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5037,
    "place_name":"North Plympton",
    "state_name":"South Australia"
  },
  {
    "postcode":5037,
    "place_name":"Netley",
    "state_name":"South Australia"
  },
  {
    "postcode":5037,
    "place_name":"Glandore",
    "state_name":"South Australia"
  },
  {
    "postcode":5038,
    "place_name":"Camden Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5038,
    "place_name":"Plympton",
    "state_name":"South Australia"
  },
  {
    "postcode":5038,
    "place_name":"Plympton Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5038,
    "place_name":"South Plympton",
    "state_name":"South Australia"
  },
  {
    "postcode":5039,
    "place_name":"Melrose Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5039,
    "place_name":"Clarence Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5039,
    "place_name":"Edwardstown",
    "state_name":"South Australia"
  },
  {
    "postcode":5039,
    "place_name":"Melrose Park DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5040,
    "place_name":"Novar Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5041,
    "place_name":"Cumberland Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5041,
    "place_name":"Westbourne Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5041,
    "place_name":"Daw Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5041,
    "place_name":"Panorama",
    "state_name":"South Australia"
  },
  {
    "postcode":5041,
    "place_name":"Colonel Light Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5042,
    "place_name":"St Marys",
    "state_name":"South Australia"
  },
  {
    "postcode":5042,
    "place_name":"Bedford Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5042,
    "place_name":"Pasadena",
    "state_name":"South Australia"
  },
  {
    "postcode":5042,
    "place_name":"Clovelly Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5042,
    "place_name":"Flinders University",
    "state_name":"South Australia"
  },
  {
    "postcode":5043,
    "place_name":"Morphettville",
    "state_name":"South Australia"
  },
  {
    "postcode":5043,
    "place_name":"Marion",
    "state_name":"South Australia"
  },
  {
    "postcode":5043,
    "place_name":"Mitchell Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5043,
    "place_name":"Park Holme",
    "state_name":"South Australia"
  },
  {
    "postcode":5043,
    "place_name":"Ascot Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5044,
    "place_name":"Somerton Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5044,
    "place_name":"Glengowrie",
    "state_name":"South Australia"
  },
  {
    "postcode":5045,
    "place_name":"Glenelg Jetty Road",
    "state_name":"South Australia"
  },
  {
    "postcode":5045,
    "place_name":"Glenelg East",
    "state_name":"South Australia"
  },
  {
    "postcode":5045,
    "place_name":"Glenelg North",
    "state_name":"South Australia"
  },
  {
    "postcode":5045,
    "place_name":"Glenelg South",
    "state_name":"South Australia"
  },
  {
    "postcode":5045,
    "place_name":"Glenelg",
    "state_name":"South Australia"
  },
  {
    "postcode":5046,
    "place_name":"Oaklands Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5046,
    "place_name":"Warradale North",
    "state_name":"South Australia"
  },
  {
    "postcode":5046,
    "place_name":"Warradale",
    "state_name":"South Australia"
  },
  {
    "postcode":5047,
    "place_name":"Seacombe Heights",
    "state_name":"South Australia"
  },
  {
    "postcode":5047,
    "place_name":"Seacombe Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5047,
    "place_name":"Darlington",
    "state_name":"South Australia"
  },
  {
    "postcode":5047,
    "place_name":"Sturt",
    "state_name":"South Australia"
  },
  {
    "postcode":5048,
    "place_name":"South Brighton",
    "state_name":"South Australia"
  },
  {
    "postcode":5048,
    "place_name":"North Brighton",
    "state_name":"South Australia"
  },
  {
    "postcode":5048,
    "place_name":"Brighton",
    "state_name":"South Australia"
  },
  {
    "postcode":5048,
    "place_name":"Hove",
    "state_name":"South Australia"
  },
  {
    "postcode":5048,
    "place_name":"Dover Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5049,
    "place_name":"Seacliff Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5049,
    "place_name":"Seaview Downs",
    "state_name":"South Australia"
  },
  {
    "postcode":5049,
    "place_name":"Kingston Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5049,
    "place_name":"Marino",
    "state_name":"South Australia"
  },
  {
    "postcode":5049,
    "place_name":"Seacliff",
    "state_name":"South Australia"
  },
  {
    "postcode":5050,
    "place_name":"Eden Hills",
    "state_name":"South Australia"
  },
  {
    "postcode":5050,
    "place_name":"Bellevue Heights",
    "state_name":"South Australia"
  },
  {
    "postcode":5051,
    "place_name":"Blackwood",
    "state_name":"South Australia"
  },
  {
    "postcode":5051,
    "place_name":"Coromandel Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5051,
    "place_name":"Hawthorndene",
    "state_name":"South Australia"
  },
  {
    "postcode":5051,
    "place_name":"Craigburn Farm",
    "state_name":"South Australia"
  },
  {
    "postcode":5052,
    "place_name":"Belair",
    "state_name":"South Australia"
  },
  {
    "postcode":5052,
    "place_name":"Glenalta",
    "state_name":"South Australia"
  },
  {
    "postcode":5061,
    "place_name":"Malvern",
    "state_name":"South Australia"
  },
  {
    "postcode":5061,
    "place_name":"Unley DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5061,
    "place_name":"Unley Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5061,
    "place_name":"Unley BC",
    "state_name":"South Australia"
  },
  {
    "postcode":5061,
    "place_name":"Unley",
    "state_name":"South Australia"
  },
  {
    "postcode":5061,
    "place_name":"Hyde Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5062,
    "place_name":"Kingswood",
    "state_name":"South Australia"
  },
  {
    "postcode":5062,
    "place_name":"Hawthorn",
    "state_name":"South Australia"
  },
  {
    "postcode":5062,
    "place_name":"Netherby",
    "state_name":"South Australia"
  },
  {
    "postcode":5062,
    "place_name":"Brown Hill Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5062,
    "place_name":"Springfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5062,
    "place_name":"Lower Mitcham",
    "state_name":"South Australia"
  },
  {
    "postcode":5062,
    "place_name":"Mitcham",
    "state_name":"South Australia"
  },
  {
    "postcode":5062,
    "place_name":"Torrens Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5062,
    "place_name":"Clapham",
    "state_name":"South Australia"
  },
  {
    "postcode":5062,
    "place_name":"Mitcham Shopping Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5062,
    "place_name":"Lynton",
    "state_name":"South Australia"
  },
  {
    "postcode":5063,
    "place_name":"Parkside",
    "state_name":"South Australia"
  },
  {
    "postcode":5063,
    "place_name":"Frewville",
    "state_name":"South Australia"
  },
  {
    "postcode":5063,
    "place_name":"Eastwood",
    "state_name":"South Australia"
  },
  {
    "postcode":5063,
    "place_name":"Fullarton",
    "state_name":"South Australia"
  },
  {
    "postcode":5063,
    "place_name":"Highgate",
    "state_name":"South Australia"
  },
  {
    "postcode":5064,
    "place_name":"Mount Osmond",
    "state_name":"South Australia"
  },
  {
    "postcode":5064,
    "place_name":"Urrbrae",
    "state_name":"South Australia"
  },
  {
    "postcode":5064,
    "place_name":"Glen Osmond",
    "state_name":"South Australia"
  },
  {
    "postcode":5064,
    "place_name":"Myrtle Bank",
    "state_name":"South Australia"
  },
  {
    "postcode":5064,
    "place_name":"St Georges",
    "state_name":"South Australia"
  },
  {
    "postcode":5064,
    "place_name":"Glenunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5065,
    "place_name":"Linden Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5065,
    "place_name":"Tusmore",
    "state_name":"South Australia"
  },
  {
    "postcode":5065,
    "place_name":"Dulwich",
    "state_name":"South Australia"
  },
  {
    "postcode":5065,
    "place_name":"Glenside",
    "state_name":"South Australia"
  },
  {
    "postcode":5065,
    "place_name":"Toorak Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5066,
    "place_name":"Stonyfell",
    "state_name":"South Australia"
  },
  {
    "postcode":5066,
    "place_name":"Burnside",
    "state_name":"South Australia"
  },
  {
    "postcode":5066,
    "place_name":"Erindale",
    "state_name":"South Australia"
  },
  {
    "postcode":5066,
    "place_name":"Beaumont",
    "state_name":"South Australia"
  },
  {
    "postcode":5066,
    "place_name":"Waterfall Gully",
    "state_name":"South Australia"
  },
  {
    "postcode":5066,
    "place_name":"Wattle Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5066,
    "place_name":"Hazelwood Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5067,
    "place_name":"Beulah Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5067,
    "place_name":"Rose Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5067,
    "place_name":"Norwood",
    "state_name":"South Australia"
  },
  {
    "postcode":5067,
    "place_name":"Kent Town",
    "state_name":"South Australia"
  },
  {
    "postcode":5067,
    "place_name":"Norwood South",
    "state_name":"South Australia"
  },
  {
    "postcode":5068,
    "place_name":"Kensington Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5068,
    "place_name":"Heathpool",
    "state_name":"South Australia"
  },
  {
    "postcode":5068,
    "place_name":"Marryatville",
    "state_name":"South Australia"
  },
  {
    "postcode":5068,
    "place_name":"Leabrook",
    "state_name":"South Australia"
  },
  {
    "postcode":5068,
    "place_name":"Kensington Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5068,
    "place_name":"Trinity Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5068,
    "place_name":"St Morris",
    "state_name":"South Australia"
  },
  {
    "postcode":5068,
    "place_name":"Kensington",
    "state_name":"South Australia"
  },
  {
    "postcode":5069,
    "place_name":"Stepney",
    "state_name":"South Australia"
  },
  {
    "postcode":5069,
    "place_name":"College Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5069,
    "place_name":"St Peters",
    "state_name":"South Australia"
  },
  {
    "postcode":5069,
    "place_name":"Hackney",
    "state_name":"South Australia"
  },
  {
    "postcode":5069,
    "place_name":"Evandale",
    "state_name":"South Australia"
  },
  {
    "postcode":5069,
    "place_name":"Maylands",
    "state_name":"South Australia"
  },
  {
    "postcode":5070,
    "place_name":"Payneham",
    "state_name":"South Australia"
  },
  {
    "postcode":5070,
    "place_name":"Glynde DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5070,
    "place_name":"Royston Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5070,
    "place_name":"Glynde Plaza",
    "state_name":"South Australia"
  },
  {
    "postcode":5070,
    "place_name":"Felixstow",
    "state_name":"South Australia"
  },
  {
    "postcode":5070,
    "place_name":"Joslin",
    "state_name":"South Australia"
  },
  {
    "postcode":5070,
    "place_name":"Glynde",
    "state_name":"South Australia"
  },
  {
    "postcode":5070,
    "place_name":"Firle",
    "state_name":"South Australia"
  },
  {
    "postcode":5070,
    "place_name":"Marden",
    "state_name":"South Australia"
  },
  {
    "postcode":5070,
    "place_name":"Payneham South",
    "state_name":"South Australia"
  },
  {
    "postcode":5071,
    "place_name":"Kent Town DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5071,
    "place_name":"Kent Town",
    "state_name":"South Australia"
  },
  {
    "postcode":5072,
    "place_name":"Magill South",
    "state_name":"South Australia"
  },
  {
    "postcode":5072,
    "place_name":"Rosslyn Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5072,
    "place_name":"Skye",
    "state_name":"South Australia"
  },
  {
    "postcode":5072,
    "place_name":"Magill",
    "state_name":"South Australia"
  },
  {
    "postcode":5072,
    "place_name":"Auldana",
    "state_name":"South Australia"
  },
  {
    "postcode":5072,
    "place_name":"Woodforde",
    "state_name":"South Australia"
  },
  {
    "postcode":5072,
    "place_name":"Magill North",
    "state_name":"South Australia"
  },
  {
    "postcode":5072,
    "place_name":"Teringie",
    "state_name":"South Australia"
  },
  {
    "postcode":5073,
    "place_name":"Tranmere",
    "state_name":"South Australia"
  },
  {
    "postcode":5073,
    "place_name":"Tranmere North",
    "state_name":"South Australia"
  },
  {
    "postcode":5073,
    "place_name":"Rostrevor",
    "state_name":"South Australia"
  },
  {
    "postcode":5073,
    "place_name":"Hectorville",
    "state_name":"South Australia"
  },
  {
    "postcode":5074,
    "place_name":"Newton",
    "state_name":"South Australia"
  },
  {
    "postcode":5074,
    "place_name":"Campbelltown",
    "state_name":"South Australia"
  },
  {
    "postcode":5075,
    "place_name":"Paradise",
    "state_name":"South Australia"
  },
  {
    "postcode":5075,
    "place_name":"Dernancourt",
    "state_name":"South Australia"
  },
  {
    "postcode":5076,
    "place_name":"Athelstone",
    "state_name":"South Australia"
  },
  {
    "postcode":5076,
    "place_name":"Castambul",
    "state_name":"South Australia"
  },
  {
    "postcode":5081,
    "place_name":"Gilberton",
    "state_name":"South Australia"
  },
  {
    "postcode":5081,
    "place_name":"Vale Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5081,
    "place_name":"Medindie",
    "state_name":"South Australia"
  },
  {
    "postcode":5081,
    "place_name":"Walkerville",
    "state_name":"South Australia"
  },
  {
    "postcode":5081,
    "place_name":"Collinswood",
    "state_name":"South Australia"
  },
  {
    "postcode":5081,
    "place_name":"Medindie Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5082,
    "place_name":"Fitzroy",
    "state_name":"South Australia"
  },
  {
    "postcode":5082,
    "place_name":"Prospect East",
    "state_name":"South Australia"
  },
  {
    "postcode":5082,
    "place_name":"Ovingham",
    "state_name":"South Australia"
  },
  {
    "postcode":5082,
    "place_name":"Thorngate",
    "state_name":"South Australia"
  },
  {
    "postcode":5082,
    "place_name":"Prospect",
    "state_name":"South Australia"
  },
  {
    "postcode":5083,
    "place_name":"Broadview",
    "state_name":"South Australia"
  },
  {
    "postcode":5083,
    "place_name":"Sefton Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5083,
    "place_name":"Nailsworth",
    "state_name":"South Australia"
  },
  {
    "postcode":5084,
    "place_name":"Kilburn North",
    "state_name":"South Australia"
  },
  {
    "postcode":5084,
    "place_name":"Kilburn",
    "state_name":"South Australia"
  },
  {
    "postcode":5084,
    "place_name":"Blair Athol",
    "state_name":"South Australia"
  },
  {
    "postcode":5085,
    "place_name":"Northgate",
    "state_name":"South Australia"
  },
  {
    "postcode":5085,
    "place_name":"Northfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5085,
    "place_name":"Clearview",
    "state_name":"South Australia"
  },
  {
    "postcode":5085,
    "place_name":"Enfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5085,
    "place_name":"Enfield Plaza",
    "state_name":"South Australia"
  },
  {
    "postcode":5086,
    "place_name":"Oakden",
    "state_name":"South Australia"
  },
  {
    "postcode":5086,
    "place_name":"Manningham",
    "state_name":"South Australia"
  },
  {
    "postcode":5086,
    "place_name":"Gilles Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5086,
    "place_name":"Greenacres",
    "state_name":"South Australia"
  },
  {
    "postcode":5086,
    "place_name":"Hillcrest",
    "state_name":"South Australia"
  },
  {
    "postcode":5086,
    "place_name":"Hampstead Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5087,
    "place_name":"Windsor Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5087,
    "place_name":"Klemzig",
    "state_name":"South Australia"
  },
  {
    "postcode":5088,
    "place_name":"Holden Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5089,
    "place_name":"Highbury",
    "state_name":"South Australia"
  },
  {
    "postcode":5090,
    "place_name":"Hope Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5091,
    "place_name":"Tea Tree Gully",
    "state_name":"South Australia"
  },
  {
    "postcode":5091,
    "place_name":"Vista",
    "state_name":"South Australia"
  },
  {
    "postcode":5091,
    "place_name":"Banksia Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5092,
    "place_name":"Modbury North DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5092,
    "place_name":"Modbury",
    "state_name":"South Australia"
  },
  {
    "postcode":5092,
    "place_name":"Modbury North",
    "state_name":"South Australia"
  },
  {
    "postcode":5092,
    "place_name":"Modbury Heights",
    "state_name":"South Australia"
  },
  {
    "postcode":5093,
    "place_name":"Valley View",
    "state_name":"South Australia"
  },
  {
    "postcode":5093,
    "place_name":"Para Vista",
    "state_name":"South Australia"
  },
  {
    "postcode":5094,
    "place_name":"Gepps Cross",
    "state_name":"South Australia"
  },
  {
    "postcode":5094,
    "place_name":"Dry Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5094,
    "place_name":"Cavan",
    "state_name":"South Australia"
  },
  {
    "postcode":5095,
    "place_name":"Pooraka",
    "state_name":"South Australia"
  },
  {
    "postcode":5095,
    "place_name":"The Levels",
    "state_name":"South Australia"
  },
  {
    "postcode":5095,
    "place_name":"Mawson Lakes",
    "state_name":"South Australia"
  },
  {
    "postcode":5096,
    "place_name":"Para Hills West",
    "state_name":"South Australia"
  },
  {
    "postcode":5096,
    "place_name":"Para Hills",
    "state_name":"South Australia"
  },
  {
    "postcode":5096,
    "place_name":"Gulfview Heights",
    "state_name":"South Australia"
  },
  {
    "postcode":5097,
    "place_name":"Redwood Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5097,
    "place_name":"St Agnes",
    "state_name":"South Australia"
  },
  {
    "postcode":5097,
    "place_name":"Ridgehaven",
    "state_name":"South Australia"
  },
  {
    "postcode":5098,
    "place_name":"Ingle Farm",
    "state_name":"South Australia"
  },
  {
    "postcode":5098,
    "place_name":"Walkley Heights",
    "state_name":"South Australia"
  },
  {
    "postcode":5106,
    "place_name":"Parafield",
    "state_name":"South Australia"
  },
  {
    "postcode":5106,
    "place_name":"Salisbury South DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5106,
    "place_name":"Salisbury South",
    "state_name":"South Australia"
  },
  {
    "postcode":5106,
    "place_name":"Salisbury South BC",
    "state_name":"South Australia"
  },
  {
    "postcode":5107,
    "place_name":"Parafield Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5107,
    "place_name":"Green Fields",
    "state_name":"South Australia"
  },
  {
    "postcode":5108,
    "place_name":"Salisbury",
    "state_name":"South Australia"
  },
  {
    "postcode":5108,
    "place_name":"Salisbury North Whites Road",
    "state_name":"South Australia"
  },
  {
    "postcode":5108,
    "place_name":"Paralowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5108,
    "place_name":"Salisbury Downs",
    "state_name":"South Australia"
  },
  {
    "postcode":5108,
    "place_name":"Salisbury North",
    "state_name":"South Australia"
  },
  {
    "postcode":5109,
    "place_name":"Salisbury East Northbri Ave",
    "state_name":"South Australia"
  },
  {
    "postcode":5109,
    "place_name":"Salisbury Plain",
    "state_name":"South Australia"
  },
  {
    "postcode":5109,
    "place_name":"Salisbury East",
    "state_name":"South Australia"
  },
  {
    "postcode":5109,
    "place_name":"Salisbury Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5109,
    "place_name":"Salisbury Heights",
    "state_name":"South Australia"
  },
  {
    "postcode":5109,
    "place_name":"Brahma Lodge",
    "state_name":"South Australia"
  },
  {
    "postcode":5110,
    "place_name":"Direk",
    "state_name":"South Australia"
  },
  {
    "postcode":5110,
    "place_name":"Globe Derby Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5110,
    "place_name":"Waterloo Corner",
    "state_name":"South Australia"
  },
  {
    "postcode":5110,
    "place_name":"St Kilda",
    "state_name":"South Australia"
  },
  {
    "postcode":5110,
    "place_name":"Bolivar",
    "state_name":"South Australia"
  },
  {
    "postcode":5110,
    "place_name":"Burton",
    "state_name":"South Australia"
  },
  {
    "postcode":5111,
    "place_name":"Edinburgh",
    "state_name":"South Australia"
  },
  {
    "postcode":5111,
    "place_name":"Edinburgh Raaf",
    "state_name":"South Australia"
  },
  {
    "postcode":5112,
    "place_name":"Elizabeth Vale",
    "state_name":"South Australia"
  },
  {
    "postcode":5112,
    "place_name":"Hillbank",
    "state_name":"South Australia"
  },
  {
    "postcode":5112,
    "place_name":"Elizabeth South",
    "state_name":"South Australia"
  },
  {
    "postcode":5112,
    "place_name":"Elizabeth Grove",
    "state_name":"South Australia"
  },
  {
    "postcode":5112,
    "place_name":"Elizabeth",
    "state_name":"South Australia"
  },
  {
    "postcode":5112,
    "place_name":"Elizabeth East",
    "state_name":"South Australia"
  },
  {
    "postcode":5113,
    "place_name":"Elizabeth Downs",
    "state_name":"South Australia"
  },
  {
    "postcode":5113,
    "place_name":"Davoren Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5113,
    "place_name":"Elizabeth West",
    "state_name":"South Australia"
  },
  {
    "postcode":5113,
    "place_name":"Davoren Park South",
    "state_name":"South Australia"
  },
  {
    "postcode":5113,
    "place_name":"Elizabeth Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5113,
    "place_name":"Elizabeth North",
    "state_name":"South Australia"
  },
  {
    "postcode":5113,
    "place_name":"Elizabeth West DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5113,
    "place_name":"Edinburgh North",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"One Tree Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"Smithfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"Smithfield West",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"Sampson Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"Uleybury",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"Gould Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"Andrews Farm",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"Humbug Scrub",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"Smithfield Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"Yattalunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"Blakeview",
    "state_name":"South Australia"
  },
  {
    "postcode":5114,
    "place_name":"Craigmore",
    "state_name":"South Australia"
  },
  {
    "postcode":5115,
    "place_name":"Munno Para",
    "state_name":"South Australia"
  },
  {
    "postcode":5115,
    "place_name":"Kudla",
    "state_name":"South Australia"
  },
  {
    "postcode":5115,
    "place_name":"Munno Para West",
    "state_name":"South Australia"
  },
  {
    "postcode":5115,
    "place_name":"Munno Para Downs",
    "state_name":"South Australia"
  },
  {
    "postcode":5116,
    "place_name":"Evanston",
    "state_name":"South Australia"
  },
  {
    "postcode":5116,
    "place_name":"Evanston Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5116,
    "place_name":"Hillier",
    "state_name":"South Australia"
  },
  {
    "postcode":5116,
    "place_name":"Evanston Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5116,
    "place_name":"Evanston South",
    "state_name":"South Australia"
  },
  {
    "postcode":5117,
    "place_name":"Angle Vale",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Kingsford",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Gawler",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Kalbeeba",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Concordia",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Gawler East",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Willaston",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Hewett",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Gawler River",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Reid",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Gawler West",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Gawler South",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Kangaroo Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Bibaringa",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Ward Belt",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Gawler Belt",
    "state_name":"South Australia"
  },
  {
    "postcode":5118,
    "place_name":"Buchfelde",
    "state_name":"South Australia"
  },
  {
    "postcode":5120,
    "place_name":"Virginia",
    "state_name":"South Australia"
  },
  {
    "postcode":5120,
    "place_name":"Buckland Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5121,
    "place_name":"Penfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5121,
    "place_name":"Penfield Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5121,
    "place_name":"Macdonald Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5125,
    "place_name":"Golden Grove",
    "state_name":"South Australia"
  },
  {
    "postcode":5125,
    "place_name":"Golden Grove Village",
    "state_name":"South Australia"
  },
  {
    "postcode":5125,
    "place_name":"Greenwith",
    "state_name":"South Australia"
  },
  {
    "postcode":5126,
    "place_name":"Fairview Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5126,
    "place_name":"Yatala Vale",
    "state_name":"South Australia"
  },
  {
    "postcode":5126,
    "place_name":"Surrey Downs",
    "state_name":"South Australia"
  },
  {
    "postcode":5127,
    "place_name":"Wynn Vale",
    "state_name":"South Australia"
  },
  {
    "postcode":5131,
    "place_name":"Houghton",
    "state_name":"South Australia"
  },
  {
    "postcode":5131,
    "place_name":"Upper Hermitage",
    "state_name":"South Australia"
  },
  {
    "postcode":5131,
    "place_name":"Lower Hermitage",
    "state_name":"South Australia"
  },
  {
    "postcode":5132,
    "place_name":"Paracombe",
    "state_name":"South Australia"
  },
  {
    "postcode":5133,
    "place_name":"Inglewood",
    "state_name":"South Australia"
  },
  {
    "postcode":5134,
    "place_name":"Montacute",
    "state_name":"South Australia"
  },
  {
    "postcode":5134,
    "place_name":"Cherryville",
    "state_name":"South Australia"
  },
  {
    "postcode":5136,
    "place_name":"Norton Summit",
    "state_name":"South Australia"
  },
  {
    "postcode":5137,
    "place_name":"Ashton",
    "state_name":"South Australia"
  },
  {
    "postcode":5137,
    "place_name":"Marble Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5138,
    "place_name":"Basket Range",
    "state_name":"South Australia"
  },
  {
    "postcode":5139,
    "place_name":"Forest Range",
    "state_name":"South Australia"
  },
  {
    "postcode":5140,
    "place_name":"Greenhill",
    "state_name":"South Australia"
  },
  {
    "postcode":5141,
    "place_name":"Summertown",
    "state_name":"South Australia"
  },
  {
    "postcode":5141,
    "place_name":"Horsnell Gully",
    "state_name":"South Australia"
  },
  {
    "postcode":5142,
    "place_name":"Uraidla",
    "state_name":"South Australia"
  },
  {
    "postcode":5144,
    "place_name":"Carey Gully",
    "state_name":"South Australia"
  },
  {
    "postcode":5150,
    "place_name":"Leawood Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5150,
    "place_name":"Eagle On The Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5151,
    "place_name":"Piccadilly",
    "state_name":"South Australia"
  },
  {
    "postcode":5152,
    "place_name":"Stirling",
    "state_name":"South Australia"
  },
  {
    "postcode":5152,
    "place_name":"Crafers",
    "state_name":"South Australia"
  },
  {
    "postcode":5152,
    "place_name":"Cleland",
    "state_name":"South Australia"
  },
  {
    "postcode":5152,
    "place_name":"Crafers West",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Longwood",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Scott Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Jupiter Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Bradbury",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Macclesfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Echunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Mylor",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Biggs Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Chapel Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Ironbank",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Heathfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Flaxley",
    "state_name":"South Australia"
  },
  {
    "postcode":5153,
    "place_name":"Green Hills Range",
    "state_name":"South Australia"
  },
  {
    "postcode":5154,
    "place_name":"Aldgate",
    "state_name":"South Australia"
  },
  {
    "postcode":5155,
    "place_name":"Mount George",
    "state_name":"South Australia"
  },
  {
    "postcode":5155,
    "place_name":"Bridgewater",
    "state_name":"South Australia"
  },
  {
    "postcode":5156,
    "place_name":"Upper Sturt",
    "state_name":"South Australia"
  },
  {
    "postcode":5157,
    "place_name":"Dorset Vale",
    "state_name":"South Australia"
  },
  {
    "postcode":5157,
    "place_name":"Clarendon",
    "state_name":"South Australia"
  },
  {
    "postcode":5157,
    "place_name":"Cherry Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5157,
    "place_name":"Kangarilla",
    "state_name":"South Australia"
  },
  {
    "postcode":5157,
    "place_name":"Bull Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5157,
    "place_name":"Ashbourne",
    "state_name":"South Australia"
  },
  {
    "postcode":5157,
    "place_name":"Coromandel East",
    "state_name":"South Australia"
  },
  {
    "postcode":5157,
    "place_name":"Mcharg Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5158,
    "place_name":"Sheidow Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5158,
    "place_name":"O'Halloran Hill DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5158,
    "place_name":"Hallett Cove",
    "state_name":"South Australia"
  },
  {
    "postcode":5158,
    "place_name":"O'Halloran Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5158,
    "place_name":"Trott Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5159,
    "place_name":"Happy Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5159,
    "place_name":"Chandlers Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5159,
    "place_name":"Flagstaff Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5159,
    "place_name":"Aberfoyle Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5160,
    "place_name":"Lonsdale DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5160,
    "place_name":"Lonsdale",
    "state_name":"South Australia"
  },
  {
    "postcode":5161,
    "place_name":"Reynella",
    "state_name":"South Australia"
  },
  {
    "postcode":5161,
    "place_name":"Reynella East",
    "state_name":"South Australia"
  },
  {
    "postcode":5161,
    "place_name":"Old Reynella",
    "state_name":"South Australia"
  },
  {
    "postcode":5162,
    "place_name":"Morphett Vale",
    "state_name":"South Australia"
  },
  {
    "postcode":5162,
    "place_name":"Woodcroft",
    "state_name":"South Australia"
  },
  {
    "postcode":5163,
    "place_name":"Huntfield Heights",
    "state_name":"South Australia"
  },
  {
    "postcode":5163,
    "place_name":"Onkaparinga Hills",
    "state_name":"South Australia"
  },
  {
    "postcode":5163,
    "place_name":"Hackham West",
    "state_name":"South Australia"
  },
  {
    "postcode":5163,
    "place_name":"Hackham",
    "state_name":"South Australia"
  },
  {
    "postcode":5164,
    "place_name":"Christie Downs",
    "state_name":"South Australia"
  },
  {
    "postcode":5165,
    "place_name":"Christies Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5165,
    "place_name":"Christies Beach North",
    "state_name":"South Australia"
  },
  {
    "postcode":5166,
    "place_name":"O'Sullivan Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5167,
    "place_name":"Port Noarlunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5167,
    "place_name":"Port Noarlunga South",
    "state_name":"South Australia"
  },
  {
    "postcode":5168,
    "place_name":"Old Noarlunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5168,
    "place_name":"Noarlunga Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5168,
    "place_name":"Noarlunga Downs",
    "state_name":"South Australia"
  },
  {
    "postcode":5169,
    "place_name":"Seaford Heights",
    "state_name":"South Australia"
  },
  {
    "postcode":5169,
    "place_name":"Moana",
    "state_name":"South Australia"
  },
  {
    "postcode":5169,
    "place_name":"Seaford Meadows",
    "state_name":"South Australia"
  },
  {
    "postcode":5169,
    "place_name":"Seaford",
    "state_name":"South Australia"
  },
  {
    "postcode":5169,
    "place_name":"Seaford Rise",
    "state_name":"South Australia"
  },
  {
    "postcode":5170,
    "place_name":"Maslin Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5171,
    "place_name":"Blewitt Springs",
    "state_name":"South Australia"
  },
  {
    "postcode":5171,
    "place_name":"Mclaren Vale",
    "state_name":"South Australia"
  },
  {
    "postcode":5171,
    "place_name":"Tatachilla",
    "state_name":"South Australia"
  },
  {
    "postcode":5171,
    "place_name":"Mclaren Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5171,
    "place_name":"Pedler Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"Hope Forest",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"Willunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"Yundi",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"Willunga Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"Dingabledinga",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"Willunga South",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"The Range",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"Pages Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"Kuitpo Colony",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"Montarra",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"Kyeema",
    "state_name":"South Australia"
  },
  {
    "postcode":5172,
    "place_name":"Whites Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5173,
    "place_name":"Port Willunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5173,
    "place_name":"Aldinga",
    "state_name":"South Australia"
  },
  {
    "postcode":5173,
    "place_name":"Aldinga Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5174,
    "place_name":"Sellicks Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5174,
    "place_name":"Sellicks Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5201,
    "place_name":"Kuitpo",
    "state_name":"South Australia"
  },
  {
    "postcode":5201,
    "place_name":"Meadows",
    "state_name":"South Australia"
  },
  {
    "postcode":5201,
    "place_name":"Prospect Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5201,
    "place_name":"Blackfellows Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5201,
    "place_name":"Paris Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5202,
    "place_name":"Hindmarsh Tiers",
    "state_name":"South Australia"
  },
  {
    "postcode":5202,
    "place_name":"Myponga",
    "state_name":"South Australia"
  },
  {
    "postcode":5202,
    "place_name":"Myponga Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5203,
    "place_name":"Bald Hills",
    "state_name":"South Australia"
  },
  {
    "postcode":5203,
    "place_name":"Yankalilla",
    "state_name":"South Australia"
  },
  {
    "postcode":5203,
    "place_name":"Wattle Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5203,
    "place_name":"Parawa",
    "state_name":"South Australia"
  },
  {
    "postcode":5203,
    "place_name":"Tunkalilla",
    "state_name":"South Australia"
  },
  {
    "postcode":5203,
    "place_name":"Torrens Vale",
    "state_name":"South Australia"
  },
  {
    "postcode":5204,
    "place_name":"Normanville",
    "state_name":"South Australia"
  },
  {
    "postcode":5204,
    "place_name":"Rapid Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5204,
    "place_name":"Second Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5204,
    "place_name":"Wirrina Cove",
    "state_name":"South Australia"
  },
  {
    "postcode":5204,
    "place_name":"Delamere",
    "state_name":"South Australia"
  },
  {
    "postcode":5204,
    "place_name":"Hay Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5204,
    "place_name":"Carrickalinga",
    "state_name":"South Australia"
  },
  {
    "postcode":5204,
    "place_name":"Silverton",
    "state_name":"South Australia"
  },
  {
    "postcode":5204,
    "place_name":"Cape Jervis",
    "state_name":"South Australia"
  },
  {
    "postcode":5204,
    "place_name":"Deep Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5210,
    "place_name":"Mount Compass",
    "state_name":"South Australia"
  },
  {
    "postcode":5210,
    "place_name":"Mount Magnificent",
    "state_name":"South Australia"
  },
  {
    "postcode":5210,
    "place_name":"Nangkita",
    "state_name":"South Australia"
  },
  {
    "postcode":5211,
    "place_name":"Lower Inman Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5211,
    "place_name":"Inman Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5211,
    "place_name":"Waitpinga",
    "state_name":"South Australia"
  },
  {
    "postcode":5211,
    "place_name":"Encounter Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5211,
    "place_name":"Hayborough",
    "state_name":"South Australia"
  },
  {
    "postcode":5211,
    "place_name":"Back Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5211,
    "place_name":"Willow Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5211,
    "place_name":"Hindmarsh Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5211,
    "place_name":"Mount Jagged",
    "state_name":"South Australia"
  },
  {
    "postcode":5211,
    "place_name":"Mccracken",
    "state_name":"South Australia"
  },
  {
    "postcode":5211,
    "place_name":"Victor Harbor",
    "state_name":"South Australia"
  },
  {
    "postcode":5212,
    "place_name":"Port Elliot",
    "state_name":"South Australia"
  },
  {
    "postcode":5213,
    "place_name":"Middleton",
    "state_name":"South Australia"
  },
  {
    "postcode":5214,
    "place_name":"Hindmarsh Island",
    "state_name":"South Australia"
  },
  {
    "postcode":5214,
    "place_name":"Mosquito Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5214,
    "place_name":"Goolwa Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5214,
    "place_name":"Currency Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5214,
    "place_name":"Goolwa",
    "state_name":"South Australia"
  },
  {
    "postcode":5214,
    "place_name":"Mundoo Island",
    "state_name":"South Australia"
  },
  {
    "postcode":5214,
    "place_name":"Goolwa South",
    "state_name":"South Australia"
  },
  {
    "postcode":5214,
    "place_name":"Goolwa North",
    "state_name":"South Australia"
  },
  {
    "postcode":5220,
    "place_name":"Parndana",
    "state_name":"South Australia"
  },
  {
    "postcode":5221,
    "place_name":"American River",
    "state_name":"South Australia"
  },
  {
    "postcode":5221,
    "place_name":"Ballast Head",
    "state_name":"South Australia"
  },
  {
    "postcode":5221,
    "place_name":"Muston",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Kangaroo Head",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Island Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Penneshaw",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Pelican Lagoon",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Brown Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Sapphiretown",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Baudin Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Dudley West",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Ironstone",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Antechamber Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Cuttlefish Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Dudley East",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Willson River",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"American Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Porky Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5222,
    "place_name":"Willoughby",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"North Cape",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"D'Estrees Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Kingscote",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Newland",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Seddon",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Emu Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Vivonne Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Kohinoor",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Brownlow Ki",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Bay Of Shoals",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Wisanger",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Karatta",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Cygnet River",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Cape Borda",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Stokes Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Haines",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"De Mole River",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Gosse",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Birchmore",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Nepean Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Macgillivray",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Menzies",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Flinders Chase",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Cassini",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Stun'Sail Boom",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Seal Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Middle River",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Western River",
    "state_name":"South Australia"
  },
  {
    "postcode":5223,
    "place_name":"Duncan",
    "state_name":"South Australia"
  },
  {
    "postcode":5231,
    "place_name":"Chain Of Ponds",
    "state_name":"South Australia"
  },
  {
    "postcode":5231,
    "place_name":"Kersbrook",
    "state_name":"South Australia"
  },
  {
    "postcode":5231,
    "place_name":"Millbrook",
    "state_name":"South Australia"
  },
  {
    "postcode":5232,
    "place_name":"Cudlee Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5233,
    "place_name":"Gumeracha",
    "state_name":"South Australia"
  },
  {
    "postcode":5233,
    "place_name":"Forreston",
    "state_name":"South Australia"
  },
  {
    "postcode":5234,
    "place_name":"Birdwood",
    "state_name":"South Australia"
  },
  {
    "postcode":5235,
    "place_name":"Flaxman Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5235,
    "place_name":"Springton",
    "state_name":"South Australia"
  },
  {
    "postcode":5235,
    "place_name":"Taunton",
    "state_name":"South Australia"
  },
  {
    "postcode":5235,
    "place_name":"Mount Pleasant",
    "state_name":"South Australia"
  },
  {
    "postcode":5235,
    "place_name":"Cromer",
    "state_name":"South Australia"
  },
  {
    "postcode":5235,
    "place_name":"Eden Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5236,
    "place_name":"Tungkillo",
    "state_name":"South Australia"
  },
  {
    "postcode":5237,
    "place_name":"Sanderston",
    "state_name":"South Australia"
  },
  {
    "postcode":5237,
    "place_name":"Milendella",
    "state_name":"South Australia"
  },
  {
    "postcode":5237,
    "place_name":"Palmer",
    "state_name":"South Australia"
  },
  {
    "postcode":5237,
    "place_name":"Apamurra",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Bowhill",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Ponde",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Purnong",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Frayville",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Caurnamont",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Nildottie",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Purnong Landing",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Five Miles",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Younghusband Holdings",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Angas Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Teal Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Julanka Holdings",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Walker Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Pompoota",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Wongulla",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Frahns",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Rocky Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Younghusband",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Forster",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Port Mannum",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Mannum",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Bolto",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Old Teal Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Big Bend",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Punthari",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Cowirra",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Pellaring Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Lake Carlet",
    "state_name":"South Australia"
  },
  {
    "postcode":5238,
    "place_name":"Claypans",
    "state_name":"South Australia"
  },
  {
    "postcode":5240,
    "place_name":"Lenswood",
    "state_name":"South Australia"
  },
  {
    "postcode":5241,
    "place_name":"Lobethal",
    "state_name":"South Australia"
  },
  {
    "postcode":5242,
    "place_name":"Balhannah",
    "state_name":"South Australia"
  },
  {
    "postcode":5243,
    "place_name":"Oakbank",
    "state_name":"South Australia"
  },
  {
    "postcode":5244,
    "place_name":"Inverbrackie",
    "state_name":"South Australia"
  },
  {
    "postcode":5244,
    "place_name":"Charleston",
    "state_name":"South Australia"
  },
  {
    "postcode":5244,
    "place_name":"Mount Torrens",
    "state_name":"South Australia"
  },
  {
    "postcode":5244,
    "place_name":"Woodside",
    "state_name":"South Australia"
  },
  {
    "postcode":5244,
    "place_name":"Harrogate",
    "state_name":"South Australia"
  },
  {
    "postcode":5245,
    "place_name":"Paechtown",
    "state_name":"South Australia"
  },
  {
    "postcode":5245,
    "place_name":"Hahndorf",
    "state_name":"South Australia"
  },
  {
    "postcode":5245,
    "place_name":"Verdun",
    "state_name":"South Australia"
  },
  {
    "postcode":5246,
    "place_name":"Woodhouse",
    "state_name":"South Australia"
  },
  {
    "postcode":5250,
    "place_name":"Littlehampton",
    "state_name":"South Australia"
  },
  {
    "postcode":5250,
    "place_name":"Blakiston",
    "state_name":"South Australia"
  },
  {
    "postcode":5250,
    "place_name":"Totness",
    "state_name":"South Australia"
  },
  {
    "postcode":5251,
    "place_name":"Mount Barker Junction",
    "state_name":"South Australia"
  },
  {
    "postcode":5251,
    "place_name":"Mount Barker Springs",
    "state_name":"South Australia"
  },
  {
    "postcode":5251,
    "place_name":"Bugle Ranges",
    "state_name":"South Australia"
  },
  {
    "postcode":5251,
    "place_name":"Mount Barker Summit",
    "state_name":"South Australia"
  },
  {
    "postcode":5251,
    "place_name":"Mount Barker",
    "state_name":"South Australia"
  },
  {
    "postcode":5251,
    "place_name":"Wistow",
    "state_name":"South Australia"
  },
  {
    "postcode":5252,
    "place_name":"Nairne",
    "state_name":"South Australia"
  },
  {
    "postcode":5252,
    "place_name":"Brukunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5252,
    "place_name":"Dawesley",
    "state_name":"South Australia"
  },
  {
    "postcode":5252,
    "place_name":"Kanmantoo",
    "state_name":"South Australia"
  },
  {
    "postcode":5252,
    "place_name":"St Ives",
    "state_name":"South Australia"
  },
  {
    "postcode":5252,
    "place_name":"Hay Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Brinkley",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Riverglen",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Ettrick",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Murray Bridge East",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"White Sands",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Northern Heights",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Swanport",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Murray Bridge",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Chapman Bore",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Murrawong",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Monteith",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Mobilong",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Sunnyside",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Willow Banks",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Riverglades",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Murray Bridge North",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Toora",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Murray Bridge South",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Long Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Gifford Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Greenbanks",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Avoca Dell",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Burdett",
    "state_name":"South Australia"
  },
  {
    "postcode":5253,
    "place_name":"Woods Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Murray Bridge",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Wall Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Caloote",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"White Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Monarto South",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Mypolonga",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Pallamana",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Woodlane",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Monarto",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Rocky Gully",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Tepko",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Petwood",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Callington",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Zadows Landing",
    "state_name":"South Australia"
  },
  {
    "postcode":5254,
    "place_name":"Rockleigh",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Woodchester",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Tooperang",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Mount Observation",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Finniss",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Mulgundawa",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Belvidere",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Gemmells",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Lake Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Langhorne Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Red Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Salem",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Bletchley",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Strathalbyn",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Sandergrove",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Nalpa",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Angas Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Highland Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Hartley",
    "state_name":"South Australia"
  },
  {
    "postcode":5255,
    "place_name":"Willyaroo",
    "state_name":"South Australia"
  },
  {
    "postcode":5256,
    "place_name":"Clayton Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5256,
    "place_name":"Tolderol",
    "state_name":"South Australia"
  },
  {
    "postcode":5256,
    "place_name":"Point Sturt",
    "state_name":"South Australia"
  },
  {
    "postcode":5256,
    "place_name":"Clayton",
    "state_name":"South Australia"
  },
  {
    "postcode":5256,
    "place_name":"Milang",
    "state_name":"South Australia"
  },
  {
    "postcode":5256,
    "place_name":"Nurragi",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Tailem Bend",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Wellington",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Narrung",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Wellington East",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Ashville",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Kepa",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Jervois",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Point Mcleay",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Naturi",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Raukkan",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Poltalloch",
    "state_name":"South Australia"
  },
  {
    "postcode":5259,
    "place_name":"Malinong",
    "state_name":"South Australia"
  },
  {
    "postcode":5260,
    "place_name":"Tailem Bend",
    "state_name":"South Australia"
  },
  {
    "postcode":5260,
    "place_name":"Elwomple",
    "state_name":"South Australia"
  },
  {
    "postcode":5261,
    "place_name":"Yumali",
    "state_name":"South Australia"
  },
  {
    "postcode":5261,
    "place_name":"Ki Ki",
    "state_name":"South Australia"
  },
  {
    "postcode":5261,
    "place_name":"Culburra",
    "state_name":"South Australia"
  },
  {
    "postcode":5261,
    "place_name":"Cooke Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5261,
    "place_name":"Coomandook",
    "state_name":"South Australia"
  },
  {
    "postcode":5262,
    "place_name":"Binnum",
    "state_name":"South Australia"
  },
  {
    "postcode":5262,
    "place_name":"Frances",
    "state_name":"South Australia"
  },
  {
    "postcode":5262,
    "place_name":"Kybybolite",
    "state_name":"South Australia"
  },
  {
    "postcode":5262,
    "place_name":"Hynam",
    "state_name":"South Australia"
  },
  {
    "postcode":5263,
    "place_name":"Coonawarra",
    "state_name":"South Australia"
  },
  {
    "postcode":5264,
    "place_name":"Meningie East",
    "state_name":"South Australia"
  },
  {
    "postcode":5264,
    "place_name":"Meningie",
    "state_name":"South Australia"
  },
  {
    "postcode":5264,
    "place_name":"Coorong",
    "state_name":"South Australia"
  },
  {
    "postcode":5264,
    "place_name":"Waltowa",
    "state_name":"South Australia"
  },
  {
    "postcode":5264,
    "place_name":"Meningie West",
    "state_name":"South Australia"
  },
  {
    "postcode":5264,
    "place_name":"Salt Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5265,
    "place_name":"Field",
    "state_name":"South Australia"
  },
  {
    "postcode":5265,
    "place_name":"Coonalpyn",
    "state_name":"South Australia"
  },
  {
    "postcode":5266,
    "place_name":"Deepwater",
    "state_name":"South Australia"
  },
  {
    "postcode":5266,
    "place_name":"Tintinara",
    "state_name":"South Australia"
  },
  {
    "postcode":5266,
    "place_name":"Bunbury",
    "state_name":"South Australia"
  },
  {
    "postcode":5266,
    "place_name":"Colebatch",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Coombe",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Mount Charles",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Petherick",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Wirrega",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Sherwood",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Keith",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Shaugh",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Mccallum",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Brimbago",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Laffer",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Willalooka",
    "state_name":"South Australia"
  },
  {
    "postcode":5267,
    "place_name":"Makin",
    "state_name":"South Australia"
  },
  {
    "postcode":5268,
    "place_name":"Lowan Vale",
    "state_name":"South Australia"
  },
  {
    "postcode":5268,
    "place_name":"Western Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5268,
    "place_name":"Cannawigara",
    "state_name":"South Australia"
  },
  {
    "postcode":5268,
    "place_name":"Bordertown South",
    "state_name":"South Australia"
  },
  {
    "postcode":5268,
    "place_name":"Senior",
    "state_name":"South Australia"
  },
  {
    "postcode":5268,
    "place_name":"Bordertown",
    "state_name":"South Australia"
  },
  {
    "postcode":5268,
    "place_name":"Pooginagoric",
    "state_name":"South Australia"
  },
  {
    "postcode":5268,
    "place_name":"Bangham",
    "state_name":"South Australia"
  },
  {
    "postcode":5269,
    "place_name":"Pine Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5269,
    "place_name":"Wolseley",
    "state_name":"South Australia"
  },
  {
    "postcode":5269,
    "place_name":"Custon",
    "state_name":"South Australia"
  },
  {
    "postcode":5270,
    "place_name":"Buckingham",
    "state_name":"South Australia"
  },
  {
    "postcode":5270,
    "place_name":"Kongal",
    "state_name":"South Australia"
  },
  {
    "postcode":5270,
    "place_name":"Carew",
    "state_name":"South Australia"
  },
  {
    "postcode":5270,
    "place_name":"Mundulla",
    "state_name":"South Australia"
  },
  {
    "postcode":5270,
    "place_name":"Mundulla West",
    "state_name":"South Australia"
  },
  {
    "postcode":5270,
    "place_name":"Swede Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Bool Lagoon",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Laurie Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Keppoch",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Moyhall",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Naracoorte",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Struan",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Padthaway",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Koppamurra",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Joanna",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Lochaber",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Cadgee",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Wrattonbully",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Spence",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Mount Light",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Wild Dog Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Marcollat",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"The Gap",
    "state_name":"South Australia"
  },
  {
    "postcode":5271,
    "place_name":"Stewart Range",
    "state_name":"South Australia"
  },
  {
    "postcode":5272,
    "place_name":"Lucindale",
    "state_name":"South Australia"
  },
  {
    "postcode":5272,
    "place_name":"Woolumbool",
    "state_name":"South Australia"
  },
  {
    "postcode":5272,
    "place_name":"Conmurra",
    "state_name":"South Australia"
  },
  {
    "postcode":5272,
    "place_name":"Coles",
    "state_name":"South Australia"
  },
  {
    "postcode":5272,
    "place_name":"Fox",
    "state_name":"South Australia"
  },
  {
    "postcode":5272,
    "place_name":"Greenways",
    "state_name":"South Australia"
  },
  {
    "postcode":5273,
    "place_name":"Avenue Range",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Rosetown",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Pinks Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Boatswain Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Keilira",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"West Range",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Kingston Se",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Blackford",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Taratap",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Tilley Swamp",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Kingston S.E.",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Wangolina",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Mount Benson",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Reedy Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Sandy Grove",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Cape Jaffa",
    "state_name":"South Australia"
  },
  {
    "postcode":5275,
    "place_name":"Wyomi",
    "state_name":"South Australia"
  },
  {
    "postcode":5276,
    "place_name":"Nora Creina",
    "state_name":"South Australia"
  },
  {
    "postcode":5276,
    "place_name":"Robe",
    "state_name":"South Australia"
  },
  {
    "postcode":5276,
    "place_name":"Bray",
    "state_name":"South Australia"
  },
  {
    "postcode":5277,
    "place_name":"Pleasant Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5277,
    "place_name":"Glenroy",
    "state_name":"South Australia"
  },
  {
    "postcode":5277,
    "place_name":"Penola",
    "state_name":"South Australia"
  },
  {
    "postcode":5277,
    "place_name":"Comaum",
    "state_name":"South Australia"
  },
  {
    "postcode":5277,
    "place_name":"Maaoupe",
    "state_name":"South Australia"
  },
  {
    "postcode":5277,
    "place_name":"Tarpeena",
    "state_name":"South Australia"
  },
  {
    "postcode":5277,
    "place_name":"Monbulla",
    "state_name":"South Australia"
  },
  {
    "postcode":5277,
    "place_name":"Nangwarry",
    "state_name":"South Australia"
  },
  {
    "postcode":5278,
    "place_name":"Kalangadoo",
    "state_name":"South Australia"
  },
  {
    "postcode":5278,
    "place_name":"Wepar",
    "state_name":"South Australia"
  },
  {
    "postcode":5278,
    "place_name":"Krongart",
    "state_name":"South Australia"
  },
  {
    "postcode":5278,
    "place_name":"Moerlong",
    "state_name":"South Australia"
  },
  {
    "postcode":5279,
    "place_name":"Mount Burr",
    "state_name":"South Australia"
  },
  {
    "postcode":5279,
    "place_name":"Trihi",
    "state_name":"South Australia"
  },
  {
    "postcode":5279,
    "place_name":"Wattle Range East",
    "state_name":"South Australia"
  },
  {
    "postcode":5279,
    "place_name":"Short",
    "state_name":"South Australia"
  },
  {
    "postcode":5279,
    "place_name":"Mount Mcintyre",
    "state_name":"South Australia"
  },
  {
    "postcode":5279,
    "place_name":"Koorine",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Beachport",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Millicent",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Tantanoola",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Clay Wells",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Furner",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Sebastopol",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Rendelsham",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"German Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Southend",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Thornlea",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Hatherleigh",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Canunda",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Wattle Range",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Kangaroo Inn",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Magarey",
    "state_name":"South Australia"
  },
  {
    "postcode":5280,
    "place_name":"Rocky Camp",
    "state_name":"South Australia"
  },
  {
    "postcode":5290,
    "place_name":"Mount Gambier",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Glencoe West",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"German Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Caveton",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Allendale East",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Worrolong",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Compton",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Eight Mile Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Yahl",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Mount Gambier",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Nene Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Pelican Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Mount Schank",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Glencoe",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Kongorong",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Square Mile",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Wandilo",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Mil-Lel",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Carpenter Rocks",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Suttontown",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Caroline",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"O.B. Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Burrungule",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Mingbool",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Port Macdonnell",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Donovans",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Glenburnie",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Moorak",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Blackfellows Caves",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Dismal Swamp",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Mount Gambier West",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Mount Gambier East",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Cape Douglas",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Racecourse Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Ob Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5291,
    "place_name":"Wye",
    "state_name":"South Australia"
  },
  {
    "postcode":5301,
    "place_name":"Moorlands",
    "state_name":"South Australia"
  },
  {
    "postcode":5301,
    "place_name":"Sherlock",
    "state_name":"South Australia"
  },
  {
    "postcode":5301,
    "place_name":"Wilkawatt",
    "state_name":"South Australia"
  },
  {
    "postcode":5301,
    "place_name":"Carcuma",
    "state_name":"South Australia"
  },
  {
    "postcode":5301,
    "place_name":"Parrakie",
    "state_name":"South Australia"
  },
  {
    "postcode":5301,
    "place_name":"Jabuk",
    "state_name":"South Australia"
  },
  {
    "postcode":5301,
    "place_name":"Peake",
    "state_name":"South Australia"
  },
  {
    "postcode":5301,
    "place_name":"Geranium",
    "state_name":"South Australia"
  },
  {
    "postcode":5301,
    "place_name":"Netherton",
    "state_name":"South Australia"
  },
  {
    "postcode":5302,
    "place_name":"Ngarkat",
    "state_name":"South Australia"
  },
  {
    "postcode":5302,
    "place_name":"Lameroo",
    "state_name":"South Australia"
  },
  {
    "postcode":5303,
    "place_name":"Parilla",
    "state_name":"South Australia"
  },
  {
    "postcode":5304,
    "place_name":"Pinnaroo",
    "state_name":"South Australia"
  },
  {
    "postcode":5304,
    "place_name":"Karte",
    "state_name":"South Australia"
  },
  {
    "postcode":5304,
    "place_name":"Kringin",
    "state_name":"South Australia"
  },
  {
    "postcode":5304,
    "place_name":"Peebinga",
    "state_name":"South Australia"
  },
  {
    "postcode":5306,
    "place_name":"Wynarka",
    "state_name":"South Australia"
  },
  {
    "postcode":5307,
    "place_name":"Karoonda",
    "state_name":"South Australia"
  },
  {
    "postcode":5307,
    "place_name":"Marama",
    "state_name":"South Australia"
  },
  {
    "postcode":5308,
    "place_name":"Galga",
    "state_name":"South Australia"
  },
  {
    "postcode":5308,
    "place_name":"Copeville",
    "state_name":"South Australia"
  },
  {
    "postcode":5308,
    "place_name":"Perponda",
    "state_name":"South Australia"
  },
  {
    "postcode":5308,
    "place_name":"Mantung",
    "state_name":"South Australia"
  },
  {
    "postcode":5308,
    "place_name":"Mercunda",
    "state_name":"South Australia"
  },
  {
    "postcode":5309,
    "place_name":"Mindarie",
    "state_name":"South Australia"
  },
  {
    "postcode":5309,
    "place_name":"Halidon",
    "state_name":"South Australia"
  },
  {
    "postcode":5309,
    "place_name":"Sandalwood",
    "state_name":"South Australia"
  },
  {
    "postcode":5309,
    "place_name":"Borrika",
    "state_name":"South Australia"
  },
  {
    "postcode":5310,
    "place_name":"Caliph",
    "state_name":"South Australia"
  },
  {
    "postcode":5310,
    "place_name":"Wanbi",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Taplan",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Malpas",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Bugle Hut",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Maggea",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Veitch",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Woodleigh",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Meribah",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Taldra",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Alawoona",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Wunkar",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Schell Well",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Paruna",
    "state_name":"South Australia"
  },
  {
    "postcode":5311,
    "place_name":"Billiatt",
    "state_name":"South Australia"
  },
  {
    "postcode":5312,
    "place_name":"Veitch",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Stuart",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Eba",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Beatty",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Murbko",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Morgan",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Beaumonts",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Wombats Rest",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"North West Bend",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Morphetts Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Brenda Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Bundey",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Maude",
    "state_name":"South Australia"
  },
  {
    "postcode":5320,
    "place_name":"Lindley",
    "state_name":"South Australia"
  },
  {
    "postcode":5321,
    "place_name":"Cadell",
    "state_name":"South Australia"
  },
  {
    "postcode":5321,
    "place_name":"Cadell Lagoon",
    "state_name":"South Australia"
  },
  {
    "postcode":5322,
    "place_name":"Golden Heights",
    "state_name":"South Australia"
  },
  {
    "postcode":5322,
    "place_name":"Sunlands",
    "state_name":"South Australia"
  },
  {
    "postcode":5322,
    "place_name":"Ramco Heights",
    "state_name":"South Australia"
  },
  {
    "postcode":5322,
    "place_name":"Ramco",
    "state_name":"South Australia"
  },
  {
    "postcode":5322,
    "place_name":"Qualco",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Wigley Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Boolgun",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Kanni",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Waikerie",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Devlins Pound",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Taylorville",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Pooginook",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Overland Corner",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Stockyard Plain",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Holder",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Markaranka",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Good Hope Landing",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Holder Siding",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Woolpunda",
    "state_name":"South Australia"
  },
  {
    "postcode":5330,
    "place_name":"Lowbank",
    "state_name":"South Australia"
  },
  {
    "postcode":5331,
    "place_name":"Kingston On Murray",
    "state_name":"South Australia"
  },
  {
    "postcode":5331,
    "place_name":"Kingston-On-Murray",
    "state_name":"South Australia"
  },
  {
    "postcode":5332,
    "place_name":"Moorook South",
    "state_name":"South Australia"
  },
  {
    "postcode":5332,
    "place_name":"Yinkanie",
    "state_name":"South Australia"
  },
  {
    "postcode":5332,
    "place_name":"Wappilka",
    "state_name":"South Australia"
  },
  {
    "postcode":5332,
    "place_name":"Moorook",
    "state_name":"South Australia"
  },
  {
    "postcode":5333,
    "place_name":"Pyap",
    "state_name":"South Australia"
  },
  {
    "postcode":5333,
    "place_name":"Bookpurnong",
    "state_name":"South Australia"
  },
  {
    "postcode":5333,
    "place_name":"New Residence",
    "state_name":"South Australia"
  },
  {
    "postcode":5333,
    "place_name":"Pyap West",
    "state_name":"South Australia"
  },
  {
    "postcode":5333,
    "place_name":"Taplan",
    "state_name":"South Australia"
  },
  {
    "postcode":5333,
    "place_name":"Loxton",
    "state_name":"South Australia"
  },
  {
    "postcode":5333,
    "place_name":"Pata",
    "state_name":"South Australia"
  },
  {
    "postcode":5333,
    "place_name":"Loxton North",
    "state_name":"South Australia"
  },
  {
    "postcode":5340,
    "place_name":"Wonuarra",
    "state_name":"South Australia"
  },
  {
    "postcode":5340,
    "place_name":"Paringa",
    "state_name":"South Australia"
  },
  {
    "postcode":5340,
    "place_name":"Yamba",
    "state_name":"South Australia"
  },
  {
    "postcode":5340,
    "place_name":"Murtho",
    "state_name":"South Australia"
  },
  {
    "postcode":5340,
    "place_name":"Pike River",
    "state_name":"South Australia"
  },
  {
    "postcode":5340,
    "place_name":"Mundic Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5341,
    "place_name":"Cooltong",
    "state_name":"South Australia"
  },
  {
    "postcode":5341,
    "place_name":"Renmark South",
    "state_name":"South Australia"
  },
  {
    "postcode":5341,
    "place_name":"Renmark West",
    "state_name":"South Australia"
  },
  {
    "postcode":5341,
    "place_name":"Renmark",
    "state_name":"South Australia"
  },
  {
    "postcode":5341,
    "place_name":"Crescent",
    "state_name":"South Australia"
  },
  {
    "postcode":5341,
    "place_name":"Chaffey",
    "state_name":"South Australia"
  },
  {
    "postcode":5341,
    "place_name":"Renmark North",
    "state_name":"South Australia"
  },
  {
    "postcode":5341,
    "place_name":"Old Calperum",
    "state_name":"South Australia"
  },
  {
    "postcode":5342,
    "place_name":"Monash",
    "state_name":"South Australia"
  },
  {
    "postcode":5343,
    "place_name":"Lyrup",
    "state_name":"South Australia"
  },
  {
    "postcode":5343,
    "place_name":"Winkie",
    "state_name":"South Australia"
  },
  {
    "postcode":5343,
    "place_name":"Berri",
    "state_name":"South Australia"
  },
  {
    "postcode":5343,
    "place_name":"Katarapko",
    "state_name":"South Australia"
  },
  {
    "postcode":5343,
    "place_name":"Gerard",
    "state_name":"South Australia"
  },
  {
    "postcode":5343,
    "place_name":"Gurra Gurra",
    "state_name":"South Australia"
  },
  {
    "postcode":5344,
    "place_name":"Glossop",
    "state_name":"South Australia"
  },
  {
    "postcode":5345,
    "place_name":"Spectacle Lake",
    "state_name":"South Australia"
  },
  {
    "postcode":5345,
    "place_name":"Barmera",
    "state_name":"South Australia"
  },
  {
    "postcode":5345,
    "place_name":"Loveday",
    "state_name":"South Australia"
  },
  {
    "postcode":5346,
    "place_name":"Cobdogla",
    "state_name":"South Australia"
  },
  {
    "postcode":5350,
    "place_name":"Sandy Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5350,
    "place_name":"Rosedale",
    "state_name":"South Australia"
  },
  {
    "postcode":5351,
    "place_name":"Cockatoo Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5351,
    "place_name":"Pewsey Vale",
    "state_name":"South Australia"
  },
  {
    "postcode":5351,
    "place_name":"Williamstown",
    "state_name":"South Australia"
  },
  {
    "postcode":5351,
    "place_name":"Lyndoch",
    "state_name":"South Australia"
  },
  {
    "postcode":5351,
    "place_name":"Altona",
    "state_name":"South Australia"
  },
  {
    "postcode":5351,
    "place_name":"Barossa Goldfields",
    "state_name":"South Australia"
  },
  {
    "postcode":5351,
    "place_name":"Mount Crawford",
    "state_name":"South Australia"
  },
  {
    "postcode":5352,
    "place_name":"Vine Vale",
    "state_name":"South Australia"
  },
  {
    "postcode":5352,
    "place_name":"Krondorf",
    "state_name":"South Australia"
  },
  {
    "postcode":5352,
    "place_name":"Rowland Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5352,
    "place_name":"Stone Well",
    "state_name":"South Australia"
  },
  {
    "postcode":5352,
    "place_name":"Tanunda",
    "state_name":"South Australia"
  },
  {
    "postcode":5352,
    "place_name":"Bethany",
    "state_name":"South Australia"
  },
  {
    "postcode":5352,
    "place_name":"Gomersal",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Angaston",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Langs Landing",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Kongolia",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Black Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Towitta",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Sunnydale",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Moculta",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Cambrai",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Keyneton",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Marks Landing",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Mount Mckenzie",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Sedan",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Punyelroo",
    "state_name":"South Australia"
  },
  {
    "postcode":5353,
    "place_name":"Penrice",
    "state_name":"South Australia"
  },
  {
    "postcode":5354,
    "place_name":"Bakara",
    "state_name":"South Australia"
  },
  {
    "postcode":5354,
    "place_name":"Swan Reach",
    "state_name":"South Australia"
  },
  {
    "postcode":5354,
    "place_name":"Naidia",
    "state_name":"South Australia"
  },
  {
    "postcode":5354,
    "place_name":"Fisher",
    "state_name":"South Australia"
  },
  {
    "postcode":5354,
    "place_name":"Bakara Well",
    "state_name":"South Australia"
  },
  {
    "postcode":5355,
    "place_name":"Light Pass",
    "state_name":"South Australia"
  },
  {
    "postcode":5355,
    "place_name":"Moppa",
    "state_name":"South Australia"
  },
  {
    "postcode":5355,
    "place_name":"Daveyston",
    "state_name":"South Australia"
  },
  {
    "postcode":5355,
    "place_name":"Ebenezer",
    "state_name":"South Australia"
  },
  {
    "postcode":5355,
    "place_name":"Marananga",
    "state_name":"South Australia"
  },
  {
    "postcode":5355,
    "place_name":"Nuriootpa",
    "state_name":"South Australia"
  },
  {
    "postcode":5355,
    "place_name":"Stockwell",
    "state_name":"South Australia"
  },
  {
    "postcode":5355,
    "place_name":"Seppeltsfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5356,
    "place_name":"Annadale",
    "state_name":"South Australia"
  },
  {
    "postcode":5356,
    "place_name":"Truro",
    "state_name":"South Australia"
  },
  {
    "postcode":5356,
    "place_name":"Dutton",
    "state_name":"South Australia"
  },
  {
    "postcode":5356,
    "place_name":"Dutton East",
    "state_name":"South Australia"
  },
  {
    "postcode":5356,
    "place_name":"Steinfeld",
    "state_name":"South Australia"
  },
  {
    "postcode":5356,
    "place_name":"St Kitts",
    "state_name":"South Australia"
  },
  {
    "postcode":5356,
    "place_name":"Stonefield",
    "state_name":"South Australia"
  },
  {
    "postcode":5356,
    "place_name":"Sandleton",
    "state_name":"South Australia"
  },
  {
    "postcode":5357,
    "place_name":"Notts Well",
    "state_name":"South Australia"
  },
  {
    "postcode":5357,
    "place_name":"Paisley",
    "state_name":"South Australia"
  },
  {
    "postcode":5357,
    "place_name":"Blanchetown",
    "state_name":"South Australia"
  },
  {
    "postcode":5357,
    "place_name":"Mcbean Pound",
    "state_name":"South Australia"
  },
  {
    "postcode":5357,
    "place_name":"New Well",
    "state_name":"South Australia"
  },
  {
    "postcode":5360,
    "place_name":"Greenock",
    "state_name":"South Australia"
  },
  {
    "postcode":5360,
    "place_name":"Nain",
    "state_name":"South Australia"
  },
  {
    "postcode":5371,
    "place_name":"Roseworthy",
    "state_name":"South Australia"
  },
  {
    "postcode":5371,
    "place_name":"Shea-Oak Log",
    "state_name":"South Australia"
  },
  {
    "postcode":5371,
    "place_name":"Morn Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5371,
    "place_name":"Templers",
    "state_name":"South Australia"
  },
  {
    "postcode":5372,
    "place_name":"Freeling",
    "state_name":"South Australia"
  },
  {
    "postcode":5373,
    "place_name":"Fords",
    "state_name":"South Australia"
  },
  {
    "postcode":5373,
    "place_name":"Bethel",
    "state_name":"South Australia"
  },
  {
    "postcode":5373,
    "place_name":"Hamilton",
    "state_name":"South Australia"
  },
  {
    "postcode":5373,
    "place_name":"Allendale North",
    "state_name":"South Australia"
  },
  {
    "postcode":5373,
    "place_name":"St Johns",
    "state_name":"South Australia"
  },
  {
    "postcode":5373,
    "place_name":"Koonunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5373,
    "place_name":"Kapunda",
    "state_name":"South Australia"
  },
  {
    "postcode":5373,
    "place_name":"Bagot Well",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Hampden",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Mount Mary",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Frankton",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Buchanan",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Julia",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Bower",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Brownlow",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Sutherlands",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Point Pass",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Eudunda",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Australia Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Neales Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Ngapala",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Peep Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5374,
    "place_name":"Hansborough",
    "state_name":"South Australia"
  },
  {
    "postcode":5381,
    "place_name":"Brady Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5381,
    "place_name":"Robertstown",
    "state_name":"South Australia"
  },
  {
    "postcode":5381,
    "place_name":"Rocky Plain",
    "state_name":"South Australia"
  },
  {
    "postcode":5381,
    "place_name":"Worlds End",
    "state_name":"South Australia"
  },
  {
    "postcode":5381,
    "place_name":"Hallelujah Hills",
    "state_name":"South Australia"
  },
  {
    "postcode":5381,
    "place_name":"Geranium Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5381,
    "place_name":"Emu Downs",
    "state_name":"South Australia"
  },
  {
    "postcode":5381,
    "place_name":"Bright",
    "state_name":"South Australia"
  },
  {
    "postcode":5400,
    "place_name":"Magdala",
    "state_name":"South Australia"
  },
  {
    "postcode":5400,
    "place_name":"Pinkerton Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5400,
    "place_name":"Woolsheds",
    "state_name":"South Australia"
  },
  {
    "postcode":5400,
    "place_name":"Wasleys",
    "state_name":"South Australia"
  },
  {
    "postcode":5401,
    "place_name":"Alma",
    "state_name":"South Australia"
  },
  {
    "postcode":5401,
    "place_name":"Hamley Bridge",
    "state_name":"South Australia"
  },
  {
    "postcode":5401,
    "place_name":"Salter Springs",
    "state_name":"South Australia"
  },
  {
    "postcode":5410,
    "place_name":"Linwood",
    "state_name":"South Australia"
  },
  {
    "postcode":5410,
    "place_name":"Stockport",
    "state_name":"South Australia"
  },
  {
    "postcode":5411,
    "place_name":"Tarlee",
    "state_name":"South Australia"
  },
  {
    "postcode":5411,
    "place_name":"Giles Corner",
    "state_name":"South Australia"
  },
  {
    "postcode":5412,
    "place_name":"Woolshed Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5412,
    "place_name":"Riverton",
    "state_name":"South Australia"
  },
  {
    "postcode":5412,
    "place_name":"Navan",
    "state_name":"South Australia"
  },
  {
    "postcode":5412,
    "place_name":"Rhynie",
    "state_name":"South Australia"
  },
  {
    "postcode":5413,
    "place_name":"Marrabel",
    "state_name":"South Australia"
  },
  {
    "postcode":5413,
    "place_name":"Waterloo",
    "state_name":"South Australia"
  },
  {
    "postcode":5413,
    "place_name":"Tothill Belt",
    "state_name":"South Australia"
  },
  {
    "postcode":5413,
    "place_name":"Apoinga",
    "state_name":"South Australia"
  },
  {
    "postcode":5413,
    "place_name":"Black Springs",
    "state_name":"South Australia"
  },
  {
    "postcode":5413,
    "place_name":"Tarnma",
    "state_name":"South Australia"
  },
  {
    "postcode":5413,
    "place_name":"Saddleworth",
    "state_name":"South Australia"
  },
  {
    "postcode":5413,
    "place_name":"Steelton",
    "state_name":"South Australia"
  },
  {
    "postcode":5413,
    "place_name":"Tothill Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5414,
    "place_name":"Manoora",
    "state_name":"South Australia"
  },
  {
    "postcode":5415,
    "place_name":"Stanley",
    "state_name":"South Australia"
  },
  {
    "postcode":5415,
    "place_name":"Mintaro",
    "state_name":"South Australia"
  },
  {
    "postcode":5416,
    "place_name":"Farrell Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5416,
    "place_name":"Porter Lagoon",
    "state_name":"South Australia"
  },
  {
    "postcode":5417,
    "place_name":"Mongolata",
    "state_name":"South Australia"
  },
  {
    "postcode":5417,
    "place_name":"Burra",
    "state_name":"South Australia"
  },
  {
    "postcode":5417,
    "place_name":"Leighton",
    "state_name":"South Australia"
  },
  {
    "postcode":5417,
    "place_name":"Koonoona",
    "state_name":"South Australia"
  },
  {
    "postcode":5417,
    "place_name":"Booborowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5417,
    "place_name":"Gum Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5417,
    "place_name":"Baldina",
    "state_name":"South Australia"
  },
  {
    "postcode":5417,
    "place_name":"Hanson",
    "state_name":"South Australia"
  },
  {
    "postcode":5417,
    "place_name":"North Booborowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5417,
    "place_name":"Burra Eastern Districts",
    "state_name":"South Australia"
  },
  {
    "postcode":5418,
    "place_name":"Mount Bryan",
    "state_name":"South Australia"
  },
  {
    "postcode":5418,
    "place_name":"Collinsville",
    "state_name":"South Australia"
  },
  {
    "postcode":5419,
    "place_name":"Hallett",
    "state_name":"South Australia"
  },
  {
    "postcode":5419,
    "place_name":"Canowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5419,
    "place_name":"Mount Bryan East",
    "state_name":"South Australia"
  },
  {
    "postcode":5419,
    "place_name":"Wonna",
    "state_name":"South Australia"
  },
  {
    "postcode":5419,
    "place_name":"Willalo",
    "state_name":"South Australia"
  },
  {
    "postcode":5419,
    "place_name":"Pine Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5419,
    "place_name":"Ulooloo",
    "state_name":"South Australia"
  },
  {
    "postcode":5420,
    "place_name":"Canowie Belt",
    "state_name":"South Australia"
  },
  {
    "postcode":5420,
    "place_name":"Whyte Yarcowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5421,
    "place_name":"Franklyn",
    "state_name":"South Australia"
  },
  {
    "postcode":5421,
    "place_name":"Terowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Ucolta",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Yatina",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Peterborough",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Erskine",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Mannanarie",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Hardy",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Paratoo",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Minvalara",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Parnaroo",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Oodla Wirra",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Dawson",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Cavenagh",
    "state_name":"South Australia"
  },
  {
    "postcode":5422,
    "place_name":"Sunnybrae",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Orroroo",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Black Rock",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Amyton",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Minburra",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Walloway",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Willowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Johnburgh",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Coomooroo",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Hammond",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Eurelia",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Pekina",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Yalpara",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Tarcowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5431,
    "place_name":"Morchard",
    "state_name":"South Australia"
  },
  {
    "postcode":5432,
    "place_name":"Yanyarrie",
    "state_name":"South Australia"
  },
  {
    "postcode":5432,
    "place_name":"Carrieton",
    "state_name":"South Australia"
  },
  {
    "postcode":5432,
    "place_name":"Belton",
    "state_name":"South Australia"
  },
  {
    "postcode":5432,
    "place_name":"Cradock",
    "state_name":"South Australia"
  },
  {
    "postcode":5432,
    "place_name":"Moockra",
    "state_name":"South Australia"
  },
  {
    "postcode":5433,
    "place_name":"Quorn",
    "state_name":"South Australia"
  },
  {
    "postcode":5433,
    "place_name":"Stephenston",
    "state_name":"South Australia"
  },
  {
    "postcode":5433,
    "place_name":"Willochra",
    "state_name":"South Australia"
  },
  {
    "postcode":5433,
    "place_name":"Yarrah",
    "state_name":"South Australia"
  },
  {
    "postcode":5433,
    "place_name":"Bruce",
    "state_name":"South Australia"
  },
  {
    "postcode":5433,
    "place_name":"Saltia",
    "state_name":"South Australia"
  },
  {
    "postcode":5434,
    "place_name":"Hawker",
    "state_name":"South Australia"
  },
  {
    "postcode":5434,
    "place_name":"Barndioota",
    "state_name":"South Australia"
  },
  {
    "postcode":5434,
    "place_name":"Kanyaka",
    "state_name":"South Australia"
  },
  {
    "postcode":5440,
    "place_name":"Waukaringa",
    "state_name":"South Australia"
  },
  {
    "postcode":5440,
    "place_name":"Yunta",
    "state_name":"South Australia"
  },
  {
    "postcode":5440,
    "place_name":"Nackara",
    "state_name":"South Australia"
  },
  {
    "postcode":5440,
    "place_name":"Mingary",
    "state_name":"South Australia"
  },
  {
    "postcode":5440,
    "place_name":"Olary",
    "state_name":"South Australia"
  },
  {
    "postcode":5440,
    "place_name":"Cockburn",
    "state_name":"South Australia"
  },
  {
    "postcode":5440,
    "place_name":"Manna Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5451,
    "place_name":"Auburn",
    "state_name":"South Australia"
  },
  {
    "postcode":5451,
    "place_name":"Undalya",
    "state_name":"South Australia"
  },
  {
    "postcode":5452,
    "place_name":"Watervale",
    "state_name":"South Australia"
  },
  {
    "postcode":5452,
    "place_name":"Leasingham",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Armagh",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Hill River",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Clare",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Spring Farm",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Hoyleton",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Stanley Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Barinia",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Sevenhill",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Boconnoc Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Kybunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Penwortham",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Emu Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Spring Gully",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Benbournie",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Gillentown",
    "state_name":"South Australia"
  },
  {
    "postcode":5453,
    "place_name":"Polish Hill River",
    "state_name":"South Australia"
  },
  {
    "postcode":5454,
    "place_name":"Spalding",
    "state_name":"South Australia"
  },
  {
    "postcode":5454,
    "place_name":"Mayfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5454,
    "place_name":"Andrews",
    "state_name":"South Australia"
  },
  {
    "postcode":5454,
    "place_name":"Hacklins Corner",
    "state_name":"South Australia"
  },
  {
    "postcode":5454,
    "place_name":"Washpool",
    "state_name":"South Australia"
  },
  {
    "postcode":5454,
    "place_name":"Euromina",
    "state_name":"South Australia"
  },
  {
    "postcode":5454,
    "place_name":"Broughton River Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5455,
    "place_name":"Hilltown",
    "state_name":"South Australia"
  },
  {
    "postcode":5460,
    "place_name":"Pinery",
    "state_name":"South Australia"
  },
  {
    "postcode":5460,
    "place_name":"Owen",
    "state_name":"South Australia"
  },
  {
    "postcode":5460,
    "place_name":"Barabba",
    "state_name":"South Australia"
  },
  {
    "postcode":5460,
    "place_name":"Stockyard Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Goyder",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Stow",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Whitwarta",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Saints",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Hoskin Corner",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Bowillia",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Halbury",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Erith",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Dalkey",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Mount Templeton",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Balaklava",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Watchman",
    "state_name":"South Australia"
  },
  {
    "postcode":5461,
    "place_name":"Everard Central",
    "state_name":"South Australia"
  },
  {
    "postcode":5462,
    "place_name":"Blyth",
    "state_name":"South Australia"
  },
  {
    "postcode":5464,
    "place_name":"Anama",
    "state_name":"South Australia"
  },
  {
    "postcode":5464,
    "place_name":"Condowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5464,
    "place_name":"Hart",
    "state_name":"South Australia"
  },
  {
    "postcode":5464,
    "place_name":"Rochester",
    "state_name":"South Australia"
  },
  {
    "postcode":5464,
    "place_name":"Koolunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5464,
    "place_name":"Bungaree",
    "state_name":"South Australia"
  },
  {
    "postcode":5464,
    "place_name":"Marola",
    "state_name":"South Australia"
  },
  {
    "postcode":5464,
    "place_name":"Brinkworth",
    "state_name":"South Australia"
  },
  {
    "postcode":5470,
    "place_name":"Yacka",
    "state_name":"South Australia"
  },
  {
    "postcode":5471,
    "place_name":"Gulnare",
    "state_name":"South Australia"
  },
  {
    "postcode":5472,
    "place_name":"Georgetown",
    "state_name":"South Australia"
  },
  {
    "postcode":5473,
    "place_name":"Gladstone",
    "state_name":"South Australia"
  },
  {
    "postcode":5480,
    "place_name":"Stone Hut",
    "state_name":"South Australia"
  },
  {
    "postcode":5480,
    "place_name":"Appila",
    "state_name":"South Australia"
  },
  {
    "postcode":5480,
    "place_name":"Laura",
    "state_name":"South Australia"
  },
  {
    "postcode":5481,
    "place_name":"Wirrabara",
    "state_name":"South Australia"
  },
  {
    "postcode":5481,
    "place_name":"Wongyarra",
    "state_name":"South Australia"
  },
  {
    "postcode":5481,
    "place_name":"Murray Town",
    "state_name":"South Australia"
  },
  {
    "postcode":5481,
    "place_name":"Bangor",
    "state_name":"South Australia"
  },
  {
    "postcode":5482,
    "place_name":"Wepowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5482,
    "place_name":"Booleroo Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5483,
    "place_name":"Melrose",
    "state_name":"South Australia"
  },
  {
    "postcode":5485,
    "place_name":"Wilmington",
    "state_name":"South Australia"
  },
  {
    "postcode":5490,
    "place_name":"Caltowie North",
    "state_name":"South Australia"
  },
  {
    "postcode":5490,
    "place_name":"Caltowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5490,
    "place_name":"Caltowie West",
    "state_name":"South Australia"
  },
  {
    "postcode":5491,
    "place_name":"Hornsdale",
    "state_name":"South Australia"
  },
  {
    "postcode":5491,
    "place_name":"Bundaleer North",
    "state_name":"South Australia"
  },
  {
    "postcode":5491,
    "place_name":"Jamestown",
    "state_name":"South Australia"
  },
  {
    "postcode":5491,
    "place_name":"Bundaleer Gardens",
    "state_name":"South Australia"
  },
  {
    "postcode":5491,
    "place_name":"Belalie North",
    "state_name":"South Australia"
  },
  {
    "postcode":5491,
    "place_name":"West Bundaleer",
    "state_name":"South Australia"
  },
  {
    "postcode":5491,
    "place_name":"Belalie East",
    "state_name":"South Australia"
  },
  {
    "postcode":5493,
    "place_name":"Yongala",
    "state_name":"South Australia"
  },
  {
    "postcode":5495,
    "place_name":"Baroota",
    "state_name":"South Australia"
  },
  {
    "postcode":5495,
    "place_name":"Port Germein",
    "state_name":"South Australia"
  },
  {
    "postcode":5495,
    "place_name":"Mambray Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5495,
    "place_name":"Nectar Brook",
    "state_name":"South Australia"
  },
  {
    "postcode":5495,
    "place_name":"Port Flinders",
    "state_name":"South Australia"
  },
  {
    "postcode":5495,
    "place_name":"Germein Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Parham",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Webb Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Dublin",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Calomba",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Wild Horse Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Port Gawler",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Lower Light",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Middle Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Lewiston",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Thompson Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Long Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Windsor",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Avon",
    "state_name":"South Australia"
  },
  {
    "postcode":5501,
    "place_name":"Two Wells",
    "state_name":"South Australia"
  },
  {
    "postcode":5502,
    "place_name":"Mallala",
    "state_name":"South Australia"
  },
  {
    "postcode":5502,
    "place_name":"Korunye",
    "state_name":"South Australia"
  },
  {
    "postcode":5502,
    "place_name":"Grace Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5502,
    "place_name":"Reeves Plains",
    "state_name":"South Australia"
  },
  {
    "postcode":5502,
    "place_name":"Redbanks",
    "state_name":"South Australia"
  },
  {
    "postcode":5502,
    "place_name":"Fischer",
    "state_name":"South Australia"
  },
  {
    "postcode":5510,
    "place_name":"Lochiel",
    "state_name":"South Australia"
  },
  {
    "postcode":5520,
    "place_name":"Bumbunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5520,
    "place_name":"Burnsfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5520,
    "place_name":"Wokurna",
    "state_name":"South Australia"
  },
  {
    "postcode":5520,
    "place_name":"Barunga Gap",
    "state_name":"South Australia"
  },
  {
    "postcode":5520,
    "place_name":"Snowtown",
    "state_name":"South Australia"
  },
  {
    "postcode":5521,
    "place_name":"Redhill",
    "state_name":"South Australia"
  },
  {
    "postcode":5522,
    "place_name":"Fisherman Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5522,
    "place_name":"Ward Hill",
    "state_name":"South Australia"
  },
  {
    "postcode":5522,
    "place_name":"Port Broughton",
    "state_name":"South Australia"
  },
  {
    "postcode":5523,
    "place_name":"Wandearah West",
    "state_name":"South Australia"
  },
  {
    "postcode":5523,
    "place_name":"Merriton",
    "state_name":"South Australia"
  },
  {
    "postcode":5523,
    "place_name":"Crystal Brook",
    "state_name":"South Australia"
  },
  {
    "postcode":5523,
    "place_name":"Clements Gap",
    "state_name":"South Australia"
  },
  {
    "postcode":5523,
    "place_name":"Beetaloo",
    "state_name":"South Australia"
  },
  {
    "postcode":5523,
    "place_name":"Narridy",
    "state_name":"South Australia"
  },
  {
    "postcode":5523,
    "place_name":"Huddleston",
    "state_name":"South Australia"
  },
  {
    "postcode":5523,
    "place_name":"Wandearah East",
    "state_name":"South Australia"
  },
  {
    "postcode":5523,
    "place_name":"Nurom",
    "state_name":"South Australia"
  },
  {
    "postcode":5523,
    "place_name":"Wandearah",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Bungama",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Pirie East",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Risdon Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Port Davis",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Port Pirie South",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Coonamia",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Nelshaby",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Port Pirie West",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Port Pirie",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Risdon Park South",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Solomontown",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Warnertown",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Telowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Lower Broughton",
    "state_name":"South Australia"
  },
  {
    "postcode":5540,
    "place_name":"Napperby",
    "state_name":"South Australia"
  },
  {
    "postcode":5550,
    "place_name":"Inkerman",
    "state_name":"South Australia"
  },
  {
    "postcode":5550,
    "place_name":"Beaufort",
    "state_name":"South Australia"
  },
  {
    "postcode":5550,
    "place_name":"Bowmans",
    "state_name":"South Australia"
  },
  {
    "postcode":5550,
    "place_name":"Nantawarra",
    "state_name":"South Australia"
  },
  {
    "postcode":5550,
    "place_name":"Port Wakefield",
    "state_name":"South Australia"
  },
  {
    "postcode":5550,
    "place_name":"Kallora",
    "state_name":"South Australia"
  },
  {
    "postcode":5550,
    "place_name":"Proof Range",
    "state_name":"South Australia"
  },
  {
    "postcode":5550,
    "place_name":"South Hummocks",
    "state_name":"South Australia"
  },
  {
    "postcode":5552,
    "place_name":"Paskeville",
    "state_name":"South Australia"
  },
  {
    "postcode":5552,
    "place_name":"Melton",
    "state_name":"South Australia"
  },
  {
    "postcode":5552,
    "place_name":"Thrington",
    "state_name":"South Australia"
  },
  {
    "postcode":5552,
    "place_name":"Sunnyvale",
    "state_name":"South Australia"
  },
  {
    "postcode":5552,
    "place_name":"Kainton",
    "state_name":"South Australia"
  },
  {
    "postcode":5552,
    "place_name":"Port Arthur",
    "state_name":"South Australia"
  },
  {
    "postcode":5552,
    "place_name":"Kulpara",
    "state_name":"South Australia"
  },
  {
    "postcode":5554,
    "place_name":"Matta Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5554,
    "place_name":"Wallaroo Mines",
    "state_name":"South Australia"
  },
  {
    "postcode":5554,
    "place_name":"Jerusalem",
    "state_name":"South Australia"
  },
  {
    "postcode":5554,
    "place_name":"Kadina",
    "state_name":"South Australia"
  },
  {
    "postcode":5554,
    "place_name":"Willamulka",
    "state_name":"South Australia"
  },
  {
    "postcode":5554,
    "place_name":"Thomas Plain",
    "state_name":"South Australia"
  },
  {
    "postcode":5554,
    "place_name":"Boors Plain",
    "state_name":"South Australia"
  },
  {
    "postcode":5554,
    "place_name":"Cunliffe",
    "state_name":"South Australia"
  },
  {
    "postcode":5554,
    "place_name":"New Town",
    "state_name":"South Australia"
  },
  {
    "postcode":5554,
    "place_name":"Jericho",
    "state_name":"South Australia"
  },
  {
    "postcode":5555,
    "place_name":"Tickera",
    "state_name":"South Australia"
  },
  {
    "postcode":5555,
    "place_name":"Mundoora",
    "state_name":"South Australia"
  },
  {
    "postcode":5555,
    "place_name":"Alford",
    "state_name":"South Australia"
  },
  {
    "postcode":5555,
    "place_name":"Collinsfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5555,
    "place_name":"Lake View",
    "state_name":"South Australia"
  },
  {
    "postcode":5555,
    "place_name":"Hope Gap",
    "state_name":"South Australia"
  },
  {
    "postcode":5556,
    "place_name":"North Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5556,
    "place_name":"Warburto",
    "state_name":"South Australia"
  },
  {
    "postcode":5556,
    "place_name":"Wallaroo Plain",
    "state_name":"South Australia"
  },
  {
    "postcode":5556,
    "place_name":"Wallaroo",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"Moonta Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"Moonta Mines",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"Moonta",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"Hamley",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"Paramatta",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"East Moonta",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"Agery",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"Kooroona",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"Port Hughes",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"Nalyappa",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"North Yelta",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"North Moonta",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"Yelta",
    "state_name":"South Australia"
  },
  {
    "postcode":5558,
    "place_name":"Cross Roads",
    "state_name":"South Australia"
  },
  {
    "postcode":5560,
    "place_name":"Bute",
    "state_name":"South Australia"
  },
  {
    "postcode":5560,
    "place_name":"Ninnes",
    "state_name":"South Australia"
  },
  {
    "postcode":5570,
    "place_name":"Winulta",
    "state_name":"South Australia"
  },
  {
    "postcode":5570,
    "place_name":"Port Clinton",
    "state_name":"South Australia"
  },
  {
    "postcode":5570,
    "place_name":"Price",
    "state_name":"South Australia"
  },
  {
    "postcode":5570,
    "place_name":"Clinton",
    "state_name":"South Australia"
  },
  {
    "postcode":5570,
    "place_name":"Clinton Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5571,
    "place_name":"Ardrossan",
    "state_name":"South Australia"
  },
  {
    "postcode":5571,
    "place_name":"Pine Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5571,
    "place_name":"Tiddy Widdy Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5571,
    "place_name":"Black Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5571,
    "place_name":"Sandilands",
    "state_name":"South Australia"
  },
  {
    "postcode":5571,
    "place_name":"Petersville",
    "state_name":"South Australia"
  },
  {
    "postcode":5571,
    "place_name":"Dowlingville",
    "state_name":"South Australia"
  },
  {
    "postcode":5571,
    "place_name":"Rogues Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5571,
    "place_name":"Cunningham",
    "state_name":"South Australia"
  },
  {
    "postcode":5571,
    "place_name":"James Well",
    "state_name":"South Australia"
  },
  {
    "postcode":5572,
    "place_name":"Arthurton",
    "state_name":"South Australia"
  },
  {
    "postcode":5573,
    "place_name":"Yorke Valley",
    "state_name":"South Australia"
  },
  {
    "postcode":5573,
    "place_name":"Point Pearce",
    "state_name":"South Australia"
  },
  {
    "postcode":5573,
    "place_name":"South Kilkerran",
    "state_name":"South Australia"
  },
  {
    "postcode":5573,
    "place_name":"Chinaman Wells",
    "state_name":"South Australia"
  },
  {
    "postcode":5573,
    "place_name":"Weetulta",
    "state_name":"South Australia"
  },
  {
    "postcode":5573,
    "place_name":"Balgowan",
    "state_name":"South Australia"
  },
  {
    "postcode":5573,
    "place_name":"Port Victoria",
    "state_name":"South Australia"
  },
  {
    "postcode":5573,
    "place_name":"Maitland",
    "state_name":"South Australia"
  },
  {
    "postcode":5573,
    "place_name":"Urania",
    "state_name":"South Australia"
  },
  {
    "postcode":5573,
    "place_name":"Wauraltee",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Hardwicke Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Bluff Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Point Turton",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Stenhouse Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Port Rickaby",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Wool Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Brentwood",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"White Hut",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Koolywurtie",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Minlaton",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Corny Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Ramsay",
    "state_name":"South Australia"
  },
  {
    "postcode":5575,
    "place_name":"Marion Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5576,
    "place_name":"Honiton",
    "state_name":"South Australia"
  },
  {
    "postcode":5576,
    "place_name":"Port Moorowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5576,
    "place_name":"Yorketown",
    "state_name":"South Australia"
  },
  {
    "postcode":5577,
    "place_name":"Inneston",
    "state_name":"South Australia"
  },
  {
    "postcode":5577,
    "place_name":"Couch Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5577,
    "place_name":"The Pines",
    "state_name":"South Australia"
  },
  {
    "postcode":5577,
    "place_name":"Point Souttar",
    "state_name":"South Australia"
  },
  {
    "postcode":5577,
    "place_name":"Warooka",
    "state_name":"South Australia"
  },
  {
    "postcode":5577,
    "place_name":"Foul Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5580,
    "place_name":"Port Julia",
    "state_name":"South Australia"
  },
  {
    "postcode":5580,
    "place_name":"Curramulka",
    "state_name":"South Australia"
  },
  {
    "postcode":5581,
    "place_name":"Sheaoak Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5581,
    "place_name":"Port Vincent",
    "state_name":"South Australia"
  },
  {
    "postcode":5582,
    "place_name":"Stansbury",
    "state_name":"South Australia"
  },
  {
    "postcode":5582,
    "place_name":"Port Giles",
    "state_name":"South Australia"
  },
  {
    "postcode":5583,
    "place_name":"Coobowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5583,
    "place_name":"Sultana Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5583,
    "place_name":"Edithburgh",
    "state_name":"South Australia"
  },
  {
    "postcode":5600,
    "place_name":"Whyalla",
    "state_name":"South Australia"
  },
  {
    "postcode":5600,
    "place_name":"Whyalla Playford",
    "state_name":"South Australia"
  },
  {
    "postcode":5600,
    "place_name":"Whyalla DC",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Iron Baron",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Point Lowly North",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Backy Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Murninnie Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Port Bonython",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Iron Knob",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Point Lowly",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Douglas Point South",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Whyalla Barson",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Cultana",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Cowleds Landing",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Douglas Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Mullaquana",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"False Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5601,
    "place_name":"Fitzgerald Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5602,
    "place_name":"Miltalie",
    "state_name":"South Australia"
  },
  {
    "postcode":5602,
    "place_name":"Lucky Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5602,
    "place_name":"Cowell",
    "state_name":"South Australia"
  },
  {
    "postcode":5602,
    "place_name":"Port Gibbon",
    "state_name":"South Australia"
  },
  {
    "postcode":5602,
    "place_name":"Minbrie",
    "state_name":"South Australia"
  },
  {
    "postcode":5602,
    "place_name":"Midgee",
    "state_name":"South Australia"
  },
  {
    "postcode":5602,
    "place_name":"Mitchellville",
    "state_name":"South Australia"
  },
  {
    "postcode":5602,
    "place_name":"Mangalo",
    "state_name":"South Australia"
  },
  {
    "postcode":5603,
    "place_name":"Verran",
    "state_name":"South Australia"
  },
  {
    "postcode":5603,
    "place_name":"Arno Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5603,
    "place_name":"Wharminda",
    "state_name":"South Australia"
  },
  {
    "postcode":5603,
    "place_name":"Hincks",
    "state_name":"South Australia"
  },
  {
    "postcode":5604,
    "place_name":"Port Neill",
    "state_name":"South Australia"
  },
  {
    "postcode":5605,
    "place_name":"Butler",
    "state_name":"South Australia"
  },
  {
    "postcode":5605,
    "place_name":"Tumby Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5606,
    "place_name":"Port Lincoln",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Koppio",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Little Douglas",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Fountain",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Coomunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Louth Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Point Boston",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Boston",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Wanilla",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Poonindie",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Green Patch",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Yallunda Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Coulta",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Wangary",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Whites River",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Mount Hope",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Ungarra",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Sleaford",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Duck Ponds",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Murdinga",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Port Lincoln",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Mount Drummond",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Tootenilla",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Charlton Gully",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Warrachie",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Pearlah",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Lincoln National Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Lipson",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Venus Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Coffin Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Hawson",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Tiatukia",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Kiana",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Sheringa",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Uley",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Brooker",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"North Shields",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Tulka",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Kellidie Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Tooligie",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Moody",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Warrow",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Whites Flat",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Farm Beach",
    "state_name":"South Australia"
  },
  {
    "postcode":5607,
    "place_name":"Mount Dutton Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5608,
    "place_name":"Whyalla Norrie",
    "state_name":"South Australia"
  },
  {
    "postcode":5608,
    "place_name":"Whyalla Norrie East",
    "state_name":"South Australia"
  },
  {
    "postcode":5608,
    "place_name":"Whyalla Stuart",
    "state_name":"South Australia"
  },
  {
    "postcode":5608,
    "place_name":"Whyalla Norrie North",
    "state_name":"South Australia"
  },
  {
    "postcode":5609,
    "place_name":"Whyalla Jenkins",
    "state_name":"South Australia"
  },
  {
    "postcode":5630,
    "place_name":"Edillilie",
    "state_name":"South Australia"
  },
  {
    "postcode":5631,
    "place_name":"Cockaleechie",
    "state_name":"South Australia"
  },
  {
    "postcode":5631,
    "place_name":"Cummins",
    "state_name":"South Australia"
  },
  {
    "postcode":5632,
    "place_name":"Karkoo",
    "state_name":"South Australia"
  },
  {
    "postcode":5632,
    "place_name":"Mitchell",
    "state_name":"South Australia"
  },
  {
    "postcode":5632,
    "place_name":"Yeelanna",
    "state_name":"South Australia"
  },
  {
    "postcode":5632,
    "place_name":"Kapinnie",
    "state_name":"South Australia"
  },
  {
    "postcode":5633,
    "place_name":"Boonerdo",
    "state_name":"South Australia"
  },
  {
    "postcode":5633,
    "place_name":"Lock",
    "state_name":"South Australia"
  },
  {
    "postcode":5640,
    "place_name":"Waddikee",
    "state_name":"South Australia"
  },
  {
    "postcode":5640,
    "place_name":"Jamieson",
    "state_name":"South Australia"
  },
  {
    "postcode":5640,
    "place_name":"Cleve",
    "state_name":"South Australia"
  },
  {
    "postcode":5640,
    "place_name":"Campoona",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Moseley",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Pinkawillinie",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Buckleboo",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Wilcherry",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Cortlinye",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Yalanda",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Caralue",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Panitya",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Kimba",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Kelly",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Cunyarie",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Solomon",
    "state_name":"South Australia"
  },
  {
    "postcode":5641,
    "place_name":"Barna",
    "state_name":"South Australia"
  },
  {
    "postcode":5642,
    "place_name":"Rudall",
    "state_name":"South Australia"
  },
  {
    "postcode":5642,
    "place_name":"Darke Peak",
    "state_name":"South Australia"
  },
  {
    "postcode":5642,
    "place_name":"Murlong",
    "state_name":"South Australia"
  },
  {
    "postcode":5642,
    "place_name":"Kielpa",
    "state_name":"South Australia"
  },
  {
    "postcode":5642,
    "place_name":"Hambidge",
    "state_name":"South Australia"
  },
  {
    "postcode":5650,
    "place_name":"Koongawa",
    "state_name":"South Australia"
  },
  {
    "postcode":5650,
    "place_name":"Warramboo",
    "state_name":"South Australia"
  },
  {
    "postcode":5650,
    "place_name":"Cootra",
    "state_name":"South Australia"
  },
  {
    "postcode":5651,
    "place_name":"Kyancutta",
    "state_name":"South Australia"
  },
  {
    "postcode":5652,
    "place_name":"Paney",
    "state_name":"South Australia"
  },
  {
    "postcode":5652,
    "place_name":"Pygery",
    "state_name":"South Australia"
  },
  {
    "postcode":5652,
    "place_name":"Wudinna",
    "state_name":"South Australia"
  },
  {
    "postcode":5653,
    "place_name":"Yaninee",
    "state_name":"South Australia"
  },
  {
    "postcode":5654,
    "place_name":"Mount Damper",
    "state_name":"South Australia"
  },
  {
    "postcode":5654,
    "place_name":"Karcultaby",
    "state_name":"South Australia"
  },
  {
    "postcode":5654,
    "place_name":"Minnipa",
    "state_name":"South Australia"
  },
  {
    "postcode":5654,
    "place_name":"Cocata",
    "state_name":"South Australia"
  },
  {
    "postcode":5655,
    "place_name":"Poochera",
    "state_name":"South Australia"
  },
  {
    "postcode":5655,
    "place_name":"Kaldoonera",
    "state_name":"South Australia"
  },
  {
    "postcode":5655,
    "place_name":"Bockelberg",
    "state_name":"South Australia"
  },
  {
    "postcode":5660,
    "place_name":"Cungena",
    "state_name":"South Australia"
  },
  {
    "postcode":5660,
    "place_name":"Chilpenunda",
    "state_name":"South Australia"
  },
  {
    "postcode":5661,
    "place_name":"Wirrulla",
    "state_name":"South Australia"
  },
  {
    "postcode":5661,
    "place_name":"Koolgera",
    "state_name":"South Australia"
  },
  {
    "postcode":5661,
    "place_name":"Yantanabie",
    "state_name":"South Australia"
  },
  {
    "postcode":5661,
    "place_name":"Wallala",
    "state_name":"South Australia"
  },
  {
    "postcode":5661,
    "place_name":"Pimbaacla",
    "state_name":"South Australia"
  },
  {
    "postcode":5670,
    "place_name":"Kappawanta",
    "state_name":"South Australia"
  },
  {
    "postcode":5670,
    "place_name":"Colton",
    "state_name":"South Australia"
  },
  {
    "postcode":5670,
    "place_name":"Ulyerra",
    "state_name":"South Australia"
  },
  {
    "postcode":5670,
    "place_name":"Bramfield",
    "state_name":"South Australia"
  },
  {
    "postcode":5670,
    "place_name":"Coolillie",
    "state_name":"South Australia"
  },
  {
    "postcode":5670,
    "place_name":"Mount Wedge",
    "state_name":"South Australia"
  },
  {
    "postcode":5670,
    "place_name":"Elliston",
    "state_name":"South Australia"
  },
  {
    "postcode":5670,
    "place_name":"Palkagee",
    "state_name":"South Australia"
  },
  {
    "postcode":5670,
    "place_name":"Talia",
    "state_name":"South Australia"
  },
  {
    "postcode":5670,
    "place_name":"Mount Joy",
    "state_name":"South Australia"
  },
  {
    "postcode":5670,
    "place_name":"Polda",
    "state_name":"South Australia"
  },
  {
    "postcode":5671,
    "place_name":"Mortana",
    "state_name":"South Australia"
  },
  {
    "postcode":5671,
    "place_name":"Port Kenny",
    "state_name":"South Australia"
  },
  {
    "postcode":5671,
    "place_name":"Calca",
    "state_name":"South Australia"
  },
  {
    "postcode":5671,
    "place_name":"Tyringa",
    "state_name":"South Australia"
  },
  {
    "postcode":5671,
    "place_name":"Baird Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5671,
    "place_name":"Mount Cooper",
    "state_name":"South Australia"
  },
  {
    "postcode":5671,
    "place_name":"Witera",
    "state_name":"South Australia"
  },
  {
    "postcode":5671,
    "place_name":"Colley",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Chinbingina",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Sceale Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Streaky Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Piednippie",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Petina",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Perlubie",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Nunjikompita",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Westall",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Haslam",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Pureba",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Carawa",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Maryvale",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Chandada",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Yanerbie",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Puntabie",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Laura Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Mudamuckla",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Eba Anchorage",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Smoky Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5680,
    "place_name":"Inkster",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Nadia",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Denial Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Ceduna",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Koonibba",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Thevenard",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Charra",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Kalanbi",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Wandana",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Bookabie",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Maltee",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Uworra",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Coorabie",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Penong",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Merghiny",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Watraba",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"White Well Corner",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Fowlers Bay",
    "state_name":"South Australia"
  },
  {
    "postcode":5690,
    "place_name":"Yalata",
    "state_name":"South Australia"
  },
  {
    "postcode":5700,
    "place_name":"Winninowie",
    "state_name":"South Australia"
  },
  {
    "postcode":5700,
    "place_name":"Port Augusta North",
    "state_name":"South Australia"
  },
  {
    "postcode":5700,
    "place_name":"Port Paterson",
    "state_name":"South Australia"
  },
  {
    "postcode":5700,
    "place_name":"Port Augusta",
    "state_name":"South Australia"
  },
  {
    "postcode":5700,
    "place_name":"Commissariat Point",
    "state_name":"South Australia"
  },
  {
    "postcode":5700,
    "place_name":"Miranda",
    "state_name":"South Australia"
  },
  {
    "postcode":5700,
    "place_name":"Blanche Harbor",
    "state_name":"South Australia"
  },
  {
    "postcode":5700,
    "place_name":"Port Augusta West",
    "state_name":"South Australia"
  },
  {
    "postcode":5700,
    "place_name":"Wami Kata",
    "state_name":"South Australia"
  },
  {
    "postcode":5700,
    "place_name":"Mundallio",
    "state_name":"South Australia"
  },
  {
    "postcode":5701,
    "place_name":"Tarcoola",
    "state_name":"South Australia"
  },
  {
    "postcode":5701,
    "place_name":"Arkaroola Village",
    "state_name":"South Australia"
  },
  {
    "postcode":5701,
    "place_name":"Glendambo",
    "state_name":"South Australia"
  },
  {
    "postcode":5701,
    "place_name":"Woolundunga",
    "state_name":"South Australia"
  },
  {
    "postcode":5701,
    "place_name":"Cook",
    "state_name":"South Australia"
  },
  {
    "postcode":5701,
    "place_name":"Kingoonya",
    "state_name":"South Australia"
  },
  {
    "postcode":5701,
    "place_name":"Port Augusta",
    "state_name":"South Australia"
  },
  {
    "postcode":5710,
    "place_name":"Kingoonya",
    "state_name":"South Australia"
  },
  {
    "postcode":5710,
    "place_name":"Cook",
    "state_name":"South Australia"
  },
  {
    "postcode":5710,
    "place_name":"Nonning",
    "state_name":"South Australia"
  },
  {
    "postcode":5710,
    "place_name":"Stirling North",
    "state_name":"South Australia"
  },
  {
    "postcode":5710,
    "place_name":"Tarcoola",
    "state_name":"South Australia"
  },
  {
    "postcode":5710,
    "place_name":"Port Augusta",
    "state_name":"South Australia"
  },
  {
    "postcode":5720,
    "place_name":"Pimba",
    "state_name":"South Australia"
  },
  {
    "postcode":5720,
    "place_name":"Woomera",
    "state_name":"South Australia"
  },
  {
    "postcode":5722,
    "place_name":"Andamooka",
    "state_name":"South Australia"
  },
  {
    "postcode":5723,
    "place_name":"Coober Pedy",
    "state_name":"South Australia"
  },
  {
    "postcode":5724,
    "place_name":"Mintabie",
    "state_name":"South Australia"
  },
  {
    "postcode":5724,
    "place_name":"Marla",
    "state_name":"South Australia"
  },
  {
    "postcode":5725,
    "place_name":"Olympic Dam",
    "state_name":"South Australia"
  },
  {
    "postcode":5725,
    "place_name":"Roxby Downs",
    "state_name":"South Australia"
  },
  {
    "postcode":5730,
    "place_name":"Blinman",
    "state_name":"South Australia"
  },
  {
    "postcode":5730,
    "place_name":"Beltana",
    "state_name":"South Australia"
  },
  {
    "postcode":5730,
    "place_name":"Parachilna",
    "state_name":"South Australia"
  },
  {
    "postcode":5731,
    "place_name":"Leigh Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5731,
    "place_name":"Innamincka",
    "state_name":"South Australia"
  },
  {
    "postcode":5731,
    "place_name":"Lyndhurst",
    "state_name":"South Australia"
  },
  {
    "postcode":5731,
    "place_name":"Cordillo Downs",
    "state_name":"South Australia"
  },
  {
    "postcode":5731,
    "place_name":"Coopers Creek",
    "state_name":"South Australia"
  },
  {
    "postcode":5732,
    "place_name":"Copley",
    "state_name":"South Australia"
  },
  {
    "postcode":5732,
    "place_name":"Nepabunna",
    "state_name":"South Australia"
  },
  {
    "postcode":5733,
    "place_name":"Farina",
    "state_name":"South Australia"
  },
  {
    "postcode":5733,
    "place_name":"Marree",
    "state_name":"South Australia"
  },
  {
    "postcode":5734,
    "place_name":"Oodnadatta",
    "state_name":"South Australia"
  },
  {
    "postcode":5800,
    "place_name":"Adelaide",
    "state_name":"South Australia"
  },
  {
    "postcode":5810,
    "place_name":"Adelaide",
    "state_name":"South Australia"
  },
  {
    "postcode":5839,
    "place_name":"Adelaide",
    "state_name":"South Australia"
  },
  {
    "postcode":5860,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5861,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5862,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5863,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5864,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5865,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5866,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5867,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5868,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5869,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5870,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5871,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5872,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5873,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5874,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5875,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5876,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5877,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5878,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5879,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5880,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5881,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5882,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5883,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5884,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5885,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5886,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5887,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5888,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5889,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5890,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5891,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5892,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5893,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5894,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5895,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5896,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5897,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5898,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5899,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5900,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5901,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5902,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5903,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5904,
    "place_name":"Adelaide Mail Centre",
    "state_name":"South Australia"
  },
  {
    "postcode":5920,
    "place_name":"Adelaide",
    "state_name":"South Australia"
  },
  {
    "postcode":5942,
    "place_name":"Regency Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5950,
    "place_name":"Export Park",
    "state_name":"South Australia"
  },
  {
    "postcode":5950,
    "place_name":"Adelaide Airport",
    "state_name":"South Australia"
  },
  {
    "postcode":5960,
    "place_name":"Torrens Island",
    "state_name":"South Australia"
  },
  {
    "postcode":5960,
    "place_name":"Garden Island",
    "state_name":"South Australia"
  },
  {
    "postcode":7000,
    "place_name":"Mount Stuart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7000,
    "place_name":"North Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7000,
    "place_name":"Queens Domain",
    "state_name":"Tasmania"
  },
  {
    "postcode":7000,
    "place_name":"West Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7000,
    "place_name":"Glebe",
    "state_name":"Tasmania"
  },
  {
    "postcode":7000,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7001,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7002,
    "place_name":"North Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7004,
    "place_name":"South Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7004,
    "place_name":"Battery Point",
    "state_name":"Tasmania"
  },
  {
    "postcode":7005,
    "place_name":"Sandy Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7005,
    "place_name":"Dynnyrne",
    "state_name":"Tasmania"
  },
  {
    "postcode":7005,
    "place_name":"Lower Sandy Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7005,
    "place_name":"University Of Tasmania",
    "state_name":"Tasmania"
  },
  {
    "postcode":7006,
    "place_name":"Sandy Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7007,
    "place_name":"Tolmans Hill",
    "state_name":"Tasmania"
  },
  {
    "postcode":7007,
    "place_name":"Mount Nelson",
    "state_name":"Tasmania"
  },
  {
    "postcode":7008,
    "place_name":"New Town",
    "state_name":"Tasmania"
  },
  {
    "postcode":7008,
    "place_name":"Lenah Valley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7009,
    "place_name":"West Moonah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7009,
    "place_name":"Moonah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7009,
    "place_name":"Derwent Park",
    "state_name":"Tasmania"
  },
  {
    "postcode":7009,
    "place_name":"Lutana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7010,
    "place_name":"Rosetta",
    "state_name":"Tasmania"
  },
  {
    "postcode":7010,
    "place_name":"Montrose",
    "state_name":"Tasmania"
  },
  {
    "postcode":7010,
    "place_name":"Dowsing Point",
    "state_name":"Tasmania"
  },
  {
    "postcode":7010,
    "place_name":"Goodwood",
    "state_name":"Tasmania"
  },
  {
    "postcode":7010,
    "place_name":"Elwick",
    "state_name":"Tasmania"
  },
  {
    "postcode":7010,
    "place_name":"Glenorchy",
    "state_name":"Tasmania"
  },
  {
    "postcode":7011,
    "place_name":"Berriedale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7011,
    "place_name":"Chigwell",
    "state_name":"Tasmania"
  },
  {
    "postcode":7011,
    "place_name":"Claremont",
    "state_name":"Tasmania"
  },
  {
    "postcode":7011,
    "place_name":"Austins Ferry",
    "state_name":"Tasmania"
  },
  {
    "postcode":7012,
    "place_name":"Collinsvale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7012,
    "place_name":"Glenlusk",
    "state_name":"Tasmania"
  },
  {
    "postcode":7015,
    "place_name":"Geilston Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7015,
    "place_name":"Lindisfarne",
    "state_name":"Tasmania"
  },
  {
    "postcode":7015,
    "place_name":"Rose Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7016,
    "place_name":"Risdon Vale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7017,
    "place_name":"Honeywood",
    "state_name":"Tasmania"
  },
  {
    "postcode":7017,
    "place_name":"Grasstree Hill",
    "state_name":"Tasmania"
  },
  {
    "postcode":7017,
    "place_name":"Risdon",
    "state_name":"Tasmania"
  },
  {
    "postcode":7017,
    "place_name":"Old Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7017,
    "place_name":"Otago",
    "state_name":"Tasmania"
  },
  {
    "postcode":7017,
    "place_name":"Tea Tree",
    "state_name":"Tasmania"
  },
  {
    "postcode":7018,
    "place_name":"Rosny",
    "state_name":"Tasmania"
  },
  {
    "postcode":7018,
    "place_name":"Bellerive",
    "state_name":"Tasmania"
  },
  {
    "postcode":7018,
    "place_name":"Montagu Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7018,
    "place_name":"Rosny Park",
    "state_name":"Tasmania"
  },
  {
    "postcode":7018,
    "place_name":"Tranmere",
    "state_name":"Tasmania"
  },
  {
    "postcode":7018,
    "place_name":"Warrane",
    "state_name":"Tasmania"
  },
  {
    "postcode":7018,
    "place_name":"Mornington",
    "state_name":"Tasmania"
  },
  {
    "postcode":7018,
    "place_name":"Howrah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7019,
    "place_name":"Oakdowns",
    "state_name":"Tasmania"
  },
  {
    "postcode":7019,
    "place_name":"Clarendon Vale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7019,
    "place_name":"Rokeby",
    "state_name":"Tasmania"
  },
  {
    "postcode":7020,
    "place_name":"Sandford",
    "state_name":"Tasmania"
  },
  {
    "postcode":7020,
    "place_name":"Clifton Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7021,
    "place_name":"Lauderdale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7022,
    "place_name":"South Arm",
    "state_name":"Tasmania"
  },
  {
    "postcode":7023,
    "place_name":"Opossum Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7024,
    "place_name":"Cremorne",
    "state_name":"Tasmania"
  },
  {
    "postcode":7025,
    "place_name":"Richmond",
    "state_name":"Tasmania"
  },
  {
    "postcode":7025,
    "place_name":"Dulcot",
    "state_name":"Tasmania"
  },
  {
    "postcode":7026,
    "place_name":"Campania",
    "state_name":"Tasmania"
  },
  {
    "postcode":7027,
    "place_name":"Colebrook",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Steppes",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Flintstone",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Bothwell",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Pontville",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Hermitage",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Tods Corner",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Apsley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Broadmarsh",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Miena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Morass Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Kempton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Pelham",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Gagebrook",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Lower Marshes",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Waddamana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Elderslie",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Shannon",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Bagdad",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Jericho",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Interlaken",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Melton Mowbray",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Bagdad North",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Herdsmans Cove",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Dysart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Granton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Arthurs Lake",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Brighton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Mangalore",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Millers Bluff",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Bridgewater",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Lake Sorell",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Dromedary",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Cramps Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Wilburville",
    "state_name":"Tasmania"
  },
  {
    "postcode":7030,
    "place_name":"Liawenee",
    "state_name":"Tasmania"
  },
  {
    "postcode":7050,
    "place_name":"Kingston Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7050,
    "place_name":"Kingston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7051,
    "place_name":"Kingston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7052,
    "place_name":"Blackmans Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7053,
    "place_name":"Bonnet Hill",
    "state_name":"Tasmania"
  },
  {
    "postcode":7053,
    "place_name":"Taroona",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Coningham",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Wellington Park",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Margate",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Tinderbox",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Neika",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Lower Snug",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Electrona",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Barretta",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Snug",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Fern Tree",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Ridgeway",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Leslie Vale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7054,
    "place_name":"Howden",
    "state_name":"Tasmania"
  },
  {
    "postcode":7055,
    "place_name":"Huntingfield",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Wattle Grove",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Huonville",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Raminea",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Glen Huon",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Glendevie",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Hastings",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Southport",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Cradoc",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Grove",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Lymington",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Petcheys Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Woodstock",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Glaziers Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Judbury",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Lune River",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Ranelagh",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Crabtree",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Lower Longley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Waterloo",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Lucaston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Strathblane",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Lonnavale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Ida Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Mountain River",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Recherche",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Southport Lagoon",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Lower Wattle Grove",
    "state_name":"Tasmania"
  },
  {
    "postcode":7109,
    "place_name":"Catamaran",
    "state_name":"Tasmania"
  },
  {
    "postcode":7112,
    "place_name":"Nicholls Rivulet",
    "state_name":"Tasmania"
  },
  {
    "postcode":7112,
    "place_name":"Randalls Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7112,
    "place_name":"Deep Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7112,
    "place_name":"Verona Sands",
    "state_name":"Tasmania"
  },
  {
    "postcode":7112,
    "place_name":"Garden Island Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7112,
    "place_name":"Eggs And Bacon Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7112,
    "place_name":"Cygnet",
    "state_name":"Tasmania"
  },
  {
    "postcode":7112,
    "place_name":"Charlotte Cove",
    "state_name":"Tasmania"
  },
  {
    "postcode":7112,
    "place_name":"Abels Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7112,
    "place_name":"Gardners Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7113,
    "place_name":"Franklin",
    "state_name":"Tasmania"
  },
  {
    "postcode":7116,
    "place_name":"Castle Forbes Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7116,
    "place_name":"Brooks Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7116,
    "place_name":"Surges Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7116,
    "place_name":"Cairns Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7116,
    "place_name":"Police Point",
    "state_name":"Tasmania"
  },
  {
    "postcode":7116,
    "place_name":"Surveyors Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7116,
    "place_name":"Port Huon",
    "state_name":"Tasmania"
  },
  {
    "postcode":7116,
    "place_name":"Geeveston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7117,
    "place_name":"Dover",
    "state_name":"Tasmania"
  },
  {
    "postcode":7119,
    "place_name":"Stonor",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Swanston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Baden",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Levendale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Lemont",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Tiberias",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Andover",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Mount Seymour",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Parattah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Oatlands",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Antill Ponds",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Whitefoord",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Woodbury",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"York Plains",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Woodsdale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Tunbridge",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Pawtella",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Rhyndaston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Tunnack",
    "state_name":"Tasmania"
  },
  {
    "postcode":7120,
    "place_name":"Stonehenge",
    "state_name":"Tasmania"
  },
  {
    "postcode":7139,
    "place_name":"Strathgordon",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Macquarie Plains",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Plenty",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Victoria Valley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Sorell Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Fitzgerald",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Magra",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Fentonbury",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Karanja",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Hollow Tree",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Maydena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Bronte Park",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Lachlan",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Malbina",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Ouse",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Gretna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Glenora",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Bushy Park",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Hayes",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Black Hills",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Hamilton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Mount Field",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Mount Lloyd",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Lawitta",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Osterley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Bradys Lake",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Moogara",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Wayatinah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Butlers Gorge",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Lake St Clair",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Westerway",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Ellendale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"National Park",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Molesworth",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Tarraleah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Strickland",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"New Norfolk",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Styx",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Uxbridge",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Derwent Bridge",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Little Pine Lagoon",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Tyenna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Boyer",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Dee",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Glenfern",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Rosegarland",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Meadowbank",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"Florentine",
    "state_name":"Tasmania"
  },
  {
    "postcode":7140,
    "place_name":"London Lakes",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Allens Rivulet",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Upper Woodstock",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"South Bruny",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Barnes Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Pelverata",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Killora",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Oyster Cove",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Lunawanna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Simpsons Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"North Bruny",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Gordon",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Apollo Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Dennes Point",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Great Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Adventure Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Alonnah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Longley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Sandfly",
    "state_name":"Tasmania"
  },
  {
    "postcode":7150,
    "place_name":"Kaoota",
    "state_name":"Tasmania"
  },
  {
    "postcode":7151,
    "place_name":"Macquarie Island",
    "state_name":"Tasmania"
  },
  {
    "postcode":7151,
    "place_name":"Macquarie",
    "state_name":"Tasmania"
  },
  {
    "postcode":7151,
    "place_name":"Casey",
    "state_name":"Tasmania"
  },
  {
    "postcode":7151,
    "place_name":"Mawson",
    "state_name":"Tasmania"
  },
  {
    "postcode":7151,
    "place_name":"Davis",
    "state_name":"Tasmania"
  },
  {
    "postcode":7151,
    "place_name":"Heard Island",
    "state_name":"Tasmania"
  },
  {
    "postcode":7151,
    "place_name":"Mcdonald Islands",
    "state_name":"Tasmania"
  },
  {
    "postcode":7155,
    "place_name":"Kettering",
    "state_name":"Tasmania"
  },
  {
    "postcode":7162,
    "place_name":"Birchs Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7162,
    "place_name":"Woodbridge",
    "state_name":"Tasmania"
  },
  {
    "postcode":7163,
    "place_name":"Flowerpot",
    "state_name":"Tasmania"
  },
  {
    "postcode":7163,
    "place_name":"Middleton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7170,
    "place_name":"Seven Mile Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7170,
    "place_name":"Roches Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7170,
    "place_name":"Cambridge",
    "state_name":"Tasmania"
  },
  {
    "postcode":7170,
    "place_name":"Mount Rumney",
    "state_name":"Tasmania"
  },
  {
    "postcode":7170,
    "place_name":"Acton Park",
    "state_name":"Tasmania"
  },
  {
    "postcode":7171,
    "place_name":"Penna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7171,
    "place_name":"Midway Point",
    "state_name":"Tasmania"
  },
  {
    "postcode":7172,
    "place_name":"Orielton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7172,
    "place_name":"Sorell",
    "state_name":"Tasmania"
  },
  {
    "postcode":7172,
    "place_name":"Nugent",
    "state_name":"Tasmania"
  },
  {
    "postcode":7172,
    "place_name":"Pawleena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7172,
    "place_name":"Wattle Hill",
    "state_name":"Tasmania"
  },
  {
    "postcode":7173,
    "place_name":"Forcett",
    "state_name":"Tasmania"
  },
  {
    "postcode":7173,
    "place_name":"Carlton River",
    "state_name":"Tasmania"
  },
  {
    "postcode":7173,
    "place_name":"Primrose Sands",
    "state_name":"Tasmania"
  },
  {
    "postcode":7173,
    "place_name":"Lewisham",
    "state_name":"Tasmania"
  },
  {
    "postcode":7173,
    "place_name":"Dodges Ferry",
    "state_name":"Tasmania"
  },
  {
    "postcode":7173,
    "place_name":"Connellys Marsh",
    "state_name":"Tasmania"
  },
  {
    "postcode":7173,
    "place_name":"Carlton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7174,
    "place_name":"Copping",
    "state_name":"Tasmania"
  },
  {
    "postcode":7175,
    "place_name":"Bream Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7175,
    "place_name":"Marion Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7176,
    "place_name":"Kellevie",
    "state_name":"Tasmania"
  },
  {
    "postcode":7177,
    "place_name":"Boomer Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7177,
    "place_name":"Dunalley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7178,
    "place_name":"Murdunna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7179,
    "place_name":"Eaglehawk Neck",
    "state_name":"Tasmania"
  },
  {
    "postcode":7180,
    "place_name":"Taranna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7182,
    "place_name":"Port Arthur",
    "state_name":"Tasmania"
  },
  {
    "postcode":7182,
    "place_name":"Cape Pillar",
    "state_name":"Tasmania"
  },
  {
    "postcode":7182,
    "place_name":"Fortescue",
    "state_name":"Tasmania"
  },
  {
    "postcode":7183,
    "place_name":"Highcroft",
    "state_name":"Tasmania"
  },
  {
    "postcode":7184,
    "place_name":"White Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7184,
    "place_name":"Nubeena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7184,
    "place_name":"Cape Raoul",
    "state_name":"Tasmania"
  },
  {
    "postcode":7184,
    "place_name":"Stormlea",
    "state_name":"Tasmania"
  },
  {
    "postcode":7185,
    "place_name":"Premaydena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7186,
    "place_name":"Saltwater River",
    "state_name":"Tasmania"
  },
  {
    "postcode":7186,
    "place_name":"Sloping Main",
    "state_name":"Tasmania"
  },
  {
    "postcode":7187,
    "place_name":"Koonya",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Swansea",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Little Swanport",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Dolphin Sands",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Runnymede",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Rheban",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Orford",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Cranbrook",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Triabunna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Spring Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Buckland",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Pontypool",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Apslawn",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Maria Island",
    "state_name":"Tasmania"
  },
  {
    "postcode":7190,
    "place_name":"Rocky Hills",
    "state_name":"Tasmania"
  },
  {
    "postcode":7209,
    "place_name":"Ross",
    "state_name":"Tasmania"
  },
  {
    "postcode":7209,
    "place_name":"Tooms Lake",
    "state_name":"Tasmania"
  },
  {
    "postcode":7210,
    "place_name":"Campbell Town",
    "state_name":"Tasmania"
  },
  {
    "postcode":7210,
    "place_name":"Lake Leake",
    "state_name":"Tasmania"
  },
  {
    "postcode":7211,
    "place_name":"Cleveland",
    "state_name":"Tasmania"
  },
  {
    "postcode":7211,
    "place_name":"Conara",
    "state_name":"Tasmania"
  },
  {
    "postcode":7211,
    "place_name":"Epping Forest",
    "state_name":"Tasmania"
  },
  {
    "postcode":7212,
    "place_name":"Evandale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7212,
    "place_name":"Burns Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7212,
    "place_name":"Blessington",
    "state_name":"Tasmania"
  },
  {
    "postcode":7212,
    "place_name":"Upper Blessington",
    "state_name":"Tasmania"
  },
  {
    "postcode":7212,
    "place_name":"Nile",
    "state_name":"Tasmania"
  },
  {
    "postcode":7212,
    "place_name":"Deddington",
    "state_name":"Tasmania"
  },
  {
    "postcode":7212,
    "place_name":"Western Junction",
    "state_name":"Tasmania"
  },
  {
    "postcode":7212,
    "place_name":"Ben Lomond",
    "state_name":"Tasmania"
  },
  {
    "postcode":7213,
    "place_name":"Royal George",
    "state_name":"Tasmania"
  },
  {
    "postcode":7213,
    "place_name":"Rossarden",
    "state_name":"Tasmania"
  },
  {
    "postcode":7213,
    "place_name":"Avoca",
    "state_name":"Tasmania"
  },
  {
    "postcode":7214,
    "place_name":"Mangana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7214,
    "place_name":"Fingal",
    "state_name":"Tasmania"
  },
  {
    "postcode":7214,
    "place_name":"Upper Esk",
    "state_name":"Tasmania"
  },
  {
    "postcode":7214,
    "place_name":"Mathinna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Seymour",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Scamander",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Douglas River",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Douglas-Apsley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Falmouth",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"St Marys",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Coles Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Friendly Beaches",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Bicheno",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Cornwall",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Four Mile Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Beaumaris",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Chain Of Lagoons",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Gray",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Upper Scamander",
    "state_name":"Tasmania"
  },
  {
    "postcode":7215,
    "place_name":"Freycinet",
    "state_name":"Tasmania"
  },
  {
    "postcode":7216,
    "place_name":"The Gardens",
    "state_name":"Tasmania"
  },
  {
    "postcode":7216,
    "place_name":"Pyengana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7216,
    "place_name":"Goshen",
    "state_name":"Tasmania"
  },
  {
    "postcode":7216,
    "place_name":"Ansons Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7216,
    "place_name":"St Helens",
    "state_name":"Tasmania"
  },
  {
    "postcode":7216,
    "place_name":"Lottah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7216,
    "place_name":"Stieglitz",
    "state_name":"Tasmania"
  },
  {
    "postcode":7216,
    "place_name":"Goulds Country",
    "state_name":"Tasmania"
  },
  {
    "postcode":7216,
    "place_name":"Akaroa",
    "state_name":"Tasmania"
  },
  {
    "postcode":7216,
    "place_name":"Binalong Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7248,
    "place_name":"Newnham",
    "state_name":"Tasmania"
  },
  {
    "postcode":7248,
    "place_name":"Rocherlea",
    "state_name":"Tasmania"
  },
  {
    "postcode":7248,
    "place_name":"Mowbray",
    "state_name":"Tasmania"
  },
  {
    "postcode":7248,
    "place_name":"Mayfield",
    "state_name":"Tasmania"
  },
  {
    "postcode":7248,
    "place_name":"Invermay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7249,
    "place_name":"Youngtown",
    "state_name":"Tasmania"
  },
  {
    "postcode":7249,
    "place_name":"Kings Meadows",
    "state_name":"Tasmania"
  },
  {
    "postcode":7249,
    "place_name":"Glen Dhu",
    "state_name":"Tasmania"
  },
  {
    "postcode":7249,
    "place_name":"Punchbowl",
    "state_name":"Tasmania"
  },
  {
    "postcode":7249,
    "place_name":"South Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Norwood",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Prospect",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Prospect Vale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Waverley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Trevallyn",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"East Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Newstead",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Travellers Rest",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Blackstone Heights",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Summerhill",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"West Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Riverside",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"Ravenswood",
    "state_name":"Tasmania"
  },
  {
    "postcode":7250,
    "place_name":"St Leonards",
    "state_name":"Tasmania"
  },
  {
    "postcode":7252,
    "place_name":"Swan Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7252,
    "place_name":"Dilston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7252,
    "place_name":"Pipers River",
    "state_name":"Tasmania"
  },
  {
    "postcode":7252,
    "place_name":"Weymouth",
    "state_name":"Tasmania"
  },
  {
    "postcode":7252,
    "place_name":"Mount Direction",
    "state_name":"Tasmania"
  },
  {
    "postcode":7252,
    "place_name":"Lefroy",
    "state_name":"Tasmania"
  },
  {
    "postcode":7252,
    "place_name":"Hillwood",
    "state_name":"Tasmania"
  },
  {
    "postcode":7252,
    "place_name":"Beechford",
    "state_name":"Tasmania"
  },
  {
    "postcode":7252,
    "place_name":"Windermere",
    "state_name":"Tasmania"
  },
  {
    "postcode":7252,
    "place_name":"Stony Head",
    "state_name":"Tasmania"
  },
  {
    "postcode":7252,
    "place_name":"Lulworth",
    "state_name":"Tasmania"
  },
  {
    "postcode":7253,
    "place_name":"George Town",
    "state_name":"Tasmania"
  },
  {
    "postcode":7253,
    "place_name":"Long Reach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7253,
    "place_name":"Low Head",
    "state_name":"Tasmania"
  },
  {
    "postcode":7253,
    "place_name":"Bell Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7254,
    "place_name":"Golconda",
    "state_name":"Tasmania"
  },
  {
    "postcode":7254,
    "place_name":"Lebrina",
    "state_name":"Tasmania"
  },
  {
    "postcode":7254,
    "place_name":"Tunnel",
    "state_name":"Tasmania"
  },
  {
    "postcode":7254,
    "place_name":"Pipers Brook",
    "state_name":"Tasmania"
  },
  {
    "postcode":7254,
    "place_name":"Bellingham",
    "state_name":"Tasmania"
  },
  {
    "postcode":7254,
    "place_name":"Retreat",
    "state_name":"Tasmania"
  },
  {
    "postcode":7254,
    "place_name":"Wyena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Ranga",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Emita",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Blue Rocks",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Loccota",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Leeka",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Lackrana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Lughrata",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Strzelecki",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Lady Barron",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Wingaroo",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Palana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Whitemark",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Killiecrankie",
    "state_name":"Tasmania"
  },
  {
    "postcode":7255,
    "place_name":"Memana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Naracoopa",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Yarra Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Yambacoona",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Currie",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Grassy",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Pearshape",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Pegarah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Loorana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Sea Elephant",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Surprise Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Reekara",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Nugara",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Bungaree",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Lymwood",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Wickham",
    "state_name":"Tasmania"
  },
  {
    "postcode":7256,
    "place_name":"Egg Lagoon",
    "state_name":"Tasmania"
  },
  {
    "postcode":7257,
    "place_name":"Cape Barren Island",
    "state_name":"Tasmania"
  },
  {
    "postcode":7258,
    "place_name":"Relbia",
    "state_name":"Tasmania"
  },
  {
    "postcode":7258,
    "place_name":"White Hills",
    "state_name":"Tasmania"
  },
  {
    "postcode":7258,
    "place_name":"Breadalbane",
    "state_name":"Tasmania"
  },
  {
    "postcode":7259,
    "place_name":"Patersonia",
    "state_name":"Tasmania"
  },
  {
    "postcode":7259,
    "place_name":"Myrtle Bank",
    "state_name":"Tasmania"
  },
  {
    "postcode":7259,
    "place_name":"Targa",
    "state_name":"Tasmania"
  },
  {
    "postcode":7259,
    "place_name":"Nunamara",
    "state_name":"Tasmania"
  },
  {
    "postcode":7259,
    "place_name":"Tayene",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"North Scottsdale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Blumont",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Nabowla",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Jetsonville",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Scottsdale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Cuckoo",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"South Springfield",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Tonganah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Springfield",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Tulendeena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Kamona",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Lietinna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Forester",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"West Scottsdale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7260,
    "place_name":"Lisle",
    "state_name":"Tasmania"
  },
  {
    "postcode":7261,
    "place_name":"Branxholm",
    "state_name":"Tasmania"
  },
  {
    "postcode":7261,
    "place_name":"Warrentinna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7262,
    "place_name":"Waterhouse",
    "state_name":"Tasmania"
  },
  {
    "postcode":7262,
    "place_name":"Tomahawk",
    "state_name":"Tasmania"
  },
  {
    "postcode":7262,
    "place_name":"Bridport",
    "state_name":"Tasmania"
  },
  {
    "postcode":7263,
    "place_name":"Trenah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7263,
    "place_name":"Talawa",
    "state_name":"Tasmania"
  },
  {
    "postcode":7263,
    "place_name":"Legerwood",
    "state_name":"Tasmania"
  },
  {
    "postcode":7263,
    "place_name":"Ringarooma",
    "state_name":"Tasmania"
  },
  {
    "postcode":7263,
    "place_name":"Alberton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Gladstone",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"South Mount Cameron",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Boobyalla",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Mount William",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Cape Portland",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Telita",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Eddystone",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Moorina",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Pioneer",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Ansons Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Derby",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Musselroe Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Weldborough",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Rushy Lagoon",
    "state_name":"Tasmania"
  },
  {
    "postcode":7264,
    "place_name":"Herrick",
    "state_name":"Tasmania"
  },
  {
    "postcode":7265,
    "place_name":"Winnaleah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7265,
    "place_name":"Banca",
    "state_name":"Tasmania"
  },
  {
    "postcode":7267,
    "place_name":"Karoola",
    "state_name":"Tasmania"
  },
  {
    "postcode":7267,
    "place_name":"Bangor",
    "state_name":"Tasmania"
  },
  {
    "postcode":7267,
    "place_name":"Turners Marsh",
    "state_name":"Tasmania"
  },
  {
    "postcode":7267,
    "place_name":"Lalla",
    "state_name":"Tasmania"
  },
  {
    "postcode":7267,
    "place_name":"Lower Turners Marsh",
    "state_name":"Tasmania"
  },
  {
    "postcode":7268,
    "place_name":"Underwood",
    "state_name":"Tasmania"
  },
  {
    "postcode":7268,
    "place_name":"Lilydale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7268,
    "place_name":"North Lilydale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7270,
    "place_name":"Rowella",
    "state_name":"Tasmania"
  },
  {
    "postcode":7270,
    "place_name":"York Town",
    "state_name":"Tasmania"
  },
  {
    "postcode":7270,
    "place_name":"Sidmouth",
    "state_name":"Tasmania"
  },
  {
    "postcode":7270,
    "place_name":"Kelso",
    "state_name":"Tasmania"
  },
  {
    "postcode":7270,
    "place_name":"Greens Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7270,
    "place_name":"Badger Head",
    "state_name":"Tasmania"
  },
  {
    "postcode":7270,
    "place_name":"Kayena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7270,
    "place_name":"Flowery Gully",
    "state_name":"Tasmania"
  },
  {
    "postcode":7270,
    "place_name":"Beauty Point",
    "state_name":"Tasmania"
  },
  {
    "postcode":7270,
    "place_name":"Beaconsfield",
    "state_name":"Tasmania"
  },
  {
    "postcode":7270,
    "place_name":"Clarence Point",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Blackwall",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Swan Point",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Notley Hills",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Lanena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Glengarry",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Robigana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Loira",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Winkleigh",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Holwell",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Deviot",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Exeter",
    "state_name":"Tasmania"
  },
  {
    "postcode":7275,
    "place_name":"Frankford",
    "state_name":"Tasmania"
  },
  {
    "postcode":7276,
    "place_name":"Gravelly Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7277,
    "place_name":"Grindelwald",
    "state_name":"Tasmania"
  },
  {
    "postcode":7277,
    "place_name":"Legana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7277,
    "place_name":"Rosevears",
    "state_name":"Tasmania"
  },
  {
    "postcode":7277,
    "place_name":"Bridgenorth",
    "state_name":"Tasmania"
  },
  {
    "postcode":7290,
    "place_name":"Hadspen",
    "state_name":"Tasmania"
  },
  {
    "postcode":7291,
    "place_name":"Carrick",
    "state_name":"Tasmania"
  },
  {
    "postcode":7292,
    "place_name":"Quamby Bend",
    "state_name":"Tasmania"
  },
  {
    "postcode":7292,
    "place_name":"Selbourne",
    "state_name":"Tasmania"
  },
  {
    "postcode":7292,
    "place_name":"Westwood",
    "state_name":"Tasmania"
  },
  {
    "postcode":7292,
    "place_name":"Hagley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7292,
    "place_name":"Rosevale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7300,
    "place_name":"Perth",
    "state_name":"Tasmania"
  },
  {
    "postcode":7300,
    "place_name":"Devon Hills",
    "state_name":"Tasmania"
  },
  {
    "postcode":7300,
    "place_name":"Powranna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7301,
    "place_name":"Blackwood Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7301,
    "place_name":"Longford",
    "state_name":"Tasmania"
  },
  {
    "postcode":7301,
    "place_name":"Bishopsbourne",
    "state_name":"Tasmania"
  },
  {
    "postcode":7301,
    "place_name":"Liffey",
    "state_name":"Tasmania"
  },
  {
    "postcode":7301,
    "place_name":"Toiberry",
    "state_name":"Tasmania"
  },
  {
    "postcode":7302,
    "place_name":"Cressy",
    "state_name":"Tasmania"
  },
  {
    "postcode":7302,
    "place_name":"Poatina",
    "state_name":"Tasmania"
  },
  {
    "postcode":7302,
    "place_name":"Bracknell",
    "state_name":"Tasmania"
  },
  {
    "postcode":7303,
    "place_name":"Osmaston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7303,
    "place_name":"Cluan",
    "state_name":"Tasmania"
  },
  {
    "postcode":7303,
    "place_name":"Birralee",
    "state_name":"Tasmania"
  },
  {
    "postcode":7303,
    "place_name":"Westbury",
    "state_name":"Tasmania"
  },
  {
    "postcode":7303,
    "place_name":"Exton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7303,
    "place_name":"Oaks",
    "state_name":"Tasmania"
  },
  {
    "postcode":7303,
    "place_name":"Whitemore",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Weegena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Dunorlan",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Western Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Quamby Brook",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Dairy Plains",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Montana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Reedy Marsh",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Liena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Mersey Forest",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Meander",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Moltema",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Mayberry",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Brandum",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Walls Of Jerusalem",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Elizabeth Town",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Red Hills",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Jackeys Marsh",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Central Plateau",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Reynolds Neck",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Doctors Point",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Golden Valley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Needles",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Kimberley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Weetah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Mole Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Deloraine",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Parkham",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Chudleigh",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Caveside",
    "state_name":"Tasmania"
  },
  {
    "postcode":7304,
    "place_name":"Breona",
    "state_name":"Tasmania"
  },
  {
    "postcode":7305,
    "place_name":"Railton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7305,
    "place_name":"Merseylea",
    "state_name":"Tasmania"
  },
  {
    "postcode":7305,
    "place_name":"Sunnyside",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Staverton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Middlesex",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"West Kentish",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Paradise",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Claude Road",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Nowhere Else",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Sheffield",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Stoodley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Lower Beulah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Acacia Hills",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Promised Land",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Lorinna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Cradle Mountain",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Lower Barrington",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Roland",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Barrington",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Cethana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Mount Roland",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Gowrie Park",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Beulah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7306,
    "place_name":"Nook",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Sassafras",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Bakers Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Harford",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Shearwater",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Latrobe",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Hawley Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Moriarty",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Wesley Vale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Northdown",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Thirlstane",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Port Sorell",
    "state_name":"Tasmania"
  },
  {
    "postcode":7307,
    "place_name":"Squeaking Point",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Forthside",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"West Devonport",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Spreyton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Stony Rise",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Devonport",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Ambleside",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Erriba",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Eugenana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Lower Wilmot",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Lillico",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Quoiba",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Paloona",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Don",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"East Devonport",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Aberdeen",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Miandetta",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Kindred",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Tugrah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Melrose",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Wilmot",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Moina",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Tarleton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"Forth",
    "state_name":"Tasmania"
  },
  {
    "postcode":7310,
    "place_name":"South Spreyton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Ulverstone",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"West Ulverstone",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Nietta",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Loongana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"South Preston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Castra",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Gunns Plains",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"North Motton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Upper Castra",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"South Nietta",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Abbotsham",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Turners Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Leith",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Spalford",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Preston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Sprent",
    "state_name":"Tasmania"
  },
  {
    "postcode":7315,
    "place_name":"Gawler",
    "state_name":"Tasmania"
  },
  {
    "postcode":7316,
    "place_name":"West Pine",
    "state_name":"Tasmania"
  },
  {
    "postcode":7316,
    "place_name":"Howth",
    "state_name":"Tasmania"
  },
  {
    "postcode":7316,
    "place_name":"Sulphur Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7316,
    "place_name":"Loyetea",
    "state_name":"Tasmania"
  },
  {
    "postcode":7316,
    "place_name":"Camena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7316,
    "place_name":"Penguin",
    "state_name":"Tasmania"
  },
  {
    "postcode":7316,
    "place_name":"Heybridge",
    "state_name":"Tasmania"
  },
  {
    "postcode":7316,
    "place_name":"South Riana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7316,
    "place_name":"Preservation Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7316,
    "place_name":"Cuprona",
    "state_name":"Tasmania"
  },
  {
    "postcode":7316,
    "place_name":"Riana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Camdale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Acton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Burnie",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Downlands",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"South Burnie",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Shorewell Park",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Upper Burnie",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Brooklyn",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Cooee",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Park Grove",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Wivenhoe",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Havenview",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Hillcrest",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Round Hill",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Emu Heights",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Ocean Vista",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Romaine",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Parklands",
    "state_name":"Tasmania"
  },
  {
    "postcode":7320,
    "place_name":"Montello",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Stowport",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Edgcumbe Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Rocky Cape",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"East Ridgley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Ridgley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Crayfish Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Wiltshire",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Parrawe",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Tullah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Savage River",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Guildford",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Waratah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Tewkesbury",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Upper Stowport",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Mooreville",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Port Latta",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Luina",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"West Mooreville",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Natone",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Boat Harbour Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Corinna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"West Ridgley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Upper Natone",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Hellyer",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Boat Harbour",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Chasm Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Montumana",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Mawbanna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Detention",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Cowrie Point",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Black River",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Sisters Beach",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Hampshire",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"East Cam",
    "state_name":"Tasmania"
  },
  {
    "postcode":7321,
    "place_name":"Highclere",
    "state_name":"Tasmania"
  },
  {
    "postcode":7322,
    "place_name":"Somerset",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Takone",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Sisters Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Yolla",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"West Takone",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Lapoinya",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Henrietta",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Milabena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Preolenna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Mount Hicks",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Wynyard",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Oldina",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Oonah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Seabrook",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Elliott",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Meunna",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Doctors Rocks",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Moorleah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Table Cape",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Myalla",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Calder",
    "state_name":"Tasmania"
  },
  {
    "postcode":7325,
    "place_name":"Flowerdale",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Trowutta",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"South Forest",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Mengha",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Edith Creek",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Temma",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Lileah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Roger River",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Togari",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Alcomie",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Scopus",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Marrawah",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Christmas Hills",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Mella",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Irishtown",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Redpa",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Forest",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Smithton",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Arthur River",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Brittons Swamp",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Nabageena",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Broadmeadows",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Three Hummock Island",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Scotchtown",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Woolnorth",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"West Montagu",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Couta Rocks",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Nelson Bay",
    "state_name":"Tasmania"
  },
  {
    "postcode":7330,
    "place_name":"Montagu",
    "state_name":"Tasmania"
  },
  {
    "postcode":7331,
    "place_name":"Stanley",
    "state_name":"Tasmania"
  },
  {
    "postcode":7466,
    "place_name":"Gormanston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7467,
    "place_name":"Lake Margaret",
    "state_name":"Tasmania"
  },
  {
    "postcode":7467,
    "place_name":"Queenstown",
    "state_name":"Tasmania"
  },
  {
    "postcode":7468,
    "place_name":"Macquarie Heads",
    "state_name":"Tasmania"
  },
  {
    "postcode":7468,
    "place_name":"Strahan",
    "state_name":"Tasmania"
  },
  {
    "postcode":7469,
    "place_name":"Granville Harbour",
    "state_name":"Tasmania"
  },
  {
    "postcode":7469,
    "place_name":"Renison Bell",
    "state_name":"Tasmania"
  },
  {
    "postcode":7469,
    "place_name":"Trial Harbour",
    "state_name":"Tasmania"
  },
  {
    "postcode":7469,
    "place_name":"Zeehan",
    "state_name":"Tasmania"
  },
  {
    "postcode":7470,
    "place_name":"Rosebery",
    "state_name":"Tasmania"
  },
  {
    "postcode":7800,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7802,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7803,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7804,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7805,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7806,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7807,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7808,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7809,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7810,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7811,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7812,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7813,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7814,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7823,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7824,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7827,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7828,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7829,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7845,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7850,
    "place_name":"Hobart",
    "state_name":"Tasmania"
  },
  {
    "postcode":7901,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7902,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7903,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7904,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7905,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7906,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7907,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7908,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7915,
    "place_name":"Burnie",
    "state_name":"Tasmania"
  },
  {
    "postcode":7916,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7917,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7918,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7919,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7920,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7921,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7922,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":7923,
    "place_name":"Launceston",
    "state_name":"Tasmania"
  },
  {
    "postcode":3000,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3001,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3002,
    "place_name":"East Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3003,
    "place_name":"West Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3004,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3004,
    "place_name":"St Kilda Road Central",
    "state_name":"Victoria"
  },
  {
    "postcode":3004,
    "place_name":"St Kilda Road Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3005,
    "place_name":"World Trade Centre",
    "state_name":"Victoria"
  },
  {
    "postcode":3006,
    "place_name":"South Wharf",
    "state_name":"Victoria"
  },
  {
    "postcode":3006,
    "place_name":"Southbank",
    "state_name":"Victoria"
  },
  {
    "postcode":3008,
    "place_name":"Docklands",
    "state_name":"Victoria"
  },
  {
    "postcode":3010,
    "place_name":"University Of Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3011,
    "place_name":"Seddon",
    "state_name":"Victoria"
  },
  {
    "postcode":3011,
    "place_name":"Seddon West",
    "state_name":"Victoria"
  },
  {
    "postcode":3011,
    "place_name":"Footscray",
    "state_name":"Victoria"
  },
  {
    "postcode":3012,
    "place_name":"Maidstone",
    "state_name":"Victoria"
  },
  {
    "postcode":3012,
    "place_name":"Tottenham",
    "state_name":"Victoria"
  },
  {
    "postcode":3012,
    "place_name":"West Footscray",
    "state_name":"Victoria"
  },
  {
    "postcode":3012,
    "place_name":"Brooklyn",
    "state_name":"Victoria"
  },
  {
    "postcode":3012,
    "place_name":"Kingsville",
    "state_name":"Victoria"
  },
  {
    "postcode":3013,
    "place_name":"Yarraville",
    "state_name":"Victoria"
  },
  {
    "postcode":3013,
    "place_name":"Yarraville West",
    "state_name":"Victoria"
  },
  {
    "postcode":3015,
    "place_name":"Newport",
    "state_name":"Victoria"
  },
  {
    "postcode":3015,
    "place_name":"Spotswood",
    "state_name":"Victoria"
  },
  {
    "postcode":3015,
    "place_name":"South Kingsville",
    "state_name":"Victoria"
  },
  {
    "postcode":3016,
    "place_name":"Williamstown North",
    "state_name":"Victoria"
  },
  {
    "postcode":3016,
    "place_name":"Williamstown",
    "state_name":"Victoria"
  },
  {
    "postcode":3018,
    "place_name":"Seaholme",
    "state_name":"Victoria"
  },
  {
    "postcode":3018,
    "place_name":"Altona",
    "state_name":"Victoria"
  },
  {
    "postcode":3019,
    "place_name":"Braybrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3019,
    "place_name":"Robinson",
    "state_name":"Victoria"
  },
  {
    "postcode":3020,
    "place_name":"Sunshine West",
    "state_name":"Victoria"
  },
  {
    "postcode":3020,
    "place_name":"Albion",
    "state_name":"Victoria"
  },
  {
    "postcode":3020,
    "place_name":"Glengala",
    "state_name":"Victoria"
  },
  {
    "postcode":3020,
    "place_name":"Sunshine North",
    "state_name":"Victoria"
  },
  {
    "postcode":3020,
    "place_name":"Sunshine",
    "state_name":"Victoria"
  },
  {
    "postcode":3021,
    "place_name":"Albanvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3021,
    "place_name":"St Albans",
    "state_name":"Victoria"
  },
  {
    "postcode":3021,
    "place_name":"Kealba",
    "state_name":"Victoria"
  },
  {
    "postcode":3021,
    "place_name":"Kings Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3022,
    "place_name":"Deer Park East",
    "state_name":"Victoria"
  },
  {
    "postcode":3022,
    "place_name":"Ardeer",
    "state_name":"Victoria"
  },
  {
    "postcode":3023,
    "place_name":"Deer Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3023,
    "place_name":"Ravenhall",
    "state_name":"Victoria"
  },
  {
    "postcode":3023,
    "place_name":"Deer Park North",
    "state_name":"Victoria"
  },
  {
    "postcode":3023,
    "place_name":"Burnside",
    "state_name":"Victoria"
  },
  {
    "postcode":3023,
    "place_name":"Cairnlea",
    "state_name":"Victoria"
  },
  {
    "postcode":3023,
    "place_name":"Burnside Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3023,
    "place_name":"Caroline Springs",
    "state_name":"Victoria"
  },
  {
    "postcode":3024,
    "place_name":"Wyndham Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3024,
    "place_name":"Mount Cottrell",
    "state_name":"Victoria"
  },
  {
    "postcode":3024,
    "place_name":"Mambourin",
    "state_name":"Victoria"
  },
  {
    "postcode":3025,
    "place_name":"Altona North",
    "state_name":"Victoria"
  },
  {
    "postcode":3025,
    "place_name":"Altona Gate",
    "state_name":"Victoria"
  },
  {
    "postcode":3025,
    "place_name":"Altona East",
    "state_name":"Victoria"
  },
  {
    "postcode":3026,
    "place_name":"Laverton North",
    "state_name":"Victoria"
  },
  {
    "postcode":3027,
    "place_name":"Williams Landing",
    "state_name":"Victoria"
  },
  {
    "postcode":3028,
    "place_name":"Altona Meadows",
    "state_name":"Victoria"
  },
  {
    "postcode":3028,
    "place_name":"Laverton",
    "state_name":"Victoria"
  },
  {
    "postcode":3028,
    "place_name":"Seabrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3029,
    "place_name":"Truganina",
    "state_name":"Victoria"
  },
  {
    "postcode":3029,
    "place_name":"Hoppers Crossing",
    "state_name":"Victoria"
  },
  {
    "postcode":3029,
    "place_name":"Tarneit",
    "state_name":"Victoria"
  },
  {
    "postcode":3030,
    "place_name":"Point Cook",
    "state_name":"Victoria"
  },
  {
    "postcode":3030,
    "place_name":"Quandong",
    "state_name":"Victoria"
  },
  {
    "postcode":3030,
    "place_name":"Werribee",
    "state_name":"Victoria"
  },
  {
    "postcode":3030,
    "place_name":"Derrimut",
    "state_name":"Victoria"
  },
  {
    "postcode":3030,
    "place_name":"Cocoroc",
    "state_name":"Victoria"
  },
  {
    "postcode":3030,
    "place_name":"Werribee South",
    "state_name":"Victoria"
  },
  {
    "postcode":3031,
    "place_name":"Flemington",
    "state_name":"Victoria"
  },
  {
    "postcode":3031,
    "place_name":"Kensington",
    "state_name":"Victoria"
  },
  {
    "postcode":3032,
    "place_name":"Maribyrnong",
    "state_name":"Victoria"
  },
  {
    "postcode":3032,
    "place_name":"Highpoint City",
    "state_name":"Victoria"
  },
  {
    "postcode":3032,
    "place_name":"Travancore",
    "state_name":"Victoria"
  },
  {
    "postcode":3032,
    "place_name":"Ascot Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3033,
    "place_name":"Keilor East",
    "state_name":"Victoria"
  },
  {
    "postcode":3034,
    "place_name":"Avondale Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3036,
    "place_name":"Keilor North",
    "state_name":"Victoria"
  },
  {
    "postcode":3036,
    "place_name":"Keilor",
    "state_name":"Victoria"
  },
  {
    "postcode":3037,
    "place_name":"Hillside",
    "state_name":"Victoria"
  },
  {
    "postcode":3037,
    "place_name":"Calder Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3037,
    "place_name":"Sydenham",
    "state_name":"Victoria"
  },
  {
    "postcode":3037,
    "place_name":"Taylors Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3037,
    "place_name":"Delahey",
    "state_name":"Victoria"
  },
  {
    "postcode":3038,
    "place_name":"Keilor Downs",
    "state_name":"Victoria"
  },
  {
    "postcode":3038,
    "place_name":"Watergardens",
    "state_name":"Victoria"
  },
  {
    "postcode":3038,
    "place_name":"Taylors Lakes",
    "state_name":"Victoria"
  },
  {
    "postcode":3038,
    "place_name":"Keilor Lodge",
    "state_name":"Victoria"
  },
  {
    "postcode":3039,
    "place_name":"Moonee Ponds",
    "state_name":"Victoria"
  },
  {
    "postcode":3040,
    "place_name":"Essendon",
    "state_name":"Victoria"
  },
  {
    "postcode":3040,
    "place_name":"Aberfeldie",
    "state_name":"Victoria"
  },
  {
    "postcode":3040,
    "place_name":"Essendon West",
    "state_name":"Victoria"
  },
  {
    "postcode":3041,
    "place_name":"Strathmore",
    "state_name":"Victoria"
  },
  {
    "postcode":3041,
    "place_name":"Strathmore Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3041,
    "place_name":"Essendon North",
    "state_name":"Victoria"
  },
  {
    "postcode":3041,
    "place_name":"Essendon Fields",
    "state_name":"Victoria"
  },
  {
    "postcode":3041,
    "place_name":"Cross Keys",
    "state_name":"Victoria"
  },
  {
    "postcode":3042,
    "place_name":"Keilor Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3042,
    "place_name":"Niddrie North",
    "state_name":"Victoria"
  },
  {
    "postcode":3042,
    "place_name":"Airport West",
    "state_name":"Victoria"
  },
  {
    "postcode":3042,
    "place_name":"Niddrie",
    "state_name":"Victoria"
  },
  {
    "postcode":3043,
    "place_name":"Gowanbrae",
    "state_name":"Victoria"
  },
  {
    "postcode":3043,
    "place_name":"Tullamarine",
    "state_name":"Victoria"
  },
  {
    "postcode":3043,
    "place_name":"Gladstone Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3044,
    "place_name":"Pascoe Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3044,
    "place_name":"Pascoe Vale South",
    "state_name":"Victoria"
  },
  {
    "postcode":3045,
    "place_name":"Melbourne Airport",
    "state_name":"Victoria"
  },
  {
    "postcode":3046,
    "place_name":"Oak Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3046,
    "place_name":"Glenroy",
    "state_name":"Victoria"
  },
  {
    "postcode":3046,
    "place_name":"Hadfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3047,
    "place_name":"Dallas",
    "state_name":"Victoria"
  },
  {
    "postcode":3047,
    "place_name":"Broadmeadows",
    "state_name":"Victoria"
  },
  {
    "postcode":3047,
    "place_name":"Jacana",
    "state_name":"Victoria"
  },
  {
    "postcode":3048,
    "place_name":"Coolaroo",
    "state_name":"Victoria"
  },
  {
    "postcode":3048,
    "place_name":"Meadow Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3049,
    "place_name":"Westmeadows",
    "state_name":"Victoria"
  },
  {
    "postcode":3049,
    "place_name":"Attwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3050,
    "place_name":"Royal Melbourne Hospital",
    "state_name":"Victoria"
  },
  {
    "postcode":3051,
    "place_name":"North Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3051,
    "place_name":"Hotham Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3052,
    "place_name":"Parkville",
    "state_name":"Victoria"
  },
  {
    "postcode":3052,
    "place_name":"Melbourne University",
    "state_name":"Victoria"
  },
  {
    "postcode":3053,
    "place_name":"Carlton",
    "state_name":"Victoria"
  },
  {
    "postcode":3053,
    "place_name":"Carlton South",
    "state_name":"Victoria"
  },
  {
    "postcode":3054,
    "place_name":"Princes Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3054,
    "place_name":"Carlton North",
    "state_name":"Victoria"
  },
  {
    "postcode":3055,
    "place_name":"Brunswick South",
    "state_name":"Victoria"
  },
  {
    "postcode":3055,
    "place_name":"Brunswick West",
    "state_name":"Victoria"
  },
  {
    "postcode":3055,
    "place_name":"Moreland West",
    "state_name":"Victoria"
  },
  {
    "postcode":3055,
    "place_name":"Moonee Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3056,
    "place_name":"Brunswick",
    "state_name":"Victoria"
  },
  {
    "postcode":3056,
    "place_name":"Brunswick North",
    "state_name":"Victoria"
  },
  {
    "postcode":3056,
    "place_name":"Brunswick Lower",
    "state_name":"Victoria"
  },
  {
    "postcode":3057,
    "place_name":"Sumner",
    "state_name":"Victoria"
  },
  {
    "postcode":3057,
    "place_name":"Brunswick East",
    "state_name":"Victoria"
  },
  {
    "postcode":3058,
    "place_name":"Coburg North",
    "state_name":"Victoria"
  },
  {
    "postcode":3058,
    "place_name":"Moreland",
    "state_name":"Victoria"
  },
  {
    "postcode":3058,
    "place_name":"Batman",
    "state_name":"Victoria"
  },
  {
    "postcode":3058,
    "place_name":"Merlynston",
    "state_name":"Victoria"
  },
  {
    "postcode":3058,
    "place_name":"Coburg",
    "state_name":"Victoria"
  },
  {
    "postcode":3059,
    "place_name":"Greenvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3060,
    "place_name":"Fawkner",
    "state_name":"Victoria"
  },
  {
    "postcode":3061,
    "place_name":"Campbellfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3062,
    "place_name":"Somerton",
    "state_name":"Victoria"
  },
  {
    "postcode":3063,
    "place_name":"Yuroke",
    "state_name":"Victoria"
  },
  {
    "postcode":3063,
    "place_name":"Oaklands Junction",
    "state_name":"Victoria"
  },
  {
    "postcode":3064,
    "place_name":"Kalkallo",
    "state_name":"Victoria"
  },
  {
    "postcode":3064,
    "place_name":"Mickleham",
    "state_name":"Victoria"
  },
  {
    "postcode":3064,
    "place_name":"Donnybrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3064,
    "place_name":"Roxburgh Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3064,
    "place_name":"Craigieburn",
    "state_name":"Victoria"
  },
  {
    "postcode":3065,
    "place_name":"Fitzroy",
    "state_name":"Victoria"
  },
  {
    "postcode":3066,
    "place_name":"Collingwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3066,
    "place_name":"Collingwood North",
    "state_name":"Victoria"
  },
  {
    "postcode":3067,
    "place_name":"Abbotsford",
    "state_name":"Victoria"
  },
  {
    "postcode":3068,
    "place_name":"Fitzroy North",
    "state_name":"Victoria"
  },
  {
    "postcode":3068,
    "place_name":"Clifton Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3070,
    "place_name":"Northcote South",
    "state_name":"Victoria"
  },
  {
    "postcode":3070,
    "place_name":"Northcote",
    "state_name":"Victoria"
  },
  {
    "postcode":3071,
    "place_name":"Thornbury",
    "state_name":"Victoria"
  },
  {
    "postcode":3072,
    "place_name":"Preston",
    "state_name":"Victoria"
  },
  {
    "postcode":3072,
    "place_name":"Regent West",
    "state_name":"Victoria"
  },
  {
    "postcode":3072,
    "place_name":"Gilberton",
    "state_name":"Victoria"
  },
  {
    "postcode":3072,
    "place_name":"Preston South",
    "state_name":"Victoria"
  },
  {
    "postcode":3072,
    "place_name":"Preston West",
    "state_name":"Victoria"
  },
  {
    "postcode":3072,
    "place_name":"Northland Centre",
    "state_name":"Victoria"
  },
  {
    "postcode":3072,
    "place_name":"Preston Lower",
    "state_name":"Victoria"
  },
  {
    "postcode":3073,
    "place_name":"Reservoir",
    "state_name":"Victoria"
  },
  {
    "postcode":3073,
    "place_name":"Keon Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3074,
    "place_name":"Thomastown",
    "state_name":"Victoria"
  },
  {
    "postcode":3075,
    "place_name":"Lalor",
    "state_name":"Victoria"
  },
  {
    "postcode":3076,
    "place_name":"Epping Dc",
    "state_name":"Victoria"
  },
  {
    "postcode":3076,
    "place_name":"Epping",
    "state_name":"Victoria"
  },
  {
    "postcode":3078,
    "place_name":"Alphington",
    "state_name":"Victoria"
  },
  {
    "postcode":3078,
    "place_name":"Fairfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3079,
    "place_name":"Ivanhoe",
    "state_name":"Victoria"
  },
  {
    "postcode":3079,
    "place_name":"Ivanhoe East",
    "state_name":"Victoria"
  },
  {
    "postcode":3079,
    "place_name":"Ivanhoe North",
    "state_name":"Victoria"
  },
  {
    "postcode":3081,
    "place_name":"Heidelberg West",
    "state_name":"Victoria"
  },
  {
    "postcode":3081,
    "place_name":"Heidelberg Rgh",
    "state_name":"Victoria"
  },
  {
    "postcode":3081,
    "place_name":"Bellfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3081,
    "place_name":"Heidelberg Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3082,
    "place_name":"Mill Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3083,
    "place_name":"Kingsbury",
    "state_name":"Victoria"
  },
  {
    "postcode":3083,
    "place_name":"Bundoora",
    "state_name":"Victoria"
  },
  {
    "postcode":3083,
    "place_name":"La Trobe University",
    "state_name":"Victoria"
  },
  {
    "postcode":3084,
    "place_name":"Viewbank",
    "state_name":"Victoria"
  },
  {
    "postcode":3084,
    "place_name":"Banyule",
    "state_name":"Victoria"
  },
  {
    "postcode":3084,
    "place_name":"Rosanna",
    "state_name":"Victoria"
  },
  {
    "postcode":3084,
    "place_name":"Heidelberg",
    "state_name":"Victoria"
  },
  {
    "postcode":3084,
    "place_name":"Eaglemont",
    "state_name":"Victoria"
  },
  {
    "postcode":3085,
    "place_name":"Yallambie",
    "state_name":"Victoria"
  },
  {
    "postcode":3085,
    "place_name":"Macleod West",
    "state_name":"Victoria"
  },
  {
    "postcode":3085,
    "place_name":"Macleod",
    "state_name":"Victoria"
  },
  {
    "postcode":3086,
    "place_name":"La Trobe University",
    "state_name":"Victoria"
  },
  {
    "postcode":3087,
    "place_name":"Watsonia North",
    "state_name":"Victoria"
  },
  {
    "postcode":3087,
    "place_name":"Watsonia",
    "state_name":"Victoria"
  },
  {
    "postcode":3088,
    "place_name":"Saint Helena",
    "state_name":"Victoria"
  },
  {
    "postcode":3088,
    "place_name":"Briar Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3088,
    "place_name":"Greensborough",
    "state_name":"Victoria"
  },
  {
    "postcode":3088,
    "place_name":"St Helena",
    "state_name":"Victoria"
  },
  {
    "postcode":3089,
    "place_name":"Diamond Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3090,
    "place_name":"Plenty",
    "state_name":"Victoria"
  },
  {
    "postcode":3091,
    "place_name":"Yarrambat",
    "state_name":"Victoria"
  },
  {
    "postcode":3093,
    "place_name":"Lower Plenty",
    "state_name":"Victoria"
  },
  {
    "postcode":3094,
    "place_name":"Montmorency",
    "state_name":"Victoria"
  },
  {
    "postcode":3095,
    "place_name":"Research",
    "state_name":"Victoria"
  },
  {
    "postcode":3095,
    "place_name":"Eltham",
    "state_name":"Victoria"
  },
  {
    "postcode":3095,
    "place_name":"Eltham North",
    "state_name":"Victoria"
  },
  {
    "postcode":3096,
    "place_name":"Wattle Glen",
    "state_name":"Victoria"
  },
  {
    "postcode":3097,
    "place_name":"Bend Of Islands",
    "state_name":"Victoria"
  },
  {
    "postcode":3097,
    "place_name":"Kangaroo Ground",
    "state_name":"Victoria"
  },
  {
    "postcode":3097,
    "place_name":"Watsons Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3099,
    "place_name":"Strathewen",
    "state_name":"Victoria"
  },
  {
    "postcode":3099,
    "place_name":"Hurstbridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3099,
    "place_name":"Arthurs Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3099,
    "place_name":"Cottles Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3099,
    "place_name":"Nutfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3101,
    "place_name":"Kew",
    "state_name":"Victoria"
  },
  {
    "postcode":3101,
    "place_name":"Cotham",
    "state_name":"Victoria"
  },
  {
    "postcode":3102,
    "place_name":"Kew East",
    "state_name":"Victoria"
  },
  {
    "postcode":3103,
    "place_name":"Balwyn",
    "state_name":"Victoria"
  },
  {
    "postcode":3103,
    "place_name":"Stradbroke Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3103,
    "place_name":"Deepdene",
    "state_name":"Victoria"
  },
  {
    "postcode":3103,
    "place_name":"Balwyn East",
    "state_name":"Victoria"
  },
  {
    "postcode":3104,
    "place_name":"Balwyn North",
    "state_name":"Victoria"
  },
  {
    "postcode":3104,
    "place_name":"Greythorn",
    "state_name":"Victoria"
  },
  {
    "postcode":3105,
    "place_name":"Bulleen",
    "state_name":"Victoria"
  },
  {
    "postcode":3106,
    "place_name":"Templestowe",
    "state_name":"Victoria"
  },
  {
    "postcode":3107,
    "place_name":"Templestowe Lower",
    "state_name":"Victoria"
  },
  {
    "postcode":3108,
    "place_name":"Doncaster",
    "state_name":"Victoria"
  },
  {
    "postcode":3109,
    "place_name":"Tunstall Square Po",
    "state_name":"Victoria"
  },
  {
    "postcode":3109,
    "place_name":"Doncaster East",
    "state_name":"Victoria"
  },
  {
    "postcode":3109,
    "place_name":"Doncaster Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3110,
    "place_name":"Nunawading Bc",
    "state_name":"Victoria"
  },
  {
    "postcode":3111,
    "place_name":"Donvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3113,
    "place_name":"Warrandyte",
    "state_name":"Victoria"
  },
  {
    "postcode":3113,
    "place_name":"North Warrandyte",
    "state_name":"Victoria"
  },
  {
    "postcode":3114,
    "place_name":"Park Orchards",
    "state_name":"Victoria"
  },
  {
    "postcode":3115,
    "place_name":"Wonga Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3116,
    "place_name":"Chirnside Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3121,
    "place_name":"Burnley",
    "state_name":"Victoria"
  },
  {
    "postcode":3121,
    "place_name":"Cremorne",
    "state_name":"Victoria"
  },
  {
    "postcode":3121,
    "place_name":"Richmond",
    "state_name":"Victoria"
  },
  {
    "postcode":3121,
    "place_name":"Richmond East",
    "state_name":"Victoria"
  },
  {
    "postcode":3121,
    "place_name":"Burnley North",
    "state_name":"Victoria"
  },
  {
    "postcode":3121,
    "place_name":"Richmond South",
    "state_name":"Victoria"
  },
  {
    "postcode":3121,
    "place_name":"Richmond North",
    "state_name":"Victoria"
  },
  {
    "postcode":3122,
    "place_name":"Glenferrie South",
    "state_name":"Victoria"
  },
  {
    "postcode":3122,
    "place_name":"Auburn South",
    "state_name":"Victoria"
  },
  {
    "postcode":3122,
    "place_name":"Hawthorn",
    "state_name":"Victoria"
  },
  {
    "postcode":3122,
    "place_name":"Hawthorn North",
    "state_name":"Victoria"
  },
  {
    "postcode":3122,
    "place_name":"Hawthorn West",
    "state_name":"Victoria"
  },
  {
    "postcode":3123,
    "place_name":"Auburn",
    "state_name":"Victoria"
  },
  {
    "postcode":3123,
    "place_name":"Hawthorn East",
    "state_name":"Victoria"
  },
  {
    "postcode":3124,
    "place_name":"Camberwell North",
    "state_name":"Victoria"
  },
  {
    "postcode":3124,
    "place_name":"Camberwell",
    "state_name":"Victoria"
  },
  {
    "postcode":3124,
    "place_name":"Camberwell West",
    "state_name":"Victoria"
  },
  {
    "postcode":3124,
    "place_name":"Camberwell South",
    "state_name":"Victoria"
  },
  {
    "postcode":3124,
    "place_name":"Hartwell",
    "state_name":"Victoria"
  },
  {
    "postcode":3124,
    "place_name":"Middle Camberwell",
    "state_name":"Victoria"
  },
  {
    "postcode":3125,
    "place_name":"Burwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3125,
    "place_name":"Surrey Hills South",
    "state_name":"Victoria"
  },
  {
    "postcode":3125,
    "place_name":"Bennettswood",
    "state_name":"Victoria"
  },
  {
    "postcode":3126,
    "place_name":"Canterbury",
    "state_name":"Victoria"
  },
  {
    "postcode":3126,
    "place_name":"Camberwell East",
    "state_name":"Victoria"
  },
  {
    "postcode":3127,
    "place_name":"Surrey Hills",
    "state_name":"Victoria"
  },
  {
    "postcode":3127,
    "place_name":"Surrey Hills North",
    "state_name":"Victoria"
  },
  {
    "postcode":3127,
    "place_name":"Mont Albert",
    "state_name":"Victoria"
  },
  {
    "postcode":3128,
    "place_name":"Box Hill South",
    "state_name":"Victoria"
  },
  {
    "postcode":3128,
    "place_name":"Box Hill Central",
    "state_name":"Victoria"
  },
  {
    "postcode":3128,
    "place_name":"Box Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3128,
    "place_name":"Wattle Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3128,
    "place_name":"Houston",
    "state_name":"Victoria"
  },
  {
    "postcode":3129,
    "place_name":"Box Hill North",
    "state_name":"Victoria"
  },
  {
    "postcode":3129,
    "place_name":"Kerrimuir",
    "state_name":"Victoria"
  },
  {
    "postcode":3129,
    "place_name":"Mont Albert North",
    "state_name":"Victoria"
  },
  {
    "postcode":3130,
    "place_name":"Blackburn North",
    "state_name":"Victoria"
  },
  {
    "postcode":3130,
    "place_name":"Blackburn South",
    "state_name":"Victoria"
  },
  {
    "postcode":3130,
    "place_name":"Blackburn",
    "state_name":"Victoria"
  },
  {
    "postcode":3130,
    "place_name":"Laburnum",
    "state_name":"Victoria"
  },
  {
    "postcode":3131,
    "place_name":"Forest Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3131,
    "place_name":"Brentford Square",
    "state_name":"Victoria"
  },
  {
    "postcode":3131,
    "place_name":"Nunawading",
    "state_name":"Victoria"
  },
  {
    "postcode":3132,
    "place_name":"Mitcham North",
    "state_name":"Victoria"
  },
  {
    "postcode":3132,
    "place_name":"Mitcham",
    "state_name":"Victoria"
  },
  {
    "postcode":3132,
    "place_name":"Rangeview",
    "state_name":"Victoria"
  },
  {
    "postcode":3133,
    "place_name":"Vermont",
    "state_name":"Victoria"
  },
  {
    "postcode":3133,
    "place_name":"Vermont South",
    "state_name":"Victoria"
  },
  {
    "postcode":3134,
    "place_name":"Warrandyte South",
    "state_name":"Victoria"
  },
  {
    "postcode":3134,
    "place_name":"Heathwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3134,
    "place_name":"Warranwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3134,
    "place_name":"Ringwood North",
    "state_name":"Victoria"
  },
  {
    "postcode":3134,
    "place_name":"Ringwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3135,
    "place_name":"Bedford Road",
    "state_name":"Victoria"
  },
  {
    "postcode":3135,
    "place_name":"Ringwood East",
    "state_name":"Victoria"
  },
  {
    "postcode":3135,
    "place_name":"Heathmont",
    "state_name":"Victoria"
  },
  {
    "postcode":3136,
    "place_name":"Croydon North",
    "state_name":"Victoria"
  },
  {
    "postcode":3136,
    "place_name":"Croydon South",
    "state_name":"Victoria"
  },
  {
    "postcode":3136,
    "place_name":"Croydon Hills",
    "state_name":"Victoria"
  },
  {
    "postcode":3136,
    "place_name":"Croydon",
    "state_name":"Victoria"
  },
  {
    "postcode":3137,
    "place_name":"Kilsyth",
    "state_name":"Victoria"
  },
  {
    "postcode":3137,
    "place_name":"Kilsyth South",
    "state_name":"Victoria"
  },
  {
    "postcode":3138,
    "place_name":"Mooroolbark",
    "state_name":"Victoria"
  },
  {
    "postcode":3139,
    "place_name":"Hoddles Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3139,
    "place_name":"Beenak",
    "state_name":"Victoria"
  },
  {
    "postcode":3139,
    "place_name":"Don Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3139,
    "place_name":"Seville",
    "state_name":"Victoria"
  },
  {
    "postcode":3139,
    "place_name":"Woori Yallock",
    "state_name":"Victoria"
  },
  {
    "postcode":3139,
    "place_name":"Yellingbo",
    "state_name":"Victoria"
  },
  {
    "postcode":3139,
    "place_name":"Wandin North",
    "state_name":"Victoria"
  },
  {
    "postcode":3139,
    "place_name":"Launching Place",
    "state_name":"Victoria"
  },
  {
    "postcode":3139,
    "place_name":"Seville East",
    "state_name":"Victoria"
  },
  {
    "postcode":3139,
    "place_name":"Wandin East",
    "state_name":"Victoria"
  },
  {
    "postcode":3140,
    "place_name":"Lilydale",
    "state_name":"Victoria"
  },
  {
    "postcode":3141,
    "place_name":"South Yarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3142,
    "place_name":"Toorak",
    "state_name":"Victoria"
  },
  {
    "postcode":3142,
    "place_name":"Hawksburn",
    "state_name":"Victoria"
  },
  {
    "postcode":3143,
    "place_name":"Armadale",
    "state_name":"Victoria"
  },
  {
    "postcode":3143,
    "place_name":"Armadale North",
    "state_name":"Victoria"
  },
  {
    "postcode":3144,
    "place_name":"Kooyong",
    "state_name":"Victoria"
  },
  {
    "postcode":3144,
    "place_name":"Malvern",
    "state_name":"Victoria"
  },
  {
    "postcode":3144,
    "place_name":"Malvern North",
    "state_name":"Victoria"
  },
  {
    "postcode":3145,
    "place_name":"Malvern East",
    "state_name":"Victoria"
  },
  {
    "postcode":3145,
    "place_name":"Darling",
    "state_name":"Victoria"
  },
  {
    "postcode":3145,
    "place_name":"Caulfield East",
    "state_name":"Victoria"
  },
  {
    "postcode":3145,
    "place_name":"Central Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3145,
    "place_name":"Darling South",
    "state_name":"Victoria"
  },
  {
    "postcode":3145,
    "place_name":"Wattletree Road Po",
    "state_name":"Victoria"
  },
  {
    "postcode":3146,
    "place_name":"Glen Iris",
    "state_name":"Victoria"
  },
  {
    "postcode":3146,
    "place_name":"Tooronga",
    "state_name":"Victoria"
  },
  {
    "postcode":3147,
    "place_name":"Ashwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3147,
    "place_name":"Ashburton",
    "state_name":"Victoria"
  },
  {
    "postcode":3148,
    "place_name":"Jordanville",
    "state_name":"Victoria"
  },
  {
    "postcode":3148,
    "place_name":"Holmesglen",
    "state_name":"Victoria"
  },
  {
    "postcode":3148,
    "place_name":"Chadstone",
    "state_name":"Victoria"
  },
  {
    "postcode":3148,
    "place_name":"Chadstone Centre",
    "state_name":"Victoria"
  },
  {
    "postcode":3149,
    "place_name":"Syndal",
    "state_name":"Victoria"
  },
  {
    "postcode":3149,
    "place_name":"Pinewood",
    "state_name":"Victoria"
  },
  {
    "postcode":3149,
    "place_name":"Mount Waverley",
    "state_name":"Victoria"
  },
  {
    "postcode":3150,
    "place_name":"Wheelers Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3150,
    "place_name":"Brandon Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3150,
    "place_name":"Glen Waverley",
    "state_name":"Victoria"
  },
  {
    "postcode":3151,
    "place_name":"Burwood Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3151,
    "place_name":"Burwood East",
    "state_name":"Victoria"
  },
  {
    "postcode":3152,
    "place_name":"Wantirna South",
    "state_name":"Victoria"
  },
  {
    "postcode":3152,
    "place_name":"Knox City Centre",
    "state_name":"Victoria"
  },
  {
    "postcode":3152,
    "place_name":"Wantirna",
    "state_name":"Victoria"
  },
  {
    "postcode":3152,
    "place_name":"Studfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3153,
    "place_name":"Bayswater North",
    "state_name":"Victoria"
  },
  {
    "postcode":3153,
    "place_name":"Bayswater",
    "state_name":"Victoria"
  },
  {
    "postcode":3154,
    "place_name":"The Basin",
    "state_name":"Victoria"
  },
  {
    "postcode":3155,
    "place_name":"Boronia",
    "state_name":"Victoria"
  },
  {
    "postcode":3156,
    "place_name":"Lysterfield South",
    "state_name":"Victoria"
  },
  {
    "postcode":3156,
    "place_name":"Lysterfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3156,
    "place_name":"Mountain Gate",
    "state_name":"Victoria"
  },
  {
    "postcode":3156,
    "place_name":"Upper Ferntree Gully",
    "state_name":"Victoria"
  },
  {
    "postcode":3156,
    "place_name":"Ferntree Gully",
    "state_name":"Victoria"
  },
  {
    "postcode":3158,
    "place_name":"Upwey",
    "state_name":"Victoria"
  },
  {
    "postcode":3159,
    "place_name":"Menzies Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3159,
    "place_name":"Selby",
    "state_name":"Victoria"
  },
  {
    "postcode":3160,
    "place_name":"Tecoma",
    "state_name":"Victoria"
  },
  {
    "postcode":3160,
    "place_name":"Belgrave South",
    "state_name":"Victoria"
  },
  {
    "postcode":3160,
    "place_name":"Belgrave Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3160,
    "place_name":"Belgrave",
    "state_name":"Victoria"
  },
  {
    "postcode":3161,
    "place_name":"Caulfield North",
    "state_name":"Victoria"
  },
  {
    "postcode":3161,
    "place_name":"Caulfield Junction",
    "state_name":"Victoria"
  },
  {
    "postcode":3162,
    "place_name":"Caulfield South",
    "state_name":"Victoria"
  },
  {
    "postcode":3162,
    "place_name":"Hopetoun Gardens",
    "state_name":"Victoria"
  },
  {
    "postcode":3162,
    "place_name":"Caulfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3163,
    "place_name":"Glen Huntly",
    "state_name":"Victoria"
  },
  {
    "postcode":3163,
    "place_name":"Carnegie",
    "state_name":"Victoria"
  },
  {
    "postcode":3163,
    "place_name":"Booran Road Po",
    "state_name":"Victoria"
  },
  {
    "postcode":3163,
    "place_name":"Murrumbeena",
    "state_name":"Victoria"
  },
  {
    "postcode":3164,
    "place_name":"Dandenong South",
    "state_name":"Victoria"
  },
  {
    "postcode":3165,
    "place_name":"Coatesville",
    "state_name":"Victoria"
  },
  {
    "postcode":3165,
    "place_name":"Bentleigh East",
    "state_name":"Victoria"
  },
  {
    "postcode":3166,
    "place_name":"Oakleigh East",
    "state_name":"Victoria"
  },
  {
    "postcode":3166,
    "place_name":"Oakleigh",
    "state_name":"Victoria"
  },
  {
    "postcode":3166,
    "place_name":"Huntingdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3166,
    "place_name":"Hughesdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3167,
    "place_name":"Oakleigh South",
    "state_name":"Victoria"
  },
  {
    "postcode":3168,
    "place_name":"Notting Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3168,
    "place_name":"Clayton",
    "state_name":"Victoria"
  },
  {
    "postcode":3169,
    "place_name":"Clarinda",
    "state_name":"Victoria"
  },
  {
    "postcode":3169,
    "place_name":"Clayton South",
    "state_name":"Victoria"
  },
  {
    "postcode":3170,
    "place_name":"Waverley Gardens",
    "state_name":"Victoria"
  },
  {
    "postcode":3170,
    "place_name":"Mulgrave",
    "state_name":"Victoria"
  },
  {
    "postcode":3171,
    "place_name":"Sandown Village",
    "state_name":"Victoria"
  },
  {
    "postcode":3171,
    "place_name":"Springvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3172,
    "place_name":"Springvale South",
    "state_name":"Victoria"
  },
  {
    "postcode":3172,
    "place_name":"Dingley Village",
    "state_name":"Victoria"
  },
  {
    "postcode":3173,
    "place_name":"Keysborough",
    "state_name":"Victoria"
  },
  {
    "postcode":3174,
    "place_name":"Noble Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3174,
    "place_name":"Noble Park North",
    "state_name":"Victoria"
  },
  {
    "postcode":3175,
    "place_name":"Dandenong East",
    "state_name":"Victoria"
  },
  {
    "postcode":3175,
    "place_name":"Dunearn",
    "state_name":"Victoria"
  },
  {
    "postcode":3175,
    "place_name":"Dandenong South",
    "state_name":"Victoria"
  },
  {
    "postcode":3175,
    "place_name":"Dandenong North",
    "state_name":"Victoria"
  },
  {
    "postcode":3175,
    "place_name":"Dandenong",
    "state_name":"Victoria"
  },
  {
    "postcode":3175,
    "place_name":"Bangholme",
    "state_name":"Victoria"
  },
  {
    "postcode":3176,
    "place_name":"Scoresby Bc",
    "state_name":"Victoria"
  },
  {
    "postcode":3177,
    "place_name":"Doveton",
    "state_name":"Victoria"
  },
  {
    "postcode":3177,
    "place_name":"Eumemmerring",
    "state_name":"Victoria"
  },
  {
    "postcode":3178,
    "place_name":"Rowville",
    "state_name":"Victoria"
  },
  {
    "postcode":3179,
    "place_name":"Scoresby",
    "state_name":"Victoria"
  },
  {
    "postcode":3180,
    "place_name":"Knoxfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3181,
    "place_name":"Prahran",
    "state_name":"Victoria"
  },
  {
    "postcode":3181,
    "place_name":"Windsor",
    "state_name":"Victoria"
  },
  {
    "postcode":3181,
    "place_name":"Prahran East",
    "state_name":"Victoria"
  },
  {
    "postcode":3182,
    "place_name":"St Kilda West",
    "state_name":"Victoria"
  },
  {
    "postcode":3182,
    "place_name":"St Kilda South",
    "state_name":"Victoria"
  },
  {
    "postcode":3182,
    "place_name":"St Kilda",
    "state_name":"Victoria"
  },
  {
    "postcode":3183,
    "place_name":"St Kilda East",
    "state_name":"Victoria"
  },
  {
    "postcode":3183,
    "place_name":"Balaclava",
    "state_name":"Victoria"
  },
  {
    "postcode":3184,
    "place_name":"Elwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3184,
    "place_name":"Brighton Road",
    "state_name":"Victoria"
  },
  {
    "postcode":3185,
    "place_name":"Elsternwick",
    "state_name":"Victoria"
  },
  {
    "postcode":3185,
    "place_name":"Gardenvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3185,
    "place_name":"Ripponlea",
    "state_name":"Victoria"
  },
  {
    "postcode":3186,
    "place_name":"Dendy",
    "state_name":"Victoria"
  },
  {
    "postcode":3186,
    "place_name":"Brighton",
    "state_name":"Victoria"
  },
  {
    "postcode":3186,
    "place_name":"Brighton North",
    "state_name":"Victoria"
  },
  {
    "postcode":3186,
    "place_name":"Were Street Po",
    "state_name":"Victoria"
  },
  {
    "postcode":3187,
    "place_name":"North Road",
    "state_name":"Victoria"
  },
  {
    "postcode":3187,
    "place_name":"Brighton East",
    "state_name":"Victoria"
  },
  {
    "postcode":3188,
    "place_name":"Hampton",
    "state_name":"Victoria"
  },
  {
    "postcode":3188,
    "place_name":"Hampton East",
    "state_name":"Victoria"
  },
  {
    "postcode":3188,
    "place_name":"Hampton North",
    "state_name":"Victoria"
  },
  {
    "postcode":3189,
    "place_name":"Moorabbin",
    "state_name":"Victoria"
  },
  {
    "postcode":3189,
    "place_name":"Moorabbin East",
    "state_name":"Victoria"
  },
  {
    "postcode":3189,
    "place_name":"Wishart",
    "state_name":"Victoria"
  },
  {
    "postcode":3190,
    "place_name":"Highett",
    "state_name":"Victoria"
  },
  {
    "postcode":3191,
    "place_name":"Sandringham",
    "state_name":"Victoria"
  },
  {
    "postcode":3192,
    "place_name":"Cheltenham",
    "state_name":"Victoria"
  },
  {
    "postcode":3192,
    "place_name":"Cheltenham East",
    "state_name":"Victoria"
  },
  {
    "postcode":3192,
    "place_name":"Southland Centre",
    "state_name":"Victoria"
  },
  {
    "postcode":3193,
    "place_name":"Beaumaris",
    "state_name":"Victoria"
  },
  {
    "postcode":3193,
    "place_name":"Black Rock North",
    "state_name":"Victoria"
  },
  {
    "postcode":3193,
    "place_name":"Black Rock",
    "state_name":"Victoria"
  },
  {
    "postcode":3193,
    "place_name":"Cromer",
    "state_name":"Victoria"
  },
  {
    "postcode":3194,
    "place_name":"Mentone",
    "state_name":"Victoria"
  },
  {
    "postcode":3194,
    "place_name":"Mentone East",
    "state_name":"Victoria"
  },
  {
    "postcode":3194,
    "place_name":"Moorabbin Airport",
    "state_name":"Victoria"
  },
  {
    "postcode":3195,
    "place_name":"Braeside",
    "state_name":"Victoria"
  },
  {
    "postcode":3195,
    "place_name":"Mordialloc",
    "state_name":"Victoria"
  },
  {
    "postcode":3195,
    "place_name":"Waterways",
    "state_name":"Victoria"
  },
  {
    "postcode":3195,
    "place_name":"Aspendale Gardens",
    "state_name":"Victoria"
  },
  {
    "postcode":3195,
    "place_name":"Parkdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3195,
    "place_name":"Aspendale",
    "state_name":"Victoria"
  },
  {
    "postcode":3196,
    "place_name":"Chelsea Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3196,
    "place_name":"Edithvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3196,
    "place_name":"Bonbeach",
    "state_name":"Victoria"
  },
  {
    "postcode":3196,
    "place_name":"Chelsea",
    "state_name":"Victoria"
  },
  {
    "postcode":3197,
    "place_name":"Carrum",
    "state_name":"Victoria"
  },
  {
    "postcode":3197,
    "place_name":"Patterson Lakes",
    "state_name":"Victoria"
  },
  {
    "postcode":3198,
    "place_name":"Belvedere Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3198,
    "place_name":"Seaford",
    "state_name":"Victoria"
  },
  {
    "postcode":3199,
    "place_name":"Karingal Centre",
    "state_name":"Victoria"
  },
  {
    "postcode":3199,
    "place_name":"Frankston South",
    "state_name":"Victoria"
  },
  {
    "postcode":3199,
    "place_name":"Frankston East",
    "state_name":"Victoria"
  },
  {
    "postcode":3199,
    "place_name":"Frankston",
    "state_name":"Victoria"
  },
  {
    "postcode":3199,
    "place_name":"Frankston Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3199,
    "place_name":"Karingal",
    "state_name":"Victoria"
  },
  {
    "postcode":3200,
    "place_name":"Frankston North",
    "state_name":"Victoria"
  },
  {
    "postcode":3200,
    "place_name":"Pines Forest",
    "state_name":"Victoria"
  },
  {
    "postcode":3201,
    "place_name":"Carrum Downs",
    "state_name":"Victoria"
  },
  {
    "postcode":3202,
    "place_name":"Heatherton",
    "state_name":"Victoria"
  },
  {
    "postcode":3204,
    "place_name":"Ormond",
    "state_name":"Victoria"
  },
  {
    "postcode":3204,
    "place_name":"Patterson",
    "state_name":"Victoria"
  },
  {
    "postcode":3204,
    "place_name":"Bentleigh",
    "state_name":"Victoria"
  },
  {
    "postcode":3204,
    "place_name":"Mckinnon",
    "state_name":"Victoria"
  },
  {
    "postcode":3205,
    "place_name":"South Melbourne Dc",
    "state_name":"Victoria"
  },
  {
    "postcode":3205,
    "place_name":"South Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3206,
    "place_name":"Albert Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3206,
    "place_name":"Middle Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3207,
    "place_name":"Garden City",
    "state_name":"Victoria"
  },
  {
    "postcode":3207,
    "place_name":"Port Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3211,
    "place_name":"Little River",
    "state_name":"Victoria"
  },
  {
    "postcode":3212,
    "place_name":"Avalon",
    "state_name":"Victoria"
  },
  {
    "postcode":3212,
    "place_name":"Lara",
    "state_name":"Victoria"
  },
  {
    "postcode":3212,
    "place_name":"Point Wilson",
    "state_name":"Victoria"
  },
  {
    "postcode":3213,
    "place_name":"Anakie",
    "state_name":"Victoria"
  },
  {
    "postcode":3213,
    "place_name":"Moorabool",
    "state_name":"Victoria"
  },
  {
    "postcode":3213,
    "place_name":"Lovely Banks",
    "state_name":"Victoria"
  },
  {
    "postcode":3213,
    "place_name":"Batesford",
    "state_name":"Victoria"
  },
  {
    "postcode":3214,
    "place_name":"Norlane",
    "state_name":"Victoria"
  },
  {
    "postcode":3214,
    "place_name":"North Shore",
    "state_name":"Victoria"
  },
  {
    "postcode":3214,
    "place_name":"Corio",
    "state_name":"Victoria"
  },
  {
    "postcode":3215,
    "place_name":"Geelong North",
    "state_name":"Victoria"
  },
  {
    "postcode":3215,
    "place_name":"Bell Post Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3215,
    "place_name":"North Geelong",
    "state_name":"Victoria"
  },
  {
    "postcode":3215,
    "place_name":"Rippleside",
    "state_name":"Victoria"
  },
  {
    "postcode":3215,
    "place_name":"Hamlyn Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3215,
    "place_name":"Drumcondra",
    "state_name":"Victoria"
  },
  {
    "postcode":3215,
    "place_name":"Bell Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3216,
    "place_name":"Highton",
    "state_name":"Victoria"
  },
  {
    "postcode":3216,
    "place_name":"Belmont",
    "state_name":"Victoria"
  },
  {
    "postcode":3216,
    "place_name":"Freshwater Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3216,
    "place_name":"Grovedale East",
    "state_name":"Victoria"
  },
  {
    "postcode":3216,
    "place_name":"Mount Duneed",
    "state_name":"Victoria"
  },
  {
    "postcode":3216,
    "place_name":"Marshall",
    "state_name":"Victoria"
  },
  {
    "postcode":3216,
    "place_name":"Wandana Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3216,
    "place_name":"Grovedale",
    "state_name":"Victoria"
  },
  {
    "postcode":3216,
    "place_name":"Waurn Ponds",
    "state_name":"Victoria"
  },
  {
    "postcode":3217,
    "place_name":"Deakin University",
    "state_name":"Victoria"
  },
  {
    "postcode":3217,
    "place_name":"Mount Duneed",
    "state_name":"Victoria"
  },
  {
    "postcode":3217,
    "place_name":"Freshwater Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3217,
    "place_name":"Charlemont",
    "state_name":"Victoria"
  },
  {
    "postcode":3217,
    "place_name":"Armstrong Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3218,
    "place_name":"Fyansford",
    "state_name":"Victoria"
  },
  {
    "postcode":3218,
    "place_name":"Stonehaven",
    "state_name":"Victoria"
  },
  {
    "postcode":3218,
    "place_name":"Geelong West",
    "state_name":"Victoria"
  },
  {
    "postcode":3218,
    "place_name":"Manifold Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3218,
    "place_name":"Herne Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3218,
    "place_name":"Murgheboluc",
    "state_name":"Victoria"
  },
  {
    "postcode":3219,
    "place_name":"Thomson",
    "state_name":"Victoria"
  },
  {
    "postcode":3219,
    "place_name":"St Albans Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3219,
    "place_name":"Newcomb",
    "state_name":"Victoria"
  },
  {
    "postcode":3219,
    "place_name":"East Geelong",
    "state_name":"Victoria"
  },
  {
    "postcode":3219,
    "place_name":"Whittington",
    "state_name":"Victoria"
  },
  {
    "postcode":3219,
    "place_name":"Breakwater",
    "state_name":"Victoria"
  },
  {
    "postcode":3220,
    "place_name":"South Geelong",
    "state_name":"Victoria"
  },
  {
    "postcode":3220,
    "place_name":"Bareena",
    "state_name":"Victoria"
  },
  {
    "postcode":3220,
    "place_name":"Newtown",
    "state_name":"Victoria"
  },
  {
    "postcode":3220,
    "place_name":"Geelong",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Murgheboluc",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Fyansford",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Stonehaven",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Batesford",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Gnarwarre",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Moolap",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Bellarine",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Geelong Mc",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Ceres",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Staughton Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Wongarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Moorabool",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Anakie",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Barrabool",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Kennett River",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Wye River",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Wallington",
    "state_name":"Victoria"
  },
  {
    "postcode":3221,
    "place_name":"Lovely Banks",
    "state_name":"Victoria"
  },
  {
    "postcode":3222,
    "place_name":"Mannerim",
    "state_name":"Victoria"
  },
  {
    "postcode":3222,
    "place_name":"Drysdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3222,
    "place_name":"Marcus Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3222,
    "place_name":"Clifton Springs",
    "state_name":"Victoria"
  },
  {
    "postcode":3222,
    "place_name":"Curlewis",
    "state_name":"Victoria"
  },
  {
    "postcode":3222,
    "place_name":"Wallington",
    "state_name":"Victoria"
  },
  {
    "postcode":3223,
    "place_name":"St Leonards",
    "state_name":"Victoria"
  },
  {
    "postcode":3223,
    "place_name":"Indented Head",
    "state_name":"Victoria"
  },
  {
    "postcode":3223,
    "place_name":"Bellarine",
    "state_name":"Victoria"
  },
  {
    "postcode":3223,
    "place_name":"Portarlington",
    "state_name":"Victoria"
  },
  {
    "postcode":3224,
    "place_name":"Leopold",
    "state_name":"Victoria"
  },
  {
    "postcode":3224,
    "place_name":"Moolap",
    "state_name":"Victoria"
  },
  {
    "postcode":3225,
    "place_name":"Point Lonsdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3225,
    "place_name":"Queenscliff",
    "state_name":"Victoria"
  },
  {
    "postcode":3225,
    "place_name":"Swan Island",
    "state_name":"Victoria"
  },
  {
    "postcode":3225,
    "place_name":"Swan Bay",
    "state_name":"Victoria"
  },
  {
    "postcode":3226,
    "place_name":"Ocean Grove",
    "state_name":"Victoria"
  },
  {
    "postcode":3227,
    "place_name":"Connewarre",
    "state_name":"Victoria"
  },
  {
    "postcode":3227,
    "place_name":"Breamlea",
    "state_name":"Victoria"
  },
  {
    "postcode":3227,
    "place_name":"Barwon Heads",
    "state_name":"Victoria"
  },
  {
    "postcode":3228,
    "place_name":"Bellbrae",
    "state_name":"Victoria"
  },
  {
    "postcode":3228,
    "place_name":"Torquay",
    "state_name":"Victoria"
  },
  {
    "postcode":3228,
    "place_name":"Bells Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3228,
    "place_name":"Jan Juc",
    "state_name":"Victoria"
  },
  {
    "postcode":3230,
    "place_name":"Anglesea",
    "state_name":"Victoria"
  },
  {
    "postcode":3231,
    "place_name":"Aireys Inlet",
    "state_name":"Victoria"
  },
  {
    "postcode":3231,
    "place_name":"Eastern View",
    "state_name":"Victoria"
  },
  {
    "postcode":3231,
    "place_name":"Fairhaven",
    "state_name":"Victoria"
  },
  {
    "postcode":3231,
    "place_name":"Big Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3231,
    "place_name":"Moggs Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3232,
    "place_name":"Lorne",
    "state_name":"Victoria"
  },
  {
    "postcode":3233,
    "place_name":"Apollo Bay",
    "state_name":"Victoria"
  },
  {
    "postcode":3233,
    "place_name":"Cape Otway",
    "state_name":"Victoria"
  },
  {
    "postcode":3233,
    "place_name":"Skenes Creek North",
    "state_name":"Victoria"
  },
  {
    "postcode":3233,
    "place_name":"Marengo",
    "state_name":"Victoria"
  },
  {
    "postcode":3233,
    "place_name":"Petticoat Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3233,
    "place_name":"Skenes Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3234,
    "place_name":"Grey River",
    "state_name":"Victoria"
  },
  {
    "postcode":3234,
    "place_name":"Wye River",
    "state_name":"Victoria"
  },
  {
    "postcode":3234,
    "place_name":"Wongarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3234,
    "place_name":"Separation Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3234,
    "place_name":"Sugarloaf",
    "state_name":"Victoria"
  },
  {
    "postcode":3234,
    "place_name":"Kennett River",
    "state_name":"Victoria"
  },
  {
    "postcode":3235,
    "place_name":"Deans Marsh",
    "state_name":"Victoria"
  },
  {
    "postcode":3235,
    "place_name":"Boonah",
    "state_name":"Victoria"
  },
  {
    "postcode":3235,
    "place_name":"Pennyroyal",
    "state_name":"Victoria"
  },
  {
    "postcode":3235,
    "place_name":"Benwerrin",
    "state_name":"Victoria"
  },
  {
    "postcode":3236,
    "place_name":"Mount Sabine",
    "state_name":"Victoria"
  },
  {
    "postcode":3236,
    "place_name":"Forrest",
    "state_name":"Victoria"
  },
  {
    "postcode":3237,
    "place_name":"Beech Forest",
    "state_name":"Victoria"
  },
  {
    "postcode":3237,
    "place_name":"Wattle Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3237,
    "place_name":"Aire Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3237,
    "place_name":"Wyelangta",
    "state_name":"Victoria"
  },
  {
    "postcode":3237,
    "place_name":"Ferguson",
    "state_name":"Victoria"
  },
  {
    "postcode":3237,
    "place_name":"Gellibrand Lower",
    "state_name":"Victoria"
  },
  {
    "postcode":3237,
    "place_name":"Yuulong",
    "state_name":"Victoria"
  },
  {
    "postcode":3237,
    "place_name":"Weeaproinah",
    "state_name":"Victoria"
  },
  {
    "postcode":3238,
    "place_name":"Johanna",
    "state_name":"Victoria"
  },
  {
    "postcode":3238,
    "place_name":"Lavers Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3238,
    "place_name":"Hordern Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3238,
    "place_name":"Glenaire",
    "state_name":"Victoria"
  },
  {
    "postcode":3239,
    "place_name":"Chapple Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3239,
    "place_name":"Carlisle River",
    "state_name":"Victoria"
  },
  {
    "postcode":3239,
    "place_name":"Kennedys Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3239,
    "place_name":"Gellibrand",
    "state_name":"Victoria"
  },
  {
    "postcode":3240,
    "place_name":"Moriac",
    "state_name":"Victoria"
  },
  {
    "postcode":3240,
    "place_name":"Modewarre",
    "state_name":"Victoria"
  },
  {
    "postcode":3240,
    "place_name":"Buckley",
    "state_name":"Victoria"
  },
  {
    "postcode":3240,
    "place_name":"Mount Moriac",
    "state_name":"Victoria"
  },
  {
    "postcode":3240,
    "place_name":"Paraparap",
    "state_name":"Victoria"
  },
  {
    "postcode":3240,
    "place_name":"Gherang",
    "state_name":"Victoria"
  },
  {
    "postcode":3241,
    "place_name":"Wensleydale",
    "state_name":"Victoria"
  },
  {
    "postcode":3241,
    "place_name":"Winchelsea",
    "state_name":"Victoria"
  },
  {
    "postcode":3241,
    "place_name":"Bambra",
    "state_name":"Victoria"
  },
  {
    "postcode":3241,
    "place_name":"Ombersley",
    "state_name":"Victoria"
  },
  {
    "postcode":3241,
    "place_name":"Winchelsea South",
    "state_name":"Victoria"
  },
  {
    "postcode":3241,
    "place_name":"Wurdiboluc",
    "state_name":"Victoria"
  },
  {
    "postcode":3242,
    "place_name":"Birregurra",
    "state_name":"Victoria"
  },
  {
    "postcode":3243,
    "place_name":"Whoorel",
    "state_name":"Victoria"
  },
  {
    "postcode":3243,
    "place_name":"Murroon",
    "state_name":"Victoria"
  },
  {
    "postcode":3243,
    "place_name":"Gerangamete",
    "state_name":"Victoria"
  },
  {
    "postcode":3243,
    "place_name":"Barwon Downs",
    "state_name":"Victoria"
  },
  {
    "postcode":3243,
    "place_name":"Warncoort",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Barongarook",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Swan Marsh",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Dreeite",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Barongarook West",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Yeo",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Dreeite South",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Larpent",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Coragulac",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Irrewarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Pirron Yallock",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Tanybryn",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Pomborneit East",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Yeodene",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Corunnun",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Warrion",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Wool Wool",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Ondit",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Irrewillipe East",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Gerangamete",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Balintore",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Nalangil",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Kawarren",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Irrewillipe",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Barramunga",
    "state_name":"Victoria"
  },
  {
    "postcode":3249,
    "place_name":"Alvie",
    "state_name":"Victoria"
  },
  {
    "postcode":3250,
    "place_name":"Colac West",
    "state_name":"Victoria"
  },
  {
    "postcode":3250,
    "place_name":"Colac East",
    "state_name":"Victoria"
  },
  {
    "postcode":3250,
    "place_name":"Colac",
    "state_name":"Victoria"
  },
  {
    "postcode":3250,
    "place_name":"Elliminyt",
    "state_name":"Victoria"
  },
  {
    "postcode":3251,
    "place_name":"Cundare North",
    "state_name":"Victoria"
  },
  {
    "postcode":3251,
    "place_name":"Cundare",
    "state_name":"Victoria"
  },
  {
    "postcode":3251,
    "place_name":"Weering",
    "state_name":"Victoria"
  },
  {
    "postcode":3251,
    "place_name":"Beeac",
    "state_name":"Victoria"
  },
  {
    "postcode":3251,
    "place_name":"Eurack",
    "state_name":"Victoria"
  },
  {
    "postcode":3254,
    "place_name":"Cororooke",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Kariah",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Gnotuk",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Carpendeit",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Pomborneit North",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Bostocks Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Pomborneit",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Weerite",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Koallah",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Leslie Manor",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Camperdown",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Tandarook",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"South Purrumbete",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Tesbury",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Skibo",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Chocolyn",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Bookaar",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Bungador",
    "state_name":"Victoria"
  },
  {
    "postcode":3260,
    "place_name":"Stonyford",
    "state_name":"Victoria"
  },
  {
    "postcode":3264,
    "place_name":"Terang",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Boorcan",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Noorat East",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Kolora",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"The Sisters",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Ellerslie",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Taroon",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Dixie",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Garvoc",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Glenormiston South",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Framlingham East",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Laang",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Panmure",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Cudgee",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Noorat",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Glenormiston North",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Ecklin South",
    "state_name":"Victoria"
  },
  {
    "postcode":3265,
    "place_name":"Framlingham",
    "state_name":"Victoria"
  },
  {
    "postcode":3266,
    "place_name":"Jancourt East",
    "state_name":"Victoria"
  },
  {
    "postcode":3266,
    "place_name":"Elingamite North",
    "state_name":"Victoria"
  },
  {
    "postcode":3266,
    "place_name":"Elingamite",
    "state_name":"Victoria"
  },
  {
    "postcode":3266,
    "place_name":"Simpson",
    "state_name":"Victoria"
  },
  {
    "postcode":3266,
    "place_name":"Bullaharre",
    "state_name":"Victoria"
  },
  {
    "postcode":3266,
    "place_name":"Jancourt",
    "state_name":"Victoria"
  },
  {
    "postcode":3266,
    "place_name":"Cobrico",
    "state_name":"Victoria"
  },
  {
    "postcode":3266,
    "place_name":"Naroghid",
    "state_name":"Victoria"
  },
  {
    "postcode":3266,
    "place_name":"Glenfyne",
    "state_name":"Victoria"
  },
  {
    "postcode":3266,
    "place_name":"Cobden",
    "state_name":"Victoria"
  },
  {
    "postcode":3267,
    "place_name":"Scotts Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Nirranda",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Nullawarre",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Timboon",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Newfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Ayrford",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Brucknell",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Nirranda South",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Heytesbury Lower",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Curdie Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"The Cove",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Curdievale",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Cowleys Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Curdies River",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Cooriemungle",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Nirranda East",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Nullawarre North",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Timboon West",
    "state_name":"Victoria"
  },
  {
    "postcode":3268,
    "place_name":"Paaratte",
    "state_name":"Victoria"
  },
  {
    "postcode":3269,
    "place_name":"Princetown",
    "state_name":"Victoria"
  },
  {
    "postcode":3269,
    "place_name":"Port Campbell",
    "state_name":"Victoria"
  },
  {
    "postcode":3269,
    "place_name":"Waarre",
    "state_name":"Victoria"
  },
  {
    "postcode":3270,
    "place_name":"Peterborough",
    "state_name":"Victoria"
  },
  {
    "postcode":3271,
    "place_name":"Dundonnell",
    "state_name":"Victoria"
  },
  {
    "postcode":3271,
    "place_name":"Darlington",
    "state_name":"Victoria"
  },
  {
    "postcode":3271,
    "place_name":"Pura Pura",
    "state_name":"Victoria"
  },
  {
    "postcode":3272,
    "place_name":"Mortlake",
    "state_name":"Victoria"
  },
  {
    "postcode":3272,
    "place_name":"Woorndoo",
    "state_name":"Victoria"
  },
  {
    "postcode":3273,
    "place_name":"Hexham",
    "state_name":"Victoria"
  },
  {
    "postcode":3274,
    "place_name":"Caramut",
    "state_name":"Victoria"
  },
  {
    "postcode":3275,
    "place_name":"Mailer Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3275,
    "place_name":"Mailors Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3276,
    "place_name":"Minjah",
    "state_name":"Victoria"
  },
  {
    "postcode":3276,
    "place_name":"Woolsthorpe",
    "state_name":"Victoria"
  },
  {
    "postcode":3277,
    "place_name":"Mepunga East",
    "state_name":"Victoria"
  },
  {
    "postcode":3277,
    "place_name":"Allansford",
    "state_name":"Victoria"
  },
  {
    "postcode":3277,
    "place_name":"Naringal East",
    "state_name":"Victoria"
  },
  {
    "postcode":3277,
    "place_name":"Naringal",
    "state_name":"Victoria"
  },
  {
    "postcode":3277,
    "place_name":"Mepunga",
    "state_name":"Victoria"
  },
  {
    "postcode":3277,
    "place_name":"Mepunga West",
    "state_name":"Victoria"
  },
  {
    "postcode":3278,
    "place_name":"Purnim",
    "state_name":"Victoria"
  },
  {
    "postcode":3278,
    "place_name":"Purnim West",
    "state_name":"Victoria"
  },
  {
    "postcode":3279,
    "place_name":"Wangoom",
    "state_name":"Victoria"
  },
  {
    "postcode":3279,
    "place_name":"Ballangeich",
    "state_name":"Victoria"
  },
  {
    "postcode":3280,
    "place_name":"Warrnambool",
    "state_name":"Victoria"
  },
  {
    "postcode":3280,
    "place_name":"Dennington",
    "state_name":"Victoria"
  },
  {
    "postcode":3281,
    "place_name":"Grassmere",
    "state_name":"Victoria"
  },
  {
    "postcode":3281,
    "place_name":"Woodford",
    "state_name":"Victoria"
  },
  {
    "postcode":3281,
    "place_name":"Bushfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3281,
    "place_name":"Winslow",
    "state_name":"Victoria"
  },
  {
    "postcode":3282,
    "place_name":"Koroit",
    "state_name":"Victoria"
  },
  {
    "postcode":3282,
    "place_name":"Illowa",
    "state_name":"Victoria"
  },
  {
    "postcode":3283,
    "place_name":"Warrong",
    "state_name":"Victoria"
  },
  {
    "postcode":3283,
    "place_name":"Crossley",
    "state_name":"Victoria"
  },
  {
    "postcode":3283,
    "place_name":"Tower Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3283,
    "place_name":"Yangery",
    "state_name":"Victoria"
  },
  {
    "postcode":3283,
    "place_name":"Southern Cross",
    "state_name":"Victoria"
  },
  {
    "postcode":3283,
    "place_name":"Yarpturk",
    "state_name":"Victoria"
  },
  {
    "postcode":3283,
    "place_name":"Killarney",
    "state_name":"Victoria"
  },
  {
    "postcode":3283,
    "place_name":"Tarrone",
    "state_name":"Victoria"
  },
  {
    "postcode":3283,
    "place_name":"Kirkstall",
    "state_name":"Victoria"
  },
  {
    "postcode":3283,
    "place_name":"Willatook",
    "state_name":"Victoria"
  },
  {
    "postcode":3284,
    "place_name":"Port Fairy",
    "state_name":"Victoria"
  },
  {
    "postcode":3284,
    "place_name":"Orford",
    "state_name":"Victoria"
  },
  {
    "postcode":3285,
    "place_name":"Yambuk",
    "state_name":"Victoria"
  },
  {
    "postcode":3285,
    "place_name":"Codrington",
    "state_name":"Victoria"
  },
  {
    "postcode":3285,
    "place_name":"Rosebrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3285,
    "place_name":"St Helens",
    "state_name":"Victoria"
  },
  {
    "postcode":3285,
    "place_name":"Narrawong",
    "state_name":"Victoria"
  },
  {
    "postcode":3285,
    "place_name":"Toolong",
    "state_name":"Victoria"
  },
  {
    "postcode":3285,
    "place_name":"Tyrendarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3285,
    "place_name":"Tyrendarra East",
    "state_name":"Victoria"
  },
  {
    "postcode":3286,
    "place_name":"Warrabkook",
    "state_name":"Victoria"
  },
  {
    "postcode":3286,
    "place_name":"Macarthur",
    "state_name":"Victoria"
  },
  {
    "postcode":3286,
    "place_name":"Condah Swamp",
    "state_name":"Victoria"
  },
  {
    "postcode":3286,
    "place_name":"Knebsworth",
    "state_name":"Victoria"
  },
  {
    "postcode":3287,
    "place_name":"Minhamite",
    "state_name":"Victoria"
  },
  {
    "postcode":3287,
    "place_name":"Hawkesdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3289,
    "place_name":"Gazette",
    "state_name":"Victoria"
  },
  {
    "postcode":3289,
    "place_name":"Tabor",
    "state_name":"Victoria"
  },
  {
    "postcode":3289,
    "place_name":"Gerrigerrup",
    "state_name":"Victoria"
  },
  {
    "postcode":3289,
    "place_name":"Penshurst",
    "state_name":"Victoria"
  },
  {
    "postcode":3289,
    "place_name":"Purdeet",
    "state_name":"Victoria"
  },
  {
    "postcode":3292,
    "place_name":"Nelson",
    "state_name":"Victoria"
  },
  {
    "postcode":3293,
    "place_name":"Glenthompson",
    "state_name":"Victoria"
  },
  {
    "postcode":3293,
    "place_name":"Narrapumelap South",
    "state_name":"Victoria"
  },
  {
    "postcode":3293,
    "place_name":"Nareeb",
    "state_name":"Victoria"
  },
  {
    "postcode":3294,
    "place_name":"Moutajup",
    "state_name":"Victoria"
  },
  {
    "postcode":3294,
    "place_name":"Victoria Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3294,
    "place_name":"Mirranatwa",
    "state_name":"Victoria"
  },
  {
    "postcode":3294,
    "place_name":"Woodhouse",
    "state_name":"Victoria"
  },
  {
    "postcode":3294,
    "place_name":"Dunkeld",
    "state_name":"Victoria"
  },
  {
    "postcode":3294,
    "place_name":"Karabeal",
    "state_name":"Victoria"
  },
  {
    "postcode":3294,
    "place_name":"Victoria Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3300,
    "place_name":"Hamilton",
    "state_name":"Victoria"
  },
  {
    "postcode":3300,
    "place_name":"Byaduk North",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Yatchaw",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Wannon",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Croxton East",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Mount Napier",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Bochara",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Tahara",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Tarrington",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Hensley Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Byaduk",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Warrayure",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Broadwater",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Morgiana",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Strathkellar",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Yulecart",
    "state_name":"Victoria"
  },
  {
    "postcode":3301,
    "place_name":"Buckley Swamp",
    "state_name":"Victoria"
  },
  {
    "postcode":3302,
    "place_name":"Grassdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3302,
    "place_name":"Branxholme",
    "state_name":"Victoria"
  },
  {
    "postcode":3303,
    "place_name":"Condah",
    "state_name":"Victoria"
  },
  {
    "postcode":3303,
    "place_name":"Wallacedale",
    "state_name":"Victoria"
  },
  {
    "postcode":3303,
    "place_name":"Breakaway Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3303,
    "place_name":"Lake Condah",
    "state_name":"Victoria"
  },
  {
    "postcode":3303,
    "place_name":"Hotspur",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Heywood",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Drik Drik",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Drumborg",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Mumbannar",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Myamyn",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Lyons",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Dartmoor",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Greenwald",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Winnap",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Bessiebelle",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Homerton",
    "state_name":"Victoria"
  },
  {
    "postcode":3304,
    "place_name":"Milltown",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Mount Richmond",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Cape Bridgewater",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Bolwarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Portland",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Gorae",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Allestree",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Gorae West",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Cashmore",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Portland West",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Portland North",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Dutton Way",
    "state_name":"Victoria"
  },
  {
    "postcode":3305,
    "place_name":"Heathmere",
    "state_name":"Victoria"
  },
  {
    "postcode":3309,
    "place_name":"Digby",
    "state_name":"Victoria"
  },
  {
    "postcode":3310,
    "place_name":"Merino",
    "state_name":"Victoria"
  },
  {
    "postcode":3310,
    "place_name":"Tahara West",
    "state_name":"Victoria"
  },
  {
    "postcode":3311,
    "place_name":"Casterton",
    "state_name":"Victoria"
  },
  {
    "postcode":3311,
    "place_name":"Corndale",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Lindsay",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Bahgallah",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Lake Mundi",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Dunrobin",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Powers Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Henty",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Wando Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Nangeela",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Carapook",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Warrock",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Brimboal",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Killara",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Poolaijelo",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Sandford",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Strathdownie",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Chetwynd",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Dorodong",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Dergholm",
    "state_name":"Victoria"
  },
  {
    "postcode":3312,
    "place_name":"Wando Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3314,
    "place_name":"Mooralla",
    "state_name":"Victoria"
  },
  {
    "postcode":3314,
    "place_name":"Grampians",
    "state_name":"Victoria"
  },
  {
    "postcode":3314,
    "place_name":"Cavendish",
    "state_name":"Victoria"
  },
  {
    "postcode":3314,
    "place_name":"Glenisla",
    "state_name":"Victoria"
  },
  {
    "postcode":3314,
    "place_name":"Bulart",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Nareen",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Paschendale",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Konongwootong",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Tarrenlea",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Muntham",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Tahara Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Tarrayoukyan",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Clover Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Gritjurk",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Brit Brit",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Coleraine",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Coojar",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Melville Forest",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Gringegalgona",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Culla",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Hilgay",
    "state_name":"Victoria"
  },
  {
    "postcode":3315,
    "place_name":"Wootong Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3317,
    "place_name":"Harrow",
    "state_name":"Victoria"
  },
  {
    "postcode":3318,
    "place_name":"Edenhope",
    "state_name":"Victoria"
  },
  {
    "postcode":3318,
    "place_name":"Kadnook",
    "state_name":"Victoria"
  },
  {
    "postcode":3318,
    "place_name":"Connewirricoo",
    "state_name":"Victoria"
  },
  {
    "postcode":3318,
    "place_name":"Ullswater",
    "state_name":"Victoria"
  },
  {
    "postcode":3318,
    "place_name":"Langkoop",
    "state_name":"Victoria"
  },
  {
    "postcode":3318,
    "place_name":"Patyah",
    "state_name":"Victoria"
  },
  {
    "postcode":3318,
    "place_name":"Charam",
    "state_name":"Victoria"
  },
  {
    "postcode":3319,
    "place_name":"Bringalbert",
    "state_name":"Victoria"
  },
  {
    "postcode":3319,
    "place_name":"Apsley",
    "state_name":"Victoria"
  },
  {
    "postcode":3319,
    "place_name":"Benayeo",
    "state_name":"Victoria"
  },
  {
    "postcode":3321,
    "place_name":"Hesse",
    "state_name":"Victoria"
  },
  {
    "postcode":3321,
    "place_name":"Inverleigh",
    "state_name":"Victoria"
  },
  {
    "postcode":3321,
    "place_name":"Wingeel",
    "state_name":"Victoria"
  },
  {
    "postcode":3322,
    "place_name":"Cressy",
    "state_name":"Victoria"
  },
  {
    "postcode":3323,
    "place_name":"Foxhow",
    "state_name":"Victoria"
  },
  {
    "postcode":3323,
    "place_name":"Duverney",
    "state_name":"Victoria"
  },
  {
    "postcode":3323,
    "place_name":"Berrybank",
    "state_name":"Victoria"
  },
  {
    "postcode":3324,
    "place_name":"Lismore",
    "state_name":"Victoria"
  },
  {
    "postcode":3324,
    "place_name":"Mount Bute",
    "state_name":"Victoria"
  },
  {
    "postcode":3324,
    "place_name":"Mingay",
    "state_name":"Victoria"
  },
  {
    "postcode":3325,
    "place_name":"Derrinallum",
    "state_name":"Victoria"
  },
  {
    "postcode":3325,
    "place_name":"Vite Vite North",
    "state_name":"Victoria"
  },
  {
    "postcode":3325,
    "place_name":"Vite Vite",
    "state_name":"Victoria"
  },
  {
    "postcode":3325,
    "place_name":"Larralea",
    "state_name":"Victoria"
  },
  {
    "postcode":3328,
    "place_name":"Teesdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3329,
    "place_name":"Shelford",
    "state_name":"Victoria"
  },
  {
    "postcode":3329,
    "place_name":"Barunah Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3329,
    "place_name":"Barunah Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3330,
    "place_name":"Rokewood",
    "state_name":"Victoria"
  },
  {
    "postcode":3331,
    "place_name":"She Oaks",
    "state_name":"Victoria"
  },
  {
    "postcode":3331,
    "place_name":"Sutherlands Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3331,
    "place_name":"Maude",
    "state_name":"Victoria"
  },
  {
    "postcode":3331,
    "place_name":"Steiglitz",
    "state_name":"Victoria"
  },
  {
    "postcode":3331,
    "place_name":"Russells Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3331,
    "place_name":"Gheringhap",
    "state_name":"Victoria"
  },
  {
    "postcode":3331,
    "place_name":"Bannockburn",
    "state_name":"Victoria"
  },
  {
    "postcode":3332,
    "place_name":"Lethbridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3333,
    "place_name":"Bamganie",
    "state_name":"Victoria"
  },
  {
    "postcode":3333,
    "place_name":"Meredith",
    "state_name":"Victoria"
  },
  {
    "postcode":3334,
    "place_name":"Bungal",
    "state_name":"Victoria"
  },
  {
    "postcode":3334,
    "place_name":"Elaine",
    "state_name":"Victoria"
  },
  {
    "postcode":3334,
    "place_name":"Mount Doran",
    "state_name":"Victoria"
  },
  {
    "postcode":3334,
    "place_name":"Morrisons",
    "state_name":"Victoria"
  },
  {
    "postcode":3334,
    "place_name":"Cargerie",
    "state_name":"Victoria"
  },
  {
    "postcode":3335,
    "place_name":"Plumpton",
    "state_name":"Victoria"
  },
  {
    "postcode":3335,
    "place_name":"Rockbank",
    "state_name":"Victoria"
  },
  {
    "postcode":3337,
    "place_name":"Melton",
    "state_name":"Victoria"
  },
  {
    "postcode":3337,
    "place_name":"Melton West",
    "state_name":"Victoria"
  },
  {
    "postcode":3337,
    "place_name":"Kurunjang",
    "state_name":"Victoria"
  },
  {
    "postcode":3337,
    "place_name":"Toolern Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3338,
    "place_name":"Brookfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3338,
    "place_name":"Eynesbury",
    "state_name":"Victoria"
  },
  {
    "postcode":3338,
    "place_name":"Melton South",
    "state_name":"Victoria"
  },
  {
    "postcode":3338,
    "place_name":"Exford",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Staughton Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Balliang East",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Hopetoun Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Balliang",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Bacchus Marsh",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Merrimu",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Parwan",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Maddingley",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Darley",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Coimadai",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Long Forest",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Glenmore",
    "state_name":"Victoria"
  },
  {
    "postcode":3340,
    "place_name":"Rowsley",
    "state_name":"Victoria"
  },
  {
    "postcode":3341,
    "place_name":"Korobeit",
    "state_name":"Victoria"
  },
  {
    "postcode":3341,
    "place_name":"Dales Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3341,
    "place_name":"Myrniong",
    "state_name":"Victoria"
  },
  {
    "postcode":3341,
    "place_name":"Pentland Hills",
    "state_name":"Victoria"
  },
  {
    "postcode":3341,
    "place_name":"Greendale",
    "state_name":"Victoria"
  },
  {
    "postcode":3342,
    "place_name":"Colbrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3342,
    "place_name":"Beremboke",
    "state_name":"Victoria"
  },
  {
    "postcode":3342,
    "place_name":"Ballan",
    "state_name":"Victoria"
  },
  {
    "postcode":3342,
    "place_name":"Fiskville",
    "state_name":"Victoria"
  },
  {
    "postcode":3342,
    "place_name":"Mount Wallace",
    "state_name":"Victoria"
  },
  {
    "postcode":3342,
    "place_name":"Bunding",
    "state_name":"Victoria"
  },
  {
    "postcode":3342,
    "place_name":"Durdidwarrah",
    "state_name":"Victoria"
  },
  {
    "postcode":3342,
    "place_name":"Blakeville",
    "state_name":"Victoria"
  },
  {
    "postcode":3342,
    "place_name":"Ingliston",
    "state_name":"Victoria"
  },
  {
    "postcode":3345,
    "place_name":"Gordon",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Brown Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Black Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Ballarat",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Lake Wendouree",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Bakery Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Mount Pleasant",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Ballarat Central",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Golden Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Mount Helen",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Nerrina",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Sovereign Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Mount Clear",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Canadian",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Alfredton",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Invermay Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Eureka",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Ballarat North",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Redan",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Ballarat West",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Ballarat East",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Soldiers Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Lucas",
    "state_name":"Victoria"
  },
  {
    "postcode":3350,
    "place_name":"Newington",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Chepstowe",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Carngham",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Springdallah",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Lake Bolac",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Streatham",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Cape Clear",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Ross Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Newtown",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Snake Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Bo Peep",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Westmere",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Smythes Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Illabarook",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Mount Emu",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Staffordshire Reef",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Wallinduc",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Hillcrest",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Smythesdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Nintingbool",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Scarsdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Berringa",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Pitfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Rokewood Junction",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Mininera",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Piggoreet",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Haddon",
    "state_name":"Victoria"
  },
  {
    "postcode":3351,
    "place_name":"Nerrin Nerrin",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Mount Rowan",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Mount Bolton",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Bunkers Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Weatherboard",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Waubra",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Chapel Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Blowhard",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Gong Gong",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Dereel",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Ballarat Roadside Delivery",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Wattle Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Enfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Dean",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Navigators",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Bolwarrah",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Mount Egerton",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Lamplough",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Langi Kal Kal",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Clarkes Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Claretown",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Bullarook",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Bungaree",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Magpie",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Lexton",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Bonshaw",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Ercildoune",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Clarendon",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Millbrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Barkstead",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Cardigan",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Yendon",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Miners Rest",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Garibaldi",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Glenbrae",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Addington",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Wallace",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Lal Lal",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Mount Mercer",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Durham Lead",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Glen Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Corindhap",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Grenville",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Napoleons",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Pootilla",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Burrumbeet",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Dunnstown",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Sulky",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Scotchmans Lead",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Cambrian Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Werneth",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Windermere",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Springbank",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Brewster",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Mitchell Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Warrenheip",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Invermay",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Scotsburn",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Cardigan Village",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Learmonth",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Mollongghip",
    "state_name":"Victoria"
  },
  {
    "postcode":3352,
    "place_name":"Leigh Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3353,
    "place_name":"Ballarat",
    "state_name":"Victoria"
  },
  {
    "postcode":3354,
    "place_name":"Ballarat Mc",
    "state_name":"Victoria"
  },
  {
    "postcode":3354,
    "place_name":"Bakery Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3355,
    "place_name":"Wendouree Village",
    "state_name":"Victoria"
  },
  {
    "postcode":3355,
    "place_name":"Wendouree",
    "state_name":"Victoria"
  },
  {
    "postcode":3355,
    "place_name":"Mitchell Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3355,
    "place_name":"Lake Gardens",
    "state_name":"Victoria"
  },
  {
    "postcode":3356,
    "place_name":"Delacombe",
    "state_name":"Victoria"
  },
  {
    "postcode":3356,
    "place_name":"Sebastopol",
    "state_name":"Victoria"
  },
  {
    "postcode":3357,
    "place_name":"Buninyong",
    "state_name":"Victoria"
  },
  {
    "postcode":3360,
    "place_name":"Happy Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3360,
    "place_name":"Pittong",
    "state_name":"Victoria"
  },
  {
    "postcode":3360,
    "place_name":"Linton",
    "state_name":"Victoria"
  },
  {
    "postcode":3360,
    "place_name":"Willowvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3360,
    "place_name":"Mannibadar",
    "state_name":"Victoria"
  },
  {
    "postcode":3361,
    "place_name":"Carranballac",
    "state_name":"Victoria"
  },
  {
    "postcode":3361,
    "place_name":"Bradvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3361,
    "place_name":"Skipton",
    "state_name":"Victoria"
  },
  {
    "postcode":3363,
    "place_name":"Mount Beckworth",
    "state_name":"Victoria"
  },
  {
    "postcode":3363,
    "place_name":"Creswick North",
    "state_name":"Victoria"
  },
  {
    "postcode":3363,
    "place_name":"Dean",
    "state_name":"Victoria"
  },
  {
    "postcode":3363,
    "place_name":"Langdons Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3363,
    "place_name":"Tourello",
    "state_name":"Victoria"
  },
  {
    "postcode":3363,
    "place_name":"Creswick",
    "state_name":"Victoria"
  },
  {
    "postcode":3363,
    "place_name":"Glendaruel",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Kooroocheang",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Werona",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Barkstead",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Mount Prospect",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Ascot",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Broomfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Newlyn",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Glendonald",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Rocklyn",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Strathlea",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Allendale",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Cabbage Tree",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Smeaton",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Blampied",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Ullina",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Smokeytown",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Joyces Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Newlyn North",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Campbelltown",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Kingston",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Coghills Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Springmount",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Lawrence",
    "state_name":"Victoria"
  },
  {
    "postcode":3364,
    "place_name":"Bald Hills",
    "state_name":"Victoria"
  },
  {
    "postcode":3370,
    "place_name":"Clunes",
    "state_name":"Victoria"
  },
  {
    "postcode":3370,
    "place_name":"Mount Cameron",
    "state_name":"Victoria"
  },
  {
    "postcode":3370,
    "place_name":"Ullina",
    "state_name":"Victoria"
  },
  {
    "postcode":3370,
    "place_name":"Glengower",
    "state_name":"Victoria"
  },
  {
    "postcode":3371,
    "place_name":"Lillicur",
    "state_name":"Victoria"
  },
  {
    "postcode":3371,
    "place_name":"Red Lion",
    "state_name":"Victoria"
  },
  {
    "postcode":3371,
    "place_name":"Evansford",
    "state_name":"Victoria"
  },
  {
    "postcode":3371,
    "place_name":"Burnbank",
    "state_name":"Victoria"
  },
  {
    "postcode":3371,
    "place_name":"Talbot",
    "state_name":"Victoria"
  },
  {
    "postcode":3371,
    "place_name":"Amherst",
    "state_name":"Victoria"
  },
  {
    "postcode":3371,
    "place_name":"Dunach",
    "state_name":"Victoria"
  },
  {
    "postcode":3371,
    "place_name":"Mount Glasgow",
    "state_name":"Victoria"
  },
  {
    "postcode":3371,
    "place_name":"Stony Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3371,
    "place_name":"Caralulup",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Trawalla",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Mena Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Lake Goldsmith",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Nerring",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Raglan",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Stoneleigh",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Waterloo",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Chute",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Main Lead",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Cross Roads",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Beaufort",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Lake Wongan",
    "state_name":"Victoria"
  },
  {
    "postcode":3373,
    "place_name":"Stockyard Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3374,
    "place_name":"Great Western",
    "state_name":"Victoria"
  },
  {
    "postcode":3375,
    "place_name":"Buangor",
    "state_name":"Victoria"
  },
  {
    "postcode":3375,
    "place_name":"Bayindeen",
    "state_name":"Victoria"
  },
  {
    "postcode":3375,
    "place_name":"Middle Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3375,
    "place_name":"Ballyrogan",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Rocky Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Warrak",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Rhymney",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Dobie",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Shays Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Mount Cole",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Crowlands",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Mount Cole Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Cathcart",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Langi Logan",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Denicull Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Eversley",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Bulgana",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Ararat",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Norval",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Moyston",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Rossbridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Dunneworthy",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Maroona",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Great Western",
    "state_name":"Victoria"
  },
  {
    "postcode":3377,
    "place_name":"Armstrong",
    "state_name":"Victoria"
  },
  {
    "postcode":3378,
    "place_name":"Yalla-Y-Poora",
    "state_name":"Victoria"
  },
  {
    "postcode":3378,
    "place_name":"Tatyoon",
    "state_name":"Victoria"
  },
  {
    "postcode":3379,
    "place_name":"Chatsworth",
    "state_name":"Victoria"
  },
  {
    "postcode":3379,
    "place_name":"Bornes Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3379,
    "place_name":"Willaura North",
    "state_name":"Victoria"
  },
  {
    "postcode":3379,
    "place_name":"Mafeking",
    "state_name":"Victoria"
  },
  {
    "postcode":3379,
    "place_name":"Stavely",
    "state_name":"Victoria"
  },
  {
    "postcode":3379,
    "place_name":"Wickliffe",
    "state_name":"Victoria"
  },
  {
    "postcode":3379,
    "place_name":"Willaura",
    "state_name":"Victoria"
  },
  {
    "postcode":3380,
    "place_name":"Stawell",
    "state_name":"Victoria"
  },
  {
    "postcode":3380,
    "place_name":"Stawell West",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Bellellen",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Bellfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Lubeck",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Mount Dryden",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Mokepilly",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Black Range",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Pomonal",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Lake Lonsdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Lake Fyans",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Halls Gap",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Campbells Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Illawarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Barkly",
    "state_name":"Victoria"
  },
  {
    "postcode":3381,
    "place_name":"Fyans Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3384,
    "place_name":"Joel South",
    "state_name":"Victoria"
  },
  {
    "postcode":3384,
    "place_name":"Wattle Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3384,
    "place_name":"Landsborough",
    "state_name":"Victoria"
  },
  {
    "postcode":3384,
    "place_name":"Barkly",
    "state_name":"Victoria"
  },
  {
    "postcode":3384,
    "place_name":"Concongella",
    "state_name":"Victoria"
  },
  {
    "postcode":3384,
    "place_name":"Joel Joel",
    "state_name":"Victoria"
  },
  {
    "postcode":3384,
    "place_name":"Navarre",
    "state_name":"Victoria"
  },
  {
    "postcode":3384,
    "place_name":"Frenchmans",
    "state_name":"Victoria"
  },
  {
    "postcode":3384,
    "place_name":"Tulkara",
    "state_name":"Victoria"
  },
  {
    "postcode":3384,
    "place_name":"Landsborough West",
    "state_name":"Victoria"
  },
  {
    "postcode":3385,
    "place_name":"Lubeck",
    "state_name":"Victoria"
  },
  {
    "postcode":3385,
    "place_name":"Dadswells Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3385,
    "place_name":"Roses Gap",
    "state_name":"Victoria"
  },
  {
    "postcode":3385,
    "place_name":"Riachella",
    "state_name":"Victoria"
  },
  {
    "postcode":3385,
    "place_name":"Deep Lead",
    "state_name":"Victoria"
  },
  {
    "postcode":3385,
    "place_name":"Wal Wal",
    "state_name":"Victoria"
  },
  {
    "postcode":3385,
    "place_name":"Glenorchy",
    "state_name":"Victoria"
  },
  {
    "postcode":3385,
    "place_name":"Ledcourt",
    "state_name":"Victoria"
  },
  {
    "postcode":3387,
    "place_name":"Morrl Morrl",
    "state_name":"Victoria"
  },
  {
    "postcode":3387,
    "place_name":"Marnoo",
    "state_name":"Victoria"
  },
  {
    "postcode":3387,
    "place_name":"Callawadda",
    "state_name":"Victoria"
  },
  {
    "postcode":3387,
    "place_name":"Wallaloo",
    "state_name":"Victoria"
  },
  {
    "postcode":3387,
    "place_name":"Kanya",
    "state_name":"Victoria"
  },
  {
    "postcode":3387,
    "place_name":"Wallaloo East",
    "state_name":"Victoria"
  },
  {
    "postcode":3387,
    "place_name":"Bolangum",
    "state_name":"Victoria"
  },
  {
    "postcode":3387,
    "place_name":"Campbells Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3387,
    "place_name":"Germania",
    "state_name":"Victoria"
  },
  {
    "postcode":3387,
    "place_name":"Greens Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3387,
    "place_name":"Marnoo West",
    "state_name":"Victoria"
  },
  {
    "postcode":3388,
    "place_name":"Banyena",
    "state_name":"Victoria"
  },
  {
    "postcode":3388,
    "place_name":"Rupanyup",
    "state_name":"Victoria"
  },
  {
    "postcode":3390,
    "place_name":"Kewell",
    "state_name":"Victoria"
  },
  {
    "postcode":3390,
    "place_name":"Murtoa",
    "state_name":"Victoria"
  },
  {
    "postcode":3391,
    "place_name":"Brim",
    "state_name":"Victoria"
  },
  {
    "postcode":3392,
    "place_name":"Sheep Hills",
    "state_name":"Victoria"
  },
  {
    "postcode":3392,
    "place_name":"Minyip",
    "state_name":"Victoria"
  },
  {
    "postcode":3392,
    "place_name":"Boolite",
    "state_name":"Victoria"
  },
  {
    "postcode":3393,
    "place_name":"Crymelon",
    "state_name":"Victoria"
  },
  {
    "postcode":3393,
    "place_name":"Kellalac",
    "state_name":"Victoria"
  },
  {
    "postcode":3393,
    "place_name":"Willenabrina",
    "state_name":"Victoria"
  },
  {
    "postcode":3393,
    "place_name":"Wilkur",
    "state_name":"Victoria"
  },
  {
    "postcode":3393,
    "place_name":"Bangerang",
    "state_name":"Victoria"
  },
  {
    "postcode":3393,
    "place_name":"Warracknabeal",
    "state_name":"Victoria"
  },
  {
    "postcode":3393,
    "place_name":"Lah",
    "state_name":"Victoria"
  },
  {
    "postcode":3393,
    "place_name":"Aubrey",
    "state_name":"Victoria"
  },
  {
    "postcode":3393,
    "place_name":"Cannum",
    "state_name":"Victoria"
  },
  {
    "postcode":3395,
    "place_name":"Kenmare",
    "state_name":"Victoria"
  },
  {
    "postcode":3395,
    "place_name":"Beulah",
    "state_name":"Victoria"
  },
  {
    "postcode":3395,
    "place_name":"Reedy Dam",
    "state_name":"Victoria"
  },
  {
    "postcode":3395,
    "place_name":"Rosebery",
    "state_name":"Victoria"
  },
  {
    "postcode":3396,
    "place_name":"Hopetoun",
    "state_name":"Victoria"
  },
  {
    "postcode":3400,
    "place_name":"Horsham",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Kalkee",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Quantong",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Nurcoung",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Wallup",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Laharum",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"St Helens Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Dooen",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Mockinya",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Zumsteins",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Nurrabiel",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Murra Warra",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Telangatuk East",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Drung",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Lower Norton",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Haven",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Toolondo",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Kanagulk",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Longerenong",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Rocklands",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Gymbowen",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Vectis",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Wartook",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Riverside",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Brimpaen",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Cherrypool",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Blackheath",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Wonwondah",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Mckenzie Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Bungalally",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Karnak",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Jung",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Wail",
    "state_name":"Victoria"
  },
  {
    "postcode":3401,
    "place_name":"Pimpinio",
    "state_name":"Victoria"
  },
  {
    "postcode":3402,
    "place_name":"Horsham",
    "state_name":"Victoria"
  },
  {
    "postcode":3407,
    "place_name":"Englefield",
    "state_name":"Victoria"
  },
  {
    "postcode":3407,
    "place_name":"Vasey",
    "state_name":"Victoria"
  },
  {
    "postcode":3407,
    "place_name":"Balmoral",
    "state_name":"Victoria"
  },
  {
    "postcode":3407,
    "place_name":"Pigeon Ponds",
    "state_name":"Victoria"
  },
  {
    "postcode":3407,
    "place_name":"Gatum",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Natimuk",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Grass Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Clear Lake",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Arapiles",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Mitre",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Duchembegarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Noradjuha",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Douglas",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Wombelano",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Jilpanger",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Tooan",
    "state_name":"Victoria"
  },
  {
    "postcode":3409,
    "place_name":"Miga Lake",
    "state_name":"Victoria"
  },
  {
    "postcode":3412,
    "place_name":"Goroke",
    "state_name":"Victoria"
  },
  {
    "postcode":3413,
    "place_name":"Neuarpurr",
    "state_name":"Victoria"
  },
  {
    "postcode":3413,
    "place_name":"Ozenkadnook",
    "state_name":"Victoria"
  },
  {
    "postcode":3413,
    "place_name":"Minimay",
    "state_name":"Victoria"
  },
  {
    "postcode":3413,
    "place_name":"Peronne",
    "state_name":"Victoria"
  },
  {
    "postcode":3414,
    "place_name":"Antwerp",
    "state_name":"Victoria"
  },
  {
    "postcode":3414,
    "place_name":"Dimboola",
    "state_name":"Victoria"
  },
  {
    "postcode":3414,
    "place_name":"Tarranyurk",
    "state_name":"Victoria"
  },
  {
    "postcode":3415,
    "place_name":"Miram",
    "state_name":"Victoria"
  },
  {
    "postcode":3418,
    "place_name":"Gerang Gerung",
    "state_name":"Victoria"
  },
  {
    "postcode":3418,
    "place_name":"Nhill",
    "state_name":"Victoria"
  },
  {
    "postcode":3418,
    "place_name":"Kiata",
    "state_name":"Victoria"
  },
  {
    "postcode":3418,
    "place_name":"Lawloit",
    "state_name":"Victoria"
  },
  {
    "postcode":3418,
    "place_name":"Broughton",
    "state_name":"Victoria"
  },
  {
    "postcode":3418,
    "place_name":"Lorquon",
    "state_name":"Victoria"
  },
  {
    "postcode":3418,
    "place_name":"Little Desert",
    "state_name":"Victoria"
  },
  {
    "postcode":3418,
    "place_name":"Yanac",
    "state_name":"Victoria"
  },
  {
    "postcode":3418,
    "place_name":"Glenlee",
    "state_name":"Victoria"
  },
  {
    "postcode":3418,
    "place_name":"Netherby",
    "state_name":"Victoria"
  },
  {
    "postcode":3419,
    "place_name":"Kaniva",
    "state_name":"Victoria"
  },
  {
    "postcode":3420,
    "place_name":"Telopea Downs",
    "state_name":"Victoria"
  },
  {
    "postcode":3420,
    "place_name":"Serviceton",
    "state_name":"Victoria"
  },
  {
    "postcode":3420,
    "place_name":"Lillimur",
    "state_name":"Victoria"
  },
  {
    "postcode":3423,
    "place_name":"Jeparit",
    "state_name":"Victoria"
  },
  {
    "postcode":3424,
    "place_name":"Yaapeet",
    "state_name":"Victoria"
  },
  {
    "postcode":3424,
    "place_name":"Albacutya",
    "state_name":"Victoria"
  },
  {
    "postcode":3424,
    "place_name":"Rainbow",
    "state_name":"Victoria"
  },
  {
    "postcode":3427,
    "place_name":"Diggers Rest",
    "state_name":"Victoria"
  },
  {
    "postcode":3428,
    "place_name":"Bulla",
    "state_name":"Victoria"
  },
  {
    "postcode":3429,
    "place_name":"Sunbury",
    "state_name":"Victoria"
  },
  {
    "postcode":3429,
    "place_name":"Wildwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3430,
    "place_name":"Clarkefield",
    "state_name":"Victoria"
  },
  {
    "postcode":3431,
    "place_name":"Riddells Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3432,
    "place_name":"Bolinda",
    "state_name":"Victoria"
  },
  {
    "postcode":3433,
    "place_name":"Monegeetta",
    "state_name":"Victoria"
  },
  {
    "postcode":3434,
    "place_name":"Romsey",
    "state_name":"Victoria"
  },
  {
    "postcode":3434,
    "place_name":"Cherokee",
    "state_name":"Victoria"
  },
  {
    "postcode":3434,
    "place_name":"Springfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3434,
    "place_name":"Kerrie",
    "state_name":"Victoria"
  },
  {
    "postcode":3435,
    "place_name":"Lancefield",
    "state_name":"Victoria"
  },
  {
    "postcode":3435,
    "place_name":"Goldie",
    "state_name":"Victoria"
  },
  {
    "postcode":3435,
    "place_name":"Benloch",
    "state_name":"Victoria"
  },
  {
    "postcode":3435,
    "place_name":"Nulla Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3437,
    "place_name":"Bullengarook",
    "state_name":"Victoria"
  },
  {
    "postcode":3437,
    "place_name":"Gisborne South",
    "state_name":"Victoria"
  },
  {
    "postcode":3437,
    "place_name":"Gisborne",
    "state_name":"Victoria"
  },
  {
    "postcode":3438,
    "place_name":"New Gisborne",
    "state_name":"Victoria"
  },
  {
    "postcode":3440,
    "place_name":"Macedon",
    "state_name":"Victoria"
  },
  {
    "postcode":3441,
    "place_name":"Mount Macedon",
    "state_name":"Victoria"
  },
  {
    "postcode":3442,
    "place_name":"Hesket",
    "state_name":"Victoria"
  },
  {
    "postcode":3442,
    "place_name":"Ashbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3442,
    "place_name":"Rochford",
    "state_name":"Victoria"
  },
  {
    "postcode":3442,
    "place_name":"Carlsruhe",
    "state_name":"Victoria"
  },
  {
    "postcode":3442,
    "place_name":"Woodend",
    "state_name":"Victoria"
  },
  {
    "postcode":3442,
    "place_name":"Cadello",
    "state_name":"Victoria"
  },
  {
    "postcode":3442,
    "place_name":"Newham",
    "state_name":"Victoria"
  },
  {
    "postcode":3442,
    "place_name":"Cobaw",
    "state_name":"Victoria"
  },
  {
    "postcode":3442,
    "place_name":"Woodend North",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Barfold",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Pastoria",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Lyal",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Redesdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Langley",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Tylden South",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Kyneton",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Glenhope",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Tylden",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Greenhill",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Baynton",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Pipers Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Mia Mia",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Metcalfe East",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Lauriston",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Edgecombe",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Sidonia",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Baynton East",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Spring Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Kyneton South",
    "state_name":"Victoria"
  },
  {
    "postcode":3444,
    "place_name":"Pastoria East",
    "state_name":"Victoria"
  },
  {
    "postcode":3446,
    "place_name":"Malmsbury",
    "state_name":"Victoria"
  },
  {
    "postcode":3446,
    "place_name":"Drummond North",
    "state_name":"Victoria"
  },
  {
    "postcode":3447,
    "place_name":"Taradale",
    "state_name":"Victoria"
  },
  {
    "postcode":3448,
    "place_name":"Sutton Grange",
    "state_name":"Victoria"
  },
  {
    "postcode":3448,
    "place_name":"Elphinstone",
    "state_name":"Victoria"
  },
  {
    "postcode":3448,
    "place_name":"Metcalfe",
    "state_name":"Victoria"
  },
  {
    "postcode":3450,
    "place_name":"Moonlight Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3450,
    "place_name":"Castlemaine",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Gower",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Mckenzie Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Campbells Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Golden Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Barkers Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Muckleford",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Guildford",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Yapeen",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Chewton Bushlands",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Faraday",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Vaughan",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Glenluce",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Chewton",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Fryerstown",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Tarilta",
    "state_name":"Victoria"
  },
  {
    "postcode":3451,
    "place_name":"Irishtown",
    "state_name":"Victoria"
  },
  {
    "postcode":3453,
    "place_name":"Ravenswood",
    "state_name":"Victoria"
  },
  {
    "postcode":3453,
    "place_name":"Harcourt North",
    "state_name":"Victoria"
  },
  {
    "postcode":3453,
    "place_name":"Harcourt",
    "state_name":"Victoria"
  },
  {
    "postcode":3453,
    "place_name":"Ravenswood South",
    "state_name":"Victoria"
  },
  {
    "postcode":3458,
    "place_name":"Newbury",
    "state_name":"Victoria"
  },
  {
    "postcode":3458,
    "place_name":"Trentham",
    "state_name":"Victoria"
  },
  {
    "postcode":3458,
    "place_name":"Fern Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3458,
    "place_name":"Trentham East",
    "state_name":"Victoria"
  },
  {
    "postcode":3458,
    "place_name":"Blackwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3458,
    "place_name":"Lerderderg",
    "state_name":"Victoria"
  },
  {
    "postcode":3458,
    "place_name":"Little Hampton",
    "state_name":"Victoria"
  },
  {
    "postcode":3458,
    "place_name":"Barrys Reef",
    "state_name":"Victoria"
  },
  {
    "postcode":3458,
    "place_name":"North Blackwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3460,
    "place_name":"Daylesford",
    "state_name":"Victoria"
  },
  {
    "postcode":3460,
    "place_name":"Basalt",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Korweinguboora",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Strangways",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Hepburn Springs",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Porcupine Ridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Musk Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Eganstown",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Yandoit",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Elevated Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Hepburn",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Leonards Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Spargo Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Sailors Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Franklinford",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Yandoit Hills",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Drummond",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Bullarto South",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Musk",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Denver",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Sailors Falls",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Mount Franklin",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Lyonville",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Shepherds Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Glenlyon",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Dry Diggings",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Bullarto",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Coomoora",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Wheatsheaf",
    "state_name":"Victoria"
  },
  {
    "postcode":3461,
    "place_name":"Clydesdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3462,
    "place_name":"Newstead",
    "state_name":"Victoria"
  },
  {
    "postcode":3462,
    "place_name":"Muckleford South",
    "state_name":"Victoria"
  },
  {
    "postcode":3462,
    "place_name":"Sandon",
    "state_name":"Victoria"
  },
  {
    "postcode":3462,
    "place_name":"Welshmans Reef",
    "state_name":"Victoria"
  },
  {
    "postcode":3462,
    "place_name":"Green Gully",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Maldon",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Laanecoorie",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Baringhup",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Bradford",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Walmer",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Baringhup West",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Eastville",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Tarrengower",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Nuggetty",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Woodstock West",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Neereman",
    "state_name":"Victoria"
  },
  {
    "postcode":3463,
    "place_name":"Shelbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3464,
    "place_name":"Carisbrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Havelock",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Maryborough",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Timor West",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Wareek",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Cotswold",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Homebush",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Moonlight Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Bung Bong",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Moolort",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Bowenvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Rathscar",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Daisy Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Natte Yallock",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Timor",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Simson",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Alma",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Majorca",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Adelaide Lead",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Flagstaff",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Rathscar West",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Craigie",
    "state_name":"Victoria"
  },
  {
    "postcode":3465,
    "place_name":"Golden Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3467,
    "place_name":"Avoca",
    "state_name":"Victoria"
  },
  {
    "postcode":3468,
    "place_name":"Mount Lonarch",
    "state_name":"Victoria"
  },
  {
    "postcode":3468,
    "place_name":"Amphitheatre",
    "state_name":"Victoria"
  },
  {
    "postcode":3469,
    "place_name":"Nowhere Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3469,
    "place_name":"Elmhurst",
    "state_name":"Victoria"
  },
  {
    "postcode":3469,
    "place_name":"Glenlogie",
    "state_name":"Victoria"
  },
  {
    "postcode":3469,
    "place_name":"Glenpatrick",
    "state_name":"Victoria"
  },
  {
    "postcode":3469,
    "place_name":"Glenlofty",
    "state_name":"Victoria"
  },
  {
    "postcode":3472,
    "place_name":"Bet Bet",
    "state_name":"Victoria"
  },
  {
    "postcode":3472,
    "place_name":"Eddington",
    "state_name":"Victoria"
  },
  {
    "postcode":3472,
    "place_name":"Bromley",
    "state_name":"Victoria"
  },
  {
    "postcode":3472,
    "place_name":"Betley",
    "state_name":"Victoria"
  },
  {
    "postcode":3472,
    "place_name":"Moliagul",
    "state_name":"Victoria"
  },
  {
    "postcode":3472,
    "place_name":"Goldsborough",
    "state_name":"Victoria"
  },
  {
    "postcode":3472,
    "place_name":"Dunluce",
    "state_name":"Victoria"
  },
  {
    "postcode":3472,
    "place_name":"Inkerman",
    "state_name":"Victoria"
  },
  {
    "postcode":3472,
    "place_name":"Dunolly",
    "state_name":"Victoria"
  },
  {
    "postcode":3472,
    "place_name":"Mount Hooghly",
    "state_name":"Victoria"
  },
  {
    "postcode":3472,
    "place_name":"Mcintyre",
    "state_name":"Victoria"
  },
  {
    "postcode":3475,
    "place_name":"Emu",
    "state_name":"Victoria"
  },
  {
    "postcode":3475,
    "place_name":"Logan",
    "state_name":"Victoria"
  },
  {
    "postcode":3475,
    "place_name":"Cochranes Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3475,
    "place_name":"Archdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3475,
    "place_name":"Archdale Junction",
    "state_name":"Victoria"
  },
  {
    "postcode":3475,
    "place_name":"Burkes Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3475,
    "place_name":"Bealiba",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Traynors Lagoon",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Grays Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Redbank",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Rostron",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Gowar East",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Coonooer West",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Paradise",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Stuart Mill",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Gre Gre North",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Gre Gre South",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Avon Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Moyreisk",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"St Arnaud North",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Marnoo East",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Carapooee West",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Beazleys Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Gre Gre",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"York Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Carapooee",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Gooroc",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Winjallok",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"St Arnaud East",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Coonooer Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Moolerr",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Swanwater",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Dalyenong",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Sutherland",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Tottington",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Slaty Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3477,
    "place_name":"Kooreh",
    "state_name":"Victoria"
  },
  {
    "postcode":3478,
    "place_name":"Redbank",
    "state_name":"Victoria"
  },
  {
    "postcode":3478,
    "place_name":"Percydale",
    "state_name":"Victoria"
  },
  {
    "postcode":3478,
    "place_name":"Stuart Mill",
    "state_name":"Victoria"
  },
  {
    "postcode":3478,
    "place_name":"Warrenmang",
    "state_name":"Victoria"
  },
  {
    "postcode":3478,
    "place_name":"Medlyn",
    "state_name":"Victoria"
  },
  {
    "postcode":3478,
    "place_name":"Moonambel",
    "state_name":"Victoria"
  },
  {
    "postcode":3478,
    "place_name":"St Arnaud",
    "state_name":"Victoria"
  },
  {
    "postcode":3478,
    "place_name":"Yawong Hills",
    "state_name":"Victoria"
  },
  {
    "postcode":3478,
    "place_name":"Tanwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3478,
    "place_name":"Dooboobetic",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Carron",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Lawler",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Areegra",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Corack East",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Donald",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Jeffcott North",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Laen North",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Cope Cope",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Corack",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Jeffcott",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Laen East",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Litchfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Swanwater West",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Laen",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Rich Avon",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Rich Avon East",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Rich Avon West",
    "state_name":"Victoria"
  },
  {
    "postcode":3480,
    "place_name":"Gil Gil",
    "state_name":"Victoria"
  },
  {
    "postcode":3482,
    "place_name":"Warmur",
    "state_name":"Victoria"
  },
  {
    "postcode":3482,
    "place_name":"Massey",
    "state_name":"Victoria"
  },
  {
    "postcode":3482,
    "place_name":"Watchem",
    "state_name":"Victoria"
  },
  {
    "postcode":3482,
    "place_name":"Morton Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3482,
    "place_name":"Watchem West",
    "state_name":"Victoria"
  },
  {
    "postcode":3483,
    "place_name":"Narraport",
    "state_name":"Victoria"
  },
  {
    "postcode":3483,
    "place_name":"Birchip",
    "state_name":"Victoria"
  },
  {
    "postcode":3483,
    "place_name":"Kinnabulla",
    "state_name":"Victoria"
  },
  {
    "postcode":3483,
    "place_name":"Karyrie",
    "state_name":"Victoria"
  },
  {
    "postcode":3483,
    "place_name":"Birchip West",
    "state_name":"Victoria"
  },
  {
    "postcode":3483,
    "place_name":"Whirily",
    "state_name":"Victoria"
  },
  {
    "postcode":3483,
    "place_name":"Ballapur",
    "state_name":"Victoria"
  },
  {
    "postcode":3483,
    "place_name":"Curyo",
    "state_name":"Victoria"
  },
  {
    "postcode":3483,
    "place_name":"Marlbed",
    "state_name":"Victoria"
  },
  {
    "postcode":3483,
    "place_name":"Jil Jil",
    "state_name":"Victoria"
  },
  {
    "postcode":3485,
    "place_name":"Woomelang",
    "state_name":"Victoria"
  },
  {
    "postcode":3485,
    "place_name":"Willangie",
    "state_name":"Victoria"
  },
  {
    "postcode":3485,
    "place_name":"Banyan",
    "state_name":"Victoria"
  },
  {
    "postcode":3485,
    "place_name":"Watchupga",
    "state_name":"Victoria"
  },
  {
    "postcode":3487,
    "place_name":"Lascelles",
    "state_name":"Victoria"
  },
  {
    "postcode":3488,
    "place_name":"Turriff East",
    "state_name":"Victoria"
  },
  {
    "postcode":3488,
    "place_name":"Speed",
    "state_name":"Victoria"
  },
  {
    "postcode":3488,
    "place_name":"Turriff",
    "state_name":"Victoria"
  },
  {
    "postcode":3489,
    "place_name":"Tempy",
    "state_name":"Victoria"
  },
  {
    "postcode":3490,
    "place_name":"Mittyack",
    "state_name":"Victoria"
  },
  {
    "postcode":3490,
    "place_name":"Murray-Sunset",
    "state_name":"Victoria"
  },
  {
    "postcode":3490,
    "place_name":"Torrita",
    "state_name":"Victoria"
  },
  {
    "postcode":3490,
    "place_name":"Kulwin",
    "state_name":"Victoria"
  },
  {
    "postcode":3490,
    "place_name":"Boinka",
    "state_name":"Victoria"
  },
  {
    "postcode":3490,
    "place_name":"Big Desert",
    "state_name":"Victoria"
  },
  {
    "postcode":3490,
    "place_name":"Ouyen",
    "state_name":"Victoria"
  },
  {
    "postcode":3490,
    "place_name":"Tutye",
    "state_name":"Victoria"
  },
  {
    "postcode":3491,
    "place_name":"Patchewollock",
    "state_name":"Victoria"
  },
  {
    "postcode":3494,
    "place_name":"Nangiloc",
    "state_name":"Victoria"
  },
  {
    "postcode":3494,
    "place_name":"Iraak",
    "state_name":"Victoria"
  },
  {
    "postcode":3494,
    "place_name":"Carwarp",
    "state_name":"Victoria"
  },
  {
    "postcode":3494,
    "place_name":"Colignan",
    "state_name":"Victoria"
  },
  {
    "postcode":3496,
    "place_name":"Sunnycliffs",
    "state_name":"Victoria"
  },
  {
    "postcode":3496,
    "place_name":"Cullulleraine",
    "state_name":"Victoria"
  },
  {
    "postcode":3496,
    "place_name":"Werrimull",
    "state_name":"Victoria"
  },
  {
    "postcode":3496,
    "place_name":"Red Cliffs",
    "state_name":"Victoria"
  },
  {
    "postcode":3496,
    "place_name":"Merrinee",
    "state_name":"Victoria"
  },
  {
    "postcode":3496,
    "place_name":"Cardross",
    "state_name":"Victoria"
  },
  {
    "postcode":3496,
    "place_name":"Meringur",
    "state_name":"Victoria"
  },
  {
    "postcode":3496,
    "place_name":"Neds Corner",
    "state_name":"Victoria"
  },
  {
    "postcode":3496,
    "place_name":"Lindsay Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3498,
    "place_name":"Irymple",
    "state_name":"Victoria"
  },
  {
    "postcode":3500,
    "place_name":"Mildura West",
    "state_name":"Victoria"
  },
  {
    "postcode":3500,
    "place_name":"Mildura",
    "state_name":"Victoria"
  },
  {
    "postcode":3501,
    "place_name":"Mildura Centre Plaza",
    "state_name":"Victoria"
  },
  {
    "postcode":3501,
    "place_name":"Nichols Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3501,
    "place_name":"Hattah",
    "state_name":"Victoria"
  },
  {
    "postcode":3501,
    "place_name":"Koorlong",
    "state_name":"Victoria"
  },
  {
    "postcode":3501,
    "place_name":"Mildura South",
    "state_name":"Victoria"
  },
  {
    "postcode":3502,
    "place_name":"Mildura",
    "state_name":"Victoria"
  },
  {
    "postcode":3505,
    "place_name":"Wargan",
    "state_name":"Victoria"
  },
  {
    "postcode":3505,
    "place_name":"Birdwoodton",
    "state_name":"Victoria"
  },
  {
    "postcode":3505,
    "place_name":"Merbein",
    "state_name":"Victoria"
  },
  {
    "postcode":3505,
    "place_name":"Cabarita",
    "state_name":"Victoria"
  },
  {
    "postcode":3505,
    "place_name":"Merbein West",
    "state_name":"Victoria"
  },
  {
    "postcode":3505,
    "place_name":"Yelta",
    "state_name":"Victoria"
  },
  {
    "postcode":3505,
    "place_name":"Merbein South",
    "state_name":"Victoria"
  },
  {
    "postcode":3506,
    "place_name":"Cowangie",
    "state_name":"Victoria"
  },
  {
    "postcode":3507,
    "place_name":"Walpeup",
    "state_name":"Victoria"
  },
  {
    "postcode":3509,
    "place_name":"Linga",
    "state_name":"Victoria"
  },
  {
    "postcode":3509,
    "place_name":"Underbool",
    "state_name":"Victoria"
  },
  {
    "postcode":3512,
    "place_name":"Carina",
    "state_name":"Victoria"
  },
  {
    "postcode":3512,
    "place_name":"Murrayville",
    "state_name":"Victoria"
  },
  {
    "postcode":3512,
    "place_name":"Panitya",
    "state_name":"Victoria"
  },
  {
    "postcode":3515,
    "place_name":"Shelbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3515,
    "place_name":"Wilsons Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3515,
    "place_name":"Marong",
    "state_name":"Victoria"
  },
  {
    "postcode":3516,
    "place_name":"Bridgewater On Loddon",
    "state_name":"Victoria"
  },
  {
    "postcode":3516,
    "place_name":"Derby",
    "state_name":"Victoria"
  },
  {
    "postcode":3516,
    "place_name":"Yarraberb",
    "state_name":"Victoria"
  },
  {
    "postcode":3516,
    "place_name":"Leichardt",
    "state_name":"Victoria"
  },
  {
    "postcode":3516,
    "place_name":"Bridgewater",
    "state_name":"Victoria"
  },
  {
    "postcode":3516,
    "place_name":"Bridgewater North",
    "state_name":"Victoria"
  },
  {
    "postcode":3517,
    "place_name":"Glenalbyn",
    "state_name":"Victoria"
  },
  {
    "postcode":3517,
    "place_name":"Jarklin",
    "state_name":"Victoria"
  },
  {
    "postcode":3517,
    "place_name":"Serpentine",
    "state_name":"Victoria"
  },
  {
    "postcode":3517,
    "place_name":"Kurting",
    "state_name":"Victoria"
  },
  {
    "postcode":3517,
    "place_name":"Powlett Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3517,
    "place_name":"Salisbury West",
    "state_name":"Victoria"
  },
  {
    "postcode":3517,
    "place_name":"Inglewood",
    "state_name":"Victoria"
  },
  {
    "postcode":3517,
    "place_name":"Bears Lagoon",
    "state_name":"Victoria"
  },
  {
    "postcode":3517,
    "place_name":"Rheola",
    "state_name":"Victoria"
  },
  {
    "postcode":3517,
    "place_name":"Brenanah",
    "state_name":"Victoria"
  },
  {
    "postcode":3517,
    "place_name":"Kingower",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Richmond Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Skinners Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Borung",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Kurraca West",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Fernihurst",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Woolshed Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Berrimal",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Wedderburn Junction",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Mysia",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Wehla",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Nine Mile",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Fentons Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Woosang",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Kurraca",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Fiery Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3518,
    "place_name":"Wedderburn",
    "state_name":"Victoria"
  },
  {
    "postcode":3520,
    "place_name":"Korong Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3520,
    "place_name":"Kinypanial",
    "state_name":"Victoria"
  },
  {
    "postcode":3521,
    "place_name":"Pyalong",
    "state_name":"Victoria"
  },
  {
    "postcode":3522,
    "place_name":"Tooborac",
    "state_name":"Victoria"
  },
  {
    "postcode":3522,
    "place_name":"Glenhope East",
    "state_name":"Victoria"
  },
  {
    "postcode":3523,
    "place_name":"Costerfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3523,
    "place_name":"Derrinal",
    "state_name":"Victoria"
  },
  {
    "postcode":3523,
    "place_name":"Argyle",
    "state_name":"Victoria"
  },
  {
    "postcode":3523,
    "place_name":"Moormbool West",
    "state_name":"Victoria"
  },
  {
    "postcode":3523,
    "place_name":"Redcastle",
    "state_name":"Victoria"
  },
  {
    "postcode":3523,
    "place_name":"Heathcote",
    "state_name":"Victoria"
  },
  {
    "postcode":3523,
    "place_name":"Ladys Pass",
    "state_name":"Victoria"
  },
  {
    "postcode":3523,
    "place_name":"Knowsley",
    "state_name":"Victoria"
  },
  {
    "postcode":3523,
    "place_name":"Heathcote South",
    "state_name":"Victoria"
  },
  {
    "postcode":3523,
    "place_name":"Mount Camel",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Wychitella North",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Charlton",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Buckrabanyule",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Granite Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Wooroonook",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Yeungroon",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Barrakee",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Terrappee",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Wychitella",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Yeungroon East",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Chirrip",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Lake Marmal",
    "state_name":"Victoria"
  },
  {
    "postcode":3525,
    "place_name":"Nareewillock",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Jeruk",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Bunguluke",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Thalia",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Ninyeunook",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Towaninny South",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Glenloth",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Towaninny",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Wycheproof South",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Dumosa",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Teddywaddy West",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Wycheproof",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Glenloth East",
    "state_name":"Victoria"
  },
  {
    "postcode":3527,
    "place_name":"Teddywaddy",
    "state_name":"Victoria"
  },
  {
    "postcode":3529,
    "place_name":"Nullawil",
    "state_name":"Victoria"
  },
  {
    "postcode":3529,
    "place_name":"Kalpienung",
    "state_name":"Victoria"
  },
  {
    "postcode":3530,
    "place_name":"Warne",
    "state_name":"Victoria"
  },
  {
    "postcode":3530,
    "place_name":"Wangie",
    "state_name":"Victoria"
  },
  {
    "postcode":3530,
    "place_name":"Sutton",
    "state_name":"Victoria"
  },
  {
    "postcode":3530,
    "place_name":"Culgoa",
    "state_name":"Victoria"
  },
  {
    "postcode":3531,
    "place_name":"Boigbeat",
    "state_name":"Victoria"
  },
  {
    "postcode":3531,
    "place_name":"Berriwillock",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Sea Lake",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Lake Tyrrell",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Ninda",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Nyarrin",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Pier Milan",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Straten",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Nandaly",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Tyenna",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Tyrrell",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Bimbourie",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Tyrrell Downs",
    "state_name":"Victoria"
  },
  {
    "postcode":3533,
    "place_name":"Myall",
    "state_name":"Victoria"
  },
  {
    "postcode":3537,
    "place_name":"Canary Island",
    "state_name":"Victoria"
  },
  {
    "postcode":3537,
    "place_name":"Barraport West",
    "state_name":"Victoria"
  },
  {
    "postcode":3537,
    "place_name":"Gredgwin",
    "state_name":"Victoria"
  },
  {
    "postcode":3537,
    "place_name":"Leaghur",
    "state_name":"Victoria"
  },
  {
    "postcode":3537,
    "place_name":"Minmindie",
    "state_name":"Victoria"
  },
  {
    "postcode":3537,
    "place_name":"Catumnal",
    "state_name":"Victoria"
  },
  {
    "postcode":3537,
    "place_name":"Barraport",
    "state_name":"Victoria"
  },
  {
    "postcode":3537,
    "place_name":"Yando",
    "state_name":"Victoria"
  },
  {
    "postcode":3537,
    "place_name":"Boort",
    "state_name":"Victoria"
  },
  {
    "postcode":3540,
    "place_name":"Oakvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3540,
    "place_name":"Quambatook",
    "state_name":"Victoria"
  },
  {
    "postcode":3540,
    "place_name":"Cannie",
    "state_name":"Victoria"
  },
  {
    "postcode":3542,
    "place_name":"Lalbert",
    "state_name":"Victoria"
  },
  {
    "postcode":3542,
    "place_name":"Tittybong",
    "state_name":"Victoria"
  },
  {
    "postcode":3542,
    "place_name":"Cokum",
    "state_name":"Victoria"
  },
  {
    "postcode":3544,
    "place_name":"Gowanford",
    "state_name":"Victoria"
  },
  {
    "postcode":3544,
    "place_name":"Ultima East",
    "state_name":"Victoria"
  },
  {
    "postcode":3544,
    "place_name":"Waitchie",
    "state_name":"Victoria"
  },
  {
    "postcode":3544,
    "place_name":"Chinangin",
    "state_name":"Victoria"
  },
  {
    "postcode":3544,
    "place_name":"Springfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3544,
    "place_name":"Murnungin",
    "state_name":"Victoria"
  },
  {
    "postcode":3544,
    "place_name":"Ultima",
    "state_name":"Victoria"
  },
  {
    "postcode":3546,
    "place_name":"Chinkapook",
    "state_name":"Victoria"
  },
  {
    "postcode":3546,
    "place_name":"Gerahmin",
    "state_name":"Victoria"
  },
  {
    "postcode":3546,
    "place_name":"Turoar",
    "state_name":"Victoria"
  },
  {
    "postcode":3546,
    "place_name":"Manangatang",
    "state_name":"Victoria"
  },
  {
    "postcode":3546,
    "place_name":"Cocamba",
    "state_name":"Victoria"
  },
  {
    "postcode":3546,
    "place_name":"Bolton",
    "state_name":"Victoria"
  },
  {
    "postcode":3546,
    "place_name":"Winnambool",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Robinvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Robinvale Irrigation District Section B",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Annuello",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Happy Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Bannerton",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Tol Tol",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Wemen",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Robinvale Irrigation District Section E",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Wandown",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Robinvale Irrigation District Section D",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Liparoo",
    "state_name":"Victoria"
  },
  {
    "postcode":3549,
    "place_name":"Robinvale Irrigation District Section C",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"Flora Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"East Bendigo",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"North Bendigo",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"Strathdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"Kennington",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"Spring Gully",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"Long Gully",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"White Hills",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"West Bendigo",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"Bendigo South",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"Quarry Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"Ironbark",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"Tysons Reef",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"Bendigo",
    "state_name":"Victoria"
  },
  {
    "postcode":3550,
    "place_name":"Sandhurst East",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Toolleen",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Lake Eppalock",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Wellsford",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Myrtle Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Maiden Gully",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Huntly",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Arnold West",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Huntly North",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Emu Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Tarnagulla",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Lockwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Painswick",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Bendigo Forward",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Myola",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Waanyarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Junortoun",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Llanelly",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Longlea",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Mandurang",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Axedale",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Woodstock On Loddon",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Bagshot",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Murphys Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Bagshot North",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Newbridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Eppalock",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Arnold",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Axe Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Mandurang South",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Kimbolton",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Epsom",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Cornella",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Strathfieldsaye",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Lockwood South",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Ascot",
    "state_name":"Victoria"
  },
  {
    "postcode":3551,
    "place_name":"Sedgwick",
    "state_name":"Victoria"
  },
  {
    "postcode":3552,
    "place_name":"Bendigo",
    "state_name":"Victoria"
  },
  {
    "postcode":3554,
    "place_name":"Bendigo Dc",
    "state_name":"Victoria"
  },
  {
    "postcode":3555,
    "place_name":"Golden Gully",
    "state_name":"Victoria"
  },
  {
    "postcode":3555,
    "place_name":"Golden Square",
    "state_name":"Victoria"
  },
  {
    "postcode":3555,
    "place_name":"Kangaroo Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3555,
    "place_name":"Lansell Plaza",
    "state_name":"Victoria"
  },
  {
    "postcode":3555,
    "place_name":"Big Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3556,
    "place_name":"Campbells Forest",
    "state_name":"Victoria"
  },
  {
    "postcode":3556,
    "place_name":"Eaglehawk",
    "state_name":"Victoria"
  },
  {
    "postcode":3556,
    "place_name":"Sebastian",
    "state_name":"Victoria"
  },
  {
    "postcode":3556,
    "place_name":"Eaglehawk North",
    "state_name":"Victoria"
  },
  {
    "postcode":3556,
    "place_name":"California Gully",
    "state_name":"Victoria"
  },
  {
    "postcode":3556,
    "place_name":"Woodvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3556,
    "place_name":"Comet Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3556,
    "place_name":"Jackass Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3556,
    "place_name":"Myers Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3556,
    "place_name":"Whipstick",
    "state_name":"Victoria"
  },
  {
    "postcode":3556,
    "place_name":"Sailors Gully",
    "state_name":"Victoria"
  },
  {
    "postcode":3557,
    "place_name":"Goornong",
    "state_name":"Victoria"
  },
  {
    "postcode":3557,
    "place_name":"Barnadown",
    "state_name":"Victoria"
  },
  {
    "postcode":3557,
    "place_name":"Muskerry",
    "state_name":"Victoria"
  },
  {
    "postcode":3557,
    "place_name":"Fosterville",
    "state_name":"Victoria"
  },
  {
    "postcode":3558,
    "place_name":"Elmore",
    "state_name":"Victoria"
  },
  {
    "postcode":3558,
    "place_name":"Hunter",
    "state_name":"Victoria"
  },
  {
    "postcode":3558,
    "place_name":"Burnewang",
    "state_name":"Victoria"
  },
  {
    "postcode":3558,
    "place_name":"Runnymede",
    "state_name":"Victoria"
  },
  {
    "postcode":3558,
    "place_name":"Corop West",
    "state_name":"Victoria"
  },
  {
    "postcode":3559,
    "place_name":"Avonmore",
    "state_name":"Victoria"
  },
  {
    "postcode":3559,
    "place_name":"Gobarup",
    "state_name":"Victoria"
  },
  {
    "postcode":3559,
    "place_name":"Colbinabbin",
    "state_name":"Victoria"
  },
  {
    "postcode":3559,
    "place_name":"Corop",
    "state_name":"Victoria"
  },
  {
    "postcode":3559,
    "place_name":"Burramboot",
    "state_name":"Victoria"
  },
  {
    "postcode":3561,
    "place_name":"Fairy Dell",
    "state_name":"Victoria"
  },
  {
    "postcode":3561,
    "place_name":"Rochester",
    "state_name":"Victoria"
  },
  {
    "postcode":3561,
    "place_name":"Ballendella",
    "state_name":"Victoria"
  },
  {
    "postcode":3561,
    "place_name":"Bonn",
    "state_name":"Victoria"
  },
  {
    "postcode":3561,
    "place_name":"Timmering",
    "state_name":"Victoria"
  },
  {
    "postcode":3561,
    "place_name":"Nanneella",
    "state_name":"Victoria"
  },
  {
    "postcode":3561,
    "place_name":"Bamawm",
    "state_name":"Victoria"
  },
  {
    "postcode":3561,
    "place_name":"Diggora",
    "state_name":"Victoria"
  },
  {
    "postcode":3562,
    "place_name":"Torrumbarry",
    "state_name":"Victoria"
  },
  {
    "postcode":3563,
    "place_name":"Lockington",
    "state_name":"Victoria"
  },
  {
    "postcode":3564,
    "place_name":"Roslynmead",
    "state_name":"Victoria"
  },
  {
    "postcode":3564,
    "place_name":"Echuca South",
    "state_name":"Victoria"
  },
  {
    "postcode":3564,
    "place_name":"Wharparilla",
    "state_name":"Victoria"
  },
  {
    "postcode":3564,
    "place_name":"Simmie",
    "state_name":"Victoria"
  },
  {
    "postcode":3564,
    "place_name":"Echuca",
    "state_name":"Victoria"
  },
  {
    "postcode":3564,
    "place_name":"Echuca Village",
    "state_name":"Victoria"
  },
  {
    "postcode":3564,
    "place_name":"Bamawm Extension",
    "state_name":"Victoria"
  },
  {
    "postcode":3564,
    "place_name":"Kanyapella",
    "state_name":"Victoria"
  },
  {
    "postcode":3564,
    "place_name":"Echuca West",
    "state_name":"Victoria"
  },
  {
    "postcode":3564,
    "place_name":"Patho",
    "state_name":"Victoria"
  },
  {
    "postcode":3565,
    "place_name":"Kotta",
    "state_name":"Victoria"
  },
  {
    "postcode":3566,
    "place_name":"Gunbower",
    "state_name":"Victoria"
  },
  {
    "postcode":3567,
    "place_name":"Horfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3567,
    "place_name":"Leitchville",
    "state_name":"Victoria"
  },
  {
    "postcode":3568,
    "place_name":"Mead",
    "state_name":"Victoria"
  },
  {
    "postcode":3568,
    "place_name":"Cohuna",
    "state_name":"Victoria"
  },
  {
    "postcode":3568,
    "place_name":"Gannawarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3568,
    "place_name":"Macorna North",
    "state_name":"Victoria"
  },
  {
    "postcode":3568,
    "place_name":"Cullen",
    "state_name":"Victoria"
  },
  {
    "postcode":3568,
    "place_name":"Keely",
    "state_name":"Victoria"
  },
  {
    "postcode":3568,
    "place_name":"Mincha West",
    "state_name":"Victoria"
  },
  {
    "postcode":3568,
    "place_name":"Mcmillans",
    "state_name":"Victoria"
  },
  {
    "postcode":3568,
    "place_name":"Wee Wee Rup",
    "state_name":"Victoria"
  },
  {
    "postcode":3568,
    "place_name":"Daltons Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3568,
    "place_name":"Burkes Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3570,
    "place_name":"Kamarooka",
    "state_name":"Victoria"
  },
  {
    "postcode":3570,
    "place_name":"Raywood",
    "state_name":"Victoria"
  },
  {
    "postcode":3570,
    "place_name":"Drummartin",
    "state_name":"Victoria"
  },
  {
    "postcode":3570,
    "place_name":"Auchmore",
    "state_name":"Victoria"
  },
  {
    "postcode":3570,
    "place_name":"Neilborough",
    "state_name":"Victoria"
  },
  {
    "postcode":3571,
    "place_name":"Kamarooka North",
    "state_name":"Victoria"
  },
  {
    "postcode":3571,
    "place_name":"Dingee",
    "state_name":"Victoria"
  },
  {
    "postcode":3571,
    "place_name":"Pompapiel",
    "state_name":"Victoria"
  },
  {
    "postcode":3571,
    "place_name":"Tandarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3572,
    "place_name":"Tennyson",
    "state_name":"Victoria"
  },
  {
    "postcode":3572,
    "place_name":"Piavella",
    "state_name":"Victoria"
  },
  {
    "postcode":3572,
    "place_name":"Milloo",
    "state_name":"Victoria"
  },
  {
    "postcode":3572,
    "place_name":"Prairie",
    "state_name":"Victoria"
  },
  {
    "postcode":3573,
    "place_name":"Pine Grove",
    "state_name":"Victoria"
  },
  {
    "postcode":3573,
    "place_name":"Calivil",
    "state_name":"Victoria"
  },
  {
    "postcode":3573,
    "place_name":"Terrick Terrick East",
    "state_name":"Victoria"
  },
  {
    "postcode":3573,
    "place_name":"Mitiamo",
    "state_name":"Victoria"
  },
  {
    "postcode":3575,
    "place_name":"Gladfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3575,
    "place_name":"Mologa",
    "state_name":"Victoria"
  },
  {
    "postcode":3575,
    "place_name":"Sylvaterre",
    "state_name":"Victoria"
  },
  {
    "postcode":3575,
    "place_name":"Loddon Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3575,
    "place_name":"Pyramid Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3575,
    "place_name":"Yarrawalla",
    "state_name":"Victoria"
  },
  {
    "postcode":3575,
    "place_name":"Terrick Terrick",
    "state_name":"Victoria"
  },
  {
    "postcode":3575,
    "place_name":"Jungaburra",
    "state_name":"Victoria"
  },
  {
    "postcode":3575,
    "place_name":"Mincha",
    "state_name":"Victoria"
  },
  {
    "postcode":3576,
    "place_name":"Durham Ox",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Mystic Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Murrabit West",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Teal Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Kerang East",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Beauchamp",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Westby",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Sandhill Lake",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Koroop",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Appin South",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Wandella",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Budgerum East",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Macorna",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Capels Crossing",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Meering West",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Murrabit",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Benjeroop",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Tragowel",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Lake Meran",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Myall",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Gonn Crossing",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Normanville",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Fairley",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Milnes Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Pine View",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Reedy Lake",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Kerang",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Bael Bael",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Appin",
    "state_name":"Victoria"
  },
  {
    "postcode":3579,
    "place_name":"Dingwall",
    "state_name":"Victoria"
  },
  {
    "postcode":3580,
    "place_name":"Koondrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3581,
    "place_name":"Lake Charm",
    "state_name":"Victoria"
  },
  {
    "postcode":3583,
    "place_name":"Tresco",
    "state_name":"Victoria"
  },
  {
    "postcode":3584,
    "place_name":"Tresco West",
    "state_name":"Victoria"
  },
  {
    "postcode":3584,
    "place_name":"Lake Boga",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Kunat",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Goschen",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Nowie",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Winlaton",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Chillingollah",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Pira",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Meatian",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Speewa",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Fish Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Swan Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Nyrraby",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Castle Donnington",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Polisbet",
    "state_name":"Victoria"
  },
  {
    "postcode":3585,
    "place_name":"Swan Hill West",
    "state_name":"Victoria"
  },
  {
    "postcode":3586,
    "place_name":"Murrawee",
    "state_name":"Victoria"
  },
  {
    "postcode":3586,
    "place_name":"Pental Island",
    "state_name":"Victoria"
  },
  {
    "postcode":3586,
    "place_name":"Tyntynder South",
    "state_name":"Victoria"
  },
  {
    "postcode":3586,
    "place_name":"Bulga",
    "state_name":"Victoria"
  },
  {
    "postcode":3586,
    "place_name":"Tyntynder",
    "state_name":"Victoria"
  },
  {
    "postcode":3586,
    "place_name":"Murraydale",
    "state_name":"Victoria"
  },
  {
    "postcode":3588,
    "place_name":"Woorinen South",
    "state_name":"Victoria"
  },
  {
    "postcode":3589,
    "place_name":"Woorinen North",
    "state_name":"Victoria"
  },
  {
    "postcode":3589,
    "place_name":"Woorinen",
    "state_name":"Victoria"
  },
  {
    "postcode":3590,
    "place_name":"Beverford",
    "state_name":"Victoria"
  },
  {
    "postcode":3591,
    "place_name":"Vinifera",
    "state_name":"Victoria"
  },
  {
    "postcode":3594,
    "place_name":"Nyah",
    "state_name":"Victoria"
  },
  {
    "postcode":3595,
    "place_name":"Nyah West",
    "state_name":"Victoria"
  },
  {
    "postcode":3596,
    "place_name":"Miralie",
    "state_name":"Victoria"
  },
  {
    "postcode":3596,
    "place_name":"Wood Wood",
    "state_name":"Victoria"
  },
  {
    "postcode":3596,
    "place_name":"Towan",
    "state_name":"Victoria"
  },
  {
    "postcode":3597,
    "place_name":"Narrung",
    "state_name":"Victoria"
  },
  {
    "postcode":3597,
    "place_name":"Kooloonong",
    "state_name":"Victoria"
  },
  {
    "postcode":3597,
    "place_name":"Kenley",
    "state_name":"Victoria"
  },
  {
    "postcode":3597,
    "place_name":"Natya",
    "state_name":"Victoria"
  },
  {
    "postcode":3597,
    "place_name":"Piangil",
    "state_name":"Victoria"
  },
  {
    "postcode":3597,
    "place_name":"Lake Powell",
    "state_name":"Victoria"
  },
  {
    "postcode":3599,
    "place_name":"Boundary Bend",
    "state_name":"Victoria"
  },
  {
    "postcode":3607,
    "place_name":"Tabilk",
    "state_name":"Victoria"
  },
  {
    "postcode":3608,
    "place_name":"Kirwans Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3608,
    "place_name":"Bailieston",
    "state_name":"Victoria"
  },
  {
    "postcode":3608,
    "place_name":"Graytown",
    "state_name":"Victoria"
  },
  {
    "postcode":3608,
    "place_name":"Nagambie",
    "state_name":"Victoria"
  },
  {
    "postcode":3608,
    "place_name":"Goulburn Weir",
    "state_name":"Victoria"
  },
  {
    "postcode":3608,
    "place_name":"Mitchellstown",
    "state_name":"Victoria"
  },
  {
    "postcode":3608,
    "place_name":"Wahring",
    "state_name":"Victoria"
  },
  {
    "postcode":3608,
    "place_name":"Wirrate",
    "state_name":"Victoria"
  },
  {
    "postcode":3610,
    "place_name":"Murchison North",
    "state_name":"Victoria"
  },
  {
    "postcode":3610,
    "place_name":"Moorilim",
    "state_name":"Victoria"
  },
  {
    "postcode":3610,
    "place_name":"Dhurringile",
    "state_name":"Victoria"
  },
  {
    "postcode":3610,
    "place_name":"Murchison",
    "state_name":"Victoria"
  },
  {
    "postcode":3610,
    "place_name":"Murchison East",
    "state_name":"Victoria"
  },
  {
    "postcode":3612,
    "place_name":"Wanalta",
    "state_name":"Victoria"
  },
  {
    "postcode":3612,
    "place_name":"Moora",
    "state_name":"Victoria"
  },
  {
    "postcode":3612,
    "place_name":"Rushworth",
    "state_name":"Victoria"
  },
  {
    "postcode":3612,
    "place_name":"Whroo",
    "state_name":"Victoria"
  },
  {
    "postcode":3612,
    "place_name":"Waranga Shores",
    "state_name":"Victoria"
  },
  {
    "postcode":3614,
    "place_name":"Toolamba",
    "state_name":"Victoria"
  },
  {
    "postcode":3614,
    "place_name":"Toolamba West",
    "state_name":"Victoria"
  },
  {
    "postcode":3616,
    "place_name":"Waranga",
    "state_name":"Victoria"
  },
  {
    "postcode":3616,
    "place_name":"Girgarre East",
    "state_name":"Victoria"
  },
  {
    "postcode":3616,
    "place_name":"Tatura",
    "state_name":"Victoria"
  },
  {
    "postcode":3616,
    "place_name":"Harston",
    "state_name":"Victoria"
  },
  {
    "postcode":3616,
    "place_name":"Tatura East",
    "state_name":"Victoria"
  },
  {
    "postcode":3616,
    "place_name":"Gillieston",
    "state_name":"Victoria"
  },
  {
    "postcode":3616,
    "place_name":"Cooma",
    "state_name":"Victoria"
  },
  {
    "postcode":3616,
    "place_name":"Mooroopna North West",
    "state_name":"Victoria"
  },
  {
    "postcode":3617,
    "place_name":"Byrneside",
    "state_name":"Victoria"
  },
  {
    "postcode":3618,
    "place_name":"Merrigum",
    "state_name":"Victoria"
  },
  {
    "postcode":3619,
    "place_name":"Kyabram",
    "state_name":"Victoria"
  },
  {
    "postcode":3620,
    "place_name":"St Germains",
    "state_name":"Victoria"
  },
  {
    "postcode":3620,
    "place_name":"Wyuna",
    "state_name":"Victoria"
  },
  {
    "postcode":3620,
    "place_name":"Kyabram South",
    "state_name":"Victoria"
  },
  {
    "postcode":3620,
    "place_name":"Lancaster",
    "state_name":"Victoria"
  },
  {
    "postcode":3620,
    "place_name":"Wyuna East",
    "state_name":"Victoria"
  },
  {
    "postcode":3620,
    "place_name":"Kyabram",
    "state_name":"Victoria"
  },
  {
    "postcode":3621,
    "place_name":"Kyvalley",
    "state_name":"Victoria"
  },
  {
    "postcode":3621,
    "place_name":"Koyuga South",
    "state_name":"Victoria"
  },
  {
    "postcode":3621,
    "place_name":"Tongala",
    "state_name":"Victoria"
  },
  {
    "postcode":3621,
    "place_name":"Yambuna",
    "state_name":"Victoria"
  },
  {
    "postcode":3622,
    "place_name":"Koyuga",
    "state_name":"Victoria"
  },
  {
    "postcode":3622,
    "place_name":"Strathallan",
    "state_name":"Victoria"
  },
  {
    "postcode":3623,
    "place_name":"Stanhope",
    "state_name":"Victoria"
  },
  {
    "postcode":3623,
    "place_name":"Carag Carag",
    "state_name":"Victoria"
  },
  {
    "postcode":3623,
    "place_name":"Stanhope South",
    "state_name":"Victoria"
  },
  {
    "postcode":3624,
    "place_name":"Girgarre",
    "state_name":"Victoria"
  },
  {
    "postcode":3629,
    "place_name":"Mooroopna North",
    "state_name":"Victoria"
  },
  {
    "postcode":3629,
    "place_name":"Mooroopna",
    "state_name":"Victoria"
  },
  {
    "postcode":3629,
    "place_name":"Ardmona",
    "state_name":"Victoria"
  },
  {
    "postcode":3629,
    "place_name":"Undera",
    "state_name":"Victoria"
  },
  {
    "postcode":3629,
    "place_name":"Coomboona",
    "state_name":"Victoria"
  },
  {
    "postcode":3630,
    "place_name":"Shepparton",
    "state_name":"Victoria"
  },
  {
    "postcode":3630,
    "place_name":"Shepparton South",
    "state_name":"Victoria"
  },
  {
    "postcode":3630,
    "place_name":"Caniambo",
    "state_name":"Victoria"
  },
  {
    "postcode":3630,
    "place_name":"Benarch",
    "state_name":"Victoria"
  },
  {
    "postcode":3630,
    "place_name":"Colliver",
    "state_name":"Victoria"
  },
  {
    "postcode":3630,
    "place_name":"Branditt",
    "state_name":"Victoria"
  },
  {
    "postcode":3630,
    "place_name":"Dunkirk",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Kialla East",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Kialla",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Orrvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Arcadia South",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Pine Lodge",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Karramomus",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Lemnos",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Tamleugh West",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Grahamvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Kialla West",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Arcadia",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Shepparton North",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Cosgrove",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Cosgrove South",
    "state_name":"Victoria"
  },
  {
    "postcode":3631,
    "place_name":"Shepparton East",
    "state_name":"Victoria"
  },
  {
    "postcode":3632,
    "place_name":"Shepparton",
    "state_name":"Victoria"
  },
  {
    "postcode":3633,
    "place_name":"Congupna",
    "state_name":"Victoria"
  },
  {
    "postcode":3634,
    "place_name":"Invergordon South",
    "state_name":"Victoria"
  },
  {
    "postcode":3634,
    "place_name":"Tallygaroopna",
    "state_name":"Victoria"
  },
  {
    "postcode":3634,
    "place_name":"Bunbartha",
    "state_name":"Victoria"
  },
  {
    "postcode":3634,
    "place_name":"Katandra West",
    "state_name":"Victoria"
  },
  {
    "postcode":3634,
    "place_name":"Zeerust",
    "state_name":"Victoria"
  },
  {
    "postcode":3634,
    "place_name":"Katandra",
    "state_name":"Victoria"
  },
  {
    "postcode":3634,
    "place_name":"Marionvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3634,
    "place_name":"Marungi",
    "state_name":"Victoria"
  },
  {
    "postcode":3635,
    "place_name":"Wunghnu",
    "state_name":"Victoria"
  },
  {
    "postcode":3635,
    "place_name":"Kaarimba",
    "state_name":"Victoria"
  },
  {
    "postcode":3635,
    "place_name":"Mundoona",
    "state_name":"Victoria"
  },
  {
    "postcode":3636,
    "place_name":"Naring",
    "state_name":"Victoria"
  },
  {
    "postcode":3636,
    "place_name":"Numurkah",
    "state_name":"Victoria"
  },
  {
    "postcode":3636,
    "place_name":"Drumanure",
    "state_name":"Victoria"
  },
  {
    "postcode":3636,
    "place_name":"Invergordon",
    "state_name":"Victoria"
  },
  {
    "postcode":3637,
    "place_name":"Yalca",
    "state_name":"Victoria"
  },
  {
    "postcode":3637,
    "place_name":"Waaia",
    "state_name":"Victoria"
  },
  {
    "postcode":3638,
    "place_name":"Nathalia",
    "state_name":"Victoria"
  },
  {
    "postcode":3638,
    "place_name":"Yielima",
    "state_name":"Victoria"
  },
  {
    "postcode":3638,
    "place_name":"Kotupna",
    "state_name":"Victoria"
  },
  {
    "postcode":3639,
    "place_name":"Barmah",
    "state_name":"Victoria"
  },
  {
    "postcode":3639,
    "place_name":"Picola West",
    "state_name":"Victoria"
  },
  {
    "postcode":3639,
    "place_name":"Lower Moira",
    "state_name":"Victoria"
  },
  {
    "postcode":3639,
    "place_name":"Picola",
    "state_name":"Victoria"
  },
  {
    "postcode":3640,
    "place_name":"Katunga",
    "state_name":"Victoria"
  },
  {
    "postcode":3641,
    "place_name":"Bearii",
    "state_name":"Victoria"
  },
  {
    "postcode":3641,
    "place_name":"Strathmerton",
    "state_name":"Victoria"
  },
  {
    "postcode":3641,
    "place_name":"Ulupna",
    "state_name":"Victoria"
  },
  {
    "postcode":3641,
    "place_name":"Mywee",
    "state_name":"Victoria"
  },
  {
    "postcode":3643,
    "place_name":"Cobram",
    "state_name":"Victoria"
  },
  {
    "postcode":3644,
    "place_name":"Koonoomoo",
    "state_name":"Victoria"
  },
  {
    "postcode":3644,
    "place_name":"Cobram",
    "state_name":"Victoria"
  },
  {
    "postcode":3644,
    "place_name":"Muckatah",
    "state_name":"Victoria"
  },
  {
    "postcode":3644,
    "place_name":"Yarroweyah",
    "state_name":"Victoria"
  },
  {
    "postcode":3644,
    "place_name":"Cobram East",
    "state_name":"Victoria"
  },
  {
    "postcode":3646,
    "place_name":"Nalinga",
    "state_name":"Victoria"
  },
  {
    "postcode":3646,
    "place_name":"Dookie",
    "state_name":"Victoria"
  },
  {
    "postcode":3646,
    "place_name":"Mount Major",
    "state_name":"Victoria"
  },
  {
    "postcode":3646,
    "place_name":"Yabba South",
    "state_name":"Victoria"
  },
  {
    "postcode":3646,
    "place_name":"Waggarandall",
    "state_name":"Victoria"
  },
  {
    "postcode":3646,
    "place_name":"Youanmite",
    "state_name":"Victoria"
  },
  {
    "postcode":3646,
    "place_name":"Yabba North",
    "state_name":"Victoria"
  },
  {
    "postcode":3647,
    "place_name":"Dookie College",
    "state_name":"Victoria"
  },
  {
    "postcode":3649,
    "place_name":"Katamatite East",
    "state_name":"Victoria"
  },
  {
    "postcode":3649,
    "place_name":"Katamatite",
    "state_name":"Victoria"
  },
  {
    "postcode":3658,
    "place_name":"Waterford Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3658,
    "place_name":"Clonbinane",
    "state_name":"Victoria"
  },
  {
    "postcode":3658,
    "place_name":"Tyaak",
    "state_name":"Victoria"
  },
  {
    "postcode":3658,
    "place_name":"Strath Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3658,
    "place_name":"Broadford",
    "state_name":"Victoria"
  },
  {
    "postcode":3658,
    "place_name":"Sugarloaf Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3658,
    "place_name":"Reedy Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3658,
    "place_name":"Sunday Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3658,
    "place_name":"Hazeldene",
    "state_name":"Victoria"
  },
  {
    "postcode":3659,
    "place_name":"Tallarook",
    "state_name":"Victoria"
  },
  {
    "postcode":3660,
    "place_name":"Northwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3660,
    "place_name":"Dropmore",
    "state_name":"Victoria"
  },
  {
    "postcode":3660,
    "place_name":"Seymour South",
    "state_name":"Victoria"
  },
  {
    "postcode":3660,
    "place_name":"Seymour",
    "state_name":"Victoria"
  },
  {
    "postcode":3660,
    "place_name":"Whiteheads Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3660,
    "place_name":"Trawool",
    "state_name":"Victoria"
  },
  {
    "postcode":3660,
    "place_name":"Caveat",
    "state_name":"Victoria"
  },
  {
    "postcode":3660,
    "place_name":"Kerrisdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3660,
    "place_name":"Highlands",
    "state_name":"Victoria"
  },
  {
    "postcode":3660,
    "place_name":"Hilldene",
    "state_name":"Victoria"
  },
  {
    "postcode":3661,
    "place_name":"Seymour",
    "state_name":"Victoria"
  },
  {
    "postcode":3662,
    "place_name":"Puckapunyal Milpo",
    "state_name":"Victoria"
  },
  {
    "postcode":3662,
    "place_name":"Puckapunyal",
    "state_name":"Victoria"
  },
  {
    "postcode":3663,
    "place_name":"Mangalore",
    "state_name":"Victoria"
  },
  {
    "postcode":3664,
    "place_name":"Upton Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3664,
    "place_name":"Avenel",
    "state_name":"Victoria"
  },
  {
    "postcode":3665,
    "place_name":"Longwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3665,
    "place_name":"Locksley",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Miepoll",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Strathbogie",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Creightons Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Gooram",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Kelvin View",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Ruffy",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Kithbrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Creighton",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Balmattum",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Pranjip",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Euroa",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Moglonemby",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Molka",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Tarcombe",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Longwood East",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Riggs Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3666,
    "place_name":"Sheans Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3669,
    "place_name":"Earlston",
    "state_name":"Victoria"
  },
  {
    "postcode":3669,
    "place_name":"Boho",
    "state_name":"Victoria"
  },
  {
    "postcode":3669,
    "place_name":"Tamleugh North",
    "state_name":"Victoria"
  },
  {
    "postcode":3669,
    "place_name":"Koonda",
    "state_name":"Victoria"
  },
  {
    "postcode":3669,
    "place_name":"Marraweeney",
    "state_name":"Victoria"
  },
  {
    "postcode":3669,
    "place_name":"Violet Town",
    "state_name":"Victoria"
  },
  {
    "postcode":3669,
    "place_name":"Upotipotpon",
    "state_name":"Victoria"
  },
  {
    "postcode":3669,
    "place_name":"Boho South",
    "state_name":"Victoria"
  },
  {
    "postcode":3669,
    "place_name":"Gowangardie",
    "state_name":"Victoria"
  },
  {
    "postcode":3669,
    "place_name":"Tamleugh",
    "state_name":"Victoria"
  },
  {
    "postcode":3669,
    "place_name":"Creek Junction",
    "state_name":"Victoria"
  },
  {
    "postcode":3670,
    "place_name":"Tarnook",
    "state_name":"Victoria"
  },
  {
    "postcode":3670,
    "place_name":"Warrenbayne",
    "state_name":"Victoria"
  },
  {
    "postcode":3670,
    "place_name":"Baddaginnie",
    "state_name":"Victoria"
  },
  {
    "postcode":3671,
    "place_name":"Benalla",
    "state_name":"Victoria"
  },
  {
    "postcode":3672,
    "place_name":"Benalla",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Goomalibee",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Upper Ryans Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Tatong",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Swanpool",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Samaria",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Upper Lurg",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Moorngag",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Winton",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Benalla",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Broken Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Molyullah",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Winton North",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Lurg",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Lima East",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Lima",
    "state_name":"Victoria"
  },
  {
    "postcode":3673,
    "place_name":"Lima South",
    "state_name":"Victoria"
  },
  {
    "postcode":3675,
    "place_name":"Boweya",
    "state_name":"Victoria"
  },
  {
    "postcode":3675,
    "place_name":"Greta",
    "state_name":"Victoria"
  },
  {
    "postcode":3675,
    "place_name":"Taminick",
    "state_name":"Victoria"
  },
  {
    "postcode":3675,
    "place_name":"Mount Bruno",
    "state_name":"Victoria"
  },
  {
    "postcode":3675,
    "place_name":"Greta West",
    "state_name":"Victoria"
  },
  {
    "postcode":3675,
    "place_name":"Glenrowan",
    "state_name":"Victoria"
  },
  {
    "postcode":3675,
    "place_name":"Glenrowan West",
    "state_name":"Victoria"
  },
  {
    "postcode":3675,
    "place_name":"Boweya North",
    "state_name":"Victoria"
  },
  {
    "postcode":3675,
    "place_name":"Greta South",
    "state_name":"Victoria"
  },
  {
    "postcode":3675,
    "place_name":"Hansonville",
    "state_name":"Victoria"
  },
  {
    "postcode":3676,
    "place_name":"Wangaratta",
    "state_name":"Victoria"
  },
  {
    "postcode":3677,
    "place_name":"Yarrunga",
    "state_name":"Victoria"
  },
  {
    "postcode":3677,
    "place_name":"Wangaratta",
    "state_name":"Victoria"
  },
  {
    "postcode":3677,
    "place_name":"Appin Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Oxley Flats",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Rose River",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Edi",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Meadow Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Waldara",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Everton Upper",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Tarrawingee",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Boorhaman",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Killawarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Wangaratta Forward",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Peechelba",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Wangandary",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Bobinawarrah",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Wangaratta South",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"North Wangaratta",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"King Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Edi Upper",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Boorhaman East",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Docker",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Peechelba East",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Markwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Dockers Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Oxley",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Wabonga",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Byawatha",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Cheshunt South",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Londrigan",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Bowser",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Everton",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Whitlands",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Cheshunt",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"East Wangaratta",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Laceby",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Carboor",
    "state_name":"Victoria"
  },
  {
    "postcode":3678,
    "place_name":"Milawa",
    "state_name":"Victoria"
  },
  {
    "postcode":3682,
    "place_name":"Norong",
    "state_name":"Victoria"
  },
  {
    "postcode":3682,
    "place_name":"Boralma",
    "state_name":"Victoria"
  },
  {
    "postcode":3682,
    "place_name":"Springhurst",
    "state_name":"Victoria"
  },
  {
    "postcode":3682,
    "place_name":"Lilliput",
    "state_name":"Victoria"
  },
  {
    "postcode":3683,
    "place_name":"Chiltern Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3683,
    "place_name":"Cornishtown",
    "state_name":"Victoria"
  },
  {
    "postcode":3683,
    "place_name":"Chiltern",
    "state_name":"Victoria"
  },
  {
    "postcode":3685,
    "place_name":"Prentice North",
    "state_name":"Victoria"
  },
  {
    "postcode":3685,
    "place_name":"Boorhaman North",
    "state_name":"Victoria"
  },
  {
    "postcode":3685,
    "place_name":"Browns Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3685,
    "place_name":"Brimin",
    "state_name":"Victoria"
  },
  {
    "postcode":3685,
    "place_name":"Rutherglen",
    "state_name":"Victoria"
  },
  {
    "postcode":3685,
    "place_name":"Gooramadda",
    "state_name":"Victoria"
  },
  {
    "postcode":3685,
    "place_name":"Great Southern",
    "state_name":"Victoria"
  },
  {
    "postcode":3685,
    "place_name":"Carlyle",
    "state_name":"Victoria"
  },
  {
    "postcode":3687,
    "place_name":"Wahgunyah",
    "state_name":"Victoria"
  },
  {
    "postcode":3688,
    "place_name":"Indigo Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3688,
    "place_name":"Barnawartha",
    "state_name":"Victoria"
  },
  {
    "postcode":3689,
    "place_name":"Wodonga",
    "state_name":"Victoria"
  },
  {
    "postcode":3690,
    "place_name":"Wodonga",
    "state_name":"Victoria"
  },
  {
    "postcode":3690,
    "place_name":"Wodonga Plaza",
    "state_name":"Victoria"
  },
  {
    "postcode":3690,
    "place_name":"West Wodonga",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Killara",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Castle Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Upper Gundowring",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Bandiana",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Bethanga",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Baranduda",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Allans Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Mount Alfred",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Bellbridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Kergunyah South",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Berringama",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Coral Bank",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Talgarno",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Kergunyah",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Gundowring",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Lone Pine",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Glen Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Tangambalanga",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Dederang",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Wodonga Forward",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Hume Weir",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Bonegilla",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Kancoona",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Thologolong",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Running Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Kiewa",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Bungil",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Gateway Island",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Lucyvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Osbornes Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Leneva",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Barnawartha North",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Mongans Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Huon Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Staghorn Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3691,
    "place_name":"Ebden",
    "state_name":"Victoria"
  },
  {
    "postcode":3694,
    "place_name":"Bandiana Milpo",
    "state_name":"Victoria"
  },
  {
    "postcode":3695,
    "place_name":"Huon",
    "state_name":"Victoria"
  },
  {
    "postcode":3695,
    "place_name":"Charleroi",
    "state_name":"Victoria"
  },
  {
    "postcode":3695,
    "place_name":"Sandy Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3695,
    "place_name":"Red Bluff",
    "state_name":"Victoria"
  },
  {
    "postcode":3697,
    "place_name":"Tawonga",
    "state_name":"Victoria"
  },
  {
    "postcode":3698,
    "place_name":"Tawonga South",
    "state_name":"Victoria"
  },
  {
    "postcode":3699,
    "place_name":"Mount Beauty",
    "state_name":"Victoria"
  },
  {
    "postcode":3699,
    "place_name":"Nelse",
    "state_name":"Victoria"
  },
  {
    "postcode":3699,
    "place_name":"Falls Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3699,
    "place_name":"Bogong",
    "state_name":"Victoria"
  },
  {
    "postcode":3700,
    "place_name":"Georges Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3700,
    "place_name":"Tallangatta",
    "state_name":"Victoria"
  },
  {
    "postcode":3700,
    "place_name":"Jarvis Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3700,
    "place_name":"Bullioh",
    "state_name":"Victoria"
  },
  {
    "postcode":3700,
    "place_name":"Tallangatta East",
    "state_name":"Victoria"
  },
  {
    "postcode":3701,
    "place_name":"Tallandoon",
    "state_name":"Victoria"
  },
  {
    "postcode":3701,
    "place_name":"Shelley",
    "state_name":"Victoria"
  },
  {
    "postcode":3701,
    "place_name":"Old Tallangatta",
    "state_name":"Victoria"
  },
  {
    "postcode":3701,
    "place_name":"Tallangatta South",
    "state_name":"Victoria"
  },
  {
    "postcode":3701,
    "place_name":"Mitta Mitta",
    "state_name":"Victoria"
  },
  {
    "postcode":3701,
    "place_name":"Eskdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3701,
    "place_name":"Tallangatta Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3701,
    "place_name":"Dartmouth",
    "state_name":"Victoria"
  },
  {
    "postcode":3701,
    "place_name":"Granya",
    "state_name":"Victoria"
  },
  {
    "postcode":3704,
    "place_name":"Koetong",
    "state_name":"Victoria"
  },
  {
    "postcode":3705,
    "place_name":"Nariel Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3705,
    "place_name":"Cudgewa",
    "state_name":"Victoria"
  },
  {
    "postcode":3707,
    "place_name":"Biggara",
    "state_name":"Victoria"
  },
  {
    "postcode":3707,
    "place_name":"Tom Groggin",
    "state_name":"Victoria"
  },
  {
    "postcode":3707,
    "place_name":"Towong",
    "state_name":"Victoria"
  },
  {
    "postcode":3707,
    "place_name":"Corryong",
    "state_name":"Victoria"
  },
  {
    "postcode":3707,
    "place_name":"Thowgla Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3707,
    "place_name":"Colac Colac",
    "state_name":"Victoria"
  },
  {
    "postcode":3707,
    "place_name":"Towong Upper",
    "state_name":"Victoria"
  },
  {
    "postcode":3707,
    "place_name":"Nariel Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3708,
    "place_name":"Tintaldra",
    "state_name":"Victoria"
  },
  {
    "postcode":3709,
    "place_name":"Walwa",
    "state_name":"Victoria"
  },
  {
    "postcode":3709,
    "place_name":"Mount Alfred",
    "state_name":"Victoria"
  },
  {
    "postcode":3709,
    "place_name":"Burrowye",
    "state_name":"Victoria"
  },
  {
    "postcode":3709,
    "place_name":"Guys Forest",
    "state_name":"Victoria"
  },
  {
    "postcode":3709,
    "place_name":"Pine Mountain",
    "state_name":"Victoria"
  },
  {
    "postcode":3711,
    "place_name":"Buxton",
    "state_name":"Victoria"
  },
  {
    "postcode":3712,
    "place_name":"Thornton",
    "state_name":"Victoria"
  },
  {
    "postcode":3712,
    "place_name":"Rubicon",
    "state_name":"Victoria"
  },
  {
    "postcode":3713,
    "place_name":"Eildon",
    "state_name":"Victoria"
  },
  {
    "postcode":3713,
    "place_name":"Lake Eildon",
    "state_name":"Victoria"
  },
  {
    "postcode":3713,
    "place_name":"Taylor Bay",
    "state_name":"Victoria"
  },
  {
    "postcode":3714,
    "place_name":"Alexandra",
    "state_name":"Victoria"
  },
  {
    "postcode":3714,
    "place_name":"Acheron",
    "state_name":"Victoria"
  },
  {
    "postcode":3714,
    "place_name":"Cathkin",
    "state_name":"Victoria"
  },
  {
    "postcode":3714,
    "place_name":"Maintongoon",
    "state_name":"Victoria"
  },
  {
    "postcode":3714,
    "place_name":"Koriella",
    "state_name":"Victoria"
  },
  {
    "postcode":3714,
    "place_name":"Whanregarwen",
    "state_name":"Victoria"
  },
  {
    "postcode":3714,
    "place_name":"Fawcett",
    "state_name":"Victoria"
  },
  {
    "postcode":3714,
    "place_name":"Crystal Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3714,
    "place_name":"Taggerty",
    "state_name":"Victoria"
  },
  {
    "postcode":3714,
    "place_name":"Devils River",
    "state_name":"Victoria"
  },
  {
    "postcode":3715,
    "place_name":"Merton",
    "state_name":"Victoria"
  },
  {
    "postcode":3715,
    "place_name":"Ancona",
    "state_name":"Victoria"
  },
  {
    "postcode":3715,
    "place_name":"Woodfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3717,
    "place_name":"Flowerdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3717,
    "place_name":"Homewood",
    "state_name":"Victoria"
  },
  {
    "postcode":3717,
    "place_name":"Killingworth",
    "state_name":"Victoria"
  },
  {
    "postcode":3717,
    "place_name":"Yea",
    "state_name":"Victoria"
  },
  {
    "postcode":3717,
    "place_name":"Limestone",
    "state_name":"Victoria"
  },
  {
    "postcode":3717,
    "place_name":"Murrindindi",
    "state_name":"Victoria"
  },
  {
    "postcode":3717,
    "place_name":"Ghin Ghin",
    "state_name":"Victoria"
  },
  {
    "postcode":3717,
    "place_name":"Glenburn",
    "state_name":"Victoria"
  },
  {
    "postcode":3718,
    "place_name":"Molesworth",
    "state_name":"Victoria"
  },
  {
    "postcode":3719,
    "place_name":"Yarck",
    "state_name":"Victoria"
  },
  {
    "postcode":3719,
    "place_name":"Gobur",
    "state_name":"Victoria"
  },
  {
    "postcode":3719,
    "place_name":"Terip Terip",
    "state_name":"Victoria"
  },
  {
    "postcode":3719,
    "place_name":"Kanumbra",
    "state_name":"Victoria"
  },
  {
    "postcode":3720,
    "place_name":"Bonnie Doon",
    "state_name":"Victoria"
  },
  {
    "postcode":3722,
    "place_name":"Barwite",
    "state_name":"Victoria"
  },
  {
    "postcode":3722,
    "place_name":"Mirimbah",
    "state_name":"Victoria"
  },
  {
    "postcode":3722,
    "place_name":"Mansfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Howes Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Howqua Inlet",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Gaffneys Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Enochs Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Archerton",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Sawmill Settlement",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Knockwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Howqua",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Mount Buller",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Mountain Bay",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Goughs Bay",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Howqua Hills",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Delatite",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Kevington",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Piries",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Matlock",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Merrijig",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Barjarg",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Maindample",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Boorolite",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Woods Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Bridge Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Macs Cove",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Jamieson",
    "state_name":"Victoria"
  },
  {
    "postcode":3723,
    "place_name":"Tolmie",
    "state_name":"Victoria"
  },
  {
    "postcode":3724,
    "place_name":"Mansfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3725,
    "place_name":"Goorambat",
    "state_name":"Victoria"
  },
  {
    "postcode":3725,
    "place_name":"Chesney Vale",
    "state_name":"Victoria"
  },
  {
    "postcode":3725,
    "place_name":"Boxwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3725,
    "place_name":"Major Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3725,
    "place_name":"Stewarton",
    "state_name":"Victoria"
  },
  {
    "postcode":3726,
    "place_name":"Bungeet",
    "state_name":"Victoria"
  },
  {
    "postcode":3726,
    "place_name":"Bungeet West",
    "state_name":"Victoria"
  },
  {
    "postcode":3726,
    "place_name":"Thoona",
    "state_name":"Victoria"
  },
  {
    "postcode":3726,
    "place_name":"Devenish",
    "state_name":"Victoria"
  },
  {
    "postcode":3727,
    "place_name":"Yundool",
    "state_name":"Victoria"
  },
  {
    "postcode":3727,
    "place_name":"Almonds",
    "state_name":"Victoria"
  },
  {
    "postcode":3727,
    "place_name":"Lake Rowan",
    "state_name":"Victoria"
  },
  {
    "postcode":3727,
    "place_name":"Pelluebla",
    "state_name":"Victoria"
  },
  {
    "postcode":3727,
    "place_name":"St James",
    "state_name":"Victoria"
  },
  {
    "postcode":3728,
    "place_name":"Tungamah",
    "state_name":"Victoria"
  },
  {
    "postcode":3728,
    "place_name":"Boomahnoomoonah",
    "state_name":"Victoria"
  },
  {
    "postcode":3728,
    "place_name":"Wilby",
    "state_name":"Victoria"
  },
  {
    "postcode":3728,
    "place_name":"Youarang",
    "state_name":"Victoria"
  },
  {
    "postcode":3730,
    "place_name":"Burramine",
    "state_name":"Victoria"
  },
  {
    "postcode":3730,
    "place_name":"Yarrawonga",
    "state_name":"Victoria"
  },
  {
    "postcode":3730,
    "place_name":"Esmond",
    "state_name":"Victoria"
  },
  {
    "postcode":3730,
    "place_name":"Boosey",
    "state_name":"Victoria"
  },
  {
    "postcode":3730,
    "place_name":"Bathumi",
    "state_name":"Victoria"
  },
  {
    "postcode":3730,
    "place_name":"Bundalong",
    "state_name":"Victoria"
  },
  {
    "postcode":3730,
    "place_name":"Yarrawonga South",
    "state_name":"Victoria"
  },
  {
    "postcode":3730,
    "place_name":"Telford",
    "state_name":"Victoria"
  },
  {
    "postcode":3730,
    "place_name":"Burramine South",
    "state_name":"Victoria"
  },
  {
    "postcode":3730,
    "place_name":"Bundalong South",
    "state_name":"Victoria"
  },
  {
    "postcode":3732,
    "place_name":"Moyhu",
    "state_name":"Victoria"
  },
  {
    "postcode":3732,
    "place_name":"Myrrhee",
    "state_name":"Victoria"
  },
  {
    "postcode":3733,
    "place_name":"Whitfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3735,
    "place_name":"Whorouly South",
    "state_name":"Victoria"
  },
  {
    "postcode":3735,
    "place_name":"Whorouly",
    "state_name":"Victoria"
  },
  {
    "postcode":3735,
    "place_name":"Bowmans Forest",
    "state_name":"Victoria"
  },
  {
    "postcode":3735,
    "place_name":"Whorouly East",
    "state_name":"Victoria"
  },
  {
    "postcode":3736,
    "place_name":"Myrtleford",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Buffalo River",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Abbeyard",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Myrtleford",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Gapsted",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Mudgegonga",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Nug Nug",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Merriang South",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Havilah",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Wonnangatta",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Rosewhite",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Merriang",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Barwidgee",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Selwyn",
    "state_name":"Victoria"
  },
  {
    "postcode":3737,
    "place_name":"Dandongadale",
    "state_name":"Victoria"
  },
  {
    "postcode":3738,
    "place_name":"Ovens",
    "state_name":"Victoria"
  },
  {
    "postcode":3739,
    "place_name":"Eurobin",
    "state_name":"Victoria"
  },
  {
    "postcode":3740,
    "place_name":"Mount Buffalo",
    "state_name":"Victoria"
  },
  {
    "postcode":3740,
    "place_name":"Porepunkah",
    "state_name":"Victoria"
  },
  {
    "postcode":3740,
    "place_name":"Buckland",
    "state_name":"Victoria"
  },
  {
    "postcode":3741,
    "place_name":"Smoko",
    "state_name":"Victoria"
  },
  {
    "postcode":3741,
    "place_name":"Mount Hotham",
    "state_name":"Victoria"
  },
  {
    "postcode":3741,
    "place_name":"Bright",
    "state_name":"Victoria"
  },
  {
    "postcode":3741,
    "place_name":"Germantown",
    "state_name":"Victoria"
  },
  {
    "postcode":3741,
    "place_name":"Hotham Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3741,
    "place_name":"Harrietville",
    "state_name":"Victoria"
  },
  {
    "postcode":3741,
    "place_name":"Freeburgh",
    "state_name":"Victoria"
  },
  {
    "postcode":3744,
    "place_name":"Wandiligong",
    "state_name":"Victoria"
  },
  {
    "postcode":3746,
    "place_name":"Eldorado",
    "state_name":"Victoria"
  },
  {
    "postcode":3747,
    "place_name":"Wooragee",
    "state_name":"Victoria"
  },
  {
    "postcode":3747,
    "place_name":"Baarmutha",
    "state_name":"Victoria"
  },
  {
    "postcode":3747,
    "place_name":"Murmungee",
    "state_name":"Victoria"
  },
  {
    "postcode":3747,
    "place_name":"Stanley",
    "state_name":"Victoria"
  },
  {
    "postcode":3747,
    "place_name":"Beechworth",
    "state_name":"Victoria"
  },
  {
    "postcode":3749,
    "place_name":"Bruarong",
    "state_name":"Victoria"
  },
  {
    "postcode":3749,
    "place_name":"Yackandandah",
    "state_name":"Victoria"
  },
  {
    "postcode":3750,
    "place_name":"Wollert",
    "state_name":"Victoria"
  },
  {
    "postcode":3751,
    "place_name":"Woodstock",
    "state_name":"Victoria"
  },
  {
    "postcode":3752,
    "place_name":"South Morang",
    "state_name":"Victoria"
  },
  {
    "postcode":3753,
    "place_name":"Beveridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3754,
    "place_name":"Mernda",
    "state_name":"Victoria"
  },
  {
    "postcode":3754,
    "place_name":"Doreen",
    "state_name":"Victoria"
  },
  {
    "postcode":3755,
    "place_name":"Yan Yean",
    "state_name":"Victoria"
  },
  {
    "postcode":3756,
    "place_name":"Hidden Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3756,
    "place_name":"Upper Plenty",
    "state_name":"Victoria"
  },
  {
    "postcode":3756,
    "place_name":"Chintin",
    "state_name":"Victoria"
  },
  {
    "postcode":3756,
    "place_name":"Wallan",
    "state_name":"Victoria"
  },
  {
    "postcode":3756,
    "place_name":"Darraweit Guim",
    "state_name":"Victoria"
  },
  {
    "postcode":3757,
    "place_name":"Kinglake Central",
    "state_name":"Victoria"
  },
  {
    "postcode":3757,
    "place_name":"Pheasant Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3757,
    "place_name":"Humevale",
    "state_name":"Victoria"
  },
  {
    "postcode":3757,
    "place_name":"Kinglake West",
    "state_name":"Victoria"
  },
  {
    "postcode":3757,
    "place_name":"Whittlesea",
    "state_name":"Victoria"
  },
  {
    "postcode":3757,
    "place_name":"Eden Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3758,
    "place_name":"Wandong",
    "state_name":"Victoria"
  },
  {
    "postcode":3758,
    "place_name":"Heathcote Junction",
    "state_name":"Victoria"
  },
  {
    "postcode":3759,
    "place_name":"Panton Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3760,
    "place_name":"Smiths Gully",
    "state_name":"Victoria"
  },
  {
    "postcode":3761,
    "place_name":"St Andrews",
    "state_name":"Victoria"
  },
  {
    "postcode":3762,
    "place_name":"Bylands",
    "state_name":"Victoria"
  },
  {
    "postcode":3763,
    "place_name":"Kinglake",
    "state_name":"Victoria"
  },
  {
    "postcode":3764,
    "place_name":"Tantaraboo",
    "state_name":"Victoria"
  },
  {
    "postcode":3764,
    "place_name":"Kilmore",
    "state_name":"Victoria"
  },
  {
    "postcode":3764,
    "place_name":"High Camp",
    "state_name":"Victoria"
  },
  {
    "postcode":3764,
    "place_name":"Kilmore East",
    "state_name":"Victoria"
  },
  {
    "postcode":3764,
    "place_name":"Moranding",
    "state_name":"Victoria"
  },
  {
    "postcode":3764,
    "place_name":"Forbes",
    "state_name":"Victoria"
  },
  {
    "postcode":3764,
    "place_name":"Glenaroua",
    "state_name":"Victoria"
  },
  {
    "postcode":3764,
    "place_name":"Willowmavin",
    "state_name":"Victoria"
  },
  {
    "postcode":3765,
    "place_name":"Montrose",
    "state_name":"Victoria"
  },
  {
    "postcode":3766,
    "place_name":"Kalorama",
    "state_name":"Victoria"
  },
  {
    "postcode":3767,
    "place_name":"Mount Dandenong",
    "state_name":"Victoria"
  },
  {
    "postcode":3770,
    "place_name":"Coldstream",
    "state_name":"Victoria"
  },
  {
    "postcode":3770,
    "place_name":"Gruyere",
    "state_name":"Victoria"
  },
  {
    "postcode":3770,
    "place_name":"Yering",
    "state_name":"Victoria"
  },
  {
    "postcode":3775,
    "place_name":"Dixons Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3775,
    "place_name":"Yarra Glen",
    "state_name":"Victoria"
  },
  {
    "postcode":3775,
    "place_name":"Christmas Hills",
    "state_name":"Victoria"
  },
  {
    "postcode":3775,
    "place_name":"Steels Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3775,
    "place_name":"Tarrawarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3777,
    "place_name":"Healesville",
    "state_name":"Victoria"
  },
  {
    "postcode":3777,
    "place_name":"Chum Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3777,
    "place_name":"Healesville Main Street",
    "state_name":"Victoria"
  },
  {
    "postcode":3777,
    "place_name":"Badger Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3777,
    "place_name":"Toolangi",
    "state_name":"Victoria"
  },
  {
    "postcode":3777,
    "place_name":"Castella",
    "state_name":"Victoria"
  },
  {
    "postcode":3777,
    "place_name":"Mount Toolebewong",
    "state_name":"Victoria"
  },
  {
    "postcode":3778,
    "place_name":"Narbethong",
    "state_name":"Victoria"
  },
  {
    "postcode":3778,
    "place_name":"Fernshaw",
    "state_name":"Victoria"
  },
  {
    "postcode":3779,
    "place_name":"Cambarville",
    "state_name":"Victoria"
  },
  {
    "postcode":3779,
    "place_name":"Marysville",
    "state_name":"Victoria"
  },
  {
    "postcode":3781,
    "place_name":"Mount Burnett",
    "state_name":"Victoria"
  },
  {
    "postcode":3781,
    "place_name":"Nangana",
    "state_name":"Victoria"
  },
  {
    "postcode":3781,
    "place_name":"Cockatoo",
    "state_name":"Victoria"
  },
  {
    "postcode":3782,
    "place_name":"Avonsleigh",
    "state_name":"Victoria"
  },
  {
    "postcode":3782,
    "place_name":"Macclesfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3782,
    "place_name":"Clematis",
    "state_name":"Victoria"
  },
  {
    "postcode":3782,
    "place_name":"Emerald",
    "state_name":"Victoria"
  },
  {
    "postcode":3783,
    "place_name":"Gembrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3785,
    "place_name":"Tremont",
    "state_name":"Victoria"
  },
  {
    "postcode":3786,
    "place_name":"Ferny Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3787,
    "place_name":"Sassafras Gully",
    "state_name":"Victoria"
  },
  {
    "postcode":3787,
    "place_name":"Sassafras",
    "state_name":"Victoria"
  },
  {
    "postcode":3788,
    "place_name":"Olinda",
    "state_name":"Victoria"
  },
  {
    "postcode":3789,
    "place_name":"Sherbrooke",
    "state_name":"Victoria"
  },
  {
    "postcode":3791,
    "place_name":"Kallista",
    "state_name":"Victoria"
  },
  {
    "postcode":3792,
    "place_name":"The Patch",
    "state_name":"Victoria"
  },
  {
    "postcode":3793,
    "place_name":"Monbulk",
    "state_name":"Victoria"
  },
  {
    "postcode":3795,
    "place_name":"Silvan",
    "state_name":"Victoria"
  },
  {
    "postcode":3796,
    "place_name":"Mount Evelyn",
    "state_name":"Victoria"
  },
  {
    "postcode":3797,
    "place_name":"Gladysdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3797,
    "place_name":"Powelltown",
    "state_name":"Victoria"
  },
  {
    "postcode":3797,
    "place_name":"Three Bridges",
    "state_name":"Victoria"
  },
  {
    "postcode":3797,
    "place_name":"Gilderoy",
    "state_name":"Victoria"
  },
  {
    "postcode":3797,
    "place_name":"Yarra Junction",
    "state_name":"Victoria"
  },
  {
    "postcode":3799,
    "place_name":"Big Pats Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3799,
    "place_name":"Mcmahons Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3799,
    "place_name":"Warburton",
    "state_name":"Victoria"
  },
  {
    "postcode":3799,
    "place_name":"Reefton",
    "state_name":"Victoria"
  },
  {
    "postcode":3799,
    "place_name":"East Warburton",
    "state_name":"Victoria"
  },
  {
    "postcode":3799,
    "place_name":"Millgrove",
    "state_name":"Victoria"
  },
  {
    "postcode":3799,
    "place_name":"Wesburn",
    "state_name":"Victoria"
  },
  {
    "postcode":3800,
    "place_name":"Monash University",
    "state_name":"Victoria"
  },
  {
    "postcode":3802,
    "place_name":"Endeavour Hills",
    "state_name":"Victoria"
  },
  {
    "postcode":3803,
    "place_name":"Hallam",
    "state_name":"Victoria"
  },
  {
    "postcode":3804,
    "place_name":"Narre Warren North",
    "state_name":"Victoria"
  },
  {
    "postcode":3804,
    "place_name":"Narre Warren East",
    "state_name":"Victoria"
  },
  {
    "postcode":3805,
    "place_name":"Narre Warren",
    "state_name":"Victoria"
  },
  {
    "postcode":3805,
    "place_name":"Fountain Gate",
    "state_name":"Victoria"
  },
  {
    "postcode":3805,
    "place_name":"Narre Warren South",
    "state_name":"Victoria"
  },
  {
    "postcode":3806,
    "place_name":"Harkaway",
    "state_name":"Victoria"
  },
  {
    "postcode":3806,
    "place_name":"Berwick",
    "state_name":"Victoria"
  },
  {
    "postcode":3807,
    "place_name":"Guys Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3807,
    "place_name":"Beaconsfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3808,
    "place_name":"Dewhurst",
    "state_name":"Victoria"
  },
  {
    "postcode":3808,
    "place_name":"Beaconsfield Upper",
    "state_name":"Victoria"
  },
  {
    "postcode":3809,
    "place_name":"Officer",
    "state_name":"Victoria"
  },
  {
    "postcode":3809,
    "place_name":"Officer South",
    "state_name":"Victoria"
  },
  {
    "postcode":3810,
    "place_name":"Rythdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3810,
    "place_name":"Pakenham South",
    "state_name":"Victoria"
  },
  {
    "postcode":3810,
    "place_name":"Pakenham",
    "state_name":"Victoria"
  },
  {
    "postcode":3810,
    "place_name":"Pakenham Upper",
    "state_name":"Victoria"
  },
  {
    "postcode":3812,
    "place_name":"Maryknoll",
    "state_name":"Victoria"
  },
  {
    "postcode":3812,
    "place_name":"Nar Nar Goon",
    "state_name":"Victoria"
  },
  {
    "postcode":3812,
    "place_name":"Nar Nar Goon North",
    "state_name":"Victoria"
  },
  {
    "postcode":3813,
    "place_name":"Tynong",
    "state_name":"Victoria"
  },
  {
    "postcode":3813,
    "place_name":"Tynong North",
    "state_name":"Victoria"
  },
  {
    "postcode":3814,
    "place_name":"Cora Lynn",
    "state_name":"Victoria"
  },
  {
    "postcode":3814,
    "place_name":"Garfield North",
    "state_name":"Victoria"
  },
  {
    "postcode":3814,
    "place_name":"Garfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3814,
    "place_name":"Vervale",
    "state_name":"Victoria"
  },
  {
    "postcode":3815,
    "place_name":"Tonimbuk",
    "state_name":"Victoria"
  },
  {
    "postcode":3815,
    "place_name":"Bunyip",
    "state_name":"Victoria"
  },
  {
    "postcode":3815,
    "place_name":"Bunyip North",
    "state_name":"Victoria"
  },
  {
    "postcode":3815,
    "place_name":"Iona",
    "state_name":"Victoria"
  },
  {
    "postcode":3816,
    "place_name":"Labertouche",
    "state_name":"Victoria"
  },
  {
    "postcode":3816,
    "place_name":"Longwarry North",
    "state_name":"Victoria"
  },
  {
    "postcode":3816,
    "place_name":"Longwarry",
    "state_name":"Victoria"
  },
  {
    "postcode":3816,
    "place_name":"Modella",
    "state_name":"Victoria"
  },
  {
    "postcode":3818,
    "place_name":"Drouin West",
    "state_name":"Victoria"
  },
  {
    "postcode":3818,
    "place_name":"Ripplebrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3818,
    "place_name":"Drouin South",
    "state_name":"Victoria"
  },
  {
    "postcode":3818,
    "place_name":"Drouin East",
    "state_name":"Victoria"
  },
  {
    "postcode":3818,
    "place_name":"Hallora",
    "state_name":"Victoria"
  },
  {
    "postcode":3818,
    "place_name":"Athlone",
    "state_name":"Victoria"
  },
  {
    "postcode":3818,
    "place_name":"Drouin",
    "state_name":"Victoria"
  },
  {
    "postcode":3818,
    "place_name":"Jindivick",
    "state_name":"Victoria"
  },
  {
    "postcode":3820,
    "place_name":"Warragul",
    "state_name":"Victoria"
  },
  {
    "postcode":3820,
    "place_name":"Bona Vista",
    "state_name":"Victoria"
  },
  {
    "postcode":3820,
    "place_name":"Lillico",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Brandy Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Lardner",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Seaview",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Crossover",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Nilma North",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Rokeby",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Neerim North",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Buln Buln East",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Nilma",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Neerim Junction",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Torwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Shady Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Bravington",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Tetoora Road",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Ferndale",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Ellinbank",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Warragul South",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Warragul West",
    "state_name":"Victoria"
  },
  {
    "postcode":3821,
    "place_name":"Buln Buln",
    "state_name":"Victoria"
  },
  {
    "postcode":3822,
    "place_name":"Gainsborough",
    "state_name":"Victoria"
  },
  {
    "postcode":3822,
    "place_name":"Cloverlea",
    "state_name":"Victoria"
  },
  {
    "postcode":3822,
    "place_name":"Darnum",
    "state_name":"Victoria"
  },
  {
    "postcode":3823,
    "place_name":"Yarragon",
    "state_name":"Victoria"
  },
  {
    "postcode":3823,
    "place_name":"Yarragon South",
    "state_name":"Victoria"
  },
  {
    "postcode":3823,
    "place_name":"Allambee",
    "state_name":"Victoria"
  },
  {
    "postcode":3824,
    "place_name":"Trafalgar South",
    "state_name":"Victoria"
  },
  {
    "postcode":3824,
    "place_name":"Trafalgar",
    "state_name":"Victoria"
  },
  {
    "postcode":3824,
    "place_name":"Thorpdale South",
    "state_name":"Victoria"
  },
  {
    "postcode":3824,
    "place_name":"Childers",
    "state_name":"Victoria"
  },
  {
    "postcode":3824,
    "place_name":"Trafalgar East",
    "state_name":"Victoria"
  },
  {
    "postcode":3824,
    "place_name":"Narracan",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Yallourn",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Jacob Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Hernes Oak",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Walhalla East",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Aberfeldy",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Jericho",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Rawson",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Tanjil South",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Willow Grove",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Amor",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Yallourn North",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Thomson",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Fumina",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Coalville",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Moe",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Moondarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Coopers Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Caringal",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Fumina South",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Westbury",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Boola",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Hill End",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Thalloo",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Erica",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Tanjil",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Walhalla",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Moe South",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Toombon",
    "state_name":"Victoria"
  },
  {
    "postcode":3825,
    "place_name":"Newborough",
    "state_name":"Victoria"
  },
  {
    "postcode":3831,
    "place_name":"Neerim East",
    "state_name":"Victoria"
  },
  {
    "postcode":3831,
    "place_name":"Neerim",
    "state_name":"Victoria"
  },
  {
    "postcode":3831,
    "place_name":"Neerim South",
    "state_name":"Victoria"
  },
  {
    "postcode":3832,
    "place_name":"Neerim Junction",
    "state_name":"Victoria"
  },
  {
    "postcode":3832,
    "place_name":"Neerim North",
    "state_name":"Victoria"
  },
  {
    "postcode":3832,
    "place_name":"Nayook",
    "state_name":"Victoria"
  },
  {
    "postcode":3833,
    "place_name":"Toorongo",
    "state_name":"Victoria"
  },
  {
    "postcode":3833,
    "place_name":"Icy Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3833,
    "place_name":"Vesper",
    "state_name":"Victoria"
  },
  {
    "postcode":3833,
    "place_name":"Gentle Annie",
    "state_name":"Victoria"
  },
  {
    "postcode":3833,
    "place_name":"Loch Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3833,
    "place_name":"Ada",
    "state_name":"Victoria"
  },
  {
    "postcode":3833,
    "place_name":"Baw Baw Village",
    "state_name":"Victoria"
  },
  {
    "postcode":3833,
    "place_name":"Noojee",
    "state_name":"Victoria"
  },
  {
    "postcode":3833,
    "place_name":"Piedmont",
    "state_name":"Victoria"
  },
  {
    "postcode":3833,
    "place_name":"Tanjil Bren",
    "state_name":"Victoria"
  },
  {
    "postcode":3833,
    "place_name":"Baw Baw",
    "state_name":"Victoria"
  },
  {
    "postcode":3835,
    "place_name":"Thorpdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3840,
    "place_name":"Hazelwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3840,
    "place_name":"Driffield",
    "state_name":"Victoria"
  },
  {
    "postcode":3840,
    "place_name":"Hazelwood South",
    "state_name":"Victoria"
  },
  {
    "postcode":3840,
    "place_name":"Morwell",
    "state_name":"Victoria"
  },
  {
    "postcode":3840,
    "place_name":"Maryvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3840,
    "place_name":"Mid Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3840,
    "place_name":"Jeeralang",
    "state_name":"Victoria"
  },
  {
    "postcode":3840,
    "place_name":"Hazelwood North",
    "state_name":"Victoria"
  },
  {
    "postcode":3840,
    "place_name":"Jeeralang Junction",
    "state_name":"Victoria"
  },
  {
    "postcode":3841,
    "place_name":"Gippsland Mc",
    "state_name":"Victoria"
  },
  {
    "postcode":3842,
    "place_name":"Churchill",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Mount Tassie",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Callignee",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Tyers",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Flynn",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Carrajung Lower",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Traralgon South",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Blackwarry",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Carrajung South",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Koornalla",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Callignee South",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Flynns Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Willung South",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Traralgon East",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Carrajung",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Traralgon",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Callignee North",
    "state_name":"Victoria"
  },
  {
    "postcode":3844,
    "place_name":"Loy Yang",
    "state_name":"Victoria"
  },
  {
    "postcode":3847,
    "place_name":"Rosedale",
    "state_name":"Victoria"
  },
  {
    "postcode":3847,
    "place_name":"Willung South",
    "state_name":"Victoria"
  },
  {
    "postcode":3847,
    "place_name":"Willung",
    "state_name":"Victoria"
  },
  {
    "postcode":3847,
    "place_name":"Hiamdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3847,
    "place_name":"Nambrok",
    "state_name":"Victoria"
  },
  {
    "postcode":3850,
    "place_name":"Wurruk",
    "state_name":"Victoria"
  },
  {
    "postcode":3850,
    "place_name":"Guthridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3850,
    "place_name":"Sale",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Fulham",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Seaspray",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Seacombe",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Darriman",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"The Heart",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Kilmany",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Montgomery",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Golden Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Giffard",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Airly",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"The Honeysuckles",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Dutson",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Cobains",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Paradise Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Glomar Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Loch Sport",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Bundalaguah",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Longford",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Clydebank",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Myrtlebank",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Stradbroke",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Flamingo Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Giffard West",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Dutson Downs",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Pearsondale",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Lake Wellington",
    "state_name":"Victoria"
  },
  {
    "postcode":3851,
    "place_name":"Somerton Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3852,
    "place_name":"East Sale",
    "state_name":"Victoria"
  },
  {
    "postcode":3852,
    "place_name":"East Sale Raaf",
    "state_name":"Victoria"
  },
  {
    "postcode":3852,
    "place_name":"Sale East Raaf",
    "state_name":"Victoria"
  },
  {
    "postcode":3853,
    "place_name":"Sale",
    "state_name":"Victoria"
  },
  {
    "postcode":3854,
    "place_name":"Glengarry",
    "state_name":"Victoria"
  },
  {
    "postcode":3854,
    "place_name":"Glengarry West",
    "state_name":"Victoria"
  },
  {
    "postcode":3854,
    "place_name":"Glengarry North",
    "state_name":"Victoria"
  },
  {
    "postcode":3856,
    "place_name":"Toongabbie",
    "state_name":"Victoria"
  },
  {
    "postcode":3857,
    "place_name":"Cowwarr",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Dawson",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Heyfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Licola",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Denison",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Arbuckle",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Gillum",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Yangoura",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Billabong",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Tamboritha",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Reynard",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Worrowing",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Seaton",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Crookayan",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Winnindoo",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Glenmaggie",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Sargood",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Buragwonduc",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Glenfalloch",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Howitt Plains",
    "state_name":"Victoria"
  },
  {
    "postcode":3858,
    "place_name":"Licola North",
    "state_name":"Victoria"
  },
  {
    "postcode":3859,
    "place_name":"Newry",
    "state_name":"Victoria"
  },
  {
    "postcode":3859,
    "place_name":"Tinamba West",
    "state_name":"Victoria"
  },
  {
    "postcode":3859,
    "place_name":"Maffra West Upper",
    "state_name":"Victoria"
  },
  {
    "postcode":3859,
    "place_name":"Tinamba",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Riverslea",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Woolenook",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Coongulla",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Nap Nap Marra",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Wrathung",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Bushy Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Wrixon",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Koorool",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Toolome",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Briagolong",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Maffra",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Boisdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Moroka",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Monomak",
    "state_name":"Victoria"
  },
  {
    "postcode":3860,
    "place_name":"Valencia Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Llowalong",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Budgee Budgee",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Dargo",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Meerlieu",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Munro",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Hollands Landing",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Stockdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Cobbannah",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Perry Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Crooked River",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Stratford",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Hawkhurst",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Waterford",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Miowera",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Wongungarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Cowa",
    "state_name":"Victoria"
  },
  {
    "postcode":3862,
    "place_name":"Moornapa",
    "state_name":"Victoria"
  },
  {
    "postcode":3864,
    "place_name":"Glenaladale",
    "state_name":"Victoria"
  },
  {
    "postcode":3864,
    "place_name":"Fernbank",
    "state_name":"Victoria"
  },
  {
    "postcode":3865,
    "place_name":"Lindenow",
    "state_name":"Victoria"
  },
  {
    "postcode":3869,
    "place_name":"Yinnar",
    "state_name":"Victoria"
  },
  {
    "postcode":3869,
    "place_name":"Yinnar South",
    "state_name":"Victoria"
  },
  {
    "postcode":3869,
    "place_name":"Jumbuk",
    "state_name":"Victoria"
  },
  {
    "postcode":3870,
    "place_name":"Budgeree",
    "state_name":"Victoria"
  },
  {
    "postcode":3870,
    "place_name":"Johnstones Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3870,
    "place_name":"Boolarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3870,
    "place_name":"Grand Ridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3870,
    "place_name":"Boolarra South",
    "state_name":"Victoria"
  },
  {
    "postcode":3871,
    "place_name":"Mirboo North",
    "state_name":"Victoria"
  },
  {
    "postcode":3871,
    "place_name":"Dollar",
    "state_name":"Victoria"
  },
  {
    "postcode":3871,
    "place_name":"Allambee Reserve",
    "state_name":"Victoria"
  },
  {
    "postcode":3871,
    "place_name":"Darlimurla",
    "state_name":"Victoria"
  },
  {
    "postcode":3871,
    "place_name":"Allambee South",
    "state_name":"Victoria"
  },
  {
    "postcode":3871,
    "place_name":"Baromi",
    "state_name":"Victoria"
  },
  {
    "postcode":3871,
    "place_name":"Mirboo",
    "state_name":"Victoria"
  },
  {
    "postcode":3871,
    "place_name":"Delburn",
    "state_name":"Victoria"
  },
  {
    "postcode":3873,
    "place_name":"Gormandale",
    "state_name":"Victoria"
  },
  {
    "postcode":3874,
    "place_name":"Woodside",
    "state_name":"Victoria"
  },
  {
    "postcode":3874,
    "place_name":"Mcloughlins Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3874,
    "place_name":"Woodside North",
    "state_name":"Victoria"
  },
  {
    "postcode":3874,
    "place_name":"Carrajung South",
    "state_name":"Victoria"
  },
  {
    "postcode":3874,
    "place_name":"Woodside Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Bairnsdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Granite Rock",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Lucknow",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Merrijig",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Hillside",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Goon Nure",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Walpa",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Deptford",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Eastwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Lindenow South",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Woodglen",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Wentworth",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Forge Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Tabberabbera",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Calulu",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Waterholes",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Clifton Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Marthavale",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Bullumwaal",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Broadlands",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Wy Yung",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Banksia Peninsula",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Newlands Arm",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Ellaswood",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"East Bairnsdale",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Iguana Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Wuk Wuk",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Mount Taylor",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Fairy Dell",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Melwood",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Ryans",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Flaggy Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Sarsfield",
    "state_name":"Victoria"
  },
  {
    "postcode":3875,
    "place_name":"Bengworden",
    "state_name":"Victoria"
  },
  {
    "postcode":3878,
    "place_name":"Eagle Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3880,
    "place_name":"Paynesville",
    "state_name":"Victoria"
  },
  {
    "postcode":3880,
    "place_name":"Boole Poole",
    "state_name":"Victoria"
  },
  {
    "postcode":3880,
    "place_name":"Ocean Grange",
    "state_name":"Victoria"
  },
  {
    "postcode":3880,
    "place_name":"Raymond Island",
    "state_name":"Victoria"
  },
  {
    "postcode":3882,
    "place_name":"Nicholson",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Wulgulmerang",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Wulgulmerang East",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Buchan South",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Suggan Buggan",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"W Tree",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Butchers Ridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Yalmy",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Gelantipy",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Wiseleigh",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Buchan",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Brumby",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Bruthen",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Wulgulmerang West",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Mossiface",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Murrindal",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Tambo Upper",
    "state_name":"Victoria"
  },
  {
    "postcode":3885,
    "place_name":"Timbarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3886,
    "place_name":"Newmerella",
    "state_name":"Victoria"
  },
  {
    "postcode":3887,
    "place_name":"Nowa Nowa",
    "state_name":"Victoria"
  },
  {
    "postcode":3887,
    "place_name":"Lake Tyers",
    "state_name":"Victoria"
  },
  {
    "postcode":3887,
    "place_name":"Wairewa",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Tostaree",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Brodribb River",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Bete Bolong North",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Goongerah",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Marlo",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Waygara",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Bendoc",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Jarrahmond",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Wombat Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Bete Bolong",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Haydens Bog",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Delegate River",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Simpsons Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Nurran",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Bonang",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Orbost",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Tubbut",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Corringle",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Cape Conran",
    "state_name":"Victoria"
  },
  {
    "postcode":3888,
    "place_name":"Deddick Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3889,
    "place_name":"Cabbage Tree Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3889,
    "place_name":"Bemm River",
    "state_name":"Victoria"
  },
  {
    "postcode":3889,
    "place_name":"Errinundra",
    "state_name":"Victoria"
  },
  {
    "postcode":3889,
    "place_name":"Bellbird Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3889,
    "place_name":"Manorina",
    "state_name":"Victoria"
  },
  {
    "postcode":3889,
    "place_name":"Club Terrace",
    "state_name":"Victoria"
  },
  {
    "postcode":3889,
    "place_name":"Combienbar",
    "state_name":"Victoria"
  },
  {
    "postcode":3890,
    "place_name":"Buldah",
    "state_name":"Victoria"
  },
  {
    "postcode":3890,
    "place_name":"Noorinbee North",
    "state_name":"Victoria"
  },
  {
    "postcode":3890,
    "place_name":"Cann River",
    "state_name":"Victoria"
  },
  {
    "postcode":3890,
    "place_name":"Chandlers Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3890,
    "place_name":"Noorinbee",
    "state_name":"Victoria"
  },
  {
    "postcode":3890,
    "place_name":"Tonghi Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3890,
    "place_name":"Tamboon",
    "state_name":"Victoria"
  },
  {
    "postcode":3891,
    "place_name":"Wangarabell",
    "state_name":"Victoria"
  },
  {
    "postcode":3891,
    "place_name":"Genoa",
    "state_name":"Victoria"
  },
  {
    "postcode":3891,
    "place_name":"Gipsy Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3891,
    "place_name":"Wallagaraugh",
    "state_name":"Victoria"
  },
  {
    "postcode":3891,
    "place_name":"Wroxham",
    "state_name":"Victoria"
  },
  {
    "postcode":3891,
    "place_name":"Wingan River",
    "state_name":"Victoria"
  },
  {
    "postcode":3891,
    "place_name":"Maramingo Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3892,
    "place_name":"Mallacoota",
    "state_name":"Victoria"
  },
  {
    "postcode":3893,
    "place_name":"Double Bridges",
    "state_name":"Victoria"
  },
  {
    "postcode":3893,
    "place_name":"Stirling",
    "state_name":"Victoria"
  },
  {
    "postcode":3893,
    "place_name":"Tambo Crossing",
    "state_name":"Victoria"
  },
  {
    "postcode":3895,
    "place_name":"Ensay",
    "state_name":"Victoria"
  },
  {
    "postcode":3895,
    "place_name":"Reedy Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3895,
    "place_name":"Doctors Flat",
    "state_name":"Victoria"
  },
  {
    "postcode":3895,
    "place_name":"Ensay North",
    "state_name":"Victoria"
  },
  {
    "postcode":3896,
    "place_name":"Swifts Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3896,
    "place_name":"Brookville",
    "state_name":"Victoria"
  },
  {
    "postcode":3896,
    "place_name":"Nunniong",
    "state_name":"Victoria"
  },
  {
    "postcode":3896,
    "place_name":"Tongio",
    "state_name":"Victoria"
  },
  {
    "postcode":3896,
    "place_name":"Bindi",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Hinnomunjie",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Glen Wills",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Omeo",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Cobungra",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Dinner Plain",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Bingo Munjie",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Cassilis",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Omeo Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Anglers Rest",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Bundara",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Shannonvale",
    "state_name":"Victoria"
  },
  {
    "postcode":3898,
    "place_name":"Glen Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3900,
    "place_name":"Benambra",
    "state_name":"Victoria"
  },
  {
    "postcode":3900,
    "place_name":"Cobberas",
    "state_name":"Victoria"
  },
  {
    "postcode":3902,
    "place_name":"Johnsonville",
    "state_name":"Victoria"
  },
  {
    "postcode":3902,
    "place_name":"Bumberrah",
    "state_name":"Victoria"
  },
  {
    "postcode":3903,
    "place_name":"Swan Reach",
    "state_name":"Victoria"
  },
  {
    "postcode":3904,
    "place_name":"Metung",
    "state_name":"Victoria"
  },
  {
    "postcode":3909,
    "place_name":"Lakes Entrance",
    "state_name":"Victoria"
  },
  {
    "postcode":3909,
    "place_name":"Nungurner",
    "state_name":"Victoria"
  },
  {
    "postcode":3909,
    "place_name":"Lake Tyers Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3909,
    "place_name":"Toorloo Arm",
    "state_name":"Victoria"
  },
  {
    "postcode":3909,
    "place_name":"Kalimna West",
    "state_name":"Victoria"
  },
  {
    "postcode":3909,
    "place_name":"Lake Bunga",
    "state_name":"Victoria"
  },
  {
    "postcode":3909,
    "place_name":"Nyerimilang",
    "state_name":"Victoria"
  },
  {
    "postcode":3909,
    "place_name":"Kalimna",
    "state_name":"Victoria"
  },
  {
    "postcode":3910,
    "place_name":"Langwarrin",
    "state_name":"Victoria"
  },
  {
    "postcode":3911,
    "place_name":"Langwarrin South",
    "state_name":"Victoria"
  },
  {
    "postcode":3911,
    "place_name":"Baxter",
    "state_name":"Victoria"
  },
  {
    "postcode":3912,
    "place_name":"Somerville",
    "state_name":"Victoria"
  },
  {
    "postcode":3912,
    "place_name":"Pearcedale",
    "state_name":"Victoria"
  },
  {
    "postcode":3913,
    "place_name":"Tyabb",
    "state_name":"Victoria"
  },
  {
    "postcode":3915,
    "place_name":"Tuerong",
    "state_name":"Victoria"
  },
  {
    "postcode":3915,
    "place_name":"Hastings",
    "state_name":"Victoria"
  },
  {
    "postcode":3916,
    "place_name":"Shoreham",
    "state_name":"Victoria"
  },
  {
    "postcode":3916,
    "place_name":"Merricks",
    "state_name":"Victoria"
  },
  {
    "postcode":3916,
    "place_name":"Point Leo",
    "state_name":"Victoria"
  },
  {
    "postcode":3918,
    "place_name":"Bittern",
    "state_name":"Victoria"
  },
  {
    "postcode":3919,
    "place_name":"Crib Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3920,
    "place_name":"Hmas Cerberus",
    "state_name":"Victoria"
  },
  {
    "postcode":3921,
    "place_name":"French Island",
    "state_name":"Victoria"
  },
  {
    "postcode":3921,
    "place_name":"Elizabeth Island",
    "state_name":"Victoria"
  },
  {
    "postcode":3921,
    "place_name":"Tankerton",
    "state_name":"Victoria"
  },
  {
    "postcode":3922,
    "place_name":"Sunset Strip",
    "state_name":"Victoria"
  },
  {
    "postcode":3922,
    "place_name":"Sunderland Bay",
    "state_name":"Victoria"
  },
  {
    "postcode":3922,
    "place_name":"Ventnor",
    "state_name":"Victoria"
  },
  {
    "postcode":3922,
    "place_name":"Cowes",
    "state_name":"Victoria"
  },
  {
    "postcode":3922,
    "place_name":"Summerlands",
    "state_name":"Victoria"
  },
  {
    "postcode":3922,
    "place_name":"Wimbledon Heights",
    "state_name":"Victoria"
  },
  {
    "postcode":3922,
    "place_name":"Silverleaves",
    "state_name":"Victoria"
  },
  {
    "postcode":3922,
    "place_name":"Surf Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3922,
    "place_name":"Smiths Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3923,
    "place_name":"Rhyll",
    "state_name":"Victoria"
  },
  {
    "postcode":3925,
    "place_name":"Churchill Island",
    "state_name":"Victoria"
  },
  {
    "postcode":3925,
    "place_name":"San Remo",
    "state_name":"Victoria"
  },
  {
    "postcode":3925,
    "place_name":"Newhaven",
    "state_name":"Victoria"
  },
  {
    "postcode":3925,
    "place_name":"Cape Woolamai",
    "state_name":"Victoria"
  },
  {
    "postcode":3926,
    "place_name":"Merricks North",
    "state_name":"Victoria"
  },
  {
    "postcode":3926,
    "place_name":"Balnarring Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3926,
    "place_name":"Balnarring",
    "state_name":"Victoria"
  },
  {
    "postcode":3926,
    "place_name":"Merricks Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3927,
    "place_name":"Somers",
    "state_name":"Victoria"
  },
  {
    "postcode":3928,
    "place_name":"Main Ridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3929,
    "place_name":"Flinders",
    "state_name":"Victoria"
  },
  {
    "postcode":3930,
    "place_name":"Mount Eliza",
    "state_name":"Victoria"
  },
  {
    "postcode":3930,
    "place_name":"Kunyung",
    "state_name":"Victoria"
  },
  {
    "postcode":3931,
    "place_name":"Mornington",
    "state_name":"Victoria"
  },
  {
    "postcode":3933,
    "place_name":"Moorooduc",
    "state_name":"Victoria"
  },
  {
    "postcode":3934,
    "place_name":"Mount Martha",
    "state_name":"Victoria"
  },
  {
    "postcode":3936,
    "place_name":"Dromana",
    "state_name":"Victoria"
  },
  {
    "postcode":3936,
    "place_name":"Safety Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3936,
    "place_name":"Arthurs Seat",
    "state_name":"Victoria"
  },
  {
    "postcode":3937,
    "place_name":"Red Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3937,
    "place_name":"Red Hill South",
    "state_name":"Victoria"
  },
  {
    "postcode":3938,
    "place_name":"Mccrae",
    "state_name":"Victoria"
  },
  {
    "postcode":3939,
    "place_name":"Boneo",
    "state_name":"Victoria"
  },
  {
    "postcode":3939,
    "place_name":"Rosebud Plaza",
    "state_name":"Victoria"
  },
  {
    "postcode":3939,
    "place_name":"Rosebud",
    "state_name":"Victoria"
  },
  {
    "postcode":3939,
    "place_name":"Fingal",
    "state_name":"Victoria"
  },
  {
    "postcode":3939,
    "place_name":"Cape Schanck",
    "state_name":"Victoria"
  },
  {
    "postcode":3940,
    "place_name":"Rosebud West",
    "state_name":"Victoria"
  },
  {
    "postcode":3941,
    "place_name":"Rye",
    "state_name":"Victoria"
  },
  {
    "postcode":3941,
    "place_name":"Tootgarook",
    "state_name":"Victoria"
  },
  {
    "postcode":3941,
    "place_name":"St Andrews Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3942,
    "place_name":"Blairgowrie",
    "state_name":"Victoria"
  },
  {
    "postcode":3943,
    "place_name":"Sorrento",
    "state_name":"Victoria"
  },
  {
    "postcode":3944,
    "place_name":"Portsea",
    "state_name":"Victoria"
  },
  {
    "postcode":3945,
    "place_name":"Krowera",
    "state_name":"Victoria"
  },
  {
    "postcode":3945,
    "place_name":"Jeetho",
    "state_name":"Victoria"
  },
  {
    "postcode":3945,
    "place_name":"Woodleigh",
    "state_name":"Victoria"
  },
  {
    "postcode":3945,
    "place_name":"Loch",
    "state_name":"Victoria"
  },
  {
    "postcode":3946,
    "place_name":"Bena",
    "state_name":"Victoria"
  },
  {
    "postcode":3950,
    "place_name":"Strzelecki",
    "state_name":"Victoria"
  },
  {
    "postcode":3950,
    "place_name":"Whitelaw",
    "state_name":"Victoria"
  },
  {
    "postcode":3950,
    "place_name":"Kardella South",
    "state_name":"Victoria"
  },
  {
    "postcode":3950,
    "place_name":"Korumburra South",
    "state_name":"Victoria"
  },
  {
    "postcode":3950,
    "place_name":"Korumburra",
    "state_name":"Victoria"
  },
  {
    "postcode":3951,
    "place_name":"Arawata",
    "state_name":"Victoria"
  },
  {
    "postcode":3951,
    "place_name":"Fairbank",
    "state_name":"Victoria"
  },
  {
    "postcode":3951,
    "place_name":"Ranceby",
    "state_name":"Victoria"
  },
  {
    "postcode":3951,
    "place_name":"Kardella",
    "state_name":"Victoria"
  },
  {
    "postcode":3951,
    "place_name":"Moyarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3951,
    "place_name":"Outtrim",
    "state_name":"Victoria"
  },
  {
    "postcode":3951,
    "place_name":"Jumbunna",
    "state_name":"Victoria"
  },
  {
    "postcode":3951,
    "place_name":"Kongwak",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Ruby",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Leongatha North",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Hallston",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Mount Eccles South",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Mount Eccles",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Koorooman",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Berrys Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Mardan",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Leongatha",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Boorool",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Leongatha South",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Wild Dog Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Nerrena",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Wooreen",
    "state_name":"Victoria"
  },
  {
    "postcode":3953,
    "place_name":"Trida",
    "state_name":"Victoria"
  },
  {
    "postcode":3954,
    "place_name":"Koonwarra",
    "state_name":"Victoria"
  },
  {
    "postcode":3956,
    "place_name":"Venus Bay",
    "state_name":"Victoria"
  },
  {
    "postcode":3956,
    "place_name":"Tarwin",
    "state_name":"Victoria"
  },
  {
    "postcode":3956,
    "place_name":"Dumbalk",
    "state_name":"Victoria"
  },
  {
    "postcode":3956,
    "place_name":"Walkerville North",
    "state_name":"Victoria"
  },
  {
    "postcode":3956,
    "place_name":"Meeniyan",
    "state_name":"Victoria"
  },
  {
    "postcode":3956,
    "place_name":"Walkerville",
    "state_name":"Victoria"
  },
  {
    "postcode":3956,
    "place_name":"Walkerville South",
    "state_name":"Victoria"
  },
  {
    "postcode":3956,
    "place_name":"Middle Tarwin",
    "state_name":"Victoria"
  },
  {
    "postcode":3956,
    "place_name":"Tarwin Lower",
    "state_name":"Victoria"
  },
  {
    "postcode":3956,
    "place_name":"Dumbalk North",
    "state_name":"Victoria"
  },
  {
    "postcode":3957,
    "place_name":"Stony Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3958,
    "place_name":"Buffalo",
    "state_name":"Victoria"
  },
  {
    "postcode":3959,
    "place_name":"Sandy Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3959,
    "place_name":"Fish Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3959,
    "place_name":"Waratah Bay",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Gunyah",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Boolarong",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Woorarra West",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Bennison",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Shallow Inlet",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Turtons Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Tidal River",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Yanakie",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Foster North",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Wilsons Promontory",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Wonga",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Mount Best",
    "state_name":"Victoria"
  },
  {
    "postcode":3960,
    "place_name":"Foster",
    "state_name":"Victoria"
  },
  {
    "postcode":3962,
    "place_name":"Woorarra East",
    "state_name":"Victoria"
  },
  {
    "postcode":3962,
    "place_name":"Toora",
    "state_name":"Victoria"
  },
  {
    "postcode":3962,
    "place_name":"Wonyip",
    "state_name":"Victoria"
  },
  {
    "postcode":3962,
    "place_name":"Toora North",
    "state_name":"Victoria"
  },
  {
    "postcode":3962,
    "place_name":"Agnes",
    "state_name":"Victoria"
  },
  {
    "postcode":3964,
    "place_name":"Port Franklin",
    "state_name":"Victoria"
  },
  {
    "postcode":3965,
    "place_name":"Port Welshpool",
    "state_name":"Victoria"
  },
  {
    "postcode":3966,
    "place_name":"Binginwarri",
    "state_name":"Victoria"
  },
  {
    "postcode":3966,
    "place_name":"Welshpool",
    "state_name":"Victoria"
  },
  {
    "postcode":3966,
    "place_name":"Hazel Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3967,
    "place_name":"Hedley",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Gelliondale",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Yarram",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Balook",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Manns Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Tarraville",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Madalya",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Langsborough",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Hunterston",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Alberton",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Won Wron",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Hiawatha",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Robertsons Beach",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Devon North",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Jack River",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Tarra Valley",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Snake Island",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Macks Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Alberton West",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Staceys Bridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Calrossie",
    "state_name":"Victoria"
  },
  {
    "postcode":3971,
    "place_name":"Port Albert",
    "state_name":"Victoria"
  },
  {
    "postcode":3975,
    "place_name":"Lyndhurst",
    "state_name":"Victoria"
  },
  {
    "postcode":3975,
    "place_name":"Lynbrook",
    "state_name":"Victoria"
  },
  {
    "postcode":3976,
    "place_name":"Hampton Park",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Botanic Ridge",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Skye",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Cannons Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Devon Meadows",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Cranbourne West",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Cranbourne South",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Cranbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Junction Village",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Cranbourne East",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Five Ways",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Sandhurst",
    "state_name":"Victoria"
  },
  {
    "postcode":3977,
    "place_name":"Cranbourne North",
    "state_name":"Victoria"
  },
  {
    "postcode":3978,
    "place_name":"Clyde North",
    "state_name":"Victoria"
  },
  {
    "postcode":3978,
    "place_name":"Cardinia",
    "state_name":"Victoria"
  },
  {
    "postcode":3978,
    "place_name":"Clyde",
    "state_name":"Victoria"
  },
  {
    "postcode":3979,
    "place_name":"Glen Alvie",
    "state_name":"Victoria"
  },
  {
    "postcode":3979,
    "place_name":"Kernot",
    "state_name":"Victoria"
  },
  {
    "postcode":3979,
    "place_name":"Almurta",
    "state_name":"Victoria"
  },
  {
    "postcode":3980,
    "place_name":"Blind Bight",
    "state_name":"Victoria"
  },
  {
    "postcode":3980,
    "place_name":"Warneet",
    "state_name":"Victoria"
  },
  {
    "postcode":3980,
    "place_name":"Tooradin",
    "state_name":"Victoria"
  },
  {
    "postcode":3981,
    "place_name":"Koo Wee Rup North",
    "state_name":"Victoria"
  },
  {
    "postcode":3981,
    "place_name":"Heath Hill",
    "state_name":"Victoria"
  },
  {
    "postcode":3981,
    "place_name":"Koo Wee Rup",
    "state_name":"Victoria"
  },
  {
    "postcode":3981,
    "place_name":"Yannathan",
    "state_name":"Victoria"
  },
  {
    "postcode":3981,
    "place_name":"Bayles",
    "state_name":"Victoria"
  },
  {
    "postcode":3981,
    "place_name":"Dalmore",
    "state_name":"Victoria"
  },
  {
    "postcode":3981,
    "place_name":"Catani",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"The Gurdies",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Tenby Point",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Pioneer Bay",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Coronet Bay",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Adams Estate",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Lang Lang",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Queensferry",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Grantville",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Monomeith",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Jam Jerrup",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Corinella",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Lang Lang East",
    "state_name":"Victoria"
  },
  {
    "postcode":3984,
    "place_name":"Caldermeade",
    "state_name":"Victoria"
  },
  {
    "postcode":3987,
    "place_name":"Nyora",
    "state_name":"Victoria"
  },
  {
    "postcode":3988,
    "place_name":"Poowong",
    "state_name":"Victoria"
  },
  {
    "postcode":3988,
    "place_name":"Poowong East",
    "state_name":"Victoria"
  },
  {
    "postcode":3988,
    "place_name":"Mountain View",
    "state_name":"Victoria"
  },
  {
    "postcode":3988,
    "place_name":"Poowong North",
    "state_name":"Victoria"
  },
  {
    "postcode":3990,
    "place_name":"Glen Forbes",
    "state_name":"Victoria"
  },
  {
    "postcode":3991,
    "place_name":"Bass",
    "state_name":"Victoria"
  },
  {
    "postcode":3992,
    "place_name":"Ryanston",
    "state_name":"Victoria"
  },
  {
    "postcode":3992,
    "place_name":"West Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3992,
    "place_name":"Dalyston",
    "state_name":"Victoria"
  },
  {
    "postcode":3992,
    "place_name":"Blackwood Forest",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"Wattle Bank",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"Lance Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"North Wonthaggi",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"Anderson",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"Kilcunda",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"Harmers Haven",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"Archies Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"Woolamai",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"South Dudley",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"St Clair",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"Wonthaggi",
    "state_name":"Victoria"
  },
  {
    "postcode":3995,
    "place_name":"Cape Paterson",
    "state_name":"Victoria"
  },
  {
    "postcode":3996,
    "place_name":"Pound Creek",
    "state_name":"Victoria"
  },
  {
    "postcode":3996,
    "place_name":"Inverloch",
    "state_name":"Victoria"
  },
  {
    "postcode":8001,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8002,
    "place_name":"East Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8003,
    "place_name":"Collins Street East",
    "state_name":"Victoria"
  },
  {
    "postcode":8004,
    "place_name":"St Kilda Road",
    "state_name":"Victoria"
  },
  {
    "postcode":8005,
    "place_name":"World Trade Centre",
    "state_name":"Victoria"
  },
  {
    "postcode":8006,
    "place_name":"Abeckett Street",
    "state_name":"Victoria"
  },
  {
    "postcode":8007,
    "place_name":"Collins Street West",
    "state_name":"Victoria"
  },
  {
    "postcode":8008,
    "place_name":"St Kilda Road Central",
    "state_name":"Victoria"
  },
  {
    "postcode":8009,
    "place_name":"Flinders Lane",
    "state_name":"Victoria"
  },
  {
    "postcode":8010,
    "place_name":"Law Courts",
    "state_name":"Victoria"
  },
  {
    "postcode":8011,
    "place_name":"Little Lonsdale Street",
    "state_name":"Victoria"
  },
  {
    "postcode":8012,
    "place_name":"Docklands",
    "state_name":"Victoria"
  },
  {
    "postcode":8045,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8051,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8060,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8061,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8066,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8069,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8070,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8071,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8102,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8103,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8107,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8108,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8111,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8120,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8205,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8383,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8386,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8388,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8390,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8393,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8394,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8396,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8399,
    "place_name":"Melbourne",
    "state_name":"Victoria"
  },
  {
    "postcode":8627,
    "place_name":"Camberwell",
    "state_name":"Victoria"
  },
  {
    "postcode":872,
    "place_name":"Ngaanyatjarra-Giles",
    "state_name":"Western Australia"
  },
  {
    "postcode":872,
    "place_name":"Gibson Desert North",
    "state_name":"Western Australia"
  },
  {
    "postcode":872,
    "place_name":"Tjirrkarli",
    "state_name":"Western Australia"
  },
  {
    "postcode":872,
    "place_name":"Wannan",
    "state_name":"Western Australia"
  },
  {
    "postcode":872,
    "place_name":"Gibson Desert South",
    "state_name":"Western Australia"
  },
  {
    "postcode":872,
    "place_name":"Patjarr",
    "state_name":"Western Australia"
  },
  {
    "postcode":872,
    "place_name":"Wingellina",
    "state_name":"Western Australia"
  },
  {
    "postcode":872,
    "place_name":"Kiwirrkurra",
    "state_name":"Western Australia"
  },
  {
    "postcode":872,
    "place_name":"Tjukurla",
    "state_name":"Western Australia"
  },
  {
    "postcode":6000,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6000,
    "place_name":"Perth GPO",
    "state_name":"Western Australia"
  },
  {
    "postcode":6000,
    "place_name":"City Delivery Centre",
    "state_name":"Western Australia"
  },
  {
    "postcode":6001,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6003,
    "place_name":"Northbridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6003,
    "place_name":"Highgate",
    "state_name":"Western Australia"
  },
  {
    "postcode":6004,
    "place_name":"East Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6005,
    "place_name":"West Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6005,
    "place_name":"Kings Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6006,
    "place_name":"North Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6007,
    "place_name":"Leederville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6007,
    "place_name":"West Leederville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6008,
    "place_name":"Shenton Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6008,
    "place_name":"Daglish",
    "state_name":"Western Australia"
  },
  {
    "postcode":6008,
    "place_name":"Subiaco",
    "state_name":"Western Australia"
  },
  {
    "postcode":6008,
    "place_name":"Subiaco East",
    "state_name":"Western Australia"
  },
  {
    "postcode":6009,
    "place_name":"Nedlands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6009,
    "place_name":"Broadway Nedlands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6009,
    "place_name":"Dalkeith",
    "state_name":"Western Australia"
  },
  {
    "postcode":6009,
    "place_name":"Nedlands DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6009,
    "place_name":"Crawley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6010,
    "place_name":"Karrakatta",
    "state_name":"Western Australia"
  },
  {
    "postcode":6010,
    "place_name":"Claremont",
    "state_name":"Western Australia"
  },
  {
    "postcode":6010,
    "place_name":"Mount Claremont",
    "state_name":"Western Australia"
  },
  {
    "postcode":6010,
    "place_name":"Swanbourne",
    "state_name":"Western Australia"
  },
  {
    "postcode":6010,
    "place_name":"Claremont North",
    "state_name":"Western Australia"
  },
  {
    "postcode":6011,
    "place_name":"Peppermint Grove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6011,
    "place_name":"Cottesloe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6012,
    "place_name":"Mosman Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6014,
    "place_name":"Wembley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6014,
    "place_name":"Floreat",
    "state_name":"Western Australia"
  },
  {
    "postcode":6014,
    "place_name":"Jolimont",
    "state_name":"Western Australia"
  },
  {
    "postcode":6015,
    "place_name":"City Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6016,
    "place_name":"Mount Hawthorn",
    "state_name":"Western Australia"
  },
  {
    "postcode":6016,
    "place_name":"Glendalough",
    "state_name":"Western Australia"
  },
  {
    "postcode":6017,
    "place_name":"Herdsman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6017,
    "place_name":"Osborne Park DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6017,
    "place_name":"Osborne Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6018,
    "place_name":"Churchlands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6018,
    "place_name":"Woodlands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6018,
    "place_name":"Gwelup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6018,
    "place_name":"Innaloo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6018,
    "place_name":"Doubleview",
    "state_name":"Western Australia"
  },
  {
    "postcode":6018,
    "place_name":"Gwelup DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6018,
    "place_name":"Karrinyup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6019,
    "place_name":"Wembley Downs",
    "state_name":"Western Australia"
  },
  {
    "postcode":6019,
    "place_name":"Scarborough",
    "state_name":"Western Australia"
  },
  {
    "postcode":6020,
    "place_name":"North Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6020,
    "place_name":"Marmion",
    "state_name":"Western Australia"
  },
  {
    "postcode":6020,
    "place_name":"Watermans Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6020,
    "place_name":"Sorrento",
    "state_name":"Western Australia"
  },
  {
    "postcode":6020,
    "place_name":"Carine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6021,
    "place_name":"Stirling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6021,
    "place_name":"Balcatta",
    "state_name":"Western Australia"
  },
  {
    "postcode":6022,
    "place_name":"Hamersley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6023,
    "place_name":"Duncraig",
    "state_name":"Western Australia"
  },
  {
    "postcode":6024,
    "place_name":"Warwick",
    "state_name":"Western Australia"
  },
  {
    "postcode":6024,
    "place_name":"Greenwood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6025,
    "place_name":"Hillarys",
    "state_name":"Western Australia"
  },
  {
    "postcode":6025,
    "place_name":"Craigie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6025,
    "place_name":"Kallaroo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6025,
    "place_name":"Padbury",
    "state_name":"Western Australia"
  },
  {
    "postcode":6026,
    "place_name":"Kingsley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6026,
    "place_name":"Woodvale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6027,
    "place_name":"Ocean Reef",
    "state_name":"Western Australia"
  },
  {
    "postcode":6027,
    "place_name":"Beldon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6027,
    "place_name":"Joondalup DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6027,
    "place_name":"Connolly",
    "state_name":"Western Australia"
  },
  {
    "postcode":6027,
    "place_name":"Heathridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6027,
    "place_name":"Edgewater",
    "state_name":"Western Australia"
  },
  {
    "postcode":6027,
    "place_name":"Mullaloo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6027,
    "place_name":"Joondalup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6028,
    "place_name":"Iluka",
    "state_name":"Western Australia"
  },
  {
    "postcode":6028,
    "place_name":"Currambine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6028,
    "place_name":"Kinross",
    "state_name":"Western Australia"
  },
  {
    "postcode":6028,
    "place_name":"Burns Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6029,
    "place_name":"Trigg",
    "state_name":"Western Australia"
  },
  {
    "postcode":6030,
    "place_name":"Merriwa",
    "state_name":"Western Australia"
  },
  {
    "postcode":6030,
    "place_name":"Tamala Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6030,
    "place_name":"Clarkson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6030,
    "place_name":"Quinns Rocks",
    "state_name":"Western Australia"
  },
  {
    "postcode":6030,
    "place_name":"Ridgewood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6030,
    "place_name":"Mindarie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6031,
    "place_name":"Neerabup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6031,
    "place_name":"Banksia Grove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6031,
    "place_name":"Carramar",
    "state_name":"Western Australia"
  },
  {
    "postcode":6032,
    "place_name":"Nowergup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6033,
    "place_name":"Carabooda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6034,
    "place_name":"Eglinton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6035,
    "place_name":"Yanchep",
    "state_name":"Western Australia"
  },
  {
    "postcode":6036,
    "place_name":"Butler",
    "state_name":"Western Australia"
  },
  {
    "postcode":6036,
    "place_name":"Jindalee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6037,
    "place_name":"Two Rocks",
    "state_name":"Western Australia"
  },
  {
    "postcode":6038,
    "place_name":"Alkimos",
    "state_name":"Western Australia"
  },
  {
    "postcode":6041,
    "place_name":"Wilbinga",
    "state_name":"Western Australia"
  },
  {
    "postcode":6041,
    "place_name":"Gabbadah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6041,
    "place_name":"Caraban",
    "state_name":"Western Australia"
  },
  {
    "postcode":6041,
    "place_name":"Woodridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6041,
    "place_name":"Guilderton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6042,
    "place_name":"Seabird",
    "state_name":"Western Australia"
  },
  {
    "postcode":6043,
    "place_name":"Ledge Point",
    "state_name":"Western Australia"
  },
  {
    "postcode":6043,
    "place_name":"Breton Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6044,
    "place_name":"Lancelin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6044,
    "place_name":"Wedge Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6044,
    "place_name":"Karakin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6044,
    "place_name":"Nilgen",
    "state_name":"Western Australia"
  },
  {
    "postcode":6050,
    "place_name":"Menora",
    "state_name":"Western Australia"
  },
  {
    "postcode":6050,
    "place_name":"Coolbinia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6050,
    "place_name":"Mount Lawley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6051,
    "place_name":"Maylands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6052,
    "place_name":"Inglewood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6052,
    "place_name":"Bedford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6053,
    "place_name":"Bayswater",
    "state_name":"Western Australia"
  },
  {
    "postcode":6054,
    "place_name":"Ashfield",
    "state_name":"Western Australia"
  },
  {
    "postcode":6054,
    "place_name":"Bassendean",
    "state_name":"Western Australia"
  },
  {
    "postcode":6054,
    "place_name":"Eden Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6054,
    "place_name":"Lockridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6054,
    "place_name":"Kiara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6055,
    "place_name":"Hazelmere",
    "state_name":"Western Australia"
  },
  {
    "postcode":6055,
    "place_name":"Henley Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6055,
    "place_name":"West Swan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6055,
    "place_name":"Brabham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6055,
    "place_name":"Caversham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6055,
    "place_name":"South Guildford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6055,
    "place_name":"Guildford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6055,
    "place_name":"Dayton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Koongamia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Viveash",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Jane Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Midvale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Boya",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Woodbridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Greenmount",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Red Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Helena Valley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Midland",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Baskerville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Bellevue",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Middle Swan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Millendon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Stratton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Swan View",
    "state_name":"Western Australia"
  },
  {
    "postcode":6056,
    "place_name":"Herne Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6057,
    "place_name":"High Wycombe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6057,
    "place_name":"Maida Vale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6058,
    "place_name":"Forrestfield",
    "state_name":"Western Australia"
  },
  {
    "postcode":6059,
    "place_name":"Dianella",
    "state_name":"Western Australia"
  },
  {
    "postcode":6060,
    "place_name":"Joondanna",
    "state_name":"Western Australia"
  },
  {
    "postcode":6060,
    "place_name":"Dog Swamp",
    "state_name":"Western Australia"
  },
  {
    "postcode":6060,
    "place_name":"Tuart Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6060,
    "place_name":"Yokine South",
    "state_name":"Western Australia"
  },
  {
    "postcode":6060,
    "place_name":"Yokine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6061,
    "place_name":"Westminster",
    "state_name":"Western Australia"
  },
  {
    "postcode":6061,
    "place_name":"Balga",
    "state_name":"Western Australia"
  },
  {
    "postcode":6061,
    "place_name":"Mirrabooka",
    "state_name":"Western Australia"
  },
  {
    "postcode":6061,
    "place_name":"Nollamara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6062,
    "place_name":"Embleton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6062,
    "place_name":"Morley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6062,
    "place_name":"Noranda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6063,
    "place_name":"Beechboro",
    "state_name":"Western Australia"
  },
  {
    "postcode":6063,
    "place_name":"Bennett Springs",
    "state_name":"Western Australia"
  },
  {
    "postcode":6064,
    "place_name":"Girrawheen",
    "state_name":"Western Australia"
  },
  {
    "postcode":6064,
    "place_name":"Alexander Heights",
    "state_name":"Western Australia"
  },
  {
    "postcode":6064,
    "place_name":"Marangaroo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6064,
    "place_name":"Koondoola",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Madeley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Gnangara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Sinagra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Hocking",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Darch",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Wangara DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Pearsall",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Tapping",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Wanneroo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Kingsway",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Wangara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Landsdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Lexia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Mariginiup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Ashby",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Jandabup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Pinjar",
    "state_name":"Western Australia"
  },
  {
    "postcode":6065,
    "place_name":"Melaleuca",
    "state_name":"Western Australia"
  },
  {
    "postcode":6066,
    "place_name":"Ballajura",
    "state_name":"Western Australia"
  },
  {
    "postcode":6067,
    "place_name":"Cullacabardee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6068,
    "place_name":"Whiteman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6069,
    "place_name":"Aveley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6069,
    "place_name":"Upper Swan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6069,
    "place_name":"The Vines",
    "state_name":"Western Australia"
  },
  {
    "postcode":6069,
    "place_name":"Ellenbrook East",
    "state_name":"Western Australia"
  },
  {
    "postcode":6069,
    "place_name":"Belhus",
    "state_name":"Western Australia"
  },
  {
    "postcode":6069,
    "place_name":"Ellenbrook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6069,
    "place_name":"Brigadoon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6070,
    "place_name":"Darlington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6071,
    "place_name":"Hovea",
    "state_name":"Western Australia"
  },
  {
    "postcode":6071,
    "place_name":"Glen Forrest",
    "state_name":"Western Australia"
  },
  {
    "postcode":6072,
    "place_name":"Mahogany Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6073,
    "place_name":"Mundaring DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6073,
    "place_name":"Mundaring",
    "state_name":"Western Australia"
  },
  {
    "postcode":6074,
    "place_name":"Sawyers Valley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6076,
    "place_name":"Bickley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6076,
    "place_name":"Paulls Valley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6076,
    "place_name":"Reservoir",
    "state_name":"Western Australia"
  },
  {
    "postcode":6076,
    "place_name":"Carmel",
    "state_name":"Western Australia"
  },
  {
    "postcode":6076,
    "place_name":"Lesmurdie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6076,
    "place_name":"Hacketts Gully",
    "state_name":"Western Australia"
  },
  {
    "postcode":6076,
    "place_name":"Kalamunda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6076,
    "place_name":"Piesse Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6076,
    "place_name":"Gooseberry Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6076,
    "place_name":"Pickering Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6076,
    "place_name":"Walliston",
    "state_name":"Western Australia"
  },
  {
    "postcode":6077,
    "place_name":"Gnangara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6077,
    "place_name":"Jandabup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6078,
    "place_name":"Pinjar",
    "state_name":"Western Australia"
  },
  {
    "postcode":6078,
    "place_name":"Mariginiup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6079,
    "place_name":"Melaleuca",
    "state_name":"Western Australia"
  },
  {
    "postcode":6079,
    "place_name":"Lexia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6081,
    "place_name":"Stoneville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6081,
    "place_name":"Parkerville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6082,
    "place_name":"Mount Helena",
    "state_name":"Western Australia"
  },
  {
    "postcode":6082,
    "place_name":"Bailup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6083,
    "place_name":"Morangup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6083,
    "place_name":"Gidgegannup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6084,
    "place_name":"Chittering",
    "state_name":"Western Australia"
  },
  {
    "postcode":6084,
    "place_name":"Lower Chittering",
    "state_name":"Western Australia"
  },
  {
    "postcode":6084,
    "place_name":"Bullsbrook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6084,
    "place_name":"Walyunga National Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6084,
    "place_name":"Avon Valley National Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6090,
    "place_name":"Malaga",
    "state_name":"Western Australia"
  },
  {
    "postcode":6100,
    "place_name":"Burswood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6100,
    "place_name":"Lathlain",
    "state_name":"Western Australia"
  },
  {
    "postcode":6100,
    "place_name":"Victoria Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6101,
    "place_name":"Carlisle South",
    "state_name":"Western Australia"
  },
  {
    "postcode":6101,
    "place_name":"Carlisle",
    "state_name":"Western Australia"
  },
  {
    "postcode":6101,
    "place_name":"East Victoria Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6101,
    "place_name":"Carlisle North",
    "state_name":"Western Australia"
  },
  {
    "postcode":6102,
    "place_name":"Bentley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6102,
    "place_name":"St James",
    "state_name":"Western Australia"
  },
  {
    "postcode":6102,
    "place_name":"Bentley DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6102,
    "place_name":"Bentley South",
    "state_name":"Western Australia"
  },
  {
    "postcode":6103,
    "place_name":"Rivervale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6104,
    "place_name":"Redcliffe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6104,
    "place_name":"Belmont",
    "state_name":"Western Australia"
  },
  {
    "postcode":6104,
    "place_name":"Ascot",
    "state_name":"Western Australia"
  },
  {
    "postcode":6105,
    "place_name":"Perth Airport",
    "state_name":"Western Australia"
  },
  {
    "postcode":6105,
    "place_name":"Kewdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6105,
    "place_name":"Cloverdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6106,
    "place_name":"Welshpool",
    "state_name":"Western Australia"
  },
  {
    "postcode":6107,
    "place_name":"Wattle Grove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6107,
    "place_name":"Queens Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6107,
    "place_name":"Kenwick",
    "state_name":"Western Australia"
  },
  {
    "postcode":6107,
    "place_name":"Beckenham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6107,
    "place_name":"East Cannington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6107,
    "place_name":"Wilson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6107,
    "place_name":"Cannington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6108,
    "place_name":"Thornlie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6109,
    "place_name":"Maddington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6109,
    "place_name":"Orange Grove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6110,
    "place_name":"Gosnells",
    "state_name":"Western Australia"
  },
  {
    "postcode":6110,
    "place_name":"Huntingdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6110,
    "place_name":"Southern River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6110,
    "place_name":"Martin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6111,
    "place_name":"Champion Lakes",
    "state_name":"Western Australia"
  },
  {
    "postcode":6111,
    "place_name":"Ashendon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6111,
    "place_name":"Kelmscott",
    "state_name":"Western Australia"
  },
  {
    "postcode":6111,
    "place_name":"Camillo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6111,
    "place_name":"Roleystone",
    "state_name":"Western Australia"
  },
  {
    "postcode":6111,
    "place_name":"Karragullen",
    "state_name":"Western Australia"
  },
  {
    "postcode":6111,
    "place_name":"Canning Mills",
    "state_name":"Western Australia"
  },
  {
    "postcode":6111,
    "place_name":"Lesley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6111,
    "place_name":"Kelmscott DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6111,
    "place_name":"Westfield",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Mount Nasura",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Piara Waters",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Wungong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Forrestdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Hilbert",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Harrisdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Mount Richon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Brookdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Haynes",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Bedfordale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Armadale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6112,
    "place_name":"Seville Grove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6121,
    "place_name":"Oldbury",
    "state_name":"Western Australia"
  },
  {
    "postcode":6121,
    "place_name":"Oakford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6122,
    "place_name":"Byford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6122,
    "place_name":"Karrakup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6122,
    "place_name":"Cardup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6122,
    "place_name":"Darling Downs",
    "state_name":"Western Australia"
  },
  {
    "postcode":6123,
    "place_name":"Whitby",
    "state_name":"Western Australia"
  },
  {
    "postcode":6123,
    "place_name":"Mundijong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6124,
    "place_name":"Jarrahdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6125,
    "place_name":"Serpentine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6125,
    "place_name":"Hopeland",
    "state_name":"Western Australia"
  },
  {
    "postcode":6125,
    "place_name":"Mardella",
    "state_name":"Western Australia"
  },
  {
    "postcode":6126,
    "place_name":"Keysbrook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6147,
    "place_name":"Lynwood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6147,
    "place_name":"Langford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6147,
    "place_name":"Parkwood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6148,
    "place_name":"Shelley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6148,
    "place_name":"Rossmoyne",
    "state_name":"Western Australia"
  },
  {
    "postcode":6148,
    "place_name":"Ferndale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6148,
    "place_name":"Riverton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6149,
    "place_name":"Bull Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6149,
    "place_name":"Leeming",
    "state_name":"Western Australia"
  },
  {
    "postcode":6150,
    "place_name":"Murdoch",
    "state_name":"Western Australia"
  },
  {
    "postcode":6150,
    "place_name":"Bateman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6150,
    "place_name":"Winthrop",
    "state_name":"Western Australia"
  },
  {
    "postcode":6151,
    "place_name":"South Perth Angelo St",
    "state_name":"Western Australia"
  },
  {
    "postcode":6151,
    "place_name":"South Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6151,
    "place_name":"Kensington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6152,
    "place_name":"Waterford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6152,
    "place_name":"Como",
    "state_name":"Western Australia"
  },
  {
    "postcode":6152,
    "place_name":"Karawara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6152,
    "place_name":"Manning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6152,
    "place_name":"Salter Point",
    "state_name":"Western Australia"
  },
  {
    "postcode":6153,
    "place_name":"Mount Pleasant",
    "state_name":"Western Australia"
  },
  {
    "postcode":6153,
    "place_name":"Ardross",
    "state_name":"Western Australia"
  },
  {
    "postcode":6153,
    "place_name":"Applecross North",
    "state_name":"Western Australia"
  },
  {
    "postcode":6153,
    "place_name":"Brentwood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6153,
    "place_name":"Canning Bridge Applecross",
    "state_name":"Western Australia"
  },
  {
    "postcode":6153,
    "place_name":"Applecross",
    "state_name":"Western Australia"
  },
  {
    "postcode":6154,
    "place_name":"Myaree",
    "state_name":"Western Australia"
  },
  {
    "postcode":6154,
    "place_name":"Booragoon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6154,
    "place_name":"Alfred Cove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6155,
    "place_name":"Canning Vale East",
    "state_name":"Western Australia"
  },
  {
    "postcode":6155,
    "place_name":"Willetton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6155,
    "place_name":"Canning Vale DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6155,
    "place_name":"Canning Vale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6155,
    "place_name":"Canning Vale South",
    "state_name":"Western Australia"
  },
  {
    "postcode":6156,
    "place_name":"Melville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6156,
    "place_name":"Willagee Central",
    "state_name":"Western Australia"
  },
  {
    "postcode":6156,
    "place_name":"Attadale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6156,
    "place_name":"Willagee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6157,
    "place_name":"Palmyra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6157,
    "place_name":"Palmyra DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6157,
    "place_name":"Bicton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6158,
    "place_name":"East Fremantle",
    "state_name":"Western Australia"
  },
  {
    "postcode":6159,
    "place_name":"North Fremantle",
    "state_name":"Western Australia"
  },
  {
    "postcode":6160,
    "place_name":"Fremantle",
    "state_name":"Western Australia"
  },
  {
    "postcode":6161,
    "place_name":"Rottnest Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6162,
    "place_name":"White Gum Valley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6162,
    "place_name":"South Fremantle",
    "state_name":"Western Australia"
  },
  {
    "postcode":6162,
    "place_name":"Beaconsfield",
    "state_name":"Western Australia"
  },
  {
    "postcode":6163,
    "place_name":"Bibra Lake",
    "state_name":"Western Australia"
  },
  {
    "postcode":6163,
    "place_name":"Hamilton Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6163,
    "place_name":"Spearwood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6163,
    "place_name":"North Lake",
    "state_name":"Western Australia"
  },
  {
    "postcode":6163,
    "place_name":"O'Connor",
    "state_name":"Western Australia"
  },
  {
    "postcode":6163,
    "place_name":"Hilton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6163,
    "place_name":"Kardinya",
    "state_name":"Western Australia"
  },
  {
    "postcode":6163,
    "place_name":"Bibra Lake DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6163,
    "place_name":"Samson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6163,
    "place_name":"Coolbellup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6163,
    "place_name":"North Coogee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6164,
    "place_name":"Atwell",
    "state_name":"Western Australia"
  },
  {
    "postcode":6164,
    "place_name":"Banjup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6164,
    "place_name":"Success",
    "state_name":"Western Australia"
  },
  {
    "postcode":6164,
    "place_name":"Beeliar",
    "state_name":"Western Australia"
  },
  {
    "postcode":6164,
    "place_name":"Hammond Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6164,
    "place_name":"Yangebup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6164,
    "place_name":"Aubin Grove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6164,
    "place_name":"South Lake",
    "state_name":"Western Australia"
  },
  {
    "postcode":6164,
    "place_name":"Jandakot",
    "state_name":"Western Australia"
  },
  {
    "postcode":6164,
    "place_name":"Cockburn Central",
    "state_name":"Western Australia"
  },
  {
    "postcode":6165,
    "place_name":"Hope Valley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6165,
    "place_name":"Naval Base",
    "state_name":"Western Australia"
  },
  {
    "postcode":6166,
    "place_name":"Wattleup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6166,
    "place_name":"Munster",
    "state_name":"Western Australia"
  },
  {
    "postcode":6166,
    "place_name":"Coogee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6166,
    "place_name":"Henderson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Wandi",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Parmelia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Casuarina",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Medina",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Anketell",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Kwinana Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Bertram",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Postans",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Calista",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Kwinana Town Centre",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Mandogalup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"The Spectacles",
    "state_name":"Western Australia"
  },
  {
    "postcode":6167,
    "place_name":"Orelia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6168,
    "place_name":"Hillman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6168,
    "place_name":"Rockingham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6168,
    "place_name":"Peron",
    "state_name":"Western Australia"
  },
  {
    "postcode":6168,
    "place_name":"Garden Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6168,
    "place_name":"Rockingham DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6168,
    "place_name":"Cooloongup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6168,
    "place_name":"Rockingham Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6168,
    "place_name":"East Rockingham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6169,
    "place_name":"Safety Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6169,
    "place_name":"Shoalwater",
    "state_name":"Western Australia"
  },
  {
    "postcode":6169,
    "place_name":"Waikiki",
    "state_name":"Western Australia"
  },
  {
    "postcode":6169,
    "place_name":"Warnbro",
    "state_name":"Western Australia"
  },
  {
    "postcode":6170,
    "place_name":"Leda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6170,
    "place_name":"Wellard",
    "state_name":"Western Australia"
  },
  {
    "postcode":6171,
    "place_name":"Baldivis",
    "state_name":"Western Australia"
  },
  {
    "postcode":6172,
    "place_name":"Port Kennedy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6173,
    "place_name":"Secret Harbour",
    "state_name":"Western Australia"
  },
  {
    "postcode":6174,
    "place_name":"Golden Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6175,
    "place_name":"Singleton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6176,
    "place_name":"Karnup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6180,
    "place_name":"Parklands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6180,
    "place_name":"Lakelands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6181,
    "place_name":"Stake Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6182,
    "place_name":"Keralup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6207,
    "place_name":"Solus",
    "state_name":"Western Australia"
  },
  {
    "postcode":6207,
    "place_name":"Nambeelup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6207,
    "place_name":"Whittaker",
    "state_name":"Western Australia"
  },
  {
    "postcode":6207,
    "place_name":"North Dandalup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6207,
    "place_name":"Myara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6208,
    "place_name":"Ravenswood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6208,
    "place_name":"Pinjarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6208,
    "place_name":"Meelon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6208,
    "place_name":"West Pinjarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6208,
    "place_name":"North Yunderup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6208,
    "place_name":"Point Grey",
    "state_name":"Western Australia"
  },
  {
    "postcode":6208,
    "place_name":"South Yunderup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6208,
    "place_name":"Blythewood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6208,
    "place_name":"Fairbridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6208,
    "place_name":"Nirimba",
    "state_name":"Western Australia"
  },
  {
    "postcode":6208,
    "place_name":"Oakley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6209,
    "place_name":"Furnissdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6209,
    "place_name":"Barragup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Mandurah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Parklands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Bouvard",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Greenfields",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Wannanup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Mandurah DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Dudley Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Clifton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Meadow Springs",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Mandurah East",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Silver Sands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Lakelands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Furnissdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Mandurah North",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"San Remo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Coodanup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Herron",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Falcon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Dawesville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Barragup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Stake Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Halls Head",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Erskine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6210,
    "place_name":"Madora Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6211,
    "place_name":"Dawesville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6211,
    "place_name":"Bouvard",
    "state_name":"Western Australia"
  },
  {
    "postcode":6211,
    "place_name":"Clifton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6211,
    "place_name":"Herron",
    "state_name":"Western Australia"
  },
  {
    "postcode":6213,
    "place_name":"Marrinup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6213,
    "place_name":"Dwellingup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6213,
    "place_name":"Etmilyn",
    "state_name":"Western Australia"
  },
  {
    "postcode":6213,
    "place_name":"Inglehope",
    "state_name":"Western Australia"
  },
  {
    "postcode":6213,
    "place_name":"Banksiadale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6213,
    "place_name":"Teesdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6213,
    "place_name":"Holyoake",
    "state_name":"Western Australia"
  },
  {
    "postcode":6214,
    "place_name":"West Coolup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6214,
    "place_name":"Coolup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6214,
    "place_name":"Birchmont",
    "state_name":"Western Australia"
  },
  {
    "postcode":6215,
    "place_name":"Waroona",
    "state_name":"Western Australia"
  },
  {
    "postcode":6215,
    "place_name":"Hamel",
    "state_name":"Western Australia"
  },
  {
    "postcode":6215,
    "place_name":"Lake Clifton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6215,
    "place_name":"Nanga Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6215,
    "place_name":"Wagerup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6215,
    "place_name":"Preston Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6218,
    "place_name":"Yarloop",
    "state_name":"Western Australia"
  },
  {
    "postcode":6220,
    "place_name":"Hoffman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6220,
    "place_name":"Myalup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6220,
    "place_name":"Cookernup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6220,
    "place_name":"Harvey",
    "state_name":"Western Australia"
  },
  {
    "postcode":6220,
    "place_name":"Warawarrup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6220,
    "place_name":"Uduc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6221,
    "place_name":"Mornington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6221,
    "place_name":"Wokalup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6223,
    "place_name":"Benger",
    "state_name":"Western Australia"
  },
  {
    "postcode":6224,
    "place_name":"Beela",
    "state_name":"Western Australia"
  },
  {
    "postcode":6224,
    "place_name":"Brunswick",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Allanson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Mumballup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Palmer",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Mcalinden",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Cardiff",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Shotts",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Lyalls Mill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Bowelling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Noggerup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Muja",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Buckingham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Collie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Collie Burn",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Mungalup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Worsley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Preston Settlement",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Yourdamung Lake",
    "state_name":"Western Australia"
  },
  {
    "postcode":6225,
    "place_name":"Harris River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6226,
    "place_name":"Roelands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6227,
    "place_name":"Burekup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6228,
    "place_name":"Waterloo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6229,
    "place_name":"Picton East",
    "state_name":"Western Australia"
  },
  {
    "postcode":6229,
    "place_name":"Picton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"Withers",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"Dalyellup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"Gelorup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"Vittoria",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"Glen Iris",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"South Bunbury",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"Pelican Point",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"Bunbury",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"East Bunbury",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"College Grove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"Davenport",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"Carey Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6230,
    "place_name":"Usher",
    "state_name":"Western Australia"
  },
  {
    "postcode":6231,
    "place_name":"Bunbury",
    "state_name":"Western Australia"
  },
  {
    "postcode":6232,
    "place_name":"Eaton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6232,
    "place_name":"Millbridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6233,
    "place_name":"Parkfield",
    "state_name":"Western Australia"
  },
  {
    "postcode":6233,
    "place_name":"Australind",
    "state_name":"Western Australia"
  },
  {
    "postcode":6233,
    "place_name":"Wellesley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6233,
    "place_name":"Leschenault",
    "state_name":"Western Australia"
  },
  {
    "postcode":6233,
    "place_name":"Binningup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6236,
    "place_name":"Wellington Mill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6236,
    "place_name":"Paradise",
    "state_name":"Western Australia"
  },
  {
    "postcode":6236,
    "place_name":"Dardanup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6236,
    "place_name":"Wellington Forest",
    "state_name":"Western Australia"
  },
  {
    "postcode":6236,
    "place_name":"Ferguson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6236,
    "place_name":"Dardanup West",
    "state_name":"Western Australia"
  },
  {
    "postcode":6236,
    "place_name":"Crooked Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6236,
    "place_name":"Henty",
    "state_name":"Western Australia"
  },
  {
    "postcode":6237,
    "place_name":"Stratham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6237,
    "place_name":"Elgin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6237,
    "place_name":"Boyanup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6237,
    "place_name":"North Boyanup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6237,
    "place_name":"Gwindinup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6237,
    "place_name":"The Plains",
    "state_name":"Western Australia"
  },
  {
    "postcode":6239,
    "place_name":"Beelerup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6239,
    "place_name":"Donnybrook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6239,
    "place_name":"Argyle",
    "state_name":"Western Australia"
  },
  {
    "postcode":6239,
    "place_name":"Upper Capel",
    "state_name":"Western Australia"
  },
  {
    "postcode":6239,
    "place_name":"Yabberup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6239,
    "place_name":"Thomson Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6239,
    "place_name":"Paynedale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6239,
    "place_name":"Queenwood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6239,
    "place_name":"Brookhampton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6239,
    "place_name":"Charley Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6239,
    "place_name":"Glen Mervyn",
    "state_name":"Western Australia"
  },
  {
    "postcode":6240,
    "place_name":"Lowden",
    "state_name":"Western Australia"
  },
  {
    "postcode":6243,
    "place_name":"Wilga West",
    "state_name":"Western Australia"
  },
  {
    "postcode":6243,
    "place_name":"Wilga",
    "state_name":"Western Australia"
  },
  {
    "postcode":6244,
    "place_name":"Mayanup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6244,
    "place_name":"Chowerup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6244,
    "place_name":"Boyup Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6244,
    "place_name":"Tonebridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6244,
    "place_name":"Dinninup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6244,
    "place_name":"Kulikup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6244,
    "place_name":"Trigwell",
    "state_name":"Western Australia"
  },
  {
    "postcode":6244,
    "place_name":"Scotts Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6251,
    "place_name":"Newlands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6251,
    "place_name":"Kirup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6251,
    "place_name":"Brazier",
    "state_name":"Western Australia"
  },
  {
    "postcode":6252,
    "place_name":"Mullalyup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6253,
    "place_name":"Balingup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6253,
    "place_name":"Southampton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6253,
    "place_name":"Grimwade",
    "state_name":"Western Australia"
  },
  {
    "postcode":6254,
    "place_name":"Greenbushes",
    "state_name":"Western Australia"
  },
  {
    "postcode":6254,
    "place_name":"North Greenbushes",
    "state_name":"Western Australia"
  },
  {
    "postcode":6255,
    "place_name":"Benjinup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6255,
    "place_name":"Hester",
    "state_name":"Western Australia"
  },
  {
    "postcode":6255,
    "place_name":"Bridgetown",
    "state_name":"Western Australia"
  },
  {
    "postcode":6255,
    "place_name":"Kangaroo Gully",
    "state_name":"Western Australia"
  },
  {
    "postcode":6255,
    "place_name":"Catterick",
    "state_name":"Western Australia"
  },
  {
    "postcode":6255,
    "place_name":"Winnejup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6255,
    "place_name":"Hester Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6256,
    "place_name":"Yornup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6256,
    "place_name":"Sunnyside",
    "state_name":"Western Australia"
  },
  {
    "postcode":6256,
    "place_name":"Glenlynn",
    "state_name":"Western Australia"
  },
  {
    "postcode":6256,
    "place_name":"Maranup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6256,
    "place_name":"Wandillup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6256,
    "place_name":"Kingston",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Yanmah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Wilgarrup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Palgarup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Diamond Tree",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Jardee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Ringbark",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Manjimup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Linfarne",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Balbarrup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Smith Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Lake Muir",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Dixvale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Quinninup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Shannon River Mill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Deanmill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Crowea",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Upper Warren",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Glenoran",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Donnelly River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Middlesex",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Mordalup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Dingup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Nyamup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6258,
    "place_name":"Perup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6260,
    "place_name":"Eastbrook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6260,
    "place_name":"Pemberton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6260,
    "place_name":"Yeagarup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6260,
    "place_name":"Collins",
    "state_name":"Western Australia"
  },
  {
    "postcode":6260,
    "place_name":"Biddelia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6260,
    "place_name":"Channybearup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6260,
    "place_name":"Callcup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6260,
    "place_name":"Beedelup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6260,
    "place_name":"Lake Jasper",
    "state_name":"Western Australia"
  },
  {
    "postcode":6260,
    "place_name":"Peerabeelup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6262,
    "place_name":"Crowea",
    "state_name":"Western Australia"
  },
  {
    "postcode":6262,
    "place_name":"Windy Harbour",
    "state_name":"Western Australia"
  },
  {
    "postcode":6262,
    "place_name":"Northcliffe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6262,
    "place_name":"Boorara Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6262,
    "place_name":"Meerup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6262,
    "place_name":"Shannon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6271,
    "place_name":"Peppermint Grove Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6271,
    "place_name":"Capel",
    "state_name":"Western Australia"
  },
  {
    "postcode":6271,
    "place_name":"Forrest Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6271,
    "place_name":"Capel River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6271,
    "place_name":"Stirling Estate",
    "state_name":"Western Australia"
  },
  {
    "postcode":6275,
    "place_name":"Nannup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6275,
    "place_name":"Jarrahwood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6275,
    "place_name":"Darradup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6275,
    "place_name":"Barrabup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6275,
    "place_name":"Carlotta",
    "state_name":"Western Australia"
  },
  {
    "postcode":6275,
    "place_name":"Cundinup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6275,
    "place_name":"Scott River East",
    "state_name":"Western Australia"
  },
  {
    "postcode":6275,
    "place_name":"Yoganup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6275,
    "place_name":"East Nannup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6275,
    "place_name":"Jalbarragup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Carbunup River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Bovell",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Busselton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Broadwater",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Yelverton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Yoongarillup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Ludlow",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Kaloorup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Vasse",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Abbey",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Metricup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Ruabon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Ambergate",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Reinscourt",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Wonnerup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"West Busselton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Yalyalup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Kealy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Siesta Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Tutunup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Anniebrook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Kalgup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"North Jindong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Hithergreen",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Walsall",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Jindong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Sabina River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Chapman Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Boallia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Wilyabrup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Marybrook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Abba River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Geographe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6280,
    "place_name":"Acton Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6281,
    "place_name":"Quindalup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6281,
    "place_name":"Dunsborough",
    "state_name":"Western Australia"
  },
  {
    "postcode":6281,
    "place_name":"Eagle Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6281,
    "place_name":"Quedjinup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6281,
    "place_name":"Naturaliste",
    "state_name":"Western Australia"
  },
  {
    "postcode":6282,
    "place_name":"Yallingup Siding",
    "state_name":"Western Australia"
  },
  {
    "postcode":6282,
    "place_name":"Yallingup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6284,
    "place_name":"Baudin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6284,
    "place_name":"Cowaramup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6284,
    "place_name":"Gracetown",
    "state_name":"Western Australia"
  },
  {
    "postcode":6284,
    "place_name":"Treeton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6285,
    "place_name":"Prevelly",
    "state_name":"Western Australia"
  },
  {
    "postcode":6285,
    "place_name":"Rosa Glen",
    "state_name":"Western Australia"
  },
  {
    "postcode":6285,
    "place_name":"Margaret River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6285,
    "place_name":"Osmington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6285,
    "place_name":"Bramley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6285,
    "place_name":"Schroeder",
    "state_name":"Western Australia"
  },
  {
    "postcode":6285,
    "place_name":"Burnside",
    "state_name":"Western Australia"
  },
  {
    "postcode":6285,
    "place_name":"Rosa Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6285,
    "place_name":"Gnarabup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6286,
    "place_name":"Forest Grove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6286,
    "place_name":"Witchcliffe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6286,
    "place_name":"Redgate",
    "state_name":"Western Australia"
  },
  {
    "postcode":6286,
    "place_name":"Boranup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6288,
    "place_name":"Karridale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6288,
    "place_name":"Scott River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6288,
    "place_name":"Hamelin Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6288,
    "place_name":"Nillup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6288,
    "place_name":"Warner Glen",
    "state_name":"Western Australia"
  },
  {
    "postcode":6288,
    "place_name":"Alexandra Bridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6288,
    "place_name":"Courtenay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6290,
    "place_name":"Leeuwin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6290,
    "place_name":"Kudardup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6290,
    "place_name":"East Augusta",
    "state_name":"Western Australia"
  },
  {
    "postcode":6290,
    "place_name":"Molloy Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6290,
    "place_name":"Augusta",
    "state_name":"Western Australia"
  },
  {
    "postcode":6290,
    "place_name":"Deepdene",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Talbot West",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Gwambygine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Burges",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"St Ronans",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"York",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Mount Observation",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Mount Hardey",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Cold Harbour",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Malebelling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Narraloggan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Gilgering",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Wilberforce",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Flint",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Caljie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Talbot",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Balladong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Greenhills",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Daliak",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Inkpen",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Quellington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Flynn",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Badgin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6302,
    "place_name":"Kauring",
    "state_name":"Western Australia"
  },
  {
    "postcode":6304,
    "place_name":"Westdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6304,
    "place_name":"Kokeby",
    "state_name":"Western Australia"
  },
  {
    "postcode":6304,
    "place_name":"Bally Bally",
    "state_name":"Western Australia"
  },
  {
    "postcode":6304,
    "place_name":"Beverley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6304,
    "place_name":"East Beverley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6304,
    "place_name":"Morbinning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6304,
    "place_name":"Dale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6306,
    "place_name":"Brookton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6306,
    "place_name":"Jelcobine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6306,
    "place_name":"Kweda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6306,
    "place_name":"Aldersyde",
    "state_name":"Western Australia"
  },
  {
    "postcode":6306,
    "place_name":"Bulyee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6308,
    "place_name":"Springs",
    "state_name":"Western Australia"
  },
  {
    "postcode":6308,
    "place_name":"Hastings",
    "state_name":"Western Australia"
  },
  {
    "postcode":6308,
    "place_name":"Pingelly",
    "state_name":"Western Australia"
  },
  {
    "postcode":6308,
    "place_name":"Dwarda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6308,
    "place_name":"East Pingelly",
    "state_name":"Western Australia"
  },
  {
    "postcode":6308,
    "place_name":"Gillimanning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6308,
    "place_name":"West Pingelly",
    "state_name":"Western Australia"
  },
  {
    "postcode":6308,
    "place_name":"Wandering",
    "state_name":"Western Australia"
  },
  {
    "postcode":6308,
    "place_name":"Codjatotine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6308,
    "place_name":"Pumphreys Bridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6309,
    "place_name":"Popanyinning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6309,
    "place_name":"Stratherne",
    "state_name":"Western Australia"
  },
  {
    "postcode":6309,
    "place_name":"East Popanyinning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6309,
    "place_name":"West Popanyinning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6311,
    "place_name":"Yornaning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6311,
    "place_name":"Contine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6311,
    "place_name":"Dryandra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6311,
    "place_name":"Wardering",
    "state_name":"Western Australia"
  },
  {
    "postcode":6311,
    "place_name":"Cuballing",
    "state_name":"Western Australia"
  },
  {
    "postcode":6311,
    "place_name":"Commodine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6311,
    "place_name":"Lol Gray",
    "state_name":"Western Australia"
  },
  {
    "postcode":6311,
    "place_name":"Townsendale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6312,
    "place_name":"Yilliminning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6312,
    "place_name":"Narrogin Valley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6312,
    "place_name":"Nomans Lake",
    "state_name":"Western Australia"
  },
  {
    "postcode":6312,
    "place_name":"Hillside",
    "state_name":"Western Australia"
  },
  {
    "postcode":6312,
    "place_name":"Dumberning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6312,
    "place_name":"Minigin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6312,
    "place_name":"Narrogin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6312,
    "place_name":"Boundain",
    "state_name":"Western Australia"
  },
  {
    "postcode":6312,
    "place_name":"Toolibin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6313,
    "place_name":"Highbury",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Piesseville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Gundaring",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Jaloran",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Dongolocking",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Lime Lake",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Ballaying",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Minding",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Collanilling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Wedgecarrup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Wagin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Arthur River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6315,
    "place_name":"Cancanning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6316,
    "place_name":"Woodanilling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6316,
    "place_name":"Boyerine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6316,
    "place_name":"Cartmeticup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6316,
    "place_name":"Glencoe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6316,
    "place_name":"Kenmare",
    "state_name":"Western Australia"
  },
  {
    "postcode":6316,
    "place_name":"Westwood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Badgebup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Datatine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Ewlyamartup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Moojebing",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Murdong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Katanning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Coyrecup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Pinwernying",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Marracoonda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Coblinine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Carrolup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"South Datatine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"Bullock Hills",
    "state_name":"Western Australia"
  },
  {
    "postcode":6317,
    "place_name":"South Glencoe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6318,
    "place_name":"Broomehill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6318,
    "place_name":"Broomehill West",
    "state_name":"Western Australia"
  },
  {
    "postcode":6318,
    "place_name":"Broomehill East",
    "state_name":"Western Australia"
  },
  {
    "postcode":6318,
    "place_name":"Broomehill Village",
    "state_name":"Western Australia"
  },
  {
    "postcode":6320,
    "place_name":"Tambellup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6320,
    "place_name":"Moonies Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6320,
    "place_name":"Wansbrough",
    "state_name":"Western Australia"
  },
  {
    "postcode":6320,
    "place_name":"Lake Toolbrunup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6320,
    "place_name":"Bobalong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6320,
    "place_name":"Borderdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6320,
    "place_name":"Dartnall",
    "state_name":"Western Australia"
  },
  {
    "postcode":6321,
    "place_name":"Cranbrook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6322,
    "place_name":"Tenterden",
    "state_name":"Western Australia"
  },
  {
    "postcode":6323,
    "place_name":"Kendenup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6324,
    "place_name":"Takalarup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6324,
    "place_name":"Porongurup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6324,
    "place_name":"Denbarker",
    "state_name":"Western Australia"
  },
  {
    "postcode":6324,
    "place_name":"Woogenellup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6324,
    "place_name":"Perillup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6324,
    "place_name":"Mount Barker",
    "state_name":"Western Australia"
  },
  {
    "postcode":6324,
    "place_name":"Forest Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6324,
    "place_name":"South Stirling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6326,
    "place_name":"Narrikup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6327,
    "place_name":"Redmond",
    "state_name":"Western Australia"
  },
  {
    "postcode":6327,
    "place_name":"Redmond West",
    "state_name":"Western Australia"
  },
  {
    "postcode":6328,
    "place_name":"Mettler",
    "state_name":"Western Australia"
  },
  {
    "postcode":6328,
    "place_name":"Manypeaks",
    "state_name":"Western Australia"
  },
  {
    "postcode":6328,
    "place_name":"Palmdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6328,
    "place_name":"Cape Riche",
    "state_name":"Western Australia"
  },
  {
    "postcode":6328,
    "place_name":"Gnowellen",
    "state_name":"Western Australia"
  },
  {
    "postcode":6328,
    "place_name":"Cheynes",
    "state_name":"Western Australia"
  },
  {
    "postcode":6328,
    "place_name":"Green Range",
    "state_name":"Western Australia"
  },
  {
    "postcode":6328,
    "place_name":"Wellstead",
    "state_name":"Western Australia"
  },
  {
    "postcode":6328,
    "place_name":"Kojaneerup South",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Kalgan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Napier",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Mount Clarence",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Green Valley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Torbay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Milpara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Lower King",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Lowlands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Willyung",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Mckail",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Mount Elphinstone",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Collingwood Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Marbelup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Orana",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Yakamia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Millbrook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Frenchman Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Bornholm",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Seppings",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Nanarup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Mira Mar",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Albany",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"West Cape Howe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Nullaki",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Centennial Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Youngs Siding",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Big Grove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Sandpatch",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Lange",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Cuthbert",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"King River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Vancouver Peninsula",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Gledhow",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Collingwood Heights",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Lockyer",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Port Albany",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Mount Melville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Bayonet Head",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Emu Point",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Little Grove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Warrenup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Spencer Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Elleker",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Robinson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Kronkup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Middleton Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Goode Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Drome",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Walmsley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6330,
    "place_name":"Torndirrup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6331,
    "place_name":"Albany Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6332,
    "place_name":"Albany",
    "state_name":"Western Australia"
  },
  {
    "postcode":6332,
    "place_name":"Albany Po",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Kentdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Hay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Parryville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Denmark",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Nornalup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Shadforth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"William Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Mount Romance",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Ocean Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Trent",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Tingledale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Peaceful Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Hazelvale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Bow Bridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Mount Lindesay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Kordabup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6333,
    "place_name":"Scotsdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6335,
    "place_name":"Kebaringup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6335,
    "place_name":"Gnowangerup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6335,
    "place_name":"Pallinup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6335,
    "place_name":"Jackitup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6336,
    "place_name":"Needilup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6336,
    "place_name":"Toompup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6336,
    "place_name":"Ongerup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6336,
    "place_name":"Mindarabin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6336,
    "place_name":"Mills Lake",
    "state_name":"Western Australia"
  },
  {
    "postcode":6336,
    "place_name":"Cowalellup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6337,
    "place_name":"Jerramungup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6337,
    "place_name":"West Fitzgerald",
    "state_name":"Western Australia"
  },
  {
    "postcode":6337,
    "place_name":"Jacup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6337,
    "place_name":"Gairdner",
    "state_name":"Western Australia"
  },
  {
    "postcode":6337,
    "place_name":"Fitzgerald",
    "state_name":"Western Australia"
  },
  {
    "postcode":6338,
    "place_name":"Bremer Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6338,
    "place_name":"Borden",
    "state_name":"Western Australia"
  },
  {
    "postcode":6338,
    "place_name":"Nalyerlup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6338,
    "place_name":"North Stirlings",
    "state_name":"Western Australia"
  },
  {
    "postcode":6338,
    "place_name":"Monjebup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6338,
    "place_name":"Boxwood Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6338,
    "place_name":"Magitup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6338,
    "place_name":"Stirling Range National Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6338,
    "place_name":"Amelup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6341,
    "place_name":"Nyabing",
    "state_name":"Western Australia"
  },
  {
    "postcode":6343,
    "place_name":"Pingrup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6346,
    "place_name":"Ravensthorpe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6346,
    "place_name":"Fitzgerald River National Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6346,
    "place_name":"Jerdacuttup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6346,
    "place_name":"West River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6348,
    "place_name":"Hopetoun",
    "state_name":"Western Australia"
  },
  {
    "postcode":6350,
    "place_name":"Nippering",
    "state_name":"Western Australia"
  },
  {
    "postcode":6350,
    "place_name":"Dumbleyung",
    "state_name":"Western Australia"
  },
  {
    "postcode":6350,
    "place_name":"Nairibin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6351,
    "place_name":"Moulyinning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6351,
    "place_name":"North Moulyinning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6352,
    "place_name":"Kukerin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6352,
    "place_name":"Merilup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6352,
    "place_name":"North Kukerin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6352,
    "place_name":"South Kukerin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6353,
    "place_name":"Beenong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6353,
    "place_name":"Kuender",
    "state_name":"Western Australia"
  },
  {
    "postcode":6353,
    "place_name":"North Lake Grace",
    "state_name":"Western Australia"
  },
  {
    "postcode":6353,
    "place_name":"Mallee Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6353,
    "place_name":"Lake Grace",
    "state_name":"Western Australia"
  },
  {
    "postcode":6353,
    "place_name":"Neendaling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6353,
    "place_name":"Tarin Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6353,
    "place_name":"North Burngup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6353,
    "place_name":"Buniche",
    "state_name":"Western Australia"
  },
  {
    "postcode":6353,
    "place_name":"South Lake Grace",
    "state_name":"Western Australia"
  },
  {
    "postcode":6355,
    "place_name":"Lake Biddy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6355,
    "place_name":"Lake Camm",
    "state_name":"Western Australia"
  },
  {
    "postcode":6355,
    "place_name":"Varley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6355,
    "place_name":"South Newdegate",
    "state_name":"Western Australia"
  },
  {
    "postcode":6355,
    "place_name":"Newdegate",
    "state_name":"Western Australia"
  },
  {
    "postcode":6355,
    "place_name":"Holt Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6355,
    "place_name":"Mount Sheridan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6355,
    "place_name":"East Newdegate",
    "state_name":"Western Australia"
  },
  {
    "postcode":6355,
    "place_name":"Magenta",
    "state_name":"Western Australia"
  },
  {
    "postcode":6355,
    "place_name":"Dunn Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6355,
    "place_name":"Little Italy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6356,
    "place_name":"Lake King",
    "state_name":"Western Australia"
  },
  {
    "postcode":6356,
    "place_name":"Mount Madden",
    "state_name":"Western Australia"
  },
  {
    "postcode":6356,
    "place_name":"Hatter Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6357,
    "place_name":"Pingaring",
    "state_name":"Western Australia"
  },
  {
    "postcode":6358,
    "place_name":"Karlgarin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6359,
    "place_name":"Hyden",
    "state_name":"Western Australia"
  },
  {
    "postcode":6359,
    "place_name":"Forrestania",
    "state_name":"Western Australia"
  },
  {
    "postcode":6361,
    "place_name":"Tincurrin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6361,
    "place_name":"Harrismith",
    "state_name":"Western Australia"
  },
  {
    "postcode":6363,
    "place_name":"Dudinin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6363,
    "place_name":"Walyurin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6365,
    "place_name":"Jilakin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6365,
    "place_name":"Kulin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6365,
    "place_name":"Jitarning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6365,
    "place_name":"Kulin West",
    "state_name":"Western Australia"
  },
  {
    "postcode":6367,
    "place_name":"Kondinin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6368,
    "place_name":"South Kumminin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6369,
    "place_name":"Mount Walker",
    "state_name":"Western Australia"
  },
  {
    "postcode":6369,
    "place_name":"Wadderin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6369,
    "place_name":"West Holleton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6369,
    "place_name":"Woolocutty",
    "state_name":"Western Australia"
  },
  {
    "postcode":6369,
    "place_name":"Narembeen",
    "state_name":"Western Australia"
  },
  {
    "postcode":6370,
    "place_name":"Wickepin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6370,
    "place_name":"Kirk Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6370,
    "place_name":"East Wickepin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6370,
    "place_name":"Malyalling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6370,
    "place_name":"Wogolin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6372,
    "place_name":"Yealering",
    "state_name":"Western Australia"
  },
  {
    "postcode":6373,
    "place_name":"Bullaring",
    "state_name":"Western Australia"
  },
  {
    "postcode":6375,
    "place_name":"Bilbarin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6375,
    "place_name":"Corrigin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6375,
    "place_name":"Kurrenkutten",
    "state_name":"Western Australia"
  },
  {
    "postcode":6375,
    "place_name":"Gorge Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6375,
    "place_name":"Kunjin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6375,
    "place_name":"Adamsvale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"South Quairading",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"Mount Stirling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"Balkuling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"Cubbine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"Doodenanning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"Mawson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"Quairading",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"Dulbelling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"Wamenusking",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"Badjaling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"Yoting",
    "state_name":"Western Australia"
  },
  {
    "postcode":6383,
    "place_name":"Dangin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6384,
    "place_name":"Pantapin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6385,
    "place_name":"Kwolyin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6386,
    "place_name":"Shackleton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6390,
    "place_name":"Ranford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6390,
    "place_name":"Boddington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6390,
    "place_name":"Crossman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6390,
    "place_name":"North Bannister",
    "state_name":"Western Australia"
  },
  {
    "postcode":6390,
    "place_name":"Bannister",
    "state_name":"Western Australia"
  },
  {
    "postcode":6390,
    "place_name":"Marradong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6390,
    "place_name":"Wuraming",
    "state_name":"Western Australia"
  },
  {
    "postcode":6390,
    "place_name":"Lower Hotham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6390,
    "place_name":"Mount Wells",
    "state_name":"Western Australia"
  },
  {
    "postcode":6390,
    "place_name":"Upper Murray",
    "state_name":"Western Australia"
  },
  {
    "postcode":6390,
    "place_name":"Mount Cooke",
    "state_name":"Western Australia"
  },
  {
    "postcode":6391,
    "place_name":"Williams",
    "state_name":"Western Australia"
  },
  {
    "postcode":6391,
    "place_name":"Narrakine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6391,
    "place_name":"Congelin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6391,
    "place_name":"Tarwonga",
    "state_name":"Western Australia"
  },
  {
    "postcode":6391,
    "place_name":"Quindanning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6391,
    "place_name":"Culbin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6391,
    "place_name":"Hillman River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6391,
    "place_name":"Boraning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6392,
    "place_name":"Meeking",
    "state_name":"Western Australia"
  },
  {
    "postcode":6392,
    "place_name":"Bokal",
    "state_name":"Western Australia"
  },
  {
    "postcode":6392,
    "place_name":"Boolading",
    "state_name":"Western Australia"
  },
  {
    "postcode":6392,
    "place_name":"Darkan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6392,
    "place_name":"Dardadine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6393,
    "place_name":"Duranillin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6393,
    "place_name":"Moodiarrup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6393,
    "place_name":"Cordering",
    "state_name":"Western Australia"
  },
  {
    "postcode":6393,
    "place_name":"Trigwell",
    "state_name":"Western Australia"
  },
  {
    "postcode":6394,
    "place_name":"Muradup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6394,
    "place_name":"Orchid Valley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6394,
    "place_name":"Boscabel",
    "state_name":"Western Australia"
  },
  {
    "postcode":6394,
    "place_name":"Beaufort River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6394,
    "place_name":"Boilup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6394,
    "place_name":"Mokup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6394,
    "place_name":"Qualeup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6394,
    "place_name":"Changerup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6395,
    "place_name":"Kojonup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6395,
    "place_name":"Mobrup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6395,
    "place_name":"Ryansbrook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6395,
    "place_name":"Jingalup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6395,
    "place_name":"Lumeah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6395,
    "place_name":"Cherry Tree Pool",
    "state_name":"Western Australia"
  },
  {
    "postcode":6396,
    "place_name":"Frankland",
    "state_name":"Western Australia"
  },
  {
    "postcode":6396,
    "place_name":"Frankland River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6397,
    "place_name":"Rocky Gully",
    "state_name":"Western Australia"
  },
  {
    "postcode":6398,
    "place_name":"Broke",
    "state_name":"Western Australia"
  },
  {
    "postcode":6398,
    "place_name":"North Walpole",
    "state_name":"Western Australia"
  },
  {
    "postcode":6398,
    "place_name":"Walpole",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Southern Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Cunjardine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Northam",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Spencers Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Jennapullin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Muluckine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Rossmore",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Burlong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Muresk",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Irishtown",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Mokine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Buckland",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Malabaine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Meenaar",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Throssell",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Jennacubbine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Wongamine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6401,
    "place_name":"Mumberkine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6403,
    "place_name":"Grass Valley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6405,
    "place_name":"Warding East",
    "state_name":"Western Australia"
  },
  {
    "postcode":6405,
    "place_name":"Meckering",
    "state_name":"Western Australia"
  },
  {
    "postcode":6405,
    "place_name":"Quelagetting",
    "state_name":"Western Australia"
  },
  {
    "postcode":6405,
    "place_name":"Greenwoods Valley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6407,
    "place_name":"Youndegin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6407,
    "place_name":"Wyola West",
    "state_name":"Western Australia"
  },
  {
    "postcode":6407,
    "place_name":"Cunderdin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6407,
    "place_name":"Wyola",
    "state_name":"Western Australia"
  },
  {
    "postcode":6407,
    "place_name":"Watercarrin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6407,
    "place_name":"Waeel",
    "state_name":"Western Australia"
  },
  {
    "postcode":6409,
    "place_name":"South Tammin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6409,
    "place_name":"North Tammin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6409,
    "place_name":"Tammin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6409,
    "place_name":"Doongin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6409,
    "place_name":"Yorkrakine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6410,
    "place_name":"Mount Caroline",
    "state_name":"Western Australia"
  },
  {
    "postcode":6410,
    "place_name":"Daadenning Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6410,
    "place_name":"North Kellerberrin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6410,
    "place_name":"Bungulla",
    "state_name":"Western Australia"
  },
  {
    "postcode":6410,
    "place_name":"Kellerberrin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6411,
    "place_name":"South Doodlakine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6411,
    "place_name":"Doodlakine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6412,
    "place_name":"Baandee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6412,
    "place_name":"North Baandee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6413,
    "place_name":"Hines Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6414,
    "place_name":"Nangeenan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6415,
    "place_name":"Merredin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6415,
    "place_name":"Goomarin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6415,
    "place_name":"Tandegin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6415,
    "place_name":"Norpa",
    "state_name":"Western Australia"
  },
  {
    "postcode":6415,
    "place_name":"Nokaning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6415,
    "place_name":"Korbel",
    "state_name":"Western Australia"
  },
  {
    "postcode":6418,
    "place_name":"Yarding",
    "state_name":"Western Australia"
  },
  {
    "postcode":6418,
    "place_name":"Bruce Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6419,
    "place_name":"Ardath",
    "state_name":"Western Australia"
  },
  {
    "postcode":6420,
    "place_name":"Cramphorne",
    "state_name":"Western Australia"
  },
  {
    "postcode":6420,
    "place_name":"Muntadgin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6421,
    "place_name":"Burracoppin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6421,
    "place_name":"South Burracoppin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6421,
    "place_name":"Warralakin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6422,
    "place_name":"Walgoolan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6423,
    "place_name":"Warrachuppin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6423,
    "place_name":"Carrabin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6423,
    "place_name":"Westonia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6423,
    "place_name":"Boodarockin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6424,
    "place_name":"Bodallin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6424,
    "place_name":"South Bodallin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6424,
    "place_name":"North Bodallin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6425,
    "place_name":"Moorine Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6425,
    "place_name":"Dulyalbin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Parker Range",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Ghooli",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Holleton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Turkey Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Marvel Loch",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Mount Hampton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Southern Cross",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Mount Holland",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Yellowdine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Corinthia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Mount Palmer",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Mount Jackson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"Skeleton Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6426,
    "place_name":"South Yilgarn",
    "state_name":"Western Australia"
  },
  {
    "postcode":6427,
    "place_name":"Koolyanobbing",
    "state_name":"Western Australia"
  },
  {
    "postcode":6428,
    "place_name":"Babakin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6429,
    "place_name":"Mount Burges",
    "state_name":"Western Australia"
  },
  {
    "postcode":6429,
    "place_name":"Wallaroo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6429,
    "place_name":"Karramindie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6429,
    "place_name":"Londonderry",
    "state_name":"Western Australia"
  },
  {
    "postcode":6429,
    "place_name":"Victoria Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6429,
    "place_name":"Boorabbin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6429,
    "place_name":"Coolgardie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6429,
    "place_name":"Bullabulling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"Kalgoorlie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"Karlkurla",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"West Lamington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"Binduli",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"Mullingar",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"South Kalgoorlie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"Somerville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"West Kalgoorlie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"Lamington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"Broadwood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"Hannans",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"Yilkari",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"Piccadilly",
    "state_name":"Western Australia"
  },
  {
    "postcode":6430,
    "place_name":"Williamstown",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Kanowna",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Feysville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Ora Banda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Boorara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Kookynie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Emu Flat",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Kurnalpi",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Lakewood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Trafalgar",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Plumridge Lakes",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Bulong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Brown Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6431,
    "place_name":"Warburton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6432,
    "place_name":"Boulder",
    "state_name":"Western Australia"
  },
  {
    "postcode":6432,
    "place_name":"Victory Heights",
    "state_name":"Western Australia"
  },
  {
    "postcode":6432,
    "place_name":"Fimiston",
    "state_name":"Western Australia"
  },
  {
    "postcode":6432,
    "place_name":"South Boulder",
    "state_name":"Western Australia"
  },
  {
    "postcode":6433,
    "place_name":"Kalgoorlie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6433,
    "place_name":"Hannans",
    "state_name":"Western Australia"
  },
  {
    "postcode":6433,
    "place_name":"Kalgoorlie Po",
    "state_name":"Western Australia"
  },
  {
    "postcode":6433,
    "place_name":"Kalgoorlie DC",
    "state_name":"Western Australia"
  },
  {
    "postcode":6433,
    "place_name":"Hannans Po",
    "state_name":"Western Australia"
  },
  {
    "postcode":6434,
    "place_name":"Cundeelee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6434,
    "place_name":"Rawlinna",
    "state_name":"Western Australia"
  },
  {
    "postcode":6434,
    "place_name":"Parkeston",
    "state_name":"Western Australia"
  },
  {
    "postcode":6434,
    "place_name":"Forrest",
    "state_name":"Western Australia"
  },
  {
    "postcode":6434,
    "place_name":"Zanthus",
    "state_name":"Western Australia"
  },
  {
    "postcode":6436,
    "place_name":"Ularring",
    "state_name":"Western Australia"
  },
  {
    "postcode":6436,
    "place_name":"Menzies",
    "state_name":"Western Australia"
  },
  {
    "postcode":6437,
    "place_name":"Leinster",
    "state_name":"Western Australia"
  },
  {
    "postcode":6437,
    "place_name":"Sir Samuel",
    "state_name":"Western Australia"
  },
  {
    "postcode":6438,
    "place_name":"Leonora",
    "state_name":"Western Australia"
  },
  {
    "postcode":6438,
    "place_name":"Lake Darlot",
    "state_name":"Western Australia"
  },
  {
    "postcode":6440,
    "place_name":"Burtville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6440,
    "place_name":"Neale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6440,
    "place_name":"Laverton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6440,
    "place_name":"Bandya",
    "state_name":"Western Australia"
  },
  {
    "postcode":6440,
    "place_name":"Beadell",
    "state_name":"Western Australia"
  },
  {
    "postcode":6440,
    "place_name":"Lake Wells",
    "state_name":"Western Australia"
  },
  {
    "postcode":6440,
    "place_name":"Cosmo Newbery",
    "state_name":"Western Australia"
  },
  {
    "postcode":6442,
    "place_name":"Kambalda West",
    "state_name":"Western Australia"
  },
  {
    "postcode":6442,
    "place_name":"Kambalda East",
    "state_name":"Western Australia"
  },
  {
    "postcode":6442,
    "place_name":"Kambalda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6443,
    "place_name":"Higginsville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6443,
    "place_name":"Norseman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6443,
    "place_name":"Fraser Range",
    "state_name":"Western Australia"
  },
  {
    "postcode":6443,
    "place_name":"Widgiemooltha",
    "state_name":"Western Australia"
  },
  {
    "postcode":6443,
    "place_name":"Balladonia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6443,
    "place_name":"Madura",
    "state_name":"Western Australia"
  },
  {
    "postcode":6443,
    "place_name":"Dundas",
    "state_name":"Western Australia"
  },
  {
    "postcode":6443,
    "place_name":"Caiguna",
    "state_name":"Western Australia"
  },
  {
    "postcode":6443,
    "place_name":"Cocklebiddy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6443,
    "place_name":"Mundrabilla",
    "state_name":"Western Australia"
  },
  {
    "postcode":6443,
    "place_name":"Eucla",
    "state_name":"Western Australia"
  },
  {
    "postcode":6445,
    "place_name":"North Cascade",
    "state_name":"Western Australia"
  },
  {
    "postcode":6445,
    "place_name":"Salmon Gums",
    "state_name":"Western Australia"
  },
  {
    "postcode":6446,
    "place_name":"Grass Patch",
    "state_name":"Western Australia"
  },
  {
    "postcode":6447,
    "place_name":"Lort River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6447,
    "place_name":"Scaddan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6447,
    "place_name":"Wittenoom Hills",
    "state_name":"Western Australia"
  },
  {
    "postcode":6447,
    "place_name":"Mount Ney",
    "state_name":"Western Australia"
  },
  {
    "postcode":6448,
    "place_name":"Gibson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Chadwick",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Condingup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Nulsen",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Coomalbidgup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Neridup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Dalyup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Monjingup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Merivale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Pink Lake",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Munglinup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Windabout",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Esperance",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Castletown",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Bandy Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"West Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Myrup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Cascade",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Cape Le Grand",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Boyatup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Beaumont",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Howick",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"Sinclair",
    "state_name":"Western Australia"
  },
  {
    "postcode":6450,
    "place_name":"East Munglinup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6452,
    "place_name":"Cape Arid",
    "state_name":"Western Australia"
  },
  {
    "postcode":6452,
    "place_name":"Israelite Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6452,
    "place_name":"Buraminya",
    "state_name":"Western Australia"
  },
  {
    "postcode":6460,
    "place_name":"Ucarty West",
    "state_name":"Western Australia"
  },
  {
    "postcode":6460,
    "place_name":"Goomalling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6460,
    "place_name":"Karranadgin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6460,
    "place_name":"Walyormouring",
    "state_name":"Western Australia"
  },
  {
    "postcode":6460,
    "place_name":"Hulongine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6461,
    "place_name":"Dowerin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6461,
    "place_name":"Koomberkine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6462,
    "place_name":"Minnivale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6462,
    "place_name":"Ucarty",
    "state_name":"Western Australia"
  },
  {
    "postcode":6462,
    "place_name":"Hindmarsh",
    "state_name":"Western Australia"
  },
  {
    "postcode":6463,
    "place_name":"Benjaberring",
    "state_name":"Western Australia"
  },
  {
    "postcode":6465,
    "place_name":"Manmanning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6466,
    "place_name":"Cadoux",
    "state_name":"Western Australia"
  },
  {
    "postcode":6467,
    "place_name":"Burakin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6468,
    "place_name":"Petrudor",
    "state_name":"Western Australia"
  },
  {
    "postcode":6468,
    "place_name":"Kalannie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6468,
    "place_name":"Goodlands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6470,
    "place_name":"Kulja",
    "state_name":"Western Australia"
  },
  {
    "postcode":6472,
    "place_name":"Tampu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6472,
    "place_name":"Remlap",
    "state_name":"Western Australia"
  },
  {
    "postcode":6472,
    "place_name":"Cleary",
    "state_name":"Western Australia"
  },
  {
    "postcode":6472,
    "place_name":"Karroun Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6472,
    "place_name":"Mouroubra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6472,
    "place_name":"Bimbijy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6472,
    "place_name":"Beacon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6473,
    "place_name":"North Wialki",
    "state_name":"Western Australia"
  },
  {
    "postcode":6473,
    "place_name":"Wialki",
    "state_name":"Western Australia"
  },
  {
    "postcode":6475,
    "place_name":"Koorda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6475,
    "place_name":"Badgerin Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6475,
    "place_name":"Mollerin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6475,
    "place_name":"Booralaming",
    "state_name":"Western Australia"
  },
  {
    "postcode":6475,
    "place_name":"Dukin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6475,
    "place_name":"Newcarlbeon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6475,
    "place_name":"Lake Margarette",
    "state_name":"Western Australia"
  },
  {
    "postcode":6476,
    "place_name":"Gabbin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6477,
    "place_name":"Bencubbin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6477,
    "place_name":"Welbungin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6479,
    "place_name":"Lake Brown",
    "state_name":"Western Australia"
  },
  {
    "postcode":6479,
    "place_name":"Dandanning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6479,
    "place_name":"Barbalin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6479,
    "place_name":"Mukinbudin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6479,
    "place_name":"Karloning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6479,
    "place_name":"Wattoning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6479,
    "place_name":"Elachbutting",
    "state_name":"Western Australia"
  },
  {
    "postcode":6479,
    "place_name":"Bonnie Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6479,
    "place_name":"Wilgoyne",
    "state_name":"Western Australia"
  },
  {
    "postcode":6480,
    "place_name":"Nukarni",
    "state_name":"Western Australia"
  },
  {
    "postcode":6484,
    "place_name":"Ennuin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6484,
    "place_name":"Bullfinch",
    "state_name":"Western Australia"
  },
  {
    "postcode":6484,
    "place_name":"Lake Deborah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6485,
    "place_name":"Korrelocking",
    "state_name":"Western Australia"
  },
  {
    "postcode":6485,
    "place_name":"Wyalkatchem",
    "state_name":"Western Australia"
  },
  {
    "postcode":6485,
    "place_name":"Cowcowing",
    "state_name":"Western Australia"
  },
  {
    "postcode":6485,
    "place_name":"Nalkain",
    "state_name":"Western Australia"
  },
  {
    "postcode":6485,
    "place_name":"Nembudding",
    "state_name":"Western Australia"
  },
  {
    "postcode":6487,
    "place_name":"Yelbeni",
    "state_name":"Western Australia"
  },
  {
    "postcode":6487,
    "place_name":"South Yelbeni",
    "state_name":"Western Australia"
  },
  {
    "postcode":6487,
    "place_name":"North Yelbeni",
    "state_name":"Western Australia"
  },
  {
    "postcode":6488,
    "place_name":"Trayning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6488,
    "place_name":"South Trayning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6488,
    "place_name":"North Trayning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6489,
    "place_name":"North Kununoppin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6489,
    "place_name":"South Kununoppin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6489,
    "place_name":"Kununoppin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6490,
    "place_name":"Elabbin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6490,
    "place_name":"Nungarin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6490,
    "place_name":"Chandler",
    "state_name":"Western Australia"
  },
  {
    "postcode":6490,
    "place_name":"Burran Rock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6490,
    "place_name":"Kwelkan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6490,
    "place_name":"Talgomine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6501,
    "place_name":"Muchea",
    "state_name":"Western Australia"
  },
  {
    "postcode":6502,
    "place_name":"Bindoon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6502,
    "place_name":"Bindoon Training Area",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Cullalla",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Gingin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Wanerie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Coonabidgee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Yeal",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Granville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Orange Springs",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Cowalla",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Bambun",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Breera",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Moondah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Moore River National Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Mindarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Boonanarring",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Red Gully",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Beermullah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Ginginup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Muckenburra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Neergabby",
    "state_name":"Western Australia"
  },
  {
    "postcode":6503,
    "place_name":"Lennard Brook",
    "state_name":"Western Australia"
  },
  {
    "postcode":6504,
    "place_name":"Mooliabeenee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6505,
    "place_name":"Wannamal",
    "state_name":"Western Australia"
  },
  {
    "postcode":6506,
    "place_name":"Mogumber",
    "state_name":"Western Australia"
  },
  {
    "postcode":6507,
    "place_name":"Dandaragan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6507,
    "place_name":"Cooljarloo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6507,
    "place_name":"Cataby",
    "state_name":"Western Australia"
  },
  {
    "postcode":6507,
    "place_name":"Yathroo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6507,
    "place_name":"Mimegarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6507,
    "place_name":"Regans Ford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6509,
    "place_name":"New Norcia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6509,
    "place_name":"Waddington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6509,
    "place_name":"Yarawindah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6509,
    "place_name":"Glentromie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6510,
    "place_name":"Gillingarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6510,
    "place_name":"Barberton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6510,
    "place_name":"Moora",
    "state_name":"Western Australia"
  },
  {
    "postcode":6510,
    "place_name":"Berkshire Valley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6510,
    "place_name":"Koojan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6510,
    "place_name":"Walebing",
    "state_name":"Western Australia"
  },
  {
    "postcode":6511,
    "place_name":"Cervantes",
    "state_name":"Western Australia"
  },
  {
    "postcode":6512,
    "place_name":"Coomberdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6512,
    "place_name":"Namban",
    "state_name":"Western Australia"
  },
  {
    "postcode":6513,
    "place_name":"Gunyidi",
    "state_name":"Western Australia"
  },
  {
    "postcode":6513,
    "place_name":"Watheroo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6514,
    "place_name":"Green Head",
    "state_name":"Western Australia"
  },
  {
    "postcode":6514,
    "place_name":"Leeman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6515,
    "place_name":"Waddy Forest",
    "state_name":"Western Australia"
  },
  {
    "postcode":6515,
    "place_name":"Coorow",
    "state_name":"Western Australia"
  },
  {
    "postcode":6515,
    "place_name":"Marchagee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6515,
    "place_name":"Eganu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6516,
    "place_name":"Jurien Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6517,
    "place_name":"Winchester",
    "state_name":"Western Australia"
  },
  {
    "postcode":6517,
    "place_name":"Carnamah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6518,
    "place_name":"Warradarge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6518,
    "place_name":"Eneabba",
    "state_name":"Western Australia"
  },
  {
    "postcode":6519,
    "place_name":"Three Springs",
    "state_name":"Western Australia"
  },
  {
    "postcode":6519,
    "place_name":"Arrino",
    "state_name":"Western Australia"
  },
  {
    "postcode":6519,
    "place_name":"Womarden",
    "state_name":"Western Australia"
  },
  {
    "postcode":6519,
    "place_name":"Arrowsmith East",
    "state_name":"Western Australia"
  },
  {
    "postcode":6519,
    "place_name":"Kadathinni",
    "state_name":"Western Australia"
  },
  {
    "postcode":6519,
    "place_name":"Dudawa",
    "state_name":"Western Australia"
  },
  {
    "postcode":6521,
    "place_name":"Nambung",
    "state_name":"Western Australia"
  },
  {
    "postcode":6521,
    "place_name":"Badgingarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6521,
    "place_name":"Boothendarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6521,
    "place_name":"Grey",
    "state_name":"Western Australia"
  },
  {
    "postcode":6521,
    "place_name":"Hill River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6522,
    "place_name":"Yandanooka",
    "state_name":"Western Australia"
  },
  {
    "postcode":6522,
    "place_name":"Bundanoon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6522,
    "place_name":"Mingenew",
    "state_name":"Western Australia"
  },
  {
    "postcode":6522,
    "place_name":"Holmwood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6522,
    "place_name":"Yarragadee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6522,
    "place_name":"Lockier",
    "state_name":"Western Australia"
  },
  {
    "postcode":6522,
    "place_name":"Nangetty",
    "state_name":"Western Australia"
  },
  {
    "postcode":6522,
    "place_name":"Mooriary",
    "state_name":"Western Australia"
  },
  {
    "postcode":6522,
    "place_name":"Mount Budd",
    "state_name":"Western Australia"
  },
  {
    "postcode":6522,
    "place_name":"Ikewa",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Irwin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Port Denison",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Dongara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Allanooka",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Mount Adams",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Milo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Bookara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Yardarino",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Arrowsmith",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Mount Horner",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Springfield",
    "state_name":"Western Australia"
  },
  {
    "postcode":6525,
    "place_name":"Bonniefield",
    "state_name":"Western Australia"
  },
  {
    "postcode":6528,
    "place_name":"South Greenough",
    "state_name":"Western Australia"
  },
  {
    "postcode":6528,
    "place_name":"Walkaway",
    "state_name":"Western Australia"
  },
  {
    "postcode":6528,
    "place_name":"Mount Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Tarcoola Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Strathalbyn",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Woorree",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Wandina",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Rangeway",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Waggrakine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Karloo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Beresford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Utakarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Sunset Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Webberton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"West End",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Beachlands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Spalding",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Houtman Abrolhos",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Bluff Point",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Meru",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Moresby",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Wonthella",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Mahomets Flats",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Mount Tarcoola",
    "state_name":"Western Australia"
  },
  {
    "postcode":6530,
    "place_name":"Geraldton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6531,
    "place_name":"Geraldton Po",
    "state_name":"Western Australia"
  },
  {
    "postcode":6531,
    "place_name":"Geraldton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Meadow",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Ajana",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Wandana",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Drummond Cove",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Eradu South",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Rudds Gully",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Yuna",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Yetna",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Coburn",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Moonyoonooka",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Deepdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Tamala",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Sandsprings",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Glenfield",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Northern Gully",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Nabawa",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Rockwell",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Narngulu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Nerren Nerren",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Kojarena",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Durawah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Oakajee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Nolba",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Georgina",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Narra Tarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Bootenal",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Toolonga",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Dindiloa",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Binnu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Naraling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Howatharra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Cape Burney",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Coolcalalaya",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Greenough",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Bringo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Wicherina",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Mount Erin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Nanson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Wicherina South",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"West Binnu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"South Yuna",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"North Eradu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Carrarang",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Valentine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Dartmoor",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Ellendale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"East Chapman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"White Peak",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Eradu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Hickety",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Minnenooka",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Hamelin Pool",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Marrah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Eurardy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Burma Road",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Tibradden",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"East Yuna",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"Buller",
    "state_name":"Western Australia"
  },
  {
    "postcode":6532,
    "place_name":"East Nabawa",
    "state_name":"Western Australia"
  },
  {
    "postcode":6535,
    "place_name":"Ogilvie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6535,
    "place_name":"Horrocks",
    "state_name":"Western Australia"
  },
  {
    "postcode":6535,
    "place_name":"Isseka",
    "state_name":"Western Australia"
  },
  {
    "postcode":6535,
    "place_name":"Yallabatharra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6535,
    "place_name":"Gregory",
    "state_name":"Western Australia"
  },
  {
    "postcode":6535,
    "place_name":"Bowes",
    "state_name":"Western Australia"
  },
  {
    "postcode":6535,
    "place_name":"Northampton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6535,
    "place_name":"Alma",
    "state_name":"Western Australia"
  },
  {
    "postcode":6535,
    "place_name":"East Bowes",
    "state_name":"Western Australia"
  },
  {
    "postcode":6535,
    "place_name":"Sandy Gully",
    "state_name":"Western Australia"
  },
  {
    "postcode":6536,
    "place_name":"Zuytdorp",
    "state_name":"Western Australia"
  },
  {
    "postcode":6536,
    "place_name":"Kalbarri",
    "state_name":"Western Australia"
  },
  {
    "postcode":6536,
    "place_name":"Kalbarri National Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6537,
    "place_name":"Denham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6537,
    "place_name":"Monkey Mia",
    "state_name":"Western Australia"
  },
  {
    "postcode":6537,
    "place_name":"Francois Peron National Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6537,
    "place_name":"Dirk Hartog Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6537,
    "place_name":"Nanga",
    "state_name":"Western Australia"
  },
  {
    "postcode":6537,
    "place_name":"Shark Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6537,
    "place_name":"Useless Loop",
    "state_name":"Western Australia"
  },
  {
    "postcode":6556,
    "place_name":"Beechina",
    "state_name":"Western Australia"
  },
  {
    "postcode":6556,
    "place_name":"The Lakes",
    "state_name":"Western Australia"
  },
  {
    "postcode":6556,
    "place_name":"Chidlow",
    "state_name":"Western Australia"
  },
  {
    "postcode":6556,
    "place_name":"Malmalling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6556,
    "place_name":"Gorrie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6558,
    "place_name":"Wooroloo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6560,
    "place_name":"Wundowie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6562,
    "place_name":"Copley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6562,
    "place_name":"Bakers Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6562,
    "place_name":"Woottating",
    "state_name":"Western Australia"
  },
  {
    "postcode":6564,
    "place_name":"Clackline",
    "state_name":"Western Australia"
  },
  {
    "postcode":6566,
    "place_name":"Carani",
    "state_name":"Western Australia"
  },
  {
    "postcode":6566,
    "place_name":"Culham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6566,
    "place_name":"West Toodyay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6566,
    "place_name":"Coondle",
    "state_name":"Western Australia"
  },
  {
    "postcode":6566,
    "place_name":"Nunile",
    "state_name":"Western Australia"
  },
  {
    "postcode":6566,
    "place_name":"Toodyay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6566,
    "place_name":"Katrine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6566,
    "place_name":"Bejoording",
    "state_name":"Western Australia"
  },
  {
    "postcode":6566,
    "place_name":"Hoddys Well",
    "state_name":"Western Australia"
  },
  {
    "postcode":6566,
    "place_name":"Dumbarton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6567,
    "place_name":"Julimar",
    "state_name":"Western Australia"
  },
  {
    "postcode":6567,
    "place_name":"Dewars Pool",
    "state_name":"Western Australia"
  },
  {
    "postcode":6567,
    "place_name":"Moondyne",
    "state_name":"Western Australia"
  },
  {
    "postcode":6568,
    "place_name":"Wattening",
    "state_name":"Western Australia"
  },
  {
    "postcode":6568,
    "place_name":"Wyening",
    "state_name":"Western Australia"
  },
  {
    "postcode":6568,
    "place_name":"Bolgart",
    "state_name":"Western Australia"
  },
  {
    "postcode":6569,
    "place_name":"Old Plains",
    "state_name":"Western Australia"
  },
  {
    "postcode":6569,
    "place_name":"Calingiri",
    "state_name":"Western Australia"
  },
  {
    "postcode":6571,
    "place_name":"Yerecoin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6572,
    "place_name":"Piawaning",
    "state_name":"Western Australia"
  },
  {
    "postcode":6574,
    "place_name":"Gabalong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6574,
    "place_name":"Bindi Bindi",
    "state_name":"Western Australia"
  },
  {
    "postcode":6575,
    "place_name":"Miling",
    "state_name":"Western Australia"
  },
  {
    "postcode":6603,
    "place_name":"Konnongorring",
    "state_name":"Western Australia"
  },
  {
    "postcode":6603,
    "place_name":"Lake Hinds",
    "state_name":"Western Australia"
  },
  {
    "postcode":6603,
    "place_name":"Wongan Hills",
    "state_name":"Western Australia"
  },
  {
    "postcode":6603,
    "place_name":"Lake Ninan",
    "state_name":"Western Australia"
  },
  {
    "postcode":6603,
    "place_name":"Mocardy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6605,
    "place_name":"Kondut",
    "state_name":"Western Australia"
  },
  {
    "postcode":6606,
    "place_name":"West Ballidu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6606,
    "place_name":"East Ballidu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6606,
    "place_name":"Ballidu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6608,
    "place_name":"Pithara",
    "state_name":"Western Australia"
  },
  {
    "postcode":6608,
    "place_name":"Marne",
    "state_name":"Western Australia"
  },
  {
    "postcode":6608,
    "place_name":"East Damboring",
    "state_name":"Western Australia"
  },
  {
    "postcode":6609,
    "place_name":"Dalwallinu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6609,
    "place_name":"Xantippe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6609,
    "place_name":"Nugadong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6612,
    "place_name":"Wubin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6612,
    "place_name":"Miamoon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6612,
    "place_name":"Paynes Find",
    "state_name":"Western Australia"
  },
  {
    "postcode":6612,
    "place_name":"Jibberding",
    "state_name":"Western Australia"
  },
  {
    "postcode":6613,
    "place_name":"Buntine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6614,
    "place_name":"Maya",
    "state_name":"Western Australia"
  },
  {
    "postcode":6616,
    "place_name":"Latham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6620,
    "place_name":"Rothsay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6620,
    "place_name":"Perenjori",
    "state_name":"Western Australia"
  },
  {
    "postcode":6623,
    "place_name":"Pintharuka",
    "state_name":"Western Australia"
  },
  {
    "postcode":6623,
    "place_name":"Koolanooka",
    "state_name":"Western Australia"
  },
  {
    "postcode":6623,
    "place_name":"Morawa",
    "state_name":"Western Australia"
  },
  {
    "postcode":6623,
    "place_name":"Bunjil",
    "state_name":"Western Australia"
  },
  {
    "postcode":6623,
    "place_name":"Bowgada",
    "state_name":"Western Australia"
  },
  {
    "postcode":6623,
    "place_name":"Gutha",
    "state_name":"Western Australia"
  },
  {
    "postcode":6625,
    "place_name":"Merkanooka",
    "state_name":"Western Australia"
  },
  {
    "postcode":6627,
    "place_name":"Canna",
    "state_name":"Western Australia"
  },
  {
    "postcode":6628,
    "place_name":"Tardun",
    "state_name":"Western Australia"
  },
  {
    "postcode":6630,
    "place_name":"Nerramyne",
    "state_name":"Western Australia"
  },
  {
    "postcode":6630,
    "place_name":"Murchison",
    "state_name":"Western Australia"
  },
  {
    "postcode":6630,
    "place_name":"Woolgorong",
    "state_name":"Western Australia"
  },
  {
    "postcode":6630,
    "place_name":"Mullewa",
    "state_name":"Western Australia"
  },
  {
    "postcode":6630,
    "place_name":"Nunierra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6630,
    "place_name":"Wongoondy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6630,
    "place_name":"Devils Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6630,
    "place_name":"West Casuarinas",
    "state_name":"Western Australia"
  },
  {
    "postcode":6631,
    "place_name":"Pindar",
    "state_name":"Western Australia"
  },
  {
    "postcode":6632,
    "place_name":"Tenindewa",
    "state_name":"Western Australia"
  },
  {
    "postcode":6632,
    "place_name":"Ambania",
    "state_name":"Western Australia"
  },
  {
    "postcode":6635,
    "place_name":"Yalgoo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6635,
    "place_name":"South Murchison",
    "state_name":"Western Australia"
  },
  {
    "postcode":6638,
    "place_name":"Mount Magnet",
    "state_name":"Western Australia"
  },
  {
    "postcode":6638,
    "place_name":"Paynesville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6638,
    "place_name":"Daggar Hills",
    "state_name":"Western Australia"
  },
  {
    "postcode":6638,
    "place_name":"Cooladar Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6639,
    "place_name":"Sandstone",
    "state_name":"Western Australia"
  },
  {
    "postcode":6640,
    "place_name":"Cue",
    "state_name":"Western Australia"
  },
  {
    "postcode":6640,
    "place_name":"East Murchison",
    "state_name":"Western Australia"
  },
  {
    "postcode":6640,
    "place_name":"Weld Range",
    "state_name":"Western Australia"
  },
  {
    "postcode":6640,
    "place_name":"Reedy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6640,
    "place_name":"Lake Austin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6642,
    "place_name":"Peak Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6642,
    "place_name":"Capricorn",
    "state_name":"Western Australia"
  },
  {
    "postcode":6642,
    "place_name":"Meekatharra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6642,
    "place_name":"Angelo River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6642,
    "place_name":"Karalundi",
    "state_name":"Western Australia"
  },
  {
    "postcode":6642,
    "place_name":"Kumarina",
    "state_name":"Western Australia"
  },
  {
    "postcode":6646,
    "place_name":"Wiluna",
    "state_name":"Western Australia"
  },
  {
    "postcode":6646,
    "place_name":"Lake Carnegie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6646,
    "place_name":"Little Sandy Desert",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Lyndon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Kingsford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Gilroyd",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Talisker",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Wooramel",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Coral Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Yandoo Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Woodleigh",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"South Plantations",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Morgantown",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Brown Range",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Bernier Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"South Carnarvon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"East Carnarvon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Carbla",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Inggarda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"North Plantations",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Kennedy Range",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Ningaloo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Babbage Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Brockman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Yalardy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Massey Bay",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Mauds Landing",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Macleod",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Carnarvon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Greys Plain",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Dorre Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6701,
    "place_name":"Minilya",
    "state_name":"Western Australia"
  },
  {
    "postcode":6705,
    "place_name":"Gascoyne Junction",
    "state_name":"Western Australia"
  },
  {
    "postcode":6705,
    "place_name":"East Lyons River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6705,
    "place_name":"West Lyons River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6705,
    "place_name":"Gascoyne River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6707,
    "place_name":"Exmouth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6707,
    "place_name":"Learmonth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6707,
    "place_name":"Cape Range National Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6707,
    "place_name":"North West Cape",
    "state_name":"Western Australia"
  },
  {
    "postcode":6707,
    "place_name":"Exmouth Gulf",
    "state_name":"Western Australia"
  },
  {
    "postcode":6710,
    "place_name":"Onslow",
    "state_name":"Western Australia"
  },
  {
    "postcode":6710,
    "place_name":"Talandji",
    "state_name":"Western Australia"
  },
  {
    "postcode":6710,
    "place_name":"Peedamulla",
    "state_name":"Western Australia"
  },
  {
    "postcode":6710,
    "place_name":"Yannarie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6710,
    "place_name":"Cane",
    "state_name":"Western Australia"
  },
  {
    "postcode":6711,
    "place_name":"Thevenard Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6712,
    "place_name":"Barrow Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6713,
    "place_name":"Dampier",
    "state_name":"Western Australia"
  },
  {
    "postcode":6713,
    "place_name":"Dampier Archipelago",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Mulataga",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Karratha",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Baynton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Karratha Industrial Estate",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Millars Well",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Pegs Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Balla Balla",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Bulgarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Antonymyre",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Cleaverville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Stove Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Nickol",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Mount Anketell",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Sherlock",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Burrup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Cooya Pooya",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Gap Ridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Mardie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Maitland",
    "state_name":"Western Australia"
  },
  {
    "postcode":6714,
    "place_name":"Gnoorea",
    "state_name":"Western Australia"
  },
  {
    "postcode":6716,
    "place_name":"Pannawonica",
    "state_name":"Western Australia"
  },
  {
    "postcode":6716,
    "place_name":"Millstream",
    "state_name":"Western Australia"
  },
  {
    "postcode":6716,
    "place_name":"Hamersley Range",
    "state_name":"Western Australia"
  },
  {
    "postcode":6716,
    "place_name":"Fortescue",
    "state_name":"Western Australia"
  },
  {
    "postcode":6718,
    "place_name":"Roebourne",
    "state_name":"Western Australia"
  },
  {
    "postcode":6718,
    "place_name":"Whim Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6720,
    "place_name":"Wickham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6720,
    "place_name":"Cossack",
    "state_name":"Western Australia"
  },
  {
    "postcode":6720,
    "place_name":"Point Samson",
    "state_name":"Western Australia"
  },
  {
    "postcode":6721,
    "place_name":"Mundabullangana",
    "state_name":"Western Australia"
  },
  {
    "postcode":6721,
    "place_name":"Wedgefield",
    "state_name":"Western Australia"
  },
  {
    "postcode":6721,
    "place_name":"Port Hedland",
    "state_name":"Western Australia"
  },
  {
    "postcode":6721,
    "place_name":"Strelley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6721,
    "place_name":"Indee",
    "state_name":"Western Australia"
  },
  {
    "postcode":6721,
    "place_name":"Redbank",
    "state_name":"Western Australia"
  },
  {
    "postcode":6721,
    "place_name":"Pardoo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6721,
    "place_name":"Wallareenya",
    "state_name":"Western Australia"
  },
  {
    "postcode":6722,
    "place_name":"Boodarie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6722,
    "place_name":"Finucane",
    "state_name":"Western Australia"
  },
  {
    "postcode":6722,
    "place_name":"De Grey",
    "state_name":"Western Australia"
  },
  {
    "postcode":6722,
    "place_name":"Pippingarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6722,
    "place_name":"South Hedland",
    "state_name":"Western Australia"
  },
  {
    "postcode":6723,
    "place_name":"Goldsworthy",
    "state_name":"Western Australia"
  },
  {
    "postcode":6725,
    "place_name":"Roebuck",
    "state_name":"Western Australia"
  },
  {
    "postcode":6725,
    "place_name":"Minyirr",
    "state_name":"Western Australia"
  },
  {
    "postcode":6725,
    "place_name":"Dampier Peninsula",
    "state_name":"Western Australia"
  },
  {
    "postcode":6725,
    "place_name":"Lagrange",
    "state_name":"Western Australia"
  },
  {
    "postcode":6725,
    "place_name":"Broome",
    "state_name":"Western Australia"
  },
  {
    "postcode":6725,
    "place_name":"Gingerah",
    "state_name":"Western Australia"
  },
  {
    "postcode":6725,
    "place_name":"Bilingurr",
    "state_name":"Western Australia"
  },
  {
    "postcode":6725,
    "place_name":"Waterbank",
    "state_name":"Western Australia"
  },
  {
    "postcode":6725,
    "place_name":"Djugun",
    "state_name":"Western Australia"
  },
  {
    "postcode":6725,
    "place_name":"Eighty Mile Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6726,
    "place_name":"Cable Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6728,
    "place_name":"Camballin",
    "state_name":"Western Australia"
  },
  {
    "postcode":6728,
    "place_name":"Kimbolton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6728,
    "place_name":"King Leopold Ranges",
    "state_name":"Western Australia"
  },
  {
    "postcode":6728,
    "place_name":"Geegully Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6728,
    "place_name":"Derby",
    "state_name":"Western Australia"
  },
  {
    "postcode":6728,
    "place_name":"Willare",
    "state_name":"Western Australia"
  },
  {
    "postcode":6728,
    "place_name":"Meda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6728,
    "place_name":"St George Ranges",
    "state_name":"Western Australia"
  },
  {
    "postcode":6731,
    "place_name":"Cockatoo Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6733,
    "place_name":"Koolan Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6740,
    "place_name":"Prince Regent River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6740,
    "place_name":"Kalumburu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6740,
    "place_name":"Mitchell Plateau",
    "state_name":"Western Australia"
  },
  {
    "postcode":6740,
    "place_name":"Oombulgurri",
    "state_name":"Western Australia"
  },
  {
    "postcode":6740,
    "place_name":"Wyndham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6740,
    "place_name":"Drysdale River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6743,
    "place_name":"Lake Argyle",
    "state_name":"Western Australia"
  },
  {
    "postcode":6743,
    "place_name":"Kununurra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6743,
    "place_name":"Gibb",
    "state_name":"Western Australia"
  },
  {
    "postcode":6743,
    "place_name":"Warmun",
    "state_name":"Western Australia"
  },
  {
    "postcode":6743,
    "place_name":"Cambridge Gulf",
    "state_name":"Western Australia"
  },
  {
    "postcode":6743,
    "place_name":"Durack",
    "state_name":"Western Australia"
  },
  {
    "postcode":6751,
    "place_name":"Rocklea",
    "state_name":"Western Australia"
  },
  {
    "postcode":6751,
    "place_name":"Tom Price",
    "state_name":"Western Australia"
  },
  {
    "postcode":6751,
    "place_name":"Chichester",
    "state_name":"Western Australia"
  },
  {
    "postcode":6751,
    "place_name":"Wittenoom",
    "state_name":"Western Australia"
  },
  {
    "postcode":6751,
    "place_name":"Mulga Downs",
    "state_name":"Western Australia"
  },
  {
    "postcode":6751,
    "place_name":"Nanutarra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6751,
    "place_name":"Innawanga",
    "state_name":"Western Australia"
  },
  {
    "postcode":6751,
    "place_name":"Mount Sheila",
    "state_name":"Western Australia"
  },
  {
    "postcode":6751,
    "place_name":"Karijini",
    "state_name":"Western Australia"
  },
  {
    "postcode":6751,
    "place_name":"Juna Downs",
    "state_name":"Western Australia"
  },
  {
    "postcode":6753,
    "place_name":"Newman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6754,
    "place_name":"Paraburdoo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6758,
    "place_name":"Nullagine",
    "state_name":"Western Australia"
  },
  {
    "postcode":6760,
    "place_name":"Marble Bar",
    "state_name":"Western Australia"
  },
  {
    "postcode":6761,
    "place_name":"Shay Gap",
    "state_name":"Western Australia"
  },
  {
    "postcode":6762,
    "place_name":"Telfer",
    "state_name":"Western Australia"
  },
  {
    "postcode":6765,
    "place_name":"Mount Hardman",
    "state_name":"Western Australia"
  },
  {
    "postcode":6765,
    "place_name":"Fitzroy Crossing",
    "state_name":"Western Australia"
  },
  {
    "postcode":6770,
    "place_name":"Sturt Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6770,
    "place_name":"Mueller Ranges",
    "state_name":"Western Australia"
  },
  {
    "postcode":6770,
    "place_name":"Mcbeath",
    "state_name":"Western Australia"
  },
  {
    "postcode":6770,
    "place_name":"Purnululu",
    "state_name":"Western Australia"
  },
  {
    "postcode":6770,
    "place_name":"Tanami",
    "state_name":"Western Australia"
  },
  {
    "postcode":6770,
    "place_name":"Halls Creek",
    "state_name":"Western Australia"
  },
  {
    "postcode":6770,
    "place_name":"Ord River",
    "state_name":"Western Australia"
  },
  {
    "postcode":6798,
    "place_name":"Christmas Island",
    "state_name":"Western Australia"
  },
  {
    "postcode":6799,
    "place_name":"Home Island Cocos (Keeling) Islands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6799,
    "place_name":"West Island Cocos (Keeling) Islands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6800,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6803,
    "place_name":"Northbridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6809,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6817,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6820,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6827,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6830,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6831,
    "place_name":"Perth St Georges Tce",
    "state_name":"Western Australia"
  },
  {
    "postcode":6832,
    "place_name":"Perth Adelaide Tce",
    "state_name":"Western Australia"
  },
  {
    "postcode":6832,
    "place_name":"Perth East St Georges Tce",
    "state_name":"Western Australia"
  },
  {
    "postcode":6837,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6838,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6839,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6840,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6841,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6842,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6843,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6844,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6845,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6846,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6847,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6848,
    "place_name":"Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6849,
    "place_name":"Perth Bc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6850,
    "place_name":"Cloisters Square Po",
    "state_name":"Western Australia"
  },
  {
    "postcode":6850,
    "place_name":"Cloisters Square",
    "state_name":"Western Australia"
  },
  {
    "postcode":6865,
    "place_name":"Northbridge",
    "state_name":"Western Australia"
  },
  {
    "postcode":6872,
    "place_name":"West Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6892,
    "place_name":"East Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6900,
    "place_name":"Leederville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6901,
    "place_name":"West Leederville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6902,
    "place_name":"Leederville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6903,
    "place_name":"Leederville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6904,
    "place_name":"Subiaco",
    "state_name":"Western Australia"
  },
  {
    "postcode":6904,
    "place_name":"Subiaco Po",
    "state_name":"Western Australia"
  },
  {
    "postcode":6905,
    "place_name":"Northlands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6905,
    "place_name":"Northlands Po",
    "state_name":"Western Australia"
  },
  {
    "postcode":6906,
    "place_name":"North Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6907,
    "place_name":"Nedlands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6909,
    "place_name":"Nedlands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6910,
    "place_name":"Claremont",
    "state_name":"Western Australia"
  },
  {
    "postcode":6911,
    "place_name":"Cottesloe",
    "state_name":"Western Australia"
  },
  {
    "postcode":6912,
    "place_name":"Mosman Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6913,
    "place_name":"Wembley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6914,
    "place_name":"Balcatta",
    "state_name":"Western Australia"
  },
  {
    "postcode":6915,
    "place_name":"Mount Hawthorn",
    "state_name":"Western Australia"
  },
  {
    "postcode":6916,
    "place_name":"Osborne Park Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6916,
    "place_name":"Osborne Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6917,
    "place_name":"Osborne Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6918,
    "place_name":"Innaloo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6919,
    "place_name":"Joondalup Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6920,
    "place_name":"North Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6921,
    "place_name":"Karrinyup",
    "state_name":"Western Australia"
  },
  {
    "postcode":6922,
    "place_name":"Scarborough",
    "state_name":"Western Australia"
  },
  {
    "postcode":6923,
    "place_name":"Hillarys",
    "state_name":"Western Australia"
  },
  {
    "postcode":6924,
    "place_name":"Greenwood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6925,
    "place_name":"Walliston Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6926,
    "place_name":"Kalamunda",
    "state_name":"Western Australia"
  },
  {
    "postcode":6929,
    "place_name":"Mount Lawley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6931,
    "place_name":"Maylands",
    "state_name":"Western Australia"
  },
  {
    "postcode":6932,
    "place_name":"Inglewood",
    "state_name":"Western Australia"
  },
  {
    "postcode":6933,
    "place_name":"Bayswater",
    "state_name":"Western Australia"
  },
  {
    "postcode":6934,
    "place_name":"Bassendean",
    "state_name":"Western Australia"
  },
  {
    "postcode":6935,
    "place_name":"Guildford",
    "state_name":"Western Australia"
  },
  {
    "postcode":6936,
    "place_name":"Midland Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6937,
    "place_name":"Tuart Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6938,
    "place_name":"Tuart Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6939,
    "place_name":"Tuart Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6940,
    "place_name":"Tuart Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6941,
    "place_name":"Mirrabooka",
    "state_name":"Western Australia"
  },
  {
    "postcode":6942,
    "place_name":"Bassendean Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6943,
    "place_name":"Morley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6944,
    "place_name":"Malaga",
    "state_name":"Western Australia"
  },
  {
    "postcode":6945,
    "place_name":"Malaga Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6946,
    "place_name":"Wanneroo",
    "state_name":"Western Australia"
  },
  {
    "postcode":6947,
    "place_name":"Wangara Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6951,
    "place_name":"South Perth",
    "state_name":"Western Australia"
  },
  {
    "postcode":6952,
    "place_name":"Como",
    "state_name":"Western Australia"
  },
  {
    "postcode":6953,
    "place_name":"Applecross",
    "state_name":"Western Australia"
  },
  {
    "postcode":6954,
    "place_name":"Booragoon",
    "state_name":"Western Australia"
  },
  {
    "postcode":6955,
    "place_name":"Willetton",
    "state_name":"Western Australia"
  },
  {
    "postcode":6956,
    "place_name":"Melville",
    "state_name":"Western Australia"
  },
  {
    "postcode":6957,
    "place_name":"Palmyra",
    "state_name":"Western Australia"
  },
  {
    "postcode":6958,
    "place_name":"Royal Australian Navy Warships",
    "state_name":"Western Australia"
  },
  {
    "postcode":6959,
    "place_name":"Fremantle",
    "state_name":"Western Australia"
  },
  {
    "postcode":6960,
    "place_name":"Myaree Bc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6961,
    "place_name":"Palmyra Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6963,
    "place_name":"Hamilton Hill",
    "state_name":"Western Australia"
  },
  {
    "postcode":6964,
    "place_name":"Success",
    "state_name":"Western Australia"
  },
  {
    "postcode":6965,
    "place_name":"Bibra Lake Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6966,
    "place_name":"Kwinana",
    "state_name":"Western Australia"
  },
  {
    "postcode":6967,
    "place_name":"Rockingham Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6968,
    "place_name":"Rockingham",
    "state_name":"Western Australia"
  },
  {
    "postcode":6969,
    "place_name":"Rockingham Beach",
    "state_name":"Western Australia"
  },
  {
    "postcode":6970,
    "place_name":"Canning Vale Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6979,
    "place_name":"Victoria Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6980,
    "place_name":"Cannington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6981,
    "place_name":"East Victoria Park",
    "state_name":"Western Australia"
  },
  {
    "postcode":6982,
    "place_name":"Bentley",
    "state_name":"Western Australia"
  },
  {
    "postcode":6983,
    "place_name":"Bentley Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6984,
    "place_name":"Belmont",
    "state_name":"Western Australia"
  },
  {
    "postcode":6985,
    "place_name":"Cloverdale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6986,
    "place_name":"Welshpool Dc",
    "state_name":"Western Australia"
  },
  {
    "postcode":6987,
    "place_name":"Cannington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6988,
    "place_name":"Thornlie",
    "state_name":"Western Australia"
  },
  {
    "postcode":6989,
    "place_name":"Maddington",
    "state_name":"Western Australia"
  },
  {
    "postcode":6990,
    "place_name":"Gosnells",
    "state_name":"Western Australia"
  },
  {
    "postcode":6991,
    "place_name":"Kelmscott",
    "state_name":"Western Australia"
  },
  {
    "postcode":6992,
    "place_name":"Armadale",
    "state_name":"Western Australia"
  },
  {
    "postcode":6997,
    "place_name":"Kelmscott Dc",
    "state_name":"Western Australia"
  }
]